const Long = require('long');

const $root = {};

(
$root.__options = {
  'stringEnums': true
});
$root.__lookup = function(pbjs) {
  const root = pbjs.Root.fromJSON({
    'nested': {
      'wix': {
        'nested': {
          'comments': {
            'options': {
              'java_package': 'com.wix.catalyst.feed'
            },
            'nested': {
              'CommentCreated': {
                'oneofs': {
                  'parent': {
                    'oneof': [
                      'entityId',
                      'commentId'
                    ]
                  }
                },
                'fields': {
                  'containerId': {
                    'type': 'string',
                    'id': 5
                  },
                  'entityId': {
                    'type': 'string',
                    'id': 1
                  },
                  'commentId': {
                    'type': 'string',
                    'id': 2
                  },
                  'comment': {
                    'type': 'CommentEntity',
                    'id': 3
                  },
                  'createdAt': {
                    'type': 'google.protobuf.Timestamp',
                    'id': 4
                  }
                }
              },
              'CommentUpdated': {
                'fields': {
                  'comment': {
                    'type': 'CommentEntity',
                    'id': 1
                  }
                }
              },
              'CommentDeleted': {
                'fields': {}
              },
              'CommentReported': {
                'fields': {
                  'reportType': {
                    'type': 'ReportType',
                    'id': 1
                  }
                }
              },
              'Comment': {
                'fields': {
                  'commentId': {
                    'type': 'string',
                    'id': 1,
                    'options': {
                      '(wix.api.format)': 'GUID'
                    }
                  },
                  'entityId': {
                    'type': 'string',
                    'id': 2,
                    'options': {
                      '(wix.api.format)': 'GUID'
                    }
                  },
                  'comment': {
                    'type': 'CommentEntity',
                    'id': 3
                  },
                  'reactions': {
                    'type': 'Reactions',
                    'id': 4
                  },
                  'replies': {
                    'type': 'Replies',
                    'id': 5
                  },
                  'createdAt': {
                    'type': 'google.protobuf.Timestamp',
                    'id': 6
                  },
                  'updatedAt': {
                    'type': 'google.protobuf.Timestamp',
                    'id': 7
                  },
                  'availableActions': {
                    'rule': 'repeated',
                    'type': 'UserAction',
                    'id': 8
                  },
                  'createdBy': {
                    'type': 'wix.social.SocialIdentity',
                    'id': 9
                  },
                  'reported': {
                    'type': 'Reported',
                    'id': 10
                  },
                  'replyTo': {
                    'type': 'ReplyTo',
                    'id': 11
                  }
                }
              },
              'CommentEntity': {
                'fields': {
                  'text': {
                    'type': 'wix.social.Text',
                    'id': 1
                  },
                  'mentions': {
                    'rule': 'repeated',
                    'type': 'wix.social.Mention',
                    'id': 2
                  },
                  'attachments': {
                    'rule': 'repeated',
                    'type': 'wix.social.Resource',
                    'id': 3
                  }
                }
              },
              'Reactions': {
                'fields': {
                  'count': {
                    'type': 'int32',
                    'id': 1
                  }
                }
              },
              'Replies': {
                'fields': {
                  'count': {
                    'type': 'int32',
                    'id': 1
                  },
                  'comments': {
                    'rule': 'repeated',
                    'type': 'Comment',
                    'id': 2
                  },
                  'pageCursor': {
                    'type': 'string',
                    'id': 3
                  },
                  'nextCursor': {
                    'type': 'google.protobuf.StringValue',
                    'id': 4
                  }
                }
              },
              'Reported': {
                'fields': {
                  'count': {
                    'type': 'google.protobuf.Int32Value',
                    'id': 1
                  },
                  'reportedTypes': {
                    'rule': 'repeated',
                    'type': 'ReportType',
                    'id': 2
                  }
                }
              },
              'CommentsAccess': {
                'fields': {
                  'allowedGlobalActions': {
                    'rule': 'repeated',
                    'type': 'UserAction',
                    'id': 1
                  },
                  'allowedCommentActions': {
                    'rule': 'repeated',
                    'type': 'UserAction',
                    'id': 2
                  }
                }
              },
              'ReplyTo': {
                'fields': {
                  'commentId': {
                    'type': 'string',
                    'id': 1,
                    'options': {
                      '(wix.api.format)': 'GUID'
                    }
                  },
                  'userId': {
                    'type': 'string',
                    'id': 2,
                    'options': {
                      '(wix.api.format)': 'GUID'
                    }
                  }
                }
              },
              'PageDirection': {
                'values': {
                  'FORWARD': 0,
                  'BACKWARD': 1
                }
              },
              'Ordering': {
                'values': {
                  'OLDEST_FIRST': 0,
                  'LATEST_FIRST': 1
                }
              },
              'UserAction': {
                'values': {
                  'VIEW': 0,
                  'ADD_COMMENT': 1,
                  'REACT': 2,
                  'UNREACT': 3,
                  'REPORT': 4,
                  'EDIT': 5,
                  'DELETE': 6
                }
              },
              'ReportType': {
                'values': {
                  'UNWANTED_CONTENT': 0,
                  'HARASSMENT': 1,
                  'INAPPROPRIATE_CONTENT': 2,
                  'HATE_SPEECH_OR_GRAPHIC': 3,
                  'OTHER': 4,
                  'UnwantedContent': 5,
                  'Harrasment': 6,
                  'InappropiateContent': 7,
                  'HateSpeechOrGraphic': 8
                }
              },
              'callbacks': {
                'options': {
                  'java_package': 'com.wix.catalyst.comments.callbacks'
                },
                'nested': {
                  'CommentCreated': {
                    'fields': {
                      'commentId': {
                        'type': 'string',
                        'id': 1,
                        'options': {
                          '(wix.api.format)': 'GUID'
                        }
                      }
                    }
                  },
                  'CommentUpdated': {
                    'fields': {
                      'commentId': {
                        'type': 'string',
                        'id': 1,
                        'options': {
                          '(wix.api.format)': 'GUID'
                        }
                      }
                    }
                  },
                  'CommentDeleted': {
                    'fields': {
                      'commentId': {
                        'type': 'string',
                        'id': 1,
                        'options': {
                          '(wix.api.format)': 'GUID'
                        }
                      }
                    }
                  },
                  'ReactedOnComment': {
                    'fields': {
                      'commentId': {
                        'type': 'string',
                        'id': 1,
                        'options': {
                          '(wix.api.format)': 'GUID'
                        }
                      }
                    }
                  },
                  'RemovedReactionOnComment': {
                    'fields': {
                      'commentId': {
                        'type': 'string',
                        'id': 1,
                        'options': {
                          '(wix.api.format)': 'GUID'
                        }
                      }
                    }
                  },
                  'CommentReported': {
                    'fields': {
                      'commentId': {
                        'type': 'string',
                        'id': 1,
                        'options': {
                          '(wix.api.format)': 'GUID'
                        }
                      }
                    }
                  }
                }
              },
              'CommentsPageCursor': {
                'fields': {
                  'fromEventId': {
                    'type': 'int64',
                    'id': 1
                  },
                  'remainingCount': {
                    'type': 'int32',
                    'id': 2
                  },
                  'entityId': {
                    'type': 'bytes',
                    'id': 3
                  },
                  'flattenToDepth': {
                    'type': 'google.protobuf.UInt32Value',
                    'id': 4
                  },
                  'backwards': {
                    'type': 'bool',
                    'id': 5
                  },
                  'ordering': {
                    'type': 'Ordering',
                    'id': 6
                  }
                }
              },
              'component': {
                'options': {
                  'java_package': 'com.wix.comments.component'
                },
                'nested': {
                  'CommentsHostedSpi': {
                    'methods': {
                      'Authorize': {
                        'requestType': 'AuthorizeRequest',
                        'responseType': 'AuthorizeResponse',
                        'options': {
                          '(wix.api.maturity)': 'ALPHA'
                        },
                        'rawOptions': [{
                          'name': '(wix.api.maturity)',
                          'value': 'ALPHA'
                        }]
                      }
                    }
                  },
                  'AuthorizeRequest': {
                    'fields': {}
                  },
                  'AuthorizeResponse': {
                    'fields': {}
                  },
                  'CommentsComponentService': {
                    'methods': {
                      'CreateComponentContext': {
                        'requestType': 'CreateComponentContextRequest',
                        'responseType': 'CreateComponentContextResponse',
                        'options': {
                          '(wix.api.maturity)': 'ALPHA',
                          '(google.api.http).get': '/api/v1/comments-component/{containerId}'
                        },
                        'rawOptions': [
                          {
                            'name': '(wix.api.maturity)',
                            'value': 'ALPHA'
                          },
                          {
                            'name': '(google.api.http).get',
                            'value': '/api/v1/comments-component/{containerId}'
                          }
                        ]
                      },
                      'CreateComponentContexts': {
                        'requestType': 'CreateComponentContextRequests',
                        'responseType': 'CreateComponentContextResponses',
                        'options': {
                          '(wix.api.maturity)': 'ALPHA'
                        },
                        'rawOptions': [{
                          'name': '(wix.api.maturity)',
                          'value': 'ALPHA'
                        }]
                      }
                    }
                  },
                  'CreateComponentContextRequests': {
                    'fields': {
                      'requests': {
                        'keyType': 'string',
                        'type': 'CreateComponentContextRequest',
                        'id': 1
                      }
                    }
                  },
                  'CreateComponentContextRequest': {
                    'fields': {
                      'containerId': {
                        'type': 'google.protobuf.StringValue',
                        'id': 1,
                        'options': {
                          '(wix.api.format)': 'GUID'
                        }
                      },
                      'containerType': {
                        'type': 'google.protobuf.StringValue',
                        'id': 2
                      },
                      'permission': {
                        'type': 'Permission',
                        'id': 3
                      },
                      'features': {
                        'rule': 'repeated',
                        'type': 'Feature',
                        'id': 4
                      },
                      'identity': {
                        'type': 'social.SocialIdentity',
                        'id': 5
                      }
                    }
                  },
                  'CreateComponentContextResponse': {
                    'fields': {
                      'componentContext': {
                        'type': 'string',
                        'id': 1
                      }
                    }
                  },
                  'CreateComponentContextResponses': {
                    'fields': {
                      'componentContexts': {
                        'keyType': 'string',
                        'type': 'string',
                        'id': 1
                      }
                    }
                  },
                  'ComponentContextEntry': {
                    'fields': {
                      'requestId': {
                        'type': 'string',
                        'id': 1
                      },
                      'componentContext': {
                        'type': 'string',
                        'id': 2
                      }
                    }
                  },
                  'Permission': {
                    'values': {
                      'VIEWER': 0,
                      'WRITER': 1,
                      'ADMIN': 2
                    }
                  },
                  'Feature': {
                    'values': {
                      'ALL': 0,
                      'REPLIES': 1,
                      'REACTIONS': 2
                    }
                  }
                }
              },
              'CommentsService': {
                'methods': {
                  'Get': {
                    'requestType': 'GetCommentRequest',
                    'responseType': 'GetCommentResponse',
                    'options': {
                      '(wix.api.maturity)': 'ALPHA',
                      '(google.api.http).get': '/api/v1/comments/{commentId}',
                      '(wix.api.required)': 'GetCommentRequest.context_token'
                    },
                    'rawOptions': [
                      {
                        'name': '(wix.api.maturity)',
                        'value': 'ALPHA'
                      },
                      {
                        'name': '(google.api.http).get',
                        'value': '/api/v1/comments/{commentId}'
                      },
                      {
                        'name': '(wix.api.required)',
                        'value': 'GetCommentRequest.context_token'
                      }
                    ]
                  },
                  'List': {
                    'requestType': 'GetListRequest',
                    'responseType': 'GetListResponse',
                    'options': {
                      '(wix.api.maturity)': 'ALPHA',
                      '(google.api.http).get': '/api/v1/comments'
                    },
                    'rawOptions': [
                      {
                        'name': '(wix.api.maturity)',
                        'value': 'ALPHA'
                      },
                      {
                        'name': '(google.api.http).get',
                        'value': '/api/v1/comments'
                      }
                    ]
                  },
                  'GetPagingContexts': {
                    'requestType': 'GetPagingContextsRequest',
                    'responseType': 'GetPagingContextsResponse',
                    'options': {
                      '(wix.api.maturity)': 'ALPHA',
                      '(wix.api.exposure)': 'INTERNAL',
                      '(google.api.http).post': '/api/v1/comments/get-contexts'
                    },
                    'rawOptions': [
                      {
                        'name': '(wix.api.maturity)',
                        'value': 'ALPHA'
                      },
                      {
                        'name': '(wix.api.exposure)',
                        'value': 'INTERNAL'
                      },
                      {
                        'name': '(google.api.http).post',
                        'value': '/api/v1/comments/get-contexts'
                      }
                    ]
                  },
                  'Create': {
                    'requestType': 'CreateCommentRequest',
                    'responseType': 'CreateCommentResponse',
                    'options': {
                      '(wix.api.maturity)': 'ALPHA',
                      '(google.api.http).post': '/api/v1/comments',
                      '(wix.api.callback).topic': 'wix-comments.callbacks',
                      '(wix.api.callback).payload': 'wix.comments.callbacks.CommentCreated',
                      '(wix.api.required)': 'CreateCommentRequest.context_token'
                    },
                    'rawOptions': [
                      {
                        'name': '(wix.api.maturity)',
                        'value': 'ALPHA'
                      },
                      {
                        'name': '(google.api.http).post',
                        'value': '/api/v1/comments'
                      },
                      {
                        'name': '(wix.api.callback).topic',
                        'value': 'wix-comments.callbacks'
                      },
                      {
                        'name': '(wix.api.callback).payload',
                        'value': 'wix.comments.callbacks.CommentCreated'
                      },
                      {
                        'name': '(wix.api.required)',
                        'value': 'CreateCommentRequest.context_token'
                      }
                    ]
                  },
                  'CreateReply': {
                    'requestType': 'CreateReplyRequest',
                    'responseType': 'CreateReplyResponse',
                    'options': {
                      '(wix.api.maturity)': 'ALPHA',
                      '(google.api.http).post': '/api/v1/comments/{parentCommentId}/reply',
                      '(wix.api.callback).topic': 'wix-comments.callbacks',
                      '(wix.api.callback).payload': 'wix.comments.callbacks.CommentCreated',
                      '(wix.api.required)': 'CreateReplyRequest.context_token'
                    },
                    'rawOptions': [
                      {
                        'name': '(wix.api.maturity)',
                        'value': 'ALPHA'
                      },
                      {
                        'name': '(google.api.http).post',
                        'value': '/api/v1/comments/{parentCommentId}/reply'
                      },
                      {
                        'name': '(wix.api.callback).topic',
                        'value': 'wix-comments.callbacks'
                      },
                      {
                        'name': '(wix.api.callback).payload',
                        'value': 'wix.comments.callbacks.CommentCreated'
                      },
                      {
                        'name': '(wix.api.required)',
                        'value': 'CreateReplyRequest.context_token'
                      }
                    ]
                  },
                  'Update': {
                    'requestType': 'UpdateCommentRequest',
                    'responseType': 'UpdateCommentResponse',
                    'options': {
                      '(wix.api.maturity)': 'ALPHA',
                      '(google.api.http).put': '/api/v1/comments/{commentId}',
                      '(wix.api.callback).topic': 'wix-comments.callbacks',
                      '(wix.api.callback).payload': 'wix.comments.callbacks.CommentUpdated',
                      '(wix.api.required)': 'UpdateCommentRequest.context_token'
                    },
                    'rawOptions': [
                      {
                        'name': '(wix.api.maturity)',
                        'value': 'ALPHA'
                      },
                      {
                        'name': '(google.api.http).put',
                        'value': '/api/v1/comments/{commentId}'
                      },
                      {
                        'name': '(wix.api.callback).topic',
                        'value': 'wix-comments.callbacks'
                      },
                      {
                        'name': '(wix.api.callback).payload',
                        'value': 'wix.comments.callbacks.CommentUpdated'
                      },
                      {
                        'name': '(wix.api.required)',
                        'value': 'UpdateCommentRequest.context_token'
                      }
                    ]
                  },
                  'Delete': {
                    'requestType': 'DeleteCommentRequest',
                    'responseType': 'DeleteCommentResponse',
                    'options': {
                      '(wix.api.maturity)': 'ALPHA',
                      '(google.api.http).delete': '/api/v1/comments/{commentId}',
                      '(wix.api.callback).topic': 'wix-comments.callbacks',
                      '(wix.api.callback).payload': 'wix.comments.callbacks.CommentDeleted',
                      '(wix.api.required)': 'DeleteCommentRequest.context_token'
                    },
                    'rawOptions': [
                      {
                        'name': '(wix.api.maturity)',
                        'value': 'ALPHA'
                      },
                      {
                        'name': '(google.api.http).delete',
                        'value': '/api/v1/comments/{commentId}'
                      },
                      {
                        'name': '(wix.api.callback).topic',
                        'value': 'wix-comments.callbacks'
                      },
                      {
                        'name': '(wix.api.callback).payload',
                        'value': 'wix.comments.callbacks.CommentDeleted'
                      },
                      {
                        'name': '(wix.api.required)',
                        'value': 'DeleteCommentRequest.context_token'
                      }
                    ]
                  },
                  'AddReaction': {
                    'requestType': 'AddReactionRequest',
                    'responseType': 'AddReactionResponse',
                    'options': {
                      '(wix.api.maturity)': 'ALPHA',
                      '(google.api.http).post': '/api/v1/comments/{commentId}/add-reaction',
                      '(google.api.http).additional_bindings.put': '/api/v1/comments/{commentId}/add-reaction',
                      '(wix.api.callback).topic': 'wix-comments.callbacks',
                      '(wix.api.callback).payload': 'wix.comments.callbacks.ReactedOnComment',
                      '(wix.api.required)': 'AddReactionRequest.context_token'
                    },
                    'rawOptions': [
                      {
                        'name': '(wix.api.maturity)',
                        'value': 'ALPHA'
                      },
                      {
                        'name': '(google.api.http).post',
                        'value': '/api/v1/comments/{commentId}/add-reaction'
                      },
                      {
                        'name': '(google.api.http).additional_bindings.put',
                        'value': '/api/v1/comments/{commentId}/add-reaction'
                      },
                      {
                        'name': '(wix.api.callback).topic',
                        'value': 'wix-comments.callbacks'
                      },
                      {
                        'name': '(wix.api.callback).payload',
                        'value': 'wix.comments.callbacks.ReactedOnComment'
                      },
                      {
                        'name': '(wix.api.required)',
                        'value': 'AddReactionRequest.context_token'
                      }
                    ]
                  },
                  'RemoveReaction': {
                    'requestType': 'RemoveReactionRequest',
                    'responseType': 'RemoveReactionResponse',
                    'options': {
                      '(wix.api.maturity)': 'ALPHA',
                      '(google.api.http).post': '/api/v1/comments/{commentId}/remove-reaction',
                      '(google.api.http).additional_bindings.put': '/api/v1/comments/{commentId}/remove-reaction',
                      '(wix.api.callback).topic': 'wix-comments.callbacks',
                      '(wix.api.callback).payload': 'wix.comments.callbacks.RemovedReactionOnComment',
                      '(wix.api.required)': 'RemoveReactionRequest.context_token'
                    },
                    'rawOptions': [
                      {
                        'name': '(wix.api.maturity)',
                        'value': 'ALPHA'
                      },
                      {
                        'name': '(google.api.http).post',
                        'value': '/api/v1/comments/{commentId}/remove-reaction'
                      },
                      {
                        'name': '(google.api.http).additional_bindings.put',
                        'value': '/api/v1/comments/{commentId}/remove-reaction'
                      },
                      {
                        'name': '(wix.api.callback).topic',
                        'value': 'wix-comments.callbacks'
                      },
                      {
                        'name': '(wix.api.callback).payload',
                        'value': 'wix.comments.callbacks.RemovedReactionOnComment'
                      },
                      {
                        'name': '(wix.api.required)',
                        'value': 'RemoveReactionRequest.context_token'
                      }
                    ]
                  },
                  'Report': {
                    'requestType': 'ReportRequest',
                    'responseType': 'ReportResponse',
                    'options': {
                      '(wix.api.maturity)': 'ALPHA',
                      '(google.api.http).post': '/api/v1/comments/{commentId}/report',
                      '(wix.api.callback).topic': 'wix-comments.callbacks',
                      '(wix.api.callback).payload': 'wix.comments.callbacks.CommentReported',
                      '(wix.api.required)': 'ReportRequest.context_token'
                    },
                    'rawOptions': [
                      {
                        'name': '(wix.api.maturity)',
                        'value': 'ALPHA'
                      },
                      {
                        'name': '(google.api.http).post',
                        'value': '/api/v1/comments/{commentId}/report'
                      },
                      {
                        'name': '(wix.api.callback).topic',
                        'value': 'wix-comments.callbacks'
                      },
                      {
                        'name': '(wix.api.callback).payload',
                        'value': 'wix.comments.callbacks.CommentReported'
                      },
                      {
                        'name': '(wix.api.required)',
                        'value': 'ReportRequest.context_token'
                      }
                    ]
                  },
                  'GetReports': {
                    'requestType': 'GetReportsRequest',
                    'responseType': 'GetReportsResponse',
                    'options': {
                      '(wix.api.maturity)': 'ALPHA',
                      '(google.api.http).get': '/api/v1/comments/{commentId}/reports',
                      '(wix.api.required)': 'GetReportsRequest.context_token'
                    },
                    'rawOptions': [
                      {
                        'name': '(wix.api.maturity)',
                        'value': 'ALPHA'
                      },
                      {
                        'name': '(google.api.http).get',
                        'value': '/api/v1/comments/{commentId}/reports'
                      },
                      {
                        'name': '(wix.api.required)',
                        'value': 'GetReportsRequest.context_token'
                      }
                    ]
                  }
                }
              },
              'GetCommentRequest': {
                'fields': {
                  'contextToken': {
                    'type': 'google.protobuf.StringValue',
                    'id': 1
                  },
                  'commentId': {
                    'type': 'string',
                    'id': 2,
                    'options': {
                      '(wix.api.format)': 'GUID'
                    }
                  },
                  'repliesRequest': {
                    'type': 'RepliesRequest',
                    'id': 3
                  },
                  'fieldset': {
                    'type': 'google.protobuf.StringValue',
                    'id': 4
                  }
                }
              },
              'GetCommentResponse': {
                'fields': {
                  'comment': {
                    'type': 'Comment',
                    'id': 1
                  },
                  'profiles': {
                    'type': 'wix.social.Profiles',
                    'id': 2
                  }
                }
              },
              'CreateCommentResponse': {
                'fields': {
                  'comment': {
                    'type': 'Comment',
                    'id': 1
                  }
                }
              },
              'CreateReplyResponse': {
                'fields': {
                  'comment': {
                    'type': 'Comment',
                    'id': 1
                  }
                }
              },
              'UpdateCommentResponse': {
                'fields': {
                  'comment': {
                    'type': 'Comment',
                    'id': 1
                  }
                }
              },
              'AddReactionResponse': {
                'fields': {
                  'comment': {
                    'type': 'Comment',
                    'id': 1
                  }
                }
              },
              'RemoveReactionResponse': {
                'fields': {
                  'comment': {
                    'type': 'Comment',
                    'id': 1
                  }
                }
              },
              'CreateCommentRequest': {
                'fields': {
                  'contextToken': {
                    'type': 'google.protobuf.StringValue',
                    'id': 1
                  },
                  'comment': {
                    'type': 'CommentEntity',
                    'id': 2
                  },
                  'predefinedCommentId': {
                    'type': 'google.protobuf.StringValue',
                    'id': 3,
                    'options': {
                      '(wix.api.format)': 'GUID'
                    }
                  },
                  'entityId': {
                    'type': 'google.protobuf.StringValue',
                    'id': 4,
                    'options': {
                      '(wix.api.format)': 'GUID'
                    }
                  }
                }
              },
              'CreateReplyRequest': {
                'fields': {
                  'contextToken': {
                    'type': 'google.protobuf.StringValue',
                    'id': 1
                  },
                  'parentCommentId': {
                    'type': 'string',
                    'id': 2,
                    'options': {
                      '(wix.api.format)': 'GUID'
                    }
                  },
                  'reply': {
                    'type': 'CommentEntity',
                    'id': 3
                  }
                }
              },
              'GetPagingContextsRequest': {
                'fields': {
                  'pagingContextSetups': {
                    'rule': 'repeated',
                    'type': 'PagingContextSetup',
                    'id': 1
                  },
                  'repliesRequest': {
                    'type': 'RepliesRequest',
                    'id': 2
                  },
                  'fieldset': {
                    'type': 'google.protobuf.StringValue',
                    'id': 3
                  }
                }
              },
              'GetPagingContextsResponse': {
                'fields': {
                  'contexts': {
                    'keyType': 'string',
                    'type': 'PagingContext',
                    'id': 1
                  },
                  'profiles': {
                    'type': 'wix.social.Profiles',
                    'id': 2
                  }
                }
              },
              'GetPagingContextRequest': {
                'fields': {
                  'pagingContextSetup': {
                    'type': 'PagingContextSetup',
                    'id': 1
                  },
                  'repliesRequest': {
                    'type': 'RepliesRequest',
                    'id': 2
                  },
                  'fieldset': {
                    'type': 'google.protobuf.StringValue',
                    'id': 3
                  }
                }
              },
              'GetPagingContextResponse': {
                'fields': {
                  'context': {
                    'type': 'PagingContext',
                    'id': 1
                  },
                  'profiles': {
                    'type': 'wix.social.Profiles',
                    'id': 2
                  }
                }
              },
              'GetListRequest': {
                'oneofs': {
                  'pageRequest': {
                    'oneof': [
                      'pagingContextSetup',
                      'cursorPaging'
                    ]
                  }
                },
                'fields': {
                  'pagingContextSetup': {
                    'type': 'PagingContextSetup',
                    'id': 1
                  },
                  'cursorPaging': {
                    'type': 'wix.common.CursorPaging',
                    'id': 2
                  },
                  'contextToken': {
                    'type': 'google.protobuf.StringValue',
                    'id': 3
                  },
                  'repliesRequest': {
                    'type': 'RepliesRequest',
                    'id': 4
                  },
                  'fieldset': {
                    'type': 'google.protobuf.StringValue',
                    'id': 5
                  }
                }
              },
              'PagingContextSetup': {
                'fields': {
                  'containerId': {
                    'type': 'google.protobuf.StringValue',
                    'id': 1,
                    'options': {
                      '(wix.api.format)': 'GUID'
                    }
                  },
                  'entityId': {
                    'type': 'google.protobuf.StringValue',
                    'id': 5,
                    'options': {
                      '(wix.api.format)': 'GUID'
                    }
                  },
                  'containerType': {
                    'type': 'google.protobuf.StringValue',
                    'id': 2
                  },
                  'limit': {
                    'type': 'google.protobuf.Int32Value',
                    'id': 3,
                    'options': {
                      '(wix.api.min)': 0
                    }
                  },
                  'access': {
                    'type': 'CommentsAccess',
                    'id': 4
                  },
                  'flattenToDepth': {
                    'type': 'google.protobuf.Int32Value',
                    'id': 6
                  },
                  'ordering': {
                    'type': 'Ordering',
                    'id': 7
                  }
                }
              },
              'GetListResponse': {
                'fields': {
                  'comments': {
                    'rule': 'repeated',
                    'type': 'Comment',
                    'id': 1
                  },
                  'contextToken': {
                    'type': 'google.protobuf.StringValue',
                    'id': 2
                  },
                  'nextCursor': {
                    'type': 'google.protobuf.StringValue',
                    'id': 3
                  },
                  'previousCursor': {
                    'type': 'google.protobuf.StringValue',
                    'id': 11
                  },
                  'profiles': {
                    'type': 'wix.social.Profiles',
                    'id': 4
                  },
                  'remainingCount': {
                    'type': 'google.protobuf.Int32Value',
                    'id': 5
                  },
                  'count': {
                    'type': 'google.protobuf.Int32Value',
                    'id': 6
                  },
                  'availableActions': {
                    'rule': 'repeated',
                    'type': 'UserAction',
                    'id': 7
                  },
                  'loggedInUserId': {
                    'type': 'google.protobuf.StringValue',
                    'id': 8,
                    'options': {
                      'deprecated': true
                    }
                  },
                  'loggedInIdentity': {
                    'type': 'wix.social.SocialIdentity',
                    'id': 9
                  }
                }
              },
              'PagingContext': {
                'fields': {
                  'comments': {
                    'rule': 'repeated',
                    'type': 'Comment',
                    'id': 1
                  },
                  'contextToken': {
                    'type': 'google.protobuf.StringValue',
                    'id': 2
                  },
                  'nextCursor': {
                    'type': 'google.protobuf.StringValue',
                    'id': 3
                  }
                }
              },
              'UpdateCommentRequest': {
                'fields': {
                  'contextToken': {
                    'type': 'google.protobuf.StringValue',
                    'id': 1
                  },
                  'commentId': {
                    'type': 'string',
                    'id': 2,
                    'options': {
                      '(wix.api.format)': 'GUID'
                    }
                  },
                  'comment': {
                    'type': 'CommentEntity',
                    'id': 3
                  },
                  'mask': {
                    'type': 'google.protobuf.FieldMask',
                    'id': 4
                  }
                }
              },
              'DeleteCommentRequest': {
                'fields': {
                  'contextToken': {
                    'type': 'google.protobuf.StringValue',
                    'id': 1
                  },
                  'commentId': {
                    'type': 'string',
                    'id': 2,
                    'options': {
                      '(wix.api.format)': 'GUID'
                    }
                  },
                  'listRequest': {
                    'type': 'GetListRequest',
                    'id': 3
                  }
                }
              },
              'DeleteCommentResponse': {
                'fields': {
                  'comment': {
                    'type': 'Comment',
                    'id': 1
                  },
                  'listResponse': {
                    'type': 'GetListResponse',
                    'id': 2
                  }
                }
              },
              'AddReactionRequest': {
                'fields': {
                  'contextToken': {
                    'type': 'google.protobuf.StringValue',
                    'id': 1
                  },
                  'commentId': {
                    'type': 'string',
                    'id': 2,
                    'options': {
                      '(wix.api.format)': 'GUID'
                    }
                  }
                }
              },
              'RemoveReactionRequest': {
                'fields': {
                  'contextToken': {
                    'type': 'google.protobuf.StringValue',
                    'id': 1
                  },
                  'commentId': {
                    'type': 'string',
                    'id': 2,
                    'options': {
                      '(wix.api.format)': 'GUID'
                    }
                  }
                }
              },
              'RepliesRequest': {
                'fields': {
                  'repliesToLoad': {
                    'type': 'int32',
                    'id': 1
                  }
                }
              },
              'ReportRequest': {
                'fields': {
                  'contextToken': {
                    'type': 'google.protobuf.StringValue',
                    'id': 1
                  },
                  'commentId': {
                    'type': 'string',
                    'id': 2,
                    'options': {
                      '(wix.api.format)': 'GUID'
                    }
                  },
                  'reportType': {
                    'type': 'ReportType',
                    'id': 3
                  },
                  'fieldset': {
                    'type': 'google.protobuf.StringValue',
                    'id': 4
                  }
                }
              },
              'ReportResponse': {
                'fields': {
                  'comment': {
                    'type': 'Comment',
                    'id': 1
                  },
                  'profiles': {
                    'type': 'wix.social.Profiles',
                    'id': 2
                  }
                }
              },
              'GetReportsRequest': {
                'fields': {
                  'contextToken': {
                    'type': 'google.protobuf.StringValue',
                    'id': 1
                  },
                  'commentId': {
                    'type': 'string',
                    'id': 2,
                    'options': {
                      '(wix.api.format)': 'GUID'
                    }
                  }
                }
              },
              'GetReportsResponse': {
                'fields': {
                  'reported': {
                    'type': 'Reported',
                    'id': 1
                  }
                }
              },
              'gdpr': {
                'options': {
                  'java_package': 'com.wix.comments.gdpr'
                },
                'nested': {
                  'GdprService': {
                    'methods': {
                      'Access': {
                        'requestType': 'AccessRequest',
                        'responseType': 'AccessResponse',
                        'options': {
                          '(wix.api.maturity)': 'ALPHA',
                          '(google.api.http).get': '/api/v1/gdpr/comments/access'
                        },
                        'rawOptions': [
                          {
                            'name': '(wix.api.maturity)',
                            'value': 'ALPHA'
                          },
                          {
                            'name': '(google.api.http).get',
                            'value': '/api/v1/gdpr/comments/access'
                          }
                        ]
                      },
                      'Forget': {
                        'requestType': 'ForgetRequest',
                        'responseType': 'ForgetResponse',
                        'options': {
                          '(wix.api.maturity)': 'ALPHA',
                          '(google.api.http).post': '/api/v1/gdpr/comments/forget'
                        },
                        'rawOptions': [
                          {
                            'name': '(wix.api.maturity)',
                            'value': 'ALPHA'
                          },
                          {
                            'name': '(google.api.http).post',
                            'value': '/api/v1/gdpr/comments/forget'
                          }
                        ]
                      }
                    }
                  },
                  'AccessRequest': {
                    'fields': {}
                  },
                  'AccessResponse': {
                    'fields': {
                      'comments': {
                        'rule': 'repeated',
                        'type': 'GdprComment',
                        'id': 1
                      },
                      'actions': {
                        'rule': 'repeated',
                        'type': 'GdprCommentAction',
                        'id': 2
                      }
                    }
                  },
                  'GdprComment': {
                    'fields': {
                      'comment': {
                        'type': 'Comment',
                        'id': 1
                      },
                      'status': {
                        'type': 'Status',
                        'id': 2
                      }
                    },
                    'nested': {
                      'Status': {
                        'values': {
                          'CREATED': 0,
                          'REMOVED': 1
                        }
                      }
                    }
                  },
                  'GdprCommentAction': {
                    'fields': {
                      'commentId': {
                        'type': 'string',
                        'id': 1
                      },
                      'actionType': {
                        'type': 'string',
                        'id': 2
                      },
                      'timestamp': {
                        'type': 'google.protobuf.Timestamp',
                        'id': 3
                      },
                      'data': {
                        'type': 'google.protobuf.Value',
                        'id': 4
                      }
                    }
                  },
                  'ForgetRequest': {
                    'fields': {}
                  },
                  'ForgetResponse': {
                    'fields': {}
                  }
                }
              },
              'FeedPageCursor': {
                'fields': {
                  'fromEventId': {
                    'type': 'int64',
                    'id': 1
                  },
                  'priorityTag': {
                    'type': 'PriorityTag',
                    'id': 2
                  },
                  'pageQuery': {
                    'type': 'FeedPageQuery',
                    'id': 3
                  }
                },
                'nested': {
                  'PriorityTag': {
                    'values': {
                      'REMAINING': 0,
                      'PINNED': 1
                    }
                  }
                }
              },
              'FeedPageQuery': {
                'fields': {
                  'identityId': {
                    'type': 'google.protobuf.StringValue',
                    'id': 1
                  },
                  'excludeOwn': {
                    'type': 'bool',
                    'id': 2
                  },
                  'limit': {
                    'type': 'google.protobuf.Int32Value',
                    'id': 3
                  },
                  'filter': {
                    'type': 'Filter',
                    'id': 4
                  }
                }
              },
              'Filter': {
                'fields': {
                  'rules': {
                    'rule': 'repeated',
                    'type': 'FilterRule',
                    'id': 1
                  }
                }
              },
              'FilterRule': {
                'oneofs': {
                  'rule': {
                    'oneof': ['fieldFilter']
                  }
                },
                'fields': {
                  'fieldFilter': {
                    'type': 'FieldFilter',
                    'id': 1
                  }
                }
              },
              'FieldFilter': {
                'oneofs': {
                  'match': {
                    'oneof': [
                      'filter',
                      'exactString'
                    ]
                  }
                },
                'fields': {
                  'name': {
                    'type': 'string',
                    'id': 1
                  },
                  'filter': {
                    'type': 'Filter',
                    'id': 2
                  },
                  'exactString': {
                    'type': 'string',
                    'id': 3
                  }
                }
              }
            }
          },
          'api': {
            'options': {
              'java_multiple_files': true,
              'java_outer_classname': 'CallbackProto',
              'java_package': 'com.wix.api'
            },
            'nested': {
              'max': {
                'type': 'double',
                'id': 50201,
                'extend': 'google.protobuf.FieldOptions'
              },
              'min': {
                'type': 'double',
                'id': 50202,
                'extend': 'google.protobuf.FieldOptions'
              },
              'maxLength': {
                'type': 'int32',
                'id': 50203,
                'extend': 'google.protobuf.FieldOptions'
              },
              'minLength': {
                'type': 'int32',
                'id': 50204,
                'extend': 'google.protobuf.FieldOptions'
              },
              'maxSize': {
                'type': 'int32',
                'id': 50209,
                'extend': 'google.protobuf.FieldOptions'
              },
              'minSize': {
                'type': 'int32',
                'id': 50210,
                'extend': 'google.protobuf.FieldOptions'
              },
              'format': {
                'type': 'Format',
                'id': 50205,
                'extend': 'google.protobuf.FieldOptions'
              },
              'readOnly': {
                'type': 'bool',
                'id': 50208,
                'extend': 'google.protobuf.FieldOptions'
              },
              'required': {
                'rule': 'repeated',
                'type': 'string',
                'id': 50200,
                'extend': 'google.protobuf.MethodOptions'
              },
              'Format': {
                'values': {
                  'EMAIL': 0,
                  'HOSTNAME': 1,
                  'IPV4': 2,
                  'IPV6': 3,
                  'URI': 4,
                  'PHONE': 7,
                  'CREDIT_CARD': 8,
                  'GUID': 9,
                  'COUNTRY': 10,
                  'LANGUAGE': 11,
                  'DECIMAL_VALUE': 12,
                  'CURRENCY': 13
                }
              },
              'serviceMaturity': {
                'type': 'Maturity',
                'id': 50104,
                'extend': 'google.protobuf.ServiceOptions'
              },
              'serviceExposure': {
                'type': 'Exposure',
                'id': 50105,
                'extend': 'google.protobuf.ServiceOptions'
              },
              'exposure': {
                'type': 'Exposure',
                'id': 50101,
                'extend': 'google.protobuf.MethodOptions'
              },
              'maturity': {
                'type': 'Maturity',
                'id': 50102,
                'extend': 'google.protobuf.MethodOptions'
              },
              'Exposure': {
                'values': {
                  'PRIVATE': 0,
                  'INTERNAL': 1,
                  'PUBLIC': 2
                }
              },
              'Maturity': {
                'values': {
                  'ALPHA': 0,
                  'BETA': 1,
                  'IA': 2,
                  'GA': 3
                }
              },
              'callback': {
                'rule': 'repeated',
                'type': 'Callback',
                'id': 50000,
                'extend': 'google.protobuf.MethodOptions'
              },
              'event': {
                'rule': 'repeated',
                'type': 'Callback',
                'id': 50000,
                'extend': 'google.protobuf.ServiceOptions',
                'options': {
                  'packed': false
                }
              },
              'Callback': {
                'fields': {
                  'topic': {
                    'rule': 'required',
                    'type': 'string',
                    'id': 1
                  },
                  'payload': {
                    'rule': 'required',
                    'type': 'string',
                    'id': 2
                  },
                  'permission': {
                    'type': 'string',
                    'id': 3
                  }
                }
              }
            }
          },
          'common': {
            'options': {
              'java_multiple_files': true,
              'java_package': 'com.wix.common',
              'java_outer_classname': 'WixLinkProto'
            },
            'nested': {
              'Paging': {
                'fields': {
                  'limit': {
                    'type': 'google.protobuf.Int32Value',
                    'id': 1,
                    'options': {
                      '(wix.api.min)': 0
                    }
                  },
                  'offset': {
                    'type': 'google.protobuf.Int32Value',
                    'id': 2,
                    'options': {
                      '(wix.api.min)': 0
                    }
                  }
                }
              },
              'CursorPaging': {
                'fields': {
                  'limit': {
                    'type': 'google.protobuf.Int32Value',
                    'id': 1,
                    'options': {
                      '(wix.api.min)': 0
                    }
                  },
                  'cursor': {
                    'type': 'google.protobuf.StringValue',
                    'id': 2
                  }
                }
              },
              'Address': {
                'oneofs': {
                  'street': {
                    'oneof': [
                      'streetAddress',
                      'addressLine'
                    ]
                  }
                },
                'fields': {
                  'country': {
                    'type': 'google.protobuf.StringValue',
                    'id': 1,
                    'options': {
                      '(wix.api.format)': 'COUNTRY'
                    }
                  },
                  'subdivision': {
                    'type': 'google.protobuf.StringValue',
                    'id': 2
                  },
                  'city': {
                    'type': 'google.protobuf.StringValue',
                    'id': 3
                  },
                  'postalCode': {
                    'type': 'google.protobuf.StringValue',
                    'id': 4
                  },
                  'streetAddress': {
                    'type': 'StreetAddress',
                    'id': 5
                  },
                  'addressLine': {
                    'type': 'google.protobuf.StringValue',
                    'id': 6
                  },
                  'addressLine_2': {
                    'type': 'google.protobuf.StringValue',
                    'id': 7
                  }
                }
              },
              'StreetAddress': {
                'fields': {
                  'number': {
                    'type': 'string',
                    'id': 1
                  },
                  'name': {
                    'type': 'string',
                    'id': 2
                  }
                }
              },
              'AddressContactDetails': {
                'fields': {
                  'fullName': {
                    'type': 'google.protobuf.StringValue',
                    'id': 1
                  },
                  'phone': {
                    'type': 'google.protobuf.StringValue',
                    'id': 2,
                    'options': {
                      '(wix.api.format)': 'PHONE'
                    }
                  },
                  'company': {
                    'type': 'google.protobuf.StringValue',
                    'id': 3
                  },
                  'email': {
                    'type': 'google.protobuf.StringValue',
                    'id': 4,
                    'options': {
                      '(wix.api.format)': 'EMAIL'
                    }
                  }
                }
              },
              'FullAddressContactDetails': {
                'fields': {
                  'firstName': {
                    'type': 'google.protobuf.StringValue',
                    'id': 1
                  },
                  'lastName': {
                    'type': 'google.protobuf.StringValue',
                    'id': 2
                  },
                  'phone': {
                    'type': 'google.protobuf.StringValue',
                    'id': 3,
                    'options': {
                      '(wix.api.format)': 'PHONE'
                    }
                  },
                  'company': {
                    'type': 'google.protobuf.StringValue',
                    'id': 4
                  },
                  'email': {
                    'type': 'google.protobuf.StringValue',
                    'id': 5,
                    'options': {
                      '(wix.api.format)': 'EMAIL'
                    }
                  },
                  'vatId': {
                    'type': 'VatId',
                    'id': 7
                  }
                }
              },
              'VatId': {
                'fields': {
                  'id': {
                    'type': 'string',
                    'id': 1
                  },
                  'type': {
                    'type': 'VatType',
                    'id': 2
                  }
                }
              },
              'VatType': {
                'values': {
                  'UNSPECIFIED': 0,
                  'CPF': 1,
                  'CNPJ': 2
                }
              },
              'AddressLocation': {
                'fields': {
                  'latitude': {
                    'type': 'google.protobuf.DoubleValue',
                    'id': 1
                  },
                  'longitude': {
                    'type': 'google.protobuf.DoubleValue',
                    'id': 2
                  }
                }
              },
              'Image': {
                'fields': {
                  'id': {
                    'type': 'string',
                    'id': 1
                  },
                  'url': {
                    'type': 'string',
                    'id': 2
                  },
                  'height': {
                    'type': 'int32',
                    'id': 3
                  },
                  'width': {
                    'type': 'int32',
                    'id': 4
                  }
                }
              },
              'Video': {
                'fields': {
                  'id': {
                    'type': 'string',
                    'id': 1
                  },
                  'url': {
                    'type': 'string',
                    'id': 2
                  },
                  'height': {
                    'type': 'int32',
                    'id': 3
                  },
                  'width': {
                    'type': 'int32',
                    'id': 4
                  },
                  'thumbnail': {
                    'type': 'Image',
                    'id': 5
                  }
                }
              },
              'Document': {
                'fields': {
                  'id': {
                    'type': 'string',
                    'id': 1
                  },
                  'url': {
                    'type': 'string',
                    'id': 2
                  }
                }
              },
              'MediaItem': {
                'oneofs': {
                  'media': {
                    'oneof': [
                      'image',
                      'video',
                      'document'
                    ]
                  }
                },
                'fields': {
                  'image': {
                    'type': 'Image',
                    'id': 1
                  },
                  'video': {
                    'type': 'Video',
                    'id': 2
                  },
                  'document': {
                    'type': 'Document',
                    'id': 3
                  }
                }
              },
              'PageUrl': {
                'fields': {
                  'base': {
                    'type': 'string',
                    'id': 1
                  },
                  'path': {
                    'type': 'string',
                    'id': 2
                  }
                }
              },
              'Sorting': {
                'fields': {
                  'fieldName': {
                    'type': 'string',
                    'id': 1
                  },
                  'order': {
                    'type': 'SortOrder',
                    'id': 2
                  }
                }
              },
              'SortOrder': {
                'values': {
                  'ASC': 0,
                  'DESC': 1
                }
              },
              'WixLink': {
                'oneofs': {
                  'Link': {
                    'oneof': [
                      'external',
                      'page',
                      'anchor',
                      'dynamicPage',
                      'document',
                      'email',
                      'phone',
                      'address',
                      'whatsApp'
                    ]
                  }
                },
                'fields': {
                  'external': {
                    'type': 'ExternalLink',
                    'id': 1
                  },
                  'page': {
                    'type': 'PageLink',
                    'id': 2
                  },
                  'anchor': {
                    'type': 'AnchorLink',
                    'id': 3
                  },
                  'dynamicPage': {
                    'type': 'DynamicPageLink',
                    'id': 4
                  },
                  'document': {
                    'type': 'DocumentLink',
                    'id': 5
                  },
                  'email': {
                    'type': 'EmailLink',
                    'id': 6
                  },
                  'phone': {
                    'type': 'PhoneLink',
                    'id': 7
                  },
                  'address': {
                    'type': 'AddressLink',
                    'id': 8
                  },
                  'whatsApp': {
                    'type': 'WhatsAppLink',
                    'id': 9
                  }
                }
              },
              'ExternalLink': {
                'fields': {
                  'url': {
                    'type': 'string',
                    'id': 1,
                    'options': {
                      '(wix.api.format)': 'URI'
                    }
                  },
                  'target': {
                    'type': 'google.protobuf.StringValue',
                    'id': 2
                  }
                }
              },
              'PageLink': {
                'fields': {
                  'pageId': {
                    'type': 'string',
                    'id': 1
                  },
                  'target': {
                    'type': 'google.protobuf.StringValue',
                    'id': 2
                  }
                }
              },
              'AnchorLink': {
                'fields': {
                  'anchorName': {
                    'type': 'string',
                    'id': 1
                  },
                  'anchorDataId': {
                    'type': 'string',
                    'id': 2
                  },
                  'pageId': {
                    'type': 'string',
                    'id': 3
                  }
                }
              },
              'DynamicPageLink': {
                'fields': {
                  'routerId': {
                    'type': 'string',
                    'id': 1
                  },
                  'innerRoute': {
                    'type': 'string',
                    'id': 2
                  },
                  'anchorDataId': {
                    'type': 'google.protobuf.StringValue',
                    'id': 3
                  }
                }
              },
              'DocumentLink': {
                'fields': {
                  'docId': {
                    'type': 'string',
                    'id': 1
                  },
                  'name': {
                    'type': 'google.protobuf.StringValue',
                    'id': 2
                  },
                  'indexable': {
                    'type': 'bool',
                    'id': 3
                  }
                }
              },
              'EmailLink': {
                'fields': {
                  'recipient': {
                    'type': 'string',
                    'id': 1,
                    'options': {
                      '(wix.api.format)': 'EMAIL'
                    }
                  },
                  'subject': {
                    'type': 'google.protobuf.StringValue',
                    'id': 2
                  },
                  'body': {
                    'type': 'google.protobuf.StringValue',
                    'id': 3
                  }
                }
              },
              'PhoneLink': {
                'fields': {
                  'phoneNumber': {
                    'type': 'string',
                    'id': 1,
                    'options': {
                      '(wix.api.format)': 'PHONE',
                      '(wix.api.maxLength)': 100
                    }
                  }
                }
              },
              'AddressLink': {
                'fields': {
                  'address': {
                    'type': 'string',
                    'id': 1
                  }
                }
              },
              'WhatsAppLink': {
                'fields': {
                  'phoneNumber': {
                    'type': 'string',
                    'id': 1,
                    'options': {
                      '(wix.api.format)': 'PHONE'
                    }
                  }
                }
              }
            }
          },
          'social': {
            'options': {
              'java_package': 'com.wix.catalyst.socialcontent.api'
            },
            'nested': {
              'Text': {
                'fields': {
                  'contentType': {
                    'type': 'ContentType',
                    'id': 1
                  },
                  'content': {
                    'type': 'google.protobuf.StringValue',
                    'id': 2
                  }
                }
              },
              'ContentType': {
                'values': {
                  'PLAIN_TEXT': 0,
                  'DRAFTJS': 1
                }
              },
              'Resource': {
                'oneofs': {
                  'ResourceId': {
                    'oneof': [
                      'uri',
                      'id'
                    ]
                  }
                },
                'fields': {
                  'uri': {
                    'type': 'string',
                    'id': 1
                  },
                  'id': {
                    'type': 'string',
                    'id': 2
                  },
                  'mediaType': {
                    'type': 'MediaType',
                    'id': 3
                  },
                  'pixelDimensions': {
                    'type': 'PixelDimensions',
                    'id': 4
                  },
                  'mimeType': {
                    'type': 'google.protobuf.StringValue',
                    'id': 5
                  }
                }
              },
              'MediaType': {
                'values': {
                  'ATTACHMENT': 0,
                  'IMAGE': 1,
                  'VIDEO': 2
                }
              },
              'PixelDimensions': {
                'fields': {
                  'width': {
                    'type': 'int32',
                    'id': 1
                  },
                  'height': {
                    'type': 'int32',
                    'id': 2
                  }
                }
              },
              'Mention': {
                'fields': {
                  'identity': {
                    'type': 'SocialIdentity',
                    'id': 1
                  }
                }
              },
              'ExternalReference': {
                'fields': {
                  'url': {
                    'type': 'string',
                    'id': 1,
                    'options': {
                      '(wix.api.format)': 'URI'
                    }
                  }
                }
              },
              'ContentPreview': {
                'fields': {
                  'contentUrl': {
                    'type': 'string',
                    'id': 1
                  },
                  'openGraph': {
                    'type': 'OpenGraph',
                    'id': 2
                  }
                }
              },
              'OpenGraph': {
                'oneofs': {
                  'openGraphType': {
                    'oneof': [
                      'typeWebsite',
                      'typeArticle'
                    ]
                  }
                },
                'fields': {
                  'title': {
                    'type': 'string',
                    'id': 1
                  },
                  'url': {
                    'type': 'string',
                    'id': 2,
                    'options': {
                      '(wix.api.format)': 'URI'
                    }
                  },
                  'description': {
                    'type': 'google.protobuf.StringValue',
                    'id': 3
                  },
                  'image': {
                    'type': 'Image',
                    'id': 4
                  },
                  'typeWebsite': {
                    'type': 'Website',
                    'id': 5
                  },
                  'typeArticle': {
                    'type': 'Article',
                    'id': 6
                  }
                },
                'nested': {
                  'Image': {
                    'fields': {
                      'url': {
                        'type': 'string',
                        'id': 1
                      },
                      'width': {
                        'type': 'google.protobuf.Int32Value',
                        'id': 2
                      },
                      'height': {
                        'type': 'google.protobuf.Int32Value',
                        'id': 3
                      }
                    }
                  },
                  'Website': {
                    'fields': {}
                  },
                  'Article': {
                    'fields': {
                      'publishedTime': {
                        'type': 'google.protobuf.Timestamp',
                        'id': 1
                      },
                      'modifiedTime': {
                        'type': 'google.protobuf.Timestamp',
                        'id': 2
                      },
                      'expirationTime': {
                        'type': 'google.protobuf.Timestamp',
                        'id': 3
                      },
                      'author': {
                        'rule': 'repeated',
                        'type': 'string',
                        'id': 4
                      },
                      'section': {
                        'type': 'string',
                        'id': 5
                      },
                      'tag': {
                        'rule': 'repeated',
                        'type': 'string',
                        'id': 6
                      }
                    }
                  }
                }
              },
              'IdentityType': {
                'values': {
                  'ANONYMOUS': 0,
                  'MEMBER': 1,
                  'USER': 2
                }
              },
              'SocialIdentity': {
                'fields': {
                  'identityId': {
                    'type': 'string',
                    'id': 1,
                    'options': {
                      '(wix.api.format)': 'GUID'
                    }
                  },
                  'identityType': {
                    'type': 'IdentityType',
                    'id': 2
                  }
                }
              },
              'Profile': {
                'fields': {
                  'id': {
                    'type': 'string',
                    'id': 1
                  },
                  'nickname': {
                    'type': 'google.protobuf.StringValue',
                    'id': 2
                  },
                  'slug': {
                    'type': 'google.protobuf.StringValue',
                    'id': 3
                  },
                  'imageUrl': {
                    'type': 'google.protobuf.StringValue',
                    'id': 4
                  },
                  'contactId': {
                    'type': 'string',
                    'id': 5
                  },
                  'isAnonymous': {
                    'type': 'bool',
                    'id': 6
                  }
                }
              },
              'Profiles': {
                'fields': {
                  'profiles': {
                    'keyType': 'string',
                    'type': 'Profile',
                    'id': 1
                  }
                }
              },
              'SocialContainer': {
                'fields': {
                  'containerId': {
                    'type': 'string',
                    'id': 1
                  },
                  'containerType': {
                    'type': 'string',
                    'id': 2
                  }
                }
              },
              'SocialEntity': {
                'fields': {
                  'ownedBy': {
                    'type': 'SocialIdentity',
                    'id': 1
                  }
                }
              },
              'ActivitiesService': {
                'methods': {
                  'QueryActivityStats': {
                    'requestType': 'QueryActivityStatsRequest',
                    'responseType': 'QueryActivityStatsResponse',
                    'options': {
                      '(wix.api.maturity)': 'ALPHA',
                      '(google.api.http).get': '/api/v1/activities',
                      '(google.api.http).additional_bindings.post': '/api/v1/activities/query'
                    },
                    'rawOptions': [
                      {
                        'name': '(wix.api.maturity)',
                        'value': 'ALPHA'
                      },
                      {
                        'name': '(google.api.http).get',
                        'value': '/api/v1/activities'
                      },
                      {
                        'name': '(google.api.http).additional_bindings.post',
                        'value': '/api/v1/activities/query'
                      }
                    ]
                  },
                  'QueryLatestActivity': {
                    'requestType': 'QueryLatestActivityRequest',
                    'responseType': 'QueryLatestActivityResponse',
                    'options': {
                      '(wix.api.maturity)': 'ALPHA',
                      '(google.api.http).get': '/api/v1/activities/latest',
                      '(google.api.http).additional_bindings.post': '/api/v1/activities/latest/query'
                    },
                    'rawOptions': [
                      {
                        'name': '(wix.api.maturity)',
                        'value': 'ALPHA'
                      },
                      {
                        'name': '(google.api.http).get',
                        'value': '/api/v1/activities/latest'
                      },
                      {
                        'name': '(google.api.http).additional_bindings.post',
                        'value': '/api/v1/activities/latest/query'
                      }
                    ]
                  },
                  'QueryIdentityActivityStats': {
                    'requestType': 'QueryIdentityActivityStatsRequest',
                    'responseType': 'QueryIdentityActivityStatsResponse',
                    'options': {
                      '(wix.api.maturity)': 'ALPHA',
                      '(google.api.http).get': '/api/v1/activities/identity'
                    },
                    'rawOptions': [
                      {
                        'name': '(wix.api.maturity)',
                        'value': 'ALPHA'
                      },
                      {
                        'name': '(google.api.http).get',
                        'value': '/api/v1/activities/identity'
                      }
                    ]
                  }
                }
              },
              'QueryActivityStatsRequest': {
                'oneofs': {
                  'range': {
                    'oneof': [
                      'time',
                      'version'
                    ]
                  }
                },
                'fields': {
                  'contextTokens': {
                    'rule': 'repeated',
                    'type': 'string',
                    'id': 1,
                    'options': {
                      '(wix.api.minSize)': 1,
                      '(wix.api.maxSize)': 100
                    }
                  },
                  'activityTypes': {
                    'rule': 'repeated',
                    'type': 'string',
                    'id': 2,
                    'options': {
                      '(wix.api.minSize)': 1,
                      '(wix.api.maxSize)': 100
                    }
                  },
                  'time': {
                    'type': 'TimeRange',
                    'id': 3
                  },
                  'version': {
                    'type': 'VersionQuery',
                    'id': 4
                  }
                }
              },
              'QueryLatestActivityRequest': {
                'fields': {
                  'contextTokens': {
                    'rule': 'repeated',
                    'type': 'string',
                    'id': 1,
                    'options': {
                      '(wix.api.minSize)': 1,
                      '(wix.api.maxSize)': 100
                    }
                  },
                  'activityTypes': {
                    'rule': 'repeated',
                    'type': 'string',
                    'id': 2,
                    'options': {
                      '(wix.api.minSize)': 1,
                      '(wix.api.maxSize)': 100
                    }
                  }
                }
              },
              'QueryIdentityActivityStatsRequest': {
                'fields': {
                  'contextTokens': {
                    'rule': 'repeated',
                    'type': 'string',
                    'id': 1,
                    'options': {
                      '(wix.api.minSize)': 1,
                      '(wix.api.maxSize)': 100
                    }
                  },
                  'activityTypes': {
                    'rule': 'repeated',
                    'type': 'string',
                    'id': 2,
                    'options': {
                      '(wix.api.minSize)': 1,
                      '(wix.api.maxSize)': 100
                    }
                  },
                  'identities': {
                    'rule': 'repeated',
                    'type': 'SocialIdentity',
                    'id': 3,
                    'options': {
                      '(wix.api.minSize)': 1,
                      '(wix.api.maxSize)': 100
                    }
                  }
                }
              },
              'QueryActivityStatsResponse': {
                'fields': {
                  'activityStats': {
                    'rule': 'repeated',
                    'type': 'ContainerActivityStats',
                    'id': 1
                  }
                }
              },
              'QueryLatestActivityResponse': {
                'fields': {
                  'latestActivities': {
                    'rule': 'repeated',
                    'type': 'ContainerLatestActivity',
                    'id': 1
                  }
                }
              },
              'QueryIdentityActivityStatsResponse': {
                'fields': {
                  'activityStats': {
                    'rule': 'repeated',
                    'type': 'ContainerIdentityActivityStats',
                    'id': 1
                  }
                }
              },
              'ContainerActivityStats': {
                'fields': {
                  'containerId': {
                    'type': 'string',
                    'id': 1
                  },
                  'containerType': {
                    'type': 'string',
                    'id': 2
                  },
                  'versionRange': {
                    'type': 'VersionRange',
                    'id': 3
                  },
                  'stats': {
                    'keyType': 'string',
                    'type': 'RequesterContextActivityStats',
                    'id': 4
                  }
                }
              },
              'ContainerIdentityActivityStats': {
                'fields': {
                  'containerId': {
                    'type': 'string',
                    'id': 1
                  },
                  'containerType': {
                    'type': 'string',
                    'id': 2
                  },
                  'stats': {
                    'rule': 'repeated',
                    'type': 'IdentityActivityStats',
                    'id': 3
                  }
                }
              },
              'ContainerLatestActivity': {
                'fields': {
                  'containerId': {
                    'type': 'string',
                    'id': 1
                  },
                  'containerType': {
                    'type': 'string',
                    'id': 2
                  },
                  'latestActivity': {
                    'type': 'ActivityInfo',
                    'id': 3
                  }
                }
              },
              'RequesterContextActivityStats': {
                'fields': {
                  'total': {
                    'type': 'int32',
                    'id': 1
                  },
                  'totalExcludedOwn': {
                    'type': 'int32',
                    'id': 5
                  }
                }
              },
              'IdentityActivityStats': {
                'fields': {
                  'identity': {
                    'type': 'SocialIdentity',
                    'id': 1
                  },
                  'activityStats': {
                    'keyType': 'string',
                    'type': 'ActivityStats',
                    'id': 2
                  }
                }
              },
              'ActivityStats': {
                'fields': {
                  'total': {
                    'type': 'int32',
                    'id': 1
                  }
                }
              },
              'ActivityInfo': {
                'fields': {
                  'activityType': {
                    'type': 'string',
                    'id': 1
                  },
                  'activityTime': {
                    'type': 'google.protobuf.Timestamp',
                    'id': 2
                  }
                }
              },
              'TimeRange': {
                'fields': {
                  'from': {
                    'type': 'google.protobuf.Timestamp',
                    'id': 1
                  },
                  'to': {
                    'type': 'google.protobuf.Timestamp',
                    'id': 2
                  }
                }
              },
              'VersionQuery': {
                'fields': {
                  'from': {
                    'type': 'google.protobuf.StringValue',
                    'id': 1
                  },
                  'to': {
                    'type': 'google.protobuf.StringValue',
                    'id': 2
                  }
                }
              },
              'VersionRange': {
                'fields': {
                  'from': {
                    'type': 'string',
                    'id': 1
                  },
                  'to': {
                    'type': 'string',
                    'id': 2
                  }
                }
              },
              'IdentityParticipated': {
                'fields': {
                  'entityId': {
                    'type': 'string',
                    'id': 1
                  },
                  'containerId': {
                    'type': 'string',
                    'id': 2
                  },
                  'identity': {
                    'type': 'SocialIdentity',
                    'id': 3
                  },
                  'resourceId': {
                    'type': 'google.protobuf.StringValue',
                    'id': 4
                  },
                  'createdAt': {
                    'type': 'google.protobuf.Timestamp',
                    'id': 5
                  }
                }
              },
              'SubscribedToEntity': {
                'fields': {
                  'entityId': {
                    'type': 'string',
                    'id': 1
                  },
                  'containerId': {
                    'type': 'string',
                    'id': 2
                  }
                }
              },
              'UnsubscribedFromEntity': {
                'fields': {
                  'entityId': {
                    'type': 'string',
                    'id': 1
                  },
                  'containerId': {
                    'type': 'string',
                    'id': 2
                  }
                }
              },
              'ManagementService': {
                'methods': {
                  'GetContextToken': {
                    'requestType': 'GetContextTokenRequest',
                    'responseType': 'GetContextTokenResponse',
                    'options': {
                      '(wix.api.maturity)': 'ALPHA',
                      '(google.api.http).get': '/bo/management/context-token'
                    },
                    'rawOptions': [
                      {
                        'name': '(wix.api.maturity)',
                        'value': 'ALPHA'
                      },
                      {
                        'name': '(google.api.http).get',
                        'value': '/bo/management/context-token'
                      }
                    ]
                  },
                  'ViewTokenContents': {
                    'requestType': 'ViewTokenContentsRequest',
                    'responseType': 'ViewTokenContentsResponse',
                    'options': {
                      '(wix.api.maturity)': 'ALPHA',
                      '(google.api.http).get': '/bo/management/view-tokens'
                    },
                    'rawOptions': [
                      {
                        'name': '(wix.api.maturity)',
                        'value': 'ALPHA'
                      },
                      {
                        'name': '(google.api.http).get',
                        'value': '/bo/management/view-tokens'
                      }
                    ]
                  },
                  'GetParticipants': {
                    'requestType': 'GetParticipantsRequest',
                    'responseType': 'GetParticipantsResponse',
                    'options': {
                      '(wix.api.maturity)': 'ALPHA',
                      '(google.api.http).get': '/bo/management/participants'
                    },
                    'rawOptions': [
                      {
                        'name': '(wix.api.maturity)',
                        'value': 'ALPHA'
                      },
                      {
                        'name': '(google.api.http).get',
                        'value': '/bo/management/participants'
                      }
                    ]
                  }
                }
              },
              'GetContextTokenRequest': {
                'fields': {
                  'appDefId': {
                    'type': 'string',
                    'id': 1
                  },
                  'containerType': {
                    'type': 'string',
                    'id': 2
                  },
                  'containerId': {
                    'type': 'google.protobuf.StringValue',
                    'id': 3
                  }
                }
              },
              'GetContextTokenResponse': {
                'fields': {
                  'contextToken': {
                    'type': 'string',
                    'id': 1
                  }
                }
              },
              'GetParticipantsRequest': {
                'fields': {
                  'contextToken': {
                    'type': 'google.protobuf.StringValue',
                    'id': 1
                  },
                  'fromEventId': {
                    'type': 'google.protobuf.UInt64Value',
                    'id': 2
                  }
                }
              },
              'GetParticipantsResponse': {
                'fields': {
                  'identities': {
                    'rule': 'repeated',
                    'type': 'SocialIdentity',
                    'id': 1
                  }
                }
              },
              'ViewTokenContentsRequest': {
                'fields': {
                  'contextToken': {
                    'type': 'string',
                    'id': 1
                  }
                }
              },
              'ViewTokenContentsResponse': {
                'fields': {
                  'contextToken': {
                    'type': 'ContextTokenStructure',
                    'id': 1
                  },
                  'identityResponse': {
                    'type': 'com.wix.core.services.identification2.IdentityResponse',
                    'id': 2
                  },
                  'metaSiteContext': {
                    'type': 'com.wixpress.metasite.reloose.api.MetaSiteContext',
                    'id': 3
                  }
                }
              },
              'ContextTokenStructure': {
                'fields': {
                  'createdAt': {
                    'type': 'google.protobuf.Timestamp',
                    'id': 1
                  },
                  'appDefId': {
                    'type': 'string',
                    'id': 2
                  },
                  'containerId': {
                    'type': 'string',
                    'id': 3,
                    'options': {
                      '(wix.api.format)': 'GUID'
                    }
                  },
                  'containerType': {
                    'type': 'string',
                    'id': 4
                  },
                  'accessControlStates': {
                    'rule': 'repeated',
                    'type': 'AccessControlState',
                    'id': 5
                  },
                  'identities': {
                    'rule': 'repeated',
                    'type': 'SocialIdentity',
                    'id': 6
                  }
                }
              },
              'AccessControlState': {
                'fields': {
                  'fullyQualifiedName': {
                    'type': 'string',
                    'id': 1
                  },
                  'state': {
                    'type': 'bytes',
                    'id': 2
                  }
                }
              },
              'AddParticipationRequest': {
                'fields': {
                  'identity': {
                    'type': 'SocialIdentity',
                    'id': 1
                  },
                  'entityId': {
                    'type': 'string',
                    'id': 2
                  },
                  'resourceId': {
                    'type': 'google.protobuf.StringValue',
                    'id': 3
                  }
                }
              },
              'ProfilesPageCursor': {
                'oneofs': {
                  'Offset': {
                    'oneof': [
                      'profilesOffset',
                      'fromEventId'
                    ]
                  }
                },
                'fields': {
                  'searchText': {
                    'type': 'string',
                    'id': 1
                  },
                  'profilesOffset': {
                    'type': 'uint32',
                    'id': 2
                  },
                  'fromEventId': {
                    'type': 'uint64',
                    'id': 3
                  }
                }
              },
              'ProfilesService': {
                'methods': {
                  'QueryProfiles': {
                    'requestType': 'QueryProfilesRequest',
                    'responseType': 'QueryProfilesResponse',
                    'options': {
                      '(wix.api.maturity)': 'ALPHA',
                      '(google.api.http).get': '/api/v1/profiles'
                    },
                    'rawOptions': [
                      {
                        'name': '(wix.api.maturity)',
                        'value': 'ALPHA'
                      },
                      {
                        'name': '(google.api.http).get',
                        'value': '/api/v1/profiles'
                      }
                    ]
                  }
                }
              },
              'QueryProfilesRequest': {
                'oneofs': {
                  'Of': {
                    'oneof': [
                      'query',
                      'paging'
                    ]
                  }
                },
                'fields': {
                  'mask': {
                    'type': 'google.protobuf.FieldMask',
                    'id': 1
                  },
                  'contextToken': {
                    'type': 'google.protobuf.StringValue',
                    'id': 2
                  },
                  'query': {
                    'type': 'SearchQuery',
                    'id': 3
                  },
                  'paging': {
                    'type': 'wix.common.CursorPaging',
                    'id': 4
                  }
                }
              },
              'SearchQuery': {
                'fields': {
                  'searchText': {
                    'type': 'string',
                    'id': 1
                  },
                  'limit': {
                    'type': 'google.protobuf.Int32Value',
                    'id': 2,
                    'options': {
                      '(wix.api.min)': 0
                    }
                  }
                }
              },
              'QueryProfilesResponse': {
                'fields': {
                  'profiles': {
                    'rule': 'repeated',
                    'type': 'Profile',
                    'id': 1
                  },
                  'nextCursor': {
                    'type': 'google.protobuf.StringValue',
                    'id': 2
                  }
                }
              },
              'groups': {
                'nested': {
                  'events': {
                    'nested': {
                      'api': {
                        'nested': {
                          'v1': {
                            'options': {
                              'java_package': 'com.wix.socialgroups.events.proto'
                            },
                            'nested': {
                              'SocialGroupMembershipEventType': {
                                'values': {
                                  'Approved': 0,
                                  'Added': 1
                                }
                              },
                              'SocialGroupEventType': {
                                'values': {
                                  'Created': 0
                                }
                              },
                              'SocialGroupMembershipEvent': {
                                'fields': {
                                  'eventType': {
                                    'type': 'SocialGroupMembershipEventType',
                                    'id': 1
                                  },
                                  'siteMemberId': {
                                    'type': 'string',
                                    'id': 2,
                                    'options': {
                                      '(wix.api.format)': 'GUID'
                                    }
                                  },
                                  'groupId': {
                                    'type': 'string',
                                    'id': 3,
                                    'options': {
                                      '(wix.api.format)': 'GUID'
                                    }
                                  }
                                }
                              },
                              'SocialGroupEvent': {
                                'fields': {
                                  'eventType': {
                                    'type': 'SocialGroupEventType',
                                    'id': 1
                                  },
                                  'siteMemberId': {
                                    'type': 'string',
                                    'id': 2,
                                    'options': {
                                      '(wix.api.format)': 'GUID'
                                    }
                                  },
                                  'groupId': {
                                    'type': 'string',
                                    'id': 3,
                                    'options': {
                                      '(wix.api.format)': 'GUID'
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  },
                  'api': {
                    'nested': {
                      'v1': {
                        'options': {
                          'java_package': 'com.wix.socialgroups.proto'
                        },
                        'nested': {
                          'GroupApp': {
                            'fields': {
                              'key': {
                                'type': 'GroupAppKey',
                                'id': 1
                              },
                              'installed': {
                                'type': 'bool',
                                'id': 2
                              },
                              'customName': {
                                'type': 'google.protobuf.StringValue',
                                'id': 3,
                                'options': {
                                  '(wix.api.minLength)': 1,
                                  '(wix.api.maxLength)': 100
                                }
                              }
                            }
                          },
                          'ConfigureAppsRequest': {
                            'fields': {
                              'groupId': {
                                'type': 'string',
                                'id': 1,
                                'options': {
                                  '(wix.api.format)': 'GUID'
                                }
                              },
                              'apps': {
                                'rule': 'repeated',
                                'type': 'GroupApp',
                                'id': 2,
                                'options': {
                                  '(wix.api.minSize)': 1,
                                  '(wix.api.maxSize)': 50
                                }
                              }
                            }
                          },
                          'ListAppsRequest': {
                            'fields': {
                              'groupId': {
                                'type': 'string',
                                'id': 1,
                                'options': {
                                  '(wix.api.format)': 'GUID'
                                }
                              }
                            }
                          },
                          'ListGroupAppsResponse': {
                            'fields': {
                              'apps': {
                                'rule': 'repeated',
                                'type': 'GroupApp',
                                'id': 1
                              }
                            }
                          },
                          'SocialGroupsAppsService': {
                            'methods': {
                              'ConfigureApps': {
                                'requestType': 'ConfigureAppsRequest',
                                'responseType': 'google.protobuf.Empty',
                                'options': {
                                  '(google.api.http).post': '/api/v1/groups/{group_id}/apps',
                                  '(wix.api.maturity)': 'BETA'
                                },
                                'rawOptions': [
                                  {
                                    'name': '(google.api.http).post',
                                    'value': '/api/v1/groups/{group_id}/apps'
                                  },
                                  {
                                    'name': '(wix.api.maturity)',
                                    'value': 'BETA'
                                  }
                                ]
                              },
                              'ListApps': {
                                'requestType': 'ListAppsRequest',
                                'responseType': 'ListGroupAppsResponse',
                                'options': {
                                  '(google.api.http).get': '/api/v1/groups/{group_id}/apps',
                                  '(wix.api.maturity)': 'BETA'
                                },
                                'rawOptions': [
                                  {
                                    'name': '(google.api.http).get',
                                    'value': '/api/v1/groups/{group_id}/apps'
                                  },
                                  {
                                    'name': '(wix.api.maturity)',
                                    'value': 'BETA'
                                  }
                                ]
                              }
                            }
                          },
                          'GroupPrivacyLevel': {
                            'values': {
                              'SECRET': 0,
                              'PRIVATE': 1,
                              'PUBLIC': 2
                            }
                          },
                          'RelationshipWithGroup': {
                            'values': {
                              'NONE': 0,
                              'JOINED': 1,
                              'PENDING_APPROVAL': 2,
                              'REJECTED_MEMBERSHIP': 3
                            }
                          },
                          'RoleInGroup': {
                            'values': {
                              'GROUP_MEMBER': 0,
                              'GROUP_MODERATOR': 1,
                              'GROUP_ADMIN': 2
                            }
                          },
                          'GroupAppKey': {
                            'values': {
                              'MEMBERS_APP': 0,
                              'FEED_APP': 1,
                              'ABOUT_APP': 2,
                              'GALLERY_APP': 3
                            }
                          },
                          'GroupsSortBy': {
                            'values': {
                              'DEFAULT': 0,
                              'RECENT_ACTIVITY': 2,
                              'NAME': 3,
                              'MEMBERS_COUNT': 4
                            }
                          },
                          'CreateGroupsPolicy': {
                            'values': {
                              'ONLY_ME': 0,
                              'MEMBERS': 1,
                              'MEMBERS_WITH_MY_APPROVAL': 2
                            }
                          },
                          'GroupApprovalStatus': {
                            'values': {
                              'EMPTY': 0,
                              'PENDING': 1,
                              'APPROVED': 2,
                              'REJECTED': 3,
                              'CANCELLED': 4
                            }
                          },
                          'GroupsInstanceSettings': {
                            'fields': {
                              'allowMembersCreateGroups': {
                                'type': 'bool',
                                'id': 1
                              },
                              'groupsSortBy': {
                                'type': 'GroupsSortBy',
                                'id': 2
                              },
                              'createGroupPolicy': {
                                'type': 'CreateGroupsPolicy',
                                'id': 3
                              }
                            }
                          },
                          'GroupDetails': {
                            'fields': {
                              'title': {
                                'type': 'google.protobuf.StringValue',
                                'id': 1,
                                'options': {
                                  '(wix.api.minLength)': 1,
                                  '(wix.api.maxLength)': 100
                                }
                              },
                              'description': {
                                'type': 'google.protobuf.StringValue',
                                'id': 2,
                                'options': {
                                  '(wix.api.maxLength)': 1000
                                }
                              },
                              'imageUrl': {
                                'type': 'google.protobuf.StringValue',
                                'id': 3,
                                'options': {
                                  '(wix.api.minLength)': 1,
                                  '(wix.api.maxLength)': 1000
                                }
                              },
                              'logoUrl': {
                                'type': 'google.protobuf.StringValue',
                                'id': 4,
                                'options': {
                                  '(wix.api.minLength)': 1,
                                  '(wix.api.maxLength)': 1000
                                }
                              }
                            }
                          },
                          'GroupRequestDetails': {
                            'fields': {
                              'description': {
                                'type': 'google.protobuf.StringValue',
                                'id': 1,
                                'options': {
                                  '(wix.api.minLength)': 1,
                                  '(wix.api.maxLength)': 1000
                                }
                              },
                              'rejectionReason': {
                                'type': 'google.protobuf.StringValue',
                                'id': 2,
                                'options': {
                                  '(wix.api.minLength)': 1,
                                  '(wix.api.maxLength)': 1000
                                }
                              }
                            }
                          },
                          'GroupSettings': {
                            'fields': {
                              'privacyLevel': {
                                'type': 'GroupPrivacyLevel',
                                'id': 1
                              },
                              'permittedToInviteMembers': {
                                'type': 'RoleInGroup',
                                'id': 2
                              },
                              'permittedToApproveMembers': {
                                'type': 'RoleInGroup',
                                'id': 3
                              }
                            }
                          },
                          'MemberName': {
                            'fields': {
                              'nick': {
                                'type': 'google.protobuf.StringValue',
                                'id': 1
                              }
                            }
                          },
                          'CursorTokens': {
                            'fields': {
                              'prev': {
                                'type': 'google.protobuf.StringValue',
                                'id': 2
                              },
                              'next': {
                                'type': 'google.protobuf.StringValue',
                                'id': 1
                              }
                            }
                          },
                          'GetTokenResponse': {
                            'fields': {
                              'token': {
                                'type': 'string',
                                'id': 1
                              }
                            }
                          },
                          'SocialGroupsMediaIntegrationService': {
                            'methods': {
                              'getToken': {
                                'requestType': 'google.protobuf.Empty',
                                'responseType': 'GetTokenResponse',
                                'options': {
                                  '(google.api.http).get': '/api/v1/integration/media/token',
                                  '(wix.api.maturity)': 'BETA'
                                },
                                'rawOptions': [
                                  {
                                    'name': '(google.api.http).get',
                                    'value': '/api/v1/integration/media/token'
                                  },
                                  {
                                    'name': '(wix.api.maturity)',
                                    'value': 'BETA'
                                  }
                                ]
                              }
                            }
                          },
                          'GetFeedTokensRequest': {
                            'fields': {
                              'groupIds': {
                                'rule': 'repeated',
                                'type': 'string',
                                'id': 1,
                                'options': {
                                  '(wix.api.format)': 'GUID'
                                }
                              }
                            }
                          },
                          'GetFeedTokensResponse': {
                            'fields': {
                              'tokens': {
                                'keyType': 'string',
                                'type': 'string',
                                'id': 1
                              }
                            }
                          },
                          'SocialGroupsFeedIntegrationService': {
                            'methods': {
                              'getTokens': {
                                'requestType': 'GetFeedTokensRequest',
                                'responseType': 'GetFeedTokensResponse',
                                'options': {
                                  '(google.api.http).post': '/api/v1/integration/feed/tokens',
                                  '(wix.api.maturity)': 'BETA'
                                },
                                'rawOptions': [
                                  {
                                    'name': '(google.api.http).post',
                                    'value': '/api/v1/integration/feed/tokens'
                                  },
                                  {
                                    'name': '(wix.api.maturity)',
                                    'value': 'BETA'
                                  }
                                ]
                              }
                            }
                          },
                          'NotificationTriggerRequest': {
                            'fields': {
                              'templateId': {
                                'type': 'string',
                                'id': 1
                              },
                              'groupInstanceId': {
                                'type': 'string',
                                'id': 2,
                                'options': {
                                  '(wix.api.format)': 'GUID'
                                }
                              },
                              'groupId': {
                                'type': 'string',
                                'id': 3,
                                'options': {
                                  '(wix.api.format)': 'GUID'
                                }
                              },
                              'postId': {
                                'type': 'string',
                                'id': 4
                              },
                              'commentId': {
                                'type': 'string',
                                'id': 5
                              },
                              'initiator': {
                                'type': 'string',
                                'id': 6
                              },
                              'recipients': {
                                'rule': 'repeated',
                                'type': 'string',
                                'id': 7
                              },
                              'translationParams': {
                                'keyType': 'string',
                                'type': 'string',
                                'id': 8
                              },
                              'deepLinkUrl': {
                                'type': 'string',
                                'id': 9
                              }
                            }
                          },
                          'SocialGroupsNotificationTriggerService': {
                            'methods': {
                              'trigger': {
                                'requestType': 'NotificationTriggerRequest',
                                'responseType': 'google.protobuf.Empty',
                                'options': {
                                  '(google.api.http).post': '/api/v1/groups/internal/notifications-trigger',
                                  '(wix.api.maturity)': 'BETA'
                                },
                                'rawOptions': [
                                  {
                                    'name': '(google.api.http).post',
                                    'value': '/api/v1/groups/internal/notifications-trigger'
                                  },
                                  {
                                    'name': '(wix.api.maturity)',
                                    'value': 'BETA'
                                  }
                                ]
                              }
                            }
                          },
                          'JoinGroupRequest': {
                            'fields': {
                              'groupId': {
                                'type': 'string',
                                'id': 1,
                                'options': {
                                  '(wix.api.format)': 'GUID'
                                }
                              }
                            }
                          },
                          'LeaveGroupRequest': {
                            'fields': {
                              'groupId': {
                                'type': 'string',
                                'id': 1,
                                'options': {
                                  '(wix.api.format)': 'GUID'
                                }
                              }
                            }
                          },
                          'SubmitRequestToJoinRequest': {
                            'fields': {
                              'groupId': {
                                'type': 'string',
                                'id': 1,
                                'options': {
                                  '(wix.api.format)': 'GUID'
                                }
                              }
                            }
                          },
                          'WithdrawRequestToJoinRequest': {
                            'fields': {
                              'groupId': {
                                'type': 'string',
                                'id': 1,
                                'options': {
                                  '(wix.api.format)': 'GUID'
                                }
                              }
                            }
                          },
                          'RejectGroupMemershipRequest': {
                            'fields': {
                              'groupId': {
                                'type': 'string',
                                'id': 1,
                                'options': {
                                  '(wix.api.format)': 'GUID'
                                }
                              },
                              'siteMemberId': {
                                'type': 'string',
                                'id': 2,
                                'options': {
                                  '(wix.api.format)': 'GUID'
                                }
                              }
                            }
                          },
                          'ApproveGroupMemershipRequest': {
                            'fields': {
                              'groupId': {
                                'type': 'string',
                                'id': 1,
                                'options': {
                                  '(wix.api.format)': 'GUID'
                                }
                              },
                              'siteMemberId': {
                                'type': 'string',
                                'id': 2,
                                'options': {
                                  '(wix.api.format)': 'GUID'
                                }
                              }
                            }
                          },
                          'GetGroupMemberRequest': {
                            'fields': {
                              'groupId': {
                                'type': 'string',
                                'id': 1,
                                'options': {
                                  '(wix.api.format)': 'GUID'
                                }
                              },
                              'siteMemberId': {
                                'type': 'string',
                                'id': 2,
                                'options': {
                                  '(wix.api.format)': 'GUID'
                                }
                              }
                            }
                          },
                          'ListGroupMembersRequest': {
                            'fields': {
                              'groupId': {
                                'type': 'string',
                                'id': 1,
                                'options': {
                                  '(wix.api.format)': 'GUID'
                                }
                              },
                              'limit': {
                                'type': 'google.protobuf.UInt32Value',
                                'id': 2,
                                'options': {
                                  '(wix.api.min)': 1,
                                  '(wix.api.max)': 100
                                }
                              },
                              'cursorToken': {
                                'type': 'google.protobuf.StringValue',
                                'id': 3
                              }
                            }
                          },
                          'ListAllMembersRequest': {
                            'fields': {
                              'groupId': {
                                'type': 'string',
                                'id': 1,
                                'options': {
                                  '(wix.api.format)': 'GUID'
                                }
                              },
                              'limit': {
                                'type': 'google.protobuf.UInt32Value',
                                'id': 2,
                                'options': {
                                  '(wix.api.min)': 1,
                                  '(wix.api.max)': 500
                                }
                              },
                              'cursorToken': {
                                'type': 'google.protobuf.StringValue',
                                'id': 3
                              }
                            }
                          },
                          'ListPendingMembersRequest': {
                            'fields': {
                              'groupId': {
                                'type': 'string',
                                'id': 1,
                                'options': {
                                  '(wix.api.format)': 'GUID'
                                }
                              },
                              'limit': {
                                'type': 'google.protobuf.UInt32Value',
                                'id': 2,
                                'options': {
                                  '(wix.api.min)': 1,
                                  '(wix.api.max)': 500
                                }
                              },
                              'cursorToken': {
                                'type': 'google.protobuf.StringValue',
                                'id': 3
                              }
                            }
                          },
                          'AddMembersToGroupRequest': {
                            'fields': {
                              'groupId': {
                                'type': 'string',
                                'id': 1,
                                'options': {
                                  '(wix.api.format)': 'GUID'
                                }
                              },
                              'siteMemberIds': {
                                'rule': 'repeated',
                                'type': 'string',
                                'id': 2,
                                'options': {
                                  '(wix.api.format)': 'GUID',
                                  '(wix.api.minSize)': 1,
                                  '(wix.api.maxSize)': 1000
                                }
                              }
                            }
                          },
                          'RemoveMembersFromGroupRequest': {
                            'fields': {
                              'groupId': {
                                'type': 'string',
                                'id': 1,
                                'options': {
                                  '(wix.api.format)': 'GUID'
                                }
                              },
                              'siteMemberIds': {
                                'rule': 'repeated',
                                'type': 'string',
                                'id': 2,
                                'options': {
                                  '(wix.api.format)': 'GUID',
                                  '(wix.api.minSize)': 1,
                                  '(wix.api.maxSize)': 1000
                                }
                              }
                            }
                          },
                          'JoinedGroupResponse': {
                            'fields': {
                              'groupId': {
                                'type': 'string',
                                'id': 1
                              },
                              'details': {
                                'type': 'GroupDetails',
                                'id': 4
                              },
                              'settings': {
                                'type': 'GroupSettings',
                                'id': 5
                              }
                            }
                          },
                          'GroupMemberResponse': {
                            'fields': {
                              'siteMemberId': {
                                'type': 'string',
                                'id': 1
                              },
                              'relationship': {
                                'type': 'RelationshipWithGroup',
                                'id': 2
                              },
                              'name': {
                                'type': 'MemberName',
                                'id': 3
                              },
                              'imageUrl': {
                                'type': 'google.protobuf.StringValue',
                                'id': 4
                              },
                              'roles': {
                                'rule': 'repeated',
                                'type': 'RoleInGroup',
                                'id': 5
                              },
                              'joinedOn': {
                                'type': 'google.protobuf.Timestamp',
                                'id': 6
                              },
                              'requestedMembershipOn': {
                                'type': 'google.protobuf.Timestamp',
                                'id': 7
                              }
                            }
                          },
                          'GetGroupMemberResponse': {
                            'fields': {
                              'member': {
                                'type': 'GroupMemberResponse',
                                'id': 1
                              }
                            }
                          },
                          'ListGroupMembersResponse': {
                            'fields': {
                              'members': {
                                'rule': 'repeated',
                                'type': 'GroupMemberResponse',
                                'id': 1
                              },
                              'cursorTokens': {
                                'type': 'CursorTokens',
                                'id': 2
                              }
                            }
                          },
                          'ListAllMembersResponse': {
                            'fields': {
                              'members': {
                                'rule': 'repeated',
                                'type': 'GroupMemberResponse',
                                'id': 1
                              },
                              'cursorTokens': {
                                'type': 'CursorTokens',
                                'id': 2
                              }
                            }
                          },
                          'PendingMemberResponse': {
                            'fields': {
                              'siteMemberId': {
                                'type': 'string',
                                'id': 1
                              },
                              'name': {
                                'type': 'MemberName',
                                'id': 2
                              },
                              'imageUrl': {
                                'type': 'google.protobuf.StringValue',
                                'id': 3
                              },
                              'requestedMembershipOn': {
                                'type': 'google.protobuf.Timestamp',
                                'id': 4
                              }
                            }
                          },
                          'ListPendingMembersResponse': {
                            'fields': {
                              'members': {
                                'rule': 'repeated',
                                'type': 'PendingMemberResponse',
                                'id': 1
                              },
                              'cursorTokens': {
                                'type': 'CursorTokens',
                                'id': 2
                              }
                            }
                          },
                          'SocialGroupsMembershipService': {
                            'methods': {
                              'JoinGroup': {
                                'requestType': 'JoinGroupRequest',
                                'responseType': 'JoinedGroupResponse',
                                'options': {
                                  '(google.api.http).post': '/api/v1/groups/{group_id}/members/me',
                                  '(wix.api.maturity)': 'BETA'
                                },
                                'rawOptions': [
                                  {
                                    'name': '(google.api.http).post',
                                    'value': '/api/v1/groups/{group_id}/members/me'
                                  },
                                  {
                                    'name': '(wix.api.maturity)',
                                    'value': 'BETA'
                                  }
                                ]
                              },
                              'LeaveGroup': {
                                'requestType': 'LeaveGroupRequest',
                                'responseType': 'google.protobuf.Empty',
                                'options': {
                                  '(google.api.http).delete': '/api/v1/groups/{group_id}/members/me',
                                  '(wix.api.maturity)': 'BETA'
                                },
                                'rawOptions': [
                                  {
                                    'name': '(google.api.http).delete',
                                    'value': '/api/v1/groups/{group_id}/members/me'
                                  },
                                  {
                                    'name': '(wix.api.maturity)',
                                    'value': 'BETA'
                                  }
                                ]
                              },
                              'AddMembersToGroup': {
                                'requestType': 'AddMembersToGroupRequest',
                                'responseType': 'google.protobuf.Empty',
                                'options': {
                                  '(google.api.http).post': '/api/v1/groups/{group_id}/members/add',
                                  '(wix.api.maturity)': 'BETA'
                                },
                                'rawOptions': [
                                  {
                                    'name': '(google.api.http).post',
                                    'value': '/api/v1/groups/{group_id}/members/add'
                                  },
                                  {
                                    'name': '(wix.api.maturity)',
                                    'value': 'BETA'
                                  }
                                ]
                              },
                              'RemoveMembersFromGroup': {
                                'requestType': 'RemoveMembersFromGroupRequest',
                                'responseType': 'google.protobuf.Empty',
                                'options': {
                                  '(google.api.http).post': '/api/v1/groups/{group_id}/members/remove',
                                  '(wix.api.maturity)': 'BETA'
                                },
                                'rawOptions': [
                                  {
                                    'name': '(google.api.http).post',
                                    'value': '/api/v1/groups/{group_id}/members/remove'
                                  },
                                  {
                                    'name': '(wix.api.maturity)',
                                    'value': 'BETA'
                                  }
                                ]
                              },
                              'GetGroupMember': {
                                'requestType': 'GetGroupMemberRequest',
                                'responseType': 'GetGroupMemberResponse',
                                'options': {
                                  '(google.api.http).get': '/api/v1/groups/{group_id}/members/member/{site_member_id}',
                                  '(wix.api.maturity)': 'BETA'
                                },
                                'rawOptions': [
                                  {
                                    'name': '(google.api.http).get',
                                    'value': '/api/v1/groups/{group_id}/members/member/{site_member_id}'
                                  },
                                  {
                                    'name': '(wix.api.maturity)',
                                    'value': 'BETA'
                                  }
                                ]
                              },
                              'ListGroupMembers': {
                                'requestType': 'ListGroupMembersRequest',
                                'responseType': 'ListGroupMembersResponse',
                                'options': {
                                  '(google.api.http).get': '/api/v1/groups/{group_id}/members',
                                  '(wix.api.maturity)': 'BETA'
                                },
                                'rawOptions': [
                                  {
                                    'name': '(google.api.http).get',
                                    'value': '/api/v1/groups/{group_id}/members'
                                  },
                                  {
                                    'name': '(wix.api.maturity)',
                                    'value': 'BETA'
                                  }
                                ]
                              },
                              'ListAllMembers': {
                                'requestType': 'ListAllMembersRequest',
                                'responseType': 'ListAllMembersResponse',
                                'options': {
                                  '(google.api.http).get': '/api/v1/groups/{group_id}/members/all',
                                  '(wix.api.maturity)': 'BETA'
                                },
                                'rawOptions': [
                                  {
                                    'name': '(google.api.http).get',
                                    'value': '/api/v1/groups/{group_id}/members/all'
                                  },
                                  {
                                    'name': '(wix.api.maturity)',
                                    'value': 'BETA'
                                  }
                                ]
                              },
                              'ListPendingMembers': {
                                'requestType': 'ListPendingMembersRequest',
                                'responseType': 'ListPendingMembersResponse',
                                'options': {
                                  '(google.api.http).get': '/api/v1/groups/{group_id}/members/pending',
                                  '(wix.api.maturity)': 'BETA'
                                },
                                'rawOptions': [
                                  {
                                    'name': '(google.api.http).get',
                                    'value': '/api/v1/groups/{group_id}/members/pending'
                                  },
                                  {
                                    'name': '(wix.api.maturity)',
                                    'value': 'BETA'
                                  }
                                ]
                              },
                              'SubmitRequestToJoin': {
                                'requestType': 'SubmitRequestToJoinRequest',
                                'responseType': 'google.protobuf.Empty',
                                'options': {
                                  '(google.api.http).post': '/api/v1/groups/{group_id}/members/request',
                                  '(wix.api.maturity)': 'BETA'
                                },
                                'rawOptions': [
                                  {
                                    'name': '(google.api.http).post',
                                    'value': '/api/v1/groups/{group_id}/members/request'
                                  },
                                  {
                                    'name': '(wix.api.maturity)',
                                    'value': 'BETA'
                                  }
                                ]
                              },
                              'WithdrawRequestToJoin': {
                                'requestType': 'WithdrawRequestToJoinRequest',
                                'responseType': 'google.protobuf.Empty',
                                'options': {
                                  '(google.api.http).delete': '/api/v1/groups/{group_id}/members/request',
                                  '(wix.api.maturity)': 'BETA'
                                },
                                'rawOptions': [
                                  {
                                    'name': '(google.api.http).delete',
                                    'value': '/api/v1/groups/{group_id}/members/request'
                                  },
                                  {
                                    'name': '(wix.api.maturity)',
                                    'value': 'BETA'
                                  }
                                ]
                              },
                              'ApproveGroupMembership': {
                                'requestType': 'ApproveGroupMemershipRequest',
                                'responseType': 'google.protobuf.Empty',
                                'options': {
                                  '(google.api.http).post': '/api/v1/groups/{group_id}/members/{site_member_id}/approve',
                                  '(wix.api.maturity)': 'BETA'
                                },
                                'rawOptions': [
                                  {
                                    'name': '(google.api.http).post',
                                    'value': '/api/v1/groups/{group_id}/members/{site_member_id}/approve'
                                  },
                                  {
                                    'name': '(wix.api.maturity)',
                                    'value': 'BETA'
                                  }
                                ]
                              },
                              'RejectGroupMembership': {
                                'requestType': 'RejectGroupMemershipRequest',
                                'responseType': 'google.protobuf.Empty',
                                'options': {
                                  '(google.api.http).post': '/api/v1/groups/{group_id}/members/{site_member_id}/reject',
                                  '(wix.api.maturity)': 'BETA'
                                },
                                'rawOptions': [
                                  {
                                    'name': '(google.api.http).post',
                                    'value': '/api/v1/groups/{group_id}/members/{site_member_id}/reject'
                                  },
                                  {
                                    'name': '(wix.api.maturity)',
                                    'value': 'BETA'
                                  }
                                ]
                              }
                            }
                          },
                          'MigrationType': {
                            'values': {
                              'TEST': 0,
                              'MIGRATE_SLUGS': 1
                            }
                          },
                          'MigrationRequest': {
                            'fields': {
                              'migrationType': {
                                'type': 'MigrationType',
                                'id': 1
                              }
                            }
                          },
                          'SocialGroupsMigrationService': {
                            'methods': {
                              'migrate': {
                                'requestType': 'MigrationRequest',
                                'responseType': 'google.protobuf.Empty',
                                'options': {
                                  '(google.api.http).post': '/api/v1/groups/migrate',
                                  '(wix.api.maturity)': 'BETA'
                                },
                                'rawOptions': [
                                  {
                                    'name': '(google.api.http).post',
                                    'value': '/api/v1/groups/migrate'
                                  },
                                  {
                                    'name': '(wix.api.maturity)',
                                    'value': 'BETA'
                                  }
                                ]
                              }
                            }
                          },
                          'SetMemberRoleRequest': {
                            'fields': {
                              'groupId': {
                                'type': 'string',
                                'id': 1,
                                'options': {
                                  '(wix.api.format)': 'GUID'
                                }
                              },
                              'siteMemberId': {
                                'type': 'string',
                                'id': 2,
                                'options': {
                                  '(wix.api.format)': 'GUID'
                                }
                              },
                              'role': {
                                'type': 'RoleInGroup',
                                'id': 3
                              }
                            }
                          },
                          'RemoveMemberRoleRequest': {
                            'fields': {
                              'groupId': {
                                'type': 'string',
                                'id': 1,
                                'options': {
                                  '(wix.api.format)': 'GUID'
                                }
                              },
                              'siteMemberId': {
                                'type': 'string',
                                'id': 2,
                                'options': {
                                  '(wix.api.format)': 'GUID'
                                }
                              }
                            }
                          },
                          'SocialGroupsRolesService': {
                            'methods': {
                              'SetMemberRole': {
                                'requestType': 'SetMemberRoleRequest',
                                'responseType': 'google.protobuf.Empty',
                                'options': {
                                  '(google.api.http).post': '/api/v1/groups/{group_id}/members/{site_member_id}/role',
                                  '(wix.api.maturity)': 'BETA'
                                },
                                'rawOptions': [
                                  {
                                    'name': '(google.api.http).post',
                                    'value': '/api/v1/groups/{group_id}/members/{site_member_id}/role'
                                  },
                                  {
                                    'name': '(wix.api.maturity)',
                                    'value': 'BETA'
                                  }
                                ]
                              },
                              'RemoveMemberRole': {
                                'requestType': 'RemoveMemberRoleRequest',
                                'responseType': 'google.protobuf.Empty',
                                'options': {
                                  '(google.api.http).delete': '/api/v1/groups/{group_id}/members/{site_member_id}/role',
                                  '(wix.api.maturity)': 'BETA'
                                },
                                'rawOptions': [
                                  {
                                    'name': '(google.api.http).delete',
                                    'value': '/api/v1/groups/{group_id}/members/{site_member_id}/role'
                                  },
                                  {
                                    'name': '(wix.api.maturity)',
                                    'value': 'BETA'
                                  }
                                ]
                              }
                            }
                          },
                          'UpdateGroupsInstanceSettingsRequest': {
                            'fields': {
                              'fieldMask': {
                                'type': 'google.protobuf.FieldMask',
                                'id': 1
                              },
                              'settings': {
                                'type': 'GroupsInstanceSettings',
                                'id': 2
                              }
                            }
                          },
                          'GetGroupsInstanceSettingsRequest': {
                            'fields': {}
                          },
                          'GroupsInstanceSettingsResponse': {
                            'fields': {
                              'settings': {
                                'type': 'GroupsInstanceSettings',
                                'id': 1
                              }
                            }
                          },
                          'CreateGroupRequest': {
                            'fields': {
                              'details': {
                                'type': 'GroupDetails',
                                'id': 1
                              },
                              'settings': {
                                'type': 'GroupSettings',
                                'id': 2
                              },
                              'requestDetails': {
                                'type': 'GroupRequestDetails',
                                'id': 3
                              }
                            }
                          },
                          'UpdateGroupRequest': {
                            'fields': {
                              'fieldMask': {
                                'type': 'google.protobuf.FieldMask',
                                'id': 1
                              },
                              'groupId': {
                                'type': 'string',
                                'id': 2,
                                'options': {
                                  '(wix.api.format)': 'GUID'
                                }
                              },
                              'details': {
                                'type': 'GroupDetails',
                                'id': 3
                              },
                              'settings': {
                                'type': 'GroupSettings',
                                'id': 4
                              },
                              'requestDetails': {
                                'type': 'GroupRequestDetails',
                                'id': 5
                              },
                              'approvalStatus': {
                                'type': 'GroupApprovalStatus',
                                'id': 6
                              }
                            }
                          },
                          'ListGroupsRequest': {
                            'fields': {
                              'relationship': {
                                'rule': 'repeated',
                                'type': 'RelationshipWithGroup',
                                'id': 1
                              },
                              'role': {
                                'rule': 'repeated',
                                'type': 'RoleInGroup',
                                'id': 2
                              }
                            }
                          },
                          'ArchiveGroupRequest': {
                            'fields': {
                              'groupId': {
                                'type': 'string',
                                'id': 1,
                                'options': {
                                  '(wix.api.format)': 'GUID'
                                }
                              }
                            }
                          },
                          'DeleteGroupRequest': {
                            'fields': {
                              'groupId': {
                                'type': 'string',
                                'id': 1,
                                'options': {
                                  '(wix.api.format)': 'GUID'
                                }
                              }
                            }
                          },
                          'GetGroupRequest': {
                            'fields': {
                              'groupId': {
                                'type': 'string',
                                'id': 1
                              }
                            }
                          },
                          'GroupResponse': {
                            'fields': {
                              'groupId': {
                                'type': 'string',
                                'id': 1
                              },
                              'relationship': {
                                'type': 'RelationshipWithGroup',
                                'id': 2
                              },
                              'roles': {
                                'rule': 'repeated',
                                'type': 'RoleInGroup',
                                'id': 3
                              },
                              'details': {
                                'type': 'GroupDetails',
                                'id': 4
                              },
                              'settings': {
                                'type': 'GroupSettings',
                                'id': 5
                              },
                              'memberCount': {
                                'type': 'google.protobuf.Int32Value',
                                'id': 6
                              },
                              'createdBy': {
                                'type': 'GroupMemberProfile',
                                'id': 7
                              },
                              'requestDetails': {
                                'type': 'GroupRequestDetails',
                                'id': 8
                              },
                              'approvalStatus': {
                                'type': 'GroupApprovalStatus',
                                'id': 9
                              },
                              'slug': {
                                'type': 'google.protobuf.StringValue',
                                'id': 10
                              }
                            }
                          },
                          'GroupMemberProfile': {
                            'fields': {
                              'siteMemberId': {
                                'type': 'string',
                                'id': 1
                              },
                              'name': {
                                'type': 'MemberName',
                                'id': 2
                              },
                              'imageUrl': {
                                'type': 'google.protobuf.StringValue',
                                'id': 3
                              }
                            }
                          },
                          'GetGroupResponse': {
                            'fields': {
                              'group': {
                                'type': 'GroupResponse',
                                'id': 1
                              }
                            }
                          },
                          'ListGroupsResponse': {
                            'fields': {
                              'groups': {
                                'rule': 'repeated',
                                'type': 'GroupResponse',
                                'id': 1
                              }
                            }
                          },
                          'SocialGroupsService': {
                            'methods': {
                              'UpdateGroupsInstanceSettings': {
                                'requestType': 'UpdateGroupsInstanceSettingsRequest',
                                'responseType': 'GroupsInstanceSettingsResponse',
                                'options': {
                                  '(google.api.http).patch': '/api/v1/groups/settings',
                                  '(wix.api.required)': 'UpdateGroupsInstanceSettingsRequest.settings',
                                  '(wix.api.maturity)': 'BETA'
                                },
                                'rawOptions': [
                                  {
                                    'name': '(google.api.http).patch',
                                    'value': '/api/v1/groups/settings'
                                  },
                                  {
                                    'name': '(wix.api.required)',
                                    'value': 'UpdateGroupsInstanceSettingsRequest.field_mask'
                                  },
                                  {
                                    'name': '(wix.api.required)',
                                    'value': 'UpdateGroupsInstanceSettingsRequest.settings'
                                  },
                                  {
                                    'name': '(wix.api.maturity)',
                                    'value': 'BETA'
                                  }
                                ]
                              },
                              'GetGroupsInstanceSettings': {
                                'requestType': 'GetGroupsInstanceSettingsRequest',
                                'responseType': 'GroupsInstanceSettingsResponse',
                                'options': {
                                  '(google.api.http).get': '/api/v1/groups/settings',
                                  '(wix.api.maturity)': 'BETA'
                                },
                                'rawOptions': [
                                  {
                                    'name': '(google.api.http).get',
                                    'value': '/api/v1/groups/settings'
                                  },
                                  {
                                    'name': '(wix.api.maturity)',
                                    'value': 'BETA'
                                  }
                                ]
                              },
                              'CreateGroup': {
                                'requestType': 'CreateGroupRequest',
                                'responseType': 'GroupResponse',
                                'options': {
                                  '(google.api.http).post': '/api/v1/groups',
                                  '(wix.api.required)': 'CreateGroupRequest.details.title',
                                  '(wix.api.maturity)': 'BETA'
                                },
                                'rawOptions': [
                                  {
                                    'name': '(google.api.http).post',
                                    'value': '/api/v1/groups'
                                  },
                                  {
                                    'name': '(wix.api.required)',
                                    'value': 'CreateGroupRequest.details.title'
                                  },
                                  {
                                    'name': '(wix.api.maturity)',
                                    'value': 'BETA'
                                  }
                                ]
                              },
                              'UpdateGroup': {
                                'requestType': 'UpdateGroupRequest',
                                'responseType': 'GroupResponse',
                                'options': {
                                  '(google.api.http).patch': '/api/v1/groups/{group_id}',
                                  '(wix.api.required)': 'UpdateGroupRequest.field_mask',
                                  '(wix.api.maturity)': 'BETA'
                                },
                                'rawOptions': [
                                  {
                                    'name': '(google.api.http).patch',
                                    'value': '/api/v1/groups/{group_id}'
                                  },
                                  {
                                    'name': '(wix.api.required)',
                                    'value': 'UpdateGroupRequest.field_mask'
                                  },
                                  {
                                    'name': '(wix.api.maturity)',
                                    'value': 'BETA'
                                  }
                                ]
                              },
                              'ArchiveGroup': {
                                'requestType': 'ArchiveGroupRequest',
                                'responseType': 'google.protobuf.Empty',
                                'options': {
                                  '(google.api.http).post': '/api/v1/groups/{group_id}/archive',
                                  '(wix.api.maturity)': 'BETA'
                                },
                                'rawOptions': [
                                  {
                                    'name': '(google.api.http).post',
                                    'value': '/api/v1/groups/{group_id}/archive'
                                  },
                                  {
                                    'name': '(wix.api.maturity)',
                                    'value': 'BETA'
                                  }
                                ]
                              },
                              'DeleteGroup': {
                                'requestType': 'DeleteGroupRequest',
                                'responseType': 'google.protobuf.Empty',
                                'options': {
                                  '(google.api.http).delete': '/api/v1/groups/{group_id}',
                                  '(wix.api.maturity)': 'BETA'
                                },
                                'rawOptions': [
                                  {
                                    'name': '(google.api.http).delete',
                                    'value': '/api/v1/groups/{group_id}'
                                  },
                                  {
                                    'name': '(wix.api.maturity)',
                                    'value': 'BETA'
                                  }
                                ]
                              },
                              'GetGroup': {
                                'requestType': 'GetGroupRequest',
                                'responseType': 'GetGroupResponse',
                                'options': {
                                  '(google.api.http).get': '/api/v1/groups/{group_id}',
                                  '(wix.api.maturity)': 'BETA'
                                },
                                'rawOptions': [
                                  {
                                    'name': '(google.api.http).get',
                                    'value': '/api/v1/groups/{group_id}'
                                  },
                                  {
                                    'name': '(wix.api.maturity)',
                                    'value': 'BETA'
                                  }
                                ]
                              },
                              'ListGroups': {
                                'requestType': 'ListGroupsRequest',
                                'responseType': 'ListGroupsResponse',
                                'options': {
                                  '(google.api.http).get': '/api/v1/groups',
                                  '(wix.api.maturity)': 'BETA'
                                },
                                'rawOptions': [
                                  {
                                    'name': '(google.api.http).get',
                                    'value': '/api/v1/groups'
                                  },
                                  {
                                    'name': '(wix.api.maturity)',
                                    'value': 'BETA'
                                  }
                                ]
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          },
          'feed': {
            'options': {
              'java_package': 'com.wix.catalyst.feed.api'
            },
            'nested': {
              'activities': {
                'options': {
                  'java_package': 'com.wix.catalyst.activities.dto'
                },
                'nested': {
                  'PostedInFeed': {
                    'fields': {}
                  }
                }
              },
              'FeedItem': {
                'fields': {
                  'feedItemId': {
                    'type': 'string',
                    'id': 1,
                    'options': {
                      '(wix.api.format)': 'GUID'
                    }
                  },
                  'entity': {
                    'type': 'FeedItemEntity',
                    'id': 2
                  },
                  'applicationData': {
                    'type': 'ApplicationData',
                    'id': 3
                  },
                  'createdBy': {
                    'type': 'string',
                    'id': 4,
                    'options': {
                      '(wix.api.format)': 'GUID'
                    }
                  },
                  'createdAt': {
                    'type': 'google.protobuf.Timestamp',
                    'id': 5
                  },
                  'updatedAt': {
                    'type': 'google.protobuf.Timestamp',
                    'id': 6
                  },
                  'comments': {
                    'type': 'Comments',
                    'id': 7
                  },
                  'latestComments': {
                    'type': 'Comments',
                    'id': 12
                  },
                  'reactions': {
                    'type': 'wix.reactions.ItemReactionsSummary',
                    'id': 8
                  },
                  'pin': {
                    'type': 'FeedItemPin',
                    'id': 9
                  },
                  'contentPreviews': {
                    'rule': 'repeated',
                    'type': 'wix.social.ContentPreview',
                    'id': 10
                  },
                  'requesterContext': {
                    'type': 'FeedItemRequester',
                    'id': 11
                  }
                }
              },
              'FeedItemEntity': {
                'fields': {
                  'body': {
                    'type': 'wix.social.Text',
                    'id': 1
                  },
                  'mentions': {
                    'rule': 'repeated',
                    'type': 'wix.social.Mention',
                    'id': 4
                  },
                  'attachments': {
                    'rule': 'repeated',
                    'type': 'wix.social.Resource',
                    'id': 5
                  },
                  'externalReferences': {
                    'rule': 'repeated',
                    'type': 'wix.social.ExternalReference',
                    'id': 6
                  }
                }
              },
              'ApplicationData': {
                'fields': {
                  'applicationId': {
                    'type': 'string',
                    'id': 1
                  },
                  'data': {
                    'type': 'google.protobuf.Value',
                    'id': 2
                  }
                }
              },
              'Comments': {
                'fields': {
                  'contextToken': {
                    'type': 'string',
                    'id': 1
                  },
                  'total': {
                    'type': 'int32',
                    'id': 2
                  },
                  'comments': {
                    'rule': 'repeated',
                    'type': 'wix.comments.Comment',
                    'id': 3
                  },
                  'cursor': {
                    'type': 'string',
                    'id': 4
                  },
                  'nextCursor': {
                    'type': 'google.protobuf.StringValue',
                    'id': 5
                  }
                }
              },
              'FeedItemPin': {
                'fields': {
                  'since': {
                    'type': 'google.protobuf.Timestamp',
                    'id': 1
                  },
                  'pinnedBy': {
                    'type': 'string',
                    'id': 2,
                    'options': {
                      '(wix.api.format)': 'GUID'
                    }
                  }
                }
              },
              'FeedItemRequester': {
                'fields': {
                  'subscribed': {
                    'type': 'bool',
                    'id': 1
                  }
                }
              },
              'FeedItemCreated': {
                'fields': {
                  'containerId': {
                    'type': 'string',
                    'id': 1
                  },
                  'entity': {
                    'type': 'FeedItemEntity',
                    'id': 2
                  },
                  'applicationData': {
                    'type': 'ApplicationData',
                    'id': 3
                  },
                  'createdAt': {
                    'type': 'google.protobuf.Timestamp',
                    'id': 4
                  }
                }
              },
              'FeedItemUpdated': {
                'fields': {
                  'entity': {
                    'type': 'FeedItemEntity',
                    'id': 2
                  },
                  'applicationData': {
                    'type': 'ApplicationData',
                    'id': 3
                  },
                  'updatedAt': {
                    'type': 'google.protobuf.Timestamp',
                    'id': 4
                  },
                  'mask': {
                    'type': 'google.protobuf.FieldMask',
                    'id': 5
                  }
                }
              },
              'FeedItemDeleted': {
                'fields': {}
              },
              'FeedItemPinned': {
                'fields': {}
              },
              'FeedItemUnpinned': {
                'fields': {}
              },
              'callbacks': {
                'options': {
                  'java_package': 'com.wix.catalyst.feed.callbacks'
                },
                'nested': {
                  'FeedItemCreated': {
                    'fields': {
                      'feedItemId': {
                        'type': 'string',
                        'id': 1,
                        'options': {
                          '(wix.api.format)': 'GUID'
                        }
                      },
                      'feedItemCreated': {
                        'type': 'wix.feed.FeedItemCreated',
                        'id': 2
                      },
                      'createdBy': {
                        'type': 'wix.social.SocialIdentity',
                        'id': 3
                      },
                      'container': {
                        'type': 'wix.social.SocialContainer',
                        'id': 4
                      }
                    }
                  },
                  'CommentedOnFeedItem': {
                    'fields': {
                      'feedItemId': {
                        'type': 'string',
                        'id': 1,
                        'options': {
                          '(wix.api.format)': 'GUID'
                        }
                      },
                      'commentId': {
                        'type': 'string',
                        'id': 2,
                        'options': {
                          '(wix.api.format)': 'GUID'
                        }
                      },
                      'comment': {
                        'type': 'wix.comments.CommentEntity',
                        'id': 3
                      },
                      'createdBy': {
                        'type': 'wix.social.SocialIdentity',
                        'id': 4
                      },
                      'container': {
                        'type': 'wix.social.SocialContainer',
                        'id': 5
                      }
                    }
                  },
                  'ReactedOnFeedItem': {
                    'fields': {
                      'feedItemId': {
                        'type': 'string',
                        'id': 1,
                        'options': {
                          '(wix.api.format)': 'GUID'
                        }
                      },
                      'reaction': {
                        'type': 'wix.reactions.Reaction',
                        'id': 2
                      },
                      'entity': {
                        'type': 'wix.social.SocialEntity',
                        'id': 3
                      },
                      'createdBy': {
                        'type': 'wix.social.SocialIdentity',
                        'id': 4
                      },
                      'container': {
                        'type': 'wix.social.SocialContainer',
                        'id': 5
                      }
                    }
                  },
                  'ReactedOnComment': {
                    'fields': {
                      'feedItemId': {
                        'type': 'string',
                        'id': 1,
                        'options': {
                          '(wix.api.format)': 'GUID'
                        }
                      },
                      'commentId': {
                        'type': 'string',
                        'id': 2,
                        'options': {
                          '(wix.api.format)': 'GUID'
                        }
                      },
                      'reaction': {
                        'type': 'wix.reactions.Reaction',
                        'id': 3
                      },
                      'entity': {
                        'type': 'wix.social.SocialEntity',
                        'id': 4
                      },
                      'createdBy': {
                        'type': 'wix.social.SocialIdentity',
                        'id': 5
                      },
                      'container': {
                        'type': 'wix.social.SocialContainer',
                        'id': 6
                      }
                    }
                  }
                }
              },
              'component': {
                'options': {
                  'java_package': 'com.wix.catalyst.feed.component'
                },
                'nested': {
                  'FeedComponentService': {
                    'methods': {
                      'FeedComponentContext': {
                        'requestType': 'CreateComponentContextRequests',
                        'responseType': 'CreateComponentContextResponses',
                        'options': {
                          '(wix.api.maturity)': 'ALPHA'
                        },
                        'rawOptions': [{
                          'name': '(wix.api.maturity)',
                          'value': 'ALPHA'
                        }]
                      }
                    }
                  },
                  'CreateComponentContextRequests': {
                    'fields': {
                      'requests': {
                        'rule': 'repeated',
                        'type': 'CreateComponentContextRequest',
                        'id': 1
                      }
                    }
                  },
                  'CreateComponentContextRequest': {
                    'fields': {
                      'contextSetup': {
                        'type': 'PagingContextSetup',
                        'id': 1
                      },
                      'query': {
                        'type': 'FeedPropertiesQuery',
                        'id': 2
                      },
                      'role': {
                        'type': 'Role',
                        'id': 3
                      },
                      'identity': {
                        'type': 'com.wix.core.services.identification2.Identity',
                        'id': 5
                      }
                    }
                  },
                  'FeedPropertiesQuery': {
                    'fields': {
                      'commentsToLoad': {
                        'type': 'google.protobuf.Int32Value',
                        'id': 1,
                        'options': {
                          '(wix.api.min)': 0
                        }
                      }
                    }
                  },
                  'PagingContextSetup': {
                    'fields': {
                      'containerId': {
                        'type': 'google.protobuf.StringValue',
                        'id': 1
                      },
                      'containerType': {
                        'type': 'google.protobuf.StringValue',
                        'id': 2
                      },
                      'limit': {
                        'type': 'google.protobuf.Int32Value',
                        'id': 3,
                        'options': {
                          '(wix.api.min)': 0
                        }
                      }
                    }
                  },
                  'CreateComponentContextResponses': {
                    'fields': {
                      'componentContexts': {
                        'keyType': 'string',
                        'type': 'string',
                        'id': 1
                      }
                    }
                  },
                  'Role': {
                    'values': {
                      'VIEWER': 0,
                      'WRITER': 1,
                      'ADMIN': 2
                    }
                  }
                }
              },
              'ContentPreviewService': {
                'methods': {
                  'Get': {
                    'requestType': 'GetRequest',
                    'responseType': 'GetResponse',
                    'options': {
                      '(wix.api.maturity)': 'ALPHA',
                      '(google.api.http).post': '/api/v1/content-previews'
                    },
                    'rawOptions': [
                      {
                        'name': '(wix.api.maturity)',
                        'value': 'ALPHA'
                      },
                      {
                        'name': '(google.api.http).post',
                        'value': '/api/v1/content-previews'
                      }
                    ]
                  }
                }
              },
              'GetRequest': {
                'fields': {
                  'supportedOgTypes': {
                    'rule': 'repeated',
                    'type': 'string',
                    'id': 1
                  },
                  'externalReferences': {
                    'rule': 'repeated',
                    'type': 'wix.social.ExternalReference',
                    'id': 6
                  }
                }
              },
              'GetResponse': {
                'fields': {
                  'contentPreviews': {
                    'rule': 'repeated',
                    'type': 'wix.social.ContentPreview',
                    'id': 1
                  }
                }
              },
              'FeedAccess': {
                'fields': {}
              },
              'FeedService': {
                'methods': {
                  'List': {
                    'requestType': 'ListFeedItemsRequest',
                    'responseType': 'ListFeedItemsResponse',
                    'options': {
                      '(wix.api.maturity)': 'ALPHA',
                      '(google.api.http).get': '/api/v1/feed/items'
                    },
                    'rawOptions': [
                      {
                        'name': '(wix.api.maturity)',
                        'value': 'ALPHA'
                      },
                      {
                        'name': '(google.api.http).get',
                        'value': '/api/v1/feed/items'
                      }
                    ]
                  },
                  'Get': {
                    'requestType': 'GetFeedItemRequest',
                    'responseType': 'FeedItem',
                    'options': {
                      '(wix.api.maturity)': 'ALPHA',
                      '(google.api.http).get': '/api/v1/feed/items/{feedItemId}'
                    },
                    'rawOptions': [
                      {
                        'name': '(wix.api.maturity)',
                        'value': 'ALPHA'
                      },
                      {
                        'name': '(google.api.http).get',
                        'value': '/api/v1/feed/items/{feedItemId}'
                      }
                    ]
                  },
                  'Create': {
                    'requestType': 'CreateFeedItemRequest',
                    'responseType': 'FeedItem',
                    'options': {
                      '(wix.api.maturity)': 'ALPHA',
                      '(google.api.http).post': '/api/v1/feed/items',
                      '(wix.api.callback).topic': 'wix-feed.callbacks',
                      '(wix.api.callback).payload': 'wix.feed.callbacks.FeedItemCreated'
                    },
                    'rawOptions': [
                      {
                        'name': '(wix.api.maturity)',
                        'value': 'ALPHA'
                      },
                      {
                        'name': '(google.api.http).post',
                        'value': '/api/v1/feed/items'
                      },
                      {
                        'name': '(wix.api.callback).topic',
                        'value': 'wix-feed.callbacks'
                      },
                      {
                        'name': '(wix.api.callback).payload',
                        'value': 'wix.feed.callbacks.FeedItemCreated'
                      }
                    ]
                  },
                  'CreateComment': {
                    'requestType': 'CreateCommentRequest',
                    'responseType': 'wix.comments.Comment',
                    'options': {
                      '(wix.api.maturity)': 'ALPHA',
                      '(wix.api.required)': 'CreateCommentRequest.feed_item_id',
                      '(google.api.http).post': '/api/v1/feed/items/{feedItemId}/comment',
                      '(wix.api.callback).topic': 'wix-feed.callbacks',
                      '(wix.api.callback).payload': 'wix.feed.callbacks.CommentedOnFeedItem'
                    },
                    'rawOptions': [
                      {
                        'name': '(wix.api.maturity)',
                        'value': 'ALPHA'
                      },
                      {
                        'name': '(wix.api.required)',
                        'value': 'CreateCommentRequest.feed_item_id'
                      },
                      {
                        'name': '(google.api.http).post',
                        'value': '/api/v1/feed/items/{feedItemId}/comment'
                      },
                      {
                        'name': '(wix.api.callback).topic',
                        'value': 'wix-feed.callbacks'
                      },
                      {
                        'name': '(wix.api.callback).payload',
                        'value': 'wix.feed.callbacks.CommentedOnFeedItem'
                      }
                    ]
                  },
                  'Update': {
                    'requestType': 'UpdateFeedItemRequest',
                    'responseType': 'FeedItem',
                    'options': {
                      '(wix.api.maturity)': 'ALPHA',
                      '(google.api.http).patch': '/api/v1/feed/items/{feedItemId}'
                    },
                    'rawOptions': [
                      {
                        'name': '(wix.api.maturity)',
                        'value': 'ALPHA'
                      },
                      {
                        'name': '(google.api.http).patch',
                        'value': '/api/v1/feed/items/{feedItemId}'
                      }
                    ]
                  },
                  'Delete': {
                    'requestType': 'DeleteFeedItemRequest',
                    'responseType': 'FeedItem',
                    'options': {
                      '(wix.api.maturity)': 'ALPHA',
                      '(google.api.http).delete': '/api/v1/feed/items/{feedItemId}'
                    },
                    'rawOptions': [
                      {
                        'name': '(wix.api.maturity)',
                        'value': 'ALPHA'
                      },
                      {
                        'name': '(google.api.http).delete',
                        'value': '/api/v1/feed/items/{feedItemId}'
                      }
                    ]
                  },
                  'PinToContainer': {
                    'requestType': 'PinToContainerRequest',
                    'responseType': 'FeedItemPin',
                    'options': {
                      '(wix.api.maturity)': 'ALPHA',
                      '(google.api.http).put': '/api/v1/feed/items/{feedItemId}/pin'
                    },
                    'rawOptions': [
                      {
                        'name': '(wix.api.maturity)',
                        'value': 'ALPHA'
                      },
                      {
                        'name': '(google.api.http).put',
                        'value': '/api/v1/feed/items/{feedItemId}/pin'
                      }
                    ]
                  },
                  'UnpinFromContainer': {
                    'requestType': 'UnpinFromContainerRequest',
                    'responseType': 'FeedItemPin',
                    'options': {
                      '(wix.api.maturity)': 'ALPHA',
                      '(google.api.http).delete': '/api/v1/feed/items/{feedItemId}/pin'
                    },
                    'rawOptions': [
                      {
                        'name': '(wix.api.maturity)',
                        'value': 'ALPHA'
                      },
                      {
                        'name': '(google.api.http).delete',
                        'value': '/api/v1/feed/items/{feedItemId}/pin'
                      }
                    ]
                  },
                  'SubscribeToFeedItem': {
                    'requestType': 'SubscribeToFeedItemRequest',
                    'responseType': 'FeedItemRequester',
                    'options': {
                      '(wix.api.maturity)': 'ALPHA',
                      '(google.api.http).put': '/api/v1/feed/items/{feedItemId}/subscribe'
                    },
                    'rawOptions': [
                      {
                        'name': '(wix.api.maturity)',
                        'value': 'ALPHA'
                      },
                      {
                        'name': '(google.api.http).put',
                        'value': '/api/v1/feed/items/{feedItemId}/subscribe'
                      }
                    ]
                  },
                  'UnsubscribeFromFeedItem': {
                    'requestType': 'UnsubscribeFromFeedItemRequest',
                    'responseType': 'FeedItemRequester',
                    'options': {
                      '(wix.api.maturity)': 'ALPHA',
                      '(google.api.http).delete': '/api/v1/feed/items/{feedItemId}/unsubscribe'
                    },
                    'rawOptions': [
                      {
                        'name': '(wix.api.maturity)',
                        'value': 'ALPHA'
                      },
                      {
                        'name': '(google.api.http).delete',
                        'value': '/api/v1/feed/items/{feedItemId}/unsubscribe'
                      }
                    ]
                  }
                }
              },
              'ListFeedItemsRequest': {
                'oneofs': {
                  'pageRequest': {
                    'oneof': [
                      'cursor',
                      'query'
                    ]
                  }
                },
                'fields': {
                  'contextToken': {
                    'type': 'google.protobuf.StringValue',
                    'id': 1
                  },
                  'cursor': {
                    'type': 'wix.common.CursorPaging',
                    'id': 2
                  },
                  'query': {
                    'type': 'FeedItemsQuery',
                    'id': 3
                  },
                  'fieldset': {
                    'type': 'string',
                    'id': 4
                  },
                  'previewQuery': {
                    'type': 'ContentPreviewQuery',
                    'id': 5
                  }
                }
              },
              'CreateFeedItemRequest': {
                'fields': {
                  'contextToken': {
                    'type': 'google.protobuf.StringValue',
                    'id': 1
                  },
                  'entity': {
                    'type': 'FeedItemEntity',
                    'id': 2
                  },
                  'applicationData': {
                    'type': 'ApplicationData',
                    'id': 3
                  },
                  'applicationOverrides': {
                    'type': 'ApplicationOverrides',
                    'id': 4
                  },
                  'fieldset': {
                    'type': 'string',
                    'id': 5
                  },
                  'previewQuery': {
                    'type': 'ContentPreviewQuery',
                    'id': 6
                  },
                  'predefinedFeedItemId': {
                    'type': 'google.protobuf.StringValue',
                    'id': 7,
                    'options': {
                      '(wix.api.format)': 'GUID'
                    }
                  }
                }
              },
              'CreateCommentRequest': {
                'fields': {
                  'contextToken': {
                    'type': 'google.protobuf.StringValue',
                    'id': 1
                  },
                  'feedItemId': {
                    'type': 'string',
                    'id': 2,
                    'options': {
                      '(wix.api.format)': 'GUID'
                    }
                  },
                  'comment': {
                    'type': 'wix.comments.CommentEntity',
                    'id': 3
                  },
                  'predefinedCommentId': {
                    'type': 'google.protobuf.StringValue',
                    'id': 4,
                    'options': {
                      '(wix.api.format)': 'GUID'
                    }
                  }
                }
              },
              'UpdateFeedItemRequest': {
                'fields': {
                  'contextToken': {
                    'type': 'google.protobuf.StringValue',
                    'id': 1
                  },
                  'feedItemId': {
                    'type': 'string',
                    'id': 2
                  },
                  'entity': {
                    'type': 'FeedItemEntity',
                    'id': 3
                  },
                  'applicationData': {
                    'type': 'ApplicationData',
                    'id': 4
                  },
                  'applicationOverrides': {
                    'type': 'ApplicationOverrides',
                    'id': 5
                  },
                  'updateMask': {
                    'type': 'google.protobuf.FieldMask',
                    'id': 6
                  },
                  'fieldset': {
                    'type': 'string',
                    'id': 7
                  },
                  'previewQuery': {
                    'type': 'ContentPreviewQuery',
                    'id': 8
                  }
                }
              },
              'DeleteFeedItemRequest': {
                'fields': {
                  'contextToken': {
                    'type': 'google.protobuf.StringValue',
                    'id': 1
                  },
                  'feedItemId': {
                    'type': 'string',
                    'id': 2
                  }
                }
              },
              'PinToContainerRequest': {
                'fields': {
                  'contextToken': {
                    'type': 'google.protobuf.StringValue',
                    'id': 1
                  },
                  'feedItemId': {
                    'type': 'string',
                    'id': 2
                  },
                  'pinPolicy': {
                    'type': 'PinPolicy',
                    'id': 3
                  }
                }
              },
              'UnpinFromContainerRequest': {
                'fields': {
                  'contextToken': {
                    'type': 'google.protobuf.StringValue',
                    'id': 1
                  },
                  'feedItemId': {
                    'type': 'string',
                    'id': 2
                  }
                }
              },
              'GetFeedItemRequest': {
                'fields': {
                  'contextToken': {
                    'type': 'google.protobuf.StringValue',
                    'id': 1
                  },
                  'feedItemId': {
                    'type': 'string',
                    'id': 2
                  },
                  'fieldset': {
                    'type': 'string',
                    'id': 3
                  },
                  'previewQuery': {
                    'type': 'ContentPreviewQuery',
                    'id': 4
                  }
                }
              },
              'ListFeedItemsResponse': {
                'fields': {
                  'feedItems': {
                    'rule': 'repeated',
                    'type': 'FeedItem',
                    'id': 1
                  },
                  'nextPageCursor': {
                    'type': 'google.protobuf.StringValue',
                    'id': 2
                  }
                }
              },
              'SubscribeToFeedItemRequest': {
                'fields': {
                  'feedItemId': {
                    'type': 'string',
                    'id': 1
                  }
                }
              },
              'UnsubscribeFromFeedItemRequest': {
                'fields': {
                  'feedItemId': {
                    'type': 'string',
                    'id': 2
                  }
                }
              },
              'FeedItemsQuery': {
                'fields': {
                  'contextToken': {
                    'type': 'google.protobuf.StringValue',
                    'id': 1
                  },
                  'containerId': {
                    'type': 'google.protobuf.StringValue',
                    'id': 2
                  },
                  'identityId': {
                    'type': 'google.protobuf.StringValue',
                    'id': 3
                  },
                  'excludeOwn': {
                    'type': 'bool',
                    'id': 4
                  },
                  'limit': {
                    'type': 'google.protobuf.Int32Value',
                    'id': 5,
                    'options': {
                      '(wix.api.min)': 0
                    }
                  },
                  'filter': {
                    'type': 'google.protobuf.Value',
                    'id': 6
                  },
                  'pinningDisabled': {
                    'type': 'bool',
                    'id': 7
                  }
                }
              },
              'ApplicationOverrides': {
                'fields': {
                  'containerId': {
                    'type': 'google.protobuf.StringValue',
                    'id': 1
                  },
                  'identityId': {
                    'type': 'google.protobuf.StringValue',
                    'id': 2
                  }
                }
              },
              'ContentPreviewQuery': {
                'fields': {
                  'supportedOgTypes': {
                    'rule': 'repeated',
                    'type': 'string',
                    'id': 1
                  },
                  'limit': {
                    'type': 'google.protobuf.Int32Value',
                    'id': 2
                  }
                }
              },
              'PinPolicy': {
                'fields': {
                  'pinnedFeedItemsAllowed': {
                    'type': 'int32',
                    'id': 1
                  },
                  'onExceedAllowedPins': {
                    'type': 'OnExceedAllowedPins',
                    'id': 2
                  }
                },
                'nested': {
                  'OnExceedAllowedPins': {
                    'values': {
                      'RESPOND_WITH_ALREADY_EXISTS': 0,
                      'REPLACE_OLDEST': 1
                    }
                  }
                }
              }
            }
          },
          'reactions': {
            'options': {
              'java_package': 'com.wix.social.reactions.api'
            },
            'nested': {
              'ItemReactionsSummary': {
                'fields': {
                  'itemId': {
                    'type': 'string',
                    'id': 1
                  },
                  'total': {
                    'type': 'int32',
                    'id': 2
                  },
                  'usersReacted': {
                    'type': 'Users',
                    'id': 3
                  },
                  'usersReactions': {
                    'type': 'UsersReactions',
                    'id': 4
                  },
                  'reactionsSummary': {
                    'type': 'ReactionsSummary',
                    'id': 5
                  },
                  'requesterReactions': {
                    'type': 'UserReactions',
                    'id': 6
                  },
                  'profiles': {
                    'type': 'wix.social.Profiles',
                    'id': 7
                  }
                }
              },
              'Users': {
                'fields': {
                  'total': {
                    'type': 'int32',
                    'id': 1
                  },
                  'userIds': {
                    'rule': 'repeated',
                    'type': 'string',
                    'id': 2
                  },
                  'nextCursor': {
                    'type': 'google.protobuf.StringValue',
                    'id': 4
                  }
                }
              },
              'UsersReactions': {
                'fields': {
                  'total': {
                    'type': 'int32',
                    'id': 1
                  },
                  'userReactions': {
                    'rule': 'repeated',
                    'type': 'UserReaction',
                    'id': 3
                  },
                  'nextCursor': {
                    'type': 'google.protobuf.StringValue',
                    'id': 4
                  }
                }
              },
              'UserReactions': {
                'fields': {
                  'reactions': {
                    'rule': 'repeated',
                    'type': 'Reaction',
                    'id': 1
                  }
                }
              },
              'UserReaction': {
                'fields': {
                  'reaction': {
                    'type': 'Reaction',
                    'id': 1
                  },
                  'userId': {
                    'type': 'string',
                    'id': 2,
                    'options': {
                      '(wix.api.format)': 'GUID'
                    }
                  },
                  'reactionTime': {
                    'type': 'google.protobuf.Timestamp',
                    'id': 3
                  }
                }
              },
              'ReactionsSummary': {
                'fields': {
                  'latestReactions': {
                    'rule': 'repeated',
                    'type': 'ReactionSummary',
                    'id': 1
                  }
                }
              },
              'ReactionSummary': {
                'fields': {
                  'reaction': {
                    'type': 'Reaction',
                    'id': 1
                  },
                  'usersReacted': {
                    'type': 'Users',
                    'id': 2
                  },
                  'reactionTime': {
                    'type': 'google.protobuf.Timestamp',
                    'id': 3
                  }
                }
              },
              'Reaction': {
                'fields': {
                  'reactionCode': {
                    'type': 'string',
                    'id': 1
                  },
                  'reactionParams': {
                    'keyType': 'string',
                    'type': 'string',
                    'id': 2
                  }
                }
              },
              'ItemsReacted': {
                'fields': {
                  'total': {
                    'type': 'int32',
                    'id': 1
                  },
                  'itemReactions': {
                    'rule': 'repeated',
                    'type': 'ItemReactions',
                    'id': 2
                  },
                  'nextCursor': {
                    'type': 'google.protobuf.StringValue',
                    'id': 3
                  }
                }
              },
              'ItemReactions': {
                'fields': {
                  'itemId': {
                    'type': 'string',
                    'id': 1,
                    'options': {
                      '(wix.api.format)': 'GUID'
                    }
                  },
                  'reactionsCount': {
                    'type': 'int32',
                    'id': 2
                  }
                }
              },
              'UsersReacted': {
                'fields': {
                  'total': {
                    'type': 'int32',
                    'id': 1
                  },
                  'userReactions': {
                    'rule': 'repeated',
                    'type': 'UserReactionsCount',
                    'id': 2
                  },
                  'nextCursor': {
                    'type': 'google.protobuf.StringValue',
                    'id': 3
                  }
                }
              },
              'UserReactionsCount': {
                'fields': {
                  'userId': {
                    'type': 'string',
                    'id': 1,
                    'options': {
                      '(wix.api.format)': 'GUID'
                    }
                  },
                  'count': {
                    'type': 'int32',
                    'id': 2
                  }
                }
              },
              'UserReacted': {
                'fields': {
                  'reaction': {
                    'type': 'google.protobuf.StringValue',
                    'id': 1
                  },
                  'args': {
                    'keyType': 'string',
                    'type': 'string',
                    'id': 2
                  }
                }
              },
              'UserUnreacted': {
                'fields': {
                  'reaction': {
                    'type': 'google.protobuf.StringValue',
                    'id': 1
                  }
                }
              },
              'ReactionsService': {
                'methods': {
                  'React': {
                    'requestType': 'ReactRequest',
                    'responseType': 'ItemReactionsSummary',
                    'options': {
                      '(wix.api.maturity)': 'ALPHA',
                      '(google.api.http).post': '/api/v1/reactions/{itemId}/react',
                      '(google.api.http).additional_bindings.put': '/api/v1/reactions/{itemId}/{reaction-code}'
                    },
                    'rawOptions': [
                      {
                        'name': '(wix.api.maturity)',
                        'value': 'ALPHA'
                      },
                      {
                        'name': '(google.api.http).post',
                        'value': '/api/v1/reactions/{itemId}/react'
                      },
                      {
                        'name': '(google.api.http).additional_bindings.put',
                        'value': '/api/v1/reactions/{itemId}/{reaction-code}'
                      }
                    ]
                  },
                  'Unreact': {
                    'requestType': 'UnreactRequest',
                    'responseType': 'ItemReactionsSummary',
                    'options': {
                      '(wix.api.maturity)': 'ALPHA',
                      '(google.api.http).post': '/api/v1/reactions/{itemId}/unreact',
                      '(google.api.http).additional_bindings.delete': '/api/v1/reactions/{itemId}/{reaction-code}'
                    },
                    'rawOptions': [
                      {
                        'name': '(wix.api.maturity)',
                        'value': 'ALPHA'
                      },
                      {
                        'name': '(google.api.http).post',
                        'value': '/api/v1/reactions/{itemId}/unreact'
                      },
                      {
                        'name': '(google.api.http).additional_bindings.delete',
                        'value': '/api/v1/reactions/{itemId}/{reaction-code}'
                      }
                    ]
                  },
                  'Get': {
                    'requestType': 'GetRequest',
                    'responseType': 'ItemReactionsSummary',
                    'options': {
                      '(wix.api.maturity)': 'ALPHA',
                      '(google.api.http).get': '/api/v1/reactions/{itemId}'
                    },
                    'rawOptions': [
                      {
                        'name': '(wix.api.maturity)',
                        'value': 'ALPHA'
                      },
                      {
                        'name': '(google.api.http).get',
                        'value': '/api/v1/reactions/{itemId}'
                      }
                    ]
                  },
                  'RemoveAll': {
                    'requestType': 'RemoveAllRequest',
                    'responseType': 'google.protobuf.Empty',
                    'options': {
                      '(wix.api.maturity)': 'ALPHA',
                      '(google.api.http).delete': '/api/v1/reactions/{itemId}',
                      '(google.api.http).additional_bindings.delete': '/api/v1/reactions'
                    },
                    'rawOptions': [
                      {
                        'name': '(wix.api.maturity)',
                        'value': 'ALPHA'
                      },
                      {
                        'name': '(google.api.http).delete',
                        'value': '/api/v1/reactions/{itemId}'
                      },
                      {
                        'name': '(google.api.http).additional_bindings.delete',
                        'value': '/api/v1/reactions'
                      }
                    ]
                  },
                  'GetReactions': {
                    'requestType': 'GetReactionsRequest',
                    'responseType': 'GetReactionsResponse',
                    'options': {
                      '(wix.api.maturity)': 'ALPHA',
                      '(google.api.http).get': '/api/v1/reactions'
                    },
                    'rawOptions': [
                      {
                        'name': '(wix.api.maturity)',
                        'value': 'ALPHA'
                      },
                      {
                        'name': '(google.api.http).get',
                        'value': '/api/v1/reactions'
                      }
                    ]
                  },
                  'GetReactionsSummary': {
                    'requestType': 'GetReactionsSummaryRequest',
                    'responseType': 'GetReactionsSummaryResponse',
                    'options': {
                      '(wix.api.maturity)': 'ALPHA',
                      '(google.api.http).get': '/api/v1/reactions/summary'
                    },
                    'rawOptions': [
                      {
                        'name': '(wix.api.maturity)',
                        'value': 'ALPHA'
                      },
                      {
                        'name': '(google.api.http).get',
                        'value': '/api/v1/reactions/summary'
                      }
                    ]
                  }
                }
              },
              'ReactRequest': {
                'fields': {
                  'itemId': {
                    'type': 'string',
                    'id': 1,
                    'options': {
                      '(wix.api.format)': 'GUID'
                    }
                  },
                  'reaction': {
                    'type': 'Reaction',
                    'id': 2
                  },
                  'scopeId': {
                    'type': 'google.protobuf.StringValue',
                    'id': 3
                  },
                  'contextToken': {
                    'type': 'google.protobuf.StringValue',
                    'id': 4
                  }
                }
              },
              'UnreactRequest': {
                'fields': {
                  'itemId': {
                    'type': 'string',
                    'id': 1,
                    'options': {
                      '(wix.api.format)': 'GUID'
                    }
                  },
                  'reactionCode': {
                    'type': 'string',
                    'id': 2
                  },
                  'contextToken': {
                    'type': 'google.protobuf.StringValue',
                    'id': 4
                  }
                }
              },
              'GetRequest': {
                'fields': {
                  'itemId': {
                    'type': 'string',
                    'id': 1,
                    'options': {
                      '(wix.api.format)': 'GUID'
                    }
                  }
                }
              },
              'RemoveAllRequest': {
                'fields': {
                  'itemId': {
                    'rule': 'repeated',
                    'type': 'string',
                    'id': 1,
                    'options': {
                      '(wix.api.format)': 'GUID'
                    }
                  },
                  'scopeId': {
                    'type': 'google.protobuf.StringValue',
                    'id': 2,
                    'options': {
                      '(wix.api.format)': 'GUID'
                    }
                  }
                }
              },
              'GetReactionsSummaryRequest': {
                'fields': {
                  'itemId': {
                    'rule': 'repeated',
                    'type': 'string',
                    'id': 1
                  },
                  'scopeId': {
                    'type': 'google.protobuf.StringValue',
                    'id': 2,
                    'options': {
                      '(wix.api.format)': 'GUID'
                    }
                  },
                  'limit': {
                    'type': 'google.protobuf.Int32Value',
                    'id': 3
                  }
                }
              },
              'GetReactionsRequest': {
                'fields': {
                  'itemId': {
                    'rule': 'repeated',
                    'type': 'string',
                    'id': 1
                  }
                }
              },
              'GetReactionsResponse': {
                'fields': {
                  'total': {
                    'type': 'int32',
                    'id': 1
                  },
                  'itemReactions': {
                    'rule': 'repeated',
                    'type': 'ItemReactionsSummary',
                    'id': 2
                  }
                }
              },
              'GetReactionsSummaryResponse': {
                'fields': {
                  'reactionsSummary': {
                    'type': 'ReactionsSummary',
                    'id': 1
                  },
                  'usersReacted': {
                    'type': 'UsersReacted',
                    'id': 2
                  },
                  'itemsReacted': {
                    'type': 'ItemsReacted',
                    'id': 3
                  }
                }
              }
            }
          }
        }
      },
      'google': {
        'nested': {
          'protobuf': {
            'options': {
              'go_package': 'github.com/golang/protobuf/protoc-gen-go/descriptor;descriptor',
              'java_package': 'com.google.protobuf',
              'java_outer_classname': 'DescriptorProtos',
              'csharp_namespace': 'Google.Protobuf.Reflection',
              'objc_class_prefix': 'GPB',
              'cc_enable_arenas': true,
              'optimize_for': 'SPEED'
            },
            'nested': {
              'DoubleValue': {
                'fields': {
                  'value': {
                    'type': 'double',
                    'id': 1
                  }
                }
              },
              'FloatValue': {
                'fields': {
                  'value': {
                    'type': 'float',
                    'id': 1
                  }
                }
              },
              'Int64Value': {
                'fields': {
                  'value': {
                    'type': 'int64',
                    'id': 1
                  }
                }
              },
              'UInt64Value': {
                'fields': {
                  'value': {
                    'type': 'uint64',
                    'id': 1
                  }
                }
              },
              'Int32Value': {
                'fields': {
                  'value': {
                    'type': 'int32',
                    'id': 1
                  }
                }
              },
              'UInt32Value': {
                'fields': {
                  'value': {
                    'type': 'uint32',
                    'id': 1
                  }
                }
              },
              'BoolValue': {
                'fields': {
                  'value': {
                    'type': 'bool',
                    'id': 1
                  }
                }
              },
              'StringValue': {
                'fields': {
                  'value': {
                    'type': 'string',
                    'id': 1
                  }
                }
              },
              'BytesValue': {
                'fields': {
                  'value': {
                    'type': 'bytes',
                    'id': 1
                  }
                }
              },
              'Timestamp': {
                'fields': {
                  'seconds': {
                    'type': 'int64',
                    'id': 1
                  },
                  'nanos': {
                    'type': 'int32',
                    'id': 2
                  }
                }
              },
              'Empty': {
                'fields': {}
              },
              'FieldMask': {
                'fields': {
                  'paths': {
                    'rule': 'repeated',
                    'type': 'string',
                    'id': 1
                  }
                }
              },
              'FileDescriptorSet': {
                'fields': {
                  'file': {
                    'rule': 'repeated',
                    'type': 'FileDescriptorProto',
                    'id': 1
                  }
                }
              },
              'FileDescriptorProto': {
                'fields': {
                  'name': {
                    'type': 'string',
                    'id': 1
                  },
                  'package': {
                    'type': 'string',
                    'id': 2
                  },
                  'dependency': {
                    'rule': 'repeated',
                    'type': 'string',
                    'id': 3
                  },
                  'publicDependency': {
                    'rule': 'repeated',
                    'type': 'int32',
                    'id': 10,
                    'options': {
                      'packed': false
                    }
                  },
                  'weakDependency': {
                    'rule': 'repeated',
                    'type': 'int32',
                    'id': 11,
                    'options': {
                      'packed': false
                    }
                  },
                  'messageType': {
                    'rule': 'repeated',
                    'type': 'DescriptorProto',
                    'id': 4
                  },
                  'enumType': {
                    'rule': 'repeated',
                    'type': 'EnumDescriptorProto',
                    'id': 5
                  },
                  'service': {
                    'rule': 'repeated',
                    'type': 'ServiceDescriptorProto',
                    'id': 6
                  },
                  'extension': {
                    'rule': 'repeated',
                    'type': 'FieldDescriptorProto',
                    'id': 7
                  },
                  'options': {
                    'type': 'FileOptions',
                    'id': 8
                  },
                  'sourceCodeInfo': {
                    'type': 'SourceCodeInfo',
                    'id': 9
                  },
                  'syntax': {
                    'type': 'string',
                    'id': 12
                  }
                }
              },
              'DescriptorProto': {
                'fields': {
                  'name': {
                    'type': 'string',
                    'id': 1
                  },
                  'field': {
                    'rule': 'repeated',
                    'type': 'FieldDescriptorProto',
                    'id': 2
                  },
                  'extension': {
                    'rule': 'repeated',
                    'type': 'FieldDescriptorProto',
                    'id': 6
                  },
                  'nestedType': {
                    'rule': 'repeated',
                    'type': 'DescriptorProto',
                    'id': 3
                  },
                  'enumType': {
                    'rule': 'repeated',
                    'type': 'EnumDescriptorProto',
                    'id': 4
                  },
                  'extensionRange': {
                    'rule': 'repeated',
                    'type': 'ExtensionRange',
                    'id': 5
                  },
                  'oneofDecl': {
                    'rule': 'repeated',
                    'type': 'OneofDescriptorProto',
                    'id': 8
                  },
                  'options': {
                    'type': 'MessageOptions',
                    'id': 7
                  },
                  'reservedRange': {
                    'rule': 'repeated',
                    'type': 'ReservedRange',
                    'id': 9
                  },
                  'reservedName': {
                    'rule': 'repeated',
                    'type': 'string',
                    'id': 10
                  }
                },
                'nested': {
                  'ExtensionRange': {
                    'fields': {
                      'start': {
                        'type': 'int32',
                        'id': 1
                      },
                      'end': {
                        'type': 'int32',
                        'id': 2
                      },
                      'options': {
                        'type': 'ExtensionRangeOptions',
                        'id': 3
                      }
                    }
                  },
                  'ReservedRange': {
                    'fields': {
                      'start': {
                        'type': 'int32',
                        'id': 1
                      },
                      'end': {
                        'type': 'int32',
                        'id': 2
                      }
                    }
                  }
                }
              },
              'ExtensionRangeOptions': {
                'fields': {
                  'uninterpretedOption': {
                    'rule': 'repeated',
                    'type': 'UninterpretedOption',
                    'id': 999
                  }
                },
                'extensions': [[
                  1000,
                  536870911
                ]]
              },
              'FieldDescriptorProto': {
                'fields': {
                  'name': {
                    'type': 'string',
                    'id': 1
                  },
                  'number': {
                    'type': 'int32',
                    'id': 3
                  },
                  'label': {
                    'type': 'Label',
                    'id': 4
                  },
                  'type': {
                    'type': 'Type',
                    'id': 5
                  },
                  'typeName': {
                    'type': 'string',
                    'id': 6
                  },
                  'extendee': {
                    'type': 'string',
                    'id': 2
                  },
                  'defaultValue': {
                    'type': 'string',
                    'id': 7
                  },
                  'oneofIndex': {
                    'type': 'int32',
                    'id': 9
                  },
                  'jsonName': {
                    'type': 'string',
                    'id': 10
                  },
                  'options': {
                    'type': 'FieldOptions',
                    'id': 8
                  }
                },
                'nested': {
                  'Type': {
                    'values': {
                      'TYPE_DOUBLE': 1,
                      'TYPE_FLOAT': 2,
                      'TYPE_INT64': 3,
                      'TYPE_UINT64': 4,
                      'TYPE_INT32': 5,
                      'TYPE_FIXED64': 6,
                      'TYPE_FIXED32': 7,
                      'TYPE_BOOL': 8,
                      'TYPE_STRING': 9,
                      'TYPE_GROUP': 10,
                      'TYPE_MESSAGE': 11,
                      'TYPE_BYTES': 12,
                      'TYPE_UINT32': 13,
                      'TYPE_ENUM': 14,
                      'TYPE_SFIXED32': 15,
                      'TYPE_SFIXED64': 16,
                      'TYPE_SINT32': 17,
                      'TYPE_SINT64': 18
                    }
                  },
                  'Label': {
                    'values': {
                      'LABEL_OPTIONAL': 1,
                      'LABEL_REQUIRED': 2,
                      'LABEL_REPEATED': 3
                    }
                  }
                }
              },
              'OneofDescriptorProto': {
                'fields': {
                  'name': {
                    'type': 'string',
                    'id': 1
                  },
                  'options': {
                    'type': 'OneofOptions',
                    'id': 2
                  }
                }
              },
              'EnumDescriptorProto': {
                'fields': {
                  'name': {
                    'type': 'string',
                    'id': 1
                  },
                  'value': {
                    'rule': 'repeated',
                    'type': 'EnumValueDescriptorProto',
                    'id': 2
                  },
                  'options': {
                    'type': 'EnumOptions',
                    'id': 3
                  },
                  'reservedRange': {
                    'rule': 'repeated',
                    'type': 'EnumReservedRange',
                    'id': 4
                  },
                  'reservedName': {
                    'rule': 'repeated',
                    'type': 'string',
                    'id': 5
                  }
                },
                'nested': {
                  'EnumReservedRange': {
                    'fields': {
                      'start': {
                        'type': 'int32',
                        'id': 1
                      },
                      'end': {
                        'type': 'int32',
                        'id': 2
                      }
                    }
                  }
                }
              },
              'EnumValueDescriptorProto': {
                'fields': {
                  'name': {
                    'type': 'string',
                    'id': 1
                  },
                  'number': {
                    'type': 'int32',
                    'id': 2
                  },
                  'options': {
                    'type': 'EnumValueOptions',
                    'id': 3
                  }
                }
              },
              'ServiceDescriptorProto': {
                'fields': {
                  'name': {
                    'type': 'string',
                    'id': 1
                  },
                  'method': {
                    'rule': 'repeated',
                    'type': 'MethodDescriptorProto',
                    'id': 2
                  },
                  'options': {
                    'type': 'ServiceOptions',
                    'id': 3
                  }
                }
              },
              'MethodDescriptorProto': {
                'fields': {
                  'name': {
                    'type': 'string',
                    'id': 1
                  },
                  'inputType': {
                    'type': 'string',
                    'id': 2
                  },
                  'outputType': {
                    'type': 'string',
                    'id': 3
                  },
                  'options': {
                    'type': 'MethodOptions',
                    'id': 4
                  },
                  'clientStreaming': {
                    'type': 'bool',
                    'id': 5,
                    'options': {
                      'default': false
                    }
                  },
                  'serverStreaming': {
                    'type': 'bool',
                    'id': 6,
                    'options': {
                      'default': false
                    }
                  }
                }
              },
              'FileOptions': {
                'fields': {
                  'javaPackage': {
                    'type': 'string',
                    'id': 1
                  },
                  'javaOuterClassname': {
                    'type': 'string',
                    'id': 8
                  },
                  'javaMultipleFiles': {
                    'type': 'bool',
                    'id': 10,
                    'options': {
                      'default': false
                    }
                  },
                  'javaGenerateEqualsAndHash': {
                    'type': 'bool',
                    'id': 20,
                    'options': {
                      'deprecated': true
                    }
                  },
                  'javaStringCheckUtf8': {
                    'type': 'bool',
                    'id': 27,
                    'options': {
                      'default': false
                    }
                  },
                  'optimizeFor': {
                    'type': 'OptimizeMode',
                    'id': 9,
                    'options': {
                      'default': 'SPEED'
                    }
                  },
                  'goPackage': {
                    'type': 'string',
                    'id': 11
                  },
                  'ccGenericServices': {
                    'type': 'bool',
                    'id': 16,
                    'options': {
                      'default': false
                    }
                  },
                  'javaGenericServices': {
                    'type': 'bool',
                    'id': 17,
                    'options': {
                      'default': false
                    }
                  },
                  'pyGenericServices': {
                    'type': 'bool',
                    'id': 18,
                    'options': {
                      'default': false
                    }
                  },
                  'phpGenericServices': {
                    'type': 'bool',
                    'id': 42,
                    'options': {
                      'default': false
                    }
                  },
                  'deprecated': {
                    'type': 'bool',
                    'id': 23,
                    'options': {
                      'default': false
                    }
                  },
                  'ccEnableArenas': {
                    'type': 'bool',
                    'id': 31,
                    'options': {
                      'default': false
                    }
                  },
                  'objcClassPrefix': {
                    'type': 'string',
                    'id': 36
                  },
                  'csharpNamespace': {
                    'type': 'string',
                    'id': 37
                  },
                  'swiftPrefix': {
                    'type': 'string',
                    'id': 39
                  },
                  'phpClassPrefix': {
                    'type': 'string',
                    'id': 40
                  },
                  'phpNamespace': {
                    'type': 'string',
                    'id': 41
                  },
                  'phpMetadataNamespace': {
                    'type': 'string',
                    'id': 44
                  },
                  'rubyPackage': {
                    'type': 'string',
                    'id': 45
                  },
                  'uninterpretedOption': {
                    'rule': 'repeated',
                    'type': 'UninterpretedOption',
                    'id': 999
                  }
                },
                'extensions': [[
                  1000,
                  536870911
                ]],
                'reserved': [[
                  38,
                  38
                ]],
                'nested': {
                  'OptimizeMode': {
                    'values': {
                      'SPEED': 1,
                      'CODE_SIZE': 2,
                      'LITE_RUNTIME': 3
                    }
                  }
                }
              },
              'MessageOptions': {
                'fields': {
                  'messageSetWireFormat': {
                    'type': 'bool',
                    'id': 1,
                    'options': {
                      'default': false
                    }
                  },
                  'noStandardDescriptorAccessor': {
                    'type': 'bool',
                    'id': 2,
                    'options': {
                      'default': false
                    }
                  },
                  'deprecated': {
                    'type': 'bool',
                    'id': 3,
                    'options': {
                      'default': false
                    }
                  },
                  'mapEntry': {
                    'type': 'bool',
                    'id': 7
                  },
                  'uninterpretedOption': {
                    'rule': 'repeated',
                    'type': 'UninterpretedOption',
                    'id': 999
                  }
                },
                'extensions': [[
                  1000,
                  536870911
                ]],
                'reserved': [
                  [
                    8,
                    8
                  ],
                  [
                    9,
                    9
                  ]
                ]
              },
              'FieldOptions': {
                'fields': {
                  'ctype': {
                    'type': 'CType',
                    'id': 1,
                    'options': {
                      'default': 'STRING'
                    }
                  },
                  'packed': {
                    'type': 'bool',
                    'id': 2
                  },
                  'jstype': {
                    'type': 'JSType',
                    'id': 6,
                    'options': {
                      'default': 'JS_NORMAL'
                    }
                  },
                  'lazy': {
                    'type': 'bool',
                    'id': 5,
                    'options': {
                      'default': false
                    }
                  },
                  'deprecated': {
                    'type': 'bool',
                    'id': 3,
                    'options': {
                      'default': false
                    }
                  },
                  'weak': {
                    'type': 'bool',
                    'id': 10,
                    'options': {
                      'default': false
                    }
                  },
                  'uninterpretedOption': {
                    'rule': 'repeated',
                    'type': 'UninterpretedOption',
                    'id': 999
                  }
                },
                'extensions': [[
                  1000,
                  536870911
                ]],
                'reserved': [[
                  4,
                  4
                ]],
                'nested': {
                  'CType': {
                    'values': {
                      'STRING': 0,
                      'CORD': 1,
                      'STRING_PIECE': 2
                    }
                  },
                  'JSType': {
                    'values': {
                      'JS_NORMAL': 0,
                      'JS_STRING': 1,
                      'JS_NUMBER': 2
                    }
                  }
                }
              },
              'OneofOptions': {
                'fields': {
                  'uninterpretedOption': {
                    'rule': 'repeated',
                    'type': 'UninterpretedOption',
                    'id': 999
                  }
                },
                'extensions': [[
                  1000,
                  536870911
                ]]
              },
              'EnumOptions': {
                'fields': {
                  'allowAlias': {
                    'type': 'bool',
                    'id': 2
                  },
                  'deprecated': {
                    'type': 'bool',
                    'id': 3,
                    'options': {
                      'default': false
                    }
                  },
                  'uninterpretedOption': {
                    'rule': 'repeated',
                    'type': 'UninterpretedOption',
                    'id': 999
                  }
                },
                'extensions': [[
                  1000,
                  536870911
                ]],
                'reserved': [[
                  5,
                  5
                ]]
              },
              'EnumValueOptions': {
                'fields': {
                  'deprecated': {
                    'type': 'bool',
                    'id': 1,
                    'options': {
                      'default': false
                    }
                  },
                  'uninterpretedOption': {
                    'rule': 'repeated',
                    'type': 'UninterpretedOption',
                    'id': 999
                  }
                },
                'extensions': [[
                  1000,
                  536870911
                ]]
              },
              'ServiceOptions': {
                'fields': {
                  'deprecated': {
                    'type': 'bool',
                    'id': 33,
                    'options': {
                      'default': false
                    }
                  },
                  'uninterpretedOption': {
                    'rule': 'repeated',
                    'type': 'UninterpretedOption',
                    'id': 999
                  }
                },
                'extensions': [[
                  1000,
                  536870911
                ]]
              },
              'MethodOptions': {
                'fields': {
                  'deprecated': {
                    'type': 'bool',
                    'id': 33,
                    'options': {
                      'default': false
                    }
                  },
                  'idempotencyLevel': {
                    'type': 'IdempotencyLevel',
                    'id': 34,
                    'options': {
                      'default': 'IDEMPOTENCY_UNKNOWN'
                    }
                  },
                  'uninterpretedOption': {
                    'rule': 'repeated',
                    'type': 'UninterpretedOption',
                    'id': 999
                  }
                },
                'extensions': [[
                  1000,
                  536870911
                ]],
                'nested': {
                  'IdempotencyLevel': {
                    'values': {
                      'IDEMPOTENCY_UNKNOWN': 0,
                      'NO_SIDE_EFFECTS': 1,
                      'IDEMPOTENT': 2
                    }
                  }
                }
              },
              'UninterpretedOption': {
                'fields': {
                  'name': {
                    'rule': 'repeated',
                    'type': 'NamePart',
                    'id': 2
                  },
                  'identifierValue': {
                    'type': 'string',
                    'id': 3
                  },
                  'positiveIntValue': {
                    'type': 'uint64',
                    'id': 4
                  },
                  'negativeIntValue': {
                    'type': 'int64',
                    'id': 5
                  },
                  'doubleValue': {
                    'type': 'double',
                    'id': 6
                  },
                  'stringValue': {
                    'type': 'bytes',
                    'id': 7
                  },
                  'aggregateValue': {
                    'type': 'string',
                    'id': 8
                  }
                },
                'nested': {
                  'NamePart': {
                    'fields': {
                      'namePart': {
                        'rule': 'required',
                        'type': 'string',
                        'id': 1
                      },
                      'isExtension': {
                        'rule': 'required',
                        'type': 'bool',
                        'id': 2
                      }
                    }
                  }
                }
              },
              'SourceCodeInfo': {
                'fields': {
                  'location': {
                    'rule': 'repeated',
                    'type': 'Location',
                    'id': 1
                  }
                },
                'nested': {
                  'Location': {
                    'fields': {
                      'path': {
                        'rule': 'repeated',
                        'type': 'int32',
                        'id': 1
                      },
                      'span': {
                        'rule': 'repeated',
                        'type': 'int32',
                        'id': 2
                      },
                      'leadingComments': {
                        'type': 'string',
                        'id': 3
                      },
                      'trailingComments': {
                        'type': 'string',
                        'id': 4
                      },
                      'leadingDetachedComments': {
                        'rule': 'repeated',
                        'type': 'string',
                        'id': 6
                      }
                    }
                  }
                }
              },
              'GeneratedCodeInfo': {
                'fields': {
                  'annotation': {
                    'rule': 'repeated',
                    'type': 'Annotation',
                    'id': 1
                  }
                },
                'nested': {
                  'Annotation': {
                    'fields': {
                      'path': {
                        'rule': 'repeated',
                        'type': 'int32',
                        'id': 1
                      },
                      'sourceFile': {
                        'type': 'string',
                        'id': 2
                      },
                      'begin': {
                        'type': 'int32',
                        'id': 3
                      },
                      'end': {
                        'type': 'int32',
                        'id': 4
                      }
                    }
                  }
                }
              },
              'Struct': {
                'fields': {
                  'fields': {
                    'keyType': 'string',
                    'type': 'Value',
                    'id': 1
                  }
                }
              },
              'Value': {
                'oneofs': {
                  'kind': {
                    'oneof': [
                      'nullValue',
                      'numberValue',
                      'stringValue',
                      'boolValue',
                      'structValue',
                      'listValue'
                    ]
                  }
                },
                'fields': {
                  'nullValue': {
                    'type': 'NullValue',
                    'id': 1
                  },
                  'numberValue': {
                    'type': 'double',
                    'id': 2
                  },
                  'stringValue': {
                    'type': 'string',
                    'id': 3
                  },
                  'boolValue': {
                    'type': 'bool',
                    'id': 4
                  },
                  'structValue': {
                    'type': 'Struct',
                    'id': 5
                  },
                  'listValue': {
                    'type': 'ListValue',
                    'id': 6
                  }
                }
              },
              'NullValue': {
                'values': {
                  'NULL_VALUE': 0
                }
              },
              'ListValue': {
                'fields': {
                  'values': {
                    'rule': 'repeated',
                    'type': 'Value',
                    'id': 1
                  }
                }
              }
            }
          },
          'api': {
            'options': {
              'go_package': 'google.golang.org/genproto/googleapis/api/annotations;annotations',
              'java_multiple_files': true,
              'java_outer_classname': 'HttpProto',
              'java_package': 'com.google.api',
              'objc_class_prefix': 'GAPI',
              'cc_enable_arenas': true
            },
            'nested': {
              'http': {
                'type': 'HttpRule',
                'id': 72295728,
                'extend': 'google.protobuf.MethodOptions'
              },
              'Http': {
                'fields': {
                  'rules': {
                    'rule': 'repeated',
                    'type': 'HttpRule',
                    'id': 1
                  }
                }
              },
              'HttpRule': {
                'oneofs': {
                  'pattern': {
                    'oneof': [
                      'get',
                      'put',
                      'post',
                      'delete',
                      'patch',
                      'custom'
                    ]
                  }
                },
                'fields': {
                  'selector': {
                    'type': 'string',
                    'id': 1
                  },
                  'get': {
                    'type': 'string',
                    'id': 2
                  },
                  'put': {
                    'type': 'string',
                    'id': 3
                  },
                  'post': {
                    'type': 'string',
                    'id': 4
                  },
                  'delete': {
                    'type': 'string',
                    'id': 5
                  },
                  'patch': {
                    'type': 'string',
                    'id': 6
                  },
                  'custom': {
                    'type': 'CustomHttpPattern',
                    'id': 8
                  },
                  'body': {
                    'type': 'string',
                    'id': 7
                  },
                  'additionalBindings': {
                    'rule': 'repeated',
                    'type': 'HttpRule',
                    'id': 11
                  }
                }
              },
              'CustomHttpPattern': {
                'fields': {
                  'kind': {
                    'type': 'string',
                    'id': 1
                  },
                  'path': {
                    'type': 'string',
                    'id': 2
                  }
                }
              }
            }
          }
        }
      },
      'com': {
        'nested': {
          'wix': {
            'nested': {
              'core': {
                'nested': {
                  'services': {
                    'nested': {
                      'identification2': {
                        'nested': {
                          'PersonType': {
                            'values': {
                              'USER': 0,
                              'SITEMEMBER': 1,
                              'VISITOR': 2
                            }
                          },
                          'Service': {
                            'fields': {
                              'appDefId': {
                                'type': 'string',
                                'id': 1
                              }
                            }
                          },
                          'Person': {
                            'fields': {
                              'type': {
                                'type': 'PersonType',
                                'id': 1
                              },
                              'id': {
                                'type': 'string',
                                'id': 2
                              },
                              'hasUserRole': {
                                'type': 'bool',
                                'id': 3
                              },
                              'isWixStaff': {
                                'type': 'bool',
                                'id': 4
                              },
                              'userAccountInfo': {
                                'type': 'UserAccountInfo',
                                'id': 5
                              }
                            }
                          },
                          'UserAccountInfo': {
                            'fields': {
                              'loggedInAccountId': {
                                'type': 'string',
                                'id': 1
                              },
                              'isAccountOwner': {
                                'type': 'bool',
                                'id': 2
                              }
                            }
                          },
                          'UserData': {
                            'fields': {
                              'userId': {
                                'type': 'string',
                                'id': 1
                              }
                            }
                          },
                          'SiteData': {
                            'fields': {
                              'instanceId': {
                                'type': 'string',
                                'id': 1
                              }
                            }
                          },
                          'WixGlobalData': {
                            'fields': {}
                          },
                          'ExternalApp': {
                            'oneofs': {
                              'DataSelector': {
                                'oneof': [
                                  'userData',
                                  'siteData',
                                  'wixGlobalData'
                                ]
                              }
                            },
                            'fields': {
                              'appDefId': {
                                'type': 'string',
                                'id': 1
                              },
                              'permissions': {
                                'rule': 'repeated',
                                'type': 'string',
                                'id': 2
                              },
                              'userData': {
                                'type': 'UserData',
                                'id': 3
                              },
                              'siteData': {
                                'type': 'SiteData',
                                'id': 4
                              },
                              'wixGlobalData': {
                                'type': 'WixGlobalData',
                                'id': 5
                              }
                            }
                          },
                          'Cache': {
                            'fields': {}
                          },
                          'Identity': {
                            'oneofs': {
                              'IdentitySelector': {
                                'oneof': [
                                  'person',
                                  'service',
                                  'externalApp',
                                  'cache'
                                ]
                              }
                            },
                            'fields': {
                              'person': {
                                'type': 'Person',
                                'id': 1
                              },
                              'service': {
                                'type': 'Service',
                                'id': 2
                              },
                              'externalApp': {
                                'type': 'ExternalApp',
                                'id': 3
                              },
                              'cache': {
                                'type': 'Cache',
                                'id': 4
                              }
                            }
                          },
                          'Context': {
                            'fields': {
                              'appDefId': {
                                'type': 'google.protobuf.StringValue',
                                'id': 1
                              },
                              'instanceId': {
                                'type': 'google.protobuf.StringValue',
                                'id': 2
                              },
                              'metasiteId': {
                                'type': 'google.protobuf.StringValue',
                                'id': 3
                              },
                              'siteMemberId': {
                                'type': 'google.protobuf.StringValue',
                                'id': 4
                              },
                              'targetAccountId': {
                                'type': 'google.protobuf.StringValue',
                                'id': 5
                              }
                            }
                          },
                          'IdentificationData': {
                            'fields': {
                              'context': {
                                'type': 'Context',
                                'id': 1
                              },
                              'identities': {
                                'rule': 'repeated',
                                'type': 'Identity',
                                'id': 2
                              }
                            }
                          },
                          'IdentityRequest': {
                            'fields': {
                              'sessions': {
                                'keyType': 'string',
                                'type': 'string',
                                'id': 1
                              }
                            }
                          },
                          'IdentityResponse': {
                            'fields': {
                              'identificationData': {
                                'type': 'IdentificationData',
                                'id': 1
                              },
                              'signedToken': {
                                'type': 'string',
                                'id': 2
                              }
                            }
                          },
                          'IdentificationServiceV2': {
                            'methods': {
                              'extractIdentity': {
                                'requestType': 'IdentityRequest',
                                'responseType': 'IdentityResponse',
                                'options': {
                                  '(.wix.api.maturity)': 'IA',
                                  '(.wix.api.exposure)': 'INTERNAL',
                                  '(google.api.http).post': '/v2/identification/extract-identity'
                                },
                                'rawOptions': [
                                  {
                                    'name': '(.wix.api.maturity)',
                                    'value': 'IA'
                                  },
                                  {
                                    'name': '(.wix.api.exposure)',
                                    'value': 'INTERNAL'
                                  },
                                  {
                                    'name': '(google.api.http).post',
                                    'value': '/v2/identification/extract-identity'
                                  }
                                ]
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          },
          'wixpress': {
            'nested': {
              'metasite': {
                'nested': {
                  'reloose': {
                    'nested': {
                      'api': {
                        'nested': {
                          'MetaSiteContext': {
                            'fields': {
                              'metaSiteId': {
                                'type': 'string',
                                'id': 1,
                                'options': {
                                  '(wix.api.format)': 'GUID'
                                }
                              },
                              'published': {
                                'type': 'bool',
                                'id': 2
                              },
                              'apps': {
                                'rule': 'repeated',
                                'type': 'App',
                                'id': 3
                              }
                            }
                          },
                          'App': {
                            'fields': {
                              'appDefId': {
                                'type': 'string',
                                'id': 1,
                                'options': {
                                  '(wix.api.maxLength)': 36
                                }
                              },
                              'instanceId': {
                                'type': 'string',
                                'id': 2,
                                'options': {
                                  '(wix.api.maxLength)': 36
                                }
                              },
                              'state': {
                                'type': 'State',
                                'id': 3,
                                'options': {
                                  '(wix.api.readOnly)': true
                                }
                              },
                              'version': {
                                'type': 'google.protobuf.StringValue',
                                'id': 4
                              }
                            },
                            'nested': {
                              'State': {
                                'values': {
                                  'UNKNOWN': 0,
                                  'ENABLED': 1,
                                  'DISABLED': 2,
                                  'TEMPLATE': 3,
                                  'PENDING': 4
                                }
                              }
                            }
                          },
                          'GetRequest': {
                            'oneofs': {
                              'getBy': {
                                'oneof': [
                                  'metaSiteId',
                                  'app'
                                ]
                              }
                            },
                            'fields': {
                              'metaSiteId': {
                                'type': 'string',
                                'id': 1,
                                'options': {
                                  '(wix.api.format)': 'GUID'
                                }
                              },
                              'app': {
                                'type': 'App',
                                'id': 2
                              }
                            }
                          },
                          'GetResponse': {
                            'fields': {
                              'context': {
                                'type': 'MetaSiteContext',
                                'id': 1
                              }
                            }
                          },
                          'GetByMetaSiteIdBulkRequest': {
                            'fields': {
                              'metaSiteIds': {
                                'rule': 'repeated',
                                'type': 'string',
                                'id': 1,
                                'options': {
                                  '(wix.api.format)': 'GUID',
                                  '(wix.api.minSize)': 1,
                                  '(wix.api.maxSize)': 200
                                }
                              }
                            }
                          },
                          'GetByMetaSiteIdBulkResponse': {
                            'fields': {
                              'contexts': {
                                'rule': 'repeated',
                                'type': 'MetaSiteContext',
                                'id': 1
                              }
                            }
                          },
                          'GetByAppBulkRequest': {
                            'fields': {
                              'appDefId': {
                                'type': 'string',
                                'id': 1,
                                'options': {
                                  '(wix.api.maxLength)': 36
                                }
                              },
                              'instanceIds': {
                                'rule': 'repeated',
                                'type': 'string',
                                'id': 2,
                                'options': {
                                  '(wix.api.minSize)': 1,
                                  '(wix.api.maxSize)': 200
                                }
                              }
                            }
                          },
                          'GetByAppBulkResponse': {
                            'fields': {
                              'contexts': {
                                'rule': 'repeated',
                                'type': 'MetaSiteContext',
                                'id': 1
                              }
                            }
                          },
                          'RelooseApi': {
                            'methods': {
                              'Get': {
                                'requestType': 'GetRequest',
                                'responseType': 'GetResponse',
                                'options': {
                                  '(google.api.http).get': 'v1/meta-site/lookup',
                                  '(wix.api.exposure)': 'INTERNAL',
                                  '(wix.api.maturity)': 'GA',
                                  '(wix.api.required)': 'GetRequest.get_by'
                                },
                                'rawOptions': [
                                  {
                                    'name': '(google.api.http).get',
                                    'value': 'v1/meta-site/lookup'
                                  },
                                  {
                                    'name': '(wix.api.exposure)',
                                    'value': 'INTERNAL'
                                  },
                                  {
                                    'name': '(wix.api.maturity)',
                                    'value': 'GA'
                                  },
                                  {
                                    'name': '(wix.api.required)',
                                    'value': 'GetRequest.get_by'
                                  }
                                ]
                              },
                              'GetByMetaSiteIdBulk': {
                                'requestType': 'GetByMetaSiteIdBulkRequest',
                                'responseType': 'GetByMetaSiteIdBulkResponse',
                                'options': {
                                  '(google.api.http).get': 'v1/meta-site/lookup/bulk-msids',
                                  '(wix.api.exposure)': 'INTERNAL',
                                  '(wix.api.maturity)': 'BETA'
                                },
                                'rawOptions': [
                                  {
                                    'name': '(google.api.http).get',
                                    'value': 'v1/meta-site/lookup/bulk-msids'
                                  },
                                  {
                                    'name': '(wix.api.exposure)',
                                    'value': 'INTERNAL'
                                  },
                                  {
                                    'name': '(wix.api.maturity)',
                                    'value': 'BETA'
                                  }
                                ]
                              },
                              'GetByAppBulk': {
                                'requestType': 'GetByAppBulkRequest',
                                'responseType': 'GetByAppBulkResponse',
                                'options': {
                                  '(google.api.http).get': 'v1/meta-site/lookup/bulk-apps',
                                  '(wix.api.exposure)': 'INTERNAL',
                                  '(wix.api.maturity)': 'BETA'
                                },
                                'rawOptions': [
                                  {
                                    'name': '(google.api.http).get',
                                    'value': 'v1/meta-site/lookup/bulk-apps'
                                  },
                                  {
                                    'name': '(wix.api.exposure)',
                                    'value': 'INTERNAL'
                                  },
                                  {
                                    'name': '(wix.api.maturity)',
                                    'value': 'BETA'
                                  }
                                ]
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  });

  $root.__lookup = function() {
    return path => {
      return root.lookup(path);
    };
  };
  return $root.__lookup();
};
$root.wix = (function() {
  const wix = {};

  wix.comments = (function() {
    const comments = {};

    comments.CommentCreated = (function() {

      class CommentCreated {

        constructor(props) {
          this.containerId = props && props.containerId;
          this.entityId = props && props.entityId;
          this.commentId = props && props.commentId;
          this.comment = props && props.comment;
          this.createdAt = props && props.createdAt;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            const oneOfMutex = {};

            if (msg.containerId != null) {
              if (typeof msg.containerId !== 'string') {
                errors.field('containerId').error('string expected');
              }
            }
            if (msg.entityId != null) {
              if (oneOfMutex['parent']) {
                errors.field('entityId').up().field('parent').error('multiple values');
              } else {
                oneOfMutex['parent'] = true;
                if (typeof msg.entityId !== 'string') {
                  errors.field('entityId').error('string expected');
                }
              }
            }
            if (msg.commentId != null) {
              if (oneOfMutex['parent']) {
                errors.field('commentId').up().field('parent').error('multiple values');
              } else {
                oneOfMutex['parent'] = true;
                if (typeof msg.commentId !== 'string') {
                  errors.field('commentId').error('string expected');
                }
              }
            }
            if (msg.comment != null) {
              $root.wix.comments.CommentEntity.verify(msg.comment, helper, errors.field('comment'));
            }
            if (msg.createdAt != null) {
              $root.google.protobuf.Timestamp.verify(msg.createdAt, helper, errors.field('createdAt'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.containerId != null) {
              json.containerId = obj.containerId;
            }
            if (obj.entityId != null) {
              json.entityId = obj.entityId;
            }
            if (obj.commentId != null) {
              json.commentId = obj.commentId;
            }
            if (obj.comment != null) {
              json.comment = $root.wix.comments.CommentEntity.toJSON(obj.comment, helper);
            }
            if (obj.createdAt != null) {
              json.createdAt = $root.google.protobuf.Timestamp.toJSON(obj.createdAt, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.comments.CommentCreated();

          if (json.containerId != null) {
            result.containerId = json.containerId;
          } else {
            result.containerId = '';
          }
          if (json.entityId != null) {
            result.entityId = json.entityId;
          } else {
            delete result.entityId;
          }
          if (json.commentId != null) {
            result.commentId = json.commentId;
          } else {
            delete result.commentId;
          }
          if (json.comment != null) {
            result.comment = $root.wix.comments.CommentEntity.fromJSON(json.comment, helper);
          } else {
            delete result.comment;
          }
          if (json.createdAt != null) {
            result.createdAt = $root.google.protobuf.Timestamp.fromJSON(json.createdAt, helper);
          } else {
            delete result.createdAt;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.containerId != null) {
              grpc.containerId = obj.containerId;
            }
            if (obj.entityId != null) {
              grpc.entityId = obj.entityId;
            }
            if (obj.commentId != null) {
              grpc.commentId = obj.commentId;
            }
            if (obj.comment != null) {
              grpc.comment = $root.wix.comments.CommentEntity.toGRPC(obj.comment, helper);
            }
            if (obj.createdAt != null) {
              grpc.createdAt = $root.google.protobuf.Timestamp.toGRPC(obj.createdAt, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.comments.CommentCreated();

            if (grpc.containerId != null) {
              result.containerId = grpc.containerId;
            } else {
              result.containerId = '';
            }
            if (grpc.entityId != null) {
              result.entityId = grpc.entityId;
            } else {
              delete result.entityId;
            }
            if (grpc.commentId != null) {
              result.commentId = grpc.commentId;
            } else {
              delete result.commentId;
            }
            if (grpc.comment != null) {
              result.comment = $root.wix.comments.CommentEntity.fromGRPC(grpc.comment, helper);
            } else {
              delete result.comment;
            }
            if (grpc.createdAt != null) {
              result.createdAt = $root.google.protobuf.Timestamp.fromGRPC(grpc.createdAt, helper);
            } else {
              delete result.createdAt;
            }
            return result;
          }
        }

        static describe() {
          return {
            'oneofs': {
              'parent': {
                'oneof': [
                  'entityId',
                  'commentId'
                ]
              }
            },
            'fields': {
              'containerId': {
                'type': 'string',
                'id': 5
              },
              'entityId': {
                'type': 'string',
                'id': 1
              },
              'commentId': {
                'type': 'string',
                'id': 2
              },
              'comment': {
                'type': $root.wix.comments.CommentEntity,
                'id': 3
              },
              'createdAt': {
                'type': $root.google.protobuf.Timestamp,
                'id': 4
              }
            }
          };
        }
      }

      Object.defineProperty(CommentCreated.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.comments.CommentCreated');
        },
        enumerable: false,
        configurable: false
      });
      return CommentCreated;
    }());
    comments.CommentUpdated = (function() {

      class CommentUpdated {

        constructor(props) {
          this.comment = props && props.comment;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.comment != null) {
              $root.wix.comments.CommentEntity.verify(msg.comment, helper, errors.field('comment'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.comment != null) {
              json.comment = $root.wix.comments.CommentEntity.toJSON(obj.comment, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.comments.CommentUpdated();

          if (json.comment != null) {
            result.comment = $root.wix.comments.CommentEntity.fromJSON(json.comment, helper);
          } else {
            delete result.comment;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.comment != null) {
              grpc.comment = $root.wix.comments.CommentEntity.toGRPC(obj.comment, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.comments.CommentUpdated();

            if (grpc.comment != null) {
              result.comment = $root.wix.comments.CommentEntity.fromGRPC(grpc.comment, helper);
            } else {
              delete result.comment;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'comment': {
                'type': $root.wix.comments.CommentEntity,
                'id': 1
              }
            }
          };
        }
      }

      Object.defineProperty(CommentUpdated.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.comments.CommentUpdated');
        },
        enumerable: false,
        configurable: false
      });
      return CommentUpdated;
    }());
    comments.CommentDeleted = (function() {

      class CommentDeleted {

        constructor(props) {}

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (!(typeof msg === 'object' && !Array.isArray(msg) && Object.keys(msg).length === 0)) {
              errors.error('empty object expected');
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.comments.CommentDeleted();

          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.comments.CommentDeleted();

            return result;
          }
        }

        static describe() {
          return {
            'fields': {}
          };
        }
      }

      Object.defineProperty(CommentDeleted.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.comments.CommentDeleted');
        },
        enumerable: false,
        configurable: false
      });
      return CommentDeleted;
    }());
    comments.CommentReported = (function() {

      class CommentReported {

        constructor(props) {
          this.reportType = props && props.reportType;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.reportType != null) {
              $root.wix.comments.ReportType.verify(msg.reportType, helper, errors.field('reportType'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.reportType != null) {
              json.reportType = $root.wix.comments.ReportType[obj.reportType];
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.comments.CommentReported();

          if (json.reportType != null) {
            result.reportType = $root.wix.comments.ReportType[json.reportType];
          } else {
            result.reportType = 'UNWANTED_CONTENT';
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.reportType != null) {
              grpc.reportType = obj.reportType;
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.comments.CommentReported();

            if (grpc.reportType != null) {
              result.reportType = grpc.reportType;
            } else {
              result.reportType = 'UNWANTED_CONTENT';
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'reportType': {
                'type': $root.wix.comments.ReportType,
                'id': 1
              }
            }
          };
        }
      }

      Object.defineProperty(CommentReported.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.comments.CommentReported');
        },
        enumerable: false,
        configurable: false
      });
      return CommentReported;
    }());
    comments.Comment = (function() {

      class Comment {

        constructor(props) {
          this.commentId = props && props.commentId;
          this.entityId = props && props.entityId;
          this.comment = props && props.comment;
          this.reactions = props && props.reactions;
          this.replies = props && props.replies;
          this.createdAt = props && props.createdAt;
          this.updatedAt = props && props.updatedAt;
          this.availableActions = props && props.availableActions;
          this.createdBy = props && props.createdBy;
          this.reported = props && props.reported;
          this.replyTo = props && props.replyTo;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.commentId != null) {
              if (typeof msg.commentId !== 'string') {
                errors.field('commentId').error('string expected');
              }
            }
            if (msg.entityId != null) {
              if (typeof msg.entityId !== 'string') {
                errors.field('entityId').error('string expected');
              }
            }
            if (msg.comment != null) {
              $root.wix.comments.CommentEntity.verify(msg.comment, helper, errors.field('comment'));
            }
            if (msg.reactions != null) {
              $root.wix.comments.Reactions.verify(msg.reactions, helper, errors.field('reactions'));
            }
            if (msg.replies != null) {
              $root.wix.comments.Replies.verify(msg.replies, helper, errors.field('replies'));
            }
            if (msg.createdAt != null) {
              $root.google.protobuf.Timestamp.verify(msg.createdAt, helper, errors.field('createdAt'));
            }
            if (msg.updatedAt != null) {
              $root.google.protobuf.Timestamp.verify(msg.updatedAt, helper, errors.field('updatedAt'));
            }
            if (msg.availableActions != null) {
              const fieldErrors = errors.field('availableActions');

              if (!Array.isArray(msg.availableActions)) {
                fieldErrors.error('array expected');
              } else {
                msg.availableActions.forEach((value, index) => {
                  $root.wix.comments.UserAction.verify(value, helper, fieldErrors.index(index));
                });
              }
            }
            if (msg.createdBy != null) {
              $root.wix.social.SocialIdentity.verify(msg.createdBy, helper, errors.field('createdBy'));
            }
            if (msg.reported != null) {
              $root.wix.comments.Reported.verify(msg.reported, helper, errors.field('reported'));
            }
            if (msg.replyTo != null) {
              $root.wix.comments.ReplyTo.verify(msg.replyTo, helper, errors.field('replyTo'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.commentId != null) {
              json.commentId = obj.commentId;
            }
            if (obj.entityId != null) {
              json.entityId = obj.entityId;
            }
            if (obj.comment != null) {
              json.comment = $root.wix.comments.CommentEntity.toJSON(obj.comment, helper);
            }
            if (obj.reactions != null) {
              json.reactions = $root.wix.comments.Reactions.toJSON(obj.reactions, helper);
            }
            if (obj.replies != null) {
              json.replies = $root.wix.comments.Replies.toJSON(obj.replies, helper);
            }
            if (obj.createdAt != null) {
              json.createdAt = $root.google.protobuf.Timestamp.toJSON(obj.createdAt, helper);
            }
            if (obj.updatedAt != null) {
              json.updatedAt = $root.google.protobuf.Timestamp.toJSON(obj.updatedAt, helper);
            }
            if (obj.availableActions != null) {
              json.availableActions = obj.availableActions.map(e => {
                return $root.wix.comments.UserAction[e];
              });
            }
            if (obj.createdBy != null) {
              json.createdBy = $root.wix.social.SocialIdentity.toJSON(obj.createdBy, helper);
            }
            if (obj.reported != null) {
              json.reported = $root.wix.comments.Reported.toJSON(obj.reported, helper);
            }
            if (obj.replyTo != null) {
              json.replyTo = $root.wix.comments.ReplyTo.toJSON(obj.replyTo, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.comments.Comment();

          if (json.commentId != null) {
            result.commentId = json.commentId;
          } else {
            result.commentId = '';
          }
          if (json.entityId != null) {
            result.entityId = json.entityId;
          } else {
            result.entityId = '';
          }
          if (json.comment != null) {
            result.comment = $root.wix.comments.CommentEntity.fromJSON(json.comment, helper);
          } else {
            delete result.comment;
          }
          if (json.reactions != null) {
            result.reactions = $root.wix.comments.Reactions.fromJSON(json.reactions, helper);
          } else {
            delete result.reactions;
          }
          if (json.replies != null) {
            result.replies = $root.wix.comments.Replies.fromJSON(json.replies, helper);
          } else {
            delete result.replies;
          }
          if (json.createdAt != null) {
            result.createdAt = $root.google.protobuf.Timestamp.fromJSON(json.createdAt, helper);
          } else {
            delete result.createdAt;
          }
          if (json.updatedAt != null) {
            result.updatedAt = $root.google.protobuf.Timestamp.fromJSON(json.updatedAt, helper);
          } else {
            delete result.updatedAt;
          }
          if (json.availableActions != null) {
            result.availableActions = json.availableActions.map(e => {
              return $root.wix.comments.UserAction[e];
            });
          } else {
            result.availableActions = [];
          }
          if (json.createdBy != null) {
            result.createdBy = $root.wix.social.SocialIdentity.fromJSON(json.createdBy, helper);
          } else {
            delete result.createdBy;
          }
          if (json.reported != null) {
            result.reported = $root.wix.comments.Reported.fromJSON(json.reported, helper);
          } else {
            delete result.reported;
          }
          if (json.replyTo != null) {
            result.replyTo = $root.wix.comments.ReplyTo.fromJSON(json.replyTo, helper);
          } else {
            delete result.replyTo;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.commentId != null) {
              grpc.commentId = obj.commentId;
            }
            if (obj.entityId != null) {
              grpc.entityId = obj.entityId;
            }
            if (obj.comment != null) {
              grpc.comment = $root.wix.comments.CommentEntity.toGRPC(obj.comment, helper);
            }
            if (obj.reactions != null) {
              grpc.reactions = $root.wix.comments.Reactions.toGRPC(obj.reactions, helper);
            }
            if (obj.replies != null) {
              grpc.replies = $root.wix.comments.Replies.toGRPC(obj.replies, helper);
            }
            if (obj.createdAt != null) {
              grpc.createdAt = $root.google.protobuf.Timestamp.toGRPC(obj.createdAt, helper);
            }
            if (obj.updatedAt != null) {
              grpc.updatedAt = $root.google.protobuf.Timestamp.toGRPC(obj.updatedAt, helper);
            }
            if (obj.availableActions != null) {
              grpc.availableActions = obj.availableActions.map(e => {
                return e;
              });
            }
            if (obj.createdBy != null) {
              grpc.createdBy = $root.wix.social.SocialIdentity.toGRPC(obj.createdBy, helper);
            }
            if (obj.reported != null) {
              grpc.reported = $root.wix.comments.Reported.toGRPC(obj.reported, helper);
            }
            if (obj.replyTo != null) {
              grpc.replyTo = $root.wix.comments.ReplyTo.toGRPC(obj.replyTo, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.comments.Comment();

            if (grpc.commentId != null) {
              result.commentId = grpc.commentId;
            } else {
              result.commentId = '';
            }
            if (grpc.entityId != null) {
              result.entityId = grpc.entityId;
            } else {
              result.entityId = '';
            }
            if (grpc.comment != null) {
              result.comment = $root.wix.comments.CommentEntity.fromGRPC(grpc.comment, helper);
            } else {
              delete result.comment;
            }
            if (grpc.reactions != null) {
              result.reactions = $root.wix.comments.Reactions.fromGRPC(grpc.reactions, helper);
            } else {
              delete result.reactions;
            }
            if (grpc.replies != null) {
              result.replies = $root.wix.comments.Replies.fromGRPC(grpc.replies, helper);
            } else {
              delete result.replies;
            }
            if (grpc.createdAt != null) {
              result.createdAt = $root.google.protobuf.Timestamp.fromGRPC(grpc.createdAt, helper);
            } else {
              delete result.createdAt;
            }
            if (grpc.updatedAt != null) {
              result.updatedAt = $root.google.protobuf.Timestamp.fromGRPC(grpc.updatedAt, helper);
            } else {
              delete result.updatedAt;
            }
            if (grpc.availableActions != null) {
              result.availableActions = grpc.availableActions.map(e => {
                return e;
              });
            } else {
              result.availableActions = [];
            }
            if (grpc.createdBy != null) {
              result.createdBy = $root.wix.social.SocialIdentity.fromGRPC(grpc.createdBy, helper);
            } else {
              delete result.createdBy;
            }
            if (grpc.reported != null) {
              result.reported = $root.wix.comments.Reported.fromGRPC(grpc.reported, helper);
            } else {
              delete result.reported;
            }
            if (grpc.replyTo != null) {
              result.replyTo = $root.wix.comments.ReplyTo.fromGRPC(grpc.replyTo, helper);
            } else {
              delete result.replyTo;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'commentId': {
                'type': 'string',
                'id': 1,
                'options': {
                  '(wix.api.format)': 'GUID'
                }
              },
              'entityId': {
                'type': 'string',
                'id': 2,
                'options': {
                  '(wix.api.format)': 'GUID'
                }
              },
              'comment': {
                'type': $root.wix.comments.CommentEntity,
                'id': 3
              },
              'reactions': {
                'type': $root.wix.comments.Reactions,
                'id': 4
              },
              'replies': {
                'type': $root.wix.comments.Replies,
                'id': 5
              },
              'createdAt': {
                'type': $root.google.protobuf.Timestamp,
                'id': 6
              },
              'updatedAt': {
                'type': $root.google.protobuf.Timestamp,
                'id': 7
              },
              'availableActions': {
                'rule': 'repeated',
                'type': $root.wix.comments.UserAction,
                'id': 8
              },
              'createdBy': {
                'type': $root.wix.social.SocialIdentity,
                'id': 9
              },
              'reported': {
                'type': $root.wix.comments.Reported,
                'id': 10
              },
              'replyTo': {
                'type': $root.wix.comments.ReplyTo,
                'id': 11
              }
            }
          };
        }
      }

      Object.defineProperty(Comment.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.comments.Comment');
        },
        enumerable: false,
        configurable: false
      });
      return Comment;
    }());
    comments.CommentEntity = (function() {

      class CommentEntity {

        constructor(props) {
          this.text = props && props.text;
          this.mentions = props && props.mentions;
          this.attachments = props && props.attachments;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.text != null) {
              $root.wix.social.Text.verify(msg.text, helper, errors.field('text'));
            }
            if (msg.mentions != null) {
              const fieldErrors = errors.field('mentions');

              if (!Array.isArray(msg.mentions)) {
                fieldErrors.error('array expected');
              } else {
                msg.mentions.forEach((value, index) => {
                  $root.wix.social.Mention.verify(value, helper, fieldErrors.index(index));
                });
              }
            }
            if (msg.attachments != null) {
              const fieldErrors = errors.field('attachments');

              if (!Array.isArray(msg.attachments)) {
                fieldErrors.error('array expected');
              } else {
                msg.attachments.forEach((value, index) => {
                  $root.wix.social.Resource.verify(value, helper, fieldErrors.index(index));
                });
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.text != null) {
              json.text = $root.wix.social.Text.toJSON(obj.text, helper);
            }
            if (obj.mentions != null) {
              json.mentions = obj.mentions.map(e => {
                return $root.wix.social.Mention.toJSON(e, helper);
              });
            }
            if (obj.attachments != null) {
              json.attachments = obj.attachments.map(e => {
                return $root.wix.social.Resource.toJSON(e, helper);
              });
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.comments.CommentEntity();

          if (json.text != null) {
            result.text = $root.wix.social.Text.fromJSON(json.text, helper);
          } else {
            delete result.text;
          }
          if (json.mentions != null) {
            result.mentions = json.mentions.map(e => {
              return $root.wix.social.Mention.fromJSON(e, helper);
            });
          } else {
            result.mentions = [];
          }
          if (json.attachments != null) {
            result.attachments = json.attachments.map(e => {
              return $root.wix.social.Resource.fromJSON(e, helper);
            });
          } else {
            result.attachments = [];
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.text != null) {
              grpc.text = $root.wix.social.Text.toGRPC(obj.text, helper);
            }
            if (obj.mentions != null) {
              grpc.mentions = obj.mentions.map(e => {
                return $root.wix.social.Mention.toGRPC(e, helper);
              });
            }
            if (obj.attachments != null) {
              grpc.attachments = obj.attachments.map(e => {
                return $root.wix.social.Resource.toGRPC(e, helper);
              });
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.comments.CommentEntity();

            if (grpc.text != null) {
              result.text = $root.wix.social.Text.fromGRPC(grpc.text, helper);
            } else {
              delete result.text;
            }
            if (grpc.mentions != null) {
              result.mentions = grpc.mentions.map(e => {
                return $root.wix.social.Mention.fromGRPC(e, helper);
              });
            } else {
              result.mentions = [];
            }
            if (grpc.attachments != null) {
              result.attachments = grpc.attachments.map(e => {
                return $root.wix.social.Resource.fromGRPC(e, helper);
              });
            } else {
              result.attachments = [];
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'text': {
                'type': $root.wix.social.Text,
                'id': 1
              },
              'mentions': {
                'rule': 'repeated',
                'type': $root.wix.social.Mention,
                'id': 2
              },
              'attachments': {
                'rule': 'repeated',
                'type': $root.wix.social.Resource,
                'id': 3
              }
            }
          };
        }
      }

      Object.defineProperty(CommentEntity.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.comments.CommentEntity');
        },
        enumerable: false,
        configurable: false
      });
      return CommentEntity;
    }());
    comments.Reactions = (function() {

      class Reactions {

        constructor(props) {
          this.count = props && props.count;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.count != null) {
              if (!Number.isInteger(msg.count)) {
                errors.field('count').error('integer expected');
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.count != null) {
              json.count = obj.count;
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.comments.Reactions();

          if (json.count != null) {
            result.count = json.count;
          } else {
            result.count = 0;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.count != null) {
              grpc.count = obj.count;
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.comments.Reactions();

            if (grpc.count != null) {
              result.count = grpc.count;
            } else {
              result.count = 0;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'count': {
                'type': 'int32',
                'id': 1
              }
            }
          };
        }
      }

      Object.defineProperty(Reactions.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.comments.Reactions');
        },
        enumerable: false,
        configurable: false
      });
      return Reactions;
    }());
    comments.Replies = (function() {

      class Replies {

        constructor(props) {
          this.count = props && props.count;
          this.comments = props && props.comments;
          this.pageCursor = props && props.pageCursor;
          this.nextCursor = props && props.nextCursor;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.count != null) {
              if (!Number.isInteger(msg.count)) {
                errors.field('count').error('integer expected');
              }
            }
            if (msg.comments != null) {
              const fieldErrors = errors.field('comments');

              if (!Array.isArray(msg.comments)) {
                fieldErrors.error('array expected');
              } else {
                msg.comments.forEach((value, index) => {
                  $root.wix.comments.Comment.verify(value, helper, fieldErrors.index(index));
                });
              }
            }
            if (msg.pageCursor != null) {
              if (typeof msg.pageCursor !== 'string') {
                errors.field('pageCursor').error('string expected');
              }
            }
            if (msg.nextCursor != null) {
              $root.google.protobuf.StringValue.verify(msg.nextCursor, helper, errors.field('nextCursor'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.count != null) {
              json.count = obj.count;
            }
            if (obj.comments != null) {
              json.comments = obj.comments.map(e => {
                return $root.wix.comments.Comment.toJSON(e, helper);
              });
            }
            if (obj.pageCursor != null) {
              json.pageCursor = obj.pageCursor;
            }
            if (obj.nextCursor != null) {
              json.nextCursor = $root.google.protobuf.StringValue.toJSON(obj.nextCursor, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.comments.Replies();

          if (json.count != null) {
            result.count = json.count;
          } else {
            result.count = 0;
          }
          if (json.comments != null) {
            result.comments = json.comments.map(e => {
              return $root.wix.comments.Comment.fromJSON(e, helper);
            });
          } else {
            result.comments = [];
          }
          if (json.pageCursor != null) {
            result.pageCursor = json.pageCursor;
          } else {
            result.pageCursor = '';
          }
          if (json.nextCursor != null) {
            result.nextCursor = $root.google.protobuf.StringValue.fromJSON(json.nextCursor, helper);
          } else {
            delete result.nextCursor;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.count != null) {
              grpc.count = obj.count;
            }
            if (obj.comments != null) {
              grpc.comments = obj.comments.map(e => {
                return $root.wix.comments.Comment.toGRPC(e, helper);
              });
            }
            if (obj.pageCursor != null) {
              grpc.pageCursor = obj.pageCursor;
            }
            if (obj.nextCursor != null) {
              grpc.nextCursor = $root.google.protobuf.StringValue.toGRPC(obj.nextCursor, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.comments.Replies();

            if (grpc.count != null) {
              result.count = grpc.count;
            } else {
              result.count = 0;
            }
            if (grpc.comments != null) {
              result.comments = grpc.comments.map(e => {
                return $root.wix.comments.Comment.fromGRPC(e, helper);
              });
            } else {
              result.comments = [];
            }
            if (grpc.pageCursor != null) {
              result.pageCursor = grpc.pageCursor;
            } else {
              result.pageCursor = '';
            }
            if (grpc.nextCursor != null) {
              result.nextCursor = $root.google.protobuf.StringValue.fromGRPC(grpc.nextCursor, helper);
            } else {
              delete result.nextCursor;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'count': {
                'type': 'int32',
                'id': 1
              },
              'comments': {
                'rule': 'repeated',
                'type': $root.wix.comments.Comment,
                'id': 2
              },
              'pageCursor': {
                'type': 'string',
                'id': 3
              },
              'nextCursor': {
                'type': $root.google.protobuf.StringValue,
                'id': 4
              }
            }
          };
        }
      }

      Object.defineProperty(Replies.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.comments.Replies');
        },
        enumerable: false,
        configurable: false
      });
      return Replies;
    }());
    comments.Reported = (function() {

      class Reported {

        constructor(props) {
          this.count = props && props.count;
          this.reportedTypes = props && props.reportedTypes;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.count != null) {
              $root.google.protobuf.Int32Value.verify(msg.count, helper, errors.field('count'));
            }
            if (msg.reportedTypes != null) {
              const fieldErrors = errors.field('reportedTypes');

              if (!Array.isArray(msg.reportedTypes)) {
                fieldErrors.error('array expected');
              } else {
                msg.reportedTypes.forEach((value, index) => {
                  $root.wix.comments.ReportType.verify(value, helper, fieldErrors.index(index));
                });
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.count != null) {
              json.count = $root.google.protobuf.Int32Value.toJSON(obj.count, helper);
            }
            if (obj.reportedTypes != null) {
              json.reportedTypes = obj.reportedTypes.map(e => {
                return $root.wix.comments.ReportType[e];
              });
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.comments.Reported();

          if (json.count != null) {
            result.count = $root.google.protobuf.Int32Value.fromJSON(json.count, helper);
          } else {
            delete result.count;
          }
          if (json.reportedTypes != null) {
            result.reportedTypes = json.reportedTypes.map(e => {
              return $root.wix.comments.ReportType[e];
            });
          } else {
            result.reportedTypes = [];
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.count != null) {
              grpc.count = $root.google.protobuf.Int32Value.toGRPC(obj.count, helper);
            }
            if (obj.reportedTypes != null) {
              grpc.reportedTypes = obj.reportedTypes.map(e => {
                return e;
              });
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.comments.Reported();

            if (grpc.count != null) {
              result.count = $root.google.protobuf.Int32Value.fromGRPC(grpc.count, helper);
            } else {
              delete result.count;
            }
            if (grpc.reportedTypes != null) {
              result.reportedTypes = grpc.reportedTypes.map(e => {
                return e;
              });
            } else {
              result.reportedTypes = [];
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'count': {
                'type': $root.google.protobuf.Int32Value,
                'id': 1
              },
              'reportedTypes': {
                'rule': 'repeated',
                'type': $root.wix.comments.ReportType,
                'id': 2
              }
            }
          };
        }
      }

      Object.defineProperty(Reported.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.comments.Reported');
        },
        enumerable: false,
        configurable: false
      });
      return Reported;
    }());
    comments.CommentsAccess = (function() {

      class CommentsAccess {

        constructor(props) {
          this.allowedGlobalActions = props && props.allowedGlobalActions;
          this.allowedCommentActions = props && props.allowedCommentActions;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.allowedGlobalActions != null) {
              const fieldErrors = errors.field('allowedGlobalActions');

              if (!Array.isArray(msg.allowedGlobalActions)) {
                fieldErrors.error('array expected');
              } else {
                msg.allowedGlobalActions.forEach((value, index) => {
                  $root.wix.comments.UserAction.verify(value, helper, fieldErrors.index(index));
                });
              }
            }
            if (msg.allowedCommentActions != null) {
              const fieldErrors = errors.field('allowedCommentActions');

              if (!Array.isArray(msg.allowedCommentActions)) {
                fieldErrors.error('array expected');
              } else {
                msg.allowedCommentActions.forEach((value, index) => {
                  $root.wix.comments.UserAction.verify(value, helper, fieldErrors.index(index));
                });
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.allowedGlobalActions != null) {
              json.allowedGlobalActions = obj.allowedGlobalActions.map(e => {
                return $root.wix.comments.UserAction[e];
              });
            }
            if (obj.allowedCommentActions != null) {
              json.allowedCommentActions = obj.allowedCommentActions.map(e => {
                return $root.wix.comments.UserAction[e];
              });
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.comments.CommentsAccess();

          if (json.allowedGlobalActions != null) {
            result.allowedGlobalActions = json.allowedGlobalActions.map(e => {
              return $root.wix.comments.UserAction[e];
            });
          } else {
            result.allowedGlobalActions = [];
          }
          if (json.allowedCommentActions != null) {
            result.allowedCommentActions = json.allowedCommentActions.map(e => {
              return $root.wix.comments.UserAction[e];
            });
          } else {
            result.allowedCommentActions = [];
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.allowedGlobalActions != null) {
              grpc.allowedGlobalActions = obj.allowedGlobalActions.map(e => {
                return e;
              });
            }
            if (obj.allowedCommentActions != null) {
              grpc.allowedCommentActions = obj.allowedCommentActions.map(e => {
                return e;
              });
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.comments.CommentsAccess();

            if (grpc.allowedGlobalActions != null) {
              result.allowedGlobalActions = grpc.allowedGlobalActions.map(e => {
                return e;
              });
            } else {
              result.allowedGlobalActions = [];
            }
            if (grpc.allowedCommentActions != null) {
              result.allowedCommentActions = grpc.allowedCommentActions.map(e => {
                return e;
              });
            } else {
              result.allowedCommentActions = [];
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'allowedGlobalActions': {
                'rule': 'repeated',
                'type': $root.wix.comments.UserAction,
                'id': 1
              },
              'allowedCommentActions': {
                'rule': 'repeated',
                'type': $root.wix.comments.UserAction,
                'id': 2
              }
            }
          };
        }
      }

      Object.defineProperty(CommentsAccess.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.comments.CommentsAccess');
        },
        enumerable: false,
        configurable: false
      });
      return CommentsAccess;
    }());
    comments.ReplyTo = (function() {

      class ReplyTo {

        constructor(props) {
          this.commentId = props && props.commentId;
          this.userId = props && props.userId;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.commentId != null) {
              if (typeof msg.commentId !== 'string') {
                errors.field('commentId').error('string expected');
              }
            }
            if (msg.userId != null) {
              if (typeof msg.userId !== 'string') {
                errors.field('userId').error('string expected');
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.commentId != null) {
              json.commentId = obj.commentId;
            }
            if (obj.userId != null) {
              json.userId = obj.userId;
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.comments.ReplyTo();

          if (json.commentId != null) {
            result.commentId = json.commentId;
          } else {
            result.commentId = '';
          }
          if (json.userId != null) {
            result.userId = json.userId;
          } else {
            result.userId = '';
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.commentId != null) {
              grpc.commentId = obj.commentId;
            }
            if (obj.userId != null) {
              grpc.userId = obj.userId;
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.comments.ReplyTo();

            if (grpc.commentId != null) {
              result.commentId = grpc.commentId;
            } else {
              result.commentId = '';
            }
            if (grpc.userId != null) {
              result.userId = grpc.userId;
            } else {
              result.userId = '';
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'commentId': {
                'type': 'string',
                'id': 1,
                'options': {
                  '(wix.api.format)': 'GUID'
                }
              },
              'userId': {
                'type': 'string',
                'id': 2,
                'options': {
                  '(wix.api.format)': 'GUID'
                }
              }
            }
          };
        }
      }

      Object.defineProperty(ReplyTo.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.comments.ReplyTo');
        },
        enumerable: false,
        configurable: false
      });
      return ReplyTo;
    }());
    comments.PageDirection = {
      verify: (value, helper, errors = helper.verification.Errors.empty()) => {
        switch (value) {
          default: {
            errors.error('enum expected');
          }
          case 'FORWARD':
          case 'BACKWARD':
            break;
        }
        return errors;
      },
      'FORWARD': 'FORWARD',
      'BACKWARD': 'BACKWARD'
    };
    comments.Ordering = {
      verify: (value, helper, errors = helper.verification.Errors.empty()) => {
        switch (value) {
          default: {
            errors.error('enum expected');
          }
          case 'OLDEST_FIRST':
          case 'LATEST_FIRST':
            break;
        }
        return errors;
      },
      'OLDEST_FIRST': 'OLDEST_FIRST',
      'LATEST_FIRST': 'LATEST_FIRST'
    };
    comments.UserAction = {
      verify: (value, helper, errors = helper.verification.Errors.empty()) => {
        switch (value) {
          default: {
            errors.error('enum expected');
          }
          case 'VIEW':
          case 'ADD_COMMENT':
          case 'REACT':
          case 'UNREACT':
          case 'REPORT':
          case 'EDIT':
          case 'DELETE':
            break;
        }
        return errors;
      },
      'VIEW': 'VIEW',
      'ADD_COMMENT': 'ADD_COMMENT',
      'REACT': 'REACT',
      'UNREACT': 'UNREACT',
      'REPORT': 'REPORT',
      'EDIT': 'EDIT',
      'DELETE': 'DELETE'
    };
    comments.ReportType = {
      verify: (value, helper, errors = helper.verification.Errors.empty()) => {
        switch (value) {
          default: {
            errors.error('enum expected');
          }
          case 'UNWANTED_CONTENT':
          case 'HARASSMENT':
          case 'INAPPROPRIATE_CONTENT':
          case 'HATE_SPEECH_OR_GRAPHIC':
          case 'OTHER':
          case 'UnwantedContent':
          case 'Harrasment':
          case 'InappropiateContent':
          case 'HateSpeechOrGraphic':
            break;
        }
        return errors;
      },
      'UNWANTED_CONTENT': 'UNWANTED_CONTENT',
      'HARASSMENT': 'HARASSMENT',
      'INAPPROPRIATE_CONTENT': 'INAPPROPRIATE_CONTENT',
      'HATE_SPEECH_OR_GRAPHIC': 'HATE_SPEECH_OR_GRAPHIC',
      'OTHER': 'OTHER',
      'UnwantedContent': 'UnwantedContent',
      'Harrasment': 'Harrasment',
      'InappropiateContent': 'InappropiateContent',
      'HateSpeechOrGraphic': 'HateSpeechOrGraphic'
    };
    comments.callbacks = (function() {
      const callbacks = {};

      callbacks.CommentCreated = (function() {

        class CommentCreated {

          constructor(props) {
            this.commentId = props && props.commentId;
          }

          static verify(msg, helper, errors = helper.verification.Errors.empty()) {
            if (typeof msg !== 'object' || msg == null) {
              errors.error('object expected');
            } else {
              if (msg.commentId != null) {
                if (typeof msg.commentId !== 'string') {
                  errors.field('commentId').error('string expected');
                }
              }
            }
            return errors;
          }

          static toJSON(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const json = {};

              if (obj.commentId != null) {
                json.commentId = obj.commentId;
              }
              return json;
            }
          }

          static fromJSON(json, helper) {
            const result = new $root.wix.comments.callbacks.CommentCreated();

            if (json.commentId != null) {
              result.commentId = json.commentId;
            } else {
              result.commentId = '';
            }
            return result;
          }

          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};

              if (obj.commentId != null) {
                grpc.commentId = obj.commentId;
              }
              return grpc;
            }
          }

          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.wix.comments.callbacks.CommentCreated();

              if (grpc.commentId != null) {
                result.commentId = grpc.commentId;
              } else {
                result.commentId = '';
              }
              return result;
            }
          }

          static describe() {
            return {
              'fields': {
                'commentId': {
                  'type': 'string',
                  'id': 1,
                  'options': {
                    '(wix.api.format)': 'GUID'
                  }
                }
              }
            };
          }
        }

        Object.defineProperty(CommentCreated.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('wix.comments.callbacks.CommentCreated');
          },
          enumerable: false,
          configurable: false
        });
        return CommentCreated;
      }());
      callbacks.CommentUpdated = (function() {

        class CommentUpdated {

          constructor(props) {
            this.commentId = props && props.commentId;
          }

          static verify(msg, helper, errors = helper.verification.Errors.empty()) {
            if (typeof msg !== 'object' || msg == null) {
              errors.error('object expected');
            } else {
              if (msg.commentId != null) {
                if (typeof msg.commentId !== 'string') {
                  errors.field('commentId').error('string expected');
                }
              }
            }
            return errors;
          }

          static toJSON(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const json = {};

              if (obj.commentId != null) {
                json.commentId = obj.commentId;
              }
              return json;
            }
          }

          static fromJSON(json, helper) {
            const result = new $root.wix.comments.callbacks.CommentUpdated();

            if (json.commentId != null) {
              result.commentId = json.commentId;
            } else {
              result.commentId = '';
            }
            return result;
          }

          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};

              if (obj.commentId != null) {
                grpc.commentId = obj.commentId;
              }
              return grpc;
            }
          }

          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.wix.comments.callbacks.CommentUpdated();

              if (grpc.commentId != null) {
                result.commentId = grpc.commentId;
              } else {
                result.commentId = '';
              }
              return result;
            }
          }

          static describe() {
            return {
              'fields': {
                'commentId': {
                  'type': 'string',
                  'id': 1,
                  'options': {
                    '(wix.api.format)': 'GUID'
                  }
                }
              }
            };
          }
        }

        Object.defineProperty(CommentUpdated.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('wix.comments.callbacks.CommentUpdated');
          },
          enumerable: false,
          configurable: false
        });
        return CommentUpdated;
      }());
      callbacks.CommentDeleted = (function() {

        class CommentDeleted {

          constructor(props) {
            this.commentId = props && props.commentId;
          }

          static verify(msg, helper, errors = helper.verification.Errors.empty()) {
            if (typeof msg !== 'object' || msg == null) {
              errors.error('object expected');
            } else {
              if (msg.commentId != null) {
                if (typeof msg.commentId !== 'string') {
                  errors.field('commentId').error('string expected');
                }
              }
            }
            return errors;
          }

          static toJSON(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const json = {};

              if (obj.commentId != null) {
                json.commentId = obj.commentId;
              }
              return json;
            }
          }

          static fromJSON(json, helper) {
            const result = new $root.wix.comments.callbacks.CommentDeleted();

            if (json.commentId != null) {
              result.commentId = json.commentId;
            } else {
              result.commentId = '';
            }
            return result;
          }

          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};

              if (obj.commentId != null) {
                grpc.commentId = obj.commentId;
              }
              return grpc;
            }
          }

          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.wix.comments.callbacks.CommentDeleted();

              if (grpc.commentId != null) {
                result.commentId = grpc.commentId;
              } else {
                result.commentId = '';
              }
              return result;
            }
          }

          static describe() {
            return {
              'fields': {
                'commentId': {
                  'type': 'string',
                  'id': 1,
                  'options': {
                    '(wix.api.format)': 'GUID'
                  }
                }
              }
            };
          }
        }

        Object.defineProperty(CommentDeleted.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('wix.comments.callbacks.CommentDeleted');
          },
          enumerable: false,
          configurable: false
        });
        return CommentDeleted;
      }());
      callbacks.ReactedOnComment = (function() {

        class ReactedOnComment {

          constructor(props) {
            this.commentId = props && props.commentId;
          }

          static verify(msg, helper, errors = helper.verification.Errors.empty()) {
            if (typeof msg !== 'object' || msg == null) {
              errors.error('object expected');
            } else {
              if (msg.commentId != null) {
                if (typeof msg.commentId !== 'string') {
                  errors.field('commentId').error('string expected');
                }
              }
            }
            return errors;
          }

          static toJSON(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const json = {};

              if (obj.commentId != null) {
                json.commentId = obj.commentId;
              }
              return json;
            }
          }

          static fromJSON(json, helper) {
            const result = new $root.wix.comments.callbacks.ReactedOnComment();

            if (json.commentId != null) {
              result.commentId = json.commentId;
            } else {
              result.commentId = '';
            }
            return result;
          }

          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};

              if (obj.commentId != null) {
                grpc.commentId = obj.commentId;
              }
              return grpc;
            }
          }

          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.wix.comments.callbacks.ReactedOnComment();

              if (grpc.commentId != null) {
                result.commentId = grpc.commentId;
              } else {
                result.commentId = '';
              }
              return result;
            }
          }

          static describe() {
            return {
              'fields': {
                'commentId': {
                  'type': 'string',
                  'id': 1,
                  'options': {
                    '(wix.api.format)': 'GUID'
                  }
                }
              }
            };
          }
        }

        Object.defineProperty(ReactedOnComment.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('wix.comments.callbacks.ReactedOnComment');
          },
          enumerable: false,
          configurable: false
        });
        return ReactedOnComment;
      }());
      callbacks.RemovedReactionOnComment = (function() {

        class RemovedReactionOnComment {

          constructor(props) {
            this.commentId = props && props.commentId;
          }

          static verify(msg, helper, errors = helper.verification.Errors.empty()) {
            if (typeof msg !== 'object' || msg == null) {
              errors.error('object expected');
            } else {
              if (msg.commentId != null) {
                if (typeof msg.commentId !== 'string') {
                  errors.field('commentId').error('string expected');
                }
              }
            }
            return errors;
          }

          static toJSON(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const json = {};

              if (obj.commentId != null) {
                json.commentId = obj.commentId;
              }
              return json;
            }
          }

          static fromJSON(json, helper) {
            const result = new $root.wix.comments.callbacks.RemovedReactionOnComment();

            if (json.commentId != null) {
              result.commentId = json.commentId;
            } else {
              result.commentId = '';
            }
            return result;
          }

          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};

              if (obj.commentId != null) {
                grpc.commentId = obj.commentId;
              }
              return grpc;
            }
          }

          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.wix.comments.callbacks.RemovedReactionOnComment();

              if (grpc.commentId != null) {
                result.commentId = grpc.commentId;
              } else {
                result.commentId = '';
              }
              return result;
            }
          }

          static describe() {
            return {
              'fields': {
                'commentId': {
                  'type': 'string',
                  'id': 1,
                  'options': {
                    '(wix.api.format)': 'GUID'
                  }
                }
              }
            };
          }
        }

        Object.defineProperty(RemovedReactionOnComment.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('wix.comments.callbacks.RemovedReactionOnComment');
          },
          enumerable: false,
          configurable: false
        });
        return RemovedReactionOnComment;
      }());
      callbacks.CommentReported = (function() {

        class CommentReported {

          constructor(props) {
            this.commentId = props && props.commentId;
          }

          static verify(msg, helper, errors = helper.verification.Errors.empty()) {
            if (typeof msg !== 'object' || msg == null) {
              errors.error('object expected');
            } else {
              if (msg.commentId != null) {
                if (typeof msg.commentId !== 'string') {
                  errors.field('commentId').error('string expected');
                }
              }
            }
            return errors;
          }

          static toJSON(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const json = {};

              if (obj.commentId != null) {
                json.commentId = obj.commentId;
              }
              return json;
            }
          }

          static fromJSON(json, helper) {
            const result = new $root.wix.comments.callbacks.CommentReported();

            if (json.commentId != null) {
              result.commentId = json.commentId;
            } else {
              result.commentId = '';
            }
            return result;
          }

          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};

              if (obj.commentId != null) {
                grpc.commentId = obj.commentId;
              }
              return grpc;
            }
          }

          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.wix.comments.callbacks.CommentReported();

              if (grpc.commentId != null) {
                result.commentId = grpc.commentId;
              } else {
                result.commentId = '';
              }
              return result;
            }
          }

          static describe() {
            return {
              'fields': {
                'commentId': {
                  'type': 'string',
                  'id': 1,
                  'options': {
                    '(wix.api.format)': 'GUID'
                  }
                }
              }
            };
          }
        }

        Object.defineProperty(CommentReported.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('wix.comments.callbacks.CommentReported');
          },
          enumerable: false,
          configurable: false
        });
        return CommentReported;
      }());
      return callbacks;
    }());
    comments.CommentsPageCursor = (function() {

      class CommentsPageCursor {

        constructor(props) {
          this.fromEventId = props && props.fromEventId;
          this.remainingCount = props && props.remainingCount;
          this.entityId = props && props.entityId;
          this.flattenToDepth = props && props.flattenToDepth;
          this.backwards = props && props.backwards;
          this.ordering = props && props.ordering;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.fromEventId != null) {
              if (!Number.isInteger(msg.fromEventId) && !Long.isLong(msg.fromEventId)) {
                errors.field('fromEventId').error('long or integer expected');
              }
            }
            if (msg.remainingCount != null) {
              if (!Number.isInteger(msg.remainingCount)) {
                errors.field('remainingCount').error('integer expected');
              }
            }
            if (msg.entityId != null) {
              if (!Buffer.isBuffer(msg.entityId)) {
                errors.field('entityId').error('buffer expected');
              }
            }
            if (msg.flattenToDepth != null) {
              $root.google.protobuf.UInt32Value.verify(msg.flattenToDepth, helper, errors.field('flattenToDepth'));
            }
            if (msg.backwards != null) {
              if (typeof msg.backwards !== 'boolean') {
                errors.field('backwards').error('boolean expected');
              }
            }
            if (msg.ordering != null) {
              $root.wix.comments.Ordering.verify(msg.ordering, helper, errors.field('ordering'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.fromEventId != null) {
              json.fromEventId = obj.fromEventId.toString();
            }
            if (obj.remainingCount != null) {
              json.remainingCount = obj.remainingCount;
            }
            if (obj.entityId != null) {
              json.entityId = obj.entityId.toString('base64');
            }
            if (obj.flattenToDepth != null) {
              json.flattenToDepth = $root.google.protobuf.UInt32Value.toJSON(obj.flattenToDepth, helper);
            }
            if (obj.backwards != null) {
              json.backwards = obj.backwards;
            }
            if (obj.ordering != null) {
              json.ordering = $root.wix.comments.Ordering[obj.ordering];
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.comments.CommentsPageCursor();

          if (json.fromEventId != null) {
            result.fromEventId = Long.fromValue(json.fromEventId);
          } else {
            result.fromEventId = Long.ZERO;
          }
          if (json.remainingCount != null) {
            result.remainingCount = json.remainingCount;
          } else {
            result.remainingCount = 0;
          }
          if (json.entityId != null) {
            result.entityId = function tryParseBytes(val) {
              try {
                return Buffer.from(val, 'base64');
              } catch (e) {
                return val;
              } finally {}
            }(json.entityId);
          } else {
            delete result.entityId;
          }
          if (json.flattenToDepth != null) {
            result.flattenToDepth = $root.google.protobuf.UInt32Value.fromJSON(json.flattenToDepth, helper);
          } else {
            delete result.flattenToDepth;
          }
          if (json.backwards != null) {
            result.backwards = json.backwards;
          } else {
            result.backwards = false;
          }
          if (json.ordering != null) {
            result.ordering = $root.wix.comments.Ordering[json.ordering];
          } else {
            result.ordering = 'OLDEST_FIRST';
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.fromEventId != null) {
              grpc.fromEventId = obj.fromEventId.toString();
            }
            if (obj.remainingCount != null) {
              grpc.remainingCount = obj.remainingCount;
            }
            if (obj.entityId != null) {
              grpc.entityId = obj.entityId;
            }
            if (obj.flattenToDepth != null) {
              grpc.flattenToDepth = $root.google.protobuf.UInt32Value.toGRPC(obj.flattenToDepth, helper);
            }
            if (obj.backwards != null) {
              grpc.backwards = obj.backwards;
            }
            if (obj.ordering != null) {
              grpc.ordering = obj.ordering;
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.comments.CommentsPageCursor();

            if (grpc.fromEventId != null) {
              result.fromEventId = Long.fromValue(grpc.fromEventId);
            } else {
              result.fromEventId = Long.ZERO;
            }
            if (grpc.remainingCount != null) {
              result.remainingCount = grpc.remainingCount;
            } else {
              result.remainingCount = 0;
            }
            if (grpc.entityId != null) {
              result.entityId = grpc.entityId;
            } else {
              delete result.entityId;
            }
            if (grpc.flattenToDepth != null) {
              result.flattenToDepth = $root.google.protobuf.UInt32Value.fromGRPC(grpc.flattenToDepth, helper);
            } else {
              delete result.flattenToDepth;
            }
            if (grpc.backwards != null) {
              result.backwards = grpc.backwards;
            } else {
              result.backwards = false;
            }
            if (grpc.ordering != null) {
              result.ordering = grpc.ordering;
            } else {
              result.ordering = 'OLDEST_FIRST';
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'fromEventId': {
                'type': 'int64',
                'id': 1
              },
              'remainingCount': {
                'type': 'int32',
                'id': 2
              },
              'entityId': {
                'type': 'bytes',
                'id': 3
              },
              'flattenToDepth': {
                'type': $root.google.protobuf.UInt32Value,
                'id': 4
              },
              'backwards': {
                'type': 'bool',
                'id': 5
              },
              'ordering': {
                'type': $root.wix.comments.Ordering,
                'id': 6
              }
            }
          };
        }
      }

      Object.defineProperty(CommentsPageCursor.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.comments.CommentsPageCursor');
        },
        enumerable: false,
        configurable: false
      });
      return CommentsPageCursor;
    }());
    comments.component = (function() {
      const component = {};

      component.CommentsHostedSpi = (function() {

        class CommentsHostedSpi {

          constructor() {
            if (this.constructor.name === CommentsHostedSpi.name) {
              throw new TypeError('class CommentsHostedSpi is abstract');
            }
          }

          authorize(aspects, msg) {
            throw new TypeError('method authorize is abstract');
          }
        }

        CommentsHostedSpi.prototype.authorize._messageTypes = function() {
          return [
            $root.wix.comments.component.AuthorizeRequest,
            $root.wix.comments.component.AuthorizeResponse
          ];
        };
        CommentsHostedSpi.prototype.authorize.__proto = pbjs => {
          return $root.__lookup(pbjs)('wix.comments.component.CommentsHostedSpi.Authorize');
        };
        Object.defineProperty(CommentsHostedSpi.prototype, '__isRpcService__', {
          value: true,
          enumerable: false,
          configurable: false
        });
        Object.defineProperty(CommentsHostedSpi.prototype, '__fqn__', {
          value: 'wix.comments.component.CommentsHostedSpi',
          enumerable: false,
          configurable: false
        });
        Object.defineProperty(CommentsHostedSpi.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('wix.comments.component.CommentsHostedSpi');
          },
          enumerable: false,
          configurable: false
        });
        Object.defineProperty(CommentsHostedSpi.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        return CommentsHostedSpi;
      }());
      component.AuthorizeRequest = (function() {

        class AuthorizeRequest {

          constructor(props) {}

          static verify(msg, helper, errors = helper.verification.Errors.empty()) {
            if (typeof msg !== 'object' || msg == null) {
              errors.error('object expected');
            } else {
              if (!(typeof msg === 'object' && !Array.isArray(msg) && Object.keys(msg).length === 0)) {
                errors.error('empty object expected');
              }
            }
            return errors;
          }

          static toJSON(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const json = {};

              return json;
            }
          }

          static fromJSON(json, helper) {
            const result = new $root.wix.comments.component.AuthorizeRequest();

            return result;
          }

          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};

              return grpc;
            }
          }

          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.wix.comments.component.AuthorizeRequest();

              return result;
            }
          }

          static describe() {
            return {
              'fields': {}
            };
          }
        }

        Object.defineProperty(AuthorizeRequest.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('wix.comments.component.AuthorizeRequest');
          },
          enumerable: false,
          configurable: false
        });
        return AuthorizeRequest;
      }());
      component.AuthorizeResponse = (function() {

        class AuthorizeResponse {

          constructor(props) {}

          static verify(msg, helper, errors = helper.verification.Errors.empty()) {
            if (typeof msg !== 'object' || msg == null) {
              errors.error('object expected');
            } else {
              if (!(typeof msg === 'object' && !Array.isArray(msg) && Object.keys(msg).length === 0)) {
                errors.error('empty object expected');
              }
            }
            return errors;
          }

          static toJSON(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const json = {};

              return json;
            }
          }

          static fromJSON(json, helper) {
            const result = new $root.wix.comments.component.AuthorizeResponse();

            return result;
          }

          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};

              return grpc;
            }
          }

          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.wix.comments.component.AuthorizeResponse();

              return result;
            }
          }

          static describe() {
            return {
              'fields': {}
            };
          }
        }

        Object.defineProperty(AuthorizeResponse.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('wix.comments.component.AuthorizeResponse');
          },
          enumerable: false,
          configurable: false
        });
        return AuthorizeResponse;
      }());
      component.CommentsComponentService = (function() {

        class CommentsComponentService {

          constructor() {
            if (this.constructor.name === CommentsComponentService.name) {
              throw new TypeError('class CommentsComponentService is abstract');
            }
          }

          createComponentContext(aspects, msg) {
            throw new TypeError('method createComponentContext is abstract');
          }

          createComponentContexts(aspects, msg) {
            throw new TypeError('method createComponentContexts is abstract');
          }
        }

        CommentsComponentService.prototype.createComponentContext._messageTypes = function() {
          return [
            $root.wix.comments.component.CreateComponentContextRequest,
            $root.wix.comments.component.CreateComponentContextResponse
          ];
        };
        CommentsComponentService.prototype.createComponentContexts._messageTypes = function() {
          return [
            $root.wix.comments.component.CreateComponentContextRequests,
            $root.wix.comments.component.CreateComponentContextResponses
          ];
        };
        CommentsComponentService.prototype.createComponentContext.__proto = pbjs => {
          return $root.__lookup(pbjs)('wix.comments.component.CommentsComponentService.CreateComponentContext');
        };
        CommentsComponentService.prototype.createComponentContexts.__proto = pbjs => {
          return $root.__lookup(pbjs)('wix.comments.component.CommentsComponentService.CreateComponentContexts');
        };
        Object.defineProperty(CommentsComponentService.prototype, '__isRpcService__', {
          value: true,
          enumerable: false,
          configurable: false
        });
        Object.defineProperty(CommentsComponentService.prototype, '__fqn__', {
          value: 'wix.comments.component.CommentsComponentService',
          enumerable: false,
          configurable: false
        });
        Object.defineProperty(CommentsComponentService.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('wix.comments.component.CommentsComponentService');
          },
          enumerable: false,
          configurable: false
        });
        Object.defineProperty(CommentsComponentService.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        return CommentsComponentService;
      }());
      component.CreateComponentContextRequests = (function() {

        class CreateComponentContextRequests {

          constructor(props) {
            this.requests = props && props.requests;
          }

          static verify(msg, helper, errors = helper.verification.Errors.empty()) {
            if (typeof msg !== 'object' || msg == null) {
              errors.error('object expected');
            } else {
              if (msg.requests != null) {
                const fieldErrors = errors.field('requests');

                if (msg.requests != null && (!(typeof msg.requests === 'object') || Array.isArray(msg.requests))) {
                  fieldErrors.error('object expected');
                } else {
                  for (let key in msg.requests) {
                    const keyErrors = fieldErrors.index(key);
                    $root.wix.comments.component.CreateComponentContextRequest.verify(msg.requests[key], helper, keyErrors.field('value'));
                  }
                }
              }
            }
            return errors;
          }

          static toJSON(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const json = {};

              if (obj.requests != null) {
                json.requests = Object.entries(obj.requests).reduce((acc, [k, v]) => {
                  acc[k] = $root.wix.comments.component.CreateComponentContextRequest.toJSON(v, helper);
                  return acc;
                }, {});
              }
              return json;
            }
          }

          static fromJSON(json, helper) {
            const result = new $root.wix.comments.component.CreateComponentContextRequests();

            if (json.requests != null) {
              result.requests = Object.entries(json.requests).reduce((acc, [k, v]) => {
                acc[k] = $root.wix.comments.component.CreateComponentContextRequest.fromJSON(v, helper);
                return acc;
              }, {});
            } else {
              delete result.requests;
            }
            return result;
          }

          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};

              if (obj.requests != null) {
                grpc.requests = Object.entries(obj.requests).reduce((acc, [k, v]) => {
                  acc[k] = $root.wix.comments.component.CreateComponentContextRequest.toGRPC(v, helper);
                  return acc;
                }, {});
              }
              return grpc;
            }
          }

          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.wix.comments.component.CreateComponentContextRequests();

              if (grpc.requests != null) {
                result.requests = Object.entries(grpc.requests).reduce((acc, [k, v]) => {
                  acc[k] = $root.wix.comments.component.CreateComponentContextRequest.fromGRPC(v, helper);
                  return acc;
                }, {});
              } else {
                delete result.requests;
              }
              return result;
            }
          }

          static describe() {
            return {
              'fields': {
                'requests': {
                  'keyType': 'string',
                  'type': $root.wix.comments.component.CreateComponentContextRequest,
                  'id': 1
                }
              }
            };
          }
        }

        Object.defineProperty(CreateComponentContextRequests.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('wix.comments.component.CreateComponentContextRequests');
          },
          enumerable: false,
          configurable: false
        });
        return CreateComponentContextRequests;
      }());
      component.CreateComponentContextRequest = (function() {

        class CreateComponentContextRequest {

          constructor(props) {
            this.containerId = props && props.containerId;
            this.containerType = props && props.containerType;
            this.permission = props && props.permission;
            this.features = props && props.features;
            this.identity = props && props.identity;
          }

          static verify(msg, helper, errors = helper.verification.Errors.empty()) {
            if (typeof msg !== 'object' || msg == null) {
              errors.error('object expected');
            } else {
              if (msg.containerId != null) {
                $root.google.protobuf.StringValue.verify(msg.containerId, helper, errors.field('containerId'));
              }
              if (msg.containerType != null) {
                $root.google.protobuf.StringValue.verify(msg.containerType, helper, errors.field('containerType'));
              }
              if (msg.permission != null) {
                $root.wix.comments.component.Permission.verify(msg.permission, helper, errors.field('permission'));
              }
              if (msg.features != null) {
                const fieldErrors = errors.field('features');

                if (!Array.isArray(msg.features)) {
                  fieldErrors.error('array expected');
                } else {
                  msg.features.forEach((value, index) => {
                    $root.wix.comments.component.Feature.verify(value, helper, fieldErrors.index(index));
                  });
                }
              }
              if (msg.identity != null) {
                $root.wix.social.SocialIdentity.verify(msg.identity, helper, errors.field('identity'));
              }
            }
            return errors;
          }

          static toJSON(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const json = {};

              if (obj.containerId != null) {
                json.containerId = $root.google.protobuf.StringValue.toJSON(obj.containerId, helper);
              }
              if (obj.containerType != null) {
                json.containerType = $root.google.protobuf.StringValue.toJSON(obj.containerType, helper);
              }
              if (obj.permission != null) {
                json.permission = $root.wix.comments.component.Permission[obj.permission];
              }
              if (obj.features != null) {
                json.features = obj.features.map(e => {
                  return $root.wix.comments.component.Feature[e];
                });
              }
              if (obj.identity != null) {
                json.identity = $root.wix.social.SocialIdentity.toJSON(obj.identity, helper);
              }
              return json;
            }
          }

          static fromJSON(json, helper) {
            const result = new $root.wix.comments.component.CreateComponentContextRequest();

            if (json.containerId != null) {
              result.containerId = $root.google.protobuf.StringValue.fromJSON(json.containerId, helper);
            } else {
              delete result.containerId;
            }
            if (json.containerType != null) {
              result.containerType = $root.google.protobuf.StringValue.fromJSON(json.containerType, helper);
            } else {
              delete result.containerType;
            }
            if (json.permission != null) {
              result.permission = $root.wix.comments.component.Permission[json.permission];
            } else {
              result.permission = 'VIEWER';
            }
            if (json.features != null) {
              result.features = json.features.map(e => {
                return $root.wix.comments.component.Feature[e];
              });
            } else {
              result.features = [];
            }
            if (json.identity != null) {
              result.identity = $root.wix.social.SocialIdentity.fromJSON(json.identity, helper);
            } else {
              delete result.identity;
            }
            return result;
          }

          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};

              if (obj.containerId != null) {
                grpc.containerId = $root.google.protobuf.StringValue.toGRPC(obj.containerId, helper);
              }
              if (obj.containerType != null) {
                grpc.containerType = $root.google.protobuf.StringValue.toGRPC(obj.containerType, helper);
              }
              if (obj.permission != null) {
                grpc.permission = obj.permission;
              }
              if (obj.features != null) {
                grpc.features = obj.features.map(e => {
                  return e;
                });
              }
              if (obj.identity != null) {
                grpc.identity = $root.wix.social.SocialIdentity.toGRPC(obj.identity, helper);
              }
              return grpc;
            }
          }

          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.wix.comments.component.CreateComponentContextRequest();

              if (grpc.containerId != null) {
                result.containerId = $root.google.protobuf.StringValue.fromGRPC(grpc.containerId, helper);
              } else {
                delete result.containerId;
              }
              if (grpc.containerType != null) {
                result.containerType = $root.google.protobuf.StringValue.fromGRPC(grpc.containerType, helper);
              } else {
                delete result.containerType;
              }
              if (grpc.permission != null) {
                result.permission = grpc.permission;
              } else {
                result.permission = 'VIEWER';
              }
              if (grpc.features != null) {
                result.features = grpc.features.map(e => {
                  return e;
                });
              } else {
                result.features = [];
              }
              if (grpc.identity != null) {
                result.identity = $root.wix.social.SocialIdentity.fromGRPC(grpc.identity, helper);
              } else {
                delete result.identity;
              }
              return result;
            }
          }

          static describe() {
            return {
              'fields': {
                'containerId': {
                  'type': $root.google.protobuf.StringValue,
                  'id': 1,
                  'options': {
                    '(wix.api.format)': 'GUID'
                  }
                },
                'containerType': {
                  'type': $root.google.protobuf.StringValue,
                  'id': 2
                },
                'permission': {
                  'type': $root.wix.comments.component.Permission,
                  'id': 3
                },
                'features': {
                  'rule': 'repeated',
                  'type': $root.wix.comments.component.Feature,
                  'id': 4
                },
                'identity': {
                  'type': $root.wix.social.SocialIdentity,
                  'id': 5
                }
              }
            };
          }
        }

        Object.defineProperty(CreateComponentContextRequest.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('wix.comments.component.CreateComponentContextRequest');
          },
          enumerable: false,
          configurable: false
        });
        return CreateComponentContextRequest;
      }());
      component.CreateComponentContextResponse = (function() {

        class CreateComponentContextResponse {

          constructor(props) {
            this.componentContext = props && props.componentContext;
          }

          static verify(msg, helper, errors = helper.verification.Errors.empty()) {
            if (typeof msg !== 'object' || msg == null) {
              errors.error('object expected');
            } else {
              if (msg.componentContext != null) {
                if (typeof msg.componentContext !== 'string') {
                  errors.field('componentContext').error('string expected');
                }
              }
            }
            return errors;
          }

          static toJSON(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const json = {};

              if (obj.componentContext != null) {
                json.componentContext = obj.componentContext;
              }
              return json;
            }
          }

          static fromJSON(json, helper) {
            const result = new $root.wix.comments.component.CreateComponentContextResponse();

            if (json.componentContext != null) {
              result.componentContext = json.componentContext;
            } else {
              result.componentContext = '';
            }
            return result;
          }

          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};

              if (obj.componentContext != null) {
                grpc.componentContext = obj.componentContext;
              }
              return grpc;
            }
          }

          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.wix.comments.component.CreateComponentContextResponse();

              if (grpc.componentContext != null) {
                result.componentContext = grpc.componentContext;
              } else {
                result.componentContext = '';
              }
              return result;
            }
          }

          static describe() {
            return {
              'fields': {
                'componentContext': {
                  'type': 'string',
                  'id': 1
                }
              }
            };
          }
        }

        Object.defineProperty(CreateComponentContextResponse.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('wix.comments.component.CreateComponentContextResponse');
          },
          enumerable: false,
          configurable: false
        });
        return CreateComponentContextResponse;
      }());
      component.CreateComponentContextResponses = (function() {

        class CreateComponentContextResponses {

          constructor(props) {
            this.componentContexts = props && props.componentContexts;
          }

          static verify(msg, helper, errors = helper.verification.Errors.empty()) {
            if (typeof msg !== 'object' || msg == null) {
              errors.error('object expected');
            } else {
              if (msg.componentContexts != null) {
                const fieldErrors = errors.field('componentContexts');

                if (msg.componentContexts != null && (!(typeof msg.componentContexts === 'object') || Array.isArray(msg.componentContexts))) {
                  fieldErrors.error('object expected');
                } else {
                  for (let key in msg.componentContexts) {
                    const keyErrors = fieldErrors.index(key);
                    if (typeof msg.componentContexts[key] !== 'string') {
                      keyErrors.field('value').error('string expected');
                    }
                  }
                }
              }
            }
            return errors;
          }

          static toJSON(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const json = {};

              if (obj.componentContexts != null) {
                json.componentContexts = Object.entries(obj.componentContexts).reduce((acc, [k, v]) => {
                  acc[k] = v;
                  return acc;
                }, {});
              }
              return json;
            }
          }

          static fromJSON(json, helper) {
            const result = new $root.wix.comments.component.CreateComponentContextResponses();

            if (json.componentContexts != null) {
              result.componentContexts = Object.entries(json.componentContexts).reduce((acc, [k, v]) => {
                acc[k] = v;
                return acc;
              }, {});
            } else {
              delete result.componentContexts;
            }
            return result;
          }

          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};

              if (obj.componentContexts != null) {
                grpc.componentContexts = Object.entries(obj.componentContexts).reduce((acc, [k, v]) => {
                  acc[k] = v;
                  return acc;
                }, {});
              }
              return grpc;
            }
          }

          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.wix.comments.component.CreateComponentContextResponses();

              if (grpc.componentContexts != null) {
                result.componentContexts = Object.entries(grpc.componentContexts).reduce((acc, [k, v]) => {
                  acc[k] = v;
                  return acc;
                }, {});
              } else {
                delete result.componentContexts;
              }
              return result;
            }
          }

          static describe() {
            return {
              'fields': {
                'componentContexts': {
                  'keyType': 'string',
                  'type': 'string',
                  'id': 1
                }
              }
            };
          }
        }

        Object.defineProperty(CreateComponentContextResponses.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('wix.comments.component.CreateComponentContextResponses');
          },
          enumerable: false,
          configurable: false
        });
        return CreateComponentContextResponses;
      }());
      component.ComponentContextEntry = (function() {

        class ComponentContextEntry {

          constructor(props) {
            this.requestId = props && props.requestId;
            this.componentContext = props && props.componentContext;
          }

          static verify(msg, helper, errors = helper.verification.Errors.empty()) {
            if (typeof msg !== 'object' || msg == null) {
              errors.error('object expected');
            } else {
              if (msg.requestId != null) {
                if (typeof msg.requestId !== 'string') {
                  errors.field('requestId').error('string expected');
                }
              }
              if (msg.componentContext != null) {
                if (typeof msg.componentContext !== 'string') {
                  errors.field('componentContext').error('string expected');
                }
              }
            }
            return errors;
          }

          static toJSON(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const json = {};

              if (obj.requestId != null) {
                json.requestId = obj.requestId;
              }
              if (obj.componentContext != null) {
                json.componentContext = obj.componentContext;
              }
              return json;
            }
          }

          static fromJSON(json, helper) {
            const result = new $root.wix.comments.component.ComponentContextEntry();

            if (json.requestId != null) {
              result.requestId = json.requestId;
            } else {
              result.requestId = '';
            }
            if (json.componentContext != null) {
              result.componentContext = json.componentContext;
            } else {
              result.componentContext = '';
            }
            return result;
          }

          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};

              if (obj.requestId != null) {
                grpc.requestId = obj.requestId;
              }
              if (obj.componentContext != null) {
                grpc.componentContext = obj.componentContext;
              }
              return grpc;
            }
          }

          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.wix.comments.component.ComponentContextEntry();

              if (grpc.requestId != null) {
                result.requestId = grpc.requestId;
              } else {
                result.requestId = '';
              }
              if (grpc.componentContext != null) {
                result.componentContext = grpc.componentContext;
              } else {
                result.componentContext = '';
              }
              return result;
            }
          }

          static describe() {
            return {
              'fields': {
                'requestId': {
                  'type': 'string',
                  'id': 1
                },
                'componentContext': {
                  'type': 'string',
                  'id': 2
                }
              }
            };
          }
        }

        Object.defineProperty(ComponentContextEntry.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('wix.comments.component.ComponentContextEntry');
          },
          enumerable: false,
          configurable: false
        });
        return ComponentContextEntry;
      }());
      component.Permission = {
        verify: (value, helper, errors = helper.verification.Errors.empty()) => {
          switch (value) {
            default: {
              errors.error('enum expected');
            }
            case 'VIEWER':
            case 'WRITER':
            case 'ADMIN':
              break;
          }
          return errors;
        },
        'VIEWER': 'VIEWER',
        'WRITER': 'WRITER',
        'ADMIN': 'ADMIN'
      };
      component.Feature = {
        verify: (value, helper, errors = helper.verification.Errors.empty()) => {
          switch (value) {
            default: {
              errors.error('enum expected');
            }
            case 'ALL':
            case 'REPLIES':
            case 'REACTIONS':
              break;
          }
          return errors;
        },
        'ALL': 'ALL',
        'REPLIES': 'REPLIES',
        'REACTIONS': 'REACTIONS'
      };
      return component;
    }());
    comments.CommentsService = (function() {

      class CommentsService {

        constructor() {
          if (this.constructor.name === CommentsService.name) {
            throw new TypeError('class CommentsService is abstract');
          }
        }

        get(aspects, msg) {
          throw new TypeError('method get is abstract');
        }

        list(aspects, msg) {
          throw new TypeError('method list is abstract');
        }

        getPagingContexts(aspects, msg) {
          throw new TypeError('method getPagingContexts is abstract');
        }

        create(aspects, msg) {
          throw new TypeError('method create is abstract');
        }

        createReply(aspects, msg) {
          throw new TypeError('method createReply is abstract');
        }

        update(aspects, msg) {
          throw new TypeError('method update is abstract');
        }

        delete(aspects, msg) {
          throw new TypeError('method delete is abstract');
        }

        addReaction(aspects, msg) {
          throw new TypeError('method addReaction is abstract');
        }

        removeReaction(aspects, msg) {
          throw new TypeError('method removeReaction is abstract');
        }

        report(aspects, msg) {
          throw new TypeError('method report is abstract');
        }

        getReports(aspects, msg) {
          throw new TypeError('method getReports is abstract');
        }
      }

      CommentsService.prototype.get._messageTypes = function() {
        return [
          $root.wix.comments.GetCommentRequest,
          $root.wix.comments.GetCommentResponse
        ];
      };
      CommentsService.prototype.list._messageTypes = function() {
        return [
          $root.wix.comments.GetListRequest,
          $root.wix.comments.GetListResponse
        ];
      };
      CommentsService.prototype.getPagingContexts._messageTypes = function() {
        return [
          $root.wix.comments.GetPagingContextsRequest,
          $root.wix.comments.GetPagingContextsResponse
        ];
      };
      CommentsService.prototype.create._messageTypes = function() {
        return [
          $root.wix.comments.CreateCommentRequest,
          $root.wix.comments.CreateCommentResponse
        ];
      };
      CommentsService.prototype.createReply._messageTypes = function() {
        return [
          $root.wix.comments.CreateReplyRequest,
          $root.wix.comments.CreateReplyResponse
        ];
      };
      CommentsService.prototype.update._messageTypes = function() {
        return [
          $root.wix.comments.UpdateCommentRequest,
          $root.wix.comments.UpdateCommentResponse
        ];
      };
      CommentsService.prototype.delete._messageTypes = function() {
        return [
          $root.wix.comments.DeleteCommentRequest,
          $root.wix.comments.DeleteCommentResponse
        ];
      };
      CommentsService.prototype.addReaction._messageTypes = function() {
        return [
          $root.wix.comments.AddReactionRequest,
          $root.wix.comments.AddReactionResponse
        ];
      };
      CommentsService.prototype.removeReaction._messageTypes = function() {
        return [
          $root.wix.comments.RemoveReactionRequest,
          $root.wix.comments.RemoveReactionResponse
        ];
      };
      CommentsService.prototype.report._messageTypes = function() {
        return [
          $root.wix.comments.ReportRequest,
          $root.wix.comments.ReportResponse
        ];
      };
      CommentsService.prototype.getReports._messageTypes = function() {
        return [
          $root.wix.comments.GetReportsRequest,
          $root.wix.comments.GetReportsResponse
        ];
      };
      CommentsService.prototype.get.__proto = pbjs => {
        return $root.__lookup(pbjs)('wix.comments.CommentsService.Get');
      };
      CommentsService.prototype.list.__proto = pbjs => {
        return $root.__lookup(pbjs)('wix.comments.CommentsService.List');
      };
      CommentsService.prototype.getPagingContexts.__proto = pbjs => {
        return $root.__lookup(pbjs)('wix.comments.CommentsService.GetPagingContexts');
      };
      CommentsService.prototype.create.__proto = pbjs => {
        return $root.__lookup(pbjs)('wix.comments.CommentsService.Create');
      };
      CommentsService.prototype.createReply.__proto = pbjs => {
        return $root.__lookup(pbjs)('wix.comments.CommentsService.CreateReply');
      };
      CommentsService.prototype.update.__proto = pbjs => {
        return $root.__lookup(pbjs)('wix.comments.CommentsService.Update');
      };
      CommentsService.prototype.delete.__proto = pbjs => {
        return $root.__lookup(pbjs)('wix.comments.CommentsService.Delete');
      };
      CommentsService.prototype.addReaction.__proto = pbjs => {
        return $root.__lookup(pbjs)('wix.comments.CommentsService.AddReaction');
      };
      CommentsService.prototype.removeReaction.__proto = pbjs => {
        return $root.__lookup(pbjs)('wix.comments.CommentsService.RemoveReaction');
      };
      CommentsService.prototype.report.__proto = pbjs => {
        return $root.__lookup(pbjs)('wix.comments.CommentsService.Report');
      };
      CommentsService.prototype.getReports.__proto = pbjs => {
        return $root.__lookup(pbjs)('wix.comments.CommentsService.GetReports');
      };
      Object.defineProperty(CommentsService.prototype, '__isRpcService__', {
        value: true,
        enumerable: false,
        configurable: false
      });
      Object.defineProperty(CommentsService.prototype, '__fqn__', {
        value: 'wix.comments.CommentsService',
        enumerable: false,
        configurable: false
      });
      Object.defineProperty(CommentsService.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.comments.CommentsService');
        },
        enumerable: false,
        configurable: false
      });
      Object.defineProperty(CommentsService.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      return CommentsService;
    }());
    comments.GetCommentRequest = (function() {

      class GetCommentRequest {

        constructor(props) {
          this.contextToken = props && props.contextToken;
          this.commentId = props && props.commentId;
          this.repliesRequest = props && props.repliesRequest;
          this.fieldset = props && props.fieldset;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.contextToken != null) {
              $root.google.protobuf.StringValue.verify(msg.contextToken, helper, errors.field('contextToken'));
            }
            if (msg.commentId != null) {
              if (typeof msg.commentId !== 'string') {
                errors.field('commentId').error('string expected');
              }
            }
            if (msg.repliesRequest != null) {
              $root.wix.comments.RepliesRequest.verify(msg.repliesRequest, helper, errors.field('repliesRequest'));
            }
            if (msg.fieldset != null) {
              $root.google.protobuf.StringValue.verify(msg.fieldset, helper, errors.field('fieldset'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.contextToken != null) {
              json.contextToken = $root.google.protobuf.StringValue.toJSON(obj.contextToken, helper);
            }
            if (obj.commentId != null) {
              json.commentId = obj.commentId;
            }
            if (obj.repliesRequest != null) {
              json.repliesRequest = $root.wix.comments.RepliesRequest.toJSON(obj.repliesRequest, helper);
            }
            if (obj.fieldset != null) {
              json.fieldset = $root.google.protobuf.StringValue.toJSON(obj.fieldset, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.comments.GetCommentRequest();

          if (json.contextToken != null) {
            result.contextToken = $root.google.protobuf.StringValue.fromJSON(json.contextToken, helper);
          } else {
            delete result.contextToken;
          }
          if (json.commentId != null) {
            result.commentId = json.commentId;
          } else {
            result.commentId = '';
          }
          if (json.repliesRequest != null) {
            result.repliesRequest = $root.wix.comments.RepliesRequest.fromJSON(json.repliesRequest, helper);
          } else {
            delete result.repliesRequest;
          }
          if (json.fieldset != null) {
            result.fieldset = $root.google.protobuf.StringValue.fromJSON(json.fieldset, helper);
          } else {
            delete result.fieldset;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.contextToken != null) {
              grpc.contextToken = $root.google.protobuf.StringValue.toGRPC(obj.contextToken, helper);
            }
            if (obj.commentId != null) {
              grpc.commentId = obj.commentId;
            }
            if (obj.repliesRequest != null) {
              grpc.repliesRequest = $root.wix.comments.RepliesRequest.toGRPC(obj.repliesRequest, helper);
            }
            if (obj.fieldset != null) {
              grpc.fieldset = $root.google.protobuf.StringValue.toGRPC(obj.fieldset, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.comments.GetCommentRequest();

            if (grpc.contextToken != null) {
              result.contextToken = $root.google.protobuf.StringValue.fromGRPC(grpc.contextToken, helper);
            } else {
              delete result.contextToken;
            }
            if (grpc.commentId != null) {
              result.commentId = grpc.commentId;
            } else {
              result.commentId = '';
            }
            if (grpc.repliesRequest != null) {
              result.repliesRequest = $root.wix.comments.RepliesRequest.fromGRPC(grpc.repliesRequest, helper);
            } else {
              delete result.repliesRequest;
            }
            if (grpc.fieldset != null) {
              result.fieldset = $root.google.protobuf.StringValue.fromGRPC(grpc.fieldset, helper);
            } else {
              delete result.fieldset;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'contextToken': {
                'type': $root.google.protobuf.StringValue,
                'id': 1
              },
              'commentId': {
                'type': 'string',
                'id': 2,
                'options': {
                  '(wix.api.format)': 'GUID'
                }
              },
              'repliesRequest': {
                'type': $root.wix.comments.RepliesRequest,
                'id': 3
              },
              'fieldset': {
                'type': $root.google.protobuf.StringValue,
                'id': 4
              }
            }
          };
        }
      }

      Object.defineProperty(GetCommentRequest.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.comments.GetCommentRequest');
        },
        enumerable: false,
        configurable: false
      });
      return GetCommentRequest;
    }());
    comments.GetCommentResponse = (function() {

      class GetCommentResponse {

        constructor(props) {
          this.comment = props && props.comment;
          this.profiles = props && props.profiles;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.comment != null) {
              $root.wix.comments.Comment.verify(msg.comment, helper, errors.field('comment'));
            }
            if (msg.profiles != null) {
              $root.wix.social.Profiles.verify(msg.profiles, helper, errors.field('profiles'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.comment != null) {
              json.comment = $root.wix.comments.Comment.toJSON(obj.comment, helper);
            }
            if (obj.profiles != null) {
              json.profiles = $root.wix.social.Profiles.toJSON(obj.profiles, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.comments.GetCommentResponse();

          if (json.comment != null) {
            result.comment = $root.wix.comments.Comment.fromJSON(json.comment, helper);
          } else {
            delete result.comment;
          }
          if (json.profiles != null) {
            result.profiles = $root.wix.social.Profiles.fromJSON(json.profiles, helper);
          } else {
            delete result.profiles;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.comment != null) {
              grpc.comment = $root.wix.comments.Comment.toGRPC(obj.comment, helper);
            }
            if (obj.profiles != null) {
              grpc.profiles = $root.wix.social.Profiles.toGRPC(obj.profiles, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.comments.GetCommentResponse();

            if (grpc.comment != null) {
              result.comment = $root.wix.comments.Comment.fromGRPC(grpc.comment, helper);
            } else {
              delete result.comment;
            }
            if (grpc.profiles != null) {
              result.profiles = $root.wix.social.Profiles.fromGRPC(grpc.profiles, helper);
            } else {
              delete result.profiles;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'comment': {
                'type': $root.wix.comments.Comment,
                'id': 1
              },
              'profiles': {
                'type': $root.wix.social.Profiles,
                'id': 2
              }
            }
          };
        }
      }

      Object.defineProperty(GetCommentResponse.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.comments.GetCommentResponse');
        },
        enumerable: false,
        configurable: false
      });
      return GetCommentResponse;
    }());
    comments.CreateCommentResponse = (function() {

      class CreateCommentResponse {

        constructor(props) {
          this.comment = props && props.comment;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.comment != null) {
              $root.wix.comments.Comment.verify(msg.comment, helper, errors.field('comment'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.comment != null) {
              json.comment = $root.wix.comments.Comment.toJSON(obj.comment, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.comments.CreateCommentResponse();

          if (json.comment != null) {
            result.comment = $root.wix.comments.Comment.fromJSON(json.comment, helper);
          } else {
            delete result.comment;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.comment != null) {
              grpc.comment = $root.wix.comments.Comment.toGRPC(obj.comment, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.comments.CreateCommentResponse();

            if (grpc.comment != null) {
              result.comment = $root.wix.comments.Comment.fromGRPC(grpc.comment, helper);
            } else {
              delete result.comment;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'comment': {
                'type': $root.wix.comments.Comment,
                'id': 1
              }
            }
          };
        }
      }

      Object.defineProperty(CreateCommentResponse.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.comments.CreateCommentResponse');
        },
        enumerable: false,
        configurable: false
      });
      return CreateCommentResponse;
    }());
    comments.CreateReplyResponse = (function() {

      class CreateReplyResponse {

        constructor(props) {
          this.comment = props && props.comment;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.comment != null) {
              $root.wix.comments.Comment.verify(msg.comment, helper, errors.field('comment'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.comment != null) {
              json.comment = $root.wix.comments.Comment.toJSON(obj.comment, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.comments.CreateReplyResponse();

          if (json.comment != null) {
            result.comment = $root.wix.comments.Comment.fromJSON(json.comment, helper);
          } else {
            delete result.comment;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.comment != null) {
              grpc.comment = $root.wix.comments.Comment.toGRPC(obj.comment, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.comments.CreateReplyResponse();

            if (grpc.comment != null) {
              result.comment = $root.wix.comments.Comment.fromGRPC(grpc.comment, helper);
            } else {
              delete result.comment;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'comment': {
                'type': $root.wix.comments.Comment,
                'id': 1
              }
            }
          };
        }
      }

      Object.defineProperty(CreateReplyResponse.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.comments.CreateReplyResponse');
        },
        enumerable: false,
        configurable: false
      });
      return CreateReplyResponse;
    }());
    comments.UpdateCommentResponse = (function() {

      class UpdateCommentResponse {

        constructor(props) {
          this.comment = props && props.comment;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.comment != null) {
              $root.wix.comments.Comment.verify(msg.comment, helper, errors.field('comment'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.comment != null) {
              json.comment = $root.wix.comments.Comment.toJSON(obj.comment, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.comments.UpdateCommentResponse();

          if (json.comment != null) {
            result.comment = $root.wix.comments.Comment.fromJSON(json.comment, helper);
          } else {
            delete result.comment;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.comment != null) {
              grpc.comment = $root.wix.comments.Comment.toGRPC(obj.comment, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.comments.UpdateCommentResponse();

            if (grpc.comment != null) {
              result.comment = $root.wix.comments.Comment.fromGRPC(grpc.comment, helper);
            } else {
              delete result.comment;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'comment': {
                'type': $root.wix.comments.Comment,
                'id': 1
              }
            }
          };
        }
      }

      Object.defineProperty(UpdateCommentResponse.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.comments.UpdateCommentResponse');
        },
        enumerable: false,
        configurable: false
      });
      return UpdateCommentResponse;
    }());
    comments.AddReactionResponse = (function() {

      class AddReactionResponse {

        constructor(props) {
          this.comment = props && props.comment;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.comment != null) {
              $root.wix.comments.Comment.verify(msg.comment, helper, errors.field('comment'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.comment != null) {
              json.comment = $root.wix.comments.Comment.toJSON(obj.comment, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.comments.AddReactionResponse();

          if (json.comment != null) {
            result.comment = $root.wix.comments.Comment.fromJSON(json.comment, helper);
          } else {
            delete result.comment;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.comment != null) {
              grpc.comment = $root.wix.comments.Comment.toGRPC(obj.comment, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.comments.AddReactionResponse();

            if (grpc.comment != null) {
              result.comment = $root.wix.comments.Comment.fromGRPC(grpc.comment, helper);
            } else {
              delete result.comment;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'comment': {
                'type': $root.wix.comments.Comment,
                'id': 1
              }
            }
          };
        }
      }

      Object.defineProperty(AddReactionResponse.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.comments.AddReactionResponse');
        },
        enumerable: false,
        configurable: false
      });
      return AddReactionResponse;
    }());
    comments.RemoveReactionResponse = (function() {

      class RemoveReactionResponse {

        constructor(props) {
          this.comment = props && props.comment;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.comment != null) {
              $root.wix.comments.Comment.verify(msg.comment, helper, errors.field('comment'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.comment != null) {
              json.comment = $root.wix.comments.Comment.toJSON(obj.comment, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.comments.RemoveReactionResponse();

          if (json.comment != null) {
            result.comment = $root.wix.comments.Comment.fromJSON(json.comment, helper);
          } else {
            delete result.comment;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.comment != null) {
              grpc.comment = $root.wix.comments.Comment.toGRPC(obj.comment, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.comments.RemoveReactionResponse();

            if (grpc.comment != null) {
              result.comment = $root.wix.comments.Comment.fromGRPC(grpc.comment, helper);
            } else {
              delete result.comment;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'comment': {
                'type': $root.wix.comments.Comment,
                'id': 1
              }
            }
          };
        }
      }

      Object.defineProperty(RemoveReactionResponse.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.comments.RemoveReactionResponse');
        },
        enumerable: false,
        configurable: false
      });
      return RemoveReactionResponse;
    }());
    comments.CreateCommentRequest = (function() {

      class CreateCommentRequest {

        constructor(props) {
          this.contextToken = props && props.contextToken;
          this.comment = props && props.comment;
          this.predefinedCommentId = props && props.predefinedCommentId;
          this.entityId = props && props.entityId;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.contextToken != null) {
              $root.google.protobuf.StringValue.verify(msg.contextToken, helper, errors.field('contextToken'));
            }
            if (msg.comment != null) {
              $root.wix.comments.CommentEntity.verify(msg.comment, helper, errors.field('comment'));
            }
            if (msg.predefinedCommentId != null) {
              $root.google.protobuf.StringValue.verify(msg.predefinedCommentId, helper, errors.field('predefinedCommentId'));
            }
            if (msg.entityId != null) {
              $root.google.protobuf.StringValue.verify(msg.entityId, helper, errors.field('entityId'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.contextToken != null) {
              json.contextToken = $root.google.protobuf.StringValue.toJSON(obj.contextToken, helper);
            }
            if (obj.comment != null) {
              json.comment = $root.wix.comments.CommentEntity.toJSON(obj.comment, helper);
            }
            if (obj.predefinedCommentId != null) {
              json.predefinedCommentId = $root.google.protobuf.StringValue.toJSON(obj.predefinedCommentId, helper);
            }
            if (obj.entityId != null) {
              json.entityId = $root.google.protobuf.StringValue.toJSON(obj.entityId, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.comments.CreateCommentRequest();

          if (json.contextToken != null) {
            result.contextToken = $root.google.protobuf.StringValue.fromJSON(json.contextToken, helper);
          } else {
            delete result.contextToken;
          }
          if (json.comment != null) {
            result.comment = $root.wix.comments.CommentEntity.fromJSON(json.comment, helper);
          } else {
            delete result.comment;
          }
          if (json.predefinedCommentId != null) {
            result.predefinedCommentId = $root.google.protobuf.StringValue.fromJSON(json.predefinedCommentId, helper);
          } else {
            delete result.predefinedCommentId;
          }
          if (json.entityId != null) {
            result.entityId = $root.google.protobuf.StringValue.fromJSON(json.entityId, helper);
          } else {
            delete result.entityId;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.contextToken != null) {
              grpc.contextToken = $root.google.protobuf.StringValue.toGRPC(obj.contextToken, helper);
            }
            if (obj.comment != null) {
              grpc.comment = $root.wix.comments.CommentEntity.toGRPC(obj.comment, helper);
            }
            if (obj.predefinedCommentId != null) {
              grpc.predefinedCommentId = $root.google.protobuf.StringValue.toGRPC(obj.predefinedCommentId, helper);
            }
            if (obj.entityId != null) {
              grpc.entityId = $root.google.protobuf.StringValue.toGRPC(obj.entityId, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.comments.CreateCommentRequest();

            if (grpc.contextToken != null) {
              result.contextToken = $root.google.protobuf.StringValue.fromGRPC(grpc.contextToken, helper);
            } else {
              delete result.contextToken;
            }
            if (grpc.comment != null) {
              result.comment = $root.wix.comments.CommentEntity.fromGRPC(grpc.comment, helper);
            } else {
              delete result.comment;
            }
            if (grpc.predefinedCommentId != null) {
              result.predefinedCommentId = $root.google.protobuf.StringValue.fromGRPC(grpc.predefinedCommentId, helper);
            } else {
              delete result.predefinedCommentId;
            }
            if (grpc.entityId != null) {
              result.entityId = $root.google.protobuf.StringValue.fromGRPC(grpc.entityId, helper);
            } else {
              delete result.entityId;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'contextToken': {
                'type': $root.google.protobuf.StringValue,
                'id': 1
              },
              'comment': {
                'type': $root.wix.comments.CommentEntity,
                'id': 2
              },
              'predefinedCommentId': {
                'type': $root.google.protobuf.StringValue,
                'id': 3,
                'options': {
                  '(wix.api.format)': 'GUID'
                }
              },
              'entityId': {
                'type': $root.google.protobuf.StringValue,
                'id': 4,
                'options': {
                  '(wix.api.format)': 'GUID'
                }
              }
            }
          };
        }
      }

      Object.defineProperty(CreateCommentRequest.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.comments.CreateCommentRequest');
        },
        enumerable: false,
        configurable: false
      });
      return CreateCommentRequest;
    }());
    comments.CreateReplyRequest = (function() {

      class CreateReplyRequest {

        constructor(props) {
          this.contextToken = props && props.contextToken;
          this.parentCommentId = props && props.parentCommentId;
          this.reply = props && props.reply;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.contextToken != null) {
              $root.google.protobuf.StringValue.verify(msg.contextToken, helper, errors.field('contextToken'));
            }
            if (msg.parentCommentId != null) {
              if (typeof msg.parentCommentId !== 'string') {
                errors.field('parentCommentId').error('string expected');
              }
            }
            if (msg.reply != null) {
              $root.wix.comments.CommentEntity.verify(msg.reply, helper, errors.field('reply'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.contextToken != null) {
              json.contextToken = $root.google.protobuf.StringValue.toJSON(obj.contextToken, helper);
            }
            if (obj.parentCommentId != null) {
              json.parentCommentId = obj.parentCommentId;
            }
            if (obj.reply != null) {
              json.reply = $root.wix.comments.CommentEntity.toJSON(obj.reply, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.comments.CreateReplyRequest();

          if (json.contextToken != null) {
            result.contextToken = $root.google.protobuf.StringValue.fromJSON(json.contextToken, helper);
          } else {
            delete result.contextToken;
          }
          if (json.parentCommentId != null) {
            result.parentCommentId = json.parentCommentId;
          } else {
            result.parentCommentId = '';
          }
          if (json.reply != null) {
            result.reply = $root.wix.comments.CommentEntity.fromJSON(json.reply, helper);
          } else {
            delete result.reply;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.contextToken != null) {
              grpc.contextToken = $root.google.protobuf.StringValue.toGRPC(obj.contextToken, helper);
            }
            if (obj.parentCommentId != null) {
              grpc.parentCommentId = obj.parentCommentId;
            }
            if (obj.reply != null) {
              grpc.reply = $root.wix.comments.CommentEntity.toGRPC(obj.reply, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.comments.CreateReplyRequest();

            if (grpc.contextToken != null) {
              result.contextToken = $root.google.protobuf.StringValue.fromGRPC(grpc.contextToken, helper);
            } else {
              delete result.contextToken;
            }
            if (grpc.parentCommentId != null) {
              result.parentCommentId = grpc.parentCommentId;
            } else {
              result.parentCommentId = '';
            }
            if (grpc.reply != null) {
              result.reply = $root.wix.comments.CommentEntity.fromGRPC(grpc.reply, helper);
            } else {
              delete result.reply;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'contextToken': {
                'type': $root.google.protobuf.StringValue,
                'id': 1
              },
              'parentCommentId': {
                'type': 'string',
                'id': 2,
                'options': {
                  '(wix.api.format)': 'GUID'
                }
              },
              'reply': {
                'type': $root.wix.comments.CommentEntity,
                'id': 3
              }
            }
          };
        }
      }

      Object.defineProperty(CreateReplyRequest.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.comments.CreateReplyRequest');
        },
        enumerable: false,
        configurable: false
      });
      return CreateReplyRequest;
    }());
    comments.GetPagingContextsRequest = (function() {

      class GetPagingContextsRequest {

        constructor(props) {
          this.pagingContextSetups = props && props.pagingContextSetups;
          this.repliesRequest = props && props.repliesRequest;
          this.fieldset = props && props.fieldset;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.pagingContextSetups != null) {
              const fieldErrors = errors.field('pagingContextSetups');

              if (!Array.isArray(msg.pagingContextSetups)) {
                fieldErrors.error('array expected');
              } else {
                msg.pagingContextSetups.forEach((value, index) => {
                  $root.wix.comments.PagingContextSetup.verify(value, helper, fieldErrors.index(index));
                });
              }
            }
            if (msg.repliesRequest != null) {
              $root.wix.comments.RepliesRequest.verify(msg.repliesRequest, helper, errors.field('repliesRequest'));
            }
            if (msg.fieldset != null) {
              $root.google.protobuf.StringValue.verify(msg.fieldset, helper, errors.field('fieldset'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.pagingContextSetups != null) {
              json.pagingContextSetups = obj.pagingContextSetups.map(e => {
                return $root.wix.comments.PagingContextSetup.toJSON(e, helper);
              });
            }
            if (obj.repliesRequest != null) {
              json.repliesRequest = $root.wix.comments.RepliesRequest.toJSON(obj.repliesRequest, helper);
            }
            if (obj.fieldset != null) {
              json.fieldset = $root.google.protobuf.StringValue.toJSON(obj.fieldset, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.comments.GetPagingContextsRequest();

          if (json.pagingContextSetups != null) {
            result.pagingContextSetups = json.pagingContextSetups.map(e => {
              return $root.wix.comments.PagingContextSetup.fromJSON(e, helper);
            });
          } else {
            result.pagingContextSetups = [];
          }
          if (json.repliesRequest != null) {
            result.repliesRequest = $root.wix.comments.RepliesRequest.fromJSON(json.repliesRequest, helper);
          } else {
            delete result.repliesRequest;
          }
          if (json.fieldset != null) {
            result.fieldset = $root.google.protobuf.StringValue.fromJSON(json.fieldset, helper);
          } else {
            delete result.fieldset;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.pagingContextSetups != null) {
              grpc.pagingContextSetups = obj.pagingContextSetups.map(e => {
                return $root.wix.comments.PagingContextSetup.toGRPC(e, helper);
              });
            }
            if (obj.repliesRequest != null) {
              grpc.repliesRequest = $root.wix.comments.RepliesRequest.toGRPC(obj.repliesRequest, helper);
            }
            if (obj.fieldset != null) {
              grpc.fieldset = $root.google.protobuf.StringValue.toGRPC(obj.fieldset, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.comments.GetPagingContextsRequest();

            if (grpc.pagingContextSetups != null) {
              result.pagingContextSetups = grpc.pagingContextSetups.map(e => {
                return $root.wix.comments.PagingContextSetup.fromGRPC(e, helper);
              });
            } else {
              result.pagingContextSetups = [];
            }
            if (grpc.repliesRequest != null) {
              result.repliesRequest = $root.wix.comments.RepliesRequest.fromGRPC(grpc.repliesRequest, helper);
            } else {
              delete result.repliesRequest;
            }
            if (grpc.fieldset != null) {
              result.fieldset = $root.google.protobuf.StringValue.fromGRPC(grpc.fieldset, helper);
            } else {
              delete result.fieldset;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'pagingContextSetups': {
                'rule': 'repeated',
                'type': $root.wix.comments.PagingContextSetup,
                'id': 1
              },
              'repliesRequest': {
                'type': $root.wix.comments.RepliesRequest,
                'id': 2
              },
              'fieldset': {
                'type': $root.google.protobuf.StringValue,
                'id': 3
              }
            }
          };
        }
      }

      Object.defineProperty(GetPagingContextsRequest.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.comments.GetPagingContextsRequest');
        },
        enumerable: false,
        configurable: false
      });
      return GetPagingContextsRequest;
    }());
    comments.GetPagingContextsResponse = (function() {

      class GetPagingContextsResponse {

        constructor(props) {
          this.contexts = props && props.contexts;
          this.profiles = props && props.profiles;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.contexts != null) {
              const fieldErrors = errors.field('contexts');

              if (msg.contexts != null && (!(typeof msg.contexts === 'object') || Array.isArray(msg.contexts))) {
                fieldErrors.error('object expected');
              } else {
                for (let key in msg.contexts) {
                  const keyErrors = fieldErrors.index(key);
                  $root.wix.comments.PagingContext.verify(msg.contexts[key], helper, keyErrors.field('value'));
                }
              }
            }
            if (msg.profiles != null) {
              $root.wix.social.Profiles.verify(msg.profiles, helper, errors.field('profiles'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.contexts != null) {
              json.contexts = Object.entries(obj.contexts).reduce((acc, [k, v]) => {
                acc[k] = $root.wix.comments.PagingContext.toJSON(v, helper);
                return acc;
              }, {});
            }
            if (obj.profiles != null) {
              json.profiles = $root.wix.social.Profiles.toJSON(obj.profiles, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.comments.GetPagingContextsResponse();

          if (json.contexts != null) {
            result.contexts = Object.entries(json.contexts).reduce((acc, [k, v]) => {
              acc[k] = $root.wix.comments.PagingContext.fromJSON(v, helper);
              return acc;
            }, {});
          } else {
            delete result.contexts;
          }
          if (json.profiles != null) {
            result.profiles = $root.wix.social.Profiles.fromJSON(json.profiles, helper);
          } else {
            delete result.profiles;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.contexts != null) {
              grpc.contexts = Object.entries(obj.contexts).reduce((acc, [k, v]) => {
                acc[k] = $root.wix.comments.PagingContext.toGRPC(v, helper);
                return acc;
              }, {});
            }
            if (obj.profiles != null) {
              grpc.profiles = $root.wix.social.Profiles.toGRPC(obj.profiles, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.comments.GetPagingContextsResponse();

            if (grpc.contexts != null) {
              result.contexts = Object.entries(grpc.contexts).reduce((acc, [k, v]) => {
                acc[k] = $root.wix.comments.PagingContext.fromGRPC(v, helper);
                return acc;
              }, {});
            } else {
              delete result.contexts;
            }
            if (grpc.profiles != null) {
              result.profiles = $root.wix.social.Profiles.fromGRPC(grpc.profiles, helper);
            } else {
              delete result.profiles;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'contexts': {
                'keyType': 'string',
                'type': $root.wix.comments.PagingContext,
                'id': 1
              },
              'profiles': {
                'type': $root.wix.social.Profiles,
                'id': 2
              }
            }
          };
        }
      }

      Object.defineProperty(GetPagingContextsResponse.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.comments.GetPagingContextsResponse');
        },
        enumerable: false,
        configurable: false
      });
      return GetPagingContextsResponse;
    }());
    comments.GetPagingContextRequest = (function() {

      class GetPagingContextRequest {

        constructor(props) {
          this.pagingContextSetup = props && props.pagingContextSetup;
          this.repliesRequest = props && props.repliesRequest;
          this.fieldset = props && props.fieldset;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.pagingContextSetup != null) {
              $root.wix.comments.PagingContextSetup.verify(msg.pagingContextSetup, helper, errors.field('pagingContextSetup'));
            }
            if (msg.repliesRequest != null) {
              $root.wix.comments.RepliesRequest.verify(msg.repliesRequest, helper, errors.field('repliesRequest'));
            }
            if (msg.fieldset != null) {
              $root.google.protobuf.StringValue.verify(msg.fieldset, helper, errors.field('fieldset'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.pagingContextSetup != null) {
              json.pagingContextSetup = $root.wix.comments.PagingContextSetup.toJSON(obj.pagingContextSetup, helper);
            }
            if (obj.repliesRequest != null) {
              json.repliesRequest = $root.wix.comments.RepliesRequest.toJSON(obj.repliesRequest, helper);
            }
            if (obj.fieldset != null) {
              json.fieldset = $root.google.protobuf.StringValue.toJSON(obj.fieldset, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.comments.GetPagingContextRequest();

          if (json.pagingContextSetup != null) {
            result.pagingContextSetup = $root.wix.comments.PagingContextSetup.fromJSON(json.pagingContextSetup, helper);
          } else {
            delete result.pagingContextSetup;
          }
          if (json.repliesRequest != null) {
            result.repliesRequest = $root.wix.comments.RepliesRequest.fromJSON(json.repliesRequest, helper);
          } else {
            delete result.repliesRequest;
          }
          if (json.fieldset != null) {
            result.fieldset = $root.google.protobuf.StringValue.fromJSON(json.fieldset, helper);
          } else {
            delete result.fieldset;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.pagingContextSetup != null) {
              grpc.pagingContextSetup = $root.wix.comments.PagingContextSetup.toGRPC(obj.pagingContextSetup, helper);
            }
            if (obj.repliesRequest != null) {
              grpc.repliesRequest = $root.wix.comments.RepliesRequest.toGRPC(obj.repliesRequest, helper);
            }
            if (obj.fieldset != null) {
              grpc.fieldset = $root.google.protobuf.StringValue.toGRPC(obj.fieldset, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.comments.GetPagingContextRequest();

            if (grpc.pagingContextSetup != null) {
              result.pagingContextSetup = $root.wix.comments.PagingContextSetup.fromGRPC(grpc.pagingContextSetup, helper);
            } else {
              delete result.pagingContextSetup;
            }
            if (grpc.repliesRequest != null) {
              result.repliesRequest = $root.wix.comments.RepliesRequest.fromGRPC(grpc.repliesRequest, helper);
            } else {
              delete result.repliesRequest;
            }
            if (grpc.fieldset != null) {
              result.fieldset = $root.google.protobuf.StringValue.fromGRPC(grpc.fieldset, helper);
            } else {
              delete result.fieldset;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'pagingContextSetup': {
                'type': $root.wix.comments.PagingContextSetup,
                'id': 1
              },
              'repliesRequest': {
                'type': $root.wix.comments.RepliesRequest,
                'id': 2
              },
              'fieldset': {
                'type': $root.google.protobuf.StringValue,
                'id': 3
              }
            }
          };
        }
      }

      Object.defineProperty(GetPagingContextRequest.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.comments.GetPagingContextRequest');
        },
        enumerable: false,
        configurable: false
      });
      return GetPagingContextRequest;
    }());
    comments.GetPagingContextResponse = (function() {

      class GetPagingContextResponse {

        constructor(props) {
          this.context = props && props.context;
          this.profiles = props && props.profiles;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.context != null) {
              $root.wix.comments.PagingContext.verify(msg.context, helper, errors.field('context'));
            }
            if (msg.profiles != null) {
              $root.wix.social.Profiles.verify(msg.profiles, helper, errors.field('profiles'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.context != null) {
              json.context = $root.wix.comments.PagingContext.toJSON(obj.context, helper);
            }
            if (obj.profiles != null) {
              json.profiles = $root.wix.social.Profiles.toJSON(obj.profiles, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.comments.GetPagingContextResponse();

          if (json.context != null) {
            result.context = $root.wix.comments.PagingContext.fromJSON(json.context, helper);
          } else {
            delete result.context;
          }
          if (json.profiles != null) {
            result.profiles = $root.wix.social.Profiles.fromJSON(json.profiles, helper);
          } else {
            delete result.profiles;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.context != null) {
              grpc.context = $root.wix.comments.PagingContext.toGRPC(obj.context, helper);
            }
            if (obj.profiles != null) {
              grpc.profiles = $root.wix.social.Profiles.toGRPC(obj.profiles, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.comments.GetPagingContextResponse();

            if (grpc.context != null) {
              result.context = $root.wix.comments.PagingContext.fromGRPC(grpc.context, helper);
            } else {
              delete result.context;
            }
            if (grpc.profiles != null) {
              result.profiles = $root.wix.social.Profiles.fromGRPC(grpc.profiles, helper);
            } else {
              delete result.profiles;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'context': {
                'type': $root.wix.comments.PagingContext,
                'id': 1
              },
              'profiles': {
                'type': $root.wix.social.Profiles,
                'id': 2
              }
            }
          };
        }
      }

      Object.defineProperty(GetPagingContextResponse.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.comments.GetPagingContextResponse');
        },
        enumerable: false,
        configurable: false
      });
      return GetPagingContextResponse;
    }());
    comments.GetListRequest = (function() {

      class GetListRequest {

        constructor(props) {
          this.pagingContextSetup = props && props.pagingContextSetup;
          this.cursorPaging = props && props.cursorPaging;
          this.contextToken = props && props.contextToken;
          this.repliesRequest = props && props.repliesRequest;
          this.fieldset = props && props.fieldset;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            const oneOfMutex = {};

            if (msg.pagingContextSetup != null) {
              if (oneOfMutex['pageRequest']) {
                errors.field('pagingContextSetup').up().field('pageRequest').error('multiple values');
              } else {
                oneOfMutex['pageRequest'] = true;
                $root.wix.comments.PagingContextSetup.verify(msg.pagingContextSetup, helper, errors.field('pagingContextSetup'));
              }
            }
            if (msg.cursorPaging != null) {
              if (oneOfMutex['pageRequest']) {
                errors.field('cursorPaging').up().field('pageRequest').error('multiple values');
              } else {
                oneOfMutex['pageRequest'] = true;
                $root.wix.common.CursorPaging.verify(msg.cursorPaging, helper, errors.field('cursorPaging'));
              }
            }
            if (msg.contextToken != null) {
              $root.google.protobuf.StringValue.verify(msg.contextToken, helper, errors.field('contextToken'));
            }
            if (msg.repliesRequest != null) {
              $root.wix.comments.RepliesRequest.verify(msg.repliesRequest, helper, errors.field('repliesRequest'));
            }
            if (msg.fieldset != null) {
              $root.google.protobuf.StringValue.verify(msg.fieldset, helper, errors.field('fieldset'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.pagingContextSetup != null) {
              json.pagingContextSetup = $root.wix.comments.PagingContextSetup.toJSON(obj.pagingContextSetup, helper);
            }
            if (obj.cursorPaging != null) {
              json.cursorPaging = $root.wix.common.CursorPaging.toJSON(obj.cursorPaging, helper);
            }
            if (obj.contextToken != null) {
              json.contextToken = $root.google.protobuf.StringValue.toJSON(obj.contextToken, helper);
            }
            if (obj.repliesRequest != null) {
              json.repliesRequest = $root.wix.comments.RepliesRequest.toJSON(obj.repliesRequest, helper);
            }
            if (obj.fieldset != null) {
              json.fieldset = $root.google.protobuf.StringValue.toJSON(obj.fieldset, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.comments.GetListRequest();

          if (json.pagingContextSetup != null) {
            result.pagingContextSetup = $root.wix.comments.PagingContextSetup.fromJSON(json.pagingContextSetup, helper);
          } else {
            delete result.pagingContextSetup;
          }
          if (json.cursorPaging != null) {
            result.cursorPaging = $root.wix.common.CursorPaging.fromJSON(json.cursorPaging, helper);
          } else {
            delete result.cursorPaging;
          }
          if (json.contextToken != null) {
            result.contextToken = $root.google.protobuf.StringValue.fromJSON(json.contextToken, helper);
          } else {
            delete result.contextToken;
          }
          if (json.repliesRequest != null) {
            result.repliesRequest = $root.wix.comments.RepliesRequest.fromJSON(json.repliesRequest, helper);
          } else {
            delete result.repliesRequest;
          }
          if (json.fieldset != null) {
            result.fieldset = $root.google.protobuf.StringValue.fromJSON(json.fieldset, helper);
          } else {
            delete result.fieldset;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.pagingContextSetup != null) {
              grpc.pagingContextSetup = $root.wix.comments.PagingContextSetup.toGRPC(obj.pagingContextSetup, helper);
            }
            if (obj.cursorPaging != null) {
              grpc.cursorPaging = $root.wix.common.CursorPaging.toGRPC(obj.cursorPaging, helper);
            }
            if (obj.contextToken != null) {
              grpc.contextToken = $root.google.protobuf.StringValue.toGRPC(obj.contextToken, helper);
            }
            if (obj.repliesRequest != null) {
              grpc.repliesRequest = $root.wix.comments.RepliesRequest.toGRPC(obj.repliesRequest, helper);
            }
            if (obj.fieldset != null) {
              grpc.fieldset = $root.google.protobuf.StringValue.toGRPC(obj.fieldset, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.comments.GetListRequest();

            if (grpc.pagingContextSetup != null) {
              result.pagingContextSetup = $root.wix.comments.PagingContextSetup.fromGRPC(grpc.pagingContextSetup, helper);
            } else {
              delete result.pagingContextSetup;
            }
            if (grpc.cursorPaging != null) {
              result.cursorPaging = $root.wix.common.CursorPaging.fromGRPC(grpc.cursorPaging, helper);
            } else {
              delete result.cursorPaging;
            }
            if (grpc.contextToken != null) {
              result.contextToken = $root.google.protobuf.StringValue.fromGRPC(grpc.contextToken, helper);
            } else {
              delete result.contextToken;
            }
            if (grpc.repliesRequest != null) {
              result.repliesRequest = $root.wix.comments.RepliesRequest.fromGRPC(grpc.repliesRequest, helper);
            } else {
              delete result.repliesRequest;
            }
            if (grpc.fieldset != null) {
              result.fieldset = $root.google.protobuf.StringValue.fromGRPC(grpc.fieldset, helper);
            } else {
              delete result.fieldset;
            }
            return result;
          }
        }

        static describe() {
          return {
            'oneofs': {
              'pageRequest': {
                'oneof': [
                  'pagingContextSetup',
                  'cursorPaging'
                ]
              }
            },
            'fields': {
              'pagingContextSetup': {
                'type': $root.wix.comments.PagingContextSetup,
                'id': 1
              },
              'cursorPaging': {
                'type': $root.wix.common.CursorPaging,
                'id': 2
              },
              'contextToken': {
                'type': $root.google.protobuf.StringValue,
                'id': 3
              },
              'repliesRequest': {
                'type': $root.wix.comments.RepliesRequest,
                'id': 4
              },
              'fieldset': {
                'type': $root.google.protobuf.StringValue,
                'id': 5
              }
            }
          };
        }
      }

      Object.defineProperty(GetListRequest.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.comments.GetListRequest');
        },
        enumerable: false,
        configurable: false
      });
      return GetListRequest;
    }());
    comments.PagingContextSetup = (function() {

      class PagingContextSetup {

        constructor(props) {
          this.containerId = props && props.containerId;
          this.entityId = props && props.entityId;
          this.containerType = props && props.containerType;
          this.limit = props && props.limit;
          this.access = props && props.access;
          this.flattenToDepth = props && props.flattenToDepth;
          this.ordering = props && props.ordering;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.containerId != null) {
              $root.google.protobuf.StringValue.verify(msg.containerId, helper, errors.field('containerId'));
            }
            if (msg.entityId != null) {
              $root.google.protobuf.StringValue.verify(msg.entityId, helper, errors.field('entityId'));
            }
            if (msg.containerType != null) {
              $root.google.protobuf.StringValue.verify(msg.containerType, helper, errors.field('containerType'));
            }
            if (msg.limit != null) {
              $root.google.protobuf.Int32Value.verify(msg.limit, helper, errors.field('limit'));
            }
            if (msg.access != null) {
              $root.wix.comments.CommentsAccess.verify(msg.access, helper, errors.field('access'));
            }
            if (msg.flattenToDepth != null) {
              $root.google.protobuf.Int32Value.verify(msg.flattenToDepth, helper, errors.field('flattenToDepth'));
            }
            if (msg.ordering != null) {
              $root.wix.comments.Ordering.verify(msg.ordering, helper, errors.field('ordering'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.containerId != null) {
              json.containerId = $root.google.protobuf.StringValue.toJSON(obj.containerId, helper);
            }
            if (obj.entityId != null) {
              json.entityId = $root.google.protobuf.StringValue.toJSON(obj.entityId, helper);
            }
            if (obj.containerType != null) {
              json.containerType = $root.google.protobuf.StringValue.toJSON(obj.containerType, helper);
            }
            if (obj.limit != null) {
              json.limit = $root.google.protobuf.Int32Value.toJSON(obj.limit, helper);
            }
            if (obj.access != null) {
              json.access = $root.wix.comments.CommentsAccess.toJSON(obj.access, helper);
            }
            if (obj.flattenToDepth != null) {
              json.flattenToDepth = $root.google.protobuf.Int32Value.toJSON(obj.flattenToDepth, helper);
            }
            if (obj.ordering != null) {
              json.ordering = $root.wix.comments.Ordering[obj.ordering];
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.comments.PagingContextSetup();

          if (json.containerId != null) {
            result.containerId = $root.google.protobuf.StringValue.fromJSON(json.containerId, helper);
          } else {
            delete result.containerId;
          }
          if (json.entityId != null) {
            result.entityId = $root.google.protobuf.StringValue.fromJSON(json.entityId, helper);
          } else {
            delete result.entityId;
          }
          if (json.containerType != null) {
            result.containerType = $root.google.protobuf.StringValue.fromJSON(json.containerType, helper);
          } else {
            delete result.containerType;
          }
          if (json.limit != null) {
            result.limit = $root.google.protobuf.Int32Value.fromJSON(json.limit, helper);
          } else {
            delete result.limit;
          }
          if (json.access != null) {
            result.access = $root.wix.comments.CommentsAccess.fromJSON(json.access, helper);
          } else {
            delete result.access;
          }
          if (json.flattenToDepth != null) {
            result.flattenToDepth = $root.google.protobuf.Int32Value.fromJSON(json.flattenToDepth, helper);
          } else {
            delete result.flattenToDepth;
          }
          if (json.ordering != null) {
            result.ordering = $root.wix.comments.Ordering[json.ordering];
          } else {
            result.ordering = 'OLDEST_FIRST';
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.containerId != null) {
              grpc.containerId = $root.google.protobuf.StringValue.toGRPC(obj.containerId, helper);
            }
            if (obj.entityId != null) {
              grpc.entityId = $root.google.protobuf.StringValue.toGRPC(obj.entityId, helper);
            }
            if (obj.containerType != null) {
              grpc.containerType = $root.google.protobuf.StringValue.toGRPC(obj.containerType, helper);
            }
            if (obj.limit != null) {
              grpc.limit = $root.google.protobuf.Int32Value.toGRPC(obj.limit, helper);
            }
            if (obj.access != null) {
              grpc.access = $root.wix.comments.CommentsAccess.toGRPC(obj.access, helper);
            }
            if (obj.flattenToDepth != null) {
              grpc.flattenToDepth = $root.google.protobuf.Int32Value.toGRPC(obj.flattenToDepth, helper);
            }
            if (obj.ordering != null) {
              grpc.ordering = obj.ordering;
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.comments.PagingContextSetup();

            if (grpc.containerId != null) {
              result.containerId = $root.google.protobuf.StringValue.fromGRPC(grpc.containerId, helper);
            } else {
              delete result.containerId;
            }
            if (grpc.entityId != null) {
              result.entityId = $root.google.protobuf.StringValue.fromGRPC(grpc.entityId, helper);
            } else {
              delete result.entityId;
            }
            if (grpc.containerType != null) {
              result.containerType = $root.google.protobuf.StringValue.fromGRPC(grpc.containerType, helper);
            } else {
              delete result.containerType;
            }
            if (grpc.limit != null) {
              result.limit = $root.google.protobuf.Int32Value.fromGRPC(grpc.limit, helper);
            } else {
              delete result.limit;
            }
            if (grpc.access != null) {
              result.access = $root.wix.comments.CommentsAccess.fromGRPC(grpc.access, helper);
            } else {
              delete result.access;
            }
            if (grpc.flattenToDepth != null) {
              result.flattenToDepth = $root.google.protobuf.Int32Value.fromGRPC(grpc.flattenToDepth, helper);
            } else {
              delete result.flattenToDepth;
            }
            if (grpc.ordering != null) {
              result.ordering = grpc.ordering;
            } else {
              result.ordering = 'OLDEST_FIRST';
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'containerId': {
                'type': $root.google.protobuf.StringValue,
                'id': 1,
                'options': {
                  '(wix.api.format)': 'GUID'
                }
              },
              'entityId': {
                'type': $root.google.protobuf.StringValue,
                'id': 5,
                'options': {
                  '(wix.api.format)': 'GUID'
                }
              },
              'containerType': {
                'type': $root.google.protobuf.StringValue,
                'id': 2
              },
              'limit': {
                'type': $root.google.protobuf.Int32Value,
                'id': 3,
                'options': {
                  '(wix.api.min)': 0
                }
              },
              'access': {
                'type': $root.wix.comments.CommentsAccess,
                'id': 4
              },
              'flattenToDepth': {
                'type': $root.google.protobuf.Int32Value,
                'id': 6
              },
              'ordering': {
                'type': $root.wix.comments.Ordering,
                'id': 7
              }
            }
          };
        }
      }

      Object.defineProperty(PagingContextSetup.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.comments.PagingContextSetup');
        },
        enumerable: false,
        configurable: false
      });
      return PagingContextSetup;
    }());
    comments.GetListResponse = (function() {

      class GetListResponse {

        constructor(props) {
          this.comments = props && props.comments;
          this.contextToken = props && props.contextToken;
          this.nextCursor = props && props.nextCursor;
          this.previousCursor = props && props.previousCursor;
          this.profiles = props && props.profiles;
          this.remainingCount = props && props.remainingCount;
          this.count = props && props.count;
          this.availableActions = props && props.availableActions;
          this.loggedInUserId = props && props.loggedInUserId;
          this.loggedInIdentity = props && props.loggedInIdentity;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.comments != null) {
              const fieldErrors = errors.field('comments');

              if (!Array.isArray(msg.comments)) {
                fieldErrors.error('array expected');
              } else {
                msg.comments.forEach((value, index) => {
                  $root.wix.comments.Comment.verify(value, helper, fieldErrors.index(index));
                });
              }
            }
            if (msg.contextToken != null) {
              $root.google.protobuf.StringValue.verify(msg.contextToken, helper, errors.field('contextToken'));
            }
            if (msg.nextCursor != null) {
              $root.google.protobuf.StringValue.verify(msg.nextCursor, helper, errors.field('nextCursor'));
            }
            if (msg.previousCursor != null) {
              $root.google.protobuf.StringValue.verify(msg.previousCursor, helper, errors.field('previousCursor'));
            }
            if (msg.profiles != null) {
              $root.wix.social.Profiles.verify(msg.profiles, helper, errors.field('profiles'));
            }
            if (msg.remainingCount != null) {
              $root.google.protobuf.Int32Value.verify(msg.remainingCount, helper, errors.field('remainingCount'));
            }
            if (msg.count != null) {
              $root.google.protobuf.Int32Value.verify(msg.count, helper, errors.field('count'));
            }
            if (msg.availableActions != null) {
              const fieldErrors = errors.field('availableActions');

              if (!Array.isArray(msg.availableActions)) {
                fieldErrors.error('array expected');
              } else {
                msg.availableActions.forEach((value, index) => {
                  $root.wix.comments.UserAction.verify(value, helper, fieldErrors.index(index));
                });
              }
            }
            if (msg.loggedInUserId != null) {
              $root.google.protobuf.StringValue.verify(msg.loggedInUserId, helper, errors.field('loggedInUserId'));
            }
            if (msg.loggedInIdentity != null) {
              $root.wix.social.SocialIdentity.verify(msg.loggedInIdentity, helper, errors.field('loggedInIdentity'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.comments != null) {
              json.comments = obj.comments.map(e => {
                return $root.wix.comments.Comment.toJSON(e, helper);
              });
            }
            if (obj.contextToken != null) {
              json.contextToken = $root.google.protobuf.StringValue.toJSON(obj.contextToken, helper);
            }
            if (obj.nextCursor != null) {
              json.nextCursor = $root.google.protobuf.StringValue.toJSON(obj.nextCursor, helper);
            }
            if (obj.previousCursor != null) {
              json.previousCursor = $root.google.protobuf.StringValue.toJSON(obj.previousCursor, helper);
            }
            if (obj.profiles != null) {
              json.profiles = $root.wix.social.Profiles.toJSON(obj.profiles, helper);
            }
            if (obj.remainingCount != null) {
              json.remainingCount = $root.google.protobuf.Int32Value.toJSON(obj.remainingCount, helper);
            }
            if (obj.count != null) {
              json.count = $root.google.protobuf.Int32Value.toJSON(obj.count, helper);
            }
            if (obj.availableActions != null) {
              json.availableActions = obj.availableActions.map(e => {
                return $root.wix.comments.UserAction[e];
              });
            }
            if (obj.loggedInUserId != null) {
              json.loggedInUserId = $root.google.protobuf.StringValue.toJSON(obj.loggedInUserId, helper);
            }
            if (obj.loggedInIdentity != null) {
              json.loggedInIdentity = $root.wix.social.SocialIdentity.toJSON(obj.loggedInIdentity, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.comments.GetListResponse();

          if (json.comments != null) {
            result.comments = json.comments.map(e => {
              return $root.wix.comments.Comment.fromJSON(e, helper);
            });
          } else {
            result.comments = [];
          }
          if (json.contextToken != null) {
            result.contextToken = $root.google.protobuf.StringValue.fromJSON(json.contextToken, helper);
          } else {
            delete result.contextToken;
          }
          if (json.nextCursor != null) {
            result.nextCursor = $root.google.protobuf.StringValue.fromJSON(json.nextCursor, helper);
          } else {
            delete result.nextCursor;
          }
          if (json.previousCursor != null) {
            result.previousCursor = $root.google.protobuf.StringValue.fromJSON(json.previousCursor, helper);
          } else {
            delete result.previousCursor;
          }
          if (json.profiles != null) {
            result.profiles = $root.wix.social.Profiles.fromJSON(json.profiles, helper);
          } else {
            delete result.profiles;
          }
          if (json.remainingCount != null) {
            result.remainingCount = $root.google.protobuf.Int32Value.fromJSON(json.remainingCount, helper);
          } else {
            delete result.remainingCount;
          }
          if (json.count != null) {
            result.count = $root.google.protobuf.Int32Value.fromJSON(json.count, helper);
          } else {
            delete result.count;
          }
          if (json.availableActions != null) {
            result.availableActions = json.availableActions.map(e => {
              return $root.wix.comments.UserAction[e];
            });
          } else {
            result.availableActions = [];
          }
          if (json.loggedInUserId != null) {
            result.loggedInUserId = $root.google.protobuf.StringValue.fromJSON(json.loggedInUserId, helper);
          } else {
            delete result.loggedInUserId;
          }
          if (json.loggedInIdentity != null) {
            result.loggedInIdentity = $root.wix.social.SocialIdentity.fromJSON(json.loggedInIdentity, helper);
          } else {
            delete result.loggedInIdentity;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.comments != null) {
              grpc.comments = obj.comments.map(e => {
                return $root.wix.comments.Comment.toGRPC(e, helper);
              });
            }
            if (obj.contextToken != null) {
              grpc.contextToken = $root.google.protobuf.StringValue.toGRPC(obj.contextToken, helper);
            }
            if (obj.nextCursor != null) {
              grpc.nextCursor = $root.google.protobuf.StringValue.toGRPC(obj.nextCursor, helper);
            }
            if (obj.previousCursor != null) {
              grpc.previousCursor = $root.google.protobuf.StringValue.toGRPC(obj.previousCursor, helper);
            }
            if (obj.profiles != null) {
              grpc.profiles = $root.wix.social.Profiles.toGRPC(obj.profiles, helper);
            }
            if (obj.remainingCount != null) {
              grpc.remainingCount = $root.google.protobuf.Int32Value.toGRPC(obj.remainingCount, helper);
            }
            if (obj.count != null) {
              grpc.count = $root.google.protobuf.Int32Value.toGRPC(obj.count, helper);
            }
            if (obj.availableActions != null) {
              grpc.availableActions = obj.availableActions.map(e => {
                return e;
              });
            }
            if (obj.loggedInUserId != null) {
              grpc.loggedInUserId = $root.google.protobuf.StringValue.toGRPC(obj.loggedInUserId, helper);
            }
            if (obj.loggedInIdentity != null) {
              grpc.loggedInIdentity = $root.wix.social.SocialIdentity.toGRPC(obj.loggedInIdentity, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.comments.GetListResponse();

            if (grpc.comments != null) {
              result.comments = grpc.comments.map(e => {
                return $root.wix.comments.Comment.fromGRPC(e, helper);
              });
            } else {
              result.comments = [];
            }
            if (grpc.contextToken != null) {
              result.contextToken = $root.google.protobuf.StringValue.fromGRPC(grpc.contextToken, helper);
            } else {
              delete result.contextToken;
            }
            if (grpc.nextCursor != null) {
              result.nextCursor = $root.google.protobuf.StringValue.fromGRPC(grpc.nextCursor, helper);
            } else {
              delete result.nextCursor;
            }
            if (grpc.previousCursor != null) {
              result.previousCursor = $root.google.protobuf.StringValue.fromGRPC(grpc.previousCursor, helper);
            } else {
              delete result.previousCursor;
            }
            if (grpc.profiles != null) {
              result.profiles = $root.wix.social.Profiles.fromGRPC(grpc.profiles, helper);
            } else {
              delete result.profiles;
            }
            if (grpc.remainingCount != null) {
              result.remainingCount = $root.google.protobuf.Int32Value.fromGRPC(grpc.remainingCount, helper);
            } else {
              delete result.remainingCount;
            }
            if (grpc.count != null) {
              result.count = $root.google.protobuf.Int32Value.fromGRPC(grpc.count, helper);
            } else {
              delete result.count;
            }
            if (grpc.availableActions != null) {
              result.availableActions = grpc.availableActions.map(e => {
                return e;
              });
            } else {
              result.availableActions = [];
            }
            if (grpc.loggedInUserId != null) {
              result.loggedInUserId = $root.google.protobuf.StringValue.fromGRPC(grpc.loggedInUserId, helper);
            } else {
              delete result.loggedInUserId;
            }
            if (grpc.loggedInIdentity != null) {
              result.loggedInIdentity = $root.wix.social.SocialIdentity.fromGRPC(grpc.loggedInIdentity, helper);
            } else {
              delete result.loggedInIdentity;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'comments': {
                'rule': 'repeated',
                'type': $root.wix.comments.Comment,
                'id': 1
              },
              'contextToken': {
                'type': $root.google.protobuf.StringValue,
                'id': 2
              },
              'nextCursor': {
                'type': $root.google.protobuf.StringValue,
                'id': 3
              },
              'previousCursor': {
                'type': $root.google.protobuf.StringValue,
                'id': 11
              },
              'profiles': {
                'type': $root.wix.social.Profiles,
                'id': 4
              },
              'remainingCount': {
                'type': $root.google.protobuf.Int32Value,
                'id': 5
              },
              'count': {
                'type': $root.google.protobuf.Int32Value,
                'id': 6
              },
              'availableActions': {
                'rule': 'repeated',
                'type': $root.wix.comments.UserAction,
                'id': 7
              },
              'loggedInUserId': {
                'type': $root.google.protobuf.StringValue,
                'id': 8,
                'options': {
                  'deprecated': true
                }
              },
              'loggedInIdentity': {
                'type': $root.wix.social.SocialIdentity,
                'id': 9
              }
            }
          };
        }
      }

      Object.defineProperty(GetListResponse.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.comments.GetListResponse');
        },
        enumerable: false,
        configurable: false
      });
      return GetListResponse;
    }());
    comments.PagingContext = (function() {

      class PagingContext {

        constructor(props) {
          this.comments = props && props.comments;
          this.contextToken = props && props.contextToken;
          this.nextCursor = props && props.nextCursor;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.comments != null) {
              const fieldErrors = errors.field('comments');

              if (!Array.isArray(msg.comments)) {
                fieldErrors.error('array expected');
              } else {
                msg.comments.forEach((value, index) => {
                  $root.wix.comments.Comment.verify(value, helper, fieldErrors.index(index));
                });
              }
            }
            if (msg.contextToken != null) {
              $root.google.protobuf.StringValue.verify(msg.contextToken, helper, errors.field('contextToken'));
            }
            if (msg.nextCursor != null) {
              $root.google.protobuf.StringValue.verify(msg.nextCursor, helper, errors.field('nextCursor'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.comments != null) {
              json.comments = obj.comments.map(e => {
                return $root.wix.comments.Comment.toJSON(e, helper);
              });
            }
            if (obj.contextToken != null) {
              json.contextToken = $root.google.protobuf.StringValue.toJSON(obj.contextToken, helper);
            }
            if (obj.nextCursor != null) {
              json.nextCursor = $root.google.protobuf.StringValue.toJSON(obj.nextCursor, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.comments.PagingContext();

          if (json.comments != null) {
            result.comments = json.comments.map(e => {
              return $root.wix.comments.Comment.fromJSON(e, helper);
            });
          } else {
            result.comments = [];
          }
          if (json.contextToken != null) {
            result.contextToken = $root.google.protobuf.StringValue.fromJSON(json.contextToken, helper);
          } else {
            delete result.contextToken;
          }
          if (json.nextCursor != null) {
            result.nextCursor = $root.google.protobuf.StringValue.fromJSON(json.nextCursor, helper);
          } else {
            delete result.nextCursor;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.comments != null) {
              grpc.comments = obj.comments.map(e => {
                return $root.wix.comments.Comment.toGRPC(e, helper);
              });
            }
            if (obj.contextToken != null) {
              grpc.contextToken = $root.google.protobuf.StringValue.toGRPC(obj.contextToken, helper);
            }
            if (obj.nextCursor != null) {
              grpc.nextCursor = $root.google.protobuf.StringValue.toGRPC(obj.nextCursor, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.comments.PagingContext();

            if (grpc.comments != null) {
              result.comments = grpc.comments.map(e => {
                return $root.wix.comments.Comment.fromGRPC(e, helper);
              });
            } else {
              result.comments = [];
            }
            if (grpc.contextToken != null) {
              result.contextToken = $root.google.protobuf.StringValue.fromGRPC(grpc.contextToken, helper);
            } else {
              delete result.contextToken;
            }
            if (grpc.nextCursor != null) {
              result.nextCursor = $root.google.protobuf.StringValue.fromGRPC(grpc.nextCursor, helper);
            } else {
              delete result.nextCursor;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'comments': {
                'rule': 'repeated',
                'type': $root.wix.comments.Comment,
                'id': 1
              },
              'contextToken': {
                'type': $root.google.protobuf.StringValue,
                'id': 2
              },
              'nextCursor': {
                'type': $root.google.protobuf.StringValue,
                'id': 3
              }
            }
          };
        }
      }

      Object.defineProperty(PagingContext.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.comments.PagingContext');
        },
        enumerable: false,
        configurable: false
      });
      return PagingContext;
    }());
    comments.UpdateCommentRequest = (function() {

      class UpdateCommentRequest {

        constructor(props) {
          this.contextToken = props && props.contextToken;
          this.commentId = props && props.commentId;
          this.comment = props && props.comment;
          this.mask = props && props.mask;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.contextToken != null) {
              $root.google.protobuf.StringValue.verify(msg.contextToken, helper, errors.field('contextToken'));
            }
            if (msg.commentId != null) {
              if (typeof msg.commentId !== 'string') {
                errors.field('commentId').error('string expected');
              }
            }
            if (msg.comment != null) {
              $root.wix.comments.CommentEntity.verify(msg.comment, helper, errors.field('comment'));
            }
            if (msg.mask != null) {
              $root.google.protobuf.FieldMask.verify(msg.mask, helper, errors.field('mask'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.contextToken != null) {
              json.contextToken = $root.google.protobuf.StringValue.toJSON(obj.contextToken, helper);
            }
            if (obj.commentId != null) {
              json.commentId = obj.commentId;
            }
            if (obj.comment != null) {
              json.comment = $root.wix.comments.CommentEntity.toJSON(obj.comment, helper);
            }
            if (obj.mask != null) {
              json.mask = $root.google.protobuf.FieldMask.toJSON(obj.mask, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.comments.UpdateCommentRequest();

          if (json.contextToken != null) {
            result.contextToken = $root.google.protobuf.StringValue.fromJSON(json.contextToken, helper);
          } else {
            delete result.contextToken;
          }
          if (json.commentId != null) {
            result.commentId = json.commentId;
          } else {
            result.commentId = '';
          }
          if (json.comment != null) {
            result.comment = $root.wix.comments.CommentEntity.fromJSON(json.comment, helper);
          } else {
            delete result.comment;
          }
          if (json.mask != null) {
            result.mask = $root.google.protobuf.FieldMask.fromJSON(json.mask, helper);
          } else {
            delete result.mask;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.contextToken != null) {
              grpc.contextToken = $root.google.protobuf.StringValue.toGRPC(obj.contextToken, helper);
            }
            if (obj.commentId != null) {
              grpc.commentId = obj.commentId;
            }
            if (obj.comment != null) {
              grpc.comment = $root.wix.comments.CommentEntity.toGRPC(obj.comment, helper);
            }
            if (obj.mask != null) {
              grpc.mask = $root.google.protobuf.FieldMask.toGRPC(obj.mask, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.comments.UpdateCommentRequest();

            if (grpc.contextToken != null) {
              result.contextToken = $root.google.protobuf.StringValue.fromGRPC(grpc.contextToken, helper);
            } else {
              delete result.contextToken;
            }
            if (grpc.commentId != null) {
              result.commentId = grpc.commentId;
            } else {
              result.commentId = '';
            }
            if (grpc.comment != null) {
              result.comment = $root.wix.comments.CommentEntity.fromGRPC(grpc.comment, helper);
            } else {
              delete result.comment;
            }
            if (grpc.mask != null) {
              result.mask = $root.google.protobuf.FieldMask.fromGRPC(grpc.mask, helper);
            } else {
              delete result.mask;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'contextToken': {
                'type': $root.google.protobuf.StringValue,
                'id': 1
              },
              'commentId': {
                'type': 'string',
                'id': 2,
                'options': {
                  '(wix.api.format)': 'GUID'
                }
              },
              'comment': {
                'type': $root.wix.comments.CommentEntity,
                'id': 3
              },
              'mask': {
                'type': $root.google.protobuf.FieldMask,
                'id': 4
              }
            }
          };
        }
      }

      Object.defineProperty(UpdateCommentRequest.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.comments.UpdateCommentRequest');
        },
        enumerable: false,
        configurable: false
      });
      return UpdateCommentRequest;
    }());
    comments.DeleteCommentRequest = (function() {

      class DeleteCommentRequest {

        constructor(props) {
          this.contextToken = props && props.contextToken;
          this.commentId = props && props.commentId;
          this.listRequest = props && props.listRequest;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.contextToken != null) {
              $root.google.protobuf.StringValue.verify(msg.contextToken, helper, errors.field('contextToken'));
            }
            if (msg.commentId != null) {
              if (typeof msg.commentId !== 'string') {
                errors.field('commentId').error('string expected');
              }
            }
            if (msg.listRequest != null) {
              $root.wix.comments.GetListRequest.verify(msg.listRequest, helper, errors.field('listRequest'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.contextToken != null) {
              json.contextToken = $root.google.protobuf.StringValue.toJSON(obj.contextToken, helper);
            }
            if (obj.commentId != null) {
              json.commentId = obj.commentId;
            }
            if (obj.listRequest != null) {
              json.listRequest = $root.wix.comments.GetListRequest.toJSON(obj.listRequest, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.comments.DeleteCommentRequest();

          if (json.contextToken != null) {
            result.contextToken = $root.google.protobuf.StringValue.fromJSON(json.contextToken, helper);
          } else {
            delete result.contextToken;
          }
          if (json.commentId != null) {
            result.commentId = json.commentId;
          } else {
            result.commentId = '';
          }
          if (json.listRequest != null) {
            result.listRequest = $root.wix.comments.GetListRequest.fromJSON(json.listRequest, helper);
          } else {
            delete result.listRequest;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.contextToken != null) {
              grpc.contextToken = $root.google.protobuf.StringValue.toGRPC(obj.contextToken, helper);
            }
            if (obj.commentId != null) {
              grpc.commentId = obj.commentId;
            }
            if (obj.listRequest != null) {
              grpc.listRequest = $root.wix.comments.GetListRequest.toGRPC(obj.listRequest, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.comments.DeleteCommentRequest();

            if (grpc.contextToken != null) {
              result.contextToken = $root.google.protobuf.StringValue.fromGRPC(grpc.contextToken, helper);
            } else {
              delete result.contextToken;
            }
            if (grpc.commentId != null) {
              result.commentId = grpc.commentId;
            } else {
              result.commentId = '';
            }
            if (grpc.listRequest != null) {
              result.listRequest = $root.wix.comments.GetListRequest.fromGRPC(grpc.listRequest, helper);
            } else {
              delete result.listRequest;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'contextToken': {
                'type': $root.google.protobuf.StringValue,
                'id': 1
              },
              'commentId': {
                'type': 'string',
                'id': 2,
                'options': {
                  '(wix.api.format)': 'GUID'
                }
              },
              'listRequest': {
                'type': $root.wix.comments.GetListRequest,
                'id': 3
              }
            }
          };
        }
      }

      Object.defineProperty(DeleteCommentRequest.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.comments.DeleteCommentRequest');
        },
        enumerable: false,
        configurable: false
      });
      return DeleteCommentRequest;
    }());
    comments.DeleteCommentResponse = (function() {

      class DeleteCommentResponse {

        constructor(props) {
          this.comment = props && props.comment;
          this.listResponse = props && props.listResponse;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.comment != null) {
              $root.wix.comments.Comment.verify(msg.comment, helper, errors.field('comment'));
            }
            if (msg.listResponse != null) {
              $root.wix.comments.GetListResponse.verify(msg.listResponse, helper, errors.field('listResponse'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.comment != null) {
              json.comment = $root.wix.comments.Comment.toJSON(obj.comment, helper);
            }
            if (obj.listResponse != null) {
              json.listResponse = $root.wix.comments.GetListResponse.toJSON(obj.listResponse, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.comments.DeleteCommentResponse();

          if (json.comment != null) {
            result.comment = $root.wix.comments.Comment.fromJSON(json.comment, helper);
          } else {
            delete result.comment;
          }
          if (json.listResponse != null) {
            result.listResponse = $root.wix.comments.GetListResponse.fromJSON(json.listResponse, helper);
          } else {
            delete result.listResponse;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.comment != null) {
              grpc.comment = $root.wix.comments.Comment.toGRPC(obj.comment, helper);
            }
            if (obj.listResponse != null) {
              grpc.listResponse = $root.wix.comments.GetListResponse.toGRPC(obj.listResponse, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.comments.DeleteCommentResponse();

            if (grpc.comment != null) {
              result.comment = $root.wix.comments.Comment.fromGRPC(grpc.comment, helper);
            } else {
              delete result.comment;
            }
            if (grpc.listResponse != null) {
              result.listResponse = $root.wix.comments.GetListResponse.fromGRPC(grpc.listResponse, helper);
            } else {
              delete result.listResponse;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'comment': {
                'type': $root.wix.comments.Comment,
                'id': 1
              },
              'listResponse': {
                'type': $root.wix.comments.GetListResponse,
                'id': 2
              }
            }
          };
        }
      }

      Object.defineProperty(DeleteCommentResponse.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.comments.DeleteCommentResponse');
        },
        enumerable: false,
        configurable: false
      });
      return DeleteCommentResponse;
    }());
    comments.AddReactionRequest = (function() {

      class AddReactionRequest {

        constructor(props) {
          this.contextToken = props && props.contextToken;
          this.commentId = props && props.commentId;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.contextToken != null) {
              $root.google.protobuf.StringValue.verify(msg.contextToken, helper, errors.field('contextToken'));
            }
            if (msg.commentId != null) {
              if (typeof msg.commentId !== 'string') {
                errors.field('commentId').error('string expected');
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.contextToken != null) {
              json.contextToken = $root.google.protobuf.StringValue.toJSON(obj.contextToken, helper);
            }
            if (obj.commentId != null) {
              json.commentId = obj.commentId;
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.comments.AddReactionRequest();

          if (json.contextToken != null) {
            result.contextToken = $root.google.protobuf.StringValue.fromJSON(json.contextToken, helper);
          } else {
            delete result.contextToken;
          }
          if (json.commentId != null) {
            result.commentId = json.commentId;
          } else {
            result.commentId = '';
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.contextToken != null) {
              grpc.contextToken = $root.google.protobuf.StringValue.toGRPC(obj.contextToken, helper);
            }
            if (obj.commentId != null) {
              grpc.commentId = obj.commentId;
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.comments.AddReactionRequest();

            if (grpc.contextToken != null) {
              result.contextToken = $root.google.protobuf.StringValue.fromGRPC(grpc.contextToken, helper);
            } else {
              delete result.contextToken;
            }
            if (grpc.commentId != null) {
              result.commentId = grpc.commentId;
            } else {
              result.commentId = '';
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'contextToken': {
                'type': $root.google.protobuf.StringValue,
                'id': 1
              },
              'commentId': {
                'type': 'string',
                'id': 2,
                'options': {
                  '(wix.api.format)': 'GUID'
                }
              }
            }
          };
        }
      }

      Object.defineProperty(AddReactionRequest.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.comments.AddReactionRequest');
        },
        enumerable: false,
        configurable: false
      });
      return AddReactionRequest;
    }());
    comments.RemoveReactionRequest = (function() {

      class RemoveReactionRequest {

        constructor(props) {
          this.contextToken = props && props.contextToken;
          this.commentId = props && props.commentId;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.contextToken != null) {
              $root.google.protobuf.StringValue.verify(msg.contextToken, helper, errors.field('contextToken'));
            }
            if (msg.commentId != null) {
              if (typeof msg.commentId !== 'string') {
                errors.field('commentId').error('string expected');
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.contextToken != null) {
              json.contextToken = $root.google.protobuf.StringValue.toJSON(obj.contextToken, helper);
            }
            if (obj.commentId != null) {
              json.commentId = obj.commentId;
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.comments.RemoveReactionRequest();

          if (json.contextToken != null) {
            result.contextToken = $root.google.protobuf.StringValue.fromJSON(json.contextToken, helper);
          } else {
            delete result.contextToken;
          }
          if (json.commentId != null) {
            result.commentId = json.commentId;
          } else {
            result.commentId = '';
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.contextToken != null) {
              grpc.contextToken = $root.google.protobuf.StringValue.toGRPC(obj.contextToken, helper);
            }
            if (obj.commentId != null) {
              grpc.commentId = obj.commentId;
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.comments.RemoveReactionRequest();

            if (grpc.contextToken != null) {
              result.contextToken = $root.google.protobuf.StringValue.fromGRPC(grpc.contextToken, helper);
            } else {
              delete result.contextToken;
            }
            if (grpc.commentId != null) {
              result.commentId = grpc.commentId;
            } else {
              result.commentId = '';
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'contextToken': {
                'type': $root.google.protobuf.StringValue,
                'id': 1
              },
              'commentId': {
                'type': 'string',
                'id': 2,
                'options': {
                  '(wix.api.format)': 'GUID'
                }
              }
            }
          };
        }
      }

      Object.defineProperty(RemoveReactionRequest.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.comments.RemoveReactionRequest');
        },
        enumerable: false,
        configurable: false
      });
      return RemoveReactionRequest;
    }());
    comments.RepliesRequest = (function() {

      class RepliesRequest {

        constructor(props) {
          this.repliesToLoad = props && props.repliesToLoad;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.repliesToLoad != null) {
              if (!Number.isInteger(msg.repliesToLoad)) {
                errors.field('repliesToLoad').error('integer expected');
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.repliesToLoad != null) {
              json.repliesToLoad = obj.repliesToLoad;
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.comments.RepliesRequest();

          if (json.repliesToLoad != null) {
            result.repliesToLoad = json.repliesToLoad;
          } else {
            result.repliesToLoad = 0;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.repliesToLoad != null) {
              grpc.repliesToLoad = obj.repliesToLoad;
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.comments.RepliesRequest();

            if (grpc.repliesToLoad != null) {
              result.repliesToLoad = grpc.repliesToLoad;
            } else {
              result.repliesToLoad = 0;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'repliesToLoad': {
                'type': 'int32',
                'id': 1
              }
            }
          };
        }
      }

      Object.defineProperty(RepliesRequest.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.comments.RepliesRequest');
        },
        enumerable: false,
        configurable: false
      });
      return RepliesRequest;
    }());
    comments.ReportRequest = (function() {

      class ReportRequest {

        constructor(props) {
          this.contextToken = props && props.contextToken;
          this.commentId = props && props.commentId;
          this.reportType = props && props.reportType;
          this.fieldset = props && props.fieldset;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.contextToken != null) {
              $root.google.protobuf.StringValue.verify(msg.contextToken, helper, errors.field('contextToken'));
            }
            if (msg.commentId != null) {
              if (typeof msg.commentId !== 'string') {
                errors.field('commentId').error('string expected');
              }
            }
            if (msg.reportType != null) {
              $root.wix.comments.ReportType.verify(msg.reportType, helper, errors.field('reportType'));
            }
            if (msg.fieldset != null) {
              $root.google.protobuf.StringValue.verify(msg.fieldset, helper, errors.field('fieldset'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.contextToken != null) {
              json.contextToken = $root.google.protobuf.StringValue.toJSON(obj.contextToken, helper);
            }
            if (obj.commentId != null) {
              json.commentId = obj.commentId;
            }
            if (obj.reportType != null) {
              json.reportType = $root.wix.comments.ReportType[obj.reportType];
            }
            if (obj.fieldset != null) {
              json.fieldset = $root.google.protobuf.StringValue.toJSON(obj.fieldset, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.comments.ReportRequest();

          if (json.contextToken != null) {
            result.contextToken = $root.google.protobuf.StringValue.fromJSON(json.contextToken, helper);
          } else {
            delete result.contextToken;
          }
          if (json.commentId != null) {
            result.commentId = json.commentId;
          } else {
            result.commentId = '';
          }
          if (json.reportType != null) {
            result.reportType = $root.wix.comments.ReportType[json.reportType];
          } else {
            result.reportType = 'UNWANTED_CONTENT';
          }
          if (json.fieldset != null) {
            result.fieldset = $root.google.protobuf.StringValue.fromJSON(json.fieldset, helper);
          } else {
            delete result.fieldset;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.contextToken != null) {
              grpc.contextToken = $root.google.protobuf.StringValue.toGRPC(obj.contextToken, helper);
            }
            if (obj.commentId != null) {
              grpc.commentId = obj.commentId;
            }
            if (obj.reportType != null) {
              grpc.reportType = obj.reportType;
            }
            if (obj.fieldset != null) {
              grpc.fieldset = $root.google.protobuf.StringValue.toGRPC(obj.fieldset, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.comments.ReportRequest();

            if (grpc.contextToken != null) {
              result.contextToken = $root.google.protobuf.StringValue.fromGRPC(grpc.contextToken, helper);
            } else {
              delete result.contextToken;
            }
            if (grpc.commentId != null) {
              result.commentId = grpc.commentId;
            } else {
              result.commentId = '';
            }
            if (grpc.reportType != null) {
              result.reportType = grpc.reportType;
            } else {
              result.reportType = 'UNWANTED_CONTENT';
            }
            if (grpc.fieldset != null) {
              result.fieldset = $root.google.protobuf.StringValue.fromGRPC(grpc.fieldset, helper);
            } else {
              delete result.fieldset;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'contextToken': {
                'type': $root.google.protobuf.StringValue,
                'id': 1
              },
              'commentId': {
                'type': 'string',
                'id': 2,
                'options': {
                  '(wix.api.format)': 'GUID'
                }
              },
              'reportType': {
                'type': $root.wix.comments.ReportType,
                'id': 3
              },
              'fieldset': {
                'type': $root.google.protobuf.StringValue,
                'id': 4
              }
            }
          };
        }
      }

      Object.defineProperty(ReportRequest.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.comments.ReportRequest');
        },
        enumerable: false,
        configurable: false
      });
      return ReportRequest;
    }());
    comments.ReportResponse = (function() {

      class ReportResponse {

        constructor(props) {
          this.comment = props && props.comment;
          this.profiles = props && props.profiles;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.comment != null) {
              $root.wix.comments.Comment.verify(msg.comment, helper, errors.field('comment'));
            }
            if (msg.profiles != null) {
              $root.wix.social.Profiles.verify(msg.profiles, helper, errors.field('profiles'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.comment != null) {
              json.comment = $root.wix.comments.Comment.toJSON(obj.comment, helper);
            }
            if (obj.profiles != null) {
              json.profiles = $root.wix.social.Profiles.toJSON(obj.profiles, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.comments.ReportResponse();

          if (json.comment != null) {
            result.comment = $root.wix.comments.Comment.fromJSON(json.comment, helper);
          } else {
            delete result.comment;
          }
          if (json.profiles != null) {
            result.profiles = $root.wix.social.Profiles.fromJSON(json.profiles, helper);
          } else {
            delete result.profiles;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.comment != null) {
              grpc.comment = $root.wix.comments.Comment.toGRPC(obj.comment, helper);
            }
            if (obj.profiles != null) {
              grpc.profiles = $root.wix.social.Profiles.toGRPC(obj.profiles, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.comments.ReportResponse();

            if (grpc.comment != null) {
              result.comment = $root.wix.comments.Comment.fromGRPC(grpc.comment, helper);
            } else {
              delete result.comment;
            }
            if (grpc.profiles != null) {
              result.profiles = $root.wix.social.Profiles.fromGRPC(grpc.profiles, helper);
            } else {
              delete result.profiles;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'comment': {
                'type': $root.wix.comments.Comment,
                'id': 1
              },
              'profiles': {
                'type': $root.wix.social.Profiles,
                'id': 2
              }
            }
          };
        }
      }

      Object.defineProperty(ReportResponse.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.comments.ReportResponse');
        },
        enumerable: false,
        configurable: false
      });
      return ReportResponse;
    }());
    comments.GetReportsRequest = (function() {

      class GetReportsRequest {

        constructor(props) {
          this.contextToken = props && props.contextToken;
          this.commentId = props && props.commentId;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.contextToken != null) {
              $root.google.protobuf.StringValue.verify(msg.contextToken, helper, errors.field('contextToken'));
            }
            if (msg.commentId != null) {
              if (typeof msg.commentId !== 'string') {
                errors.field('commentId').error('string expected');
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.contextToken != null) {
              json.contextToken = $root.google.protobuf.StringValue.toJSON(obj.contextToken, helper);
            }
            if (obj.commentId != null) {
              json.commentId = obj.commentId;
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.comments.GetReportsRequest();

          if (json.contextToken != null) {
            result.contextToken = $root.google.protobuf.StringValue.fromJSON(json.contextToken, helper);
          } else {
            delete result.contextToken;
          }
          if (json.commentId != null) {
            result.commentId = json.commentId;
          } else {
            result.commentId = '';
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.contextToken != null) {
              grpc.contextToken = $root.google.protobuf.StringValue.toGRPC(obj.contextToken, helper);
            }
            if (obj.commentId != null) {
              grpc.commentId = obj.commentId;
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.comments.GetReportsRequest();

            if (grpc.contextToken != null) {
              result.contextToken = $root.google.protobuf.StringValue.fromGRPC(grpc.contextToken, helper);
            } else {
              delete result.contextToken;
            }
            if (grpc.commentId != null) {
              result.commentId = grpc.commentId;
            } else {
              result.commentId = '';
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'contextToken': {
                'type': $root.google.protobuf.StringValue,
                'id': 1
              },
              'commentId': {
                'type': 'string',
                'id': 2,
                'options': {
                  '(wix.api.format)': 'GUID'
                }
              }
            }
          };
        }
      }

      Object.defineProperty(GetReportsRequest.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.comments.GetReportsRequest');
        },
        enumerable: false,
        configurable: false
      });
      return GetReportsRequest;
    }());
    comments.GetReportsResponse = (function() {

      class GetReportsResponse {

        constructor(props) {
          this.reported = props && props.reported;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.reported != null) {
              $root.wix.comments.Reported.verify(msg.reported, helper, errors.field('reported'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.reported != null) {
              json.reported = $root.wix.comments.Reported.toJSON(obj.reported, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.comments.GetReportsResponse();

          if (json.reported != null) {
            result.reported = $root.wix.comments.Reported.fromJSON(json.reported, helper);
          } else {
            delete result.reported;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.reported != null) {
              grpc.reported = $root.wix.comments.Reported.toGRPC(obj.reported, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.comments.GetReportsResponse();

            if (grpc.reported != null) {
              result.reported = $root.wix.comments.Reported.fromGRPC(grpc.reported, helper);
            } else {
              delete result.reported;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'reported': {
                'type': $root.wix.comments.Reported,
                'id': 1
              }
            }
          };
        }
      }

      Object.defineProperty(GetReportsResponse.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.comments.GetReportsResponse');
        },
        enumerable: false,
        configurable: false
      });
      return GetReportsResponse;
    }());
    comments.gdpr = (function() {
      const gdpr = {};

      gdpr.GdprService = (function() {

        class GdprService {

          constructor() {
            if (this.constructor.name === GdprService.name) {
              throw new TypeError('class GdprService is abstract');
            }
          }

          access(aspects, msg) {
            throw new TypeError('method access is abstract');
          }

          forget(aspects, msg) {
            throw new TypeError('method forget is abstract');
          }
        }

        GdprService.prototype.access._messageTypes = function() {
          return [
            $root.wix.comments.gdpr.AccessRequest,
            $root.wix.comments.gdpr.AccessResponse
          ];
        };
        GdprService.prototype.forget._messageTypes = function() {
          return [
            $root.wix.comments.gdpr.ForgetRequest,
            $root.wix.comments.gdpr.ForgetResponse
          ];
        };
        GdprService.prototype.access.__proto = pbjs => {
          return $root.__lookup(pbjs)('wix.comments.gdpr.GdprService.Access');
        };
        GdprService.prototype.forget.__proto = pbjs => {
          return $root.__lookup(pbjs)('wix.comments.gdpr.GdprService.Forget');
        };
        Object.defineProperty(GdprService.prototype, '__isRpcService__', {
          value: true,
          enumerable: false,
          configurable: false
        });
        Object.defineProperty(GdprService.prototype, '__fqn__', {
          value: 'wix.comments.gdpr.GdprService',
          enumerable: false,
          configurable: false
        });
        Object.defineProperty(GdprService.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('wix.comments.gdpr.GdprService');
          },
          enumerable: false,
          configurable: false
        });
        Object.defineProperty(GdprService.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        return GdprService;
      }());
      gdpr.AccessRequest = (function() {

        class AccessRequest {

          constructor(props) {}

          static verify(msg, helper, errors = helper.verification.Errors.empty()) {
            if (typeof msg !== 'object' || msg == null) {
              errors.error('object expected');
            } else {
              if (!(typeof msg === 'object' && !Array.isArray(msg) && Object.keys(msg).length === 0)) {
                errors.error('empty object expected');
              }
            }
            return errors;
          }

          static toJSON(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const json = {};

              return json;
            }
          }

          static fromJSON(json, helper) {
            const result = new $root.wix.comments.gdpr.AccessRequest();

            return result;
          }

          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};

              return grpc;
            }
          }

          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.wix.comments.gdpr.AccessRequest();

              return result;
            }
          }

          static describe() {
            return {
              'fields': {}
            };
          }
        }

        Object.defineProperty(AccessRequest.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('wix.comments.gdpr.AccessRequest');
          },
          enumerable: false,
          configurable: false
        });
        return AccessRequest;
      }());
      gdpr.AccessResponse = (function() {

        class AccessResponse {

          constructor(props) {
            this.comments = props && props.comments;
            this.actions = props && props.actions;
          }

          static verify(msg, helper, errors = helper.verification.Errors.empty()) {
            if (typeof msg !== 'object' || msg == null) {
              errors.error('object expected');
            } else {
              if (msg.comments != null) {
                const fieldErrors = errors.field('comments');

                if (!Array.isArray(msg.comments)) {
                  fieldErrors.error('array expected');
                } else {
                  msg.comments.forEach((value, index) => {
                    $root.wix.comments.gdpr.GdprComment.verify(value, helper, fieldErrors.index(index));
                  });
                }
              }
              if (msg.actions != null) {
                const fieldErrors = errors.field('actions');

                if (!Array.isArray(msg.actions)) {
                  fieldErrors.error('array expected');
                } else {
                  msg.actions.forEach((value, index) => {
                    $root.wix.comments.gdpr.GdprCommentAction.verify(value, helper, fieldErrors.index(index));
                  });
                }
              }
            }
            return errors;
          }

          static toJSON(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const json = {};

              if (obj.comments != null) {
                json.comments = obj.comments.map(e => {
                  return $root.wix.comments.gdpr.GdprComment.toJSON(e, helper);
                });
              }
              if (obj.actions != null) {
                json.actions = obj.actions.map(e => {
                  return $root.wix.comments.gdpr.GdprCommentAction.toJSON(e, helper);
                });
              }
              return json;
            }
          }

          static fromJSON(json, helper) {
            const result = new $root.wix.comments.gdpr.AccessResponse();

            if (json.comments != null) {
              result.comments = json.comments.map(e => {
                return $root.wix.comments.gdpr.GdprComment.fromJSON(e, helper);
              });
            } else {
              result.comments = [];
            }
            if (json.actions != null) {
              result.actions = json.actions.map(e => {
                return $root.wix.comments.gdpr.GdprCommentAction.fromJSON(e, helper);
              });
            } else {
              result.actions = [];
            }
            return result;
          }

          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};

              if (obj.comments != null) {
                grpc.comments = obj.comments.map(e => {
                  return $root.wix.comments.gdpr.GdprComment.toGRPC(e, helper);
                });
              }
              if (obj.actions != null) {
                grpc.actions = obj.actions.map(e => {
                  return $root.wix.comments.gdpr.GdprCommentAction.toGRPC(e, helper);
                });
              }
              return grpc;
            }
          }

          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.wix.comments.gdpr.AccessResponse();

              if (grpc.comments != null) {
                result.comments = grpc.comments.map(e => {
                  return $root.wix.comments.gdpr.GdprComment.fromGRPC(e, helper);
                });
              } else {
                result.comments = [];
              }
              if (grpc.actions != null) {
                result.actions = grpc.actions.map(e => {
                  return $root.wix.comments.gdpr.GdprCommentAction.fromGRPC(e, helper);
                });
              } else {
                result.actions = [];
              }
              return result;
            }
          }

          static describe() {
            return {
              'fields': {
                'comments': {
                  'rule': 'repeated',
                  'type': $root.wix.comments.gdpr.GdprComment,
                  'id': 1
                },
                'actions': {
                  'rule': 'repeated',
                  'type': $root.wix.comments.gdpr.GdprCommentAction,
                  'id': 2
                }
              }
            };
          }
        }

        Object.defineProperty(AccessResponse.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('wix.comments.gdpr.AccessResponse');
          },
          enumerable: false,
          configurable: false
        });
        return AccessResponse;
      }());
      gdpr.GdprComment = (function() {

        class GdprComment {

          constructor(props) {
            this.comment = props && props.comment;
            this.status = props && props.status;
          }

          static verify(msg, helper, errors = helper.verification.Errors.empty()) {
            if (typeof msg !== 'object' || msg == null) {
              errors.error('object expected');
            } else {
              if (msg.comment != null) {
                $root.wix.comments.Comment.verify(msg.comment, helper, errors.field('comment'));
              }
              if (msg.status != null) {
                $root.wix.comments.gdpr.GdprComment.Status.verify(msg.status, helper, errors.field('status'));
              }
            }
            return errors;
          }

          static toJSON(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const json = {};

              if (obj.comment != null) {
                json.comment = $root.wix.comments.Comment.toJSON(obj.comment, helper);
              }
              if (obj.status != null) {
                json.status = $root.wix.comments.gdpr.GdprComment.Status[obj.status];
              }
              return json;
            }
          }

          static fromJSON(json, helper) {
            const result = new $root.wix.comments.gdpr.GdprComment();

            if (json.comment != null) {
              result.comment = $root.wix.comments.Comment.fromJSON(json.comment, helper);
            } else {
              delete result.comment;
            }
            if (json.status != null) {
              result.status = $root.wix.comments.gdpr.GdprComment.Status[json.status];
            } else {
              result.status = 'CREATED';
            }
            return result;
          }

          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};

              if (obj.comment != null) {
                grpc.comment = $root.wix.comments.Comment.toGRPC(obj.comment, helper);
              }
              if (obj.status != null) {
                grpc.status = obj.status;
              }
              return grpc;
            }
          }

          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.wix.comments.gdpr.GdprComment();

              if (grpc.comment != null) {
                result.comment = $root.wix.comments.Comment.fromGRPC(grpc.comment, helper);
              } else {
                delete result.comment;
              }
              if (grpc.status != null) {
                result.status = grpc.status;
              } else {
                result.status = 'CREATED';
              }
              return result;
            }
          }

          static describe() {
            return {
              'fields': {
                'comment': {
                  'type': $root.wix.comments.Comment,
                  'id': 1
                },
                'status': {
                  'type': $root.wix.comments.gdpr.GdprComment.Status,
                  'id': 2
                }
              },
              'nested': {
                'Status': {
                  'values': {
                    'CREATED': 0,
                    'REMOVED': 1
                  }
                }
              }
            };
          }
        }

        GdprComment.Status = {
          verify: (value, helper, errors = helper.verification.Errors.empty()) => {
            switch (value) {
              default: {
                errors.error('enum expected');
              }
              case 'CREATED':
              case 'REMOVED':
                break;
            }
            return errors;
          },
          'CREATED': 'CREATED',
          'REMOVED': 'REMOVED'
        };
        GdprComment.Status = {
          verify: (value, helper, errors = helper.verification.Errors.empty()) => {
            switch (value) {
              default: {
                errors.error('enum expected');
              }
              case 'CREATED':
              case 'REMOVED':
                break;
            }
            return errors;
          },
          'CREATED': 'CREATED',
          'REMOVED': 'REMOVED'
        };
        Object.defineProperty(GdprComment.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('wix.comments.gdpr.GdprComment');
          },
          enumerable: false,
          configurable: false
        });
        return GdprComment;
      }());
      gdpr.GdprCommentAction = (function() {

        class GdprCommentAction {

          constructor(props) {
            this.commentId = props && props.commentId;
            this.actionType = props && props.actionType;
            this.timestamp = props && props.timestamp;
            this.data = props && props.data;
          }

          static verify(msg, helper, errors = helper.verification.Errors.empty()) {
            if (typeof msg !== 'object' || msg == null) {
              errors.error('object expected');
            } else {
              if (msg.commentId != null) {
                if (typeof msg.commentId !== 'string') {
                  errors.field('commentId').error('string expected');
                }
              }
              if (msg.actionType != null) {
                if (typeof msg.actionType !== 'string') {
                  errors.field('actionType').error('string expected');
                }
              }
              if (msg.timestamp != null) {
                $root.google.protobuf.Timestamp.verify(msg.timestamp, helper, errors.field('timestamp'));
              }
              if (msg.data != null) {
                $root.google.protobuf.Value.verify(msg.data, helper, errors.field('data'));
              }
            }
            return errors;
          }

          static toJSON(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const json = {};

              if (obj.commentId != null) {
                json.commentId = obj.commentId;
              }
              if (obj.actionType != null) {
                json.actionType = obj.actionType;
              }
              if (obj.timestamp != null) {
                json.timestamp = $root.google.protobuf.Timestamp.toJSON(obj.timestamp, helper);
              }
              if (obj.data != null) {
                json.data = $root.google.protobuf.Value.toJSON(obj.data, helper);
              }
              return json;
            }
          }

          static fromJSON(json, helper) {
            const result = new $root.wix.comments.gdpr.GdprCommentAction();

            if (json.commentId != null) {
              result.commentId = json.commentId;
            } else {
              result.commentId = '';
            }
            if (json.actionType != null) {
              result.actionType = json.actionType;
            } else {
              result.actionType = '';
            }
            if (json.timestamp != null) {
              result.timestamp = $root.google.protobuf.Timestamp.fromJSON(json.timestamp, helper);
            } else {
              delete result.timestamp;
            }
            if (json.data != null) {
              result.data = $root.google.protobuf.Value.fromJSON(json.data, helper);
            } else {
              delete result.data;
            }
            return result;
          }

          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};

              if (obj.commentId != null) {
                grpc.commentId = obj.commentId;
              }
              if (obj.actionType != null) {
                grpc.actionType = obj.actionType;
              }
              if (obj.timestamp != null) {
                grpc.timestamp = $root.google.protobuf.Timestamp.toGRPC(obj.timestamp, helper);
              }
              grpc.data = ($root.google.protobuf.Value.toGRPC(obj.data, helper));
              return grpc;
            }
          }

          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.wix.comments.gdpr.GdprCommentAction();

              if (grpc.commentId != null) {
                result.commentId = grpc.commentId;
              } else {
                result.commentId = '';
              }
              if (grpc.actionType != null) {
                result.actionType = grpc.actionType;
              } else {
                result.actionType = '';
              }
              if (grpc.timestamp != null) {
                result.timestamp = $root.google.protobuf.Timestamp.fromGRPC(grpc.timestamp, helper);
              } else {
                delete result.timestamp;
              }
              if (grpc.data != null) {
                result.data = $root.google.protobuf.Value.fromGRPC(grpc.data, helper);
              } else {
                delete result.data;
              }
              return result;
            }
          }

          static describe() {
            return {
              'fields': {
                'commentId': {
                  'type': 'string',
                  'id': 1
                },
                'actionType': {
                  'type': 'string',
                  'id': 2
                },
                'timestamp': {
                  'type': $root.google.protobuf.Timestamp,
                  'id': 3
                },
                'data': {
                  'type': $root.google.protobuf.Value,
                  'id': 4
                }
              }
            };
          }
        }

        Object.defineProperty(GdprCommentAction.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('wix.comments.gdpr.GdprCommentAction');
          },
          enumerable: false,
          configurable: false
        });
        return GdprCommentAction;
      }());
      gdpr.ForgetRequest = (function() {

        class ForgetRequest {

          constructor(props) {}

          static verify(msg, helper, errors = helper.verification.Errors.empty()) {
            if (typeof msg !== 'object' || msg == null) {
              errors.error('object expected');
            } else {
              if (!(typeof msg === 'object' && !Array.isArray(msg) && Object.keys(msg).length === 0)) {
                errors.error('empty object expected');
              }
            }
            return errors;
          }

          static toJSON(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const json = {};

              return json;
            }
          }

          static fromJSON(json, helper) {
            const result = new $root.wix.comments.gdpr.ForgetRequest();

            return result;
          }

          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};

              return grpc;
            }
          }

          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.wix.comments.gdpr.ForgetRequest();

              return result;
            }
          }

          static describe() {
            return {
              'fields': {}
            };
          }
        }

        Object.defineProperty(ForgetRequest.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('wix.comments.gdpr.ForgetRequest');
          },
          enumerable: false,
          configurable: false
        });
        return ForgetRequest;
      }());
      gdpr.ForgetResponse = (function() {

        class ForgetResponse {

          constructor(props) {}

          static verify(msg, helper, errors = helper.verification.Errors.empty()) {
            if (typeof msg !== 'object' || msg == null) {
              errors.error('object expected');
            } else {
              if (!(typeof msg === 'object' && !Array.isArray(msg) && Object.keys(msg).length === 0)) {
                errors.error('empty object expected');
              }
            }
            return errors;
          }

          static toJSON(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const json = {};

              return json;
            }
          }

          static fromJSON(json, helper) {
            const result = new $root.wix.comments.gdpr.ForgetResponse();

            return result;
          }

          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};

              return grpc;
            }
          }

          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.wix.comments.gdpr.ForgetResponse();

              return result;
            }
          }

          static describe() {
            return {
              'fields': {}
            };
          }
        }

        Object.defineProperty(ForgetResponse.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('wix.comments.gdpr.ForgetResponse');
          },
          enumerable: false,
          configurable: false
        });
        return ForgetResponse;
      }());
      return gdpr;
    }());
    comments.FeedPageCursor = (function() {

      class FeedPageCursor {

        constructor(props) {
          this.fromEventId = props && props.fromEventId;
          this.priorityTag = props && props.priorityTag;
          this.pageQuery = props && props.pageQuery;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.fromEventId != null) {
              if (!Number.isInteger(msg.fromEventId) && !Long.isLong(msg.fromEventId)) {
                errors.field('fromEventId').error('long or integer expected');
              }
            }
            if (msg.priorityTag != null) {
              $root.wix.comments.FeedPageCursor.PriorityTag.verify(msg.priorityTag, helper, errors.field('priorityTag'));
            }
            if (msg.pageQuery != null) {
              $root.wix.comments.FeedPageQuery.verify(msg.pageQuery, helper, errors.field('pageQuery'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.fromEventId != null) {
              json.fromEventId = obj.fromEventId.toString();
            }
            if (obj.priorityTag != null) {
              json.priorityTag = $root.wix.comments.FeedPageCursor.PriorityTag[obj.priorityTag];
            }
            if (obj.pageQuery != null) {
              json.pageQuery = $root.wix.comments.FeedPageQuery.toJSON(obj.pageQuery, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.comments.FeedPageCursor();

          if (json.fromEventId != null) {
            result.fromEventId = Long.fromValue(json.fromEventId);
          } else {
            result.fromEventId = Long.ZERO;
          }
          if (json.priorityTag != null) {
            result.priorityTag = $root.wix.comments.FeedPageCursor.PriorityTag[json.priorityTag];
          } else {
            result.priorityTag = 'REMAINING';
          }
          if (json.pageQuery != null) {
            result.pageQuery = $root.wix.comments.FeedPageQuery.fromJSON(json.pageQuery, helper);
          } else {
            delete result.pageQuery;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.fromEventId != null) {
              grpc.fromEventId = obj.fromEventId.toString();
            }
            if (obj.priorityTag != null) {
              grpc.priorityTag = obj.priorityTag;
            }
            if (obj.pageQuery != null) {
              grpc.pageQuery = $root.wix.comments.FeedPageQuery.toGRPC(obj.pageQuery, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.comments.FeedPageCursor();

            if (grpc.fromEventId != null) {
              result.fromEventId = Long.fromValue(grpc.fromEventId);
            } else {
              result.fromEventId = Long.ZERO;
            }
            if (grpc.priorityTag != null) {
              result.priorityTag = grpc.priorityTag;
            } else {
              result.priorityTag = 'REMAINING';
            }
            if (grpc.pageQuery != null) {
              result.pageQuery = $root.wix.comments.FeedPageQuery.fromGRPC(grpc.pageQuery, helper);
            } else {
              delete result.pageQuery;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'fromEventId': {
                'type': 'int64',
                'id': 1
              },
              'priorityTag': {
                'type': $root.wix.comments.FeedPageCursor.PriorityTag,
                'id': 2
              },
              'pageQuery': {
                'type': $root.wix.comments.FeedPageQuery,
                'id': 3
              }
            },
            'nested': {
              'PriorityTag': {
                'values': {
                  'REMAINING': 0,
                  'PINNED': 1
                }
              }
            }
          };
        }
      }

      FeedPageCursor.PriorityTag = {
        verify: (value, helper, errors = helper.verification.Errors.empty()) => {
          switch (value) {
            default: {
              errors.error('enum expected');
            }
            case 'REMAINING':
            case 'PINNED':
              break;
          }
          return errors;
        },
        'REMAINING': 'REMAINING',
        'PINNED': 'PINNED'
      };
      FeedPageCursor.PriorityTag = {
        verify: (value, helper, errors = helper.verification.Errors.empty()) => {
          switch (value) {
            default: {
              errors.error('enum expected');
            }
            case 'REMAINING':
            case 'PINNED':
              break;
          }
          return errors;
        },
        'REMAINING': 'REMAINING',
        'PINNED': 'PINNED'
      };
      Object.defineProperty(FeedPageCursor.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.comments.FeedPageCursor');
        },
        enumerable: false,
        configurable: false
      });
      return FeedPageCursor;
    }());
    comments.FeedPageQuery = (function() {

      class FeedPageQuery {

        constructor(props) {
          this.identityId = props && props.identityId;
          this.excludeOwn = props && props.excludeOwn;
          this.limit = props && props.limit;
          this.filter = props && props.filter;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.identityId != null) {
              $root.google.protobuf.StringValue.verify(msg.identityId, helper, errors.field('identityId'));
            }
            if (msg.excludeOwn != null) {
              if (typeof msg.excludeOwn !== 'boolean') {
                errors.field('excludeOwn').error('boolean expected');
              }
            }
            if (msg.limit != null) {
              $root.google.protobuf.Int32Value.verify(msg.limit, helper, errors.field('limit'));
            }
            if (msg.filter != null) {
              $root.wix.comments.Filter.verify(msg.filter, helper, errors.field('filter'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.identityId != null) {
              json.identityId = $root.google.protobuf.StringValue.toJSON(obj.identityId, helper);
            }
            if (obj.excludeOwn != null) {
              json.excludeOwn = obj.excludeOwn;
            }
            if (obj.limit != null) {
              json.limit = $root.google.protobuf.Int32Value.toJSON(obj.limit, helper);
            }
            if (obj.filter != null) {
              json.filter = $root.wix.comments.Filter.toJSON(obj.filter, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.comments.FeedPageQuery();

          if (json.identityId != null) {
            result.identityId = $root.google.protobuf.StringValue.fromJSON(json.identityId, helper);
          } else {
            delete result.identityId;
          }
          if (json.excludeOwn != null) {
            result.excludeOwn = json.excludeOwn;
          } else {
            result.excludeOwn = false;
          }
          if (json.limit != null) {
            result.limit = $root.google.protobuf.Int32Value.fromJSON(json.limit, helper);
          } else {
            delete result.limit;
          }
          if (json.filter != null) {
            result.filter = $root.wix.comments.Filter.fromJSON(json.filter, helper);
          } else {
            delete result.filter;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.identityId != null) {
              grpc.identityId = $root.google.protobuf.StringValue.toGRPC(obj.identityId, helper);
            }
            if (obj.excludeOwn != null) {
              grpc.excludeOwn = obj.excludeOwn;
            }
            if (obj.limit != null) {
              grpc.limit = $root.google.protobuf.Int32Value.toGRPC(obj.limit, helper);
            }
            if (obj.filter != null) {
              grpc.filter = $root.wix.comments.Filter.toGRPC(obj.filter, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.comments.FeedPageQuery();

            if (grpc.identityId != null) {
              result.identityId = $root.google.protobuf.StringValue.fromGRPC(grpc.identityId, helper);
            } else {
              delete result.identityId;
            }
            if (grpc.excludeOwn != null) {
              result.excludeOwn = grpc.excludeOwn;
            } else {
              result.excludeOwn = false;
            }
            if (grpc.limit != null) {
              result.limit = $root.google.protobuf.Int32Value.fromGRPC(grpc.limit, helper);
            } else {
              delete result.limit;
            }
            if (grpc.filter != null) {
              result.filter = $root.wix.comments.Filter.fromGRPC(grpc.filter, helper);
            } else {
              delete result.filter;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'identityId': {
                'type': $root.google.protobuf.StringValue,
                'id': 1
              },
              'excludeOwn': {
                'type': 'bool',
                'id': 2
              },
              'limit': {
                'type': $root.google.protobuf.Int32Value,
                'id': 3
              },
              'filter': {
                'type': $root.wix.comments.Filter,
                'id': 4
              }
            }
          };
        }
      }

      Object.defineProperty(FeedPageQuery.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.comments.FeedPageQuery');
        },
        enumerable: false,
        configurable: false
      });
      return FeedPageQuery;
    }());
    comments.Filter = (function() {

      class Filter {

        constructor(props) {
          this.rules = props && props.rules;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.rules != null) {
              const fieldErrors = errors.field('rules');

              if (!Array.isArray(msg.rules)) {
                fieldErrors.error('array expected');
              } else {
                msg.rules.forEach((value, index) => {
                  $root.wix.comments.FilterRule.verify(value, helper, fieldErrors.index(index));
                });
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.rules != null) {
              json.rules = obj.rules.map(e => {
                return $root.wix.comments.FilterRule.toJSON(e, helper);
              });
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.comments.Filter();

          if (json.rules != null) {
            result.rules = json.rules.map(e => {
              return $root.wix.comments.FilterRule.fromJSON(e, helper);
            });
          } else {
            result.rules = [];
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.rules != null) {
              grpc.rules = obj.rules.map(e => {
                return $root.wix.comments.FilterRule.toGRPC(e, helper);
              });
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.comments.Filter();

            if (grpc.rules != null) {
              result.rules = grpc.rules.map(e => {
                return $root.wix.comments.FilterRule.fromGRPC(e, helper);
              });
            } else {
              result.rules = [];
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'rules': {
                'rule': 'repeated',
                'type': $root.wix.comments.FilterRule,
                'id': 1
              }
            }
          };
        }
      }

      Object.defineProperty(Filter.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.comments.Filter');
        },
        enumerable: false,
        configurable: false
      });
      return Filter;
    }());
    comments.FilterRule = (function() {

      class FilterRule {

        constructor(props) {
          this.fieldFilter = props && props.fieldFilter;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            const oneOfMutex = {};

            if (msg.fieldFilter != null) {
              if (oneOfMutex['rule']) {
                errors.field('fieldFilter').up().field('rule').error('multiple values');
              } else {
                oneOfMutex['rule'] = true;
                $root.wix.comments.FieldFilter.verify(msg.fieldFilter, helper, errors.field('fieldFilter'));
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.fieldFilter != null) {
              json.fieldFilter = $root.wix.comments.FieldFilter.toJSON(obj.fieldFilter, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.comments.FilterRule();

          if (json.fieldFilter != null) {
            result.fieldFilter = $root.wix.comments.FieldFilter.fromJSON(json.fieldFilter, helper);
          } else {
            delete result.fieldFilter;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.fieldFilter != null) {
              grpc.fieldFilter = $root.wix.comments.FieldFilter.toGRPC(obj.fieldFilter, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.comments.FilterRule();

            if (grpc.fieldFilter != null) {
              result.fieldFilter = $root.wix.comments.FieldFilter.fromGRPC(grpc.fieldFilter, helper);
            } else {
              delete result.fieldFilter;
            }
            return result;
          }
        }

        static describe() {
          return {
            'oneofs': {
              'rule': {
                'oneof': ['fieldFilter']
              }
            },
            'fields': {
              'fieldFilter': {
                'type': $root.wix.comments.FieldFilter,
                'id': 1
              }
            }
          };
        }
      }

      Object.defineProperty(FilterRule.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.comments.FilterRule');
        },
        enumerable: false,
        configurable: false
      });
      return FilterRule;
    }());
    comments.FieldFilter = (function() {

      class FieldFilter {

        constructor(props) {
          this.name = props && props.name;
          this.filter = props && props.filter;
          this.exactString = props && props.exactString;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            const oneOfMutex = {};

            if (msg.name != null) {
              if (typeof msg.name !== 'string') {
                errors.field('name').error('string expected');
              }
            }
            if (msg.filter != null) {
              if (oneOfMutex['match']) {
                errors.field('filter').up().field('match').error('multiple values');
              } else {
                oneOfMutex['match'] = true;
                $root.wix.comments.Filter.verify(msg.filter, helper, errors.field('filter'));
              }
            }
            if (msg.exactString != null) {
              if (oneOfMutex['match']) {
                errors.field('exactString').up().field('match').error('multiple values');
              } else {
                oneOfMutex['match'] = true;
                if (typeof msg.exactString !== 'string') {
                  errors.field('exactString').error('string expected');
                }
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.name != null) {
              json.name = obj.name;
            }
            if (obj.filter != null) {
              json.filter = $root.wix.comments.Filter.toJSON(obj.filter, helper);
            }
            if (obj.exactString != null) {
              json.exactString = obj.exactString;
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.comments.FieldFilter();

          if (json.name != null) {
            result.name = json.name;
          } else {
            result.name = '';
          }
          if (json.filter != null) {
            result.filter = $root.wix.comments.Filter.fromJSON(json.filter, helper);
          } else {
            delete result.filter;
          }
          if (json.exactString != null) {
            result.exactString = json.exactString;
          } else {
            delete result.exactString;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.name != null) {
              grpc.name = obj.name;
            }
            if (obj.filter != null) {
              grpc.filter = $root.wix.comments.Filter.toGRPC(obj.filter, helper);
            }
            if (obj.exactString != null) {
              grpc.exactString = obj.exactString;
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.comments.FieldFilter();

            if (grpc.name != null) {
              result.name = grpc.name;
            } else {
              result.name = '';
            }
            if (grpc.filter != null) {
              result.filter = $root.wix.comments.Filter.fromGRPC(grpc.filter, helper);
            } else {
              delete result.filter;
            }
            if (grpc.exactString != null) {
              result.exactString = grpc.exactString;
            } else {
              delete result.exactString;
            }
            return result;
          }
        }

        static describe() {
          return {
            'oneofs': {
              'match': {
                'oneof': [
                  'filter',
                  'exactString'
                ]
              }
            },
            'fields': {
              'name': {
                'type': 'string',
                'id': 1
              },
              'filter': {
                'type': $root.wix.comments.Filter,
                'id': 2
              },
              'exactString': {
                'type': 'string',
                'id': 3
              }
            }
          };
        }
      }

      Object.defineProperty(FieldFilter.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.comments.FieldFilter');
        },
        enumerable: false,
        configurable: false
      });
      return FieldFilter;
    }());
    return comments;
  }());
  wix.api = (function() {
    const api = {};

    api.Format = {
      verify: (value, helper, errors = helper.verification.Errors.empty()) => {
        switch (value) {
          default: {
            errors.error('enum expected');
          }
          case 'EMAIL':
          case 'HOSTNAME':
          case 'IPV4':
          case 'IPV6':
          case 'URI':
          case 'PHONE':
          case 'CREDIT_CARD':
          case 'GUID':
          case 'COUNTRY':
          case 'LANGUAGE':
          case 'DECIMAL_VALUE':
          case 'CURRENCY':
            break;
        }
        return errors;
      },
      'EMAIL': 'EMAIL',
      'HOSTNAME': 'HOSTNAME',
      'IPV4': 'IPV4',
      'IPV6': 'IPV6',
      'URI': 'URI',
      'PHONE': 'PHONE',
      'CREDIT_CARD': 'CREDIT_CARD',
      'GUID': 'GUID',
      'COUNTRY': 'COUNTRY',
      'LANGUAGE': 'LANGUAGE',
      'DECIMAL_VALUE': 'DECIMAL_VALUE',
      'CURRENCY': 'CURRENCY'
    };
    api.Exposure = {
      verify: (value, helper, errors = helper.verification.Errors.empty()) => {
        switch (value) {
          default: {
            errors.error('enum expected');
          }
          case 'PRIVATE':
          case 'INTERNAL':
          case 'PUBLIC':
            break;
        }
        return errors;
      },
      'PRIVATE': 'PRIVATE',
      'INTERNAL': 'INTERNAL',
      'PUBLIC': 'PUBLIC'
    };
    api.Maturity = {
      verify: (value, helper, errors = helper.verification.Errors.empty()) => {
        switch (value) {
          default: {
            errors.error('enum expected');
          }
          case 'ALPHA':
          case 'BETA':
          case 'IA':
          case 'GA':
            break;
        }
        return errors;
      },
      'ALPHA': 'ALPHA',
      'BETA': 'BETA',
      'IA': 'IA',
      'GA': 'GA'
    };
    api.Callback = (function() {

      class Callback {

        constructor(props) {
          this.topic = props && props.topic;
          this.payload = props && props.payload;
          this.permission = props && props.permission;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.topic != null) {
              if (typeof msg.topic !== 'string') {
                errors.field('topic').error('string expected');
              }
            }
            if (msg.payload != null) {
              if (typeof msg.payload !== 'string') {
                errors.field('payload').error('string expected');
              }
            }
            if (msg.permission != null) {
              if (typeof msg.permission !== 'string') {
                errors.field('permission').error('string expected');
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.topic != null) {
              json.topic = obj.topic;
            }
            if (obj.payload != null) {
              json.payload = obj.payload;
            }
            if (obj.permission != null) {
              json.permission = obj.permission;
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.api.Callback();

          if (json.topic != null) {
            result.topic = json.topic;
          } else {
            result.topic = '';
          }
          if (json.payload != null) {
            result.payload = json.payload;
          } else {
            result.payload = '';
          }
          if (json.permission != null) {
            result.permission = json.permission;
          } else {
            result.permission = '';
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.topic != null) {
              grpc.topic = obj.topic;
            }
            if (obj.payload != null) {
              grpc.payload = obj.payload;
            }
            if (obj.permission != null) {
              grpc.permission = obj.permission;
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.api.Callback();

            if (grpc.topic != null) {
              result.topic = grpc.topic;
            } else {
              result.topic = '';
            }
            if (grpc.payload != null) {
              result.payload = grpc.payload;
            } else {
              result.payload = '';
            }
            if (grpc.permission != null) {
              result.permission = grpc.permission;
            } else {
              result.permission = '';
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'topic': {
                'rule': 'required',
                'type': 'string',
                'id': 1
              },
              'payload': {
                'rule': 'required',
                'type': 'string',
                'id': 2
              },
              'permission': {
                'type': 'string',
                'id': 3
              }
            }
          };
        }
      }

      Object.defineProperty(Callback.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.api.Callback');
        },
        enumerable: false,
        configurable: false
      });
      return Callback;
    }());
    return api;
  }());
  wix.common = (function() {
    const common = {};

    common.Paging = (function() {

      class Paging {

        constructor(props) {
          this.limit = props && props.limit;
          this.offset = props && props.offset;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.limit != null) {
              $root.google.protobuf.Int32Value.verify(msg.limit, helper, errors.field('limit'));
            }
            if (msg.offset != null) {
              $root.google.protobuf.Int32Value.verify(msg.offset, helper, errors.field('offset'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.limit != null) {
              json.limit = $root.google.protobuf.Int32Value.toJSON(obj.limit, helper);
            }
            if (obj.offset != null) {
              json.offset = $root.google.protobuf.Int32Value.toJSON(obj.offset, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.common.Paging();

          if (json.limit != null) {
            result.limit = $root.google.protobuf.Int32Value.fromJSON(json.limit, helper);
          } else {
            delete result.limit;
          }
          if (json.offset != null) {
            result.offset = $root.google.protobuf.Int32Value.fromJSON(json.offset, helper);
          } else {
            delete result.offset;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.limit != null) {
              grpc.limit = $root.google.protobuf.Int32Value.toGRPC(obj.limit, helper);
            }
            if (obj.offset != null) {
              grpc.offset = $root.google.protobuf.Int32Value.toGRPC(obj.offset, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.Paging();

            if (grpc.limit != null) {
              result.limit = $root.google.protobuf.Int32Value.fromGRPC(grpc.limit, helper);
            } else {
              delete result.limit;
            }
            if (grpc.offset != null) {
              result.offset = $root.google.protobuf.Int32Value.fromGRPC(grpc.offset, helper);
            } else {
              delete result.offset;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'limit': {
                'type': $root.google.protobuf.Int32Value,
                'id': 1,
                'options': {
                  '(wix.api.min)': 0
                }
              },
              'offset': {
                'type': $root.google.protobuf.Int32Value,
                'id': 2,
                'options': {
                  '(wix.api.min)': 0
                }
              }
            }
          };
        }
      }

      Object.defineProperty(Paging.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.Paging');
        },
        enumerable: false,
        configurable: false
      });
      return Paging;
    }());
    common.CursorPaging = (function() {

      class CursorPaging {

        constructor(props) {
          this.limit = props && props.limit;
          this.cursor = props && props.cursor;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.limit != null) {
              $root.google.protobuf.Int32Value.verify(msg.limit, helper, errors.field('limit'));
            }
            if (msg.cursor != null) {
              $root.google.protobuf.StringValue.verify(msg.cursor, helper, errors.field('cursor'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.limit != null) {
              json.limit = $root.google.protobuf.Int32Value.toJSON(obj.limit, helper);
            }
            if (obj.cursor != null) {
              json.cursor = $root.google.protobuf.StringValue.toJSON(obj.cursor, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.common.CursorPaging();

          if (json.limit != null) {
            result.limit = $root.google.protobuf.Int32Value.fromJSON(json.limit, helper);
          } else {
            delete result.limit;
          }
          if (json.cursor != null) {
            result.cursor = $root.google.protobuf.StringValue.fromJSON(json.cursor, helper);
          } else {
            delete result.cursor;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.limit != null) {
              grpc.limit = $root.google.protobuf.Int32Value.toGRPC(obj.limit, helper);
            }
            if (obj.cursor != null) {
              grpc.cursor = $root.google.protobuf.StringValue.toGRPC(obj.cursor, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.CursorPaging();

            if (grpc.limit != null) {
              result.limit = $root.google.protobuf.Int32Value.fromGRPC(grpc.limit, helper);
            } else {
              delete result.limit;
            }
            if (grpc.cursor != null) {
              result.cursor = $root.google.protobuf.StringValue.fromGRPC(grpc.cursor, helper);
            } else {
              delete result.cursor;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'limit': {
                'type': $root.google.protobuf.Int32Value,
                'id': 1,
                'options': {
                  '(wix.api.min)': 0
                }
              },
              'cursor': {
                'type': $root.google.protobuf.StringValue,
                'id': 2
              }
            }
          };
        }
      }

      Object.defineProperty(CursorPaging.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.CursorPaging');
        },
        enumerable: false,
        configurable: false
      });
      return CursorPaging;
    }());
    common.Address = (function() {

      class Address {

        constructor(props) {
          this.country = props && props.country;
          this.subdivision = props && props.subdivision;
          this.city = props && props.city;
          this.postalCode = props && props.postalCode;
          this.streetAddress = props && props.streetAddress;
          this.addressLine = props && props.addressLine;
          this.addressLine_2 = props && props.addressLine_2;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            const oneOfMutex = {};

            if (msg.country != null) {
              $root.google.protobuf.StringValue.verify(msg.country, helper, errors.field('country'));
            }
            if (msg.subdivision != null) {
              $root.google.protobuf.StringValue.verify(msg.subdivision, helper, errors.field('subdivision'));
            }
            if (msg.city != null) {
              $root.google.protobuf.StringValue.verify(msg.city, helper, errors.field('city'));
            }
            if (msg.postalCode != null) {
              $root.google.protobuf.StringValue.verify(msg.postalCode, helper, errors.field('postalCode'));
            }
            if (msg.streetAddress != null) {
              if (oneOfMutex['street']) {
                errors.field('streetAddress').up().field('street').error('multiple values');
              } else {
                oneOfMutex['street'] = true;
                $root.wix.common.StreetAddress.verify(msg.streetAddress, helper, errors.field('streetAddress'));
              }
            }
            if (msg.addressLine != null) {
              if (oneOfMutex['street']) {
                errors.field('addressLine').up().field('street').error('multiple values');
              } else {
                oneOfMutex['street'] = true;
                $root.google.protobuf.StringValue.verify(msg.addressLine, helper, errors.field('addressLine'));
              }
            }
            if (msg.addressLine_2 != null) {
              $root.google.protobuf.StringValue.verify(msg.addressLine_2, helper, errors.field('addressLine_2'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.country != null) {
              json.country = $root.google.protobuf.StringValue.toJSON(obj.country, helper);
            }
            if (obj.subdivision != null) {
              json.subdivision = $root.google.protobuf.StringValue.toJSON(obj.subdivision, helper);
            }
            if (obj.city != null) {
              json.city = $root.google.protobuf.StringValue.toJSON(obj.city, helper);
            }
            if (obj.postalCode != null) {
              json.postalCode = $root.google.protobuf.StringValue.toJSON(obj.postalCode, helper);
            }
            if (obj.streetAddress != null) {
              json.streetAddress = $root.wix.common.StreetAddress.toJSON(obj.streetAddress, helper);
            }
            if (obj.addressLine != null) {
              json.addressLine = $root.google.protobuf.StringValue.toJSON(obj.addressLine, helper);
            }
            if (obj.addressLine_2 != null) {
              json.addressLine_2 = $root.google.protobuf.StringValue.toJSON(obj.addressLine_2, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.common.Address();

          if (json.country != null) {
            result.country = $root.google.protobuf.StringValue.fromJSON(json.country, helper);
          } else {
            delete result.country;
          }
          if (json.subdivision != null) {
            result.subdivision = $root.google.protobuf.StringValue.fromJSON(json.subdivision, helper);
          } else {
            delete result.subdivision;
          }
          if (json.city != null) {
            result.city = $root.google.protobuf.StringValue.fromJSON(json.city, helper);
          } else {
            delete result.city;
          }
          if (json.postalCode != null) {
            result.postalCode = $root.google.protobuf.StringValue.fromJSON(json.postalCode, helper);
          } else {
            delete result.postalCode;
          }
          if (json.streetAddress != null) {
            result.streetAddress = $root.wix.common.StreetAddress.fromJSON(json.streetAddress, helper);
          } else {
            delete result.streetAddress;
          }
          if (json.addressLine != null) {
            result.addressLine = $root.google.protobuf.StringValue.fromJSON(json.addressLine, helper);
          } else {
            delete result.addressLine;
          }
          if (json.addressLine_2 != null) {
            result.addressLine_2 = $root.google.protobuf.StringValue.fromJSON(json.addressLine_2, helper);
          } else {
            delete result.addressLine_2;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.country != null) {
              grpc.country = $root.google.protobuf.StringValue.toGRPC(obj.country, helper);
            }
            if (obj.subdivision != null) {
              grpc.subdivision = $root.google.protobuf.StringValue.toGRPC(obj.subdivision, helper);
            }
            if (obj.city != null) {
              grpc.city = $root.google.protobuf.StringValue.toGRPC(obj.city, helper);
            }
            if (obj.postalCode != null) {
              grpc.postalCode = $root.google.protobuf.StringValue.toGRPC(obj.postalCode, helper);
            }
            if (obj.streetAddress != null) {
              grpc.streetAddress = $root.wix.common.StreetAddress.toGRPC(obj.streetAddress, helper);
            }
            if (obj.addressLine != null) {
              grpc.addressLine = $root.google.protobuf.StringValue.toGRPC(obj.addressLine, helper);
            }
            if (obj.addressLine_2 != null) {
              grpc.addressLine_2 = $root.google.protobuf.StringValue.toGRPC(obj.addressLine_2, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.Address();

            if (grpc.country != null) {
              result.country = $root.google.protobuf.StringValue.fromGRPC(grpc.country, helper);
            } else {
              delete result.country;
            }
            if (grpc.subdivision != null) {
              result.subdivision = $root.google.protobuf.StringValue.fromGRPC(grpc.subdivision, helper);
            } else {
              delete result.subdivision;
            }
            if (grpc.city != null) {
              result.city = $root.google.protobuf.StringValue.fromGRPC(grpc.city, helper);
            } else {
              delete result.city;
            }
            if (grpc.postalCode != null) {
              result.postalCode = $root.google.protobuf.StringValue.fromGRPC(grpc.postalCode, helper);
            } else {
              delete result.postalCode;
            }
            if (grpc.streetAddress != null) {
              result.streetAddress = $root.wix.common.StreetAddress.fromGRPC(grpc.streetAddress, helper);
            } else {
              delete result.streetAddress;
            }
            if (grpc.addressLine != null) {
              result.addressLine = $root.google.protobuf.StringValue.fromGRPC(grpc.addressLine, helper);
            } else {
              delete result.addressLine;
            }
            if (grpc.addressLine_2 != null) {
              result.addressLine_2 = $root.google.protobuf.StringValue.fromGRPC(grpc.addressLine_2, helper);
            } else {
              delete result.addressLine_2;
            }
            return result;
          }
        }

        static describe() {
          return {
            'oneofs': {
              'street': {
                'oneof': [
                  'streetAddress',
                  'addressLine'
                ]
              }
            },
            'fields': {
              'country': {
                'type': $root.google.protobuf.StringValue,
                'id': 1,
                'options': {
                  '(wix.api.format)': 'COUNTRY'
                }
              },
              'subdivision': {
                'type': $root.google.protobuf.StringValue,
                'id': 2
              },
              'city': {
                'type': $root.google.protobuf.StringValue,
                'id': 3
              },
              'postalCode': {
                'type': $root.google.protobuf.StringValue,
                'id': 4
              },
              'streetAddress': {
                'type': $root.wix.common.StreetAddress,
                'id': 5
              },
              'addressLine': {
                'type': $root.google.protobuf.StringValue,
                'id': 6
              },
              'addressLine_2': {
                'type': $root.google.protobuf.StringValue,
                'id': 7
              }
            }
          };
        }
      }

      Object.defineProperty(Address.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.Address');
        },
        enumerable: false,
        configurable: false
      });
      return Address;
    }());
    common.StreetAddress = (function() {

      class StreetAddress {

        constructor(props) {
          this.number = props && props.number;
          this.name = props && props.name;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.number != null) {
              if (typeof msg.number !== 'string') {
                errors.field('number').error('string expected');
              }
            }
            if (msg.name != null) {
              if (typeof msg.name !== 'string') {
                errors.field('name').error('string expected');
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.number != null) {
              json.number = obj.number;
            }
            if (obj.name != null) {
              json.name = obj.name;
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.common.StreetAddress();

          if (json.number != null) {
            result.number = json.number;
          } else {
            result.number = '';
          }
          if (json.name != null) {
            result.name = json.name;
          } else {
            result.name = '';
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.number != null) {
              grpc.number = obj.number;
            }
            if (obj.name != null) {
              grpc.name = obj.name;
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.StreetAddress();

            if (grpc.number != null) {
              result.number = grpc.number;
            } else {
              result.number = '';
            }
            if (grpc.name != null) {
              result.name = grpc.name;
            } else {
              result.name = '';
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'number': {
                'type': 'string',
                'id': 1
              },
              'name': {
                'type': 'string',
                'id': 2
              }
            }
          };
        }
      }

      Object.defineProperty(StreetAddress.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.StreetAddress');
        },
        enumerable: false,
        configurable: false
      });
      return StreetAddress;
    }());
    common.AddressContactDetails = (function() {

      class AddressContactDetails {

        constructor(props) {
          this.fullName = props && props.fullName;
          this.phone = props && props.phone;
          this.company = props && props.company;
          this.email = props && props.email;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.fullName != null) {
              $root.google.protobuf.StringValue.verify(msg.fullName, helper, errors.field('fullName'));
            }
            if (msg.phone != null) {
              $root.google.protobuf.StringValue.verify(msg.phone, helper, errors.field('phone'));
            }
            if (msg.company != null) {
              $root.google.protobuf.StringValue.verify(msg.company, helper, errors.field('company'));
            }
            if (msg.email != null) {
              $root.google.protobuf.StringValue.verify(msg.email, helper, errors.field('email'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.fullName != null) {
              json.fullName = $root.google.protobuf.StringValue.toJSON(obj.fullName, helper);
            }
            if (obj.phone != null) {
              json.phone = $root.google.protobuf.StringValue.toJSON(obj.phone, helper);
            }
            if (obj.company != null) {
              json.company = $root.google.protobuf.StringValue.toJSON(obj.company, helper);
            }
            if (obj.email != null) {
              json.email = $root.google.protobuf.StringValue.toJSON(obj.email, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.common.AddressContactDetails();

          if (json.fullName != null) {
            result.fullName = $root.google.protobuf.StringValue.fromJSON(json.fullName, helper);
          } else {
            delete result.fullName;
          }
          if (json.phone != null) {
            result.phone = $root.google.protobuf.StringValue.fromJSON(json.phone, helper);
          } else {
            delete result.phone;
          }
          if (json.company != null) {
            result.company = $root.google.protobuf.StringValue.fromJSON(json.company, helper);
          } else {
            delete result.company;
          }
          if (json.email != null) {
            result.email = $root.google.protobuf.StringValue.fromJSON(json.email, helper);
          } else {
            delete result.email;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.fullName != null) {
              grpc.fullName = $root.google.protobuf.StringValue.toGRPC(obj.fullName, helper);
            }
            if (obj.phone != null) {
              grpc.phone = $root.google.protobuf.StringValue.toGRPC(obj.phone, helper);
            }
            if (obj.company != null) {
              grpc.company = $root.google.protobuf.StringValue.toGRPC(obj.company, helper);
            }
            if (obj.email != null) {
              grpc.email = $root.google.protobuf.StringValue.toGRPC(obj.email, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.AddressContactDetails();

            if (grpc.fullName != null) {
              result.fullName = $root.google.protobuf.StringValue.fromGRPC(grpc.fullName, helper);
            } else {
              delete result.fullName;
            }
            if (grpc.phone != null) {
              result.phone = $root.google.protobuf.StringValue.fromGRPC(grpc.phone, helper);
            } else {
              delete result.phone;
            }
            if (grpc.company != null) {
              result.company = $root.google.protobuf.StringValue.fromGRPC(grpc.company, helper);
            } else {
              delete result.company;
            }
            if (grpc.email != null) {
              result.email = $root.google.protobuf.StringValue.fromGRPC(grpc.email, helper);
            } else {
              delete result.email;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'fullName': {
                'type': $root.google.protobuf.StringValue,
                'id': 1
              },
              'phone': {
                'type': $root.google.protobuf.StringValue,
                'id': 2,
                'options': {
                  '(wix.api.format)': 'PHONE'
                }
              },
              'company': {
                'type': $root.google.protobuf.StringValue,
                'id': 3
              },
              'email': {
                'type': $root.google.protobuf.StringValue,
                'id': 4,
                'options': {
                  '(wix.api.format)': 'EMAIL'
                }
              }
            }
          };
        }
      }

      Object.defineProperty(AddressContactDetails.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.AddressContactDetails');
        },
        enumerable: false,
        configurable: false
      });
      return AddressContactDetails;
    }());
    common.FullAddressContactDetails = (function() {

      class FullAddressContactDetails {

        constructor(props) {
          this.firstName = props && props.firstName;
          this.lastName = props && props.lastName;
          this.phone = props && props.phone;
          this.company = props && props.company;
          this.email = props && props.email;
          this.vatId = props && props.vatId;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.firstName != null) {
              $root.google.protobuf.StringValue.verify(msg.firstName, helper, errors.field('firstName'));
            }
            if (msg.lastName != null) {
              $root.google.protobuf.StringValue.verify(msg.lastName, helper, errors.field('lastName'));
            }
            if (msg.phone != null) {
              $root.google.protobuf.StringValue.verify(msg.phone, helper, errors.field('phone'));
            }
            if (msg.company != null) {
              $root.google.protobuf.StringValue.verify(msg.company, helper, errors.field('company'));
            }
            if (msg.email != null) {
              $root.google.protobuf.StringValue.verify(msg.email, helper, errors.field('email'));
            }
            if (msg.vatId != null) {
              $root.wix.common.VatId.verify(msg.vatId, helper, errors.field('vatId'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.firstName != null) {
              json.firstName = $root.google.protobuf.StringValue.toJSON(obj.firstName, helper);
            }
            if (obj.lastName != null) {
              json.lastName = $root.google.protobuf.StringValue.toJSON(obj.lastName, helper);
            }
            if (obj.phone != null) {
              json.phone = $root.google.protobuf.StringValue.toJSON(obj.phone, helper);
            }
            if (obj.company != null) {
              json.company = $root.google.protobuf.StringValue.toJSON(obj.company, helper);
            }
            if (obj.email != null) {
              json.email = $root.google.protobuf.StringValue.toJSON(obj.email, helper);
            }
            if (obj.vatId != null) {
              json.vatId = $root.wix.common.VatId.toJSON(obj.vatId, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.common.FullAddressContactDetails();

          if (json.firstName != null) {
            result.firstName = $root.google.protobuf.StringValue.fromJSON(json.firstName, helper);
          } else {
            delete result.firstName;
          }
          if (json.lastName != null) {
            result.lastName = $root.google.protobuf.StringValue.fromJSON(json.lastName, helper);
          } else {
            delete result.lastName;
          }
          if (json.phone != null) {
            result.phone = $root.google.protobuf.StringValue.fromJSON(json.phone, helper);
          } else {
            delete result.phone;
          }
          if (json.company != null) {
            result.company = $root.google.protobuf.StringValue.fromJSON(json.company, helper);
          } else {
            delete result.company;
          }
          if (json.email != null) {
            result.email = $root.google.protobuf.StringValue.fromJSON(json.email, helper);
          } else {
            delete result.email;
          }
          if (json.vatId != null) {
            result.vatId = $root.wix.common.VatId.fromJSON(json.vatId, helper);
          } else {
            delete result.vatId;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.firstName != null) {
              grpc.firstName = $root.google.protobuf.StringValue.toGRPC(obj.firstName, helper);
            }
            if (obj.lastName != null) {
              grpc.lastName = $root.google.protobuf.StringValue.toGRPC(obj.lastName, helper);
            }
            if (obj.phone != null) {
              grpc.phone = $root.google.protobuf.StringValue.toGRPC(obj.phone, helper);
            }
            if (obj.company != null) {
              grpc.company = $root.google.protobuf.StringValue.toGRPC(obj.company, helper);
            }
            if (obj.email != null) {
              grpc.email = $root.google.protobuf.StringValue.toGRPC(obj.email, helper);
            }
            if (obj.vatId != null) {
              grpc.vatId = $root.wix.common.VatId.toGRPC(obj.vatId, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.FullAddressContactDetails();

            if (grpc.firstName != null) {
              result.firstName = $root.google.protobuf.StringValue.fromGRPC(grpc.firstName, helper);
            } else {
              delete result.firstName;
            }
            if (grpc.lastName != null) {
              result.lastName = $root.google.protobuf.StringValue.fromGRPC(grpc.lastName, helper);
            } else {
              delete result.lastName;
            }
            if (grpc.phone != null) {
              result.phone = $root.google.protobuf.StringValue.fromGRPC(grpc.phone, helper);
            } else {
              delete result.phone;
            }
            if (grpc.company != null) {
              result.company = $root.google.protobuf.StringValue.fromGRPC(grpc.company, helper);
            } else {
              delete result.company;
            }
            if (grpc.email != null) {
              result.email = $root.google.protobuf.StringValue.fromGRPC(grpc.email, helper);
            } else {
              delete result.email;
            }
            if (grpc.vatId != null) {
              result.vatId = $root.wix.common.VatId.fromGRPC(grpc.vatId, helper);
            } else {
              delete result.vatId;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'firstName': {
                'type': $root.google.protobuf.StringValue,
                'id': 1
              },
              'lastName': {
                'type': $root.google.protobuf.StringValue,
                'id': 2
              },
              'phone': {
                'type': $root.google.protobuf.StringValue,
                'id': 3,
                'options': {
                  '(wix.api.format)': 'PHONE'
                }
              },
              'company': {
                'type': $root.google.protobuf.StringValue,
                'id': 4
              },
              'email': {
                'type': $root.google.protobuf.StringValue,
                'id': 5,
                'options': {
                  '(wix.api.format)': 'EMAIL'
                }
              },
              'vatId': {
                'type': $root.wix.common.VatId,
                'id': 7
              }
            }
          };
        }
      }

      Object.defineProperty(FullAddressContactDetails.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.FullAddressContactDetails');
        },
        enumerable: false,
        configurable: false
      });
      return FullAddressContactDetails;
    }());
    common.VatId = (function() {

      class VatId {

        constructor(props) {
          this.id = props && props.id;
          this.type = props && props.type;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.id != null) {
              if (typeof msg.id !== 'string') {
                errors.field('id').error('string expected');
              }
            }
            if (msg.type != null) {
              $root.wix.common.VatType.verify(msg.type, helper, errors.field('type'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.id != null) {
              json.id = obj.id;
            }
            if (obj.type != null) {
              json.type = $root.wix.common.VatType[obj.type];
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.common.VatId();

          if (json.id != null) {
            result.id = json.id;
          } else {
            result.id = '';
          }
          if (json.type != null) {
            result.type = $root.wix.common.VatType[json.type];
          } else {
            result.type = 'UNSPECIFIED';
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.id != null) {
              grpc.id = obj.id;
            }
            if (obj.type != null) {
              grpc.type = obj.type;
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.VatId();

            if (grpc.id != null) {
              result.id = grpc.id;
            } else {
              result.id = '';
            }
            if (grpc.type != null) {
              result.type = grpc.type;
            } else {
              result.type = 'UNSPECIFIED';
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'id': {
                'type': 'string',
                'id': 1
              },
              'type': {
                'type': $root.wix.common.VatType,
                'id': 2
              }
            }
          };
        }
      }

      Object.defineProperty(VatId.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.VatId');
        },
        enumerable: false,
        configurable: false
      });
      return VatId;
    }());
    common.VatType = {
      verify: (value, helper, errors = helper.verification.Errors.empty()) => {
        switch (value) {
          default: {
            errors.error('enum expected');
          }
          case 'UNSPECIFIED':
          case 'CPF':
          case 'CNPJ':
            break;
        }
        return errors;
      },
      'UNSPECIFIED': 'UNSPECIFIED',
      'CPF': 'CPF',
      'CNPJ': 'CNPJ'
    };
    common.AddressLocation = (function() {

      class AddressLocation {

        constructor(props) {
          this.latitude = props && props.latitude;
          this.longitude = props && props.longitude;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.latitude != null) {
              $root.google.protobuf.DoubleValue.verify(msg.latitude, helper, errors.field('latitude'));
            }
            if (msg.longitude != null) {
              $root.google.protobuf.DoubleValue.verify(msg.longitude, helper, errors.field('longitude'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.latitude != null) {
              json.latitude = $root.google.protobuf.DoubleValue.toJSON(obj.latitude, helper);
            }
            if (obj.longitude != null) {
              json.longitude = $root.google.protobuf.DoubleValue.toJSON(obj.longitude, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.common.AddressLocation();

          if (json.latitude != null) {
            result.latitude = $root.google.protobuf.DoubleValue.fromJSON(json.latitude, helper);
          } else {
            delete result.latitude;
          }
          if (json.longitude != null) {
            result.longitude = $root.google.protobuf.DoubleValue.fromJSON(json.longitude, helper);
          } else {
            delete result.longitude;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.latitude != null) {
              grpc.latitude = $root.google.protobuf.DoubleValue.toGRPC(obj.latitude, helper);
            }
            if (obj.longitude != null) {
              grpc.longitude = $root.google.protobuf.DoubleValue.toGRPC(obj.longitude, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.AddressLocation();

            if (grpc.latitude != null) {
              result.latitude = $root.google.protobuf.DoubleValue.fromGRPC(grpc.latitude, helper);
            } else {
              delete result.latitude;
            }
            if (grpc.longitude != null) {
              result.longitude = $root.google.protobuf.DoubleValue.fromGRPC(grpc.longitude, helper);
            } else {
              delete result.longitude;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'latitude': {
                'type': $root.google.protobuf.DoubleValue,
                'id': 1
              },
              'longitude': {
                'type': $root.google.protobuf.DoubleValue,
                'id': 2
              }
            }
          };
        }
      }

      Object.defineProperty(AddressLocation.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.AddressLocation');
        },
        enumerable: false,
        configurable: false
      });
      return AddressLocation;
    }());
    common.Image = (function() {

      class Image {

        constructor(props) {
          this.id = props && props.id;
          this.url = props && props.url;
          this.height = props && props.height;
          this.width = props && props.width;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.id != null) {
              if (typeof msg.id !== 'string') {
                errors.field('id').error('string expected');
              }
            }
            if (msg.url != null) {
              if (typeof msg.url !== 'string') {
                errors.field('url').error('string expected');
              }
            }
            if (msg.height != null) {
              if (!Number.isInteger(msg.height)) {
                errors.field('height').error('integer expected');
              }
            }
            if (msg.width != null) {
              if (!Number.isInteger(msg.width)) {
                errors.field('width').error('integer expected');
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.id != null) {
              json.id = obj.id;
            }
            if (obj.url != null) {
              json.url = obj.url;
            }
            if (obj.height != null) {
              json.height = obj.height;
            }
            if (obj.width != null) {
              json.width = obj.width;
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.common.Image();

          if (json.id != null) {
            result.id = json.id;
          } else {
            result.id = '';
          }
          if (json.url != null) {
            result.url = json.url;
          } else {
            result.url = '';
          }
          if (json.height != null) {
            result.height = json.height;
          } else {
            result.height = 0;
          }
          if (json.width != null) {
            result.width = json.width;
          } else {
            result.width = 0;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.id != null) {
              grpc.id = obj.id;
            }
            if (obj.url != null) {
              grpc.url = obj.url;
            }
            if (obj.height != null) {
              grpc.height = obj.height;
            }
            if (obj.width != null) {
              grpc.width = obj.width;
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.Image();

            if (grpc.id != null) {
              result.id = grpc.id;
            } else {
              result.id = '';
            }
            if (grpc.url != null) {
              result.url = grpc.url;
            } else {
              result.url = '';
            }
            if (grpc.height != null) {
              result.height = grpc.height;
            } else {
              result.height = 0;
            }
            if (grpc.width != null) {
              result.width = grpc.width;
            } else {
              result.width = 0;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'id': {
                'type': 'string',
                'id': 1
              },
              'url': {
                'type': 'string',
                'id': 2
              },
              'height': {
                'type': 'int32',
                'id': 3
              },
              'width': {
                'type': 'int32',
                'id': 4
              }
            }
          };
        }
      }

      Object.defineProperty(Image.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.Image');
        },
        enumerable: false,
        configurable: false
      });
      return Image;
    }());
    common.Video = (function() {

      class Video {

        constructor(props) {
          this.id = props && props.id;
          this.url = props && props.url;
          this.height = props && props.height;
          this.width = props && props.width;
          this.thumbnail = props && props.thumbnail;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.id != null) {
              if (typeof msg.id !== 'string') {
                errors.field('id').error('string expected');
              }
            }
            if (msg.url != null) {
              if (typeof msg.url !== 'string') {
                errors.field('url').error('string expected');
              }
            }
            if (msg.height != null) {
              if (!Number.isInteger(msg.height)) {
                errors.field('height').error('integer expected');
              }
            }
            if (msg.width != null) {
              if (!Number.isInteger(msg.width)) {
                errors.field('width').error('integer expected');
              }
            }
            if (msg.thumbnail != null) {
              $root.wix.common.Image.verify(msg.thumbnail, helper, errors.field('thumbnail'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.id != null) {
              json.id = obj.id;
            }
            if (obj.url != null) {
              json.url = obj.url;
            }
            if (obj.height != null) {
              json.height = obj.height;
            }
            if (obj.width != null) {
              json.width = obj.width;
            }
            if (obj.thumbnail != null) {
              json.thumbnail = $root.wix.common.Image.toJSON(obj.thumbnail, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.common.Video();

          if (json.id != null) {
            result.id = json.id;
          } else {
            result.id = '';
          }
          if (json.url != null) {
            result.url = json.url;
          } else {
            result.url = '';
          }
          if (json.height != null) {
            result.height = json.height;
          } else {
            result.height = 0;
          }
          if (json.width != null) {
            result.width = json.width;
          } else {
            result.width = 0;
          }
          if (json.thumbnail != null) {
            result.thumbnail = $root.wix.common.Image.fromJSON(json.thumbnail, helper);
          } else {
            delete result.thumbnail;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.id != null) {
              grpc.id = obj.id;
            }
            if (obj.url != null) {
              grpc.url = obj.url;
            }
            if (obj.height != null) {
              grpc.height = obj.height;
            }
            if (obj.width != null) {
              grpc.width = obj.width;
            }
            if (obj.thumbnail != null) {
              grpc.thumbnail = $root.wix.common.Image.toGRPC(obj.thumbnail, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.Video();

            if (grpc.id != null) {
              result.id = grpc.id;
            } else {
              result.id = '';
            }
            if (grpc.url != null) {
              result.url = grpc.url;
            } else {
              result.url = '';
            }
            if (grpc.height != null) {
              result.height = grpc.height;
            } else {
              result.height = 0;
            }
            if (grpc.width != null) {
              result.width = grpc.width;
            } else {
              result.width = 0;
            }
            if (grpc.thumbnail != null) {
              result.thumbnail = $root.wix.common.Image.fromGRPC(grpc.thumbnail, helper);
            } else {
              delete result.thumbnail;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'id': {
                'type': 'string',
                'id': 1
              },
              'url': {
                'type': 'string',
                'id': 2
              },
              'height': {
                'type': 'int32',
                'id': 3
              },
              'width': {
                'type': 'int32',
                'id': 4
              },
              'thumbnail': {
                'type': $root.wix.common.Image,
                'id': 5
              }
            }
          };
        }
      }

      Object.defineProperty(Video.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.Video');
        },
        enumerable: false,
        configurable: false
      });
      return Video;
    }());
    common.Document = (function() {

      class Document {

        constructor(props) {
          this.id = props && props.id;
          this.url = props && props.url;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.id != null) {
              if (typeof msg.id !== 'string') {
                errors.field('id').error('string expected');
              }
            }
            if (msg.url != null) {
              if (typeof msg.url !== 'string') {
                errors.field('url').error('string expected');
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.id != null) {
              json.id = obj.id;
            }
            if (obj.url != null) {
              json.url = obj.url;
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.common.Document();

          if (json.id != null) {
            result.id = json.id;
          } else {
            result.id = '';
          }
          if (json.url != null) {
            result.url = json.url;
          } else {
            result.url = '';
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.id != null) {
              grpc.id = obj.id;
            }
            if (obj.url != null) {
              grpc.url = obj.url;
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.Document();

            if (grpc.id != null) {
              result.id = grpc.id;
            } else {
              result.id = '';
            }
            if (grpc.url != null) {
              result.url = grpc.url;
            } else {
              result.url = '';
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'id': {
                'type': 'string',
                'id': 1
              },
              'url': {
                'type': 'string',
                'id': 2
              }
            }
          };
        }
      }

      Object.defineProperty(Document.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.Document');
        },
        enumerable: false,
        configurable: false
      });
      return Document;
    }());
    common.MediaItem = (function() {

      class MediaItem {

        constructor(props) {
          this.image = props && props.image;
          this.video = props && props.video;
          this.document = props && props.document;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            const oneOfMutex = {};

            if (msg.image != null) {
              if (oneOfMutex['media']) {
                errors.field('image').up().field('media').error('multiple values');
              } else {
                oneOfMutex['media'] = true;
                $root.wix.common.Image.verify(msg.image, helper, errors.field('image'));
              }
            }
            if (msg.video != null) {
              if (oneOfMutex['media']) {
                errors.field('video').up().field('media').error('multiple values');
              } else {
                oneOfMutex['media'] = true;
                $root.wix.common.Video.verify(msg.video, helper, errors.field('video'));
              }
            }
            if (msg.document != null) {
              if (oneOfMutex['media']) {
                errors.field('document').up().field('media').error('multiple values');
              } else {
                oneOfMutex['media'] = true;
                $root.wix.common.Document.verify(msg.document, helper, errors.field('document'));
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.image != null) {
              json.image = $root.wix.common.Image.toJSON(obj.image, helper);
            }
            if (obj.video != null) {
              json.video = $root.wix.common.Video.toJSON(obj.video, helper);
            }
            if (obj.document != null) {
              json.document = $root.wix.common.Document.toJSON(obj.document, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.common.MediaItem();

          if (json.image != null) {
            result.image = $root.wix.common.Image.fromJSON(json.image, helper);
          } else {
            delete result.image;
          }
          if (json.video != null) {
            result.video = $root.wix.common.Video.fromJSON(json.video, helper);
          } else {
            delete result.video;
          }
          if (json.document != null) {
            result.document = $root.wix.common.Document.fromJSON(json.document, helper);
          } else {
            delete result.document;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.image != null) {
              grpc.image = $root.wix.common.Image.toGRPC(obj.image, helper);
            }
            if (obj.video != null) {
              grpc.video = $root.wix.common.Video.toGRPC(obj.video, helper);
            }
            if (obj.document != null) {
              grpc.document = $root.wix.common.Document.toGRPC(obj.document, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.MediaItem();

            if (grpc.image != null) {
              result.image = $root.wix.common.Image.fromGRPC(grpc.image, helper);
            } else {
              delete result.image;
            }
            if (grpc.video != null) {
              result.video = $root.wix.common.Video.fromGRPC(grpc.video, helper);
            } else {
              delete result.video;
            }
            if (grpc.document != null) {
              result.document = $root.wix.common.Document.fromGRPC(grpc.document, helper);
            } else {
              delete result.document;
            }
            return result;
          }
        }

        static describe() {
          return {
            'oneofs': {
              'media': {
                'oneof': [
                  'image',
                  'video',
                  'document'
                ]
              }
            },
            'fields': {
              'image': {
                'type': $root.wix.common.Image,
                'id': 1
              },
              'video': {
                'type': $root.wix.common.Video,
                'id': 2
              },
              'document': {
                'type': $root.wix.common.Document,
                'id': 3
              }
            }
          };
        }
      }

      Object.defineProperty(MediaItem.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.MediaItem');
        },
        enumerable: false,
        configurable: false
      });
      return MediaItem;
    }());
    common.PageUrl = (function() {

      class PageUrl {

        constructor(props) {
          this.base = props && props.base;
          this.path = props && props.path;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.base != null) {
              if (typeof msg.base !== 'string') {
                errors.field('base').error('string expected');
              }
            }
            if (msg.path != null) {
              if (typeof msg.path !== 'string') {
                errors.field('path').error('string expected');
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.base != null) {
              json.base = obj.base;
            }
            if (obj.path != null) {
              json.path = obj.path;
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.common.PageUrl();

          if (json.base != null) {
            result.base = json.base;
          } else {
            result.base = '';
          }
          if (json.path != null) {
            result.path = json.path;
          } else {
            result.path = '';
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.base != null) {
              grpc.base = obj.base;
            }
            if (obj.path != null) {
              grpc.path = obj.path;
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.PageUrl();

            if (grpc.base != null) {
              result.base = grpc.base;
            } else {
              result.base = '';
            }
            if (grpc.path != null) {
              result.path = grpc.path;
            } else {
              result.path = '';
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'base': {
                'type': 'string',
                'id': 1
              },
              'path': {
                'type': 'string',
                'id': 2
              }
            }
          };
        }
      }

      Object.defineProperty(PageUrl.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.PageUrl');
        },
        enumerable: false,
        configurable: false
      });
      return PageUrl;
    }());
    common.Sorting = (function() {

      class Sorting {

        constructor(props) {
          this.fieldName = props && props.fieldName;
          this.order = props && props.order;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.fieldName != null) {
              if (typeof msg.fieldName !== 'string') {
                errors.field('fieldName').error('string expected');
              }
            }
            if (msg.order != null) {
              $root.wix.common.SortOrder.verify(msg.order, helper, errors.field('order'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.fieldName != null) {
              json.fieldName = obj.fieldName;
            }
            if (obj.order != null) {
              json.order = $root.wix.common.SortOrder[obj.order];
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.common.Sorting();

          if (json.fieldName != null) {
            result.fieldName = json.fieldName;
          } else {
            result.fieldName = '';
          }
          if (json.order != null) {
            result.order = $root.wix.common.SortOrder[json.order];
          } else {
            result.order = 'ASC';
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.fieldName != null) {
              grpc.fieldName = obj.fieldName;
            }
            if (obj.order != null) {
              grpc.order = obj.order;
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.Sorting();

            if (grpc.fieldName != null) {
              result.fieldName = grpc.fieldName;
            } else {
              result.fieldName = '';
            }
            if (grpc.order != null) {
              result.order = grpc.order;
            } else {
              result.order = 'ASC';
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'fieldName': {
                'type': 'string',
                'id': 1
              },
              'order': {
                'type': $root.wix.common.SortOrder,
                'id': 2
              }
            }
          };
        }
      }

      Object.defineProperty(Sorting.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.Sorting');
        },
        enumerable: false,
        configurable: false
      });
      return Sorting;
    }());
    common.SortOrder = {
      verify: (value, helper, errors = helper.verification.Errors.empty()) => {
        switch (value) {
          default: {
            errors.error('enum expected');
          }
          case 'ASC':
          case 'DESC':
            break;
        }
        return errors;
      },
      'ASC': 'ASC',
      'DESC': 'DESC'
    };
    common.WixLink = (function() {

      class WixLink {

        constructor(props) {
          this.external = props && props.external;
          this.page = props && props.page;
          this.anchor = props && props.anchor;
          this.dynamicPage = props && props.dynamicPage;
          this.document = props && props.document;
          this.email = props && props.email;
          this.phone = props && props.phone;
          this.address = props && props.address;
          this.whatsApp = props && props.whatsApp;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            const oneOfMutex = {};

            if (msg.external != null) {
              if (oneOfMutex['Link']) {
                errors.field('external').up().field('Link').error('multiple values');
              } else {
                oneOfMutex['Link'] = true;
                $root.wix.common.ExternalLink.verify(msg.external, helper, errors.field('external'));
              }
            }
            if (msg.page != null) {
              if (oneOfMutex['Link']) {
                errors.field('page').up().field('Link').error('multiple values');
              } else {
                oneOfMutex['Link'] = true;
                $root.wix.common.PageLink.verify(msg.page, helper, errors.field('page'));
              }
            }
            if (msg.anchor != null) {
              if (oneOfMutex['Link']) {
                errors.field('anchor').up().field('Link').error('multiple values');
              } else {
                oneOfMutex['Link'] = true;
                $root.wix.common.AnchorLink.verify(msg.anchor, helper, errors.field('anchor'));
              }
            }
            if (msg.dynamicPage != null) {
              if (oneOfMutex['Link']) {
                errors.field('dynamicPage').up().field('Link').error('multiple values');
              } else {
                oneOfMutex['Link'] = true;
                $root.wix.common.DynamicPageLink.verify(msg.dynamicPage, helper, errors.field('dynamicPage'));
              }
            }
            if (msg.document != null) {
              if (oneOfMutex['Link']) {
                errors.field('document').up().field('Link').error('multiple values');
              } else {
                oneOfMutex['Link'] = true;
                $root.wix.common.DocumentLink.verify(msg.document, helper, errors.field('document'));
              }
            }
            if (msg.email != null) {
              if (oneOfMutex['Link']) {
                errors.field('email').up().field('Link').error('multiple values');
              } else {
                oneOfMutex['Link'] = true;
                $root.wix.common.EmailLink.verify(msg.email, helper, errors.field('email'));
              }
            }
            if (msg.phone != null) {
              if (oneOfMutex['Link']) {
                errors.field('phone').up().field('Link').error('multiple values');
              } else {
                oneOfMutex['Link'] = true;
                $root.wix.common.PhoneLink.verify(msg.phone, helper, errors.field('phone'));
              }
            }
            if (msg.address != null) {
              if (oneOfMutex['Link']) {
                errors.field('address').up().field('Link').error('multiple values');
              } else {
                oneOfMutex['Link'] = true;
                $root.wix.common.AddressLink.verify(msg.address, helper, errors.field('address'));
              }
            }
            if (msg.whatsApp != null) {
              if (oneOfMutex['Link']) {
                errors.field('whatsApp').up().field('Link').error('multiple values');
              } else {
                oneOfMutex['Link'] = true;
                $root.wix.common.WhatsAppLink.verify(msg.whatsApp, helper, errors.field('whatsApp'));
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.external != null) {
              json.external = $root.wix.common.ExternalLink.toJSON(obj.external, helper);
            }
            if (obj.page != null) {
              json.page = $root.wix.common.PageLink.toJSON(obj.page, helper);
            }
            if (obj.anchor != null) {
              json.anchor = $root.wix.common.AnchorLink.toJSON(obj.anchor, helper);
            }
            if (obj.dynamicPage != null) {
              json.dynamicPage = $root.wix.common.DynamicPageLink.toJSON(obj.dynamicPage, helper);
            }
            if (obj.document != null) {
              json.document = $root.wix.common.DocumentLink.toJSON(obj.document, helper);
            }
            if (obj.email != null) {
              json.email = $root.wix.common.EmailLink.toJSON(obj.email, helper);
            }
            if (obj.phone != null) {
              json.phone = $root.wix.common.PhoneLink.toJSON(obj.phone, helper);
            }
            if (obj.address != null) {
              json.address = $root.wix.common.AddressLink.toJSON(obj.address, helper);
            }
            if (obj.whatsApp != null) {
              json.whatsApp = $root.wix.common.WhatsAppLink.toJSON(obj.whatsApp, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.common.WixLink();

          if (json.external != null) {
            result.external = $root.wix.common.ExternalLink.fromJSON(json.external, helper);
          } else {
            delete result.external;
          }
          if (json.page != null) {
            result.page = $root.wix.common.PageLink.fromJSON(json.page, helper);
          } else {
            delete result.page;
          }
          if (json.anchor != null) {
            result.anchor = $root.wix.common.AnchorLink.fromJSON(json.anchor, helper);
          } else {
            delete result.anchor;
          }
          if (json.dynamicPage != null) {
            result.dynamicPage = $root.wix.common.DynamicPageLink.fromJSON(json.dynamicPage, helper);
          } else {
            delete result.dynamicPage;
          }
          if (json.document != null) {
            result.document = $root.wix.common.DocumentLink.fromJSON(json.document, helper);
          } else {
            delete result.document;
          }
          if (json.email != null) {
            result.email = $root.wix.common.EmailLink.fromJSON(json.email, helper);
          } else {
            delete result.email;
          }
          if (json.phone != null) {
            result.phone = $root.wix.common.PhoneLink.fromJSON(json.phone, helper);
          } else {
            delete result.phone;
          }
          if (json.address != null) {
            result.address = $root.wix.common.AddressLink.fromJSON(json.address, helper);
          } else {
            delete result.address;
          }
          if (json.whatsApp != null) {
            result.whatsApp = $root.wix.common.WhatsAppLink.fromJSON(json.whatsApp, helper);
          } else {
            delete result.whatsApp;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.external != null) {
              grpc.external = $root.wix.common.ExternalLink.toGRPC(obj.external, helper);
            }
            if (obj.page != null) {
              grpc.page = $root.wix.common.PageLink.toGRPC(obj.page, helper);
            }
            if (obj.anchor != null) {
              grpc.anchor = $root.wix.common.AnchorLink.toGRPC(obj.anchor, helper);
            }
            if (obj.dynamicPage != null) {
              grpc.dynamicPage = $root.wix.common.DynamicPageLink.toGRPC(obj.dynamicPage, helper);
            }
            if (obj.document != null) {
              grpc.document = $root.wix.common.DocumentLink.toGRPC(obj.document, helper);
            }
            if (obj.email != null) {
              grpc.email = $root.wix.common.EmailLink.toGRPC(obj.email, helper);
            }
            if (obj.phone != null) {
              grpc.phone = $root.wix.common.PhoneLink.toGRPC(obj.phone, helper);
            }
            if (obj.address != null) {
              grpc.address = $root.wix.common.AddressLink.toGRPC(obj.address, helper);
            }
            if (obj.whatsApp != null) {
              grpc.whatsApp = $root.wix.common.WhatsAppLink.toGRPC(obj.whatsApp, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.WixLink();

            if (grpc.external != null) {
              result.external = $root.wix.common.ExternalLink.fromGRPC(grpc.external, helper);
            } else {
              delete result.external;
            }
            if (grpc.page != null) {
              result.page = $root.wix.common.PageLink.fromGRPC(grpc.page, helper);
            } else {
              delete result.page;
            }
            if (grpc.anchor != null) {
              result.anchor = $root.wix.common.AnchorLink.fromGRPC(grpc.anchor, helper);
            } else {
              delete result.anchor;
            }
            if (grpc.dynamicPage != null) {
              result.dynamicPage = $root.wix.common.DynamicPageLink.fromGRPC(grpc.dynamicPage, helper);
            } else {
              delete result.dynamicPage;
            }
            if (grpc.document != null) {
              result.document = $root.wix.common.DocumentLink.fromGRPC(grpc.document, helper);
            } else {
              delete result.document;
            }
            if (grpc.email != null) {
              result.email = $root.wix.common.EmailLink.fromGRPC(grpc.email, helper);
            } else {
              delete result.email;
            }
            if (grpc.phone != null) {
              result.phone = $root.wix.common.PhoneLink.fromGRPC(grpc.phone, helper);
            } else {
              delete result.phone;
            }
            if (grpc.address != null) {
              result.address = $root.wix.common.AddressLink.fromGRPC(grpc.address, helper);
            } else {
              delete result.address;
            }
            if (grpc.whatsApp != null) {
              result.whatsApp = $root.wix.common.WhatsAppLink.fromGRPC(grpc.whatsApp, helper);
            } else {
              delete result.whatsApp;
            }
            return result;
          }
        }

        static describe() {
          return {
            'oneofs': {
              'Link': {
                'oneof': [
                  'external',
                  'page',
                  'anchor',
                  'dynamicPage',
                  'document',
                  'email',
                  'phone',
                  'address',
                  'whatsApp'
                ]
              }
            },
            'fields': {
              'external': {
                'type': $root.wix.common.ExternalLink,
                'id': 1
              },
              'page': {
                'type': $root.wix.common.PageLink,
                'id': 2
              },
              'anchor': {
                'type': $root.wix.common.AnchorLink,
                'id': 3
              },
              'dynamicPage': {
                'type': $root.wix.common.DynamicPageLink,
                'id': 4
              },
              'document': {
                'type': $root.wix.common.DocumentLink,
                'id': 5
              },
              'email': {
                'type': $root.wix.common.EmailLink,
                'id': 6
              },
              'phone': {
                'type': $root.wix.common.PhoneLink,
                'id': 7
              },
              'address': {
                'type': $root.wix.common.AddressLink,
                'id': 8
              },
              'whatsApp': {
                'type': $root.wix.common.WhatsAppLink,
                'id': 9
              }
            }
          };
        }
      }

      Object.defineProperty(WixLink.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.WixLink');
        },
        enumerable: false,
        configurable: false
      });
      return WixLink;
    }());
    common.ExternalLink = (function() {

      class ExternalLink {

        constructor(props) {
          this.url = props && props.url;
          this.target = props && props.target;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.url != null) {
              if (typeof msg.url !== 'string') {
                errors.field('url').error('string expected');
              }
            }
            if (msg.target != null) {
              $root.google.protobuf.StringValue.verify(msg.target, helper, errors.field('target'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.url != null) {
              json.url = obj.url;
            }
            if (obj.target != null) {
              json.target = $root.google.protobuf.StringValue.toJSON(obj.target, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.common.ExternalLink();

          if (json.url != null) {
            result.url = json.url;
          } else {
            result.url = '';
          }
          if (json.target != null) {
            result.target = $root.google.protobuf.StringValue.fromJSON(json.target, helper);
          } else {
            delete result.target;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.url != null) {
              grpc.url = obj.url;
            }
            if (obj.target != null) {
              grpc.target = $root.google.protobuf.StringValue.toGRPC(obj.target, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.ExternalLink();

            if (grpc.url != null) {
              result.url = grpc.url;
            } else {
              result.url = '';
            }
            if (grpc.target != null) {
              result.target = $root.google.protobuf.StringValue.fromGRPC(grpc.target, helper);
            } else {
              delete result.target;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'url': {
                'type': 'string',
                'id': 1,
                'options': {
                  '(wix.api.format)': 'URI'
                }
              },
              'target': {
                'type': $root.google.protobuf.StringValue,
                'id': 2
              }
            }
          };
        }
      }

      Object.defineProperty(ExternalLink.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.ExternalLink');
        },
        enumerable: false,
        configurable: false
      });
      return ExternalLink;
    }());
    common.PageLink = (function() {

      class PageLink {

        constructor(props) {
          this.pageId = props && props.pageId;
          this.target = props && props.target;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.pageId != null) {
              if (typeof msg.pageId !== 'string') {
                errors.field('pageId').error('string expected');
              }
            }
            if (msg.target != null) {
              $root.google.protobuf.StringValue.verify(msg.target, helper, errors.field('target'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.pageId != null) {
              json.pageId = obj.pageId;
            }
            if (obj.target != null) {
              json.target = $root.google.protobuf.StringValue.toJSON(obj.target, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.common.PageLink();

          if (json.pageId != null) {
            result.pageId = json.pageId;
          } else {
            result.pageId = '';
          }
          if (json.target != null) {
            result.target = $root.google.protobuf.StringValue.fromJSON(json.target, helper);
          } else {
            delete result.target;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.pageId != null) {
              grpc.pageId = obj.pageId;
            }
            if (obj.target != null) {
              grpc.target = $root.google.protobuf.StringValue.toGRPC(obj.target, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.PageLink();

            if (grpc.pageId != null) {
              result.pageId = grpc.pageId;
            } else {
              result.pageId = '';
            }
            if (grpc.target != null) {
              result.target = $root.google.protobuf.StringValue.fromGRPC(grpc.target, helper);
            } else {
              delete result.target;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'pageId': {
                'type': 'string',
                'id': 1
              },
              'target': {
                'type': $root.google.protobuf.StringValue,
                'id': 2
              }
            }
          };
        }
      }

      Object.defineProperty(PageLink.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.PageLink');
        },
        enumerable: false,
        configurable: false
      });
      return PageLink;
    }());
    common.AnchorLink = (function() {

      class AnchorLink {

        constructor(props) {
          this.anchorName = props && props.anchorName;
          this.anchorDataId = props && props.anchorDataId;
          this.pageId = props && props.pageId;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.anchorName != null) {
              if (typeof msg.anchorName !== 'string') {
                errors.field('anchorName').error('string expected');
              }
            }
            if (msg.anchorDataId != null) {
              if (typeof msg.anchorDataId !== 'string') {
                errors.field('anchorDataId').error('string expected');
              }
            }
            if (msg.pageId != null) {
              if (typeof msg.pageId !== 'string') {
                errors.field('pageId').error('string expected');
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.anchorName != null) {
              json.anchorName = obj.anchorName;
            }
            if (obj.anchorDataId != null) {
              json.anchorDataId = obj.anchorDataId;
            }
            if (obj.pageId != null) {
              json.pageId = obj.pageId;
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.common.AnchorLink();

          if (json.anchorName != null) {
            result.anchorName = json.anchorName;
          } else {
            result.anchorName = '';
          }
          if (json.anchorDataId != null) {
            result.anchorDataId = json.anchorDataId;
          } else {
            result.anchorDataId = '';
          }
          if (json.pageId != null) {
            result.pageId = json.pageId;
          } else {
            result.pageId = '';
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.anchorName != null) {
              grpc.anchorName = obj.anchorName;
            }
            if (obj.anchorDataId != null) {
              grpc.anchorDataId = obj.anchorDataId;
            }
            if (obj.pageId != null) {
              grpc.pageId = obj.pageId;
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.AnchorLink();

            if (grpc.anchorName != null) {
              result.anchorName = grpc.anchorName;
            } else {
              result.anchorName = '';
            }
            if (grpc.anchorDataId != null) {
              result.anchorDataId = grpc.anchorDataId;
            } else {
              result.anchorDataId = '';
            }
            if (grpc.pageId != null) {
              result.pageId = grpc.pageId;
            } else {
              result.pageId = '';
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'anchorName': {
                'type': 'string',
                'id': 1
              },
              'anchorDataId': {
                'type': 'string',
                'id': 2
              },
              'pageId': {
                'type': 'string',
                'id': 3
              }
            }
          };
        }
      }

      Object.defineProperty(AnchorLink.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.AnchorLink');
        },
        enumerable: false,
        configurable: false
      });
      return AnchorLink;
    }());
    common.DynamicPageLink = (function() {

      class DynamicPageLink {

        constructor(props) {
          this.routerId = props && props.routerId;
          this.innerRoute = props && props.innerRoute;
          this.anchorDataId = props && props.anchorDataId;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.routerId != null) {
              if (typeof msg.routerId !== 'string') {
                errors.field('routerId').error('string expected');
              }
            }
            if (msg.innerRoute != null) {
              if (typeof msg.innerRoute !== 'string') {
                errors.field('innerRoute').error('string expected');
              }
            }
            if (msg.anchorDataId != null) {
              $root.google.protobuf.StringValue.verify(msg.anchorDataId, helper, errors.field('anchorDataId'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.routerId != null) {
              json.routerId = obj.routerId;
            }
            if (obj.innerRoute != null) {
              json.innerRoute = obj.innerRoute;
            }
            if (obj.anchorDataId != null) {
              json.anchorDataId = $root.google.protobuf.StringValue.toJSON(obj.anchorDataId, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.common.DynamicPageLink();

          if (json.routerId != null) {
            result.routerId = json.routerId;
          } else {
            result.routerId = '';
          }
          if (json.innerRoute != null) {
            result.innerRoute = json.innerRoute;
          } else {
            result.innerRoute = '';
          }
          if (json.anchorDataId != null) {
            result.anchorDataId = $root.google.protobuf.StringValue.fromJSON(json.anchorDataId, helper);
          } else {
            delete result.anchorDataId;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.routerId != null) {
              grpc.routerId = obj.routerId;
            }
            if (obj.innerRoute != null) {
              grpc.innerRoute = obj.innerRoute;
            }
            if (obj.anchorDataId != null) {
              grpc.anchorDataId = $root.google.protobuf.StringValue.toGRPC(obj.anchorDataId, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.DynamicPageLink();

            if (grpc.routerId != null) {
              result.routerId = grpc.routerId;
            } else {
              result.routerId = '';
            }
            if (grpc.innerRoute != null) {
              result.innerRoute = grpc.innerRoute;
            } else {
              result.innerRoute = '';
            }
            if (grpc.anchorDataId != null) {
              result.anchorDataId = $root.google.protobuf.StringValue.fromGRPC(grpc.anchorDataId, helper);
            } else {
              delete result.anchorDataId;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'routerId': {
                'type': 'string',
                'id': 1
              },
              'innerRoute': {
                'type': 'string',
                'id': 2
              },
              'anchorDataId': {
                'type': $root.google.protobuf.StringValue,
                'id': 3
              }
            }
          };
        }
      }

      Object.defineProperty(DynamicPageLink.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.DynamicPageLink');
        },
        enumerable: false,
        configurable: false
      });
      return DynamicPageLink;
    }());
    common.DocumentLink = (function() {

      class DocumentLink {

        constructor(props) {
          this.docId = props && props.docId;
          this.name = props && props.name;
          this.indexable = props && props.indexable;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.docId != null) {
              if (typeof msg.docId !== 'string') {
                errors.field('docId').error('string expected');
              }
            }
            if (msg.name != null) {
              $root.google.protobuf.StringValue.verify(msg.name, helper, errors.field('name'));
            }
            if (msg.indexable != null) {
              if (typeof msg.indexable !== 'boolean') {
                errors.field('indexable').error('boolean expected');
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.docId != null) {
              json.docId = obj.docId;
            }
            if (obj.name != null) {
              json.name = $root.google.protobuf.StringValue.toJSON(obj.name, helper);
            }
            if (obj.indexable != null) {
              json.indexable = obj.indexable;
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.common.DocumentLink();

          if (json.docId != null) {
            result.docId = json.docId;
          } else {
            result.docId = '';
          }
          if (json.name != null) {
            result.name = $root.google.protobuf.StringValue.fromJSON(json.name, helper);
          } else {
            delete result.name;
          }
          if (json.indexable != null) {
            result.indexable = json.indexable;
          } else {
            result.indexable = false;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.docId != null) {
              grpc.docId = obj.docId;
            }
            if (obj.name != null) {
              grpc.name = $root.google.protobuf.StringValue.toGRPC(obj.name, helper);
            }
            if (obj.indexable != null) {
              grpc.indexable = obj.indexable;
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.DocumentLink();

            if (grpc.docId != null) {
              result.docId = grpc.docId;
            } else {
              result.docId = '';
            }
            if (grpc.name != null) {
              result.name = $root.google.protobuf.StringValue.fromGRPC(grpc.name, helper);
            } else {
              delete result.name;
            }
            if (grpc.indexable != null) {
              result.indexable = grpc.indexable;
            } else {
              result.indexable = false;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'docId': {
                'type': 'string',
                'id': 1
              },
              'name': {
                'type': $root.google.protobuf.StringValue,
                'id': 2
              },
              'indexable': {
                'type': 'bool',
                'id': 3
              }
            }
          };
        }
      }

      Object.defineProperty(DocumentLink.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.DocumentLink');
        },
        enumerable: false,
        configurable: false
      });
      return DocumentLink;
    }());
    common.EmailLink = (function() {

      class EmailLink {

        constructor(props) {
          this.recipient = props && props.recipient;
          this.subject = props && props.subject;
          this.body = props && props.body;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.recipient != null) {
              if (typeof msg.recipient !== 'string') {
                errors.field('recipient').error('string expected');
              }
            }
            if (msg.subject != null) {
              $root.google.protobuf.StringValue.verify(msg.subject, helper, errors.field('subject'));
            }
            if (msg.body != null) {
              $root.google.protobuf.StringValue.verify(msg.body, helper, errors.field('body'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.recipient != null) {
              json.recipient = obj.recipient;
            }
            if (obj.subject != null) {
              json.subject = $root.google.protobuf.StringValue.toJSON(obj.subject, helper);
            }
            if (obj.body != null) {
              json.body = $root.google.protobuf.StringValue.toJSON(obj.body, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.common.EmailLink();

          if (json.recipient != null) {
            result.recipient = json.recipient;
          } else {
            result.recipient = '';
          }
          if (json.subject != null) {
            result.subject = $root.google.protobuf.StringValue.fromJSON(json.subject, helper);
          } else {
            delete result.subject;
          }
          if (json.body != null) {
            result.body = $root.google.protobuf.StringValue.fromJSON(json.body, helper);
          } else {
            delete result.body;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.recipient != null) {
              grpc.recipient = obj.recipient;
            }
            if (obj.subject != null) {
              grpc.subject = $root.google.protobuf.StringValue.toGRPC(obj.subject, helper);
            }
            if (obj.body != null) {
              grpc.body = $root.google.protobuf.StringValue.toGRPC(obj.body, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.EmailLink();

            if (grpc.recipient != null) {
              result.recipient = grpc.recipient;
            } else {
              result.recipient = '';
            }
            if (grpc.subject != null) {
              result.subject = $root.google.protobuf.StringValue.fromGRPC(grpc.subject, helper);
            } else {
              delete result.subject;
            }
            if (grpc.body != null) {
              result.body = $root.google.protobuf.StringValue.fromGRPC(grpc.body, helper);
            } else {
              delete result.body;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'recipient': {
                'type': 'string',
                'id': 1,
                'options': {
                  '(wix.api.format)': 'EMAIL'
                }
              },
              'subject': {
                'type': $root.google.protobuf.StringValue,
                'id': 2
              },
              'body': {
                'type': $root.google.protobuf.StringValue,
                'id': 3
              }
            }
          };
        }
      }

      Object.defineProperty(EmailLink.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.EmailLink');
        },
        enumerable: false,
        configurable: false
      });
      return EmailLink;
    }());
    common.PhoneLink = (function() {

      class PhoneLink {

        constructor(props) {
          this.phoneNumber = props && props.phoneNumber;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.phoneNumber != null) {
              if (typeof msg.phoneNumber !== 'string') {
                errors.field('phoneNumber').error('string expected');
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.phoneNumber != null) {
              json.phoneNumber = obj.phoneNumber;
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.common.PhoneLink();

          if (json.phoneNumber != null) {
            result.phoneNumber = json.phoneNumber;
          } else {
            result.phoneNumber = '';
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.phoneNumber != null) {
              grpc.phoneNumber = obj.phoneNumber;
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.PhoneLink();

            if (grpc.phoneNumber != null) {
              result.phoneNumber = grpc.phoneNumber;
            } else {
              result.phoneNumber = '';
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'phoneNumber': {
                'type': 'string',
                'id': 1,
                'options': {
                  '(wix.api.format)': 'PHONE',
                  '(wix.api.maxLength)': 100
                }
              }
            }
          };
        }
      }

      Object.defineProperty(PhoneLink.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.PhoneLink');
        },
        enumerable: false,
        configurable: false
      });
      return PhoneLink;
    }());
    common.AddressLink = (function() {

      class AddressLink {

        constructor(props) {
          this.address = props && props.address;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.address != null) {
              if (typeof msg.address !== 'string') {
                errors.field('address').error('string expected');
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.address != null) {
              json.address = obj.address;
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.common.AddressLink();

          if (json.address != null) {
            result.address = json.address;
          } else {
            result.address = '';
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.address != null) {
              grpc.address = obj.address;
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.AddressLink();

            if (grpc.address != null) {
              result.address = grpc.address;
            } else {
              result.address = '';
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'address': {
                'type': 'string',
                'id': 1
              }
            }
          };
        }
      }

      Object.defineProperty(AddressLink.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.AddressLink');
        },
        enumerable: false,
        configurable: false
      });
      return AddressLink;
    }());
    common.WhatsAppLink = (function() {

      class WhatsAppLink {

        constructor(props) {
          this.phoneNumber = props && props.phoneNumber;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.phoneNumber != null) {
              if (typeof msg.phoneNumber !== 'string') {
                errors.field('phoneNumber').error('string expected');
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.phoneNumber != null) {
              json.phoneNumber = obj.phoneNumber;
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.common.WhatsAppLink();

          if (json.phoneNumber != null) {
            result.phoneNumber = json.phoneNumber;
          } else {
            result.phoneNumber = '';
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.phoneNumber != null) {
              grpc.phoneNumber = obj.phoneNumber;
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.WhatsAppLink();

            if (grpc.phoneNumber != null) {
              result.phoneNumber = grpc.phoneNumber;
            } else {
              result.phoneNumber = '';
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'phoneNumber': {
                'type': 'string',
                'id': 1,
                'options': {
                  '(wix.api.format)': 'PHONE'
                }
              }
            }
          };
        }
      }

      Object.defineProperty(WhatsAppLink.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.WhatsAppLink');
        },
        enumerable: false,
        configurable: false
      });
      return WhatsAppLink;
    }());
    return common;
  }());
  wix.social = (function() {
    const social = {};

    social.Text = (function() {

      class Text {

        constructor(props) {
          this.contentType = props && props.contentType;
          this.content = props && props.content;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.contentType != null) {
              $root.wix.social.ContentType.verify(msg.contentType, helper, errors.field('contentType'));
            }
            if (msg.content != null) {
              $root.google.protobuf.StringValue.verify(msg.content, helper, errors.field('content'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.contentType != null) {
              json.contentType = $root.wix.social.ContentType[obj.contentType];
            }
            if (obj.content != null) {
              json.content = $root.google.protobuf.StringValue.toJSON(obj.content, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.social.Text();

          if (json.contentType != null) {
            result.contentType = $root.wix.social.ContentType[json.contentType];
          } else {
            result.contentType = 'PLAIN_TEXT';
          }
          if (json.content != null) {
            result.content = $root.google.protobuf.StringValue.fromJSON(json.content, helper);
          } else {
            delete result.content;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.contentType != null) {
              grpc.contentType = obj.contentType;
            }
            if (obj.content != null) {
              grpc.content = $root.google.protobuf.StringValue.toGRPC(obj.content, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.social.Text();

            if (grpc.contentType != null) {
              result.contentType = grpc.contentType;
            } else {
              result.contentType = 'PLAIN_TEXT';
            }
            if (grpc.content != null) {
              result.content = $root.google.protobuf.StringValue.fromGRPC(grpc.content, helper);
            } else {
              delete result.content;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'contentType': {
                'type': $root.wix.social.ContentType,
                'id': 1
              },
              'content': {
                'type': $root.google.protobuf.StringValue,
                'id': 2
              }
            }
          };
        }
      }

      Object.defineProperty(Text.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.social.Text');
        },
        enumerable: false,
        configurable: false
      });
      return Text;
    }());
    social.ContentType = {
      verify: (value, helper, errors = helper.verification.Errors.empty()) => {
        switch (value) {
          default: {
            errors.error('enum expected');
          }
          case 'PLAIN_TEXT':
          case 'DRAFTJS':
            break;
        }
        return errors;
      },
      'PLAIN_TEXT': 'PLAIN_TEXT',
      'DRAFTJS': 'DRAFTJS'
    };
    social.Resource = (function() {

      class Resource {

        constructor(props) {
          this.uri = props && props.uri;
          this.id = props && props.id;
          this.mediaType = props && props.mediaType;
          this.pixelDimensions = props && props.pixelDimensions;
          this.mimeType = props && props.mimeType;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            const oneOfMutex = {};

            if (msg.uri != null) {
              if (oneOfMutex['ResourceId']) {
                errors.field('uri').up().field('ResourceId').error('multiple values');
              } else {
                oneOfMutex['ResourceId'] = true;
                if (typeof msg.uri !== 'string') {
                  errors.field('uri').error('string expected');
                }
              }
            }
            if (msg.id != null) {
              if (oneOfMutex['ResourceId']) {
                errors.field('id').up().field('ResourceId').error('multiple values');
              } else {
                oneOfMutex['ResourceId'] = true;
                if (typeof msg.id !== 'string') {
                  errors.field('id').error('string expected');
                }
              }
            }
            if (msg.mediaType != null) {
              $root.wix.social.MediaType.verify(msg.mediaType, helper, errors.field('mediaType'));
            }
            if (msg.pixelDimensions != null) {
              $root.wix.social.PixelDimensions.verify(msg.pixelDimensions, helper, errors.field('pixelDimensions'));
            }
            if (msg.mimeType != null) {
              $root.google.protobuf.StringValue.verify(msg.mimeType, helper, errors.field('mimeType'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.uri != null) {
              json.uri = obj.uri;
            }
            if (obj.id != null) {
              json.id = obj.id;
            }
            if (obj.mediaType != null) {
              json.mediaType = $root.wix.social.MediaType[obj.mediaType];
            }
            if (obj.pixelDimensions != null) {
              json.pixelDimensions = $root.wix.social.PixelDimensions.toJSON(obj.pixelDimensions, helper);
            }
            if (obj.mimeType != null) {
              json.mimeType = $root.google.protobuf.StringValue.toJSON(obj.mimeType, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.social.Resource();

          if (json.uri != null) {
            result.uri = json.uri;
          } else {
            delete result.uri;
          }
          if (json.id != null) {
            result.id = json.id;
          } else {
            delete result.id;
          }
          if (json.mediaType != null) {
            result.mediaType = $root.wix.social.MediaType[json.mediaType];
          } else {
            result.mediaType = 'ATTACHMENT';
          }
          if (json.pixelDimensions != null) {
            result.pixelDimensions = $root.wix.social.PixelDimensions.fromJSON(json.pixelDimensions, helper);
          } else {
            delete result.pixelDimensions;
          }
          if (json.mimeType != null) {
            result.mimeType = $root.google.protobuf.StringValue.fromJSON(json.mimeType, helper);
          } else {
            delete result.mimeType;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.uri != null) {
              grpc.uri = obj.uri;
            }
            if (obj.id != null) {
              grpc.id = obj.id;
            }
            if (obj.mediaType != null) {
              grpc.mediaType = obj.mediaType;
            }
            if (obj.pixelDimensions != null) {
              grpc.pixelDimensions = $root.wix.social.PixelDimensions.toGRPC(obj.pixelDimensions, helper);
            }
            if (obj.mimeType != null) {
              grpc.mimeType = $root.google.protobuf.StringValue.toGRPC(obj.mimeType, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.social.Resource();

            if (grpc.uri != null) {
              result.uri = grpc.uri;
            } else {
              delete result.uri;
            }
            if (grpc.id != null) {
              result.id = grpc.id;
            } else {
              delete result.id;
            }
            if (grpc.mediaType != null) {
              result.mediaType = grpc.mediaType;
            } else {
              result.mediaType = 'ATTACHMENT';
            }
            if (grpc.pixelDimensions != null) {
              result.pixelDimensions = $root.wix.social.PixelDimensions.fromGRPC(grpc.pixelDimensions, helper);
            } else {
              delete result.pixelDimensions;
            }
            if (grpc.mimeType != null) {
              result.mimeType = $root.google.protobuf.StringValue.fromGRPC(grpc.mimeType, helper);
            } else {
              delete result.mimeType;
            }
            return result;
          }
        }

        static describe() {
          return {
            'oneofs': {
              'ResourceId': {
                'oneof': [
                  'uri',
                  'id'
                ]
              }
            },
            'fields': {
              'uri': {
                'type': 'string',
                'id': 1
              },
              'id': {
                'type': 'string',
                'id': 2
              },
              'mediaType': {
                'type': $root.wix.social.MediaType,
                'id': 3
              },
              'pixelDimensions': {
                'type': $root.wix.social.PixelDimensions,
                'id': 4
              },
              'mimeType': {
                'type': $root.google.protobuf.StringValue,
                'id': 5
              }
            }
          };
        }
      }

      Object.defineProperty(Resource.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.social.Resource');
        },
        enumerable: false,
        configurable: false
      });
      return Resource;
    }());
    social.MediaType = {
      verify: (value, helper, errors = helper.verification.Errors.empty()) => {
        switch (value) {
          default: {
            errors.error('enum expected');
          }
          case 'ATTACHMENT':
          case 'IMAGE':
          case 'VIDEO':
            break;
        }
        return errors;
      },
      'ATTACHMENT': 'ATTACHMENT',
      'IMAGE': 'IMAGE',
      'VIDEO': 'VIDEO'
    };
    social.PixelDimensions = (function() {

      class PixelDimensions {

        constructor(props) {
          this.width = props && props.width;
          this.height = props && props.height;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.width != null) {
              if (!Number.isInteger(msg.width)) {
                errors.field('width').error('integer expected');
              }
            }
            if (msg.height != null) {
              if (!Number.isInteger(msg.height)) {
                errors.field('height').error('integer expected');
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.width != null) {
              json.width = obj.width;
            }
            if (obj.height != null) {
              json.height = obj.height;
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.social.PixelDimensions();

          if (json.width != null) {
            result.width = json.width;
          } else {
            result.width = 0;
          }
          if (json.height != null) {
            result.height = json.height;
          } else {
            result.height = 0;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.width != null) {
              grpc.width = obj.width;
            }
            if (obj.height != null) {
              grpc.height = obj.height;
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.social.PixelDimensions();

            if (grpc.width != null) {
              result.width = grpc.width;
            } else {
              result.width = 0;
            }
            if (grpc.height != null) {
              result.height = grpc.height;
            } else {
              result.height = 0;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'width': {
                'type': 'int32',
                'id': 1
              },
              'height': {
                'type': 'int32',
                'id': 2
              }
            }
          };
        }
      }

      Object.defineProperty(PixelDimensions.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.social.PixelDimensions');
        },
        enumerable: false,
        configurable: false
      });
      return PixelDimensions;
    }());
    social.Mention = (function() {

      class Mention {

        constructor(props) {
          this.identity = props && props.identity;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.identity != null) {
              $root.wix.social.SocialIdentity.verify(msg.identity, helper, errors.field('identity'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.identity != null) {
              json.identity = $root.wix.social.SocialIdentity.toJSON(obj.identity, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.social.Mention();

          if (json.identity != null) {
            result.identity = $root.wix.social.SocialIdentity.fromJSON(json.identity, helper);
          } else {
            delete result.identity;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.identity != null) {
              grpc.identity = $root.wix.social.SocialIdentity.toGRPC(obj.identity, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.social.Mention();

            if (grpc.identity != null) {
              result.identity = $root.wix.social.SocialIdentity.fromGRPC(grpc.identity, helper);
            } else {
              delete result.identity;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'identity': {
                'type': $root.wix.social.SocialIdentity,
                'id': 1
              }
            }
          };
        }
      }

      Object.defineProperty(Mention.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.social.Mention');
        },
        enumerable: false,
        configurable: false
      });
      return Mention;
    }());
    social.ExternalReference = (function() {

      class ExternalReference {

        constructor(props) {
          this.url = props && props.url;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.url != null) {
              if (typeof msg.url !== 'string') {
                errors.field('url').error('string expected');
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.url != null) {
              json.url = obj.url;
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.social.ExternalReference();

          if (json.url != null) {
            result.url = json.url;
          } else {
            result.url = '';
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.url != null) {
              grpc.url = obj.url;
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.social.ExternalReference();

            if (grpc.url != null) {
              result.url = grpc.url;
            } else {
              result.url = '';
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'url': {
                'type': 'string',
                'id': 1,
                'options': {
                  '(wix.api.format)': 'URI'
                }
              }
            }
          };
        }
      }

      Object.defineProperty(ExternalReference.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.social.ExternalReference');
        },
        enumerable: false,
        configurable: false
      });
      return ExternalReference;
    }());
    social.ContentPreview = (function() {

      class ContentPreview {

        constructor(props) {
          this.contentUrl = props && props.contentUrl;
          this.openGraph = props && props.openGraph;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.contentUrl != null) {
              if (typeof msg.contentUrl !== 'string') {
                errors.field('contentUrl').error('string expected');
              }
            }
            if (msg.openGraph != null) {
              $root.wix.social.OpenGraph.verify(msg.openGraph, helper, errors.field('openGraph'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.contentUrl != null) {
              json.contentUrl = obj.contentUrl;
            }
            if (obj.openGraph != null) {
              json.openGraph = $root.wix.social.OpenGraph.toJSON(obj.openGraph, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.social.ContentPreview();

          if (json.contentUrl != null) {
            result.contentUrl = json.contentUrl;
          } else {
            result.contentUrl = '';
          }
          if (json.openGraph != null) {
            result.openGraph = $root.wix.social.OpenGraph.fromJSON(json.openGraph, helper);
          } else {
            delete result.openGraph;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.contentUrl != null) {
              grpc.contentUrl = obj.contentUrl;
            }
            if (obj.openGraph != null) {
              grpc.openGraph = $root.wix.social.OpenGraph.toGRPC(obj.openGraph, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.social.ContentPreview();

            if (grpc.contentUrl != null) {
              result.contentUrl = grpc.contentUrl;
            } else {
              result.contentUrl = '';
            }
            if (grpc.openGraph != null) {
              result.openGraph = $root.wix.social.OpenGraph.fromGRPC(grpc.openGraph, helper);
            } else {
              delete result.openGraph;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'contentUrl': {
                'type': 'string',
                'id': 1
              },
              'openGraph': {
                'type': $root.wix.social.OpenGraph,
                'id': 2
              }
            }
          };
        }
      }

      Object.defineProperty(ContentPreview.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.social.ContentPreview');
        },
        enumerable: false,
        configurable: false
      });
      return ContentPreview;
    }());
    social.OpenGraph = (function() {

      class OpenGraph {

        constructor(props) {
          this.title = props && props.title;
          this.url = props && props.url;
          this.description = props && props.description;
          this.image = props && props.image;
          this.typeWebsite = props && props.typeWebsite;
          this.typeArticle = props && props.typeArticle;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            const oneOfMutex = {};

            if (msg.title != null) {
              if (typeof msg.title !== 'string') {
                errors.field('title').error('string expected');
              }
            }
            if (msg.url != null) {
              if (typeof msg.url !== 'string') {
                errors.field('url').error('string expected');
              }
            }
            if (msg.description != null) {
              $root.google.protobuf.StringValue.verify(msg.description, helper, errors.field('description'));
            }
            if (msg.image != null) {
              $root.wix.social.OpenGraph.Image.verify(msg.image, helper, errors.field('image'));
            }
            if (msg.typeWebsite != null) {
              if (oneOfMutex['openGraphType']) {
                errors.field('typeWebsite').up().field('openGraphType').error('multiple values');
              } else {
                oneOfMutex['openGraphType'] = true;
                $root.wix.social.OpenGraph.Website.verify(msg.typeWebsite, helper, errors.field('typeWebsite'));
              }
            }
            if (msg.typeArticle != null) {
              if (oneOfMutex['openGraphType']) {
                errors.field('typeArticle').up().field('openGraphType').error('multiple values');
              } else {
                oneOfMutex['openGraphType'] = true;
                $root.wix.social.OpenGraph.Article.verify(msg.typeArticle, helper, errors.field('typeArticle'));
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.title != null) {
              json.title = obj.title;
            }
            if (obj.url != null) {
              json.url = obj.url;
            }
            if (obj.description != null) {
              json.description = $root.google.protobuf.StringValue.toJSON(obj.description, helper);
            }
            if (obj.image != null) {
              json.image = $root.wix.social.OpenGraph.Image.toJSON(obj.image, helper);
            }
            if (obj.typeWebsite != null) {
              json.typeWebsite = $root.wix.social.OpenGraph.Website.toJSON(obj.typeWebsite, helper);
            }
            if (obj.typeArticle != null) {
              json.typeArticle = $root.wix.social.OpenGraph.Article.toJSON(obj.typeArticle, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.social.OpenGraph();

          if (json.title != null) {
            result.title = json.title;
          } else {
            result.title = '';
          }
          if (json.url != null) {
            result.url = json.url;
          } else {
            result.url = '';
          }
          if (json.description != null) {
            result.description = $root.google.protobuf.StringValue.fromJSON(json.description, helper);
          } else {
            delete result.description;
          }
          if (json.image != null) {
            result.image = $root.wix.social.OpenGraph.Image.fromJSON(json.image, helper);
          } else {
            delete result.image;
          }
          if (json.typeWebsite != null) {
            result.typeWebsite = $root.wix.social.OpenGraph.Website.fromJSON(json.typeWebsite, helper);
          } else {
            delete result.typeWebsite;
          }
          if (json.typeArticle != null) {
            result.typeArticle = $root.wix.social.OpenGraph.Article.fromJSON(json.typeArticle, helper);
          } else {
            delete result.typeArticle;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.title != null) {
              grpc.title = obj.title;
            }
            if (obj.url != null) {
              grpc.url = obj.url;
            }
            if (obj.description != null) {
              grpc.description = $root.google.protobuf.StringValue.toGRPC(obj.description, helper);
            }
            if (obj.image != null) {
              grpc.image = $root.wix.social.OpenGraph.Image.toGRPC(obj.image, helper);
            }
            if (obj.typeWebsite != null) {
              grpc.typeWebsite = $root.wix.social.OpenGraph.Website.toGRPC(obj.typeWebsite, helper);
            }
            if (obj.typeArticle != null) {
              grpc.typeArticle = $root.wix.social.OpenGraph.Article.toGRPC(obj.typeArticle, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.social.OpenGraph();

            if (grpc.title != null) {
              result.title = grpc.title;
            } else {
              result.title = '';
            }
            if (grpc.url != null) {
              result.url = grpc.url;
            } else {
              result.url = '';
            }
            if (grpc.description != null) {
              result.description = $root.google.protobuf.StringValue.fromGRPC(grpc.description, helper);
            } else {
              delete result.description;
            }
            if (grpc.image != null) {
              result.image = $root.wix.social.OpenGraph.Image.fromGRPC(grpc.image, helper);
            } else {
              delete result.image;
            }
            if (grpc.typeWebsite != null) {
              result.typeWebsite = $root.wix.social.OpenGraph.Website.fromGRPC(grpc.typeWebsite, helper);
            } else {
              delete result.typeWebsite;
            }
            if (grpc.typeArticle != null) {
              result.typeArticle = $root.wix.social.OpenGraph.Article.fromGRPC(grpc.typeArticle, helper);
            } else {
              delete result.typeArticle;
            }
            return result;
          }
        }

        static describe() {
          return {
            'oneofs': {
              'openGraphType': {
                'oneof': [
                  'typeWebsite',
                  'typeArticle'
                ]
              }
            },
            'fields': {
              'title': {
                'type': 'string',
                'id': 1
              },
              'url': {
                'type': 'string',
                'id': 2,
                'options': {
                  '(wix.api.format)': 'URI'
                }
              },
              'description': {
                'type': $root.google.protobuf.StringValue,
                'id': 3
              },
              'image': {
                'type': $root.wix.social.OpenGraph.Image,
                'id': 4
              },
              'typeWebsite': {
                'type': $root.wix.social.OpenGraph.Website,
                'id': 5
              },
              'typeArticle': {
                'type': $root.wix.social.OpenGraph.Article,
                'id': 6
              }
            },
            'nested': {
              'Image': {
                'fields': {
                  'url': {
                    'type': 'string',
                    'id': 1
                  },
                  'width': {
                    'type': 'google.protobuf.Int32Value',
                    'id': 2
                  },
                  'height': {
                    'type': 'google.protobuf.Int32Value',
                    'id': 3
                  }
                }
              },
              'Website': {
                'fields': {}
              },
              'Article': {
                'fields': {
                  'publishedTime': {
                    'type': 'google.protobuf.Timestamp',
                    'id': 1
                  },
                  'modifiedTime': {
                    'type': 'google.protobuf.Timestamp',
                    'id': 2
                  },
                  'expirationTime': {
                    'type': 'google.protobuf.Timestamp',
                    'id': 3
                  },
                  'author': {
                    'rule': 'repeated',
                    'type': 'string',
                    'id': 4
                  },
                  'section': {
                    'type': 'string',
                    'id': 5
                  },
                  'tag': {
                    'rule': 'repeated',
                    'type': 'string',
                    'id': 6
                  }
                }
              }
            }
          };
        }
      }

      OpenGraph.Image = (function() {

        class Image {

          constructor(props) {
            this.url = props && props.url;
            this.width = props && props.width;
            this.height = props && props.height;
          }

          static verify(msg, helper, errors = helper.verification.Errors.empty()) {
            if (typeof msg !== 'object' || msg == null) {
              errors.error('object expected');
            } else {
              if (msg.url != null) {
                if (typeof msg.url !== 'string') {
                  errors.field('url').error('string expected');
                }
              }
              if (msg.width != null) {
                $root.google.protobuf.Int32Value.verify(msg.width, helper, errors.field('width'));
              }
              if (msg.height != null) {
                $root.google.protobuf.Int32Value.verify(msg.height, helper, errors.field('height'));
              }
            }
            return errors;
          }

          static toJSON(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const json = {};

              if (obj.url != null) {
                json.url = obj.url;
              }
              if (obj.width != null) {
                json.width = $root.google.protobuf.Int32Value.toJSON(obj.width, helper);
              }
              if (obj.height != null) {
                json.height = $root.google.protobuf.Int32Value.toJSON(obj.height, helper);
              }
              return json;
            }
          }

          static fromJSON(json, helper) {
            const result = new $root.wix.social.OpenGraph.Image();

            if (json.url != null) {
              result.url = json.url;
            } else {
              result.url = '';
            }
            if (json.width != null) {
              result.width = $root.google.protobuf.Int32Value.fromJSON(json.width, helper);
            } else {
              delete result.width;
            }
            if (json.height != null) {
              result.height = $root.google.protobuf.Int32Value.fromJSON(json.height, helper);
            } else {
              delete result.height;
            }
            return result;
          }

          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};

              if (obj.url != null) {
                grpc.url = obj.url;
              }
              if (obj.width != null) {
                grpc.width = $root.google.protobuf.Int32Value.toGRPC(obj.width, helper);
              }
              if (obj.height != null) {
                grpc.height = $root.google.protobuf.Int32Value.toGRPC(obj.height, helper);
              }
              return grpc;
            }
          }

          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.wix.social.OpenGraph.Image();

              if (grpc.url != null) {
                result.url = grpc.url;
              } else {
                result.url = '';
              }
              if (grpc.width != null) {
                result.width = $root.google.protobuf.Int32Value.fromGRPC(grpc.width, helper);
              } else {
                delete result.width;
              }
              if (grpc.height != null) {
                result.height = $root.google.protobuf.Int32Value.fromGRPC(grpc.height, helper);
              } else {
                delete result.height;
              }
              return result;
            }
          }

          static describe() {
            return {
              'fields': {
                'url': {
                  'type': 'string',
                  'id': 1
                },
                'width': {
                  'type': $root.google.protobuf.Int32Value,
                  'id': 2
                },
                'height': {
                  'type': $root.google.protobuf.Int32Value,
                  'id': 3
                }
              }
            };
          }
        }

        Object.defineProperty(Image.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('wix.social.OpenGraph.Image');
          },
          enumerable: false,
          configurable: false
        });
        return Image;
      }());
      OpenGraph.Website = (function() {

        class Website {

          constructor(props) {}

          static verify(msg, helper, errors = helper.verification.Errors.empty()) {
            if (typeof msg !== 'object' || msg == null) {
              errors.error('object expected');
            } else {
              if (!(typeof msg === 'object' && !Array.isArray(msg) && Object.keys(msg).length === 0)) {
                errors.error('empty object expected');
              }
            }
            return errors;
          }

          static toJSON(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const json = {};

              return json;
            }
          }

          static fromJSON(json, helper) {
            const result = new $root.wix.social.OpenGraph.Website();

            return result;
          }

          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};

              return grpc;
            }
          }

          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.wix.social.OpenGraph.Website();

              return result;
            }
          }

          static describe() {
            return {
              'fields': {}
            };
          }
        }

        Object.defineProperty(Website.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('wix.social.OpenGraph.Website');
          },
          enumerable: false,
          configurable: false
        });
        return Website;
      }());
      OpenGraph.Article = (function() {

        class Article {

          constructor(props) {
            this.publishedTime = props && props.publishedTime;
            this.modifiedTime = props && props.modifiedTime;
            this.expirationTime = props && props.expirationTime;
            this.author = props && props.author;
            this.section = props && props.section;
            this.tag = props && props.tag;
          }

          static verify(msg, helper, errors = helper.verification.Errors.empty()) {
            if (typeof msg !== 'object' || msg == null) {
              errors.error('object expected');
            } else {
              if (msg.publishedTime != null) {
                $root.google.protobuf.Timestamp.verify(msg.publishedTime, helper, errors.field('publishedTime'));
              }
              if (msg.modifiedTime != null) {
                $root.google.protobuf.Timestamp.verify(msg.modifiedTime, helper, errors.field('modifiedTime'));
              }
              if (msg.expirationTime != null) {
                $root.google.protobuf.Timestamp.verify(msg.expirationTime, helper, errors.field('expirationTime'));
              }
              if (msg.author != null) {
                const fieldErrors = errors.field('author');

                if (!Array.isArray(msg.author)) {
                  fieldErrors.error('array expected');
                } else {
                  msg.author.forEach((value, index) => {
                    if (typeof value !== 'string') {
                      fieldErrors.index(index).error('string expected');
                    }
                  });
                }
              }
              if (msg.section != null) {
                if (typeof msg.section !== 'string') {
                  errors.field('section').error('string expected');
                }
              }
              if (msg.tag != null) {
                const fieldErrors = errors.field('tag');

                if (!Array.isArray(msg.tag)) {
                  fieldErrors.error('array expected');
                } else {
                  msg.tag.forEach((value, index) => {
                    if (typeof value !== 'string') {
                      fieldErrors.index(index).error('string expected');
                    }
                  });
                }
              }
            }
            return errors;
          }

          static toJSON(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const json = {};

              if (obj.publishedTime != null) {
                json.publishedTime = $root.google.protobuf.Timestamp.toJSON(obj.publishedTime, helper);
              }
              if (obj.modifiedTime != null) {
                json.modifiedTime = $root.google.protobuf.Timestamp.toJSON(obj.modifiedTime, helper);
              }
              if (obj.expirationTime != null) {
                json.expirationTime = $root.google.protobuf.Timestamp.toJSON(obj.expirationTime, helper);
              }
              if (obj.author != null) {
                json.author = obj.author.map(e => {
                  return e;
                });
              }
              if (obj.section != null) {
                json.section = obj.section;
              }
              if (obj.tag != null) {
                json.tag = obj.tag.map(e => {
                  return e;
                });
              }
              return json;
            }
          }

          static fromJSON(json, helper) {
            const result = new $root.wix.social.OpenGraph.Article();

            if (json.publishedTime != null) {
              result.publishedTime = $root.google.protobuf.Timestamp.fromJSON(json.publishedTime, helper);
            } else {
              delete result.publishedTime;
            }
            if (json.modifiedTime != null) {
              result.modifiedTime = $root.google.protobuf.Timestamp.fromJSON(json.modifiedTime, helper);
            } else {
              delete result.modifiedTime;
            }
            if (json.expirationTime != null) {
              result.expirationTime = $root.google.protobuf.Timestamp.fromJSON(json.expirationTime, helper);
            } else {
              delete result.expirationTime;
            }
            if (json.author != null) {
              result.author = json.author.map(e => {
                return e;
              });
            } else {
              result.author = [];
            }
            if (json.section != null) {
              result.section = json.section;
            } else {
              result.section = '';
            }
            if (json.tag != null) {
              result.tag = json.tag.map(e => {
                return e;
              });
            } else {
              result.tag = [];
            }
            return result;
          }

          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};

              if (obj.publishedTime != null) {
                grpc.publishedTime = $root.google.protobuf.Timestamp.toGRPC(obj.publishedTime, helper);
              }
              if (obj.modifiedTime != null) {
                grpc.modifiedTime = $root.google.protobuf.Timestamp.toGRPC(obj.modifiedTime, helper);
              }
              if (obj.expirationTime != null) {
                grpc.expirationTime = $root.google.protobuf.Timestamp.toGRPC(obj.expirationTime, helper);
              }
              if (obj.author != null) {
                grpc.author = obj.author.map(e => {
                  return e;
                });
              }
              if (obj.section != null) {
                grpc.section = obj.section;
              }
              if (obj.tag != null) {
                grpc.tag = obj.tag.map(e => {
                  return e;
                });
              }
              return grpc;
            }
          }

          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.wix.social.OpenGraph.Article();

              if (grpc.publishedTime != null) {
                result.publishedTime = $root.google.protobuf.Timestamp.fromGRPC(grpc.publishedTime, helper);
              } else {
                delete result.publishedTime;
              }
              if (grpc.modifiedTime != null) {
                result.modifiedTime = $root.google.protobuf.Timestamp.fromGRPC(grpc.modifiedTime, helper);
              } else {
                delete result.modifiedTime;
              }
              if (grpc.expirationTime != null) {
                result.expirationTime = $root.google.protobuf.Timestamp.fromGRPC(grpc.expirationTime, helper);
              } else {
                delete result.expirationTime;
              }
              if (grpc.author != null) {
                result.author = grpc.author.map(e => {
                  return e;
                });
              } else {
                result.author = [];
              }
              if (grpc.section != null) {
                result.section = grpc.section;
              } else {
                result.section = '';
              }
              if (grpc.tag != null) {
                result.tag = grpc.tag.map(e => {
                  return e;
                });
              } else {
                result.tag = [];
              }
              return result;
            }
          }

          static describe() {
            return {
              'fields': {
                'publishedTime': {
                  'type': $root.google.protobuf.Timestamp,
                  'id': 1
                },
                'modifiedTime': {
                  'type': $root.google.protobuf.Timestamp,
                  'id': 2
                },
                'expirationTime': {
                  'type': $root.google.protobuf.Timestamp,
                  'id': 3
                },
                'author': {
                  'rule': 'repeated',
                  'type': 'string',
                  'id': 4
                },
                'section': {
                  'type': 'string',
                  'id': 5
                },
                'tag': {
                  'rule': 'repeated',
                  'type': 'string',
                  'id': 6
                }
              }
            };
          }
        }

        Object.defineProperty(Article.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('wix.social.OpenGraph.Article');
          },
          enumerable: false,
          configurable: false
        });
        return Article;
      }());
      OpenGraph.Image = (function() {

        class Image {

          constructor(props) {
            this.url = props && props.url;
            this.width = props && props.width;
            this.height = props && props.height;
          }

          static verify(msg, helper, errors = helper.verification.Errors.empty()) {
            if (typeof msg !== 'object' || msg == null) {
              errors.error('object expected');
            } else {
              if (msg.url != null) {
                if (typeof msg.url !== 'string') {
                  errors.field('url').error('string expected');
                }
              }
              if (msg.width != null) {
                $root.google.protobuf.Int32Value.verify(msg.width, helper, errors.field('width'));
              }
              if (msg.height != null) {
                $root.google.protobuf.Int32Value.verify(msg.height, helper, errors.field('height'));
              }
            }
            return errors;
          }

          static toJSON(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const json = {};

              if (obj.url != null) {
                json.url = obj.url;
              }
              if (obj.width != null) {
                json.width = $root.google.protobuf.Int32Value.toJSON(obj.width, helper);
              }
              if (obj.height != null) {
                json.height = $root.google.protobuf.Int32Value.toJSON(obj.height, helper);
              }
              return json;
            }
          }

          static fromJSON(json, helper) {
            const result = new $root.wix.social.OpenGraph.Image();

            if (json.url != null) {
              result.url = json.url;
            } else {
              result.url = '';
            }
            if (json.width != null) {
              result.width = $root.google.protobuf.Int32Value.fromJSON(json.width, helper);
            } else {
              delete result.width;
            }
            if (json.height != null) {
              result.height = $root.google.protobuf.Int32Value.fromJSON(json.height, helper);
            } else {
              delete result.height;
            }
            return result;
          }

          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};

              if (obj.url != null) {
                grpc.url = obj.url;
              }
              if (obj.width != null) {
                grpc.width = $root.google.protobuf.Int32Value.toGRPC(obj.width, helper);
              }
              if (obj.height != null) {
                grpc.height = $root.google.protobuf.Int32Value.toGRPC(obj.height, helper);
              }
              return grpc;
            }
          }

          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.wix.social.OpenGraph.Image();

              if (grpc.url != null) {
                result.url = grpc.url;
              } else {
                result.url = '';
              }
              if (grpc.width != null) {
                result.width = $root.google.protobuf.Int32Value.fromGRPC(grpc.width, helper);
              } else {
                delete result.width;
              }
              if (grpc.height != null) {
                result.height = $root.google.protobuf.Int32Value.fromGRPC(grpc.height, helper);
              } else {
                delete result.height;
              }
              return result;
            }
          }

          static describe() {
            return {
              'fields': {
                'url': {
                  'type': 'string',
                  'id': 1
                },
                'width': {
                  'type': $root.google.protobuf.Int32Value,
                  'id': 2
                },
                'height': {
                  'type': $root.google.protobuf.Int32Value,
                  'id': 3
                }
              }
            };
          }
        }

        Object.defineProperty(Image.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('wix.social.OpenGraph.Image');
          },
          enumerable: false,
          configurable: false
        });
        return Image;
      }());
      OpenGraph.Website = (function() {

        class Website {

          constructor(props) {}

          static verify(msg, helper, errors = helper.verification.Errors.empty()) {
            if (typeof msg !== 'object' || msg == null) {
              errors.error('object expected');
            } else {
              if (!(typeof msg === 'object' && !Array.isArray(msg) && Object.keys(msg).length === 0)) {
                errors.error('empty object expected');
              }
            }
            return errors;
          }

          static toJSON(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const json = {};

              return json;
            }
          }

          static fromJSON(json, helper) {
            const result = new $root.wix.social.OpenGraph.Website();

            return result;
          }

          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};

              return grpc;
            }
          }

          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.wix.social.OpenGraph.Website();

              return result;
            }
          }

          static describe() {
            return {
              'fields': {}
            };
          }
        }

        Object.defineProperty(Website.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('wix.social.OpenGraph.Website');
          },
          enumerable: false,
          configurable: false
        });
        return Website;
      }());
      OpenGraph.Article = (function() {

        class Article {

          constructor(props) {
            this.publishedTime = props && props.publishedTime;
            this.modifiedTime = props && props.modifiedTime;
            this.expirationTime = props && props.expirationTime;
            this.author = props && props.author;
            this.section = props && props.section;
            this.tag = props && props.tag;
          }

          static verify(msg, helper, errors = helper.verification.Errors.empty()) {
            if (typeof msg !== 'object' || msg == null) {
              errors.error('object expected');
            } else {
              if (msg.publishedTime != null) {
                $root.google.protobuf.Timestamp.verify(msg.publishedTime, helper, errors.field('publishedTime'));
              }
              if (msg.modifiedTime != null) {
                $root.google.protobuf.Timestamp.verify(msg.modifiedTime, helper, errors.field('modifiedTime'));
              }
              if (msg.expirationTime != null) {
                $root.google.protobuf.Timestamp.verify(msg.expirationTime, helper, errors.field('expirationTime'));
              }
              if (msg.author != null) {
                const fieldErrors = errors.field('author');

                if (!Array.isArray(msg.author)) {
                  fieldErrors.error('array expected');
                } else {
                  msg.author.forEach((value, index) => {
                    if (typeof value !== 'string') {
                      fieldErrors.index(index).error('string expected');
                    }
                  });
                }
              }
              if (msg.section != null) {
                if (typeof msg.section !== 'string') {
                  errors.field('section').error('string expected');
                }
              }
              if (msg.tag != null) {
                const fieldErrors = errors.field('tag');

                if (!Array.isArray(msg.tag)) {
                  fieldErrors.error('array expected');
                } else {
                  msg.tag.forEach((value, index) => {
                    if (typeof value !== 'string') {
                      fieldErrors.index(index).error('string expected');
                    }
                  });
                }
              }
            }
            return errors;
          }

          static toJSON(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const json = {};

              if (obj.publishedTime != null) {
                json.publishedTime = $root.google.protobuf.Timestamp.toJSON(obj.publishedTime, helper);
              }
              if (obj.modifiedTime != null) {
                json.modifiedTime = $root.google.protobuf.Timestamp.toJSON(obj.modifiedTime, helper);
              }
              if (obj.expirationTime != null) {
                json.expirationTime = $root.google.protobuf.Timestamp.toJSON(obj.expirationTime, helper);
              }
              if (obj.author != null) {
                json.author = obj.author.map(e => {
                  return e;
                });
              }
              if (obj.section != null) {
                json.section = obj.section;
              }
              if (obj.tag != null) {
                json.tag = obj.tag.map(e => {
                  return e;
                });
              }
              return json;
            }
          }

          static fromJSON(json, helper) {
            const result = new $root.wix.social.OpenGraph.Article();

            if (json.publishedTime != null) {
              result.publishedTime = $root.google.protobuf.Timestamp.fromJSON(json.publishedTime, helper);
            } else {
              delete result.publishedTime;
            }
            if (json.modifiedTime != null) {
              result.modifiedTime = $root.google.protobuf.Timestamp.fromJSON(json.modifiedTime, helper);
            } else {
              delete result.modifiedTime;
            }
            if (json.expirationTime != null) {
              result.expirationTime = $root.google.protobuf.Timestamp.fromJSON(json.expirationTime, helper);
            } else {
              delete result.expirationTime;
            }
            if (json.author != null) {
              result.author = json.author.map(e => {
                return e;
              });
            } else {
              result.author = [];
            }
            if (json.section != null) {
              result.section = json.section;
            } else {
              result.section = '';
            }
            if (json.tag != null) {
              result.tag = json.tag.map(e => {
                return e;
              });
            } else {
              result.tag = [];
            }
            return result;
          }

          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};

              if (obj.publishedTime != null) {
                grpc.publishedTime = $root.google.protobuf.Timestamp.toGRPC(obj.publishedTime, helper);
              }
              if (obj.modifiedTime != null) {
                grpc.modifiedTime = $root.google.protobuf.Timestamp.toGRPC(obj.modifiedTime, helper);
              }
              if (obj.expirationTime != null) {
                grpc.expirationTime = $root.google.protobuf.Timestamp.toGRPC(obj.expirationTime, helper);
              }
              if (obj.author != null) {
                grpc.author = obj.author.map(e => {
                  return e;
                });
              }
              if (obj.section != null) {
                grpc.section = obj.section;
              }
              if (obj.tag != null) {
                grpc.tag = obj.tag.map(e => {
                  return e;
                });
              }
              return grpc;
            }
          }

          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.wix.social.OpenGraph.Article();

              if (grpc.publishedTime != null) {
                result.publishedTime = $root.google.protobuf.Timestamp.fromGRPC(grpc.publishedTime, helper);
              } else {
                delete result.publishedTime;
              }
              if (grpc.modifiedTime != null) {
                result.modifiedTime = $root.google.protobuf.Timestamp.fromGRPC(grpc.modifiedTime, helper);
              } else {
                delete result.modifiedTime;
              }
              if (grpc.expirationTime != null) {
                result.expirationTime = $root.google.protobuf.Timestamp.fromGRPC(grpc.expirationTime, helper);
              } else {
                delete result.expirationTime;
              }
              if (grpc.author != null) {
                result.author = grpc.author.map(e => {
                  return e;
                });
              } else {
                result.author = [];
              }
              if (grpc.section != null) {
                result.section = grpc.section;
              } else {
                result.section = '';
              }
              if (grpc.tag != null) {
                result.tag = grpc.tag.map(e => {
                  return e;
                });
              } else {
                result.tag = [];
              }
              return result;
            }
          }

          static describe() {
            return {
              'fields': {
                'publishedTime': {
                  'type': $root.google.protobuf.Timestamp,
                  'id': 1
                },
                'modifiedTime': {
                  'type': $root.google.protobuf.Timestamp,
                  'id': 2
                },
                'expirationTime': {
                  'type': $root.google.protobuf.Timestamp,
                  'id': 3
                },
                'author': {
                  'rule': 'repeated',
                  'type': 'string',
                  'id': 4
                },
                'section': {
                  'type': 'string',
                  'id': 5
                },
                'tag': {
                  'rule': 'repeated',
                  'type': 'string',
                  'id': 6
                }
              }
            };
          }
        }

        Object.defineProperty(Article.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('wix.social.OpenGraph.Article');
          },
          enumerable: false,
          configurable: false
        });
        return Article;
      }());
      Object.defineProperty(OpenGraph.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.social.OpenGraph');
        },
        enumerable: false,
        configurable: false
      });
      return OpenGraph;
    }());
    social.IdentityType = {
      verify: (value, helper, errors = helper.verification.Errors.empty()) => {
        switch (value) {
          default: {
            errors.error('enum expected');
          }
          case 'ANONYMOUS':
          case 'MEMBER':
          case 'USER':
            break;
        }
        return errors;
      },
      'ANONYMOUS': 'ANONYMOUS',
      'MEMBER': 'MEMBER',
      'USER': 'USER'
    };
    social.SocialIdentity = (function() {

      class SocialIdentity {

        constructor(props) {
          this.identityId = props && props.identityId;
          this.identityType = props && props.identityType;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.identityId != null) {
              if (typeof msg.identityId !== 'string') {
                errors.field('identityId').error('string expected');
              }
            }
            if (msg.identityType != null) {
              $root.wix.social.IdentityType.verify(msg.identityType, helper, errors.field('identityType'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.identityId != null) {
              json.identityId = obj.identityId;
            }
            if (obj.identityType != null) {
              json.identityType = $root.wix.social.IdentityType[obj.identityType];
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.social.SocialIdentity();

          if (json.identityId != null) {
            result.identityId = json.identityId;
          } else {
            result.identityId = '';
          }
          if (json.identityType != null) {
            result.identityType = $root.wix.social.IdentityType[json.identityType];
          } else {
            result.identityType = 'ANONYMOUS';
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.identityId != null) {
              grpc.identityId = obj.identityId;
            }
            if (obj.identityType != null) {
              grpc.identityType = obj.identityType;
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.social.SocialIdentity();

            if (grpc.identityId != null) {
              result.identityId = grpc.identityId;
            } else {
              result.identityId = '';
            }
            if (grpc.identityType != null) {
              result.identityType = grpc.identityType;
            } else {
              result.identityType = 'ANONYMOUS';
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'identityId': {
                'type': 'string',
                'id': 1,
                'options': {
                  '(wix.api.format)': 'GUID'
                }
              },
              'identityType': {
                'type': $root.wix.social.IdentityType,
                'id': 2
              }
            }
          };
        }
      }

      Object.defineProperty(SocialIdentity.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.social.SocialIdentity');
        },
        enumerable: false,
        configurable: false
      });
      return SocialIdentity;
    }());
    social.Profile = (function() {

      class Profile {

        constructor(props) {
          this.id = props && props.id;
          this.nickname = props && props.nickname;
          this.slug = props && props.slug;
          this.imageUrl = props && props.imageUrl;
          this.contactId = props && props.contactId;
          this.isAnonymous = props && props.isAnonymous;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.id != null) {
              if (typeof msg.id !== 'string') {
                errors.field('id').error('string expected');
              }
            }
            if (msg.nickname != null) {
              $root.google.protobuf.StringValue.verify(msg.nickname, helper, errors.field('nickname'));
            }
            if (msg.slug != null) {
              $root.google.protobuf.StringValue.verify(msg.slug, helper, errors.field('slug'));
            }
            if (msg.imageUrl != null) {
              $root.google.protobuf.StringValue.verify(msg.imageUrl, helper, errors.field('imageUrl'));
            }
            if (msg.contactId != null) {
              if (typeof msg.contactId !== 'string') {
                errors.field('contactId').error('string expected');
              }
            }
            if (msg.isAnonymous != null) {
              if (typeof msg.isAnonymous !== 'boolean') {
                errors.field('isAnonymous').error('boolean expected');
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.id != null) {
              json.id = obj.id;
            }
            if (obj.nickname != null) {
              json.nickname = $root.google.protobuf.StringValue.toJSON(obj.nickname, helper);
            }
            if (obj.slug != null) {
              json.slug = $root.google.protobuf.StringValue.toJSON(obj.slug, helper);
            }
            if (obj.imageUrl != null) {
              json.imageUrl = $root.google.protobuf.StringValue.toJSON(obj.imageUrl, helper);
            }
            if (obj.contactId != null) {
              json.contactId = obj.contactId;
            }
            if (obj.isAnonymous != null) {
              json.isAnonymous = obj.isAnonymous;
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.social.Profile();

          if (json.id != null) {
            result.id = json.id;
          } else {
            result.id = '';
          }
          if (json.nickname != null) {
            result.nickname = $root.google.protobuf.StringValue.fromJSON(json.nickname, helper);
          } else {
            delete result.nickname;
          }
          if (json.slug != null) {
            result.slug = $root.google.protobuf.StringValue.fromJSON(json.slug, helper);
          } else {
            delete result.slug;
          }
          if (json.imageUrl != null) {
            result.imageUrl = $root.google.protobuf.StringValue.fromJSON(json.imageUrl, helper);
          } else {
            delete result.imageUrl;
          }
          if (json.contactId != null) {
            result.contactId = json.contactId;
          } else {
            result.contactId = '';
          }
          if (json.isAnonymous != null) {
            result.isAnonymous = json.isAnonymous;
          } else {
            result.isAnonymous = false;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.id != null) {
              grpc.id = obj.id;
            }
            if (obj.nickname != null) {
              grpc.nickname = $root.google.protobuf.StringValue.toGRPC(obj.nickname, helper);
            }
            if (obj.slug != null) {
              grpc.slug = $root.google.protobuf.StringValue.toGRPC(obj.slug, helper);
            }
            if (obj.imageUrl != null) {
              grpc.imageUrl = $root.google.protobuf.StringValue.toGRPC(obj.imageUrl, helper);
            }
            if (obj.contactId != null) {
              grpc.contactId = obj.contactId;
            }
            if (obj.isAnonymous != null) {
              grpc.isAnonymous = obj.isAnonymous;
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.social.Profile();

            if (grpc.id != null) {
              result.id = grpc.id;
            } else {
              result.id = '';
            }
            if (grpc.nickname != null) {
              result.nickname = $root.google.protobuf.StringValue.fromGRPC(grpc.nickname, helper);
            } else {
              delete result.nickname;
            }
            if (grpc.slug != null) {
              result.slug = $root.google.protobuf.StringValue.fromGRPC(grpc.slug, helper);
            } else {
              delete result.slug;
            }
            if (grpc.imageUrl != null) {
              result.imageUrl = $root.google.protobuf.StringValue.fromGRPC(grpc.imageUrl, helper);
            } else {
              delete result.imageUrl;
            }
            if (grpc.contactId != null) {
              result.contactId = grpc.contactId;
            } else {
              result.contactId = '';
            }
            if (grpc.isAnonymous != null) {
              result.isAnonymous = grpc.isAnonymous;
            } else {
              result.isAnonymous = false;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'id': {
                'type': 'string',
                'id': 1
              },
              'nickname': {
                'type': $root.google.protobuf.StringValue,
                'id': 2
              },
              'slug': {
                'type': $root.google.protobuf.StringValue,
                'id': 3
              },
              'imageUrl': {
                'type': $root.google.protobuf.StringValue,
                'id': 4
              },
              'contactId': {
                'type': 'string',
                'id': 5
              },
              'isAnonymous': {
                'type': 'bool',
                'id': 6
              }
            }
          };
        }
      }

      Object.defineProperty(Profile.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.social.Profile');
        },
        enumerable: false,
        configurable: false
      });
      return Profile;
    }());
    social.Profiles = (function() {

      class Profiles {

        constructor(props) {
          this.profiles = props && props.profiles;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.profiles != null) {
              const fieldErrors = errors.field('profiles');

              if (msg.profiles != null && (!(typeof msg.profiles === 'object') || Array.isArray(msg.profiles))) {
                fieldErrors.error('object expected');
              } else {
                for (let key in msg.profiles) {
                  const keyErrors = fieldErrors.index(key);
                  $root.wix.social.Profile.verify(msg.profiles[key], helper, keyErrors.field('value'));
                }
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.profiles != null) {
              json.profiles = Object.entries(obj.profiles).reduce((acc, [k, v]) => {
                acc[k] = $root.wix.social.Profile.toJSON(v, helper);
                return acc;
              }, {});
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.social.Profiles();

          if (json.profiles != null) {
            result.profiles = Object.entries(json.profiles).reduce((acc, [k, v]) => {
              acc[k] = $root.wix.social.Profile.fromJSON(v, helper);
              return acc;
            }, {});
          } else {
            delete result.profiles;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.profiles != null) {
              grpc.profiles = Object.entries(obj.profiles).reduce((acc, [k, v]) => {
                acc[k] = $root.wix.social.Profile.toGRPC(v, helper);
                return acc;
              }, {});
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.social.Profiles();

            if (grpc.profiles != null) {
              result.profiles = Object.entries(grpc.profiles).reduce((acc, [k, v]) => {
                acc[k] = $root.wix.social.Profile.fromGRPC(v, helper);
                return acc;
              }, {});
            } else {
              delete result.profiles;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'profiles': {
                'keyType': 'string',
                'type': $root.wix.social.Profile,
                'id': 1
              }
            }
          };
        }
      }

      Object.defineProperty(Profiles.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.social.Profiles');
        },
        enumerable: false,
        configurable: false
      });
      return Profiles;
    }());
    social.SocialContainer = (function() {

      class SocialContainer {

        constructor(props) {
          this.containerId = props && props.containerId;
          this.containerType = props && props.containerType;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.containerId != null) {
              if (typeof msg.containerId !== 'string') {
                errors.field('containerId').error('string expected');
              }
            }
            if (msg.containerType != null) {
              if (typeof msg.containerType !== 'string') {
                errors.field('containerType').error('string expected');
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.containerId != null) {
              json.containerId = obj.containerId;
            }
            if (obj.containerType != null) {
              json.containerType = obj.containerType;
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.social.SocialContainer();

          if (json.containerId != null) {
            result.containerId = json.containerId;
          } else {
            result.containerId = '';
          }
          if (json.containerType != null) {
            result.containerType = json.containerType;
          } else {
            result.containerType = '';
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.containerId != null) {
              grpc.containerId = obj.containerId;
            }
            if (obj.containerType != null) {
              grpc.containerType = obj.containerType;
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.social.SocialContainer();

            if (grpc.containerId != null) {
              result.containerId = grpc.containerId;
            } else {
              result.containerId = '';
            }
            if (grpc.containerType != null) {
              result.containerType = grpc.containerType;
            } else {
              result.containerType = '';
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'containerId': {
                'type': 'string',
                'id': 1
              },
              'containerType': {
                'type': 'string',
                'id': 2
              }
            }
          };
        }
      }

      Object.defineProperty(SocialContainer.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.social.SocialContainer');
        },
        enumerable: false,
        configurable: false
      });
      return SocialContainer;
    }());
    social.SocialEntity = (function() {

      class SocialEntity {

        constructor(props) {
          this.ownedBy = props && props.ownedBy;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.ownedBy != null) {
              $root.wix.social.SocialIdentity.verify(msg.ownedBy, helper, errors.field('ownedBy'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.ownedBy != null) {
              json.ownedBy = $root.wix.social.SocialIdentity.toJSON(obj.ownedBy, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.social.SocialEntity();

          if (json.ownedBy != null) {
            result.ownedBy = $root.wix.social.SocialIdentity.fromJSON(json.ownedBy, helper);
          } else {
            delete result.ownedBy;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.ownedBy != null) {
              grpc.ownedBy = $root.wix.social.SocialIdentity.toGRPC(obj.ownedBy, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.social.SocialEntity();

            if (grpc.ownedBy != null) {
              result.ownedBy = $root.wix.social.SocialIdentity.fromGRPC(grpc.ownedBy, helper);
            } else {
              delete result.ownedBy;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'ownedBy': {
                'type': $root.wix.social.SocialIdentity,
                'id': 1
              }
            }
          };
        }
      }

      Object.defineProperty(SocialEntity.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.social.SocialEntity');
        },
        enumerable: false,
        configurable: false
      });
      return SocialEntity;
    }());
    social.ActivitiesService = (function() {

      class ActivitiesService {

        constructor() {
          if (this.constructor.name === ActivitiesService.name) {
            throw new TypeError('class ActivitiesService is abstract');
          }
        }

        queryActivityStats(aspects, msg) {
          throw new TypeError('method queryActivityStats is abstract');
        }

        queryLatestActivity(aspects, msg) {
          throw new TypeError('method queryLatestActivity is abstract');
        }

        queryIdentityActivityStats(aspects, msg) {
          throw new TypeError('method queryIdentityActivityStats is abstract');
        }
      }

      ActivitiesService.prototype.queryActivityStats._messageTypes = function() {
        return [
          $root.wix.social.QueryActivityStatsRequest,
          $root.wix.social.QueryActivityStatsResponse
        ];
      };
      ActivitiesService.prototype.queryLatestActivity._messageTypes = function() {
        return [
          $root.wix.social.QueryLatestActivityRequest,
          $root.wix.social.QueryLatestActivityResponse
        ];
      };
      ActivitiesService.prototype.queryIdentityActivityStats._messageTypes = function() {
        return [
          $root.wix.social.QueryIdentityActivityStatsRequest,
          $root.wix.social.QueryIdentityActivityStatsResponse
        ];
      };
      ActivitiesService.prototype.queryActivityStats.__proto = pbjs => {
        return $root.__lookup(pbjs)('wix.social.ActivitiesService.QueryActivityStats');
      };
      ActivitiesService.prototype.queryLatestActivity.__proto = pbjs => {
        return $root.__lookup(pbjs)('wix.social.ActivitiesService.QueryLatestActivity');
      };
      ActivitiesService.prototype.queryIdentityActivityStats.__proto = pbjs => {
        return $root.__lookup(pbjs)('wix.social.ActivitiesService.QueryIdentityActivityStats');
      };
      Object.defineProperty(ActivitiesService.prototype, '__isRpcService__', {
        value: true,
        enumerable: false,
        configurable: false
      });
      Object.defineProperty(ActivitiesService.prototype, '__fqn__', {
        value: 'wix.social.ActivitiesService',
        enumerable: false,
        configurable: false
      });
      Object.defineProperty(ActivitiesService.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.social.ActivitiesService');
        },
        enumerable: false,
        configurable: false
      });
      Object.defineProperty(ActivitiesService.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      return ActivitiesService;
    }());
    social.QueryActivityStatsRequest = (function() {

      class QueryActivityStatsRequest {

        constructor(props) {
          this.contextTokens = props && props.contextTokens;
          this.activityTypes = props && props.activityTypes;
          this.time = props && props.time;
          this.version = props && props.version;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            const oneOfMutex = {};

            if (msg.contextTokens != null) {
              const fieldErrors = errors.field('contextTokens');

              if (!Array.isArray(msg.contextTokens)) {
                fieldErrors.error('array expected');
              } else {
                msg.contextTokens.forEach((value, index) => {
                  if (typeof value !== 'string') {
                    fieldErrors.index(index).error('string expected');
                  }
                });
              }
            }
            if (msg.activityTypes != null) {
              const fieldErrors = errors.field('activityTypes');

              if (!Array.isArray(msg.activityTypes)) {
                fieldErrors.error('array expected');
              } else {
                msg.activityTypes.forEach((value, index) => {
                  if (typeof value !== 'string') {
                    fieldErrors.index(index).error('string expected');
                  }
                });
              }
            }
            if (msg.time != null) {
              if (oneOfMutex['range']) {
                errors.field('time').up().field('range').error('multiple values');
              } else {
                oneOfMutex['range'] = true;
                $root.wix.social.TimeRange.verify(msg.time, helper, errors.field('time'));
              }
            }
            if (msg.version != null) {
              if (oneOfMutex['range']) {
                errors.field('version').up().field('range').error('multiple values');
              } else {
                oneOfMutex['range'] = true;
                $root.wix.social.VersionQuery.verify(msg.version, helper, errors.field('version'));
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.contextTokens != null) {
              json.contextTokens = obj.contextTokens.map(e => {
                return e;
              });
            }
            if (obj.activityTypes != null) {
              json.activityTypes = obj.activityTypes.map(e => {
                return e;
              });
            }
            if (obj.time != null) {
              json.time = $root.wix.social.TimeRange.toJSON(obj.time, helper);
            }
            if (obj.version != null) {
              json.version = $root.wix.social.VersionQuery.toJSON(obj.version, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.social.QueryActivityStatsRequest();

          if (json.contextTokens != null) {
            result.contextTokens = json.contextTokens.map(e => {
              return e;
            });
          } else {
            result.contextTokens = [];
          }
          if (json.activityTypes != null) {
            result.activityTypes = json.activityTypes.map(e => {
              return e;
            });
          } else {
            result.activityTypes = [];
          }
          if (json.time != null) {
            result.time = $root.wix.social.TimeRange.fromJSON(json.time, helper);
          } else {
            delete result.time;
          }
          if (json.version != null) {
            result.version = $root.wix.social.VersionQuery.fromJSON(json.version, helper);
          } else {
            delete result.version;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.contextTokens != null) {
              grpc.contextTokens = obj.contextTokens.map(e => {
                return e;
              });
            }
            if (obj.activityTypes != null) {
              grpc.activityTypes = obj.activityTypes.map(e => {
                return e;
              });
            }
            if (obj.time != null) {
              grpc.time = $root.wix.social.TimeRange.toGRPC(obj.time, helper);
            }
            if (obj.version != null) {
              grpc.version = $root.wix.social.VersionQuery.toGRPC(obj.version, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.social.QueryActivityStatsRequest();

            if (grpc.contextTokens != null) {
              result.contextTokens = grpc.contextTokens.map(e => {
                return e;
              });
            } else {
              result.contextTokens = [];
            }
            if (grpc.activityTypes != null) {
              result.activityTypes = grpc.activityTypes.map(e => {
                return e;
              });
            } else {
              result.activityTypes = [];
            }
            if (grpc.time != null) {
              result.time = $root.wix.social.TimeRange.fromGRPC(grpc.time, helper);
            } else {
              delete result.time;
            }
            if (grpc.version != null) {
              result.version = $root.wix.social.VersionQuery.fromGRPC(grpc.version, helper);
            } else {
              delete result.version;
            }
            return result;
          }
        }

        static describe() {
          return {
            'oneofs': {
              'range': {
                'oneof': [
                  'time',
                  'version'
                ]
              }
            },
            'fields': {
              'contextTokens': {
                'rule': 'repeated',
                'type': 'string',
                'id': 1,
                'options': {
                  '(wix.api.minSize)': 1,
                  '(wix.api.maxSize)': 100
                }
              },
              'activityTypes': {
                'rule': 'repeated',
                'type': 'string',
                'id': 2,
                'options': {
                  '(wix.api.minSize)': 1,
                  '(wix.api.maxSize)': 100
                }
              },
              'time': {
                'type': $root.wix.social.TimeRange,
                'id': 3
              },
              'version': {
                'type': $root.wix.social.VersionQuery,
                'id': 4
              }
            }
          };
        }
      }

      Object.defineProperty(QueryActivityStatsRequest.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.social.QueryActivityStatsRequest');
        },
        enumerable: false,
        configurable: false
      });
      return QueryActivityStatsRequest;
    }());
    social.QueryLatestActivityRequest = (function() {

      class QueryLatestActivityRequest {

        constructor(props) {
          this.contextTokens = props && props.contextTokens;
          this.activityTypes = props && props.activityTypes;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.contextTokens != null) {
              const fieldErrors = errors.field('contextTokens');

              if (!Array.isArray(msg.contextTokens)) {
                fieldErrors.error('array expected');
              } else {
                msg.contextTokens.forEach((value, index) => {
                  if (typeof value !== 'string') {
                    fieldErrors.index(index).error('string expected');
                  }
                });
              }
            }
            if (msg.activityTypes != null) {
              const fieldErrors = errors.field('activityTypes');

              if (!Array.isArray(msg.activityTypes)) {
                fieldErrors.error('array expected');
              } else {
                msg.activityTypes.forEach((value, index) => {
                  if (typeof value !== 'string') {
                    fieldErrors.index(index).error('string expected');
                  }
                });
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.contextTokens != null) {
              json.contextTokens = obj.contextTokens.map(e => {
                return e;
              });
            }
            if (obj.activityTypes != null) {
              json.activityTypes = obj.activityTypes.map(e => {
                return e;
              });
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.social.QueryLatestActivityRequest();

          if (json.contextTokens != null) {
            result.contextTokens = json.contextTokens.map(e => {
              return e;
            });
          } else {
            result.contextTokens = [];
          }
          if (json.activityTypes != null) {
            result.activityTypes = json.activityTypes.map(e => {
              return e;
            });
          } else {
            result.activityTypes = [];
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.contextTokens != null) {
              grpc.contextTokens = obj.contextTokens.map(e => {
                return e;
              });
            }
            if (obj.activityTypes != null) {
              grpc.activityTypes = obj.activityTypes.map(e => {
                return e;
              });
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.social.QueryLatestActivityRequest();

            if (grpc.contextTokens != null) {
              result.contextTokens = grpc.contextTokens.map(e => {
                return e;
              });
            } else {
              result.contextTokens = [];
            }
            if (grpc.activityTypes != null) {
              result.activityTypes = grpc.activityTypes.map(e => {
                return e;
              });
            } else {
              result.activityTypes = [];
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'contextTokens': {
                'rule': 'repeated',
                'type': 'string',
                'id': 1,
                'options': {
                  '(wix.api.minSize)': 1,
                  '(wix.api.maxSize)': 100
                }
              },
              'activityTypes': {
                'rule': 'repeated',
                'type': 'string',
                'id': 2,
                'options': {
                  '(wix.api.minSize)': 1,
                  '(wix.api.maxSize)': 100
                }
              }
            }
          };
        }
      }

      Object.defineProperty(QueryLatestActivityRequest.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.social.QueryLatestActivityRequest');
        },
        enumerable: false,
        configurable: false
      });
      return QueryLatestActivityRequest;
    }());
    social.QueryIdentityActivityStatsRequest = (function() {

      class QueryIdentityActivityStatsRequest {

        constructor(props) {
          this.contextTokens = props && props.contextTokens;
          this.activityTypes = props && props.activityTypes;
          this.identities = props && props.identities;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.contextTokens != null) {
              const fieldErrors = errors.field('contextTokens');

              if (!Array.isArray(msg.contextTokens)) {
                fieldErrors.error('array expected');
              } else {
                msg.contextTokens.forEach((value, index) => {
                  if (typeof value !== 'string') {
                    fieldErrors.index(index).error('string expected');
                  }
                });
              }
            }
            if (msg.activityTypes != null) {
              const fieldErrors = errors.field('activityTypes');

              if (!Array.isArray(msg.activityTypes)) {
                fieldErrors.error('array expected');
              } else {
                msg.activityTypes.forEach((value, index) => {
                  if (typeof value !== 'string') {
                    fieldErrors.index(index).error('string expected');
                  }
                });
              }
            }
            if (msg.identities != null) {
              const fieldErrors = errors.field('identities');

              if (!Array.isArray(msg.identities)) {
                fieldErrors.error('array expected');
              } else {
                msg.identities.forEach((value, index) => {
                  $root.wix.social.SocialIdentity.verify(value, helper, fieldErrors.index(index));
                });
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.contextTokens != null) {
              json.contextTokens = obj.contextTokens.map(e => {
                return e;
              });
            }
            if (obj.activityTypes != null) {
              json.activityTypes = obj.activityTypes.map(e => {
                return e;
              });
            }
            if (obj.identities != null) {
              json.identities = obj.identities.map(e => {
                return $root.wix.social.SocialIdentity.toJSON(e, helper);
              });
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.social.QueryIdentityActivityStatsRequest();

          if (json.contextTokens != null) {
            result.contextTokens = json.contextTokens.map(e => {
              return e;
            });
          } else {
            result.contextTokens = [];
          }
          if (json.activityTypes != null) {
            result.activityTypes = json.activityTypes.map(e => {
              return e;
            });
          } else {
            result.activityTypes = [];
          }
          if (json.identities != null) {
            result.identities = json.identities.map(e => {
              return $root.wix.social.SocialIdentity.fromJSON(e, helper);
            });
          } else {
            result.identities = [];
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.contextTokens != null) {
              grpc.contextTokens = obj.contextTokens.map(e => {
                return e;
              });
            }
            if (obj.activityTypes != null) {
              grpc.activityTypes = obj.activityTypes.map(e => {
                return e;
              });
            }
            if (obj.identities != null) {
              grpc.identities = obj.identities.map(e => {
                return $root.wix.social.SocialIdentity.toGRPC(e, helper);
              });
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.social.QueryIdentityActivityStatsRequest();

            if (grpc.contextTokens != null) {
              result.contextTokens = grpc.contextTokens.map(e => {
                return e;
              });
            } else {
              result.contextTokens = [];
            }
            if (grpc.activityTypes != null) {
              result.activityTypes = grpc.activityTypes.map(e => {
                return e;
              });
            } else {
              result.activityTypes = [];
            }
            if (grpc.identities != null) {
              result.identities = grpc.identities.map(e => {
                return $root.wix.social.SocialIdentity.fromGRPC(e, helper);
              });
            } else {
              result.identities = [];
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'contextTokens': {
                'rule': 'repeated',
                'type': 'string',
                'id': 1,
                'options': {
                  '(wix.api.minSize)': 1,
                  '(wix.api.maxSize)': 100
                }
              },
              'activityTypes': {
                'rule': 'repeated',
                'type': 'string',
                'id': 2,
                'options': {
                  '(wix.api.minSize)': 1,
                  '(wix.api.maxSize)': 100
                }
              },
              'identities': {
                'rule': 'repeated',
                'type': $root.wix.social.SocialIdentity,
                'id': 3,
                'options': {
                  '(wix.api.minSize)': 1,
                  '(wix.api.maxSize)': 100
                }
              }
            }
          };
        }
      }

      Object.defineProperty(QueryIdentityActivityStatsRequest.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.social.QueryIdentityActivityStatsRequest');
        },
        enumerable: false,
        configurable: false
      });
      return QueryIdentityActivityStatsRequest;
    }());
    social.QueryActivityStatsResponse = (function() {

      class QueryActivityStatsResponse {

        constructor(props) {
          this.activityStats = props && props.activityStats;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.activityStats != null) {
              const fieldErrors = errors.field('activityStats');

              if (!Array.isArray(msg.activityStats)) {
                fieldErrors.error('array expected');
              } else {
                msg.activityStats.forEach((value, index) => {
                  $root.wix.social.ContainerActivityStats.verify(value, helper, fieldErrors.index(index));
                });
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.activityStats != null) {
              json.activityStats = obj.activityStats.map(e => {
                return $root.wix.social.ContainerActivityStats.toJSON(e, helper);
              });
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.social.QueryActivityStatsResponse();

          if (json.activityStats != null) {
            result.activityStats = json.activityStats.map(e => {
              return $root.wix.social.ContainerActivityStats.fromJSON(e, helper);
            });
          } else {
            result.activityStats = [];
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.activityStats != null) {
              grpc.activityStats = obj.activityStats.map(e => {
                return $root.wix.social.ContainerActivityStats.toGRPC(e, helper);
              });
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.social.QueryActivityStatsResponse();

            if (grpc.activityStats != null) {
              result.activityStats = grpc.activityStats.map(e => {
                return $root.wix.social.ContainerActivityStats.fromGRPC(e, helper);
              });
            } else {
              result.activityStats = [];
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'activityStats': {
                'rule': 'repeated',
                'type': $root.wix.social.ContainerActivityStats,
                'id': 1
              }
            }
          };
        }
      }

      Object.defineProperty(QueryActivityStatsResponse.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.social.QueryActivityStatsResponse');
        },
        enumerable: false,
        configurable: false
      });
      return QueryActivityStatsResponse;
    }());
    social.QueryLatestActivityResponse = (function() {

      class QueryLatestActivityResponse {

        constructor(props) {
          this.latestActivities = props && props.latestActivities;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.latestActivities != null) {
              const fieldErrors = errors.field('latestActivities');

              if (!Array.isArray(msg.latestActivities)) {
                fieldErrors.error('array expected');
              } else {
                msg.latestActivities.forEach((value, index) => {
                  $root.wix.social.ContainerLatestActivity.verify(value, helper, fieldErrors.index(index));
                });
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.latestActivities != null) {
              json.latestActivities = obj.latestActivities.map(e => {
                return $root.wix.social.ContainerLatestActivity.toJSON(e, helper);
              });
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.social.QueryLatestActivityResponse();

          if (json.latestActivities != null) {
            result.latestActivities = json.latestActivities.map(e => {
              return $root.wix.social.ContainerLatestActivity.fromJSON(e, helper);
            });
          } else {
            result.latestActivities = [];
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.latestActivities != null) {
              grpc.latestActivities = obj.latestActivities.map(e => {
                return $root.wix.social.ContainerLatestActivity.toGRPC(e, helper);
              });
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.social.QueryLatestActivityResponse();

            if (grpc.latestActivities != null) {
              result.latestActivities = grpc.latestActivities.map(e => {
                return $root.wix.social.ContainerLatestActivity.fromGRPC(e, helper);
              });
            } else {
              result.latestActivities = [];
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'latestActivities': {
                'rule': 'repeated',
                'type': $root.wix.social.ContainerLatestActivity,
                'id': 1
              }
            }
          };
        }
      }

      Object.defineProperty(QueryLatestActivityResponse.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.social.QueryLatestActivityResponse');
        },
        enumerable: false,
        configurable: false
      });
      return QueryLatestActivityResponse;
    }());
    social.QueryIdentityActivityStatsResponse = (function() {

      class QueryIdentityActivityStatsResponse {

        constructor(props) {
          this.activityStats = props && props.activityStats;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.activityStats != null) {
              const fieldErrors = errors.field('activityStats');

              if (!Array.isArray(msg.activityStats)) {
                fieldErrors.error('array expected');
              } else {
                msg.activityStats.forEach((value, index) => {
                  $root.wix.social.ContainerIdentityActivityStats.verify(value, helper, fieldErrors.index(index));
                });
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.activityStats != null) {
              json.activityStats = obj.activityStats.map(e => {
                return $root.wix.social.ContainerIdentityActivityStats.toJSON(e, helper);
              });
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.social.QueryIdentityActivityStatsResponse();

          if (json.activityStats != null) {
            result.activityStats = json.activityStats.map(e => {
              return $root.wix.social.ContainerIdentityActivityStats.fromJSON(e, helper);
            });
          } else {
            result.activityStats = [];
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.activityStats != null) {
              grpc.activityStats = obj.activityStats.map(e => {
                return $root.wix.social.ContainerIdentityActivityStats.toGRPC(e, helper);
              });
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.social.QueryIdentityActivityStatsResponse();

            if (grpc.activityStats != null) {
              result.activityStats = grpc.activityStats.map(e => {
                return $root.wix.social.ContainerIdentityActivityStats.fromGRPC(e, helper);
              });
            } else {
              result.activityStats = [];
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'activityStats': {
                'rule': 'repeated',
                'type': $root.wix.social.ContainerIdentityActivityStats,
                'id': 1
              }
            }
          };
        }
      }

      Object.defineProperty(QueryIdentityActivityStatsResponse.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.social.QueryIdentityActivityStatsResponse');
        },
        enumerable: false,
        configurable: false
      });
      return QueryIdentityActivityStatsResponse;
    }());
    social.ContainerActivityStats = (function() {

      class ContainerActivityStats {

        constructor(props) {
          this.containerId = props && props.containerId;
          this.containerType = props && props.containerType;
          this.versionRange = props && props.versionRange;
          this.stats = props && props.stats;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.containerId != null) {
              if (typeof msg.containerId !== 'string') {
                errors.field('containerId').error('string expected');
              }
            }
            if (msg.containerType != null) {
              if (typeof msg.containerType !== 'string') {
                errors.field('containerType').error('string expected');
              }
            }
            if (msg.versionRange != null) {
              $root.wix.social.VersionRange.verify(msg.versionRange, helper, errors.field('versionRange'));
            }
            if (msg.stats != null) {
              const fieldErrors = errors.field('stats');

              if (msg.stats != null && (!(typeof msg.stats === 'object') || Array.isArray(msg.stats))) {
                fieldErrors.error('object expected');
              } else {
                for (let key in msg.stats) {
                  const keyErrors = fieldErrors.index(key);
                  $root.wix.social.RequesterContextActivityStats.verify(msg.stats[key], helper, keyErrors.field('value'));
                }
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.containerId != null) {
              json.containerId = obj.containerId;
            }
            if (obj.containerType != null) {
              json.containerType = obj.containerType;
            }
            if (obj.versionRange != null) {
              json.versionRange = $root.wix.social.VersionRange.toJSON(obj.versionRange, helper);
            }
            if (obj.stats != null) {
              json.stats = Object.entries(obj.stats).reduce((acc, [k, v]) => {
                acc[k] = $root.wix.social.RequesterContextActivityStats.toJSON(v, helper);
                return acc;
              }, {});
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.social.ContainerActivityStats();

          if (json.containerId != null) {
            result.containerId = json.containerId;
          } else {
            result.containerId = '';
          }
          if (json.containerType != null) {
            result.containerType = json.containerType;
          } else {
            result.containerType = '';
          }
          if (json.versionRange != null) {
            result.versionRange = $root.wix.social.VersionRange.fromJSON(json.versionRange, helper);
          } else {
            delete result.versionRange;
          }
          if (json.stats != null) {
            result.stats = Object.entries(json.stats).reduce((acc, [k, v]) => {
              acc[k] = $root.wix.social.RequesterContextActivityStats.fromJSON(v, helper);
              return acc;
            }, {});
          } else {
            delete result.stats;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.containerId != null) {
              grpc.containerId = obj.containerId;
            }
            if (obj.containerType != null) {
              grpc.containerType = obj.containerType;
            }
            if (obj.versionRange != null) {
              grpc.versionRange = $root.wix.social.VersionRange.toGRPC(obj.versionRange, helper);
            }
            if (obj.stats != null) {
              grpc.stats = Object.entries(obj.stats).reduce((acc, [k, v]) => {
                acc[k] = $root.wix.social.RequesterContextActivityStats.toGRPC(v, helper);
                return acc;
              }, {});
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.social.ContainerActivityStats();

            if (grpc.containerId != null) {
              result.containerId = grpc.containerId;
            } else {
              result.containerId = '';
            }
            if (grpc.containerType != null) {
              result.containerType = grpc.containerType;
            } else {
              result.containerType = '';
            }
            if (grpc.versionRange != null) {
              result.versionRange = $root.wix.social.VersionRange.fromGRPC(grpc.versionRange, helper);
            } else {
              delete result.versionRange;
            }
            if (grpc.stats != null) {
              result.stats = Object.entries(grpc.stats).reduce((acc, [k, v]) => {
                acc[k] = $root.wix.social.RequesterContextActivityStats.fromGRPC(v, helper);
                return acc;
              }, {});
            } else {
              delete result.stats;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'containerId': {
                'type': 'string',
                'id': 1
              },
              'containerType': {
                'type': 'string',
                'id': 2
              },
              'versionRange': {
                'type': $root.wix.social.VersionRange,
                'id': 3
              },
              'stats': {
                'keyType': 'string',
                'type': $root.wix.social.RequesterContextActivityStats,
                'id': 4
              }
            }
          };
        }
      }

      Object.defineProperty(ContainerActivityStats.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.social.ContainerActivityStats');
        },
        enumerable: false,
        configurable: false
      });
      return ContainerActivityStats;
    }());
    social.ContainerIdentityActivityStats = (function() {

      class ContainerIdentityActivityStats {

        constructor(props) {
          this.containerId = props && props.containerId;
          this.containerType = props && props.containerType;
          this.stats = props && props.stats;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.containerId != null) {
              if (typeof msg.containerId !== 'string') {
                errors.field('containerId').error('string expected');
              }
            }
            if (msg.containerType != null) {
              if (typeof msg.containerType !== 'string') {
                errors.field('containerType').error('string expected');
              }
            }
            if (msg.stats != null) {
              const fieldErrors = errors.field('stats');

              if (!Array.isArray(msg.stats)) {
                fieldErrors.error('array expected');
              } else {
                msg.stats.forEach((value, index) => {
                  $root.wix.social.IdentityActivityStats.verify(value, helper, fieldErrors.index(index));
                });
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.containerId != null) {
              json.containerId = obj.containerId;
            }
            if (obj.containerType != null) {
              json.containerType = obj.containerType;
            }
            if (obj.stats != null) {
              json.stats = obj.stats.map(e => {
                return $root.wix.social.IdentityActivityStats.toJSON(e, helper);
              });
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.social.ContainerIdentityActivityStats();

          if (json.containerId != null) {
            result.containerId = json.containerId;
          } else {
            result.containerId = '';
          }
          if (json.containerType != null) {
            result.containerType = json.containerType;
          } else {
            result.containerType = '';
          }
          if (json.stats != null) {
            result.stats = json.stats.map(e => {
              return $root.wix.social.IdentityActivityStats.fromJSON(e, helper);
            });
          } else {
            result.stats = [];
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.containerId != null) {
              grpc.containerId = obj.containerId;
            }
            if (obj.containerType != null) {
              grpc.containerType = obj.containerType;
            }
            if (obj.stats != null) {
              grpc.stats = obj.stats.map(e => {
                return $root.wix.social.IdentityActivityStats.toGRPC(e, helper);
              });
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.social.ContainerIdentityActivityStats();

            if (grpc.containerId != null) {
              result.containerId = grpc.containerId;
            } else {
              result.containerId = '';
            }
            if (grpc.containerType != null) {
              result.containerType = grpc.containerType;
            } else {
              result.containerType = '';
            }
            if (grpc.stats != null) {
              result.stats = grpc.stats.map(e => {
                return $root.wix.social.IdentityActivityStats.fromGRPC(e, helper);
              });
            } else {
              result.stats = [];
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'containerId': {
                'type': 'string',
                'id': 1
              },
              'containerType': {
                'type': 'string',
                'id': 2
              },
              'stats': {
                'rule': 'repeated',
                'type': $root.wix.social.IdentityActivityStats,
                'id': 3
              }
            }
          };
        }
      }

      Object.defineProperty(ContainerIdentityActivityStats.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.social.ContainerIdentityActivityStats');
        },
        enumerable: false,
        configurable: false
      });
      return ContainerIdentityActivityStats;
    }());
    social.ContainerLatestActivity = (function() {

      class ContainerLatestActivity {

        constructor(props) {
          this.containerId = props && props.containerId;
          this.containerType = props && props.containerType;
          this.latestActivity = props && props.latestActivity;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.containerId != null) {
              if (typeof msg.containerId !== 'string') {
                errors.field('containerId').error('string expected');
              }
            }
            if (msg.containerType != null) {
              if (typeof msg.containerType !== 'string') {
                errors.field('containerType').error('string expected');
              }
            }
            if (msg.latestActivity != null) {
              $root.wix.social.ActivityInfo.verify(msg.latestActivity, helper, errors.field('latestActivity'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.containerId != null) {
              json.containerId = obj.containerId;
            }
            if (obj.containerType != null) {
              json.containerType = obj.containerType;
            }
            if (obj.latestActivity != null) {
              json.latestActivity = $root.wix.social.ActivityInfo.toJSON(obj.latestActivity, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.social.ContainerLatestActivity();

          if (json.containerId != null) {
            result.containerId = json.containerId;
          } else {
            result.containerId = '';
          }
          if (json.containerType != null) {
            result.containerType = json.containerType;
          } else {
            result.containerType = '';
          }
          if (json.latestActivity != null) {
            result.latestActivity = $root.wix.social.ActivityInfo.fromJSON(json.latestActivity, helper);
          } else {
            delete result.latestActivity;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.containerId != null) {
              grpc.containerId = obj.containerId;
            }
            if (obj.containerType != null) {
              grpc.containerType = obj.containerType;
            }
            if (obj.latestActivity != null) {
              grpc.latestActivity = $root.wix.social.ActivityInfo.toGRPC(obj.latestActivity, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.social.ContainerLatestActivity();

            if (grpc.containerId != null) {
              result.containerId = grpc.containerId;
            } else {
              result.containerId = '';
            }
            if (grpc.containerType != null) {
              result.containerType = grpc.containerType;
            } else {
              result.containerType = '';
            }
            if (grpc.latestActivity != null) {
              result.latestActivity = $root.wix.social.ActivityInfo.fromGRPC(grpc.latestActivity, helper);
            } else {
              delete result.latestActivity;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'containerId': {
                'type': 'string',
                'id': 1
              },
              'containerType': {
                'type': 'string',
                'id': 2
              },
              'latestActivity': {
                'type': $root.wix.social.ActivityInfo,
                'id': 3
              }
            }
          };
        }
      }

      Object.defineProperty(ContainerLatestActivity.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.social.ContainerLatestActivity');
        },
        enumerable: false,
        configurable: false
      });
      return ContainerLatestActivity;
    }());
    social.RequesterContextActivityStats = (function() {

      class RequesterContextActivityStats {

        constructor(props) {
          this.total = props && props.total;
          this.totalExcludedOwn = props && props.totalExcludedOwn;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.total != null) {
              if (!Number.isInteger(msg.total)) {
                errors.field('total').error('integer expected');
              }
            }
            if (msg.totalExcludedOwn != null) {
              if (!Number.isInteger(msg.totalExcludedOwn)) {
                errors.field('totalExcludedOwn').error('integer expected');
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.total != null) {
              json.total = obj.total;
            }
            if (obj.totalExcludedOwn != null) {
              json.totalExcludedOwn = obj.totalExcludedOwn;
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.social.RequesterContextActivityStats();

          if (json.total != null) {
            result.total = json.total;
          } else {
            result.total = 0;
          }
          if (json.totalExcludedOwn != null) {
            result.totalExcludedOwn = json.totalExcludedOwn;
          } else {
            result.totalExcludedOwn = 0;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.total != null) {
              grpc.total = obj.total;
            }
            if (obj.totalExcludedOwn != null) {
              grpc.totalExcludedOwn = obj.totalExcludedOwn;
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.social.RequesterContextActivityStats();

            if (grpc.total != null) {
              result.total = grpc.total;
            } else {
              result.total = 0;
            }
            if (grpc.totalExcludedOwn != null) {
              result.totalExcludedOwn = grpc.totalExcludedOwn;
            } else {
              result.totalExcludedOwn = 0;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'total': {
                'type': 'int32',
                'id': 1
              },
              'totalExcludedOwn': {
                'type': 'int32',
                'id': 5
              }
            }
          };
        }
      }

      Object.defineProperty(RequesterContextActivityStats.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.social.RequesterContextActivityStats');
        },
        enumerable: false,
        configurable: false
      });
      return RequesterContextActivityStats;
    }());
    social.IdentityActivityStats = (function() {

      class IdentityActivityStats {

        constructor(props) {
          this.identity = props && props.identity;
          this.activityStats = props && props.activityStats;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.identity != null) {
              $root.wix.social.SocialIdentity.verify(msg.identity, helper, errors.field('identity'));
            }
            if (msg.activityStats != null) {
              const fieldErrors = errors.field('activityStats');

              if (msg.activityStats != null && (!(typeof msg.activityStats === 'object') || Array.isArray(msg.activityStats))) {
                fieldErrors.error('object expected');
              } else {
                for (let key in msg.activityStats) {
                  const keyErrors = fieldErrors.index(key);
                  $root.wix.social.ActivityStats.verify(msg.activityStats[key], helper, keyErrors.field('value'));
                }
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.identity != null) {
              json.identity = $root.wix.social.SocialIdentity.toJSON(obj.identity, helper);
            }
            if (obj.activityStats != null) {
              json.activityStats = Object.entries(obj.activityStats).reduce((acc, [k, v]) => {
                acc[k] = $root.wix.social.ActivityStats.toJSON(v, helper);
                return acc;
              }, {});
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.social.IdentityActivityStats();

          if (json.identity != null) {
            result.identity = $root.wix.social.SocialIdentity.fromJSON(json.identity, helper);
          } else {
            delete result.identity;
          }
          if (json.activityStats != null) {
            result.activityStats = Object.entries(json.activityStats).reduce((acc, [k, v]) => {
              acc[k] = $root.wix.social.ActivityStats.fromJSON(v, helper);
              return acc;
            }, {});
          } else {
            delete result.activityStats;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.identity != null) {
              grpc.identity = $root.wix.social.SocialIdentity.toGRPC(obj.identity, helper);
            }
            if (obj.activityStats != null) {
              grpc.activityStats = Object.entries(obj.activityStats).reduce((acc, [k, v]) => {
                acc[k] = $root.wix.social.ActivityStats.toGRPC(v, helper);
                return acc;
              }, {});
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.social.IdentityActivityStats();

            if (grpc.identity != null) {
              result.identity = $root.wix.social.SocialIdentity.fromGRPC(grpc.identity, helper);
            } else {
              delete result.identity;
            }
            if (grpc.activityStats != null) {
              result.activityStats = Object.entries(grpc.activityStats).reduce((acc, [k, v]) => {
                acc[k] = $root.wix.social.ActivityStats.fromGRPC(v, helper);
                return acc;
              }, {});
            } else {
              delete result.activityStats;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'identity': {
                'type': $root.wix.social.SocialIdentity,
                'id': 1
              },
              'activityStats': {
                'keyType': 'string',
                'type': $root.wix.social.ActivityStats,
                'id': 2
              }
            }
          };
        }
      }

      Object.defineProperty(IdentityActivityStats.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.social.IdentityActivityStats');
        },
        enumerable: false,
        configurable: false
      });
      return IdentityActivityStats;
    }());
    social.ActivityStats = (function() {

      class ActivityStats {

        constructor(props) {
          this.total = props && props.total;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.total != null) {
              if (!Number.isInteger(msg.total)) {
                errors.field('total').error('integer expected');
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.total != null) {
              json.total = obj.total;
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.social.ActivityStats();

          if (json.total != null) {
            result.total = json.total;
          } else {
            result.total = 0;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.total != null) {
              grpc.total = obj.total;
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.social.ActivityStats();

            if (grpc.total != null) {
              result.total = grpc.total;
            } else {
              result.total = 0;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'total': {
                'type': 'int32',
                'id': 1
              }
            }
          };
        }
      }

      Object.defineProperty(ActivityStats.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.social.ActivityStats');
        },
        enumerable: false,
        configurable: false
      });
      return ActivityStats;
    }());
    social.ActivityInfo = (function() {

      class ActivityInfo {

        constructor(props) {
          this.activityType = props && props.activityType;
          this.activityTime = props && props.activityTime;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.activityType != null) {
              if (typeof msg.activityType !== 'string') {
                errors.field('activityType').error('string expected');
              }
            }
            if (msg.activityTime != null) {
              $root.google.protobuf.Timestamp.verify(msg.activityTime, helper, errors.field('activityTime'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.activityType != null) {
              json.activityType = obj.activityType;
            }
            if (obj.activityTime != null) {
              json.activityTime = $root.google.protobuf.Timestamp.toJSON(obj.activityTime, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.social.ActivityInfo();

          if (json.activityType != null) {
            result.activityType = json.activityType;
          } else {
            result.activityType = '';
          }
          if (json.activityTime != null) {
            result.activityTime = $root.google.protobuf.Timestamp.fromJSON(json.activityTime, helper);
          } else {
            delete result.activityTime;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.activityType != null) {
              grpc.activityType = obj.activityType;
            }
            if (obj.activityTime != null) {
              grpc.activityTime = $root.google.protobuf.Timestamp.toGRPC(obj.activityTime, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.social.ActivityInfo();

            if (grpc.activityType != null) {
              result.activityType = grpc.activityType;
            } else {
              result.activityType = '';
            }
            if (grpc.activityTime != null) {
              result.activityTime = $root.google.protobuf.Timestamp.fromGRPC(grpc.activityTime, helper);
            } else {
              delete result.activityTime;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'activityType': {
                'type': 'string',
                'id': 1
              },
              'activityTime': {
                'type': $root.google.protobuf.Timestamp,
                'id': 2
              }
            }
          };
        }
      }

      Object.defineProperty(ActivityInfo.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.social.ActivityInfo');
        },
        enumerable: false,
        configurable: false
      });
      return ActivityInfo;
    }());
    social.TimeRange = (function() {

      class TimeRange {

        constructor(props) {
          this.from = props && props.from;
          this.to = props && props.to;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.from != null) {
              $root.google.protobuf.Timestamp.verify(msg.from, helper, errors.field('from'));
            }
            if (msg.to != null) {
              $root.google.protobuf.Timestamp.verify(msg.to, helper, errors.field('to'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.from != null) {
              json.from = $root.google.protobuf.Timestamp.toJSON(obj.from, helper);
            }
            if (obj.to != null) {
              json.to = $root.google.protobuf.Timestamp.toJSON(obj.to, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.social.TimeRange();

          if (json.from != null) {
            result.from = $root.google.protobuf.Timestamp.fromJSON(json.from, helper);
          } else {
            delete result.from;
          }
          if (json.to != null) {
            result.to = $root.google.protobuf.Timestamp.fromJSON(json.to, helper);
          } else {
            delete result.to;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.from != null) {
              grpc.from = $root.google.protobuf.Timestamp.toGRPC(obj.from, helper);
            }
            if (obj.to != null) {
              grpc.to = $root.google.protobuf.Timestamp.toGRPC(obj.to, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.social.TimeRange();

            if (grpc.from != null) {
              result.from = $root.google.protobuf.Timestamp.fromGRPC(grpc.from, helper);
            } else {
              delete result.from;
            }
            if (grpc.to != null) {
              result.to = $root.google.protobuf.Timestamp.fromGRPC(grpc.to, helper);
            } else {
              delete result.to;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'from': {
                'type': $root.google.protobuf.Timestamp,
                'id': 1
              },
              'to': {
                'type': $root.google.protobuf.Timestamp,
                'id': 2
              }
            }
          };
        }
      }

      Object.defineProperty(TimeRange.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.social.TimeRange');
        },
        enumerable: false,
        configurable: false
      });
      return TimeRange;
    }());
    social.VersionQuery = (function() {

      class VersionQuery {

        constructor(props) {
          this.from = props && props.from;
          this.to = props && props.to;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.from != null) {
              $root.google.protobuf.StringValue.verify(msg.from, helper, errors.field('from'));
            }
            if (msg.to != null) {
              $root.google.protobuf.StringValue.verify(msg.to, helper, errors.field('to'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.from != null) {
              json.from = $root.google.protobuf.StringValue.toJSON(obj.from, helper);
            }
            if (obj.to != null) {
              json.to = $root.google.protobuf.StringValue.toJSON(obj.to, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.social.VersionQuery();

          if (json.from != null) {
            result.from = $root.google.protobuf.StringValue.fromJSON(json.from, helper);
          } else {
            delete result.from;
          }
          if (json.to != null) {
            result.to = $root.google.protobuf.StringValue.fromJSON(json.to, helper);
          } else {
            delete result.to;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.from != null) {
              grpc.from = $root.google.protobuf.StringValue.toGRPC(obj.from, helper);
            }
            if (obj.to != null) {
              grpc.to = $root.google.protobuf.StringValue.toGRPC(obj.to, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.social.VersionQuery();

            if (grpc.from != null) {
              result.from = $root.google.protobuf.StringValue.fromGRPC(grpc.from, helper);
            } else {
              delete result.from;
            }
            if (grpc.to != null) {
              result.to = $root.google.protobuf.StringValue.fromGRPC(grpc.to, helper);
            } else {
              delete result.to;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'from': {
                'type': $root.google.protobuf.StringValue,
                'id': 1
              },
              'to': {
                'type': $root.google.protobuf.StringValue,
                'id': 2
              }
            }
          };
        }
      }

      Object.defineProperty(VersionQuery.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.social.VersionQuery');
        },
        enumerable: false,
        configurable: false
      });
      return VersionQuery;
    }());
    social.VersionRange = (function() {

      class VersionRange {

        constructor(props) {
          this.from = props && props.from;
          this.to = props && props.to;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.from != null) {
              if (typeof msg.from !== 'string') {
                errors.field('from').error('string expected');
              }
            }
            if (msg.to != null) {
              if (typeof msg.to !== 'string') {
                errors.field('to').error('string expected');
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.from != null) {
              json.from = obj.from;
            }
            if (obj.to != null) {
              json.to = obj.to;
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.social.VersionRange();

          if (json.from != null) {
            result.from = json.from;
          } else {
            result.from = '';
          }
          if (json.to != null) {
            result.to = json.to;
          } else {
            result.to = '';
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.from != null) {
              grpc.from = obj.from;
            }
            if (obj.to != null) {
              grpc.to = obj.to;
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.social.VersionRange();

            if (grpc.from != null) {
              result.from = grpc.from;
            } else {
              result.from = '';
            }
            if (grpc.to != null) {
              result.to = grpc.to;
            } else {
              result.to = '';
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'from': {
                'type': 'string',
                'id': 1
              },
              'to': {
                'type': 'string',
                'id': 2
              }
            }
          };
        }
      }

      Object.defineProperty(VersionRange.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.social.VersionRange');
        },
        enumerable: false,
        configurable: false
      });
      return VersionRange;
    }());
    social.IdentityParticipated = (function() {

      class IdentityParticipated {

        constructor(props) {
          this.entityId = props && props.entityId;
          this.containerId = props && props.containerId;
          this.identity = props && props.identity;
          this.resourceId = props && props.resourceId;
          this.createdAt = props && props.createdAt;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.entityId != null) {
              if (typeof msg.entityId !== 'string') {
                errors.field('entityId').error('string expected');
              }
            }
            if (msg.containerId != null) {
              if (typeof msg.containerId !== 'string') {
                errors.field('containerId').error('string expected');
              }
            }
            if (msg.identity != null) {
              $root.wix.social.SocialIdentity.verify(msg.identity, helper, errors.field('identity'));
            }
            if (msg.resourceId != null) {
              $root.google.protobuf.StringValue.verify(msg.resourceId, helper, errors.field('resourceId'));
            }
            if (msg.createdAt != null) {
              $root.google.protobuf.Timestamp.verify(msg.createdAt, helper, errors.field('createdAt'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.entityId != null) {
              json.entityId = obj.entityId;
            }
            if (obj.containerId != null) {
              json.containerId = obj.containerId;
            }
            if (obj.identity != null) {
              json.identity = $root.wix.social.SocialIdentity.toJSON(obj.identity, helper);
            }
            if (obj.resourceId != null) {
              json.resourceId = $root.google.protobuf.StringValue.toJSON(obj.resourceId, helper);
            }
            if (obj.createdAt != null) {
              json.createdAt = $root.google.protobuf.Timestamp.toJSON(obj.createdAt, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.social.IdentityParticipated();

          if (json.entityId != null) {
            result.entityId = json.entityId;
          } else {
            result.entityId = '';
          }
          if (json.containerId != null) {
            result.containerId = json.containerId;
          } else {
            result.containerId = '';
          }
          if (json.identity != null) {
            result.identity = $root.wix.social.SocialIdentity.fromJSON(json.identity, helper);
          } else {
            delete result.identity;
          }
          if (json.resourceId != null) {
            result.resourceId = $root.google.protobuf.StringValue.fromJSON(json.resourceId, helper);
          } else {
            delete result.resourceId;
          }
          if (json.createdAt != null) {
            result.createdAt = $root.google.protobuf.Timestamp.fromJSON(json.createdAt, helper);
          } else {
            delete result.createdAt;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.entityId != null) {
              grpc.entityId = obj.entityId;
            }
            if (obj.containerId != null) {
              grpc.containerId = obj.containerId;
            }
            if (obj.identity != null) {
              grpc.identity = $root.wix.social.SocialIdentity.toGRPC(obj.identity, helper);
            }
            if (obj.resourceId != null) {
              grpc.resourceId = $root.google.protobuf.StringValue.toGRPC(obj.resourceId, helper);
            }
            if (obj.createdAt != null) {
              grpc.createdAt = $root.google.protobuf.Timestamp.toGRPC(obj.createdAt, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.social.IdentityParticipated();

            if (grpc.entityId != null) {
              result.entityId = grpc.entityId;
            } else {
              result.entityId = '';
            }
            if (grpc.containerId != null) {
              result.containerId = grpc.containerId;
            } else {
              result.containerId = '';
            }
            if (grpc.identity != null) {
              result.identity = $root.wix.social.SocialIdentity.fromGRPC(grpc.identity, helper);
            } else {
              delete result.identity;
            }
            if (grpc.resourceId != null) {
              result.resourceId = $root.google.protobuf.StringValue.fromGRPC(grpc.resourceId, helper);
            } else {
              delete result.resourceId;
            }
            if (grpc.createdAt != null) {
              result.createdAt = $root.google.protobuf.Timestamp.fromGRPC(grpc.createdAt, helper);
            } else {
              delete result.createdAt;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'entityId': {
                'type': 'string',
                'id': 1
              },
              'containerId': {
                'type': 'string',
                'id': 2
              },
              'identity': {
                'type': $root.wix.social.SocialIdentity,
                'id': 3
              },
              'resourceId': {
                'type': $root.google.protobuf.StringValue,
                'id': 4
              },
              'createdAt': {
                'type': $root.google.protobuf.Timestamp,
                'id': 5
              }
            }
          };
        }
      }

      Object.defineProperty(IdentityParticipated.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.social.IdentityParticipated');
        },
        enumerable: false,
        configurable: false
      });
      return IdentityParticipated;
    }());
    social.SubscribedToEntity = (function() {

      class SubscribedToEntity {

        constructor(props) {
          this.entityId = props && props.entityId;
          this.containerId = props && props.containerId;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.entityId != null) {
              if (typeof msg.entityId !== 'string') {
                errors.field('entityId').error('string expected');
              }
            }
            if (msg.containerId != null) {
              if (typeof msg.containerId !== 'string') {
                errors.field('containerId').error('string expected');
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.entityId != null) {
              json.entityId = obj.entityId;
            }
            if (obj.containerId != null) {
              json.containerId = obj.containerId;
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.social.SubscribedToEntity();

          if (json.entityId != null) {
            result.entityId = json.entityId;
          } else {
            result.entityId = '';
          }
          if (json.containerId != null) {
            result.containerId = json.containerId;
          } else {
            result.containerId = '';
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.entityId != null) {
              grpc.entityId = obj.entityId;
            }
            if (obj.containerId != null) {
              grpc.containerId = obj.containerId;
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.social.SubscribedToEntity();

            if (grpc.entityId != null) {
              result.entityId = grpc.entityId;
            } else {
              result.entityId = '';
            }
            if (grpc.containerId != null) {
              result.containerId = grpc.containerId;
            } else {
              result.containerId = '';
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'entityId': {
                'type': 'string',
                'id': 1
              },
              'containerId': {
                'type': 'string',
                'id': 2
              }
            }
          };
        }
      }

      Object.defineProperty(SubscribedToEntity.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.social.SubscribedToEntity');
        },
        enumerable: false,
        configurable: false
      });
      return SubscribedToEntity;
    }());
    social.UnsubscribedFromEntity = (function() {

      class UnsubscribedFromEntity {

        constructor(props) {
          this.entityId = props && props.entityId;
          this.containerId = props && props.containerId;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.entityId != null) {
              if (typeof msg.entityId !== 'string') {
                errors.field('entityId').error('string expected');
              }
            }
            if (msg.containerId != null) {
              if (typeof msg.containerId !== 'string') {
                errors.field('containerId').error('string expected');
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.entityId != null) {
              json.entityId = obj.entityId;
            }
            if (obj.containerId != null) {
              json.containerId = obj.containerId;
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.social.UnsubscribedFromEntity();

          if (json.entityId != null) {
            result.entityId = json.entityId;
          } else {
            result.entityId = '';
          }
          if (json.containerId != null) {
            result.containerId = json.containerId;
          } else {
            result.containerId = '';
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.entityId != null) {
              grpc.entityId = obj.entityId;
            }
            if (obj.containerId != null) {
              grpc.containerId = obj.containerId;
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.social.UnsubscribedFromEntity();

            if (grpc.entityId != null) {
              result.entityId = grpc.entityId;
            } else {
              result.entityId = '';
            }
            if (grpc.containerId != null) {
              result.containerId = grpc.containerId;
            } else {
              result.containerId = '';
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'entityId': {
                'type': 'string',
                'id': 1
              },
              'containerId': {
                'type': 'string',
                'id': 2
              }
            }
          };
        }
      }

      Object.defineProperty(UnsubscribedFromEntity.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.social.UnsubscribedFromEntity');
        },
        enumerable: false,
        configurable: false
      });
      return UnsubscribedFromEntity;
    }());
    social.ManagementService = (function() {

      class ManagementService {

        constructor() {
          if (this.constructor.name === ManagementService.name) {
            throw new TypeError('class ManagementService is abstract');
          }
        }

        getContextToken(aspects, msg) {
          throw new TypeError('method getContextToken is abstract');
        }

        viewTokenContents(aspects, msg) {
          throw new TypeError('method viewTokenContents is abstract');
        }

        getParticipants(aspects, msg) {
          throw new TypeError('method getParticipants is abstract');
        }
      }

      ManagementService.prototype.getContextToken._messageTypes = function() {
        return [
          $root.wix.social.GetContextTokenRequest,
          $root.wix.social.GetContextTokenResponse
        ];
      };
      ManagementService.prototype.viewTokenContents._messageTypes = function() {
        return [
          $root.wix.social.ViewTokenContentsRequest,
          $root.wix.social.ViewTokenContentsResponse
        ];
      };
      ManagementService.prototype.getParticipants._messageTypes = function() {
        return [
          $root.wix.social.GetParticipantsRequest,
          $root.wix.social.GetParticipantsResponse
        ];
      };
      ManagementService.prototype.getContextToken.__proto = pbjs => {
        return $root.__lookup(pbjs)('wix.social.ManagementService.GetContextToken');
      };
      ManagementService.prototype.viewTokenContents.__proto = pbjs => {
        return $root.__lookup(pbjs)('wix.social.ManagementService.ViewTokenContents');
      };
      ManagementService.prototype.getParticipants.__proto = pbjs => {
        return $root.__lookup(pbjs)('wix.social.ManagementService.GetParticipants');
      };
      Object.defineProperty(ManagementService.prototype, '__isRpcService__', {
        value: true,
        enumerable: false,
        configurable: false
      });
      Object.defineProperty(ManagementService.prototype, '__fqn__', {
        value: 'wix.social.ManagementService',
        enumerable: false,
        configurable: false
      });
      Object.defineProperty(ManagementService.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.social.ManagementService');
        },
        enumerable: false,
        configurable: false
      });
      Object.defineProperty(ManagementService.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      return ManagementService;
    }());
    social.GetContextTokenRequest = (function() {

      class GetContextTokenRequest {

        constructor(props) {
          this.appDefId = props && props.appDefId;
          this.containerType = props && props.containerType;
          this.containerId = props && props.containerId;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.appDefId != null) {
              if (typeof msg.appDefId !== 'string') {
                errors.field('appDefId').error('string expected');
              }
            }
            if (msg.containerType != null) {
              if (typeof msg.containerType !== 'string') {
                errors.field('containerType').error('string expected');
              }
            }
            if (msg.containerId != null) {
              $root.google.protobuf.StringValue.verify(msg.containerId, helper, errors.field('containerId'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.appDefId != null) {
              json.appDefId = obj.appDefId;
            }
            if (obj.containerType != null) {
              json.containerType = obj.containerType;
            }
            if (obj.containerId != null) {
              json.containerId = $root.google.protobuf.StringValue.toJSON(obj.containerId, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.social.GetContextTokenRequest();

          if (json.appDefId != null) {
            result.appDefId = json.appDefId;
          } else {
            result.appDefId = '';
          }
          if (json.containerType != null) {
            result.containerType = json.containerType;
          } else {
            result.containerType = '';
          }
          if (json.containerId != null) {
            result.containerId = $root.google.protobuf.StringValue.fromJSON(json.containerId, helper);
          } else {
            delete result.containerId;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.appDefId != null) {
              grpc.appDefId = obj.appDefId;
            }
            if (obj.containerType != null) {
              grpc.containerType = obj.containerType;
            }
            if (obj.containerId != null) {
              grpc.containerId = $root.google.protobuf.StringValue.toGRPC(obj.containerId, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.social.GetContextTokenRequest();

            if (grpc.appDefId != null) {
              result.appDefId = grpc.appDefId;
            } else {
              result.appDefId = '';
            }
            if (grpc.containerType != null) {
              result.containerType = grpc.containerType;
            } else {
              result.containerType = '';
            }
            if (grpc.containerId != null) {
              result.containerId = $root.google.protobuf.StringValue.fromGRPC(grpc.containerId, helper);
            } else {
              delete result.containerId;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'appDefId': {
                'type': 'string',
                'id': 1
              },
              'containerType': {
                'type': 'string',
                'id': 2
              },
              'containerId': {
                'type': $root.google.protobuf.StringValue,
                'id': 3
              }
            }
          };
        }
      }

      Object.defineProperty(GetContextTokenRequest.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.social.GetContextTokenRequest');
        },
        enumerable: false,
        configurable: false
      });
      return GetContextTokenRequest;
    }());
    social.GetContextTokenResponse = (function() {

      class GetContextTokenResponse {

        constructor(props) {
          this.contextToken = props && props.contextToken;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.contextToken != null) {
              if (typeof msg.contextToken !== 'string') {
                errors.field('contextToken').error('string expected');
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.contextToken != null) {
              json.contextToken = obj.contextToken;
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.social.GetContextTokenResponse();

          if (json.contextToken != null) {
            result.contextToken = json.contextToken;
          } else {
            result.contextToken = '';
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.contextToken != null) {
              grpc.contextToken = obj.contextToken;
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.social.GetContextTokenResponse();

            if (grpc.contextToken != null) {
              result.contextToken = grpc.contextToken;
            } else {
              result.contextToken = '';
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'contextToken': {
                'type': 'string',
                'id': 1
              }
            }
          };
        }
      }

      Object.defineProperty(GetContextTokenResponse.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.social.GetContextTokenResponse');
        },
        enumerable: false,
        configurable: false
      });
      return GetContextTokenResponse;
    }());
    social.GetParticipantsRequest = (function() {

      class GetParticipantsRequest {

        constructor(props) {
          this.contextToken = props && props.contextToken;
          this.fromEventId = props && props.fromEventId;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.contextToken != null) {
              $root.google.protobuf.StringValue.verify(msg.contextToken, helper, errors.field('contextToken'));
            }
            if (msg.fromEventId != null) {
              $root.google.protobuf.UInt64Value.verify(msg.fromEventId, helper, errors.field('fromEventId'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.contextToken != null) {
              json.contextToken = $root.google.protobuf.StringValue.toJSON(obj.contextToken, helper);
            }
            if (obj.fromEventId != null) {
              json.fromEventId = $root.google.protobuf.UInt64Value.toJSON(obj.fromEventId, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.social.GetParticipantsRequest();

          if (json.contextToken != null) {
            result.contextToken = $root.google.protobuf.StringValue.fromJSON(json.contextToken, helper);
          } else {
            delete result.contextToken;
          }
          if (json.fromEventId != null) {
            result.fromEventId = $root.google.protobuf.UInt64Value.fromJSON(json.fromEventId, helper);
          } else {
            delete result.fromEventId;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.contextToken != null) {
              grpc.contextToken = $root.google.protobuf.StringValue.toGRPC(obj.contextToken, helper);
            }
            if (obj.fromEventId != null) {
              grpc.fromEventId = $root.google.protobuf.UInt64Value.toGRPC(obj.fromEventId, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.social.GetParticipantsRequest();

            if (grpc.contextToken != null) {
              result.contextToken = $root.google.protobuf.StringValue.fromGRPC(grpc.contextToken, helper);
            } else {
              delete result.contextToken;
            }
            if (grpc.fromEventId != null) {
              result.fromEventId = $root.google.protobuf.UInt64Value.fromGRPC(grpc.fromEventId, helper);
            } else {
              delete result.fromEventId;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'contextToken': {
                'type': $root.google.protobuf.StringValue,
                'id': 1
              },
              'fromEventId': {
                'type': $root.google.protobuf.UInt64Value,
                'id': 2
              }
            }
          };
        }
      }

      Object.defineProperty(GetParticipantsRequest.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.social.GetParticipantsRequest');
        },
        enumerable: false,
        configurable: false
      });
      return GetParticipantsRequest;
    }());
    social.GetParticipantsResponse = (function() {

      class GetParticipantsResponse {

        constructor(props) {
          this.identities = props && props.identities;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.identities != null) {
              const fieldErrors = errors.field('identities');

              if (!Array.isArray(msg.identities)) {
                fieldErrors.error('array expected');
              } else {
                msg.identities.forEach((value, index) => {
                  $root.wix.social.SocialIdentity.verify(value, helper, fieldErrors.index(index));
                });
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.identities != null) {
              json.identities = obj.identities.map(e => {
                return $root.wix.social.SocialIdentity.toJSON(e, helper);
              });
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.social.GetParticipantsResponse();

          if (json.identities != null) {
            result.identities = json.identities.map(e => {
              return $root.wix.social.SocialIdentity.fromJSON(e, helper);
            });
          } else {
            result.identities = [];
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.identities != null) {
              grpc.identities = obj.identities.map(e => {
                return $root.wix.social.SocialIdentity.toGRPC(e, helper);
              });
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.social.GetParticipantsResponse();

            if (grpc.identities != null) {
              result.identities = grpc.identities.map(e => {
                return $root.wix.social.SocialIdentity.fromGRPC(e, helper);
              });
            } else {
              result.identities = [];
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'identities': {
                'rule': 'repeated',
                'type': $root.wix.social.SocialIdentity,
                'id': 1
              }
            }
          };
        }
      }

      Object.defineProperty(GetParticipantsResponse.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.social.GetParticipantsResponse');
        },
        enumerable: false,
        configurable: false
      });
      return GetParticipantsResponse;
    }());
    social.ViewTokenContentsRequest = (function() {

      class ViewTokenContentsRequest {

        constructor(props) {
          this.contextToken = props && props.contextToken;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.contextToken != null) {
              if (typeof msg.contextToken !== 'string') {
                errors.field('contextToken').error('string expected');
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.contextToken != null) {
              json.contextToken = obj.contextToken;
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.social.ViewTokenContentsRequest();

          if (json.contextToken != null) {
            result.contextToken = json.contextToken;
          } else {
            result.contextToken = '';
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.contextToken != null) {
              grpc.contextToken = obj.contextToken;
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.social.ViewTokenContentsRequest();

            if (grpc.contextToken != null) {
              result.contextToken = grpc.contextToken;
            } else {
              result.contextToken = '';
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'contextToken': {
                'type': 'string',
                'id': 1
              }
            }
          };
        }
      }

      Object.defineProperty(ViewTokenContentsRequest.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.social.ViewTokenContentsRequest');
        },
        enumerable: false,
        configurable: false
      });
      return ViewTokenContentsRequest;
    }());
    social.ViewTokenContentsResponse = (function() {

      class ViewTokenContentsResponse {

        constructor(props) {
          this.contextToken = props && props.contextToken;
          this.identityResponse = props && props.identityResponse;
          this.metaSiteContext = props && props.metaSiteContext;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.contextToken != null) {
              $root.wix.social.ContextTokenStructure.verify(msg.contextToken, helper, errors.field('contextToken'));
            }
            if (msg.identityResponse != null) {
              $root.com.wix.core.services.identification2.IdentityResponse.verify(msg.identityResponse, helper, errors.field('identityResponse'));
            }
            if (msg.metaSiteContext != null) {
              $root.com.wixpress.metasite.reloose.api.MetaSiteContext.verify(msg.metaSiteContext, helper, errors.field('metaSiteContext'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.contextToken != null) {
              json.contextToken = $root.wix.social.ContextTokenStructure.toJSON(obj.contextToken, helper);
            }
            if (obj.identityResponse != null) {
              json.identityResponse = $root.com.wix.core.services.identification2.IdentityResponse.toJSON(obj.identityResponse, helper);
            }
            if (obj.metaSiteContext != null) {
              json.metaSiteContext = $root.com.wixpress.metasite.reloose.api.MetaSiteContext.toJSON(obj.metaSiteContext, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.social.ViewTokenContentsResponse();

          if (json.contextToken != null) {
            result.contextToken = $root.wix.social.ContextTokenStructure.fromJSON(json.contextToken, helper);
          } else {
            delete result.contextToken;
          }
          if (json.identityResponse != null) {
            result.identityResponse = $root.com.wix.core.services.identification2.IdentityResponse.fromJSON(json.identityResponse, helper);
          } else {
            delete result.identityResponse;
          }
          if (json.metaSiteContext != null) {
            result.metaSiteContext = $root.com.wixpress.metasite.reloose.api.MetaSiteContext.fromJSON(json.metaSiteContext, helper);
          } else {
            delete result.metaSiteContext;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.contextToken != null) {
              grpc.contextToken = $root.wix.social.ContextTokenStructure.toGRPC(obj.contextToken, helper);
            }
            if (obj.identityResponse != null) {
              grpc.identityResponse = $root.com.wix.core.services.identification2.IdentityResponse.toGRPC(obj.identityResponse, helper);
            }
            if (obj.metaSiteContext != null) {
              grpc.metaSiteContext = $root.com.wixpress.metasite.reloose.api.MetaSiteContext.toGRPC(obj.metaSiteContext, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.social.ViewTokenContentsResponse();

            if (grpc.contextToken != null) {
              result.contextToken = $root.wix.social.ContextTokenStructure.fromGRPC(grpc.contextToken, helper);
            } else {
              delete result.contextToken;
            }
            if (grpc.identityResponse != null) {
              result.identityResponse = $root.com.wix.core.services.identification2.IdentityResponse.fromGRPC(grpc.identityResponse, helper);
            } else {
              delete result.identityResponse;
            }
            if (grpc.metaSiteContext != null) {
              result.metaSiteContext = $root.com.wixpress.metasite.reloose.api.MetaSiteContext.fromGRPC(grpc.metaSiteContext, helper);
            } else {
              delete result.metaSiteContext;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'contextToken': {
                'type': $root.wix.social.ContextTokenStructure,
                'id': 1
              },
              'identityResponse': {
                'type': $root.com.wix.core.services.identification2.IdentityResponse,
                'id': 2
              },
              'metaSiteContext': {
                'type': $root.com.wixpress.metasite.reloose.api.MetaSiteContext,
                'id': 3
              }
            }
          };
        }
      }

      Object.defineProperty(ViewTokenContentsResponse.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.social.ViewTokenContentsResponse');
        },
        enumerable: false,
        configurable: false
      });
      return ViewTokenContentsResponse;
    }());
    social.ContextTokenStructure = (function() {

      class ContextTokenStructure {

        constructor(props) {
          this.createdAt = props && props.createdAt;
          this.appDefId = props && props.appDefId;
          this.containerId = props && props.containerId;
          this.containerType = props && props.containerType;
          this.accessControlStates = props && props.accessControlStates;
          this.identities = props && props.identities;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.createdAt != null) {
              $root.google.protobuf.Timestamp.verify(msg.createdAt, helper, errors.field('createdAt'));
            }
            if (msg.appDefId != null) {
              if (typeof msg.appDefId !== 'string') {
                errors.field('appDefId').error('string expected');
              }
            }
            if (msg.containerId != null) {
              if (typeof msg.containerId !== 'string') {
                errors.field('containerId').error('string expected');
              }
            }
            if (msg.containerType != null) {
              if (typeof msg.containerType !== 'string') {
                errors.field('containerType').error('string expected');
              }
            }
            if (msg.accessControlStates != null) {
              const fieldErrors = errors.field('accessControlStates');

              if (!Array.isArray(msg.accessControlStates)) {
                fieldErrors.error('array expected');
              } else {
                msg.accessControlStates.forEach((value, index) => {
                  $root.wix.social.AccessControlState.verify(value, helper, fieldErrors.index(index));
                });
              }
            }
            if (msg.identities != null) {
              const fieldErrors = errors.field('identities');

              if (!Array.isArray(msg.identities)) {
                fieldErrors.error('array expected');
              } else {
                msg.identities.forEach((value, index) => {
                  $root.wix.social.SocialIdentity.verify(value, helper, fieldErrors.index(index));
                });
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.createdAt != null) {
              json.createdAt = $root.google.protobuf.Timestamp.toJSON(obj.createdAt, helper);
            }
            if (obj.appDefId != null) {
              json.appDefId = obj.appDefId;
            }
            if (obj.containerId != null) {
              json.containerId = obj.containerId;
            }
            if (obj.containerType != null) {
              json.containerType = obj.containerType;
            }
            if (obj.accessControlStates != null) {
              json.accessControlStates = obj.accessControlStates.map(e => {
                return $root.wix.social.AccessControlState.toJSON(e, helper);
              });
            }
            if (obj.identities != null) {
              json.identities = obj.identities.map(e => {
                return $root.wix.social.SocialIdentity.toJSON(e, helper);
              });
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.social.ContextTokenStructure();

          if (json.createdAt != null) {
            result.createdAt = $root.google.protobuf.Timestamp.fromJSON(json.createdAt, helper);
          } else {
            delete result.createdAt;
          }
          if (json.appDefId != null) {
            result.appDefId = json.appDefId;
          } else {
            result.appDefId = '';
          }
          if (json.containerId != null) {
            result.containerId = json.containerId;
          } else {
            result.containerId = '';
          }
          if (json.containerType != null) {
            result.containerType = json.containerType;
          } else {
            result.containerType = '';
          }
          if (json.accessControlStates != null) {
            result.accessControlStates = json.accessControlStates.map(e => {
              return $root.wix.social.AccessControlState.fromJSON(e, helper);
            });
          } else {
            result.accessControlStates = [];
          }
          if (json.identities != null) {
            result.identities = json.identities.map(e => {
              return $root.wix.social.SocialIdentity.fromJSON(e, helper);
            });
          } else {
            result.identities = [];
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.createdAt != null) {
              grpc.createdAt = $root.google.protobuf.Timestamp.toGRPC(obj.createdAt, helper);
            }
            if (obj.appDefId != null) {
              grpc.appDefId = obj.appDefId;
            }
            if (obj.containerId != null) {
              grpc.containerId = obj.containerId;
            }
            if (obj.containerType != null) {
              grpc.containerType = obj.containerType;
            }
            if (obj.accessControlStates != null) {
              grpc.accessControlStates = obj.accessControlStates.map(e => {
                return $root.wix.social.AccessControlState.toGRPC(e, helper);
              });
            }
            if (obj.identities != null) {
              grpc.identities = obj.identities.map(e => {
                return $root.wix.social.SocialIdentity.toGRPC(e, helper);
              });
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.social.ContextTokenStructure();

            if (grpc.createdAt != null) {
              result.createdAt = $root.google.protobuf.Timestamp.fromGRPC(grpc.createdAt, helper);
            } else {
              delete result.createdAt;
            }
            if (grpc.appDefId != null) {
              result.appDefId = grpc.appDefId;
            } else {
              result.appDefId = '';
            }
            if (grpc.containerId != null) {
              result.containerId = grpc.containerId;
            } else {
              result.containerId = '';
            }
            if (grpc.containerType != null) {
              result.containerType = grpc.containerType;
            } else {
              result.containerType = '';
            }
            if (grpc.accessControlStates != null) {
              result.accessControlStates = grpc.accessControlStates.map(e => {
                return $root.wix.social.AccessControlState.fromGRPC(e, helper);
              });
            } else {
              result.accessControlStates = [];
            }
            if (grpc.identities != null) {
              result.identities = grpc.identities.map(e => {
                return $root.wix.social.SocialIdentity.fromGRPC(e, helper);
              });
            } else {
              result.identities = [];
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'createdAt': {
                'type': $root.google.protobuf.Timestamp,
                'id': 1
              },
              'appDefId': {
                'type': 'string',
                'id': 2
              },
              'containerId': {
                'type': 'string',
                'id': 3,
                'options': {
                  '(wix.api.format)': 'GUID'
                }
              },
              'containerType': {
                'type': 'string',
                'id': 4
              },
              'accessControlStates': {
                'rule': 'repeated',
                'type': $root.wix.social.AccessControlState,
                'id': 5
              },
              'identities': {
                'rule': 'repeated',
                'type': $root.wix.social.SocialIdentity,
                'id': 6
              }
            }
          };
        }
      }

      Object.defineProperty(ContextTokenStructure.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.social.ContextTokenStructure');
        },
        enumerable: false,
        configurable: false
      });
      return ContextTokenStructure;
    }());
    social.AccessControlState = (function() {

      class AccessControlState {

        constructor(props) {
          this.fullyQualifiedName = props && props.fullyQualifiedName;
          this.state = props && props.state;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.fullyQualifiedName != null) {
              if (typeof msg.fullyQualifiedName !== 'string') {
                errors.field('fullyQualifiedName').error('string expected');
              }
            }
            if (msg.state != null) {
              if (!Buffer.isBuffer(msg.state)) {
                errors.field('state').error('buffer expected');
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.fullyQualifiedName != null) {
              json.fullyQualifiedName = obj.fullyQualifiedName;
            }
            if (obj.state != null) {
              json.state = obj.state.toString('base64');
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.social.AccessControlState();

          if (json.fullyQualifiedName != null) {
            result.fullyQualifiedName = json.fullyQualifiedName;
          } else {
            result.fullyQualifiedName = '';
          }
          if (json.state != null) {
            result.state = function tryParseBytes(val) {
              try {
                return Buffer.from(val, 'base64');
              } catch (e) {
                return val;
              } finally {}
            }(json.state);
          } else {
            delete result.state;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.fullyQualifiedName != null) {
              grpc.fullyQualifiedName = obj.fullyQualifiedName;
            }
            if (obj.state != null) {
              grpc.state = obj.state;
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.social.AccessControlState();

            if (grpc.fullyQualifiedName != null) {
              result.fullyQualifiedName = grpc.fullyQualifiedName;
            } else {
              result.fullyQualifiedName = '';
            }
            if (grpc.state != null) {
              result.state = grpc.state;
            } else {
              delete result.state;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'fullyQualifiedName': {
                'type': 'string',
                'id': 1
              },
              'state': {
                'type': 'bytes',
                'id': 2
              }
            }
          };
        }
      }

      Object.defineProperty(AccessControlState.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.social.AccessControlState');
        },
        enumerable: false,
        configurable: false
      });
      return AccessControlState;
    }());
    social.AddParticipationRequest = (function() {

      class AddParticipationRequest {

        constructor(props) {
          this.identity = props && props.identity;
          this.entityId = props && props.entityId;
          this.resourceId = props && props.resourceId;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.identity != null) {
              $root.wix.social.SocialIdentity.verify(msg.identity, helper, errors.field('identity'));
            }
            if (msg.entityId != null) {
              if (typeof msg.entityId !== 'string') {
                errors.field('entityId').error('string expected');
              }
            }
            if (msg.resourceId != null) {
              $root.google.protobuf.StringValue.verify(msg.resourceId, helper, errors.field('resourceId'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.identity != null) {
              json.identity = $root.wix.social.SocialIdentity.toJSON(obj.identity, helper);
            }
            if (obj.entityId != null) {
              json.entityId = obj.entityId;
            }
            if (obj.resourceId != null) {
              json.resourceId = $root.google.protobuf.StringValue.toJSON(obj.resourceId, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.social.AddParticipationRequest();

          if (json.identity != null) {
            result.identity = $root.wix.social.SocialIdentity.fromJSON(json.identity, helper);
          } else {
            delete result.identity;
          }
          if (json.entityId != null) {
            result.entityId = json.entityId;
          } else {
            result.entityId = '';
          }
          if (json.resourceId != null) {
            result.resourceId = $root.google.protobuf.StringValue.fromJSON(json.resourceId, helper);
          } else {
            delete result.resourceId;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.identity != null) {
              grpc.identity = $root.wix.social.SocialIdentity.toGRPC(obj.identity, helper);
            }
            if (obj.entityId != null) {
              grpc.entityId = obj.entityId;
            }
            if (obj.resourceId != null) {
              grpc.resourceId = $root.google.protobuf.StringValue.toGRPC(obj.resourceId, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.social.AddParticipationRequest();

            if (grpc.identity != null) {
              result.identity = $root.wix.social.SocialIdentity.fromGRPC(grpc.identity, helper);
            } else {
              delete result.identity;
            }
            if (grpc.entityId != null) {
              result.entityId = grpc.entityId;
            } else {
              result.entityId = '';
            }
            if (grpc.resourceId != null) {
              result.resourceId = $root.google.protobuf.StringValue.fromGRPC(grpc.resourceId, helper);
            } else {
              delete result.resourceId;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'identity': {
                'type': $root.wix.social.SocialIdentity,
                'id': 1
              },
              'entityId': {
                'type': 'string',
                'id': 2
              },
              'resourceId': {
                'type': $root.google.protobuf.StringValue,
                'id': 3
              }
            }
          };
        }
      }

      Object.defineProperty(AddParticipationRequest.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.social.AddParticipationRequest');
        },
        enumerable: false,
        configurable: false
      });
      return AddParticipationRequest;
    }());
    social.ProfilesPageCursor = (function() {

      class ProfilesPageCursor {

        constructor(props) {
          this.searchText = props && props.searchText;
          this.profilesOffset = props && props.profilesOffset;
          this.fromEventId = props && props.fromEventId;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            const oneOfMutex = {};

            if (msg.searchText != null) {
              if (typeof msg.searchText !== 'string') {
                errors.field('searchText').error('string expected');
              }
            }
            if (msg.profilesOffset != null) {
              if (oneOfMutex['Offset']) {
                errors.field('profilesOffset').up().field('Offset').error('multiple values');
              } else {
                oneOfMutex['Offset'] = true;
                if (!Number.isInteger(msg.profilesOffset) || msg.profilesOffset < 0) {
                  errors.field('profilesOffset').error('non-negative integer expected');
                }
              }
            }
            if (msg.fromEventId != null) {
              if (oneOfMutex['Offset']) {
                errors.field('fromEventId').up().field('Offset').error('multiple values');
              } else {
                oneOfMutex['Offset'] = true;
                if (!((Number.isInteger(msg.fromEventId) || Long.isLong(msg.fromEventId)) && Long.fromValue(msg.fromEventId).greaterThanOrEqual(0))) {
                  errors.field('fromEventId').error('non-negative long or integer expected');
                }
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.searchText != null) {
              json.searchText = obj.searchText;
            }
            if (obj.profilesOffset != null) {
              json.profilesOffset = obj.profilesOffset;
            }
            if (obj.fromEventId != null) {
              json.fromEventId = obj.fromEventId.toString();
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.social.ProfilesPageCursor();

          if (json.searchText != null) {
            result.searchText = json.searchText;
          } else {
            result.searchText = '';
          }
          if (json.profilesOffset != null) {
            result.profilesOffset = json.profilesOffset;
          } else {
            delete result.profilesOffset;
          }
          if (json.fromEventId != null) {
            result.fromEventId = Long.fromValue(json.fromEventId);
          } else {
            delete result.fromEventId;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.searchText != null) {
              grpc.searchText = obj.searchText;
            }
            if (obj.profilesOffset != null) {
              grpc.profilesOffset = obj.profilesOffset;
            }
            if (obj.fromEventId != null) {
              grpc.fromEventId = obj.fromEventId.toString();
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.social.ProfilesPageCursor();

            if (grpc.searchText != null) {
              result.searchText = grpc.searchText;
            } else {
              result.searchText = '';
            }
            if (grpc.profilesOffset != null) {
              result.profilesOffset = grpc.profilesOffset;
            } else {
              delete result.profilesOffset;
            }
            if (grpc.fromEventId != null) {
              result.fromEventId = Long.fromValue(grpc.fromEventId);
            } else {
              delete result.fromEventId;
            }
            return result;
          }
        }

        static describe() {
          return {
            'oneofs': {
              'Offset': {
                'oneof': [
                  'profilesOffset',
                  'fromEventId'
                ]
              }
            },
            'fields': {
              'searchText': {
                'type': 'string',
                'id': 1
              },
              'profilesOffset': {
                'type': 'uint32',
                'id': 2
              },
              'fromEventId': {
                'type': 'uint64',
                'id': 3
              }
            }
          };
        }
      }

      Object.defineProperty(ProfilesPageCursor.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.social.ProfilesPageCursor');
        },
        enumerable: false,
        configurable: false
      });
      return ProfilesPageCursor;
    }());
    social.ProfilesService = (function() {

      class ProfilesService {

        constructor() {
          if (this.constructor.name === ProfilesService.name) {
            throw new TypeError('class ProfilesService is abstract');
          }
        }

        queryProfiles(aspects, msg) {
          throw new TypeError('method queryProfiles is abstract');
        }
      }

      ProfilesService.prototype.queryProfiles._messageTypes = function() {
        return [
          $root.wix.social.QueryProfilesRequest,
          $root.wix.social.QueryProfilesResponse
        ];
      };
      ProfilesService.prototype.queryProfiles.__proto = pbjs => {
        return $root.__lookup(pbjs)('wix.social.ProfilesService.QueryProfiles');
      };
      Object.defineProperty(ProfilesService.prototype, '__isRpcService__', {
        value: true,
        enumerable: false,
        configurable: false
      });
      Object.defineProperty(ProfilesService.prototype, '__fqn__', {
        value: 'wix.social.ProfilesService',
        enumerable: false,
        configurable: false
      });
      Object.defineProperty(ProfilesService.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.social.ProfilesService');
        },
        enumerable: false,
        configurable: false
      });
      Object.defineProperty(ProfilesService.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      return ProfilesService;
    }());
    social.QueryProfilesRequest = (function() {

      class QueryProfilesRequest {

        constructor(props) {
          this.mask = props && props.mask;
          this.contextToken = props && props.contextToken;
          this.query = props && props.query;
          this.paging = props && props.paging;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            const oneOfMutex = {};

            if (msg.mask != null) {
              $root.google.protobuf.FieldMask.verify(msg.mask, helper, errors.field('mask'));
            }
            if (msg.contextToken != null) {
              $root.google.protobuf.StringValue.verify(msg.contextToken, helper, errors.field('contextToken'));
            }
            if (msg.query != null) {
              if (oneOfMutex['Of']) {
                errors.field('query').up().field('Of').error('multiple values');
              } else {
                oneOfMutex['Of'] = true;
                $root.wix.social.SearchQuery.verify(msg.query, helper, errors.field('query'));
              }
            }
            if (msg.paging != null) {
              if (oneOfMutex['Of']) {
                errors.field('paging').up().field('Of').error('multiple values');
              } else {
                oneOfMutex['Of'] = true;
                $root.wix.common.CursorPaging.verify(msg.paging, helper, errors.field('paging'));
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.mask != null) {
              json.mask = $root.google.protobuf.FieldMask.toJSON(obj.mask, helper);
            }
            if (obj.contextToken != null) {
              json.contextToken = $root.google.protobuf.StringValue.toJSON(obj.contextToken, helper);
            }
            if (obj.query != null) {
              json.query = $root.wix.social.SearchQuery.toJSON(obj.query, helper);
            }
            if (obj.paging != null) {
              json.paging = $root.wix.common.CursorPaging.toJSON(obj.paging, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.social.QueryProfilesRequest();

          if (json.mask != null) {
            result.mask = $root.google.protobuf.FieldMask.fromJSON(json.mask, helper);
          } else {
            delete result.mask;
          }
          if (json.contextToken != null) {
            result.contextToken = $root.google.protobuf.StringValue.fromJSON(json.contextToken, helper);
          } else {
            delete result.contextToken;
          }
          if (json.query != null) {
            result.query = $root.wix.social.SearchQuery.fromJSON(json.query, helper);
          } else {
            delete result.query;
          }
          if (json.paging != null) {
            result.paging = $root.wix.common.CursorPaging.fromJSON(json.paging, helper);
          } else {
            delete result.paging;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.mask != null) {
              grpc.mask = $root.google.protobuf.FieldMask.toGRPC(obj.mask, helper);
            }
            if (obj.contextToken != null) {
              grpc.contextToken = $root.google.protobuf.StringValue.toGRPC(obj.contextToken, helper);
            }
            if (obj.query != null) {
              grpc.query = $root.wix.social.SearchQuery.toGRPC(obj.query, helper);
            }
            if (obj.paging != null) {
              grpc.paging = $root.wix.common.CursorPaging.toGRPC(obj.paging, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.social.QueryProfilesRequest();

            if (grpc.mask != null) {
              result.mask = $root.google.protobuf.FieldMask.fromGRPC(grpc.mask, helper);
            } else {
              delete result.mask;
            }
            if (grpc.contextToken != null) {
              result.contextToken = $root.google.protobuf.StringValue.fromGRPC(grpc.contextToken, helper);
            } else {
              delete result.contextToken;
            }
            if (grpc.query != null) {
              result.query = $root.wix.social.SearchQuery.fromGRPC(grpc.query, helper);
            } else {
              delete result.query;
            }
            if (grpc.paging != null) {
              result.paging = $root.wix.common.CursorPaging.fromGRPC(grpc.paging, helper);
            } else {
              delete result.paging;
            }
            return result;
          }
        }

        static describe() {
          return {
            'oneofs': {
              'Of': {
                'oneof': [
                  'query',
                  'paging'
                ]
              }
            },
            'fields': {
              'mask': {
                'type': $root.google.protobuf.FieldMask,
                'id': 1
              },
              'contextToken': {
                'type': $root.google.protobuf.StringValue,
                'id': 2
              },
              'query': {
                'type': $root.wix.social.SearchQuery,
                'id': 3
              },
              'paging': {
                'type': $root.wix.common.CursorPaging,
                'id': 4
              }
            }
          };
        }
      }

      Object.defineProperty(QueryProfilesRequest.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.social.QueryProfilesRequest');
        },
        enumerable: false,
        configurable: false
      });
      return QueryProfilesRequest;
    }());
    social.SearchQuery = (function() {

      class SearchQuery {

        constructor(props) {
          this.searchText = props && props.searchText;
          this.limit = props && props.limit;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.searchText != null) {
              if (typeof msg.searchText !== 'string') {
                errors.field('searchText').error('string expected');
              }
            }
            if (msg.limit != null) {
              $root.google.protobuf.Int32Value.verify(msg.limit, helper, errors.field('limit'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.searchText != null) {
              json.searchText = obj.searchText;
            }
            if (obj.limit != null) {
              json.limit = $root.google.protobuf.Int32Value.toJSON(obj.limit, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.social.SearchQuery();

          if (json.searchText != null) {
            result.searchText = json.searchText;
          } else {
            result.searchText = '';
          }
          if (json.limit != null) {
            result.limit = $root.google.protobuf.Int32Value.fromJSON(json.limit, helper);
          } else {
            delete result.limit;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.searchText != null) {
              grpc.searchText = obj.searchText;
            }
            if (obj.limit != null) {
              grpc.limit = $root.google.protobuf.Int32Value.toGRPC(obj.limit, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.social.SearchQuery();

            if (grpc.searchText != null) {
              result.searchText = grpc.searchText;
            } else {
              result.searchText = '';
            }
            if (grpc.limit != null) {
              result.limit = $root.google.protobuf.Int32Value.fromGRPC(grpc.limit, helper);
            } else {
              delete result.limit;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'searchText': {
                'type': 'string',
                'id': 1
              },
              'limit': {
                'type': $root.google.protobuf.Int32Value,
                'id': 2,
                'options': {
                  '(wix.api.min)': 0
                }
              }
            }
          };
        }
      }

      Object.defineProperty(SearchQuery.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.social.SearchQuery');
        },
        enumerable: false,
        configurable: false
      });
      return SearchQuery;
    }());
    social.QueryProfilesResponse = (function() {

      class QueryProfilesResponse {

        constructor(props) {
          this.profiles = props && props.profiles;
          this.nextCursor = props && props.nextCursor;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.profiles != null) {
              const fieldErrors = errors.field('profiles');

              if (!Array.isArray(msg.profiles)) {
                fieldErrors.error('array expected');
              } else {
                msg.profiles.forEach((value, index) => {
                  $root.wix.social.Profile.verify(value, helper, fieldErrors.index(index));
                });
              }
            }
            if (msg.nextCursor != null) {
              $root.google.protobuf.StringValue.verify(msg.nextCursor, helper, errors.field('nextCursor'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.profiles != null) {
              json.profiles = obj.profiles.map(e => {
                return $root.wix.social.Profile.toJSON(e, helper);
              });
            }
            if (obj.nextCursor != null) {
              json.nextCursor = $root.google.protobuf.StringValue.toJSON(obj.nextCursor, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.social.QueryProfilesResponse();

          if (json.profiles != null) {
            result.profiles = json.profiles.map(e => {
              return $root.wix.social.Profile.fromJSON(e, helper);
            });
          } else {
            result.profiles = [];
          }
          if (json.nextCursor != null) {
            result.nextCursor = $root.google.protobuf.StringValue.fromJSON(json.nextCursor, helper);
          } else {
            delete result.nextCursor;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.profiles != null) {
              grpc.profiles = obj.profiles.map(e => {
                return $root.wix.social.Profile.toGRPC(e, helper);
              });
            }
            if (obj.nextCursor != null) {
              grpc.nextCursor = $root.google.protobuf.StringValue.toGRPC(obj.nextCursor, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.social.QueryProfilesResponse();

            if (grpc.profiles != null) {
              result.profiles = grpc.profiles.map(e => {
                return $root.wix.social.Profile.fromGRPC(e, helper);
              });
            } else {
              result.profiles = [];
            }
            if (grpc.nextCursor != null) {
              result.nextCursor = $root.google.protobuf.StringValue.fromGRPC(grpc.nextCursor, helper);
            } else {
              delete result.nextCursor;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'profiles': {
                'rule': 'repeated',
                'type': $root.wix.social.Profile,
                'id': 1
              },
              'nextCursor': {
                'type': $root.google.protobuf.StringValue,
                'id': 2
              }
            }
          };
        }
      }

      Object.defineProperty(QueryProfilesResponse.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.social.QueryProfilesResponse');
        },
        enumerable: false,
        configurable: false
      });
      return QueryProfilesResponse;
    }());
    social.groups = (function() {
      const groups = {};

      groups.events = (function() {
        const events = {};

        events.api = (function() {
          const api = {};

          api.v1 = (function() {
            const v1 = {};

            v1.SocialGroupMembershipEventType = {
              verify: (value, helper, errors = helper.verification.Errors.empty()) => {
                switch (value) {
                  default: {
                    errors.error('enum expected');
                  }
                  case 'Approved':
                  case 'Added':
                    break;
                }
                return errors;
              },
              'Approved': 'Approved',
              'Added': 'Added'
            };
            v1.SocialGroupEventType = {
              verify: (value, helper, errors = helper.verification.Errors.empty()) => {
                switch (value) {
                  default: {
                    errors.error('enum expected');
                  }
                  case 'Created':
                    break;
                }
                return errors;
              },
              'Created': 'Created'
            };
            v1.SocialGroupMembershipEvent = (function() {

              class SocialGroupMembershipEvent {

                constructor(props) {
                  this.eventType = props && props.eventType;
                  this.siteMemberId = props && props.siteMemberId;
                  this.groupId = props && props.groupId;
                }

                static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                  if (typeof msg !== 'object' || msg == null) {
                    errors.error('object expected');
                  } else {
                    if (msg.eventType != null) {
                      $root.wix.social.groups.events.api.v1.SocialGroupMembershipEventType.verify(msg.eventType, helper, errors.field('eventType'));
                    }
                    if (msg.siteMemberId != null) {
                      if (typeof msg.siteMemberId !== 'string') {
                        errors.field('siteMemberId').error('string expected');
                      }
                    }
                    if (msg.groupId != null) {
                      if (typeof msg.groupId !== 'string') {
                        errors.field('groupId').error('string expected');
                      }
                    }
                  }
                  return errors;
                }

                static toJSON(obj, helper) {
                  if (obj == null) {
                    return null;
                  } else {
                    const json = {};

                    if (obj.eventType != null) {
                      json.eventType = $root.wix.social.groups.events.api.v1.SocialGroupMembershipEventType[obj.eventType];
                    }
                    if (obj.siteMemberId != null) {
                      json.siteMemberId = obj.siteMemberId;
                    }
                    if (obj.groupId != null) {
                      json.groupId = obj.groupId;
                    }
                    return json;
                  }
                }

                static fromJSON(json, helper) {
                  const result = new $root.wix.social.groups.events.api.v1.SocialGroupMembershipEvent();

                  if (json.eventType != null) {
                    result.eventType = $root.wix.social.groups.events.api.v1.SocialGroupMembershipEventType[json.eventType];
                  } else {
                    result.eventType = 'Approved';
                  }
                  if (json.siteMemberId != null) {
                    result.siteMemberId = json.siteMemberId;
                  } else {
                    result.siteMemberId = '';
                  }
                  if (json.groupId != null) {
                    result.groupId = json.groupId;
                  } else {
                    result.groupId = '';
                  }
                  return result;
                }

                static toGRPC(obj, helper) {
                  if (obj == null) {
                    return null;
                  } else {
                    const grpc = {};

                    if (obj.eventType != null) {
                      grpc.eventType = obj.eventType;
                    }
                    if (obj.siteMemberId != null) {
                      grpc.siteMemberId = obj.siteMemberId;
                    }
                    if (obj.groupId != null) {
                      grpc.groupId = obj.groupId;
                    }
                    return grpc;
                  }
                }

                static fromGRPC(grpc, helper) {
                  if (grpc == null) {
                    return null;
                  } else {
                    const result = new $root.wix.social.groups.events.api.v1.SocialGroupMembershipEvent();

                    if (grpc.eventType != null) {
                      result.eventType = grpc.eventType;
                    } else {
                      result.eventType = 'Approved';
                    }
                    if (grpc.siteMemberId != null) {
                      result.siteMemberId = grpc.siteMemberId;
                    } else {
                      result.siteMemberId = '';
                    }
                    if (grpc.groupId != null) {
                      result.groupId = grpc.groupId;
                    } else {
                      result.groupId = '';
                    }
                    return result;
                  }
                }

                static describe() {
                  return {
                    'fields': {
                      'eventType': {
                        'type': $root.wix.social.groups.events.api.v1.SocialGroupMembershipEventType,
                        'id': 1
                      },
                      'siteMemberId': {
                        'type': 'string',
                        'id': 2,
                        'options': {
                          '(wix.api.format)': 'GUID'
                        }
                      },
                      'groupId': {
                        'type': 'string',
                        'id': 3,
                        'options': {
                          '(wix.api.format)': 'GUID'
                        }
                      }
                    }
                  };
                }
              }

              Object.defineProperty(SocialGroupMembershipEvent.prototype, '__proto', {
                value: pbjs => {
                  return $root.__lookup(pbjs)('wix.social.groups.events.api.v1.SocialGroupMembershipEvent');
                },
                enumerable: false,
                configurable: false
              });
              return SocialGroupMembershipEvent;
            }());
            v1.SocialGroupEvent = (function() {

              class SocialGroupEvent {

                constructor(props) {
                  this.eventType = props && props.eventType;
                  this.siteMemberId = props && props.siteMemberId;
                  this.groupId = props && props.groupId;
                }

                static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                  if (typeof msg !== 'object' || msg == null) {
                    errors.error('object expected');
                  } else {
                    if (msg.eventType != null) {
                      $root.wix.social.groups.events.api.v1.SocialGroupEventType.verify(msg.eventType, helper, errors.field('eventType'));
                    }
                    if (msg.siteMemberId != null) {
                      if (typeof msg.siteMemberId !== 'string') {
                        errors.field('siteMemberId').error('string expected');
                      }
                    }
                    if (msg.groupId != null) {
                      if (typeof msg.groupId !== 'string') {
                        errors.field('groupId').error('string expected');
                      }
                    }
                  }
                  return errors;
                }

                static toJSON(obj, helper) {
                  if (obj == null) {
                    return null;
                  } else {
                    const json = {};

                    if (obj.eventType != null) {
                      json.eventType = $root.wix.social.groups.events.api.v1.SocialGroupEventType[obj.eventType];
                    }
                    if (obj.siteMemberId != null) {
                      json.siteMemberId = obj.siteMemberId;
                    }
                    if (obj.groupId != null) {
                      json.groupId = obj.groupId;
                    }
                    return json;
                  }
                }

                static fromJSON(json, helper) {
                  const result = new $root.wix.social.groups.events.api.v1.SocialGroupEvent();

                  if (json.eventType != null) {
                    result.eventType = $root.wix.social.groups.events.api.v1.SocialGroupEventType[json.eventType];
                  } else {
                    result.eventType = 'Created';
                  }
                  if (json.siteMemberId != null) {
                    result.siteMemberId = json.siteMemberId;
                  } else {
                    result.siteMemberId = '';
                  }
                  if (json.groupId != null) {
                    result.groupId = json.groupId;
                  } else {
                    result.groupId = '';
                  }
                  return result;
                }

                static toGRPC(obj, helper) {
                  if (obj == null) {
                    return null;
                  } else {
                    const grpc = {};

                    if (obj.eventType != null) {
                      grpc.eventType = obj.eventType;
                    }
                    if (obj.siteMemberId != null) {
                      grpc.siteMemberId = obj.siteMemberId;
                    }
                    if (obj.groupId != null) {
                      grpc.groupId = obj.groupId;
                    }
                    return grpc;
                  }
                }

                static fromGRPC(grpc, helper) {
                  if (grpc == null) {
                    return null;
                  } else {
                    const result = new $root.wix.social.groups.events.api.v1.SocialGroupEvent();

                    if (grpc.eventType != null) {
                      result.eventType = grpc.eventType;
                    } else {
                      result.eventType = 'Created';
                    }
                    if (grpc.siteMemberId != null) {
                      result.siteMemberId = grpc.siteMemberId;
                    } else {
                      result.siteMemberId = '';
                    }
                    if (grpc.groupId != null) {
                      result.groupId = grpc.groupId;
                    } else {
                      result.groupId = '';
                    }
                    return result;
                  }
                }

                static describe() {
                  return {
                    'fields': {
                      'eventType': {
                        'type': $root.wix.social.groups.events.api.v1.SocialGroupEventType,
                        'id': 1
                      },
                      'siteMemberId': {
                        'type': 'string',
                        'id': 2,
                        'options': {
                          '(wix.api.format)': 'GUID'
                        }
                      },
                      'groupId': {
                        'type': 'string',
                        'id': 3,
                        'options': {
                          '(wix.api.format)': 'GUID'
                        }
                      }
                    }
                  };
                }
              }

              Object.defineProperty(SocialGroupEvent.prototype, '__proto', {
                value: pbjs => {
                  return $root.__lookup(pbjs)('wix.social.groups.events.api.v1.SocialGroupEvent');
                },
                enumerable: false,
                configurable: false
              });
              return SocialGroupEvent;
            }());
            return v1;
          }());
          return api;
        }());
        return events;
      }());
      groups.api = (function() {
        const api = {};

        api.v1 = (function() {
          const v1 = {};

          v1.GroupApp = (function() {

            class GroupApp {

              constructor(props) {
                this.key = props && props.key;
                this.installed = props && props.installed;
                this.customName = props && props.customName;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.key != null) {
                    $root.wix.social.groups.api.v1.GroupAppKey.verify(msg.key, helper, errors.field('key'));
                  }
                  if (msg.installed != null) {
                    if (typeof msg.installed !== 'boolean') {
                      errors.field('installed').error('boolean expected');
                    }
                  }
                  if (msg.customName != null) {
                    $root.google.protobuf.StringValue.verify(msg.customName, helper, errors.field('customName'));
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.key != null) {
                    json.key = $root.wix.social.groups.api.v1.GroupAppKey[obj.key];
                  }
                  if (obj.installed != null) {
                    json.installed = obj.installed;
                  }
                  if (obj.customName != null) {
                    json.customName = $root.google.protobuf.StringValue.toJSON(obj.customName, helper);
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.wix.social.groups.api.v1.GroupApp();

                if (json.key != null) {
                  result.key = $root.wix.social.groups.api.v1.GroupAppKey[json.key];
                } else {
                  result.key = 'MEMBERS_APP';
                }
                if (json.installed != null) {
                  result.installed = json.installed;
                } else {
                  result.installed = false;
                }
                if (json.customName != null) {
                  result.customName = $root.google.protobuf.StringValue.fromJSON(json.customName, helper);
                } else {
                  delete result.customName;
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.key != null) {
                    grpc.key = obj.key;
                  }
                  if (obj.installed != null) {
                    grpc.installed = obj.installed;
                  }
                  if (obj.customName != null) {
                    grpc.customName = $root.google.protobuf.StringValue.toGRPC(obj.customName, helper);
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.wix.social.groups.api.v1.GroupApp();

                  if (grpc.key != null) {
                    result.key = grpc.key;
                  } else {
                    result.key = 'MEMBERS_APP';
                  }
                  if (grpc.installed != null) {
                    result.installed = grpc.installed;
                  } else {
                    result.installed = false;
                  }
                  if (grpc.customName != null) {
                    result.customName = $root.google.protobuf.StringValue.fromGRPC(grpc.customName, helper);
                  } else {
                    delete result.customName;
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'key': {
                      'type': $root.wix.social.groups.api.v1.GroupAppKey,
                      'id': 1
                    },
                    'installed': {
                      'type': 'bool',
                      'id': 2
                    },
                    'customName': {
                      'type': $root.google.protobuf.StringValue,
                      'id': 3,
                      'options': {
                        '(wix.api.minLength)': 1,
                        '(wix.api.maxLength)': 100
                      }
                    }
                  }
                };
              }
            }

            Object.defineProperty(GroupApp.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.GroupApp');
              },
              enumerable: false,
              configurable: false
            });
            return GroupApp;
          }());
          v1.ConfigureAppsRequest = (function() {

            class ConfigureAppsRequest {

              constructor(props) {
                this.groupId = props && props.groupId;
                this.apps = props && props.apps;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.groupId != null) {
                    if (typeof msg.groupId !== 'string') {
                      errors.field('groupId').error('string expected');
                    }
                  }
                  if (msg.apps != null) {
                    const fieldErrors = errors.field('apps');

                    if (!Array.isArray(msg.apps)) {
                      fieldErrors.error('array expected');
                    } else {
                      msg.apps.forEach((value, index) => {
                        $root.wix.social.groups.api.v1.GroupApp.verify(value, helper, fieldErrors.index(index));
                      });
                    }
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.groupId != null) {
                    json.groupId = obj.groupId;
                  }
                  if (obj.apps != null) {
                    json.apps = obj.apps.map(e => {
                      return $root.wix.social.groups.api.v1.GroupApp.toJSON(e, helper);
                    });
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.wix.social.groups.api.v1.ConfigureAppsRequest();

                if (json.groupId != null) {
                  result.groupId = json.groupId;
                } else {
                  result.groupId = '';
                }
                if (json.apps != null) {
                  result.apps = json.apps.map(e => {
                    return $root.wix.social.groups.api.v1.GroupApp.fromJSON(e, helper);
                  });
                } else {
                  result.apps = [];
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.groupId != null) {
                    grpc.groupId = obj.groupId;
                  }
                  if (obj.apps != null) {
                    grpc.apps = obj.apps.map(e => {
                      return $root.wix.social.groups.api.v1.GroupApp.toGRPC(e, helper);
                    });
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.wix.social.groups.api.v1.ConfigureAppsRequest();

                  if (grpc.groupId != null) {
                    result.groupId = grpc.groupId;
                  } else {
                    result.groupId = '';
                  }
                  if (grpc.apps != null) {
                    result.apps = grpc.apps.map(e => {
                      return $root.wix.social.groups.api.v1.GroupApp.fromGRPC(e, helper);
                    });
                  } else {
                    result.apps = [];
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'groupId': {
                      'type': 'string',
                      'id': 1,
                      'options': {
                        '(wix.api.format)': 'GUID'
                      }
                    },
                    'apps': {
                      'rule': 'repeated',
                      'type': $root.wix.social.groups.api.v1.GroupApp,
                      'id': 2,
                      'options': {
                        '(wix.api.minSize)': 1,
                        '(wix.api.maxSize)': 50
                      }
                    }
                  }
                };
              }
            }

            Object.defineProperty(ConfigureAppsRequest.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.ConfigureAppsRequest');
              },
              enumerable: false,
              configurable: false
            });
            return ConfigureAppsRequest;
          }());
          v1.ListAppsRequest = (function() {

            class ListAppsRequest {

              constructor(props) {
                this.groupId = props && props.groupId;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.groupId != null) {
                    if (typeof msg.groupId !== 'string') {
                      errors.field('groupId').error('string expected');
                    }
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.groupId != null) {
                    json.groupId = obj.groupId;
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.wix.social.groups.api.v1.ListAppsRequest();

                if (json.groupId != null) {
                  result.groupId = json.groupId;
                } else {
                  result.groupId = '';
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.groupId != null) {
                    grpc.groupId = obj.groupId;
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.wix.social.groups.api.v1.ListAppsRequest();

                  if (grpc.groupId != null) {
                    result.groupId = grpc.groupId;
                  } else {
                    result.groupId = '';
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'groupId': {
                      'type': 'string',
                      'id': 1,
                      'options': {
                        '(wix.api.format)': 'GUID'
                      }
                    }
                  }
                };
              }
            }

            Object.defineProperty(ListAppsRequest.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.ListAppsRequest');
              },
              enumerable: false,
              configurable: false
            });
            return ListAppsRequest;
          }());
          v1.ListGroupAppsResponse = (function() {

            class ListGroupAppsResponse {

              constructor(props) {
                this.apps = props && props.apps;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.apps != null) {
                    const fieldErrors = errors.field('apps');

                    if (!Array.isArray(msg.apps)) {
                      fieldErrors.error('array expected');
                    } else {
                      msg.apps.forEach((value, index) => {
                        $root.wix.social.groups.api.v1.GroupApp.verify(value, helper, fieldErrors.index(index));
                      });
                    }
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.apps != null) {
                    json.apps = obj.apps.map(e => {
                      return $root.wix.social.groups.api.v1.GroupApp.toJSON(e, helper);
                    });
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.wix.social.groups.api.v1.ListGroupAppsResponse();

                if (json.apps != null) {
                  result.apps = json.apps.map(e => {
                    return $root.wix.social.groups.api.v1.GroupApp.fromJSON(e, helper);
                  });
                } else {
                  result.apps = [];
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.apps != null) {
                    grpc.apps = obj.apps.map(e => {
                      return $root.wix.social.groups.api.v1.GroupApp.toGRPC(e, helper);
                    });
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.wix.social.groups.api.v1.ListGroupAppsResponse();

                  if (grpc.apps != null) {
                    result.apps = grpc.apps.map(e => {
                      return $root.wix.social.groups.api.v1.GroupApp.fromGRPC(e, helper);
                    });
                  } else {
                    result.apps = [];
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'apps': {
                      'rule': 'repeated',
                      'type': $root.wix.social.groups.api.v1.GroupApp,
                      'id': 1
                    }
                  }
                };
              }
            }

            Object.defineProperty(ListGroupAppsResponse.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.ListGroupAppsResponse');
              },
              enumerable: false,
              configurable: false
            });
            return ListGroupAppsResponse;
          }());
          v1.SocialGroupsAppsService = (function() {

            class SocialGroupsAppsService {

              constructor() {
                if (this.constructor.name === SocialGroupsAppsService.name) {
                  throw new TypeError('class SocialGroupsAppsService is abstract');
                }
              }

              configureApps(aspects, msg) {
                throw new TypeError('method configureApps is abstract');
              }

              listApps(aspects, msg) {
                throw new TypeError('method listApps is abstract');
              }
            }

            SocialGroupsAppsService.prototype.configureApps._messageTypes = function() {
              return [
                $root.wix.social.groups.api.v1.ConfigureAppsRequest,
                $root.google.protobuf.Empty
              ];
            };
            SocialGroupsAppsService.prototype.listApps._messageTypes = function() {
              return [
                $root.wix.social.groups.api.v1.ListAppsRequest,
                $root.wix.social.groups.api.v1.ListGroupAppsResponse
              ];
            };
            SocialGroupsAppsService.prototype.configureApps.__proto = pbjs => {
              return $root.__lookup(pbjs)('wix.social.groups.api.v1.SocialGroupsAppsService.ConfigureApps');
            };
            SocialGroupsAppsService.prototype.listApps.__proto = pbjs => {
              return $root.__lookup(pbjs)('wix.social.groups.api.v1.SocialGroupsAppsService.ListApps');
            };
            Object.defineProperty(SocialGroupsAppsService.prototype, '__isRpcService__', {
              value: true,
              enumerable: false,
              configurable: false
            });
            Object.defineProperty(SocialGroupsAppsService.prototype, '__fqn__', {
              value: 'wix.social.groups.api.v1.SocialGroupsAppsService',
              enumerable: false,
              configurable: false
            });
            Object.defineProperty(SocialGroupsAppsService.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.SocialGroupsAppsService');
              },
              enumerable: false,
              configurable: false
            });
            Object.defineProperty(SocialGroupsAppsService.prototype, '__options__', {
              value: $root.__options,
              enumerable: false,
              configurable: false
            });
            return SocialGroupsAppsService;
          }());
          v1.GroupPrivacyLevel = {
            verify: (value, helper, errors = helper.verification.Errors.empty()) => {
              switch (value) {
                default: {
                  errors.error('enum expected');
                }
                case 'SECRET':
                case 'PRIVATE':
                case 'PUBLIC':
                  break;
              }
              return errors;
            },
            'SECRET': 'SECRET',
            'PRIVATE': 'PRIVATE',
            'PUBLIC': 'PUBLIC'
          };
          v1.RelationshipWithGroup = {
            verify: (value, helper, errors = helper.verification.Errors.empty()) => {
              switch (value) {
                default: {
                  errors.error('enum expected');
                }
                case 'NONE':
                case 'JOINED':
                case 'PENDING_APPROVAL':
                case 'REJECTED_MEMBERSHIP':
                  break;
              }
              return errors;
            },
            'NONE': 'NONE',
            'JOINED': 'JOINED',
            'PENDING_APPROVAL': 'PENDING_APPROVAL',
            'REJECTED_MEMBERSHIP': 'REJECTED_MEMBERSHIP'
          };
          v1.RoleInGroup = {
            verify: (value, helper, errors = helper.verification.Errors.empty()) => {
              switch (value) {
                default: {
                  errors.error('enum expected');
                }
                case 'GROUP_MEMBER':
                case 'GROUP_MODERATOR':
                case 'GROUP_ADMIN':
                  break;
              }
              return errors;
            },
            'GROUP_MEMBER': 'GROUP_MEMBER',
            'GROUP_MODERATOR': 'GROUP_MODERATOR',
            'GROUP_ADMIN': 'GROUP_ADMIN'
          };
          v1.GroupAppKey = {
            verify: (value, helper, errors = helper.verification.Errors.empty()) => {
              switch (value) {
                default: {
                  errors.error('enum expected');
                }
                case 'MEMBERS_APP':
                case 'FEED_APP':
                case 'ABOUT_APP':
                case 'GALLERY_APP':
                  break;
              }
              return errors;
            },
            'MEMBERS_APP': 'MEMBERS_APP',
            'FEED_APP': 'FEED_APP',
            'ABOUT_APP': 'ABOUT_APP',
            'GALLERY_APP': 'GALLERY_APP'
          };
          v1.GroupsSortBy = {
            verify: (value, helper, errors = helper.verification.Errors.empty()) => {
              switch (value) {
                default: {
                  errors.error('enum expected');
                }
                case 'DEFAULT':
                case 'RECENT_ACTIVITY':
                case 'NAME':
                case 'MEMBERS_COUNT':
                  break;
              }
              return errors;
            },
            'DEFAULT': 'DEFAULT',
            'RECENT_ACTIVITY': 'RECENT_ACTIVITY',
            'NAME': 'NAME',
            'MEMBERS_COUNT': 'MEMBERS_COUNT'
          };
          v1.CreateGroupsPolicy = {
            verify: (value, helper, errors = helper.verification.Errors.empty()) => {
              switch (value) {
                default: {
                  errors.error('enum expected');
                }
                case 'ONLY_ME':
                case 'MEMBERS':
                case 'MEMBERS_WITH_MY_APPROVAL':
                  break;
              }
              return errors;
            },
            'ONLY_ME': 'ONLY_ME',
            'MEMBERS': 'MEMBERS',
            'MEMBERS_WITH_MY_APPROVAL': 'MEMBERS_WITH_MY_APPROVAL'
          };
          v1.GroupApprovalStatus = {
            verify: (value, helper, errors = helper.verification.Errors.empty()) => {
              switch (value) {
                default: {
                  errors.error('enum expected');
                }
                case 'EMPTY':
                case 'PENDING':
                case 'APPROVED':
                case 'REJECTED':
                case 'CANCELLED':
                  break;
              }
              return errors;
            },
            'EMPTY': 'EMPTY',
            'PENDING': 'PENDING',
            'APPROVED': 'APPROVED',
            'REJECTED': 'REJECTED',
            'CANCELLED': 'CANCELLED'
          };
          v1.GroupsInstanceSettings = (function() {

            class GroupsInstanceSettings {

              constructor(props) {
                this.allowMembersCreateGroups = props && props.allowMembersCreateGroups;
                this.groupsSortBy = props && props.groupsSortBy;
                this.createGroupPolicy = props && props.createGroupPolicy;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.allowMembersCreateGroups != null) {
                    if (typeof msg.allowMembersCreateGroups !== 'boolean') {
                      errors.field('allowMembersCreateGroups').error('boolean expected');
                    }
                  }
                  if (msg.groupsSortBy != null) {
                    $root.wix.social.groups.api.v1.GroupsSortBy.verify(msg.groupsSortBy, helper, errors.field('groupsSortBy'));
                  }
                  if (msg.createGroupPolicy != null) {
                    $root.wix.social.groups.api.v1.CreateGroupsPolicy.verify(msg.createGroupPolicy, helper, errors.field('createGroupPolicy'));
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.allowMembersCreateGroups != null) {
                    json.allowMembersCreateGroups = obj.allowMembersCreateGroups;
                  }
                  if (obj.groupsSortBy != null) {
                    json.groupsSortBy = $root.wix.social.groups.api.v1.GroupsSortBy[obj.groupsSortBy];
                  }
                  if (obj.createGroupPolicy != null) {
                    json.createGroupPolicy = $root.wix.social.groups.api.v1.CreateGroupsPolicy[obj.createGroupPolicy];
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.wix.social.groups.api.v1.GroupsInstanceSettings();

                if (json.allowMembersCreateGroups != null) {
                  result.allowMembersCreateGroups = json.allowMembersCreateGroups;
                } else {
                  result.allowMembersCreateGroups = false;
                }
                if (json.groupsSortBy != null) {
                  result.groupsSortBy = $root.wix.social.groups.api.v1.GroupsSortBy[json.groupsSortBy];
                } else {
                  result.groupsSortBy = 'DEFAULT';
                }
                if (json.createGroupPolicy != null) {
                  result.createGroupPolicy = $root.wix.social.groups.api.v1.CreateGroupsPolicy[json.createGroupPolicy];
                } else {
                  result.createGroupPolicy = 'ONLY_ME';
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.allowMembersCreateGroups != null) {
                    grpc.allowMembersCreateGroups = obj.allowMembersCreateGroups;
                  }
                  if (obj.groupsSortBy != null) {
                    grpc.groupsSortBy = obj.groupsSortBy;
                  }
                  if (obj.createGroupPolicy != null) {
                    grpc.createGroupPolicy = obj.createGroupPolicy;
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.wix.social.groups.api.v1.GroupsInstanceSettings();

                  if (grpc.allowMembersCreateGroups != null) {
                    result.allowMembersCreateGroups = grpc.allowMembersCreateGroups;
                  } else {
                    result.allowMembersCreateGroups = false;
                  }
                  if (grpc.groupsSortBy != null) {
                    result.groupsSortBy = grpc.groupsSortBy;
                  } else {
                    result.groupsSortBy = 'DEFAULT';
                  }
                  if (grpc.createGroupPolicy != null) {
                    result.createGroupPolicy = grpc.createGroupPolicy;
                  } else {
                    result.createGroupPolicy = 'ONLY_ME';
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'allowMembersCreateGroups': {
                      'type': 'bool',
                      'id': 1
                    },
                    'groupsSortBy': {
                      'type': $root.wix.social.groups.api.v1.GroupsSortBy,
                      'id': 2
                    },
                    'createGroupPolicy': {
                      'type': $root.wix.social.groups.api.v1.CreateGroupsPolicy,
                      'id': 3
                    }
                  }
                };
              }
            }

            Object.defineProperty(GroupsInstanceSettings.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.GroupsInstanceSettings');
              },
              enumerable: false,
              configurable: false
            });
            return GroupsInstanceSettings;
          }());
          v1.GroupDetails = (function() {

            class GroupDetails {

              constructor(props) {
                this.title = props && props.title;
                this.description = props && props.description;
                this.imageUrl = props && props.imageUrl;
                this.logoUrl = props && props.logoUrl;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.title != null) {
                    $root.google.protobuf.StringValue.verify(msg.title, helper, errors.field('title'));
                  }
                  if (msg.description != null) {
                    $root.google.protobuf.StringValue.verify(msg.description, helper, errors.field('description'));
                  }
                  if (msg.imageUrl != null) {
                    $root.google.protobuf.StringValue.verify(msg.imageUrl, helper, errors.field('imageUrl'));
                  }
                  if (msg.logoUrl != null) {
                    $root.google.protobuf.StringValue.verify(msg.logoUrl, helper, errors.field('logoUrl'));
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.title != null) {
                    json.title = $root.google.protobuf.StringValue.toJSON(obj.title, helper);
                  }
                  if (obj.description != null) {
                    json.description = $root.google.protobuf.StringValue.toJSON(obj.description, helper);
                  }
                  if (obj.imageUrl != null) {
                    json.imageUrl = $root.google.protobuf.StringValue.toJSON(obj.imageUrl, helper);
                  }
                  if (obj.logoUrl != null) {
                    json.logoUrl = $root.google.protobuf.StringValue.toJSON(obj.logoUrl, helper);
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.wix.social.groups.api.v1.GroupDetails();

                if (json.title != null) {
                  result.title = $root.google.protobuf.StringValue.fromJSON(json.title, helper);
                } else {
                  delete result.title;
                }
                if (json.description != null) {
                  result.description = $root.google.protobuf.StringValue.fromJSON(json.description, helper);
                } else {
                  delete result.description;
                }
                if (json.imageUrl != null) {
                  result.imageUrl = $root.google.protobuf.StringValue.fromJSON(json.imageUrl, helper);
                } else {
                  delete result.imageUrl;
                }
                if (json.logoUrl != null) {
                  result.logoUrl = $root.google.protobuf.StringValue.fromJSON(json.logoUrl, helper);
                } else {
                  delete result.logoUrl;
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.title != null) {
                    grpc.title = $root.google.protobuf.StringValue.toGRPC(obj.title, helper);
                  }
                  if (obj.description != null) {
                    grpc.description = $root.google.protobuf.StringValue.toGRPC(obj.description, helper);
                  }
                  if (obj.imageUrl != null) {
                    grpc.imageUrl = $root.google.protobuf.StringValue.toGRPC(obj.imageUrl, helper);
                  }
                  if (obj.logoUrl != null) {
                    grpc.logoUrl = $root.google.protobuf.StringValue.toGRPC(obj.logoUrl, helper);
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.wix.social.groups.api.v1.GroupDetails();

                  if (grpc.title != null) {
                    result.title = $root.google.protobuf.StringValue.fromGRPC(grpc.title, helper);
                  } else {
                    delete result.title;
                  }
                  if (grpc.description != null) {
                    result.description = $root.google.protobuf.StringValue.fromGRPC(grpc.description, helper);
                  } else {
                    delete result.description;
                  }
                  if (grpc.imageUrl != null) {
                    result.imageUrl = $root.google.protobuf.StringValue.fromGRPC(grpc.imageUrl, helper);
                  } else {
                    delete result.imageUrl;
                  }
                  if (grpc.logoUrl != null) {
                    result.logoUrl = $root.google.protobuf.StringValue.fromGRPC(grpc.logoUrl, helper);
                  } else {
                    delete result.logoUrl;
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'title': {
                      'type': $root.google.protobuf.StringValue,
                      'id': 1,
                      'options': {
                        '(wix.api.minLength)': 1,
                        '(wix.api.maxLength)': 100
                      }
                    },
                    'description': {
                      'type': $root.google.protobuf.StringValue,
                      'id': 2,
                      'options': {
                        '(wix.api.maxLength)': 1000
                      }
                    },
                    'imageUrl': {
                      'type': $root.google.protobuf.StringValue,
                      'id': 3,
                      'options': {
                        '(wix.api.minLength)': 1,
                        '(wix.api.maxLength)': 1000
                      }
                    },
                    'logoUrl': {
                      'type': $root.google.protobuf.StringValue,
                      'id': 4,
                      'options': {
                        '(wix.api.minLength)': 1,
                        '(wix.api.maxLength)': 1000
                      }
                    }
                  }
                };
              }
            }

            Object.defineProperty(GroupDetails.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.GroupDetails');
              },
              enumerable: false,
              configurable: false
            });
            return GroupDetails;
          }());
          v1.GroupRequestDetails = (function() {

            class GroupRequestDetails {

              constructor(props) {
                this.description = props && props.description;
                this.rejectionReason = props && props.rejectionReason;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.description != null) {
                    $root.google.protobuf.StringValue.verify(msg.description, helper, errors.field('description'));
                  }
                  if (msg.rejectionReason != null) {
                    $root.google.protobuf.StringValue.verify(msg.rejectionReason, helper, errors.field('rejectionReason'));
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.description != null) {
                    json.description = $root.google.protobuf.StringValue.toJSON(obj.description, helper);
                  }
                  if (obj.rejectionReason != null) {
                    json.rejectionReason = $root.google.protobuf.StringValue.toJSON(obj.rejectionReason, helper);
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.wix.social.groups.api.v1.GroupRequestDetails();

                if (json.description != null) {
                  result.description = $root.google.protobuf.StringValue.fromJSON(json.description, helper);
                } else {
                  delete result.description;
                }
                if (json.rejectionReason != null) {
                  result.rejectionReason = $root.google.protobuf.StringValue.fromJSON(json.rejectionReason, helper);
                } else {
                  delete result.rejectionReason;
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.description != null) {
                    grpc.description = $root.google.protobuf.StringValue.toGRPC(obj.description, helper);
                  }
                  if (obj.rejectionReason != null) {
                    grpc.rejectionReason = $root.google.protobuf.StringValue.toGRPC(obj.rejectionReason, helper);
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.wix.social.groups.api.v1.GroupRequestDetails();

                  if (grpc.description != null) {
                    result.description = $root.google.protobuf.StringValue.fromGRPC(grpc.description, helper);
                  } else {
                    delete result.description;
                  }
                  if (grpc.rejectionReason != null) {
                    result.rejectionReason = $root.google.protobuf.StringValue.fromGRPC(grpc.rejectionReason, helper);
                  } else {
                    delete result.rejectionReason;
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'description': {
                      'type': $root.google.protobuf.StringValue,
                      'id': 1,
                      'options': {
                        '(wix.api.minLength)': 1,
                        '(wix.api.maxLength)': 1000
                      }
                    },
                    'rejectionReason': {
                      'type': $root.google.protobuf.StringValue,
                      'id': 2,
                      'options': {
                        '(wix.api.minLength)': 1,
                        '(wix.api.maxLength)': 1000
                      }
                    }
                  }
                };
              }
            }

            Object.defineProperty(GroupRequestDetails.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.GroupRequestDetails');
              },
              enumerable: false,
              configurable: false
            });
            return GroupRequestDetails;
          }());
          v1.GroupSettings = (function() {

            class GroupSettings {

              constructor(props) {
                this.privacyLevel = props && props.privacyLevel;
                this.permittedToInviteMembers = props && props.permittedToInviteMembers;
                this.permittedToApproveMembers = props && props.permittedToApproveMembers;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.privacyLevel != null) {
                    $root.wix.social.groups.api.v1.GroupPrivacyLevel.verify(msg.privacyLevel, helper, errors.field('privacyLevel'));
                  }
                  if (msg.permittedToInviteMembers != null) {
                    $root.wix.social.groups.api.v1.RoleInGroup.verify(msg.permittedToInviteMembers, helper, errors.field('permittedToInviteMembers'));
                  }
                  if (msg.permittedToApproveMembers != null) {
                    $root.wix.social.groups.api.v1.RoleInGroup.verify(msg.permittedToApproveMembers, helper, errors.field('permittedToApproveMembers'));
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.privacyLevel != null) {
                    json.privacyLevel = $root.wix.social.groups.api.v1.GroupPrivacyLevel[obj.privacyLevel];
                  }
                  if (obj.permittedToInviteMembers != null) {
                    json.permittedToInviteMembers = $root.wix.social.groups.api.v1.RoleInGroup[obj.permittedToInviteMembers];
                  }
                  if (obj.permittedToApproveMembers != null) {
                    json.permittedToApproveMembers = $root.wix.social.groups.api.v1.RoleInGroup[obj.permittedToApproveMembers];
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.wix.social.groups.api.v1.GroupSettings();

                if (json.privacyLevel != null) {
                  result.privacyLevel = $root.wix.social.groups.api.v1.GroupPrivacyLevel[json.privacyLevel];
                } else {
                  result.privacyLevel = 'SECRET';
                }
                if (json.permittedToInviteMembers != null) {
                  result.permittedToInviteMembers = $root.wix.social.groups.api.v1.RoleInGroup[json.permittedToInviteMembers];
                } else {
                  result.permittedToInviteMembers = 'GROUP_MEMBER';
                }
                if (json.permittedToApproveMembers != null) {
                  result.permittedToApproveMembers = $root.wix.social.groups.api.v1.RoleInGroup[json.permittedToApproveMembers];
                } else {
                  result.permittedToApproveMembers = 'GROUP_MEMBER';
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.privacyLevel != null) {
                    grpc.privacyLevel = obj.privacyLevel;
                  }
                  if (obj.permittedToInviteMembers != null) {
                    grpc.permittedToInviteMembers = obj.permittedToInviteMembers;
                  }
                  if (obj.permittedToApproveMembers != null) {
                    grpc.permittedToApproveMembers = obj.permittedToApproveMembers;
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.wix.social.groups.api.v1.GroupSettings();

                  if (grpc.privacyLevel != null) {
                    result.privacyLevel = grpc.privacyLevel;
                  } else {
                    result.privacyLevel = 'SECRET';
                  }
                  if (grpc.permittedToInviteMembers != null) {
                    result.permittedToInviteMembers = grpc.permittedToInviteMembers;
                  } else {
                    result.permittedToInviteMembers = 'GROUP_MEMBER';
                  }
                  if (grpc.permittedToApproveMembers != null) {
                    result.permittedToApproveMembers = grpc.permittedToApproveMembers;
                  } else {
                    result.permittedToApproveMembers = 'GROUP_MEMBER';
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'privacyLevel': {
                      'type': $root.wix.social.groups.api.v1.GroupPrivacyLevel,
                      'id': 1
                    },
                    'permittedToInviteMembers': {
                      'type': $root.wix.social.groups.api.v1.RoleInGroup,
                      'id': 2
                    },
                    'permittedToApproveMembers': {
                      'type': $root.wix.social.groups.api.v1.RoleInGroup,
                      'id': 3
                    }
                  }
                };
              }
            }

            Object.defineProperty(GroupSettings.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.GroupSettings');
              },
              enumerable: false,
              configurable: false
            });
            return GroupSettings;
          }());
          v1.MemberName = (function() {

            class MemberName {

              constructor(props) {
                this.nick = props && props.nick;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.nick != null) {
                    $root.google.protobuf.StringValue.verify(msg.nick, helper, errors.field('nick'));
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.nick != null) {
                    json.nick = $root.google.protobuf.StringValue.toJSON(obj.nick, helper);
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.wix.social.groups.api.v1.MemberName();

                if (json.nick != null) {
                  result.nick = $root.google.protobuf.StringValue.fromJSON(json.nick, helper);
                } else {
                  delete result.nick;
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.nick != null) {
                    grpc.nick = $root.google.protobuf.StringValue.toGRPC(obj.nick, helper);
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.wix.social.groups.api.v1.MemberName();

                  if (grpc.nick != null) {
                    result.nick = $root.google.protobuf.StringValue.fromGRPC(grpc.nick, helper);
                  } else {
                    delete result.nick;
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'nick': {
                      'type': $root.google.protobuf.StringValue,
                      'id': 1
                    }
                  }
                };
              }
            }

            Object.defineProperty(MemberName.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.MemberName');
              },
              enumerable: false,
              configurable: false
            });
            return MemberName;
          }());
          v1.CursorTokens = (function() {

            class CursorTokens {

              constructor(props) {
                this.prev = props && props.prev;
                this.next = props && props.next;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.prev != null) {
                    $root.google.protobuf.StringValue.verify(msg.prev, helper, errors.field('prev'));
                  }
                  if (msg.next != null) {
                    $root.google.protobuf.StringValue.verify(msg.next, helper, errors.field('next'));
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.prev != null) {
                    json.prev = $root.google.protobuf.StringValue.toJSON(obj.prev, helper);
                  }
                  if (obj.next != null) {
                    json.next = $root.google.protobuf.StringValue.toJSON(obj.next, helper);
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.wix.social.groups.api.v1.CursorTokens();

                if (json.prev != null) {
                  result.prev = $root.google.protobuf.StringValue.fromJSON(json.prev, helper);
                } else {
                  delete result.prev;
                }
                if (json.next != null) {
                  result.next = $root.google.protobuf.StringValue.fromJSON(json.next, helper);
                } else {
                  delete result.next;
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.prev != null) {
                    grpc.prev = $root.google.protobuf.StringValue.toGRPC(obj.prev, helper);
                  }
                  if (obj.next != null) {
                    grpc.next = $root.google.protobuf.StringValue.toGRPC(obj.next, helper);
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.wix.social.groups.api.v1.CursorTokens();

                  if (grpc.prev != null) {
                    result.prev = $root.google.protobuf.StringValue.fromGRPC(grpc.prev, helper);
                  } else {
                    delete result.prev;
                  }
                  if (grpc.next != null) {
                    result.next = $root.google.protobuf.StringValue.fromGRPC(grpc.next, helper);
                  } else {
                    delete result.next;
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'prev': {
                      'type': $root.google.protobuf.StringValue,
                      'id': 2
                    },
                    'next': {
                      'type': $root.google.protobuf.StringValue,
                      'id': 1
                    }
                  }
                };
              }
            }

            Object.defineProperty(CursorTokens.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.CursorTokens');
              },
              enumerable: false,
              configurable: false
            });
            return CursorTokens;
          }());
          v1.GetTokenResponse = (function() {

            class GetTokenResponse {

              constructor(props) {
                this.token = props && props.token;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.token != null) {
                    if (typeof msg.token !== 'string') {
                      errors.field('token').error('string expected');
                    }
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.token != null) {
                    json.token = obj.token;
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.wix.social.groups.api.v1.GetTokenResponse();

                if (json.token != null) {
                  result.token = json.token;
                } else {
                  result.token = '';
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.token != null) {
                    grpc.token = obj.token;
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.wix.social.groups.api.v1.GetTokenResponse();

                  if (grpc.token != null) {
                    result.token = grpc.token;
                  } else {
                    result.token = '';
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'token': {
                      'type': 'string',
                      'id': 1
                    }
                  }
                };
              }
            }

            Object.defineProperty(GetTokenResponse.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.GetTokenResponse');
              },
              enumerable: false,
              configurable: false
            });
            return GetTokenResponse;
          }());
          v1.SocialGroupsMediaIntegrationService = (function() {

            class SocialGroupsMediaIntegrationService {

              constructor() {
                if (this.constructor.name === SocialGroupsMediaIntegrationService.name) {
                  throw new TypeError('class SocialGroupsMediaIntegrationService is abstract');
                }
              }

              getToken(aspects, msg) {
                throw new TypeError('method getToken is abstract');
              }
            }

            SocialGroupsMediaIntegrationService.prototype.getToken._messageTypes = function() {
              return [
                $root.google.protobuf.Empty,
                $root.wix.social.groups.api.v1.GetTokenResponse
              ];
            };
            SocialGroupsMediaIntegrationService.prototype.getToken.__proto = pbjs => {
              return $root.__lookup(pbjs)('wix.social.groups.api.v1.SocialGroupsMediaIntegrationService.getToken');
            };
            Object.defineProperty(SocialGroupsMediaIntegrationService.prototype, '__isRpcService__', {
              value: true,
              enumerable: false,
              configurable: false
            });
            Object.defineProperty(SocialGroupsMediaIntegrationService.prototype, '__fqn__', {
              value: 'wix.social.groups.api.v1.SocialGroupsMediaIntegrationService',
              enumerable: false,
              configurable: false
            });
            Object.defineProperty(SocialGroupsMediaIntegrationService.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.SocialGroupsMediaIntegrationService');
              },
              enumerable: false,
              configurable: false
            });
            Object.defineProperty(SocialGroupsMediaIntegrationService.prototype, '__options__', {
              value: $root.__options,
              enumerable: false,
              configurable: false
            });
            return SocialGroupsMediaIntegrationService;
          }());
          v1.GetFeedTokensRequest = (function() {

            class GetFeedTokensRequest {

              constructor(props) {
                this.groupIds = props && props.groupIds;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.groupIds != null) {
                    const fieldErrors = errors.field('groupIds');

                    if (!Array.isArray(msg.groupIds)) {
                      fieldErrors.error('array expected');
                    } else {
                      msg.groupIds.forEach((value, index) => {
                        if (typeof value !== 'string') {
                          fieldErrors.index(index).error('string expected');
                        }
                      });
                    }
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.groupIds != null) {
                    json.groupIds = obj.groupIds.map(e => {
                      return e;
                    });
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.wix.social.groups.api.v1.GetFeedTokensRequest();

                if (json.groupIds != null) {
                  result.groupIds = json.groupIds.map(e => {
                    return e;
                  });
                } else {
                  result.groupIds = [];
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.groupIds != null) {
                    grpc.groupIds = obj.groupIds.map(e => {
                      return e;
                    });
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.wix.social.groups.api.v1.GetFeedTokensRequest();

                  if (grpc.groupIds != null) {
                    result.groupIds = grpc.groupIds.map(e => {
                      return e;
                    });
                  } else {
                    result.groupIds = [];
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'groupIds': {
                      'rule': 'repeated',
                      'type': 'string',
                      'id': 1,
                      'options': {
                        '(wix.api.format)': 'GUID'
                      }
                    }
                  }
                };
              }
            }

            Object.defineProperty(GetFeedTokensRequest.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.GetFeedTokensRequest');
              },
              enumerable: false,
              configurable: false
            });
            return GetFeedTokensRequest;
          }());
          v1.GetFeedTokensResponse = (function() {

            class GetFeedTokensResponse {

              constructor(props) {
                this.tokens = props && props.tokens;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.tokens != null) {
                    const fieldErrors = errors.field('tokens');

                    if (msg.tokens != null && (!(typeof msg.tokens === 'object') || Array.isArray(msg.tokens))) {
                      fieldErrors.error('object expected');
                    } else {
                      for (let key in msg.tokens) {
                        const keyErrors = fieldErrors.index(key);
                        if (typeof msg.tokens[key] !== 'string') {
                          keyErrors.field('value').error('string expected');
                        }
                      }
                    }
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.tokens != null) {
                    json.tokens = Object.entries(obj.tokens).reduce((acc, [k, v]) => {
                      acc[k] = v;
                      return acc;
                    }, {});
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.wix.social.groups.api.v1.GetFeedTokensResponse();

                if (json.tokens != null) {
                  result.tokens = Object.entries(json.tokens).reduce((acc, [k, v]) => {
                    acc[k] = v;
                    return acc;
                  }, {});
                } else {
                  delete result.tokens;
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.tokens != null) {
                    grpc.tokens = Object.entries(obj.tokens).reduce((acc, [k, v]) => {
                      acc[k] = v;
                      return acc;
                    }, {});
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.wix.social.groups.api.v1.GetFeedTokensResponse();

                  if (grpc.tokens != null) {
                    result.tokens = Object.entries(grpc.tokens).reduce((acc, [k, v]) => {
                      acc[k] = v;
                      return acc;
                    }, {});
                  } else {
                    delete result.tokens;
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'tokens': {
                      'keyType': 'string',
                      'type': 'string',
                      'id': 1
                    }
                  }
                };
              }
            }

            Object.defineProperty(GetFeedTokensResponse.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.GetFeedTokensResponse');
              },
              enumerable: false,
              configurable: false
            });
            return GetFeedTokensResponse;
          }());
          v1.SocialGroupsFeedIntegrationService = (function() {

            class SocialGroupsFeedIntegrationService {

              constructor() {
                if (this.constructor.name === SocialGroupsFeedIntegrationService.name) {
                  throw new TypeError('class SocialGroupsFeedIntegrationService is abstract');
                }
              }

              getTokens(aspects, msg) {
                throw new TypeError('method getTokens is abstract');
              }
            }

            SocialGroupsFeedIntegrationService.prototype.getTokens._messageTypes = function() {
              return [
                $root.wix.social.groups.api.v1.GetFeedTokensRequest,
                $root.wix.social.groups.api.v1.GetFeedTokensResponse
              ];
            };
            SocialGroupsFeedIntegrationService.prototype.getTokens.__proto = pbjs => {
              return $root.__lookup(pbjs)('wix.social.groups.api.v1.SocialGroupsFeedIntegrationService.getTokens');
            };
            Object.defineProperty(SocialGroupsFeedIntegrationService.prototype, '__isRpcService__', {
              value: true,
              enumerable: false,
              configurable: false
            });
            Object.defineProperty(SocialGroupsFeedIntegrationService.prototype, '__fqn__', {
              value: 'wix.social.groups.api.v1.SocialGroupsFeedIntegrationService',
              enumerable: false,
              configurable: false
            });
            Object.defineProperty(SocialGroupsFeedIntegrationService.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.SocialGroupsFeedIntegrationService');
              },
              enumerable: false,
              configurable: false
            });
            Object.defineProperty(SocialGroupsFeedIntegrationService.prototype, '__options__', {
              value: $root.__options,
              enumerable: false,
              configurable: false
            });
            return SocialGroupsFeedIntegrationService;
          }());
          v1.NotificationTriggerRequest = (function() {

            class NotificationTriggerRequest {

              constructor(props) {
                this.templateId = props && props.templateId;
                this.groupInstanceId = props && props.groupInstanceId;
                this.groupId = props && props.groupId;
                this.postId = props && props.postId;
                this.commentId = props && props.commentId;
                this.initiator = props && props.initiator;
                this.recipients = props && props.recipients;
                this.translationParams = props && props.translationParams;
                this.deepLinkUrl = props && props.deepLinkUrl;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.templateId != null) {
                    if (typeof msg.templateId !== 'string') {
                      errors.field('templateId').error('string expected');
                    }
                  }
                  if (msg.groupInstanceId != null) {
                    if (typeof msg.groupInstanceId !== 'string') {
                      errors.field('groupInstanceId').error('string expected');
                    }
                  }
                  if (msg.groupId != null) {
                    if (typeof msg.groupId !== 'string') {
                      errors.field('groupId').error('string expected');
                    }
                  }
                  if (msg.postId != null) {
                    if (typeof msg.postId !== 'string') {
                      errors.field('postId').error('string expected');
                    }
                  }
                  if (msg.commentId != null) {
                    if (typeof msg.commentId !== 'string') {
                      errors.field('commentId').error('string expected');
                    }
                  }
                  if (msg.initiator != null) {
                    if (typeof msg.initiator !== 'string') {
                      errors.field('initiator').error('string expected');
                    }
                  }
                  if (msg.recipients != null) {
                    const fieldErrors = errors.field('recipients');

                    if (!Array.isArray(msg.recipients)) {
                      fieldErrors.error('array expected');
                    } else {
                      msg.recipients.forEach((value, index) => {
                        if (typeof value !== 'string') {
                          fieldErrors.index(index).error('string expected');
                        }
                      });
                    }
                  }
                  if (msg.translationParams != null) {
                    const fieldErrors = errors.field('translationParams');

                    if (msg.translationParams != null && (!(typeof msg.translationParams === 'object') || Array.isArray(msg.translationParams))) {
                      fieldErrors.error('object expected');
                    } else {
                      for (let key in msg.translationParams) {
                        const keyErrors = fieldErrors.index(key);
                        if (typeof msg.translationParams[key] !== 'string') {
                          keyErrors.field('value').error('string expected');
                        }
                      }
                    }
                  }
                  if (msg.deepLinkUrl != null) {
                    if (typeof msg.deepLinkUrl !== 'string') {
                      errors.field('deepLinkUrl').error('string expected');
                    }
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.templateId != null) {
                    json.templateId = obj.templateId;
                  }
                  if (obj.groupInstanceId != null) {
                    json.groupInstanceId = obj.groupInstanceId;
                  }
                  if (obj.groupId != null) {
                    json.groupId = obj.groupId;
                  }
                  if (obj.postId != null) {
                    json.postId = obj.postId;
                  }
                  if (obj.commentId != null) {
                    json.commentId = obj.commentId;
                  }
                  if (obj.initiator != null) {
                    json.initiator = obj.initiator;
                  }
                  if (obj.recipients != null) {
                    json.recipients = obj.recipients.map(e => {
                      return e;
                    });
                  }
                  if (obj.translationParams != null) {
                    json.translationParams = Object.entries(obj.translationParams).reduce((acc, [k, v]) => {
                      acc[k] = v;
                      return acc;
                    }, {});
                  }
                  if (obj.deepLinkUrl != null) {
                    json.deepLinkUrl = obj.deepLinkUrl;
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.wix.social.groups.api.v1.NotificationTriggerRequest();

                if (json.templateId != null) {
                  result.templateId = json.templateId;
                } else {
                  result.templateId = '';
                }
                if (json.groupInstanceId != null) {
                  result.groupInstanceId = json.groupInstanceId;
                } else {
                  result.groupInstanceId = '';
                }
                if (json.groupId != null) {
                  result.groupId = json.groupId;
                } else {
                  result.groupId = '';
                }
                if (json.postId != null) {
                  result.postId = json.postId;
                } else {
                  result.postId = '';
                }
                if (json.commentId != null) {
                  result.commentId = json.commentId;
                } else {
                  result.commentId = '';
                }
                if (json.initiator != null) {
                  result.initiator = json.initiator;
                } else {
                  result.initiator = '';
                }
                if (json.recipients != null) {
                  result.recipients = json.recipients.map(e => {
                    return e;
                  });
                } else {
                  result.recipients = [];
                }
                if (json.translationParams != null) {
                  result.translationParams = Object.entries(json.translationParams).reduce((acc, [k, v]) => {
                    acc[k] = v;
                    return acc;
                  }, {});
                } else {
                  delete result.translationParams;
                }
                if (json.deepLinkUrl != null) {
                  result.deepLinkUrl = json.deepLinkUrl;
                } else {
                  result.deepLinkUrl = '';
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.templateId != null) {
                    grpc.templateId = obj.templateId;
                  }
                  if (obj.groupInstanceId != null) {
                    grpc.groupInstanceId = obj.groupInstanceId;
                  }
                  if (obj.groupId != null) {
                    grpc.groupId = obj.groupId;
                  }
                  if (obj.postId != null) {
                    grpc.postId = obj.postId;
                  }
                  if (obj.commentId != null) {
                    grpc.commentId = obj.commentId;
                  }
                  if (obj.initiator != null) {
                    grpc.initiator = obj.initiator;
                  }
                  if (obj.recipients != null) {
                    grpc.recipients = obj.recipients.map(e => {
                      return e;
                    });
                  }
                  if (obj.translationParams != null) {
                    grpc.translationParams = Object.entries(obj.translationParams).reduce((acc, [k, v]) => {
                      acc[k] = v;
                      return acc;
                    }, {});
                  }
                  if (obj.deepLinkUrl != null) {
                    grpc.deepLinkUrl = obj.deepLinkUrl;
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.wix.social.groups.api.v1.NotificationTriggerRequest();

                  if (grpc.templateId != null) {
                    result.templateId = grpc.templateId;
                  } else {
                    result.templateId = '';
                  }
                  if (grpc.groupInstanceId != null) {
                    result.groupInstanceId = grpc.groupInstanceId;
                  } else {
                    result.groupInstanceId = '';
                  }
                  if (grpc.groupId != null) {
                    result.groupId = grpc.groupId;
                  } else {
                    result.groupId = '';
                  }
                  if (grpc.postId != null) {
                    result.postId = grpc.postId;
                  } else {
                    result.postId = '';
                  }
                  if (grpc.commentId != null) {
                    result.commentId = grpc.commentId;
                  } else {
                    result.commentId = '';
                  }
                  if (grpc.initiator != null) {
                    result.initiator = grpc.initiator;
                  } else {
                    result.initiator = '';
                  }
                  if (grpc.recipients != null) {
                    result.recipients = grpc.recipients.map(e => {
                      return e;
                    });
                  } else {
                    result.recipients = [];
                  }
                  if (grpc.translationParams != null) {
                    result.translationParams = Object.entries(grpc.translationParams).reduce((acc, [k, v]) => {
                      acc[k] = v;
                      return acc;
                    }, {});
                  } else {
                    delete result.translationParams;
                  }
                  if (grpc.deepLinkUrl != null) {
                    result.deepLinkUrl = grpc.deepLinkUrl;
                  } else {
                    result.deepLinkUrl = '';
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'templateId': {
                      'type': 'string',
                      'id': 1
                    },
                    'groupInstanceId': {
                      'type': 'string',
                      'id': 2,
                      'options': {
                        '(wix.api.format)': 'GUID'
                      }
                    },
                    'groupId': {
                      'type': 'string',
                      'id': 3,
                      'options': {
                        '(wix.api.format)': 'GUID'
                      }
                    },
                    'postId': {
                      'type': 'string',
                      'id': 4
                    },
                    'commentId': {
                      'type': 'string',
                      'id': 5
                    },
                    'initiator': {
                      'type': 'string',
                      'id': 6
                    },
                    'recipients': {
                      'rule': 'repeated',
                      'type': 'string',
                      'id': 7
                    },
                    'translationParams': {
                      'keyType': 'string',
                      'type': 'string',
                      'id': 8
                    },
                    'deepLinkUrl': {
                      'type': 'string',
                      'id': 9
                    }
                  }
                };
              }
            }

            Object.defineProperty(NotificationTriggerRequest.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.NotificationTriggerRequest');
              },
              enumerable: false,
              configurable: false
            });
            return NotificationTriggerRequest;
          }());
          v1.SocialGroupsNotificationTriggerService = (function() {

            class SocialGroupsNotificationTriggerService {

              constructor() {
                if (this.constructor.name === SocialGroupsNotificationTriggerService.name) {
                  throw new TypeError('class SocialGroupsNotificationTriggerService is abstract');
                }
              }

              trigger(aspects, msg) {
                throw new TypeError('method trigger is abstract');
              }
            }

            SocialGroupsNotificationTriggerService.prototype.trigger._messageTypes = function() {
              return [
                $root.wix.social.groups.api.v1.NotificationTriggerRequest,
                $root.google.protobuf.Empty
              ];
            };
            SocialGroupsNotificationTriggerService.prototype.trigger.__proto = pbjs => {
              return $root.__lookup(pbjs)('wix.social.groups.api.v1.SocialGroupsNotificationTriggerService.trigger');
            };
            Object.defineProperty(SocialGroupsNotificationTriggerService.prototype, '__isRpcService__', {
              value: true,
              enumerable: false,
              configurable: false
            });
            Object.defineProperty(SocialGroupsNotificationTriggerService.prototype, '__fqn__', {
              value: 'wix.social.groups.api.v1.SocialGroupsNotificationTriggerService',
              enumerable: false,
              configurable: false
            });
            Object.defineProperty(SocialGroupsNotificationTriggerService.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.SocialGroupsNotificationTriggerService');
              },
              enumerable: false,
              configurable: false
            });
            Object.defineProperty(SocialGroupsNotificationTriggerService.prototype, '__options__', {
              value: $root.__options,
              enumerable: false,
              configurable: false
            });
            return SocialGroupsNotificationTriggerService;
          }());
          v1.JoinGroupRequest = (function() {

            class JoinGroupRequest {

              constructor(props) {
                this.groupId = props && props.groupId;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.groupId != null) {
                    if (typeof msg.groupId !== 'string') {
                      errors.field('groupId').error('string expected');
                    }
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.groupId != null) {
                    json.groupId = obj.groupId;
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.wix.social.groups.api.v1.JoinGroupRequest();

                if (json.groupId != null) {
                  result.groupId = json.groupId;
                } else {
                  result.groupId = '';
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.groupId != null) {
                    grpc.groupId = obj.groupId;
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.wix.social.groups.api.v1.JoinGroupRequest();

                  if (grpc.groupId != null) {
                    result.groupId = grpc.groupId;
                  } else {
                    result.groupId = '';
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'groupId': {
                      'type': 'string',
                      'id': 1,
                      'options': {
                        '(wix.api.format)': 'GUID'
                      }
                    }
                  }
                };
              }
            }

            Object.defineProperty(JoinGroupRequest.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.JoinGroupRequest');
              },
              enumerable: false,
              configurable: false
            });
            return JoinGroupRequest;
          }());
          v1.LeaveGroupRequest = (function() {

            class LeaveGroupRequest {

              constructor(props) {
                this.groupId = props && props.groupId;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.groupId != null) {
                    if (typeof msg.groupId !== 'string') {
                      errors.field('groupId').error('string expected');
                    }
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.groupId != null) {
                    json.groupId = obj.groupId;
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.wix.social.groups.api.v1.LeaveGroupRequest();

                if (json.groupId != null) {
                  result.groupId = json.groupId;
                } else {
                  result.groupId = '';
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.groupId != null) {
                    grpc.groupId = obj.groupId;
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.wix.social.groups.api.v1.LeaveGroupRequest();

                  if (grpc.groupId != null) {
                    result.groupId = grpc.groupId;
                  } else {
                    result.groupId = '';
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'groupId': {
                      'type': 'string',
                      'id': 1,
                      'options': {
                        '(wix.api.format)': 'GUID'
                      }
                    }
                  }
                };
              }
            }

            Object.defineProperty(LeaveGroupRequest.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.LeaveGroupRequest');
              },
              enumerable: false,
              configurable: false
            });
            return LeaveGroupRequest;
          }());
          v1.SubmitRequestToJoinRequest = (function() {

            class SubmitRequestToJoinRequest {

              constructor(props) {
                this.groupId = props && props.groupId;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.groupId != null) {
                    if (typeof msg.groupId !== 'string') {
                      errors.field('groupId').error('string expected');
                    }
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.groupId != null) {
                    json.groupId = obj.groupId;
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.wix.social.groups.api.v1.SubmitRequestToJoinRequest();

                if (json.groupId != null) {
                  result.groupId = json.groupId;
                } else {
                  result.groupId = '';
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.groupId != null) {
                    grpc.groupId = obj.groupId;
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.wix.social.groups.api.v1.SubmitRequestToJoinRequest();

                  if (grpc.groupId != null) {
                    result.groupId = grpc.groupId;
                  } else {
                    result.groupId = '';
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'groupId': {
                      'type': 'string',
                      'id': 1,
                      'options': {
                        '(wix.api.format)': 'GUID'
                      }
                    }
                  }
                };
              }
            }

            Object.defineProperty(SubmitRequestToJoinRequest.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.SubmitRequestToJoinRequest');
              },
              enumerable: false,
              configurable: false
            });
            return SubmitRequestToJoinRequest;
          }());
          v1.WithdrawRequestToJoinRequest = (function() {

            class WithdrawRequestToJoinRequest {

              constructor(props) {
                this.groupId = props && props.groupId;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.groupId != null) {
                    if (typeof msg.groupId !== 'string') {
                      errors.field('groupId').error('string expected');
                    }
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.groupId != null) {
                    json.groupId = obj.groupId;
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.wix.social.groups.api.v1.WithdrawRequestToJoinRequest();

                if (json.groupId != null) {
                  result.groupId = json.groupId;
                } else {
                  result.groupId = '';
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.groupId != null) {
                    grpc.groupId = obj.groupId;
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.wix.social.groups.api.v1.WithdrawRequestToJoinRequest();

                  if (grpc.groupId != null) {
                    result.groupId = grpc.groupId;
                  } else {
                    result.groupId = '';
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'groupId': {
                      'type': 'string',
                      'id': 1,
                      'options': {
                        '(wix.api.format)': 'GUID'
                      }
                    }
                  }
                };
              }
            }

            Object.defineProperty(WithdrawRequestToJoinRequest.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.WithdrawRequestToJoinRequest');
              },
              enumerable: false,
              configurable: false
            });
            return WithdrawRequestToJoinRequest;
          }());
          v1.RejectGroupMemershipRequest = (function() {

            class RejectGroupMemershipRequest {

              constructor(props) {
                this.groupId = props && props.groupId;
                this.siteMemberId = props && props.siteMemberId;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.groupId != null) {
                    if (typeof msg.groupId !== 'string') {
                      errors.field('groupId').error('string expected');
                    }
                  }
                  if (msg.siteMemberId != null) {
                    if (typeof msg.siteMemberId !== 'string') {
                      errors.field('siteMemberId').error('string expected');
                    }
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.groupId != null) {
                    json.groupId = obj.groupId;
                  }
                  if (obj.siteMemberId != null) {
                    json.siteMemberId = obj.siteMemberId;
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.wix.social.groups.api.v1.RejectGroupMemershipRequest();

                if (json.groupId != null) {
                  result.groupId = json.groupId;
                } else {
                  result.groupId = '';
                }
                if (json.siteMemberId != null) {
                  result.siteMemberId = json.siteMemberId;
                } else {
                  result.siteMemberId = '';
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.groupId != null) {
                    grpc.groupId = obj.groupId;
                  }
                  if (obj.siteMemberId != null) {
                    grpc.siteMemberId = obj.siteMemberId;
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.wix.social.groups.api.v1.RejectGroupMemershipRequest();

                  if (grpc.groupId != null) {
                    result.groupId = grpc.groupId;
                  } else {
                    result.groupId = '';
                  }
                  if (grpc.siteMemberId != null) {
                    result.siteMemberId = grpc.siteMemberId;
                  } else {
                    result.siteMemberId = '';
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'groupId': {
                      'type': 'string',
                      'id': 1,
                      'options': {
                        '(wix.api.format)': 'GUID'
                      }
                    },
                    'siteMemberId': {
                      'type': 'string',
                      'id': 2,
                      'options': {
                        '(wix.api.format)': 'GUID'
                      }
                    }
                  }
                };
              }
            }

            Object.defineProperty(RejectGroupMemershipRequest.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.RejectGroupMemershipRequest');
              },
              enumerable: false,
              configurable: false
            });
            return RejectGroupMemershipRequest;
          }());
          v1.ApproveGroupMemershipRequest = (function() {

            class ApproveGroupMemershipRequest {

              constructor(props) {
                this.groupId = props && props.groupId;
                this.siteMemberId = props && props.siteMemberId;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.groupId != null) {
                    if (typeof msg.groupId !== 'string') {
                      errors.field('groupId').error('string expected');
                    }
                  }
                  if (msg.siteMemberId != null) {
                    if (typeof msg.siteMemberId !== 'string') {
                      errors.field('siteMemberId').error('string expected');
                    }
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.groupId != null) {
                    json.groupId = obj.groupId;
                  }
                  if (obj.siteMemberId != null) {
                    json.siteMemberId = obj.siteMemberId;
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.wix.social.groups.api.v1.ApproveGroupMemershipRequest();

                if (json.groupId != null) {
                  result.groupId = json.groupId;
                } else {
                  result.groupId = '';
                }
                if (json.siteMemberId != null) {
                  result.siteMemberId = json.siteMemberId;
                } else {
                  result.siteMemberId = '';
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.groupId != null) {
                    grpc.groupId = obj.groupId;
                  }
                  if (obj.siteMemberId != null) {
                    grpc.siteMemberId = obj.siteMemberId;
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.wix.social.groups.api.v1.ApproveGroupMemershipRequest();

                  if (grpc.groupId != null) {
                    result.groupId = grpc.groupId;
                  } else {
                    result.groupId = '';
                  }
                  if (grpc.siteMemberId != null) {
                    result.siteMemberId = grpc.siteMemberId;
                  } else {
                    result.siteMemberId = '';
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'groupId': {
                      'type': 'string',
                      'id': 1,
                      'options': {
                        '(wix.api.format)': 'GUID'
                      }
                    },
                    'siteMemberId': {
                      'type': 'string',
                      'id': 2,
                      'options': {
                        '(wix.api.format)': 'GUID'
                      }
                    }
                  }
                };
              }
            }

            Object.defineProperty(ApproveGroupMemershipRequest.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.ApproveGroupMemershipRequest');
              },
              enumerable: false,
              configurable: false
            });
            return ApproveGroupMemershipRequest;
          }());
          v1.GetGroupMemberRequest = (function() {

            class GetGroupMemberRequest {

              constructor(props) {
                this.groupId = props && props.groupId;
                this.siteMemberId = props && props.siteMemberId;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.groupId != null) {
                    if (typeof msg.groupId !== 'string') {
                      errors.field('groupId').error('string expected');
                    }
                  }
                  if (msg.siteMemberId != null) {
                    if (typeof msg.siteMemberId !== 'string') {
                      errors.field('siteMemberId').error('string expected');
                    }
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.groupId != null) {
                    json.groupId = obj.groupId;
                  }
                  if (obj.siteMemberId != null) {
                    json.siteMemberId = obj.siteMemberId;
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.wix.social.groups.api.v1.GetGroupMemberRequest();

                if (json.groupId != null) {
                  result.groupId = json.groupId;
                } else {
                  result.groupId = '';
                }
                if (json.siteMemberId != null) {
                  result.siteMemberId = json.siteMemberId;
                } else {
                  result.siteMemberId = '';
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.groupId != null) {
                    grpc.groupId = obj.groupId;
                  }
                  if (obj.siteMemberId != null) {
                    grpc.siteMemberId = obj.siteMemberId;
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.wix.social.groups.api.v1.GetGroupMemberRequest();

                  if (grpc.groupId != null) {
                    result.groupId = grpc.groupId;
                  } else {
                    result.groupId = '';
                  }
                  if (grpc.siteMemberId != null) {
                    result.siteMemberId = grpc.siteMemberId;
                  } else {
                    result.siteMemberId = '';
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'groupId': {
                      'type': 'string',
                      'id': 1,
                      'options': {
                        '(wix.api.format)': 'GUID'
                      }
                    },
                    'siteMemberId': {
                      'type': 'string',
                      'id': 2,
                      'options': {
                        '(wix.api.format)': 'GUID'
                      }
                    }
                  }
                };
              }
            }

            Object.defineProperty(GetGroupMemberRequest.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.GetGroupMemberRequest');
              },
              enumerable: false,
              configurable: false
            });
            return GetGroupMemberRequest;
          }());
          v1.ListGroupMembersRequest = (function() {

            class ListGroupMembersRequest {

              constructor(props) {
                this.groupId = props && props.groupId;
                this.limit = props && props.limit;
                this.cursorToken = props && props.cursorToken;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.groupId != null) {
                    if (typeof msg.groupId !== 'string') {
                      errors.field('groupId').error('string expected');
                    }
                  }
                  if (msg.limit != null) {
                    $root.google.protobuf.UInt32Value.verify(msg.limit, helper, errors.field('limit'));
                  }
                  if (msg.cursorToken != null) {
                    $root.google.protobuf.StringValue.verify(msg.cursorToken, helper, errors.field('cursorToken'));
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.groupId != null) {
                    json.groupId = obj.groupId;
                  }
                  if (obj.limit != null) {
                    json.limit = $root.google.protobuf.UInt32Value.toJSON(obj.limit, helper);
                  }
                  if (obj.cursorToken != null) {
                    json.cursorToken = $root.google.protobuf.StringValue.toJSON(obj.cursorToken, helper);
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.wix.social.groups.api.v1.ListGroupMembersRequest();

                if (json.groupId != null) {
                  result.groupId = json.groupId;
                } else {
                  result.groupId = '';
                }
                if (json.limit != null) {
                  result.limit = $root.google.protobuf.UInt32Value.fromJSON(json.limit, helper);
                } else {
                  delete result.limit;
                }
                if (json.cursorToken != null) {
                  result.cursorToken = $root.google.protobuf.StringValue.fromJSON(json.cursorToken, helper);
                } else {
                  delete result.cursorToken;
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.groupId != null) {
                    grpc.groupId = obj.groupId;
                  }
                  if (obj.limit != null) {
                    grpc.limit = $root.google.protobuf.UInt32Value.toGRPC(obj.limit, helper);
                  }
                  if (obj.cursorToken != null) {
                    grpc.cursorToken = $root.google.protobuf.StringValue.toGRPC(obj.cursorToken, helper);
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.wix.social.groups.api.v1.ListGroupMembersRequest();

                  if (grpc.groupId != null) {
                    result.groupId = grpc.groupId;
                  } else {
                    result.groupId = '';
                  }
                  if (grpc.limit != null) {
                    result.limit = $root.google.protobuf.UInt32Value.fromGRPC(grpc.limit, helper);
                  } else {
                    delete result.limit;
                  }
                  if (grpc.cursorToken != null) {
                    result.cursorToken = $root.google.protobuf.StringValue.fromGRPC(grpc.cursorToken, helper);
                  } else {
                    delete result.cursorToken;
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'groupId': {
                      'type': 'string',
                      'id': 1,
                      'options': {
                        '(wix.api.format)': 'GUID'
                      }
                    },
                    'limit': {
                      'type': $root.google.protobuf.UInt32Value,
                      'id': 2,
                      'options': {
                        '(wix.api.min)': 1,
                        '(wix.api.max)': 100
                      }
                    },
                    'cursorToken': {
                      'type': $root.google.protobuf.StringValue,
                      'id': 3
                    }
                  }
                };
              }
            }

            Object.defineProperty(ListGroupMembersRequest.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.ListGroupMembersRequest');
              },
              enumerable: false,
              configurable: false
            });
            return ListGroupMembersRequest;
          }());
          v1.ListAllMembersRequest = (function() {

            class ListAllMembersRequest {

              constructor(props) {
                this.groupId = props && props.groupId;
                this.limit = props && props.limit;
                this.cursorToken = props && props.cursorToken;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.groupId != null) {
                    if (typeof msg.groupId !== 'string') {
                      errors.field('groupId').error('string expected');
                    }
                  }
                  if (msg.limit != null) {
                    $root.google.protobuf.UInt32Value.verify(msg.limit, helper, errors.field('limit'));
                  }
                  if (msg.cursorToken != null) {
                    $root.google.protobuf.StringValue.verify(msg.cursorToken, helper, errors.field('cursorToken'));
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.groupId != null) {
                    json.groupId = obj.groupId;
                  }
                  if (obj.limit != null) {
                    json.limit = $root.google.protobuf.UInt32Value.toJSON(obj.limit, helper);
                  }
                  if (obj.cursorToken != null) {
                    json.cursorToken = $root.google.protobuf.StringValue.toJSON(obj.cursorToken, helper);
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.wix.social.groups.api.v1.ListAllMembersRequest();

                if (json.groupId != null) {
                  result.groupId = json.groupId;
                } else {
                  result.groupId = '';
                }
                if (json.limit != null) {
                  result.limit = $root.google.protobuf.UInt32Value.fromJSON(json.limit, helper);
                } else {
                  delete result.limit;
                }
                if (json.cursorToken != null) {
                  result.cursorToken = $root.google.protobuf.StringValue.fromJSON(json.cursorToken, helper);
                } else {
                  delete result.cursorToken;
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.groupId != null) {
                    grpc.groupId = obj.groupId;
                  }
                  if (obj.limit != null) {
                    grpc.limit = $root.google.protobuf.UInt32Value.toGRPC(obj.limit, helper);
                  }
                  if (obj.cursorToken != null) {
                    grpc.cursorToken = $root.google.protobuf.StringValue.toGRPC(obj.cursorToken, helper);
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.wix.social.groups.api.v1.ListAllMembersRequest();

                  if (grpc.groupId != null) {
                    result.groupId = grpc.groupId;
                  } else {
                    result.groupId = '';
                  }
                  if (grpc.limit != null) {
                    result.limit = $root.google.protobuf.UInt32Value.fromGRPC(grpc.limit, helper);
                  } else {
                    delete result.limit;
                  }
                  if (grpc.cursorToken != null) {
                    result.cursorToken = $root.google.protobuf.StringValue.fromGRPC(grpc.cursorToken, helper);
                  } else {
                    delete result.cursorToken;
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'groupId': {
                      'type': 'string',
                      'id': 1,
                      'options': {
                        '(wix.api.format)': 'GUID'
                      }
                    },
                    'limit': {
                      'type': $root.google.protobuf.UInt32Value,
                      'id': 2,
                      'options': {
                        '(wix.api.min)': 1,
                        '(wix.api.max)': 500
                      }
                    },
                    'cursorToken': {
                      'type': $root.google.protobuf.StringValue,
                      'id': 3
                    }
                  }
                };
              }
            }

            Object.defineProperty(ListAllMembersRequest.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.ListAllMembersRequest');
              },
              enumerable: false,
              configurable: false
            });
            return ListAllMembersRequest;
          }());
          v1.ListPendingMembersRequest = (function() {

            class ListPendingMembersRequest {

              constructor(props) {
                this.groupId = props && props.groupId;
                this.limit = props && props.limit;
                this.cursorToken = props && props.cursorToken;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.groupId != null) {
                    if (typeof msg.groupId !== 'string') {
                      errors.field('groupId').error('string expected');
                    }
                  }
                  if (msg.limit != null) {
                    $root.google.protobuf.UInt32Value.verify(msg.limit, helper, errors.field('limit'));
                  }
                  if (msg.cursorToken != null) {
                    $root.google.protobuf.StringValue.verify(msg.cursorToken, helper, errors.field('cursorToken'));
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.groupId != null) {
                    json.groupId = obj.groupId;
                  }
                  if (obj.limit != null) {
                    json.limit = $root.google.protobuf.UInt32Value.toJSON(obj.limit, helper);
                  }
                  if (obj.cursorToken != null) {
                    json.cursorToken = $root.google.protobuf.StringValue.toJSON(obj.cursorToken, helper);
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.wix.social.groups.api.v1.ListPendingMembersRequest();

                if (json.groupId != null) {
                  result.groupId = json.groupId;
                } else {
                  result.groupId = '';
                }
                if (json.limit != null) {
                  result.limit = $root.google.protobuf.UInt32Value.fromJSON(json.limit, helper);
                } else {
                  delete result.limit;
                }
                if (json.cursorToken != null) {
                  result.cursorToken = $root.google.protobuf.StringValue.fromJSON(json.cursorToken, helper);
                } else {
                  delete result.cursorToken;
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.groupId != null) {
                    grpc.groupId = obj.groupId;
                  }
                  if (obj.limit != null) {
                    grpc.limit = $root.google.protobuf.UInt32Value.toGRPC(obj.limit, helper);
                  }
                  if (obj.cursorToken != null) {
                    grpc.cursorToken = $root.google.protobuf.StringValue.toGRPC(obj.cursorToken, helper);
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.wix.social.groups.api.v1.ListPendingMembersRequest();

                  if (grpc.groupId != null) {
                    result.groupId = grpc.groupId;
                  } else {
                    result.groupId = '';
                  }
                  if (grpc.limit != null) {
                    result.limit = $root.google.protobuf.UInt32Value.fromGRPC(grpc.limit, helper);
                  } else {
                    delete result.limit;
                  }
                  if (grpc.cursorToken != null) {
                    result.cursorToken = $root.google.protobuf.StringValue.fromGRPC(grpc.cursorToken, helper);
                  } else {
                    delete result.cursorToken;
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'groupId': {
                      'type': 'string',
                      'id': 1,
                      'options': {
                        '(wix.api.format)': 'GUID'
                      }
                    },
                    'limit': {
                      'type': $root.google.protobuf.UInt32Value,
                      'id': 2,
                      'options': {
                        '(wix.api.min)': 1,
                        '(wix.api.max)': 500
                      }
                    },
                    'cursorToken': {
                      'type': $root.google.protobuf.StringValue,
                      'id': 3
                    }
                  }
                };
              }
            }

            Object.defineProperty(ListPendingMembersRequest.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.ListPendingMembersRequest');
              },
              enumerable: false,
              configurable: false
            });
            return ListPendingMembersRequest;
          }());
          v1.AddMembersToGroupRequest = (function() {

            class AddMembersToGroupRequest {

              constructor(props) {
                this.groupId = props && props.groupId;
                this.siteMemberIds = props && props.siteMemberIds;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.groupId != null) {
                    if (typeof msg.groupId !== 'string') {
                      errors.field('groupId').error('string expected');
                    }
                  }
                  if (msg.siteMemberIds != null) {
                    const fieldErrors = errors.field('siteMemberIds');

                    if (!Array.isArray(msg.siteMemberIds)) {
                      fieldErrors.error('array expected');
                    } else {
                      msg.siteMemberIds.forEach((value, index) => {
                        if (typeof value !== 'string') {
                          fieldErrors.index(index).error('string expected');
                        }
                      });
                    }
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.groupId != null) {
                    json.groupId = obj.groupId;
                  }
                  if (obj.siteMemberIds != null) {
                    json.siteMemberIds = obj.siteMemberIds.map(e => {
                      return e;
                    });
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.wix.social.groups.api.v1.AddMembersToGroupRequest();

                if (json.groupId != null) {
                  result.groupId = json.groupId;
                } else {
                  result.groupId = '';
                }
                if (json.siteMemberIds != null) {
                  result.siteMemberIds = json.siteMemberIds.map(e => {
                    return e;
                  });
                } else {
                  result.siteMemberIds = [];
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.groupId != null) {
                    grpc.groupId = obj.groupId;
                  }
                  if (obj.siteMemberIds != null) {
                    grpc.siteMemberIds = obj.siteMemberIds.map(e => {
                      return e;
                    });
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.wix.social.groups.api.v1.AddMembersToGroupRequest();

                  if (grpc.groupId != null) {
                    result.groupId = grpc.groupId;
                  } else {
                    result.groupId = '';
                  }
                  if (grpc.siteMemberIds != null) {
                    result.siteMemberIds = grpc.siteMemberIds.map(e => {
                      return e;
                    });
                  } else {
                    result.siteMemberIds = [];
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'groupId': {
                      'type': 'string',
                      'id': 1,
                      'options': {
                        '(wix.api.format)': 'GUID'
                      }
                    },
                    'siteMemberIds': {
                      'rule': 'repeated',
                      'type': 'string',
                      'id': 2,
                      'options': {
                        '(wix.api.format)': 'GUID',
                        '(wix.api.minSize)': 1,
                        '(wix.api.maxSize)': 1000
                      }
                    }
                  }
                };
              }
            }

            Object.defineProperty(AddMembersToGroupRequest.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.AddMembersToGroupRequest');
              },
              enumerable: false,
              configurable: false
            });
            return AddMembersToGroupRequest;
          }());
          v1.RemoveMembersFromGroupRequest = (function() {

            class RemoveMembersFromGroupRequest {

              constructor(props) {
                this.groupId = props && props.groupId;
                this.siteMemberIds = props && props.siteMemberIds;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.groupId != null) {
                    if (typeof msg.groupId !== 'string') {
                      errors.field('groupId').error('string expected');
                    }
                  }
                  if (msg.siteMemberIds != null) {
                    const fieldErrors = errors.field('siteMemberIds');

                    if (!Array.isArray(msg.siteMemberIds)) {
                      fieldErrors.error('array expected');
                    } else {
                      msg.siteMemberIds.forEach((value, index) => {
                        if (typeof value !== 'string') {
                          fieldErrors.index(index).error('string expected');
                        }
                      });
                    }
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.groupId != null) {
                    json.groupId = obj.groupId;
                  }
                  if (obj.siteMemberIds != null) {
                    json.siteMemberIds = obj.siteMemberIds.map(e => {
                      return e;
                    });
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.wix.social.groups.api.v1.RemoveMembersFromGroupRequest();

                if (json.groupId != null) {
                  result.groupId = json.groupId;
                } else {
                  result.groupId = '';
                }
                if (json.siteMemberIds != null) {
                  result.siteMemberIds = json.siteMemberIds.map(e => {
                    return e;
                  });
                } else {
                  result.siteMemberIds = [];
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.groupId != null) {
                    grpc.groupId = obj.groupId;
                  }
                  if (obj.siteMemberIds != null) {
                    grpc.siteMemberIds = obj.siteMemberIds.map(e => {
                      return e;
                    });
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.wix.social.groups.api.v1.RemoveMembersFromGroupRequest();

                  if (grpc.groupId != null) {
                    result.groupId = grpc.groupId;
                  } else {
                    result.groupId = '';
                  }
                  if (grpc.siteMemberIds != null) {
                    result.siteMemberIds = grpc.siteMemberIds.map(e => {
                      return e;
                    });
                  } else {
                    result.siteMemberIds = [];
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'groupId': {
                      'type': 'string',
                      'id': 1,
                      'options': {
                        '(wix.api.format)': 'GUID'
                      }
                    },
                    'siteMemberIds': {
                      'rule': 'repeated',
                      'type': 'string',
                      'id': 2,
                      'options': {
                        '(wix.api.format)': 'GUID',
                        '(wix.api.minSize)': 1,
                        '(wix.api.maxSize)': 1000
                      }
                    }
                  }
                };
              }
            }

            Object.defineProperty(RemoveMembersFromGroupRequest.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.RemoveMembersFromGroupRequest');
              },
              enumerable: false,
              configurable: false
            });
            return RemoveMembersFromGroupRequest;
          }());
          v1.JoinedGroupResponse = (function() {

            class JoinedGroupResponse {

              constructor(props) {
                this.groupId = props && props.groupId;
                this.details = props && props.details;
                this.settings = props && props.settings;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.groupId != null) {
                    if (typeof msg.groupId !== 'string') {
                      errors.field('groupId').error('string expected');
                    }
                  }
                  if (msg.details != null) {
                    $root.wix.social.groups.api.v1.GroupDetails.verify(msg.details, helper, errors.field('details'));
                  }
                  if (msg.settings != null) {
                    $root.wix.social.groups.api.v1.GroupSettings.verify(msg.settings, helper, errors.field('settings'));
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.groupId != null) {
                    json.groupId = obj.groupId;
                  }
                  if (obj.details != null) {
                    json.details = $root.wix.social.groups.api.v1.GroupDetails.toJSON(obj.details, helper);
                  }
                  if (obj.settings != null) {
                    json.settings = $root.wix.social.groups.api.v1.GroupSettings.toJSON(obj.settings, helper);
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.wix.social.groups.api.v1.JoinedGroupResponse();

                if (json.groupId != null) {
                  result.groupId = json.groupId;
                } else {
                  result.groupId = '';
                }
                if (json.details != null) {
                  result.details = $root.wix.social.groups.api.v1.GroupDetails.fromJSON(json.details, helper);
                } else {
                  delete result.details;
                }
                if (json.settings != null) {
                  result.settings = $root.wix.social.groups.api.v1.GroupSettings.fromJSON(json.settings, helper);
                } else {
                  delete result.settings;
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.groupId != null) {
                    grpc.groupId = obj.groupId;
                  }
                  if (obj.details != null) {
                    grpc.details = $root.wix.social.groups.api.v1.GroupDetails.toGRPC(obj.details, helper);
                  }
                  if (obj.settings != null) {
                    grpc.settings = $root.wix.social.groups.api.v1.GroupSettings.toGRPC(obj.settings, helper);
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.wix.social.groups.api.v1.JoinedGroupResponse();

                  if (grpc.groupId != null) {
                    result.groupId = grpc.groupId;
                  } else {
                    result.groupId = '';
                  }
                  if (grpc.details != null) {
                    result.details = $root.wix.social.groups.api.v1.GroupDetails.fromGRPC(grpc.details, helper);
                  } else {
                    delete result.details;
                  }
                  if (grpc.settings != null) {
                    result.settings = $root.wix.social.groups.api.v1.GroupSettings.fromGRPC(grpc.settings, helper);
                  } else {
                    delete result.settings;
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'groupId': {
                      'type': 'string',
                      'id': 1
                    },
                    'details': {
                      'type': $root.wix.social.groups.api.v1.GroupDetails,
                      'id': 4
                    },
                    'settings': {
                      'type': $root.wix.social.groups.api.v1.GroupSettings,
                      'id': 5
                    }
                  }
                };
              }
            }

            Object.defineProperty(JoinedGroupResponse.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.JoinedGroupResponse');
              },
              enumerable: false,
              configurable: false
            });
            return JoinedGroupResponse;
          }());
          v1.GroupMemberResponse = (function() {

            class GroupMemberResponse {

              constructor(props) {
                this.siteMemberId = props && props.siteMemberId;
                this.relationship = props && props.relationship;
                this.name = props && props.name;
                this.imageUrl = props && props.imageUrl;
                this.roles = props && props.roles;
                this.joinedOn = props && props.joinedOn;
                this.requestedMembershipOn = props && props.requestedMembershipOn;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.siteMemberId != null) {
                    if (typeof msg.siteMemberId !== 'string') {
                      errors.field('siteMemberId').error('string expected');
                    }
                  }
                  if (msg.relationship != null) {
                    $root.wix.social.groups.api.v1.RelationshipWithGroup.verify(msg.relationship, helper, errors.field('relationship'));
                  }
                  if (msg.name != null) {
                    $root.wix.social.groups.api.v1.MemberName.verify(msg.name, helper, errors.field('name'));
                  }
                  if (msg.imageUrl != null) {
                    $root.google.protobuf.StringValue.verify(msg.imageUrl, helper, errors.field('imageUrl'));
                  }
                  if (msg.roles != null) {
                    const fieldErrors = errors.field('roles');

                    if (!Array.isArray(msg.roles)) {
                      fieldErrors.error('array expected');
                    } else {
                      msg.roles.forEach((value, index) => {
                        $root.wix.social.groups.api.v1.RoleInGroup.verify(value, helper, fieldErrors.index(index));
                      });
                    }
                  }
                  if (msg.joinedOn != null) {
                    $root.google.protobuf.Timestamp.verify(msg.joinedOn, helper, errors.field('joinedOn'));
                  }
                  if (msg.requestedMembershipOn != null) {
                    $root.google.protobuf.Timestamp.verify(msg.requestedMembershipOn, helper, errors.field('requestedMembershipOn'));
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.siteMemberId != null) {
                    json.siteMemberId = obj.siteMemberId;
                  }
                  if (obj.relationship != null) {
                    json.relationship = $root.wix.social.groups.api.v1.RelationshipWithGroup[obj.relationship];
                  }
                  if (obj.name != null) {
                    json.name = $root.wix.social.groups.api.v1.MemberName.toJSON(obj.name, helper);
                  }
                  if (obj.imageUrl != null) {
                    json.imageUrl = $root.google.protobuf.StringValue.toJSON(obj.imageUrl, helper);
                  }
                  if (obj.roles != null) {
                    json.roles = obj.roles.map(e => {
                      return $root.wix.social.groups.api.v1.RoleInGroup[e];
                    });
                  }
                  if (obj.joinedOn != null) {
                    json.joinedOn = $root.google.protobuf.Timestamp.toJSON(obj.joinedOn, helper);
                  }
                  if (obj.requestedMembershipOn != null) {
                    json.requestedMembershipOn = $root.google.protobuf.Timestamp.toJSON(obj.requestedMembershipOn, helper);
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.wix.social.groups.api.v1.GroupMemberResponse();

                if (json.siteMemberId != null) {
                  result.siteMemberId = json.siteMemberId;
                } else {
                  result.siteMemberId = '';
                }
                if (json.relationship != null) {
                  result.relationship = $root.wix.social.groups.api.v1.RelationshipWithGroup[json.relationship];
                } else {
                  result.relationship = 'NONE';
                }
                if (json.name != null) {
                  result.name = $root.wix.social.groups.api.v1.MemberName.fromJSON(json.name, helper);
                } else {
                  delete result.name;
                }
                if (json.imageUrl != null) {
                  result.imageUrl = $root.google.protobuf.StringValue.fromJSON(json.imageUrl, helper);
                } else {
                  delete result.imageUrl;
                }
                if (json.roles != null) {
                  result.roles = json.roles.map(e => {
                    return $root.wix.social.groups.api.v1.RoleInGroup[e];
                  });
                } else {
                  result.roles = [];
                }
                if (json.joinedOn != null) {
                  result.joinedOn = $root.google.protobuf.Timestamp.fromJSON(json.joinedOn, helper);
                } else {
                  delete result.joinedOn;
                }
                if (json.requestedMembershipOn != null) {
                  result.requestedMembershipOn = $root.google.protobuf.Timestamp.fromJSON(json.requestedMembershipOn, helper);
                } else {
                  delete result.requestedMembershipOn;
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.siteMemberId != null) {
                    grpc.siteMemberId = obj.siteMemberId;
                  }
                  if (obj.relationship != null) {
                    grpc.relationship = obj.relationship;
                  }
                  if (obj.name != null) {
                    grpc.name = $root.wix.social.groups.api.v1.MemberName.toGRPC(obj.name, helper);
                  }
                  if (obj.imageUrl != null) {
                    grpc.imageUrl = $root.google.protobuf.StringValue.toGRPC(obj.imageUrl, helper);
                  }
                  if (obj.roles != null) {
                    grpc.roles = obj.roles.map(e => {
                      return e;
                    });
                  }
                  if (obj.joinedOn != null) {
                    grpc.joinedOn = $root.google.protobuf.Timestamp.toGRPC(obj.joinedOn, helper);
                  }
                  if (obj.requestedMembershipOn != null) {
                    grpc.requestedMembershipOn = $root.google.protobuf.Timestamp.toGRPC(obj.requestedMembershipOn, helper);
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.wix.social.groups.api.v1.GroupMemberResponse();

                  if (grpc.siteMemberId != null) {
                    result.siteMemberId = grpc.siteMemberId;
                  } else {
                    result.siteMemberId = '';
                  }
                  if (grpc.relationship != null) {
                    result.relationship = grpc.relationship;
                  } else {
                    result.relationship = 'NONE';
                  }
                  if (grpc.name != null) {
                    result.name = $root.wix.social.groups.api.v1.MemberName.fromGRPC(grpc.name, helper);
                  } else {
                    delete result.name;
                  }
                  if (grpc.imageUrl != null) {
                    result.imageUrl = $root.google.protobuf.StringValue.fromGRPC(grpc.imageUrl, helper);
                  } else {
                    delete result.imageUrl;
                  }
                  if (grpc.roles != null) {
                    result.roles = grpc.roles.map(e => {
                      return e;
                    });
                  } else {
                    result.roles = [];
                  }
                  if (grpc.joinedOn != null) {
                    result.joinedOn = $root.google.protobuf.Timestamp.fromGRPC(grpc.joinedOn, helper);
                  } else {
                    delete result.joinedOn;
                  }
                  if (grpc.requestedMembershipOn != null) {
                    result.requestedMembershipOn = $root.google.protobuf.Timestamp.fromGRPC(grpc.requestedMembershipOn, helper);
                  } else {
                    delete result.requestedMembershipOn;
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'siteMemberId': {
                      'type': 'string',
                      'id': 1
                    },
                    'relationship': {
                      'type': $root.wix.social.groups.api.v1.RelationshipWithGroup,
                      'id': 2
                    },
                    'name': {
                      'type': $root.wix.social.groups.api.v1.MemberName,
                      'id': 3
                    },
                    'imageUrl': {
                      'type': $root.google.protobuf.StringValue,
                      'id': 4
                    },
                    'roles': {
                      'rule': 'repeated',
                      'type': $root.wix.social.groups.api.v1.RoleInGroup,
                      'id': 5
                    },
                    'joinedOn': {
                      'type': $root.google.protobuf.Timestamp,
                      'id': 6
                    },
                    'requestedMembershipOn': {
                      'type': $root.google.protobuf.Timestamp,
                      'id': 7
                    }
                  }
                };
              }
            }

            Object.defineProperty(GroupMemberResponse.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.GroupMemberResponse');
              },
              enumerable: false,
              configurable: false
            });
            return GroupMemberResponse;
          }());
          v1.GetGroupMemberResponse = (function() {

            class GetGroupMemberResponse {

              constructor(props) {
                this.member = props && props.member;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.member != null) {
                    $root.wix.social.groups.api.v1.GroupMemberResponse.verify(msg.member, helper, errors.field('member'));
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.member != null) {
                    json.member = $root.wix.social.groups.api.v1.GroupMemberResponse.toJSON(obj.member, helper);
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.wix.social.groups.api.v1.GetGroupMemberResponse();

                if (json.member != null) {
                  result.member = $root.wix.social.groups.api.v1.GroupMemberResponse.fromJSON(json.member, helper);
                } else {
                  delete result.member;
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.member != null) {
                    grpc.member = $root.wix.social.groups.api.v1.GroupMemberResponse.toGRPC(obj.member, helper);
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.wix.social.groups.api.v1.GetGroupMemberResponse();

                  if (grpc.member != null) {
                    result.member = $root.wix.social.groups.api.v1.GroupMemberResponse.fromGRPC(grpc.member, helper);
                  } else {
                    delete result.member;
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'member': {
                      'type': $root.wix.social.groups.api.v1.GroupMemberResponse,
                      'id': 1
                    }
                  }
                };
              }
            }

            Object.defineProperty(GetGroupMemberResponse.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.GetGroupMemberResponse');
              },
              enumerable: false,
              configurable: false
            });
            return GetGroupMemberResponse;
          }());
          v1.ListGroupMembersResponse = (function() {

            class ListGroupMembersResponse {

              constructor(props) {
                this.members = props && props.members;
                this.cursorTokens = props && props.cursorTokens;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.members != null) {
                    const fieldErrors = errors.field('members');

                    if (!Array.isArray(msg.members)) {
                      fieldErrors.error('array expected');
                    } else {
                      msg.members.forEach((value, index) => {
                        $root.wix.social.groups.api.v1.GroupMemberResponse.verify(value, helper, fieldErrors.index(index));
                      });
                    }
                  }
                  if (msg.cursorTokens != null) {
                    $root.wix.social.groups.api.v1.CursorTokens.verify(msg.cursorTokens, helper, errors.field('cursorTokens'));
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.members != null) {
                    json.members = obj.members.map(e => {
                      return $root.wix.social.groups.api.v1.GroupMemberResponse.toJSON(e, helper);
                    });
                  }
                  if (obj.cursorTokens != null) {
                    json.cursorTokens = $root.wix.social.groups.api.v1.CursorTokens.toJSON(obj.cursorTokens, helper);
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.wix.social.groups.api.v1.ListGroupMembersResponse();

                if (json.members != null) {
                  result.members = json.members.map(e => {
                    return $root.wix.social.groups.api.v1.GroupMemberResponse.fromJSON(e, helper);
                  });
                } else {
                  result.members = [];
                }
                if (json.cursorTokens != null) {
                  result.cursorTokens = $root.wix.social.groups.api.v1.CursorTokens.fromJSON(json.cursorTokens, helper);
                } else {
                  delete result.cursorTokens;
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.members != null) {
                    grpc.members = obj.members.map(e => {
                      return $root.wix.social.groups.api.v1.GroupMemberResponse.toGRPC(e, helper);
                    });
                  }
                  if (obj.cursorTokens != null) {
                    grpc.cursorTokens = $root.wix.social.groups.api.v1.CursorTokens.toGRPC(obj.cursorTokens, helper);
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.wix.social.groups.api.v1.ListGroupMembersResponse();

                  if (grpc.members != null) {
                    result.members = grpc.members.map(e => {
                      return $root.wix.social.groups.api.v1.GroupMemberResponse.fromGRPC(e, helper);
                    });
                  } else {
                    result.members = [];
                  }
                  if (grpc.cursorTokens != null) {
                    result.cursorTokens = $root.wix.social.groups.api.v1.CursorTokens.fromGRPC(grpc.cursorTokens, helper);
                  } else {
                    delete result.cursorTokens;
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'members': {
                      'rule': 'repeated',
                      'type': $root.wix.social.groups.api.v1.GroupMemberResponse,
                      'id': 1
                    },
                    'cursorTokens': {
                      'type': $root.wix.social.groups.api.v1.CursorTokens,
                      'id': 2
                    }
                  }
                };
              }
            }

            Object.defineProperty(ListGroupMembersResponse.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.ListGroupMembersResponse');
              },
              enumerable: false,
              configurable: false
            });
            return ListGroupMembersResponse;
          }());
          v1.ListAllMembersResponse = (function() {

            class ListAllMembersResponse {

              constructor(props) {
                this.members = props && props.members;
                this.cursorTokens = props && props.cursorTokens;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.members != null) {
                    const fieldErrors = errors.field('members');

                    if (!Array.isArray(msg.members)) {
                      fieldErrors.error('array expected');
                    } else {
                      msg.members.forEach((value, index) => {
                        $root.wix.social.groups.api.v1.GroupMemberResponse.verify(value, helper, fieldErrors.index(index));
                      });
                    }
                  }
                  if (msg.cursorTokens != null) {
                    $root.wix.social.groups.api.v1.CursorTokens.verify(msg.cursorTokens, helper, errors.field('cursorTokens'));
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.members != null) {
                    json.members = obj.members.map(e => {
                      return $root.wix.social.groups.api.v1.GroupMemberResponse.toJSON(e, helper);
                    });
                  }
                  if (obj.cursorTokens != null) {
                    json.cursorTokens = $root.wix.social.groups.api.v1.CursorTokens.toJSON(obj.cursorTokens, helper);
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.wix.social.groups.api.v1.ListAllMembersResponse();

                if (json.members != null) {
                  result.members = json.members.map(e => {
                    return $root.wix.social.groups.api.v1.GroupMemberResponse.fromJSON(e, helper);
                  });
                } else {
                  result.members = [];
                }
                if (json.cursorTokens != null) {
                  result.cursorTokens = $root.wix.social.groups.api.v1.CursorTokens.fromJSON(json.cursorTokens, helper);
                } else {
                  delete result.cursorTokens;
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.members != null) {
                    grpc.members = obj.members.map(e => {
                      return $root.wix.social.groups.api.v1.GroupMemberResponse.toGRPC(e, helper);
                    });
                  }
                  if (obj.cursorTokens != null) {
                    grpc.cursorTokens = $root.wix.social.groups.api.v1.CursorTokens.toGRPC(obj.cursorTokens, helper);
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.wix.social.groups.api.v1.ListAllMembersResponse();

                  if (grpc.members != null) {
                    result.members = grpc.members.map(e => {
                      return $root.wix.social.groups.api.v1.GroupMemberResponse.fromGRPC(e, helper);
                    });
                  } else {
                    result.members = [];
                  }
                  if (grpc.cursorTokens != null) {
                    result.cursorTokens = $root.wix.social.groups.api.v1.CursorTokens.fromGRPC(grpc.cursorTokens, helper);
                  } else {
                    delete result.cursorTokens;
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'members': {
                      'rule': 'repeated',
                      'type': $root.wix.social.groups.api.v1.GroupMemberResponse,
                      'id': 1
                    },
                    'cursorTokens': {
                      'type': $root.wix.social.groups.api.v1.CursorTokens,
                      'id': 2
                    }
                  }
                };
              }
            }

            Object.defineProperty(ListAllMembersResponse.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.ListAllMembersResponse');
              },
              enumerable: false,
              configurable: false
            });
            return ListAllMembersResponse;
          }());
          v1.PendingMemberResponse = (function() {

            class PendingMemberResponse {

              constructor(props) {
                this.siteMemberId = props && props.siteMemberId;
                this.name = props && props.name;
                this.imageUrl = props && props.imageUrl;
                this.requestedMembershipOn = props && props.requestedMembershipOn;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.siteMemberId != null) {
                    if (typeof msg.siteMemberId !== 'string') {
                      errors.field('siteMemberId').error('string expected');
                    }
                  }
                  if (msg.name != null) {
                    $root.wix.social.groups.api.v1.MemberName.verify(msg.name, helper, errors.field('name'));
                  }
                  if (msg.imageUrl != null) {
                    $root.google.protobuf.StringValue.verify(msg.imageUrl, helper, errors.field('imageUrl'));
                  }
                  if (msg.requestedMembershipOn != null) {
                    $root.google.protobuf.Timestamp.verify(msg.requestedMembershipOn, helper, errors.field('requestedMembershipOn'));
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.siteMemberId != null) {
                    json.siteMemberId = obj.siteMemberId;
                  }
                  if (obj.name != null) {
                    json.name = $root.wix.social.groups.api.v1.MemberName.toJSON(obj.name, helper);
                  }
                  if (obj.imageUrl != null) {
                    json.imageUrl = $root.google.protobuf.StringValue.toJSON(obj.imageUrl, helper);
                  }
                  if (obj.requestedMembershipOn != null) {
                    json.requestedMembershipOn = $root.google.protobuf.Timestamp.toJSON(obj.requestedMembershipOn, helper);
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.wix.social.groups.api.v1.PendingMemberResponse();

                if (json.siteMemberId != null) {
                  result.siteMemberId = json.siteMemberId;
                } else {
                  result.siteMemberId = '';
                }
                if (json.name != null) {
                  result.name = $root.wix.social.groups.api.v1.MemberName.fromJSON(json.name, helper);
                } else {
                  delete result.name;
                }
                if (json.imageUrl != null) {
                  result.imageUrl = $root.google.protobuf.StringValue.fromJSON(json.imageUrl, helper);
                } else {
                  delete result.imageUrl;
                }
                if (json.requestedMembershipOn != null) {
                  result.requestedMembershipOn = $root.google.protobuf.Timestamp.fromJSON(json.requestedMembershipOn, helper);
                } else {
                  delete result.requestedMembershipOn;
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.siteMemberId != null) {
                    grpc.siteMemberId = obj.siteMemberId;
                  }
                  if (obj.name != null) {
                    grpc.name = $root.wix.social.groups.api.v1.MemberName.toGRPC(obj.name, helper);
                  }
                  if (obj.imageUrl != null) {
                    grpc.imageUrl = $root.google.protobuf.StringValue.toGRPC(obj.imageUrl, helper);
                  }
                  if (obj.requestedMembershipOn != null) {
                    grpc.requestedMembershipOn = $root.google.protobuf.Timestamp.toGRPC(obj.requestedMembershipOn, helper);
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.wix.social.groups.api.v1.PendingMemberResponse();

                  if (grpc.siteMemberId != null) {
                    result.siteMemberId = grpc.siteMemberId;
                  } else {
                    result.siteMemberId = '';
                  }
                  if (grpc.name != null) {
                    result.name = $root.wix.social.groups.api.v1.MemberName.fromGRPC(grpc.name, helper);
                  } else {
                    delete result.name;
                  }
                  if (grpc.imageUrl != null) {
                    result.imageUrl = $root.google.protobuf.StringValue.fromGRPC(grpc.imageUrl, helper);
                  } else {
                    delete result.imageUrl;
                  }
                  if (grpc.requestedMembershipOn != null) {
                    result.requestedMembershipOn = $root.google.protobuf.Timestamp.fromGRPC(grpc.requestedMembershipOn, helper);
                  } else {
                    delete result.requestedMembershipOn;
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'siteMemberId': {
                      'type': 'string',
                      'id': 1
                    },
                    'name': {
                      'type': $root.wix.social.groups.api.v1.MemberName,
                      'id': 2
                    },
                    'imageUrl': {
                      'type': $root.google.protobuf.StringValue,
                      'id': 3
                    },
                    'requestedMembershipOn': {
                      'type': $root.google.protobuf.Timestamp,
                      'id': 4
                    }
                  }
                };
              }
            }

            Object.defineProperty(PendingMemberResponse.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.PendingMemberResponse');
              },
              enumerable: false,
              configurable: false
            });
            return PendingMemberResponse;
          }());
          v1.ListPendingMembersResponse = (function() {

            class ListPendingMembersResponse {

              constructor(props) {
                this.members = props && props.members;
                this.cursorTokens = props && props.cursorTokens;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.members != null) {
                    const fieldErrors = errors.field('members');

                    if (!Array.isArray(msg.members)) {
                      fieldErrors.error('array expected');
                    } else {
                      msg.members.forEach((value, index) => {
                        $root.wix.social.groups.api.v1.PendingMemberResponse.verify(value, helper, fieldErrors.index(index));
                      });
                    }
                  }
                  if (msg.cursorTokens != null) {
                    $root.wix.social.groups.api.v1.CursorTokens.verify(msg.cursorTokens, helper, errors.field('cursorTokens'));
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.members != null) {
                    json.members = obj.members.map(e => {
                      return $root.wix.social.groups.api.v1.PendingMemberResponse.toJSON(e, helper);
                    });
                  }
                  if (obj.cursorTokens != null) {
                    json.cursorTokens = $root.wix.social.groups.api.v1.CursorTokens.toJSON(obj.cursorTokens, helper);
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.wix.social.groups.api.v1.ListPendingMembersResponse();

                if (json.members != null) {
                  result.members = json.members.map(e => {
                    return $root.wix.social.groups.api.v1.PendingMemberResponse.fromJSON(e, helper);
                  });
                } else {
                  result.members = [];
                }
                if (json.cursorTokens != null) {
                  result.cursorTokens = $root.wix.social.groups.api.v1.CursorTokens.fromJSON(json.cursorTokens, helper);
                } else {
                  delete result.cursorTokens;
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.members != null) {
                    grpc.members = obj.members.map(e => {
                      return $root.wix.social.groups.api.v1.PendingMemberResponse.toGRPC(e, helper);
                    });
                  }
                  if (obj.cursorTokens != null) {
                    grpc.cursorTokens = $root.wix.social.groups.api.v1.CursorTokens.toGRPC(obj.cursorTokens, helper);
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.wix.social.groups.api.v1.ListPendingMembersResponse();

                  if (grpc.members != null) {
                    result.members = grpc.members.map(e => {
                      return $root.wix.social.groups.api.v1.PendingMemberResponse.fromGRPC(e, helper);
                    });
                  } else {
                    result.members = [];
                  }
                  if (grpc.cursorTokens != null) {
                    result.cursorTokens = $root.wix.social.groups.api.v1.CursorTokens.fromGRPC(grpc.cursorTokens, helper);
                  } else {
                    delete result.cursorTokens;
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'members': {
                      'rule': 'repeated',
                      'type': $root.wix.social.groups.api.v1.PendingMemberResponse,
                      'id': 1
                    },
                    'cursorTokens': {
                      'type': $root.wix.social.groups.api.v1.CursorTokens,
                      'id': 2
                    }
                  }
                };
              }
            }

            Object.defineProperty(ListPendingMembersResponse.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.ListPendingMembersResponse');
              },
              enumerable: false,
              configurable: false
            });
            return ListPendingMembersResponse;
          }());
          v1.SocialGroupsMembershipService = (function() {

            class SocialGroupsMembershipService {

              constructor() {
                if (this.constructor.name === SocialGroupsMembershipService.name) {
                  throw new TypeError('class SocialGroupsMembershipService is abstract');
                }
              }

              joinGroup(aspects, msg) {
                throw new TypeError('method joinGroup is abstract');
              }

              leaveGroup(aspects, msg) {
                throw new TypeError('method leaveGroup is abstract');
              }

              addMembersToGroup(aspects, msg) {
                throw new TypeError('method addMembersToGroup is abstract');
              }

              removeMembersFromGroup(aspects, msg) {
                throw new TypeError('method removeMembersFromGroup is abstract');
              }

              getGroupMember(aspects, msg) {
                throw new TypeError('method getGroupMember is abstract');
              }

              listGroupMembers(aspects, msg) {
                throw new TypeError('method listGroupMembers is abstract');
              }

              listAllMembers(aspects, msg) {
                throw new TypeError('method listAllMembers is abstract');
              }

              listPendingMembers(aspects, msg) {
                throw new TypeError('method listPendingMembers is abstract');
              }

              submitRequestToJoin(aspects, msg) {
                throw new TypeError('method submitRequestToJoin is abstract');
              }

              withdrawRequestToJoin(aspects, msg) {
                throw new TypeError('method withdrawRequestToJoin is abstract');
              }

              approveGroupMembership(aspects, msg) {
                throw new TypeError('method approveGroupMembership is abstract');
              }

              rejectGroupMembership(aspects, msg) {
                throw new TypeError('method rejectGroupMembership is abstract');
              }
            }

            SocialGroupsMembershipService.prototype.joinGroup._messageTypes = function() {
              return [
                $root.wix.social.groups.api.v1.JoinGroupRequest,
                $root.wix.social.groups.api.v1.JoinedGroupResponse
              ];
            };
            SocialGroupsMembershipService.prototype.leaveGroup._messageTypes = function() {
              return [
                $root.wix.social.groups.api.v1.LeaveGroupRequest,
                $root.google.protobuf.Empty
              ];
            };
            SocialGroupsMembershipService.prototype.addMembersToGroup._messageTypes = function() {
              return [
                $root.wix.social.groups.api.v1.AddMembersToGroupRequest,
                $root.google.protobuf.Empty
              ];
            };
            SocialGroupsMembershipService.prototype.removeMembersFromGroup._messageTypes = function() {
              return [
                $root.wix.social.groups.api.v1.RemoveMembersFromGroupRequest,
                $root.google.protobuf.Empty
              ];
            };
            SocialGroupsMembershipService.prototype.getGroupMember._messageTypes = function() {
              return [
                $root.wix.social.groups.api.v1.GetGroupMemberRequest,
                $root.wix.social.groups.api.v1.GetGroupMemberResponse
              ];
            };
            SocialGroupsMembershipService.prototype.listGroupMembers._messageTypes = function() {
              return [
                $root.wix.social.groups.api.v1.ListGroupMembersRequest,
                $root.wix.social.groups.api.v1.ListGroupMembersResponse
              ];
            };
            SocialGroupsMembershipService.prototype.listAllMembers._messageTypes = function() {
              return [
                $root.wix.social.groups.api.v1.ListAllMembersRequest,
                $root.wix.social.groups.api.v1.ListAllMembersResponse
              ];
            };
            SocialGroupsMembershipService.prototype.listPendingMembers._messageTypes = function() {
              return [
                $root.wix.social.groups.api.v1.ListPendingMembersRequest,
                $root.wix.social.groups.api.v1.ListPendingMembersResponse
              ];
            };
            SocialGroupsMembershipService.prototype.submitRequestToJoin._messageTypes = function() {
              return [
                $root.wix.social.groups.api.v1.SubmitRequestToJoinRequest,
                $root.google.protobuf.Empty
              ];
            };
            SocialGroupsMembershipService.prototype.withdrawRequestToJoin._messageTypes = function() {
              return [
                $root.wix.social.groups.api.v1.WithdrawRequestToJoinRequest,
                $root.google.protobuf.Empty
              ];
            };
            SocialGroupsMembershipService.prototype.approveGroupMembership._messageTypes = function() {
              return [
                $root.wix.social.groups.api.v1.ApproveGroupMemershipRequest,
                $root.google.protobuf.Empty
              ];
            };
            SocialGroupsMembershipService.prototype.rejectGroupMembership._messageTypes = function() {
              return [
                $root.wix.social.groups.api.v1.RejectGroupMemershipRequest,
                $root.google.protobuf.Empty
              ];
            };
            SocialGroupsMembershipService.prototype.joinGroup.__proto = pbjs => {
              return $root.__lookup(pbjs)('wix.social.groups.api.v1.SocialGroupsMembershipService.JoinGroup');
            };
            SocialGroupsMembershipService.prototype.leaveGroup.__proto = pbjs => {
              return $root.__lookup(pbjs)('wix.social.groups.api.v1.SocialGroupsMembershipService.LeaveGroup');
            };
            SocialGroupsMembershipService.prototype.addMembersToGroup.__proto = pbjs => {
              return $root.__lookup(pbjs)('wix.social.groups.api.v1.SocialGroupsMembershipService.AddMembersToGroup');
            };
            SocialGroupsMembershipService.prototype.removeMembersFromGroup.__proto = pbjs => {
              return $root.__lookup(pbjs)('wix.social.groups.api.v1.SocialGroupsMembershipService.RemoveMembersFromGroup');
            };
            SocialGroupsMembershipService.prototype.getGroupMember.__proto = pbjs => {
              return $root.__lookup(pbjs)('wix.social.groups.api.v1.SocialGroupsMembershipService.GetGroupMember');
            };
            SocialGroupsMembershipService.prototype.listGroupMembers.__proto = pbjs => {
              return $root.__lookup(pbjs)('wix.social.groups.api.v1.SocialGroupsMembershipService.ListGroupMembers');
            };
            SocialGroupsMembershipService.prototype.listAllMembers.__proto = pbjs => {
              return $root.__lookup(pbjs)('wix.social.groups.api.v1.SocialGroupsMembershipService.ListAllMembers');
            };
            SocialGroupsMembershipService.prototype.listPendingMembers.__proto = pbjs => {
              return $root.__lookup(pbjs)('wix.social.groups.api.v1.SocialGroupsMembershipService.ListPendingMembers');
            };
            SocialGroupsMembershipService.prototype.submitRequestToJoin.__proto = pbjs => {
              return $root.__lookup(pbjs)('wix.social.groups.api.v1.SocialGroupsMembershipService.SubmitRequestToJoin');
            };
            SocialGroupsMembershipService.prototype.withdrawRequestToJoin.__proto = pbjs => {
              return $root.__lookup(pbjs)('wix.social.groups.api.v1.SocialGroupsMembershipService.WithdrawRequestToJoin');
            };
            SocialGroupsMembershipService.prototype.approveGroupMembership.__proto = pbjs => {
              return $root.__lookup(pbjs)('wix.social.groups.api.v1.SocialGroupsMembershipService.ApproveGroupMembership');
            };
            SocialGroupsMembershipService.prototype.rejectGroupMembership.__proto = pbjs => {
              return $root.__lookup(pbjs)('wix.social.groups.api.v1.SocialGroupsMembershipService.RejectGroupMembership');
            };
            Object.defineProperty(SocialGroupsMembershipService.prototype, '__isRpcService__', {
              value: true,
              enumerable: false,
              configurable: false
            });
            Object.defineProperty(SocialGroupsMembershipService.prototype, '__fqn__', {
              value: 'wix.social.groups.api.v1.SocialGroupsMembershipService',
              enumerable: false,
              configurable: false
            });
            Object.defineProperty(SocialGroupsMembershipService.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.SocialGroupsMembershipService');
              },
              enumerable: false,
              configurable: false
            });
            Object.defineProperty(SocialGroupsMembershipService.prototype, '__options__', {
              value: $root.__options,
              enumerable: false,
              configurable: false
            });
            return SocialGroupsMembershipService;
          }());
          v1.MigrationType = {
            verify: (value, helper, errors = helper.verification.Errors.empty()) => {
              switch (value) {
                default: {
                  errors.error('enum expected');
                }
                case 'TEST':
                case 'MIGRATE_SLUGS':
                  break;
              }
              return errors;
            },
            'TEST': 'TEST',
            'MIGRATE_SLUGS': 'MIGRATE_SLUGS'
          };
          v1.MigrationRequest = (function() {

            class MigrationRequest {

              constructor(props) {
                this.migrationType = props && props.migrationType;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.migrationType != null) {
                    $root.wix.social.groups.api.v1.MigrationType.verify(msg.migrationType, helper, errors.field('migrationType'));
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.migrationType != null) {
                    json.migrationType = $root.wix.social.groups.api.v1.MigrationType[obj.migrationType];
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.wix.social.groups.api.v1.MigrationRequest();

                if (json.migrationType != null) {
                  result.migrationType = $root.wix.social.groups.api.v1.MigrationType[json.migrationType];
                } else {
                  result.migrationType = 'TEST';
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.migrationType != null) {
                    grpc.migrationType = obj.migrationType;
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.wix.social.groups.api.v1.MigrationRequest();

                  if (grpc.migrationType != null) {
                    result.migrationType = grpc.migrationType;
                  } else {
                    result.migrationType = 'TEST';
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'migrationType': {
                      'type': $root.wix.social.groups.api.v1.MigrationType,
                      'id': 1
                    }
                  }
                };
              }
            }

            Object.defineProperty(MigrationRequest.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.MigrationRequest');
              },
              enumerable: false,
              configurable: false
            });
            return MigrationRequest;
          }());
          v1.SocialGroupsMigrationService = (function() {

            class SocialGroupsMigrationService {

              constructor() {
                if (this.constructor.name === SocialGroupsMigrationService.name) {
                  throw new TypeError('class SocialGroupsMigrationService is abstract');
                }
              }

              migrate(aspects, msg) {
                throw new TypeError('method migrate is abstract');
              }
            }

            SocialGroupsMigrationService.prototype.migrate._messageTypes = function() {
              return [
                $root.wix.social.groups.api.v1.MigrationRequest,
                $root.google.protobuf.Empty
              ];
            };
            SocialGroupsMigrationService.prototype.migrate.__proto = pbjs => {
              return $root.__lookup(pbjs)('wix.social.groups.api.v1.SocialGroupsMigrationService.migrate');
            };
            Object.defineProperty(SocialGroupsMigrationService.prototype, '__isRpcService__', {
              value: true,
              enumerable: false,
              configurable: false
            });
            Object.defineProperty(SocialGroupsMigrationService.prototype, '__fqn__', {
              value: 'wix.social.groups.api.v1.SocialGroupsMigrationService',
              enumerable: false,
              configurable: false
            });
            Object.defineProperty(SocialGroupsMigrationService.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.SocialGroupsMigrationService');
              },
              enumerable: false,
              configurable: false
            });
            Object.defineProperty(SocialGroupsMigrationService.prototype, '__options__', {
              value: $root.__options,
              enumerable: false,
              configurable: false
            });
            return SocialGroupsMigrationService;
          }());
          v1.SetMemberRoleRequest = (function() {

            class SetMemberRoleRequest {

              constructor(props) {
                this.groupId = props && props.groupId;
                this.siteMemberId = props && props.siteMemberId;
                this.role = props && props.role;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.groupId != null) {
                    if (typeof msg.groupId !== 'string') {
                      errors.field('groupId').error('string expected');
                    }
                  }
                  if (msg.siteMemberId != null) {
                    if (typeof msg.siteMemberId !== 'string') {
                      errors.field('siteMemberId').error('string expected');
                    }
                  }
                  if (msg.role != null) {
                    $root.wix.social.groups.api.v1.RoleInGroup.verify(msg.role, helper, errors.field('role'));
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.groupId != null) {
                    json.groupId = obj.groupId;
                  }
                  if (obj.siteMemberId != null) {
                    json.siteMemberId = obj.siteMemberId;
                  }
                  if (obj.role != null) {
                    json.role = $root.wix.social.groups.api.v1.RoleInGroup[obj.role];
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.wix.social.groups.api.v1.SetMemberRoleRequest();

                if (json.groupId != null) {
                  result.groupId = json.groupId;
                } else {
                  result.groupId = '';
                }
                if (json.siteMemberId != null) {
                  result.siteMemberId = json.siteMemberId;
                } else {
                  result.siteMemberId = '';
                }
                if (json.role != null) {
                  result.role = $root.wix.social.groups.api.v1.RoleInGroup[json.role];
                } else {
                  result.role = 'GROUP_MEMBER';
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.groupId != null) {
                    grpc.groupId = obj.groupId;
                  }
                  if (obj.siteMemberId != null) {
                    grpc.siteMemberId = obj.siteMemberId;
                  }
                  if (obj.role != null) {
                    grpc.role = obj.role;
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.wix.social.groups.api.v1.SetMemberRoleRequest();

                  if (grpc.groupId != null) {
                    result.groupId = grpc.groupId;
                  } else {
                    result.groupId = '';
                  }
                  if (grpc.siteMemberId != null) {
                    result.siteMemberId = grpc.siteMemberId;
                  } else {
                    result.siteMemberId = '';
                  }
                  if (grpc.role != null) {
                    result.role = grpc.role;
                  } else {
                    result.role = 'GROUP_MEMBER';
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'groupId': {
                      'type': 'string',
                      'id': 1,
                      'options': {
                        '(wix.api.format)': 'GUID'
                      }
                    },
                    'siteMemberId': {
                      'type': 'string',
                      'id': 2,
                      'options': {
                        '(wix.api.format)': 'GUID'
                      }
                    },
                    'role': {
                      'type': $root.wix.social.groups.api.v1.RoleInGroup,
                      'id': 3
                    }
                  }
                };
              }
            }

            Object.defineProperty(SetMemberRoleRequest.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.SetMemberRoleRequest');
              },
              enumerable: false,
              configurable: false
            });
            return SetMemberRoleRequest;
          }());
          v1.RemoveMemberRoleRequest = (function() {

            class RemoveMemberRoleRequest {

              constructor(props) {
                this.groupId = props && props.groupId;
                this.siteMemberId = props && props.siteMemberId;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.groupId != null) {
                    if (typeof msg.groupId !== 'string') {
                      errors.field('groupId').error('string expected');
                    }
                  }
                  if (msg.siteMemberId != null) {
                    if (typeof msg.siteMemberId !== 'string') {
                      errors.field('siteMemberId').error('string expected');
                    }
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.groupId != null) {
                    json.groupId = obj.groupId;
                  }
                  if (obj.siteMemberId != null) {
                    json.siteMemberId = obj.siteMemberId;
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.wix.social.groups.api.v1.RemoveMemberRoleRequest();

                if (json.groupId != null) {
                  result.groupId = json.groupId;
                } else {
                  result.groupId = '';
                }
                if (json.siteMemberId != null) {
                  result.siteMemberId = json.siteMemberId;
                } else {
                  result.siteMemberId = '';
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.groupId != null) {
                    grpc.groupId = obj.groupId;
                  }
                  if (obj.siteMemberId != null) {
                    grpc.siteMemberId = obj.siteMemberId;
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.wix.social.groups.api.v1.RemoveMemberRoleRequest();

                  if (grpc.groupId != null) {
                    result.groupId = grpc.groupId;
                  } else {
                    result.groupId = '';
                  }
                  if (grpc.siteMemberId != null) {
                    result.siteMemberId = grpc.siteMemberId;
                  } else {
                    result.siteMemberId = '';
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'groupId': {
                      'type': 'string',
                      'id': 1,
                      'options': {
                        '(wix.api.format)': 'GUID'
                      }
                    },
                    'siteMemberId': {
                      'type': 'string',
                      'id': 2,
                      'options': {
                        '(wix.api.format)': 'GUID'
                      }
                    }
                  }
                };
              }
            }

            Object.defineProperty(RemoveMemberRoleRequest.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.RemoveMemberRoleRequest');
              },
              enumerable: false,
              configurable: false
            });
            return RemoveMemberRoleRequest;
          }());
          v1.SocialGroupsRolesService = (function() {

            class SocialGroupsRolesService {

              constructor() {
                if (this.constructor.name === SocialGroupsRolesService.name) {
                  throw new TypeError('class SocialGroupsRolesService is abstract');
                }
              }

              setMemberRole(aspects, msg) {
                throw new TypeError('method setMemberRole is abstract');
              }

              removeMemberRole(aspects, msg) {
                throw new TypeError('method removeMemberRole is abstract');
              }
            }

            SocialGroupsRolesService.prototype.setMemberRole._messageTypes = function() {
              return [
                $root.wix.social.groups.api.v1.SetMemberRoleRequest,
                $root.google.protobuf.Empty
              ];
            };
            SocialGroupsRolesService.prototype.removeMemberRole._messageTypes = function() {
              return [
                $root.wix.social.groups.api.v1.RemoveMemberRoleRequest,
                $root.google.protobuf.Empty
              ];
            };
            SocialGroupsRolesService.prototype.setMemberRole.__proto = pbjs => {
              return $root.__lookup(pbjs)('wix.social.groups.api.v1.SocialGroupsRolesService.SetMemberRole');
            };
            SocialGroupsRolesService.prototype.removeMemberRole.__proto = pbjs => {
              return $root.__lookup(pbjs)('wix.social.groups.api.v1.SocialGroupsRolesService.RemoveMemberRole');
            };
            Object.defineProperty(SocialGroupsRolesService.prototype, '__isRpcService__', {
              value: true,
              enumerable: false,
              configurable: false
            });
            Object.defineProperty(SocialGroupsRolesService.prototype, '__fqn__', {
              value: 'wix.social.groups.api.v1.SocialGroupsRolesService',
              enumerable: false,
              configurable: false
            });
            Object.defineProperty(SocialGroupsRolesService.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.SocialGroupsRolesService');
              },
              enumerable: false,
              configurable: false
            });
            Object.defineProperty(SocialGroupsRolesService.prototype, '__options__', {
              value: $root.__options,
              enumerable: false,
              configurable: false
            });
            return SocialGroupsRolesService;
          }());
          v1.UpdateGroupsInstanceSettingsRequest = (function() {

            class UpdateGroupsInstanceSettingsRequest {

              constructor(props) {
                this.fieldMask = props && props.fieldMask;
                this.settings = props && props.settings;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.fieldMask != null) {
                    $root.google.protobuf.FieldMask.verify(msg.fieldMask, helper, errors.field('fieldMask'));
                  }
                  if (msg.settings != null) {
                    $root.wix.social.groups.api.v1.GroupsInstanceSettings.verify(msg.settings, helper, errors.field('settings'));
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.fieldMask != null) {
                    json.fieldMask = $root.google.protobuf.FieldMask.toJSON(obj.fieldMask, helper);
                  }
                  if (obj.settings != null) {
                    json.settings = $root.wix.social.groups.api.v1.GroupsInstanceSettings.toJSON(obj.settings, helper);
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.wix.social.groups.api.v1.UpdateGroupsInstanceSettingsRequest();

                if (json.fieldMask != null) {
                  result.fieldMask = $root.google.protobuf.FieldMask.fromJSON(json.fieldMask, helper);
                } else {
                  delete result.fieldMask;
                }
                if (json.settings != null) {
                  result.settings = $root.wix.social.groups.api.v1.GroupsInstanceSettings.fromJSON(json.settings, helper);
                } else {
                  delete result.settings;
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.fieldMask != null) {
                    grpc.fieldMask = $root.google.protobuf.FieldMask.toGRPC(obj.fieldMask, helper);
                  }
                  if (obj.settings != null) {
                    grpc.settings = $root.wix.social.groups.api.v1.GroupsInstanceSettings.toGRPC(obj.settings, helper);
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.wix.social.groups.api.v1.UpdateGroupsInstanceSettingsRequest();

                  if (grpc.fieldMask != null) {
                    result.fieldMask = $root.google.protobuf.FieldMask.fromGRPC(grpc.fieldMask, helper);
                  } else {
                    delete result.fieldMask;
                  }
                  if (grpc.settings != null) {
                    result.settings = $root.wix.social.groups.api.v1.GroupsInstanceSettings.fromGRPC(grpc.settings, helper);
                  } else {
                    delete result.settings;
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'fieldMask': {
                      'type': $root.google.protobuf.FieldMask,
                      'id': 1
                    },
                    'settings': {
                      'type': $root.wix.social.groups.api.v1.GroupsInstanceSettings,
                      'id': 2
                    }
                  }
                };
              }
            }

            Object.defineProperty(UpdateGroupsInstanceSettingsRequest.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.UpdateGroupsInstanceSettingsRequest');
              },
              enumerable: false,
              configurable: false
            });
            return UpdateGroupsInstanceSettingsRequest;
          }());
          v1.GetGroupsInstanceSettingsRequest = (function() {

            class GetGroupsInstanceSettingsRequest {

              constructor(props) {}

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (!(typeof msg === 'object' && !Array.isArray(msg) && Object.keys(msg).length === 0)) {
                    errors.error('empty object expected');
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.wix.social.groups.api.v1.GetGroupsInstanceSettingsRequest();

                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.wix.social.groups.api.v1.GetGroupsInstanceSettingsRequest();

                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {}
                };
              }
            }

            Object.defineProperty(GetGroupsInstanceSettingsRequest.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.GetGroupsInstanceSettingsRequest');
              },
              enumerable: false,
              configurable: false
            });
            return GetGroupsInstanceSettingsRequest;
          }());
          v1.GroupsInstanceSettingsResponse = (function() {

            class GroupsInstanceSettingsResponse {

              constructor(props) {
                this.settings = props && props.settings;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.settings != null) {
                    $root.wix.social.groups.api.v1.GroupsInstanceSettings.verify(msg.settings, helper, errors.field('settings'));
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.settings != null) {
                    json.settings = $root.wix.social.groups.api.v1.GroupsInstanceSettings.toJSON(obj.settings, helper);
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.wix.social.groups.api.v1.GroupsInstanceSettingsResponse();

                if (json.settings != null) {
                  result.settings = $root.wix.social.groups.api.v1.GroupsInstanceSettings.fromJSON(json.settings, helper);
                } else {
                  delete result.settings;
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.settings != null) {
                    grpc.settings = $root.wix.social.groups.api.v1.GroupsInstanceSettings.toGRPC(obj.settings, helper);
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.wix.social.groups.api.v1.GroupsInstanceSettingsResponse();

                  if (grpc.settings != null) {
                    result.settings = $root.wix.social.groups.api.v1.GroupsInstanceSettings.fromGRPC(grpc.settings, helper);
                  } else {
                    delete result.settings;
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'settings': {
                      'type': $root.wix.social.groups.api.v1.GroupsInstanceSettings,
                      'id': 1
                    }
                  }
                };
              }
            }

            Object.defineProperty(GroupsInstanceSettingsResponse.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.GroupsInstanceSettingsResponse');
              },
              enumerable: false,
              configurable: false
            });
            return GroupsInstanceSettingsResponse;
          }());
          v1.CreateGroupRequest = (function() {

            class CreateGroupRequest {

              constructor(props) {
                this.details = props && props.details;
                this.settings = props && props.settings;
                this.requestDetails = props && props.requestDetails;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.details != null) {
                    $root.wix.social.groups.api.v1.GroupDetails.verify(msg.details, helper, errors.field('details'));
                  }
                  if (msg.settings != null) {
                    $root.wix.social.groups.api.v1.GroupSettings.verify(msg.settings, helper, errors.field('settings'));
                  }
                  if (msg.requestDetails != null) {
                    $root.wix.social.groups.api.v1.GroupRequestDetails.verify(msg.requestDetails, helper, errors.field('requestDetails'));
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.details != null) {
                    json.details = $root.wix.social.groups.api.v1.GroupDetails.toJSON(obj.details, helper);
                  }
                  if (obj.settings != null) {
                    json.settings = $root.wix.social.groups.api.v1.GroupSettings.toJSON(obj.settings, helper);
                  }
                  if (obj.requestDetails != null) {
                    json.requestDetails = $root.wix.social.groups.api.v1.GroupRequestDetails.toJSON(obj.requestDetails, helper);
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.wix.social.groups.api.v1.CreateGroupRequest();

                if (json.details != null) {
                  result.details = $root.wix.social.groups.api.v1.GroupDetails.fromJSON(json.details, helper);
                } else {
                  delete result.details;
                }
                if (json.settings != null) {
                  result.settings = $root.wix.social.groups.api.v1.GroupSettings.fromJSON(json.settings, helper);
                } else {
                  delete result.settings;
                }
                if (json.requestDetails != null) {
                  result.requestDetails = $root.wix.social.groups.api.v1.GroupRequestDetails.fromJSON(json.requestDetails, helper);
                } else {
                  delete result.requestDetails;
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.details != null) {
                    grpc.details = $root.wix.social.groups.api.v1.GroupDetails.toGRPC(obj.details, helper);
                  }
                  if (obj.settings != null) {
                    grpc.settings = $root.wix.social.groups.api.v1.GroupSettings.toGRPC(obj.settings, helper);
                  }
                  if (obj.requestDetails != null) {
                    grpc.requestDetails = $root.wix.social.groups.api.v1.GroupRequestDetails.toGRPC(obj.requestDetails, helper);
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.wix.social.groups.api.v1.CreateGroupRequest();

                  if (grpc.details != null) {
                    result.details = $root.wix.social.groups.api.v1.GroupDetails.fromGRPC(grpc.details, helper);
                  } else {
                    delete result.details;
                  }
                  if (grpc.settings != null) {
                    result.settings = $root.wix.social.groups.api.v1.GroupSettings.fromGRPC(grpc.settings, helper);
                  } else {
                    delete result.settings;
                  }
                  if (grpc.requestDetails != null) {
                    result.requestDetails = $root.wix.social.groups.api.v1.GroupRequestDetails.fromGRPC(grpc.requestDetails, helper);
                  } else {
                    delete result.requestDetails;
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'details': {
                      'type': $root.wix.social.groups.api.v1.GroupDetails,
                      'id': 1
                    },
                    'settings': {
                      'type': $root.wix.social.groups.api.v1.GroupSettings,
                      'id': 2
                    },
                    'requestDetails': {
                      'type': $root.wix.social.groups.api.v1.GroupRequestDetails,
                      'id': 3
                    }
                  }
                };
              }
            }

            Object.defineProperty(CreateGroupRequest.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.CreateGroupRequest');
              },
              enumerable: false,
              configurable: false
            });
            return CreateGroupRequest;
          }());
          v1.UpdateGroupRequest = (function() {

            class UpdateGroupRequest {

              constructor(props) {
                this.fieldMask = props && props.fieldMask;
                this.groupId = props && props.groupId;
                this.details = props && props.details;
                this.settings = props && props.settings;
                this.requestDetails = props && props.requestDetails;
                this.approvalStatus = props && props.approvalStatus;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.fieldMask != null) {
                    $root.google.protobuf.FieldMask.verify(msg.fieldMask, helper, errors.field('fieldMask'));
                  }
                  if (msg.groupId != null) {
                    if (typeof msg.groupId !== 'string') {
                      errors.field('groupId').error('string expected');
                    }
                  }
                  if (msg.details != null) {
                    $root.wix.social.groups.api.v1.GroupDetails.verify(msg.details, helper, errors.field('details'));
                  }
                  if (msg.settings != null) {
                    $root.wix.social.groups.api.v1.GroupSettings.verify(msg.settings, helper, errors.field('settings'));
                  }
                  if (msg.requestDetails != null) {
                    $root.wix.social.groups.api.v1.GroupRequestDetails.verify(msg.requestDetails, helper, errors.field('requestDetails'));
                  }
                  if (msg.approvalStatus != null) {
                    $root.wix.social.groups.api.v1.GroupApprovalStatus.verify(msg.approvalStatus, helper, errors.field('approvalStatus'));
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.fieldMask != null) {
                    json.fieldMask = $root.google.protobuf.FieldMask.toJSON(obj.fieldMask, helper);
                  }
                  if (obj.groupId != null) {
                    json.groupId = obj.groupId;
                  }
                  if (obj.details != null) {
                    json.details = $root.wix.social.groups.api.v1.GroupDetails.toJSON(obj.details, helper);
                  }
                  if (obj.settings != null) {
                    json.settings = $root.wix.social.groups.api.v1.GroupSettings.toJSON(obj.settings, helper);
                  }
                  if (obj.requestDetails != null) {
                    json.requestDetails = $root.wix.social.groups.api.v1.GroupRequestDetails.toJSON(obj.requestDetails, helper);
                  }
                  if (obj.approvalStatus != null) {
                    json.approvalStatus = $root.wix.social.groups.api.v1.GroupApprovalStatus[obj.approvalStatus];
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.wix.social.groups.api.v1.UpdateGroupRequest();

                if (json.fieldMask != null) {
                  result.fieldMask = $root.google.protobuf.FieldMask.fromJSON(json.fieldMask, helper);
                } else {
                  delete result.fieldMask;
                }
                if (json.groupId != null) {
                  result.groupId = json.groupId;
                } else {
                  result.groupId = '';
                }
                if (json.details != null) {
                  result.details = $root.wix.social.groups.api.v1.GroupDetails.fromJSON(json.details, helper);
                } else {
                  delete result.details;
                }
                if (json.settings != null) {
                  result.settings = $root.wix.social.groups.api.v1.GroupSettings.fromJSON(json.settings, helper);
                } else {
                  delete result.settings;
                }
                if (json.requestDetails != null) {
                  result.requestDetails = $root.wix.social.groups.api.v1.GroupRequestDetails.fromJSON(json.requestDetails, helper);
                } else {
                  delete result.requestDetails;
                }
                if (json.approvalStatus != null) {
                  result.approvalStatus = $root.wix.social.groups.api.v1.GroupApprovalStatus[json.approvalStatus];
                } else {
                  result.approvalStatus = 'EMPTY';
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.fieldMask != null) {
                    grpc.fieldMask = $root.google.protobuf.FieldMask.toGRPC(obj.fieldMask, helper);
                  }
                  if (obj.groupId != null) {
                    grpc.groupId = obj.groupId;
                  }
                  if (obj.details != null) {
                    grpc.details = $root.wix.social.groups.api.v1.GroupDetails.toGRPC(obj.details, helper);
                  }
                  if (obj.settings != null) {
                    grpc.settings = $root.wix.social.groups.api.v1.GroupSettings.toGRPC(obj.settings, helper);
                  }
                  if (obj.requestDetails != null) {
                    grpc.requestDetails = $root.wix.social.groups.api.v1.GroupRequestDetails.toGRPC(obj.requestDetails, helper);
                  }
                  if (obj.approvalStatus != null) {
                    grpc.approvalStatus = obj.approvalStatus;
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.wix.social.groups.api.v1.UpdateGroupRequest();

                  if (grpc.fieldMask != null) {
                    result.fieldMask = $root.google.protobuf.FieldMask.fromGRPC(grpc.fieldMask, helper);
                  } else {
                    delete result.fieldMask;
                  }
                  if (grpc.groupId != null) {
                    result.groupId = grpc.groupId;
                  } else {
                    result.groupId = '';
                  }
                  if (grpc.details != null) {
                    result.details = $root.wix.social.groups.api.v1.GroupDetails.fromGRPC(grpc.details, helper);
                  } else {
                    delete result.details;
                  }
                  if (grpc.settings != null) {
                    result.settings = $root.wix.social.groups.api.v1.GroupSettings.fromGRPC(grpc.settings, helper);
                  } else {
                    delete result.settings;
                  }
                  if (grpc.requestDetails != null) {
                    result.requestDetails = $root.wix.social.groups.api.v1.GroupRequestDetails.fromGRPC(grpc.requestDetails, helper);
                  } else {
                    delete result.requestDetails;
                  }
                  if (grpc.approvalStatus != null) {
                    result.approvalStatus = grpc.approvalStatus;
                  } else {
                    result.approvalStatus = 'EMPTY';
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'fieldMask': {
                      'type': $root.google.protobuf.FieldMask,
                      'id': 1
                    },
                    'groupId': {
                      'type': 'string',
                      'id': 2,
                      'options': {
                        '(wix.api.format)': 'GUID'
                      }
                    },
                    'details': {
                      'type': $root.wix.social.groups.api.v1.GroupDetails,
                      'id': 3
                    },
                    'settings': {
                      'type': $root.wix.social.groups.api.v1.GroupSettings,
                      'id': 4
                    },
                    'requestDetails': {
                      'type': $root.wix.social.groups.api.v1.GroupRequestDetails,
                      'id': 5
                    },
                    'approvalStatus': {
                      'type': $root.wix.social.groups.api.v1.GroupApprovalStatus,
                      'id': 6
                    }
                  }
                };
              }
            }

            Object.defineProperty(UpdateGroupRequest.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.UpdateGroupRequest');
              },
              enumerable: false,
              configurable: false
            });
            return UpdateGroupRequest;
          }());
          v1.ListGroupsRequest = (function() {

            class ListGroupsRequest {

              constructor(props) {
                this.relationship = props && props.relationship;
                this.role = props && props.role;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.relationship != null) {
                    const fieldErrors = errors.field('relationship');

                    if (!Array.isArray(msg.relationship)) {
                      fieldErrors.error('array expected');
                    } else {
                      msg.relationship.forEach((value, index) => {
                        $root.wix.social.groups.api.v1.RelationshipWithGroup.verify(value, helper, fieldErrors.index(index));
                      });
                    }
                  }
                  if (msg.role != null) {
                    const fieldErrors = errors.field('role');

                    if (!Array.isArray(msg.role)) {
                      fieldErrors.error('array expected');
                    } else {
                      msg.role.forEach((value, index) => {
                        $root.wix.social.groups.api.v1.RoleInGroup.verify(value, helper, fieldErrors.index(index));
                      });
                    }
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.relationship != null) {
                    json.relationship = obj.relationship.map(e => {
                      return $root.wix.social.groups.api.v1.RelationshipWithGroup[e];
                    });
                  }
                  if (obj.role != null) {
                    json.role = obj.role.map(e => {
                      return $root.wix.social.groups.api.v1.RoleInGroup[e];
                    });
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.wix.social.groups.api.v1.ListGroupsRequest();

                if (json.relationship != null) {
                  result.relationship = json.relationship.map(e => {
                    return $root.wix.social.groups.api.v1.RelationshipWithGroup[e];
                  });
                } else {
                  result.relationship = [];
                }
                if (json.role != null) {
                  result.role = json.role.map(e => {
                    return $root.wix.social.groups.api.v1.RoleInGroup[e];
                  });
                } else {
                  result.role = [];
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.relationship != null) {
                    grpc.relationship = obj.relationship.map(e => {
                      return e;
                    });
                  }
                  if (obj.role != null) {
                    grpc.role = obj.role.map(e => {
                      return e;
                    });
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.wix.social.groups.api.v1.ListGroupsRequest();

                  if (grpc.relationship != null) {
                    result.relationship = grpc.relationship.map(e => {
                      return e;
                    });
                  } else {
                    result.relationship = [];
                  }
                  if (grpc.role != null) {
                    result.role = grpc.role.map(e => {
                      return e;
                    });
                  } else {
                    result.role = [];
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'relationship': {
                      'rule': 'repeated',
                      'type': $root.wix.social.groups.api.v1.RelationshipWithGroup,
                      'id': 1
                    },
                    'role': {
                      'rule': 'repeated',
                      'type': $root.wix.social.groups.api.v1.RoleInGroup,
                      'id': 2
                    }
                  }
                };
              }
            }

            Object.defineProperty(ListGroupsRequest.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.ListGroupsRequest');
              },
              enumerable: false,
              configurable: false
            });
            return ListGroupsRequest;
          }());
          v1.ArchiveGroupRequest = (function() {

            class ArchiveGroupRequest {

              constructor(props) {
                this.groupId = props && props.groupId;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.groupId != null) {
                    if (typeof msg.groupId !== 'string') {
                      errors.field('groupId').error('string expected');
                    }
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.groupId != null) {
                    json.groupId = obj.groupId;
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.wix.social.groups.api.v1.ArchiveGroupRequest();

                if (json.groupId != null) {
                  result.groupId = json.groupId;
                } else {
                  result.groupId = '';
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.groupId != null) {
                    grpc.groupId = obj.groupId;
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.wix.social.groups.api.v1.ArchiveGroupRequest();

                  if (grpc.groupId != null) {
                    result.groupId = grpc.groupId;
                  } else {
                    result.groupId = '';
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'groupId': {
                      'type': 'string',
                      'id': 1,
                      'options': {
                        '(wix.api.format)': 'GUID'
                      }
                    }
                  }
                };
              }
            }

            Object.defineProperty(ArchiveGroupRequest.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.ArchiveGroupRequest');
              },
              enumerable: false,
              configurable: false
            });
            return ArchiveGroupRequest;
          }());
          v1.DeleteGroupRequest = (function() {

            class DeleteGroupRequest {

              constructor(props) {
                this.groupId = props && props.groupId;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.groupId != null) {
                    if (typeof msg.groupId !== 'string') {
                      errors.field('groupId').error('string expected');
                    }
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.groupId != null) {
                    json.groupId = obj.groupId;
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.wix.social.groups.api.v1.DeleteGroupRequest();

                if (json.groupId != null) {
                  result.groupId = json.groupId;
                } else {
                  result.groupId = '';
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.groupId != null) {
                    grpc.groupId = obj.groupId;
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.wix.social.groups.api.v1.DeleteGroupRequest();

                  if (grpc.groupId != null) {
                    result.groupId = grpc.groupId;
                  } else {
                    result.groupId = '';
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'groupId': {
                      'type': 'string',
                      'id': 1,
                      'options': {
                        '(wix.api.format)': 'GUID'
                      }
                    }
                  }
                };
              }
            }

            Object.defineProperty(DeleteGroupRequest.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.DeleteGroupRequest');
              },
              enumerable: false,
              configurable: false
            });
            return DeleteGroupRequest;
          }());
          v1.GetGroupRequest = (function() {

            class GetGroupRequest {

              constructor(props) {
                this.groupId = props && props.groupId;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.groupId != null) {
                    if (typeof msg.groupId !== 'string') {
                      errors.field('groupId').error('string expected');
                    }
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.groupId != null) {
                    json.groupId = obj.groupId;
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.wix.social.groups.api.v1.GetGroupRequest();

                if (json.groupId != null) {
                  result.groupId = json.groupId;
                } else {
                  result.groupId = '';
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.groupId != null) {
                    grpc.groupId = obj.groupId;
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.wix.social.groups.api.v1.GetGroupRequest();

                  if (grpc.groupId != null) {
                    result.groupId = grpc.groupId;
                  } else {
                    result.groupId = '';
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'groupId': {
                      'type': 'string',
                      'id': 1
                    }
                  }
                };
              }
            }

            Object.defineProperty(GetGroupRequest.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.GetGroupRequest');
              },
              enumerable: false,
              configurable: false
            });
            return GetGroupRequest;
          }());
          v1.GroupResponse = (function() {

            class GroupResponse {

              constructor(props) {
                this.groupId = props && props.groupId;
                this.relationship = props && props.relationship;
                this.roles = props && props.roles;
                this.details = props && props.details;
                this.settings = props && props.settings;
                this.memberCount = props && props.memberCount;
                this.createdBy = props && props.createdBy;
                this.requestDetails = props && props.requestDetails;
                this.approvalStatus = props && props.approvalStatus;
                this.slug = props && props.slug;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.groupId != null) {
                    if (typeof msg.groupId !== 'string') {
                      errors.field('groupId').error('string expected');
                    }
                  }
                  if (msg.relationship != null) {
                    $root.wix.social.groups.api.v1.RelationshipWithGroup.verify(msg.relationship, helper, errors.field('relationship'));
                  }
                  if (msg.roles != null) {
                    const fieldErrors = errors.field('roles');

                    if (!Array.isArray(msg.roles)) {
                      fieldErrors.error('array expected');
                    } else {
                      msg.roles.forEach((value, index) => {
                        $root.wix.social.groups.api.v1.RoleInGroup.verify(value, helper, fieldErrors.index(index));
                      });
                    }
                  }
                  if (msg.details != null) {
                    $root.wix.social.groups.api.v1.GroupDetails.verify(msg.details, helper, errors.field('details'));
                  }
                  if (msg.settings != null) {
                    $root.wix.social.groups.api.v1.GroupSettings.verify(msg.settings, helper, errors.field('settings'));
                  }
                  if (msg.memberCount != null) {
                    $root.google.protobuf.Int32Value.verify(msg.memberCount, helper, errors.field('memberCount'));
                  }
                  if (msg.createdBy != null) {
                    $root.wix.social.groups.api.v1.GroupMemberProfile.verify(msg.createdBy, helper, errors.field('createdBy'));
                  }
                  if (msg.requestDetails != null) {
                    $root.wix.social.groups.api.v1.GroupRequestDetails.verify(msg.requestDetails, helper, errors.field('requestDetails'));
                  }
                  if (msg.approvalStatus != null) {
                    $root.wix.social.groups.api.v1.GroupApprovalStatus.verify(msg.approvalStatus, helper, errors.field('approvalStatus'));
                  }
                  if (msg.slug != null) {
                    $root.google.protobuf.StringValue.verify(msg.slug, helper, errors.field('slug'));
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.groupId != null) {
                    json.groupId = obj.groupId;
                  }
                  if (obj.relationship != null) {
                    json.relationship = $root.wix.social.groups.api.v1.RelationshipWithGroup[obj.relationship];
                  }
                  if (obj.roles != null) {
                    json.roles = obj.roles.map(e => {
                      return $root.wix.social.groups.api.v1.RoleInGroup[e];
                    });
                  }
                  if (obj.details != null) {
                    json.details = $root.wix.social.groups.api.v1.GroupDetails.toJSON(obj.details, helper);
                  }
                  if (obj.settings != null) {
                    json.settings = $root.wix.social.groups.api.v1.GroupSettings.toJSON(obj.settings, helper);
                  }
                  if (obj.memberCount != null) {
                    json.memberCount = $root.google.protobuf.Int32Value.toJSON(obj.memberCount, helper);
                  }
                  if (obj.createdBy != null) {
                    json.createdBy = $root.wix.social.groups.api.v1.GroupMemberProfile.toJSON(obj.createdBy, helper);
                  }
                  if (obj.requestDetails != null) {
                    json.requestDetails = $root.wix.social.groups.api.v1.GroupRequestDetails.toJSON(obj.requestDetails, helper);
                  }
                  if (obj.approvalStatus != null) {
                    json.approvalStatus = $root.wix.social.groups.api.v1.GroupApprovalStatus[obj.approvalStatus];
                  }
                  if (obj.slug != null) {
                    json.slug = $root.google.protobuf.StringValue.toJSON(obj.slug, helper);
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.wix.social.groups.api.v1.GroupResponse();

                if (json.groupId != null) {
                  result.groupId = json.groupId;
                } else {
                  result.groupId = '';
                }
                if (json.relationship != null) {
                  result.relationship = $root.wix.social.groups.api.v1.RelationshipWithGroup[json.relationship];
                } else {
                  result.relationship = 'NONE';
                }
                if (json.roles != null) {
                  result.roles = json.roles.map(e => {
                    return $root.wix.social.groups.api.v1.RoleInGroup[e];
                  });
                } else {
                  result.roles = [];
                }
                if (json.details != null) {
                  result.details = $root.wix.social.groups.api.v1.GroupDetails.fromJSON(json.details, helper);
                } else {
                  delete result.details;
                }
                if (json.settings != null) {
                  result.settings = $root.wix.social.groups.api.v1.GroupSettings.fromJSON(json.settings, helper);
                } else {
                  delete result.settings;
                }
                if (json.memberCount != null) {
                  result.memberCount = $root.google.protobuf.Int32Value.fromJSON(json.memberCount, helper);
                } else {
                  delete result.memberCount;
                }
                if (json.createdBy != null) {
                  result.createdBy = $root.wix.social.groups.api.v1.GroupMemberProfile.fromJSON(json.createdBy, helper);
                } else {
                  delete result.createdBy;
                }
                if (json.requestDetails != null) {
                  result.requestDetails = $root.wix.social.groups.api.v1.GroupRequestDetails.fromJSON(json.requestDetails, helper);
                } else {
                  delete result.requestDetails;
                }
                if (json.approvalStatus != null) {
                  result.approvalStatus = $root.wix.social.groups.api.v1.GroupApprovalStatus[json.approvalStatus];
                } else {
                  result.approvalStatus = 'EMPTY';
                }
                if (json.slug != null) {
                  result.slug = $root.google.protobuf.StringValue.fromJSON(json.slug, helper);
                } else {
                  delete result.slug;
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.groupId != null) {
                    grpc.groupId = obj.groupId;
                  }
                  if (obj.relationship != null) {
                    grpc.relationship = obj.relationship;
                  }
                  if (obj.roles != null) {
                    grpc.roles = obj.roles.map(e => {
                      return e;
                    });
                  }
                  if (obj.details != null) {
                    grpc.details = $root.wix.social.groups.api.v1.GroupDetails.toGRPC(obj.details, helper);
                  }
                  if (obj.settings != null) {
                    grpc.settings = $root.wix.social.groups.api.v1.GroupSettings.toGRPC(obj.settings, helper);
                  }
                  if (obj.memberCount != null) {
                    grpc.memberCount = $root.google.protobuf.Int32Value.toGRPC(obj.memberCount, helper);
                  }
                  if (obj.createdBy != null) {
                    grpc.createdBy = $root.wix.social.groups.api.v1.GroupMemberProfile.toGRPC(obj.createdBy, helper);
                  }
                  if (obj.requestDetails != null) {
                    grpc.requestDetails = $root.wix.social.groups.api.v1.GroupRequestDetails.toGRPC(obj.requestDetails, helper);
                  }
                  if (obj.approvalStatus != null) {
                    grpc.approvalStatus = obj.approvalStatus;
                  }
                  if (obj.slug != null) {
                    grpc.slug = $root.google.protobuf.StringValue.toGRPC(obj.slug, helper);
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.wix.social.groups.api.v1.GroupResponse();

                  if (grpc.groupId != null) {
                    result.groupId = grpc.groupId;
                  } else {
                    result.groupId = '';
                  }
                  if (grpc.relationship != null) {
                    result.relationship = grpc.relationship;
                  } else {
                    result.relationship = 'NONE';
                  }
                  if (grpc.roles != null) {
                    result.roles = grpc.roles.map(e => {
                      return e;
                    });
                  } else {
                    result.roles = [];
                  }
                  if (grpc.details != null) {
                    result.details = $root.wix.social.groups.api.v1.GroupDetails.fromGRPC(grpc.details, helper);
                  } else {
                    delete result.details;
                  }
                  if (grpc.settings != null) {
                    result.settings = $root.wix.social.groups.api.v1.GroupSettings.fromGRPC(grpc.settings, helper);
                  } else {
                    delete result.settings;
                  }
                  if (grpc.memberCount != null) {
                    result.memberCount = $root.google.protobuf.Int32Value.fromGRPC(grpc.memberCount, helper);
                  } else {
                    delete result.memberCount;
                  }
                  if (grpc.createdBy != null) {
                    result.createdBy = $root.wix.social.groups.api.v1.GroupMemberProfile.fromGRPC(grpc.createdBy, helper);
                  } else {
                    delete result.createdBy;
                  }
                  if (grpc.requestDetails != null) {
                    result.requestDetails = $root.wix.social.groups.api.v1.GroupRequestDetails.fromGRPC(grpc.requestDetails, helper);
                  } else {
                    delete result.requestDetails;
                  }
                  if (grpc.approvalStatus != null) {
                    result.approvalStatus = grpc.approvalStatus;
                  } else {
                    result.approvalStatus = 'EMPTY';
                  }
                  if (grpc.slug != null) {
                    result.slug = $root.google.protobuf.StringValue.fromGRPC(grpc.slug, helper);
                  } else {
                    delete result.slug;
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'groupId': {
                      'type': 'string',
                      'id': 1
                    },
                    'relationship': {
                      'type': $root.wix.social.groups.api.v1.RelationshipWithGroup,
                      'id': 2
                    },
                    'roles': {
                      'rule': 'repeated',
                      'type': $root.wix.social.groups.api.v1.RoleInGroup,
                      'id': 3
                    },
                    'details': {
                      'type': $root.wix.social.groups.api.v1.GroupDetails,
                      'id': 4
                    },
                    'settings': {
                      'type': $root.wix.social.groups.api.v1.GroupSettings,
                      'id': 5
                    },
                    'memberCount': {
                      'type': $root.google.protobuf.Int32Value,
                      'id': 6
                    },
                    'createdBy': {
                      'type': $root.wix.social.groups.api.v1.GroupMemberProfile,
                      'id': 7
                    },
                    'requestDetails': {
                      'type': $root.wix.social.groups.api.v1.GroupRequestDetails,
                      'id': 8
                    },
                    'approvalStatus': {
                      'type': $root.wix.social.groups.api.v1.GroupApprovalStatus,
                      'id': 9
                    },
                    'slug': {
                      'type': $root.google.protobuf.StringValue,
                      'id': 10
                    }
                  }
                };
              }
            }

            Object.defineProperty(GroupResponse.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.GroupResponse');
              },
              enumerable: false,
              configurable: false
            });
            return GroupResponse;
          }());
          v1.GroupMemberProfile = (function() {

            class GroupMemberProfile {

              constructor(props) {
                this.siteMemberId = props && props.siteMemberId;
                this.name = props && props.name;
                this.imageUrl = props && props.imageUrl;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.siteMemberId != null) {
                    if (typeof msg.siteMemberId !== 'string') {
                      errors.field('siteMemberId').error('string expected');
                    }
                  }
                  if (msg.name != null) {
                    $root.wix.social.groups.api.v1.MemberName.verify(msg.name, helper, errors.field('name'));
                  }
                  if (msg.imageUrl != null) {
                    $root.google.protobuf.StringValue.verify(msg.imageUrl, helper, errors.field('imageUrl'));
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.siteMemberId != null) {
                    json.siteMemberId = obj.siteMemberId;
                  }
                  if (obj.name != null) {
                    json.name = $root.wix.social.groups.api.v1.MemberName.toJSON(obj.name, helper);
                  }
                  if (obj.imageUrl != null) {
                    json.imageUrl = $root.google.protobuf.StringValue.toJSON(obj.imageUrl, helper);
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.wix.social.groups.api.v1.GroupMemberProfile();

                if (json.siteMemberId != null) {
                  result.siteMemberId = json.siteMemberId;
                } else {
                  result.siteMemberId = '';
                }
                if (json.name != null) {
                  result.name = $root.wix.social.groups.api.v1.MemberName.fromJSON(json.name, helper);
                } else {
                  delete result.name;
                }
                if (json.imageUrl != null) {
                  result.imageUrl = $root.google.protobuf.StringValue.fromJSON(json.imageUrl, helper);
                } else {
                  delete result.imageUrl;
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.siteMemberId != null) {
                    grpc.siteMemberId = obj.siteMemberId;
                  }
                  if (obj.name != null) {
                    grpc.name = $root.wix.social.groups.api.v1.MemberName.toGRPC(obj.name, helper);
                  }
                  if (obj.imageUrl != null) {
                    grpc.imageUrl = $root.google.protobuf.StringValue.toGRPC(obj.imageUrl, helper);
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.wix.social.groups.api.v1.GroupMemberProfile();

                  if (grpc.siteMemberId != null) {
                    result.siteMemberId = grpc.siteMemberId;
                  } else {
                    result.siteMemberId = '';
                  }
                  if (grpc.name != null) {
                    result.name = $root.wix.social.groups.api.v1.MemberName.fromGRPC(grpc.name, helper);
                  } else {
                    delete result.name;
                  }
                  if (grpc.imageUrl != null) {
                    result.imageUrl = $root.google.protobuf.StringValue.fromGRPC(grpc.imageUrl, helper);
                  } else {
                    delete result.imageUrl;
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'siteMemberId': {
                      'type': 'string',
                      'id': 1
                    },
                    'name': {
                      'type': $root.wix.social.groups.api.v1.MemberName,
                      'id': 2
                    },
                    'imageUrl': {
                      'type': $root.google.protobuf.StringValue,
                      'id': 3
                    }
                  }
                };
              }
            }

            Object.defineProperty(GroupMemberProfile.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.GroupMemberProfile');
              },
              enumerable: false,
              configurable: false
            });
            return GroupMemberProfile;
          }());
          v1.GetGroupResponse = (function() {

            class GetGroupResponse {

              constructor(props) {
                this.group = props && props.group;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.group != null) {
                    $root.wix.social.groups.api.v1.GroupResponse.verify(msg.group, helper, errors.field('group'));
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.group != null) {
                    json.group = $root.wix.social.groups.api.v1.GroupResponse.toJSON(obj.group, helper);
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.wix.social.groups.api.v1.GetGroupResponse();

                if (json.group != null) {
                  result.group = $root.wix.social.groups.api.v1.GroupResponse.fromJSON(json.group, helper);
                } else {
                  delete result.group;
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.group != null) {
                    grpc.group = $root.wix.social.groups.api.v1.GroupResponse.toGRPC(obj.group, helper);
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.wix.social.groups.api.v1.GetGroupResponse();

                  if (grpc.group != null) {
                    result.group = $root.wix.social.groups.api.v1.GroupResponse.fromGRPC(grpc.group, helper);
                  } else {
                    delete result.group;
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'group': {
                      'type': $root.wix.social.groups.api.v1.GroupResponse,
                      'id': 1
                    }
                  }
                };
              }
            }

            Object.defineProperty(GetGroupResponse.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.GetGroupResponse');
              },
              enumerable: false,
              configurable: false
            });
            return GetGroupResponse;
          }());
          v1.ListGroupsResponse = (function() {

            class ListGroupsResponse {

              constructor(props) {
                this.groups = props && props.groups;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.groups != null) {
                    const fieldErrors = errors.field('groups');

                    if (!Array.isArray(msg.groups)) {
                      fieldErrors.error('array expected');
                    } else {
                      msg.groups.forEach((value, index) => {
                        $root.wix.social.groups.api.v1.GroupResponse.verify(value, helper, fieldErrors.index(index));
                      });
                    }
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.groups != null) {
                    json.groups = obj.groups.map(e => {
                      return $root.wix.social.groups.api.v1.GroupResponse.toJSON(e, helper);
                    });
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.wix.social.groups.api.v1.ListGroupsResponse();

                if (json.groups != null) {
                  result.groups = json.groups.map(e => {
                    return $root.wix.social.groups.api.v1.GroupResponse.fromJSON(e, helper);
                  });
                } else {
                  result.groups = [];
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.groups != null) {
                    grpc.groups = obj.groups.map(e => {
                      return $root.wix.social.groups.api.v1.GroupResponse.toGRPC(e, helper);
                    });
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.wix.social.groups.api.v1.ListGroupsResponse();

                  if (grpc.groups != null) {
                    result.groups = grpc.groups.map(e => {
                      return $root.wix.social.groups.api.v1.GroupResponse.fromGRPC(e, helper);
                    });
                  } else {
                    result.groups = [];
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'groups': {
                      'rule': 'repeated',
                      'type': $root.wix.social.groups.api.v1.GroupResponse,
                      'id': 1
                    }
                  }
                };
              }
            }

            Object.defineProperty(ListGroupsResponse.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.ListGroupsResponse');
              },
              enumerable: false,
              configurable: false
            });
            return ListGroupsResponse;
          }());
          v1.SocialGroupsService = (function() {

            class SocialGroupsService {

              constructor() {
                if (this.constructor.name === SocialGroupsService.name) {
                  throw new TypeError('class SocialGroupsService is abstract');
                }
              }

              updateGroupsInstanceSettings(aspects, msg) {
                throw new TypeError('method updateGroupsInstanceSettings is abstract');
              }

              getGroupsInstanceSettings(aspects, msg) {
                throw new TypeError('method getGroupsInstanceSettings is abstract');
              }

              createGroup(aspects, msg) {
                throw new TypeError('method createGroup is abstract');
              }

              updateGroup(aspects, msg) {
                throw new TypeError('method updateGroup is abstract');
              }

              archiveGroup(aspects, msg) {
                throw new TypeError('method archiveGroup is abstract');
              }

              deleteGroup(aspects, msg) {
                throw new TypeError('method deleteGroup is abstract');
              }

              getGroup(aspects, msg) {
                throw new TypeError('method getGroup is abstract');
              }

              listGroups(aspects, msg) {
                throw new TypeError('method listGroups is abstract');
              }
            }

            SocialGroupsService.prototype.updateGroupsInstanceSettings._messageTypes = function() {
              return [
                $root.wix.social.groups.api.v1.UpdateGroupsInstanceSettingsRequest,
                $root.wix.social.groups.api.v1.GroupsInstanceSettingsResponse
              ];
            };
            SocialGroupsService.prototype.getGroupsInstanceSettings._messageTypes = function() {
              return [
                $root.wix.social.groups.api.v1.GetGroupsInstanceSettingsRequest,
                $root.wix.social.groups.api.v1.GroupsInstanceSettingsResponse
              ];
            };
            SocialGroupsService.prototype.createGroup._messageTypes = function() {
              return [
                $root.wix.social.groups.api.v1.CreateGroupRequest,
                $root.wix.social.groups.api.v1.GroupResponse
              ];
            };
            SocialGroupsService.prototype.updateGroup._messageTypes = function() {
              return [
                $root.wix.social.groups.api.v1.UpdateGroupRequest,
                $root.wix.social.groups.api.v1.GroupResponse
              ];
            };
            SocialGroupsService.prototype.archiveGroup._messageTypes = function() {
              return [
                $root.wix.social.groups.api.v1.ArchiveGroupRequest,
                $root.google.protobuf.Empty
              ];
            };
            SocialGroupsService.prototype.deleteGroup._messageTypes = function() {
              return [
                $root.wix.social.groups.api.v1.DeleteGroupRequest,
                $root.google.protobuf.Empty
              ];
            };
            SocialGroupsService.prototype.getGroup._messageTypes = function() {
              return [
                $root.wix.social.groups.api.v1.GetGroupRequest,
                $root.wix.social.groups.api.v1.GetGroupResponse
              ];
            };
            SocialGroupsService.prototype.listGroups._messageTypes = function() {
              return [
                $root.wix.social.groups.api.v1.ListGroupsRequest,
                $root.wix.social.groups.api.v1.ListGroupsResponse
              ];
            };
            SocialGroupsService.prototype.updateGroupsInstanceSettings.__proto = pbjs => {
              return $root.__lookup(pbjs)('wix.social.groups.api.v1.SocialGroupsService.UpdateGroupsInstanceSettings');
            };
            SocialGroupsService.prototype.getGroupsInstanceSettings.__proto = pbjs => {
              return $root.__lookup(pbjs)('wix.social.groups.api.v1.SocialGroupsService.GetGroupsInstanceSettings');
            };
            SocialGroupsService.prototype.createGroup.__proto = pbjs => {
              return $root.__lookup(pbjs)('wix.social.groups.api.v1.SocialGroupsService.CreateGroup');
            };
            SocialGroupsService.prototype.updateGroup.__proto = pbjs => {
              return $root.__lookup(pbjs)('wix.social.groups.api.v1.SocialGroupsService.UpdateGroup');
            };
            SocialGroupsService.prototype.archiveGroup.__proto = pbjs => {
              return $root.__lookup(pbjs)('wix.social.groups.api.v1.SocialGroupsService.ArchiveGroup');
            };
            SocialGroupsService.prototype.deleteGroup.__proto = pbjs => {
              return $root.__lookup(pbjs)('wix.social.groups.api.v1.SocialGroupsService.DeleteGroup');
            };
            SocialGroupsService.prototype.getGroup.__proto = pbjs => {
              return $root.__lookup(pbjs)('wix.social.groups.api.v1.SocialGroupsService.GetGroup');
            };
            SocialGroupsService.prototype.listGroups.__proto = pbjs => {
              return $root.__lookup(pbjs)('wix.social.groups.api.v1.SocialGroupsService.ListGroups');
            };
            Object.defineProperty(SocialGroupsService.prototype, '__isRpcService__', {
              value: true,
              enumerable: false,
              configurable: false
            });
            Object.defineProperty(SocialGroupsService.prototype, '__fqn__', {
              value: 'wix.social.groups.api.v1.SocialGroupsService',
              enumerable: false,
              configurable: false
            });
            Object.defineProperty(SocialGroupsService.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('wix.social.groups.api.v1.SocialGroupsService');
              },
              enumerable: false,
              configurable: false
            });
            Object.defineProperty(SocialGroupsService.prototype, '__options__', {
              value: $root.__options,
              enumerable: false,
              configurable: false
            });
            return SocialGroupsService;
          }());
          return v1;
        }());
        return api;
      }());
      return groups;
    }());
    return social;
  }());
  wix.feed = (function() {
    const feed = {};

    feed.activities = (function() {
      const activities = {};

      activities.PostedInFeed = (function() {

        class PostedInFeed {

          constructor(props) {}

          static verify(msg, helper, errors = helper.verification.Errors.empty()) {
            if (typeof msg !== 'object' || msg == null) {
              errors.error('object expected');
            } else {
              if (!(typeof msg === 'object' && !Array.isArray(msg) && Object.keys(msg).length === 0)) {
                errors.error('empty object expected');
              }
            }
            return errors;
          }

          static toJSON(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const json = {};

              return json;
            }
          }

          static fromJSON(json, helper) {
            const result = new $root.wix.feed.activities.PostedInFeed();

            return result;
          }

          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};

              return grpc;
            }
          }

          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.wix.feed.activities.PostedInFeed();

              return result;
            }
          }

          static describe() {
            return {
              'fields': {}
            };
          }
        }

        Object.defineProperty(PostedInFeed.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('wix.feed.activities.PostedInFeed');
          },
          enumerable: false,
          configurable: false
        });
        return PostedInFeed;
      }());
      return activities;
    }());
    feed.FeedItem = (function() {

      class FeedItem {

        constructor(props) {
          this.feedItemId = props && props.feedItemId;
          this.entity = props && props.entity;
          this.applicationData = props && props.applicationData;
          this.createdBy = props && props.createdBy;
          this.createdAt = props && props.createdAt;
          this.updatedAt = props && props.updatedAt;
          this.comments = props && props.comments;
          this.latestComments = props && props.latestComments;
          this.reactions = props && props.reactions;
          this.pin = props && props.pin;
          this.contentPreviews = props && props.contentPreviews;
          this.requesterContext = props && props.requesterContext;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.feedItemId != null) {
              if (typeof msg.feedItemId !== 'string') {
                errors.field('feedItemId').error('string expected');
              }
            }
            if (msg.entity != null) {
              $root.wix.feed.FeedItemEntity.verify(msg.entity, helper, errors.field('entity'));
            }
            if (msg.applicationData != null) {
              $root.wix.feed.ApplicationData.verify(msg.applicationData, helper, errors.field('applicationData'));
            }
            if (msg.createdBy != null) {
              if (typeof msg.createdBy !== 'string') {
                errors.field('createdBy').error('string expected');
              }
            }
            if (msg.createdAt != null) {
              $root.google.protobuf.Timestamp.verify(msg.createdAt, helper, errors.field('createdAt'));
            }
            if (msg.updatedAt != null) {
              $root.google.protobuf.Timestamp.verify(msg.updatedAt, helper, errors.field('updatedAt'));
            }
            if (msg.comments != null) {
              $root.wix.feed.Comments.verify(msg.comments, helper, errors.field('comments'));
            }
            if (msg.latestComments != null) {
              $root.wix.feed.Comments.verify(msg.latestComments, helper, errors.field('latestComments'));
            }
            if (msg.reactions != null) {
              $root.wix.reactions.ItemReactionsSummary.verify(msg.reactions, helper, errors.field('reactions'));
            }
            if (msg.pin != null) {
              $root.wix.feed.FeedItemPin.verify(msg.pin, helper, errors.field('pin'));
            }
            if (msg.contentPreviews != null) {
              const fieldErrors = errors.field('contentPreviews');

              if (!Array.isArray(msg.contentPreviews)) {
                fieldErrors.error('array expected');
              } else {
                msg.contentPreviews.forEach((value, index) => {
                  $root.wix.social.ContentPreview.verify(value, helper, fieldErrors.index(index));
                });
              }
            }
            if (msg.requesterContext != null) {
              $root.wix.feed.FeedItemRequester.verify(msg.requesterContext, helper, errors.field('requesterContext'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.feedItemId != null) {
              json.feedItemId = obj.feedItemId;
            }
            if (obj.entity != null) {
              json.entity = $root.wix.feed.FeedItemEntity.toJSON(obj.entity, helper);
            }
            if (obj.applicationData != null) {
              json.applicationData = $root.wix.feed.ApplicationData.toJSON(obj.applicationData, helper);
            }
            if (obj.createdBy != null) {
              json.createdBy = obj.createdBy;
            }
            if (obj.createdAt != null) {
              json.createdAt = $root.google.protobuf.Timestamp.toJSON(obj.createdAt, helper);
            }
            if (obj.updatedAt != null) {
              json.updatedAt = $root.google.protobuf.Timestamp.toJSON(obj.updatedAt, helper);
            }
            if (obj.comments != null) {
              json.comments = $root.wix.feed.Comments.toJSON(obj.comments, helper);
            }
            if (obj.latestComments != null) {
              json.latestComments = $root.wix.feed.Comments.toJSON(obj.latestComments, helper);
            }
            if (obj.reactions != null) {
              json.reactions = $root.wix.reactions.ItemReactionsSummary.toJSON(obj.reactions, helper);
            }
            if (obj.pin != null) {
              json.pin = $root.wix.feed.FeedItemPin.toJSON(obj.pin, helper);
            }
            if (obj.contentPreviews != null) {
              json.contentPreviews = obj.contentPreviews.map(e => {
                return $root.wix.social.ContentPreview.toJSON(e, helper);
              });
            }
            if (obj.requesterContext != null) {
              json.requesterContext = $root.wix.feed.FeedItemRequester.toJSON(obj.requesterContext, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.feed.FeedItem();

          if (json.feedItemId != null) {
            result.feedItemId = json.feedItemId;
          } else {
            result.feedItemId = '';
          }
          if (json.entity != null) {
            result.entity = $root.wix.feed.FeedItemEntity.fromJSON(json.entity, helper);
          } else {
            delete result.entity;
          }
          if (json.applicationData != null) {
            result.applicationData = $root.wix.feed.ApplicationData.fromJSON(json.applicationData, helper);
          } else {
            delete result.applicationData;
          }
          if (json.createdBy != null) {
            result.createdBy = json.createdBy;
          } else {
            result.createdBy = '';
          }
          if (json.createdAt != null) {
            result.createdAt = $root.google.protobuf.Timestamp.fromJSON(json.createdAt, helper);
          } else {
            delete result.createdAt;
          }
          if (json.updatedAt != null) {
            result.updatedAt = $root.google.protobuf.Timestamp.fromJSON(json.updatedAt, helper);
          } else {
            delete result.updatedAt;
          }
          if (json.comments != null) {
            result.comments = $root.wix.feed.Comments.fromJSON(json.comments, helper);
          } else {
            delete result.comments;
          }
          if (json.latestComments != null) {
            result.latestComments = $root.wix.feed.Comments.fromJSON(json.latestComments, helper);
          } else {
            delete result.latestComments;
          }
          if (json.reactions != null) {
            result.reactions = $root.wix.reactions.ItemReactionsSummary.fromJSON(json.reactions, helper);
          } else {
            delete result.reactions;
          }
          if (json.pin != null) {
            result.pin = $root.wix.feed.FeedItemPin.fromJSON(json.pin, helper);
          } else {
            delete result.pin;
          }
          if (json.contentPreviews != null) {
            result.contentPreviews = json.contentPreviews.map(e => {
              return $root.wix.social.ContentPreview.fromJSON(e, helper);
            });
          } else {
            result.contentPreviews = [];
          }
          if (json.requesterContext != null) {
            result.requesterContext = $root.wix.feed.FeedItemRequester.fromJSON(json.requesterContext, helper);
          } else {
            delete result.requesterContext;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.feedItemId != null) {
              grpc.feedItemId = obj.feedItemId;
            }
            if (obj.entity != null) {
              grpc.entity = $root.wix.feed.FeedItemEntity.toGRPC(obj.entity, helper);
            }
            if (obj.applicationData != null) {
              grpc.applicationData = $root.wix.feed.ApplicationData.toGRPC(obj.applicationData, helper);
            }
            if (obj.createdBy != null) {
              grpc.createdBy = obj.createdBy;
            }
            if (obj.createdAt != null) {
              grpc.createdAt = $root.google.protobuf.Timestamp.toGRPC(obj.createdAt, helper);
            }
            if (obj.updatedAt != null) {
              grpc.updatedAt = $root.google.protobuf.Timestamp.toGRPC(obj.updatedAt, helper);
            }
            if (obj.comments != null) {
              grpc.comments = $root.wix.feed.Comments.toGRPC(obj.comments, helper);
            }
            if (obj.latestComments != null) {
              grpc.latestComments = $root.wix.feed.Comments.toGRPC(obj.latestComments, helper);
            }
            if (obj.reactions != null) {
              grpc.reactions = $root.wix.reactions.ItemReactionsSummary.toGRPC(obj.reactions, helper);
            }
            if (obj.pin != null) {
              grpc.pin = $root.wix.feed.FeedItemPin.toGRPC(obj.pin, helper);
            }
            if (obj.contentPreviews != null) {
              grpc.contentPreviews = obj.contentPreviews.map(e => {
                return $root.wix.social.ContentPreview.toGRPC(e, helper);
              });
            }
            if (obj.requesterContext != null) {
              grpc.requesterContext = $root.wix.feed.FeedItemRequester.toGRPC(obj.requesterContext, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.feed.FeedItem();

            if (grpc.feedItemId != null) {
              result.feedItemId = grpc.feedItemId;
            } else {
              result.feedItemId = '';
            }
            if (grpc.entity != null) {
              result.entity = $root.wix.feed.FeedItemEntity.fromGRPC(grpc.entity, helper);
            } else {
              delete result.entity;
            }
            if (grpc.applicationData != null) {
              result.applicationData = $root.wix.feed.ApplicationData.fromGRPC(grpc.applicationData, helper);
            } else {
              delete result.applicationData;
            }
            if (grpc.createdBy != null) {
              result.createdBy = grpc.createdBy;
            } else {
              result.createdBy = '';
            }
            if (grpc.createdAt != null) {
              result.createdAt = $root.google.protobuf.Timestamp.fromGRPC(grpc.createdAt, helper);
            } else {
              delete result.createdAt;
            }
            if (grpc.updatedAt != null) {
              result.updatedAt = $root.google.protobuf.Timestamp.fromGRPC(grpc.updatedAt, helper);
            } else {
              delete result.updatedAt;
            }
            if (grpc.comments != null) {
              result.comments = $root.wix.feed.Comments.fromGRPC(grpc.comments, helper);
            } else {
              delete result.comments;
            }
            if (grpc.latestComments != null) {
              result.latestComments = $root.wix.feed.Comments.fromGRPC(grpc.latestComments, helper);
            } else {
              delete result.latestComments;
            }
            if (grpc.reactions != null) {
              result.reactions = $root.wix.reactions.ItemReactionsSummary.fromGRPC(grpc.reactions, helper);
            } else {
              delete result.reactions;
            }
            if (grpc.pin != null) {
              result.pin = $root.wix.feed.FeedItemPin.fromGRPC(grpc.pin, helper);
            } else {
              delete result.pin;
            }
            if (grpc.contentPreviews != null) {
              result.contentPreviews = grpc.contentPreviews.map(e => {
                return $root.wix.social.ContentPreview.fromGRPC(e, helper);
              });
            } else {
              result.contentPreviews = [];
            }
            if (grpc.requesterContext != null) {
              result.requesterContext = $root.wix.feed.FeedItemRequester.fromGRPC(grpc.requesterContext, helper);
            } else {
              delete result.requesterContext;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'feedItemId': {
                'type': 'string',
                'id': 1,
                'options': {
                  '(wix.api.format)': 'GUID'
                }
              },
              'entity': {
                'type': $root.wix.feed.FeedItemEntity,
                'id': 2
              },
              'applicationData': {
                'type': $root.wix.feed.ApplicationData,
                'id': 3
              },
              'createdBy': {
                'type': 'string',
                'id': 4,
                'options': {
                  '(wix.api.format)': 'GUID'
                }
              },
              'createdAt': {
                'type': $root.google.protobuf.Timestamp,
                'id': 5
              },
              'updatedAt': {
                'type': $root.google.protobuf.Timestamp,
                'id': 6
              },
              'comments': {
                'type': $root.wix.feed.Comments,
                'id': 7
              },
              'latestComments': {
                'type': $root.wix.feed.Comments,
                'id': 12
              },
              'reactions': {
                'type': $root.wix.reactions.ItemReactionsSummary,
                'id': 8
              },
              'pin': {
                'type': $root.wix.feed.FeedItemPin,
                'id': 9
              },
              'contentPreviews': {
                'rule': 'repeated',
                'type': $root.wix.social.ContentPreview,
                'id': 10
              },
              'requesterContext': {
                'type': $root.wix.feed.FeedItemRequester,
                'id': 11
              }
            }
          };
        }
      }

      Object.defineProperty(FeedItem.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.feed.FeedItem');
        },
        enumerable: false,
        configurable: false
      });
      return FeedItem;
    }());
    feed.FeedItemEntity = (function() {

      class FeedItemEntity {

        constructor(props) {
          this.body = props && props.body;
          this.mentions = props && props.mentions;
          this.attachments = props && props.attachments;
          this.externalReferences = props && props.externalReferences;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.body != null) {
              $root.wix.social.Text.verify(msg.body, helper, errors.field('body'));
            }
            if (msg.mentions != null) {
              const fieldErrors = errors.field('mentions');

              if (!Array.isArray(msg.mentions)) {
                fieldErrors.error('array expected');
              } else {
                msg.mentions.forEach((value, index) => {
                  $root.wix.social.Mention.verify(value, helper, fieldErrors.index(index));
                });
              }
            }
            if (msg.attachments != null) {
              const fieldErrors = errors.field('attachments');

              if (!Array.isArray(msg.attachments)) {
                fieldErrors.error('array expected');
              } else {
                msg.attachments.forEach((value, index) => {
                  $root.wix.social.Resource.verify(value, helper, fieldErrors.index(index));
                });
              }
            }
            if (msg.externalReferences != null) {
              const fieldErrors = errors.field('externalReferences');

              if (!Array.isArray(msg.externalReferences)) {
                fieldErrors.error('array expected');
              } else {
                msg.externalReferences.forEach((value, index) => {
                  $root.wix.social.ExternalReference.verify(value, helper, fieldErrors.index(index));
                });
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.body != null) {
              json.body = $root.wix.social.Text.toJSON(obj.body, helper);
            }
            if (obj.mentions != null) {
              json.mentions = obj.mentions.map(e => {
                return $root.wix.social.Mention.toJSON(e, helper);
              });
            }
            if (obj.attachments != null) {
              json.attachments = obj.attachments.map(e => {
                return $root.wix.social.Resource.toJSON(e, helper);
              });
            }
            if (obj.externalReferences != null) {
              json.externalReferences = obj.externalReferences.map(e => {
                return $root.wix.social.ExternalReference.toJSON(e, helper);
              });
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.feed.FeedItemEntity();

          if (json.body != null) {
            result.body = $root.wix.social.Text.fromJSON(json.body, helper);
          } else {
            delete result.body;
          }
          if (json.mentions != null) {
            result.mentions = json.mentions.map(e => {
              return $root.wix.social.Mention.fromJSON(e, helper);
            });
          } else {
            result.mentions = [];
          }
          if (json.attachments != null) {
            result.attachments = json.attachments.map(e => {
              return $root.wix.social.Resource.fromJSON(e, helper);
            });
          } else {
            result.attachments = [];
          }
          if (json.externalReferences != null) {
            result.externalReferences = json.externalReferences.map(e => {
              return $root.wix.social.ExternalReference.fromJSON(e, helper);
            });
          } else {
            result.externalReferences = [];
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.body != null) {
              grpc.body = $root.wix.social.Text.toGRPC(obj.body, helper);
            }
            if (obj.mentions != null) {
              grpc.mentions = obj.mentions.map(e => {
                return $root.wix.social.Mention.toGRPC(e, helper);
              });
            }
            if (obj.attachments != null) {
              grpc.attachments = obj.attachments.map(e => {
                return $root.wix.social.Resource.toGRPC(e, helper);
              });
            }
            if (obj.externalReferences != null) {
              grpc.externalReferences = obj.externalReferences.map(e => {
                return $root.wix.social.ExternalReference.toGRPC(e, helper);
              });
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.feed.FeedItemEntity();

            if (grpc.body != null) {
              result.body = $root.wix.social.Text.fromGRPC(grpc.body, helper);
            } else {
              delete result.body;
            }
            if (grpc.mentions != null) {
              result.mentions = grpc.mentions.map(e => {
                return $root.wix.social.Mention.fromGRPC(e, helper);
              });
            } else {
              result.mentions = [];
            }
            if (grpc.attachments != null) {
              result.attachments = grpc.attachments.map(e => {
                return $root.wix.social.Resource.fromGRPC(e, helper);
              });
            } else {
              result.attachments = [];
            }
            if (grpc.externalReferences != null) {
              result.externalReferences = grpc.externalReferences.map(e => {
                return $root.wix.social.ExternalReference.fromGRPC(e, helper);
              });
            } else {
              result.externalReferences = [];
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'body': {
                'type': $root.wix.social.Text,
                'id': 1
              },
              'mentions': {
                'rule': 'repeated',
                'type': $root.wix.social.Mention,
                'id': 4
              },
              'attachments': {
                'rule': 'repeated',
                'type': $root.wix.social.Resource,
                'id': 5
              },
              'externalReferences': {
                'rule': 'repeated',
                'type': $root.wix.social.ExternalReference,
                'id': 6
              }
            }
          };
        }
      }

      Object.defineProperty(FeedItemEntity.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.feed.FeedItemEntity');
        },
        enumerable: false,
        configurable: false
      });
      return FeedItemEntity;
    }());
    feed.ApplicationData = (function() {

      class ApplicationData {

        constructor(props) {
          this.applicationId = props && props.applicationId;
          this.data = props && props.data;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.applicationId != null) {
              if (typeof msg.applicationId !== 'string') {
                errors.field('applicationId').error('string expected');
              }
            }
            if (msg.data != null) {
              $root.google.protobuf.Value.verify(msg.data, helper, errors.field('data'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.applicationId != null) {
              json.applicationId = obj.applicationId;
            }
            if (obj.data != null) {
              json.data = $root.google.protobuf.Value.toJSON(obj.data, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.feed.ApplicationData();

          if (json.applicationId != null) {
            result.applicationId = json.applicationId;
          } else {
            result.applicationId = '';
          }
          if (json.data != null) {
            result.data = $root.google.protobuf.Value.fromJSON(json.data, helper);
          } else {
            delete result.data;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.applicationId != null) {
              grpc.applicationId = obj.applicationId;
            }
            grpc.data = ($root.google.protobuf.Value.toGRPC(obj.data, helper));
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.feed.ApplicationData();

            if (grpc.applicationId != null) {
              result.applicationId = grpc.applicationId;
            } else {
              result.applicationId = '';
            }
            if (grpc.data != null) {
              result.data = $root.google.protobuf.Value.fromGRPC(grpc.data, helper);
            } else {
              delete result.data;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'applicationId': {
                'type': 'string',
                'id': 1
              },
              'data': {
                'type': $root.google.protobuf.Value,
                'id': 2
              }
            }
          };
        }
      }

      Object.defineProperty(ApplicationData.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.feed.ApplicationData');
        },
        enumerable: false,
        configurable: false
      });
      return ApplicationData;
    }());
    feed.Comments = (function() {

      class Comments {

        constructor(props) {
          this.contextToken = props && props.contextToken;
          this.total = props && props.total;
          this.comments = props && props.comments;
          this.cursor = props && props.cursor;
          this.nextCursor = props && props.nextCursor;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.contextToken != null) {
              if (typeof msg.contextToken !== 'string') {
                errors.field('contextToken').error('string expected');
              }
            }
            if (msg.total != null) {
              if (!Number.isInteger(msg.total)) {
                errors.field('total').error('integer expected');
              }
            }
            if (msg.comments != null) {
              const fieldErrors = errors.field('comments');

              if (!Array.isArray(msg.comments)) {
                fieldErrors.error('array expected');
              } else {
                msg.comments.forEach((value, index) => {
                  $root.wix.comments.Comment.verify(value, helper, fieldErrors.index(index));
                });
              }
            }
            if (msg.cursor != null) {
              if (typeof msg.cursor !== 'string') {
                errors.field('cursor').error('string expected');
              }
            }
            if (msg.nextCursor != null) {
              $root.google.protobuf.StringValue.verify(msg.nextCursor, helper, errors.field('nextCursor'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.contextToken != null) {
              json.contextToken = obj.contextToken;
            }
            if (obj.total != null) {
              json.total = obj.total;
            }
            if (obj.comments != null) {
              json.comments = obj.comments.map(e => {
                return $root.wix.comments.Comment.toJSON(e, helper);
              });
            }
            if (obj.cursor != null) {
              json.cursor = obj.cursor;
            }
            if (obj.nextCursor != null) {
              json.nextCursor = $root.google.protobuf.StringValue.toJSON(obj.nextCursor, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.feed.Comments();

          if (json.contextToken != null) {
            result.contextToken = json.contextToken;
          } else {
            result.contextToken = '';
          }
          if (json.total != null) {
            result.total = json.total;
          } else {
            result.total = 0;
          }
          if (json.comments != null) {
            result.comments = json.comments.map(e => {
              return $root.wix.comments.Comment.fromJSON(e, helper);
            });
          } else {
            result.comments = [];
          }
          if (json.cursor != null) {
            result.cursor = json.cursor;
          } else {
            result.cursor = '';
          }
          if (json.nextCursor != null) {
            result.nextCursor = $root.google.protobuf.StringValue.fromJSON(json.nextCursor, helper);
          } else {
            delete result.nextCursor;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.contextToken != null) {
              grpc.contextToken = obj.contextToken;
            }
            if (obj.total != null) {
              grpc.total = obj.total;
            }
            if (obj.comments != null) {
              grpc.comments = obj.comments.map(e => {
                return $root.wix.comments.Comment.toGRPC(e, helper);
              });
            }
            if (obj.cursor != null) {
              grpc.cursor = obj.cursor;
            }
            if (obj.nextCursor != null) {
              grpc.nextCursor = $root.google.protobuf.StringValue.toGRPC(obj.nextCursor, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.feed.Comments();

            if (grpc.contextToken != null) {
              result.contextToken = grpc.contextToken;
            } else {
              result.contextToken = '';
            }
            if (grpc.total != null) {
              result.total = grpc.total;
            } else {
              result.total = 0;
            }
            if (grpc.comments != null) {
              result.comments = grpc.comments.map(e => {
                return $root.wix.comments.Comment.fromGRPC(e, helper);
              });
            } else {
              result.comments = [];
            }
            if (grpc.cursor != null) {
              result.cursor = grpc.cursor;
            } else {
              result.cursor = '';
            }
            if (grpc.nextCursor != null) {
              result.nextCursor = $root.google.protobuf.StringValue.fromGRPC(grpc.nextCursor, helper);
            } else {
              delete result.nextCursor;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'contextToken': {
                'type': 'string',
                'id': 1
              },
              'total': {
                'type': 'int32',
                'id': 2
              },
              'comments': {
                'rule': 'repeated',
                'type': $root.wix.comments.Comment,
                'id': 3
              },
              'cursor': {
                'type': 'string',
                'id': 4
              },
              'nextCursor': {
                'type': $root.google.protobuf.StringValue,
                'id': 5
              }
            }
          };
        }
      }

      Object.defineProperty(Comments.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.feed.Comments');
        },
        enumerable: false,
        configurable: false
      });
      return Comments;
    }());
    feed.FeedItemPin = (function() {

      class FeedItemPin {

        constructor(props) {
          this.since = props && props.since;
          this.pinnedBy = props && props.pinnedBy;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.since != null) {
              $root.google.protobuf.Timestamp.verify(msg.since, helper, errors.field('since'));
            }
            if (msg.pinnedBy != null) {
              if (typeof msg.pinnedBy !== 'string') {
                errors.field('pinnedBy').error('string expected');
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.since != null) {
              json.since = $root.google.protobuf.Timestamp.toJSON(obj.since, helper);
            }
            if (obj.pinnedBy != null) {
              json.pinnedBy = obj.pinnedBy;
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.feed.FeedItemPin();

          if (json.since != null) {
            result.since = $root.google.protobuf.Timestamp.fromJSON(json.since, helper);
          } else {
            delete result.since;
          }
          if (json.pinnedBy != null) {
            result.pinnedBy = json.pinnedBy;
          } else {
            result.pinnedBy = '';
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.since != null) {
              grpc.since = $root.google.protobuf.Timestamp.toGRPC(obj.since, helper);
            }
            if (obj.pinnedBy != null) {
              grpc.pinnedBy = obj.pinnedBy;
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.feed.FeedItemPin();

            if (grpc.since != null) {
              result.since = $root.google.protobuf.Timestamp.fromGRPC(grpc.since, helper);
            } else {
              delete result.since;
            }
            if (grpc.pinnedBy != null) {
              result.pinnedBy = grpc.pinnedBy;
            } else {
              result.pinnedBy = '';
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'since': {
                'type': $root.google.protobuf.Timestamp,
                'id': 1
              },
              'pinnedBy': {
                'type': 'string',
                'id': 2,
                'options': {
                  '(wix.api.format)': 'GUID'
                }
              }
            }
          };
        }
      }

      Object.defineProperty(FeedItemPin.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.feed.FeedItemPin');
        },
        enumerable: false,
        configurable: false
      });
      return FeedItemPin;
    }());
    feed.FeedItemRequester = (function() {

      class FeedItemRequester {

        constructor(props) {
          this.subscribed = props && props.subscribed;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.subscribed != null) {
              if (typeof msg.subscribed !== 'boolean') {
                errors.field('subscribed').error('boolean expected');
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.subscribed != null) {
              json.subscribed = obj.subscribed;
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.feed.FeedItemRequester();

          if (json.subscribed != null) {
            result.subscribed = json.subscribed;
          } else {
            result.subscribed = false;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.subscribed != null) {
              grpc.subscribed = obj.subscribed;
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.feed.FeedItemRequester();

            if (grpc.subscribed != null) {
              result.subscribed = grpc.subscribed;
            } else {
              result.subscribed = false;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'subscribed': {
                'type': 'bool',
                'id': 1
              }
            }
          };
        }
      }

      Object.defineProperty(FeedItemRequester.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.feed.FeedItemRequester');
        },
        enumerable: false,
        configurable: false
      });
      return FeedItemRequester;
    }());
    feed.FeedItemCreated = (function() {

      class FeedItemCreated {

        constructor(props) {
          this.containerId = props && props.containerId;
          this.entity = props && props.entity;
          this.applicationData = props && props.applicationData;
          this.createdAt = props && props.createdAt;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.containerId != null) {
              if (typeof msg.containerId !== 'string') {
                errors.field('containerId').error('string expected');
              }
            }
            if (msg.entity != null) {
              $root.wix.feed.FeedItemEntity.verify(msg.entity, helper, errors.field('entity'));
            }
            if (msg.applicationData != null) {
              $root.wix.feed.ApplicationData.verify(msg.applicationData, helper, errors.field('applicationData'));
            }
            if (msg.createdAt != null) {
              $root.google.protobuf.Timestamp.verify(msg.createdAt, helper, errors.field('createdAt'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.containerId != null) {
              json.containerId = obj.containerId;
            }
            if (obj.entity != null) {
              json.entity = $root.wix.feed.FeedItemEntity.toJSON(obj.entity, helper);
            }
            if (obj.applicationData != null) {
              json.applicationData = $root.wix.feed.ApplicationData.toJSON(obj.applicationData, helper);
            }
            if (obj.createdAt != null) {
              json.createdAt = $root.google.protobuf.Timestamp.toJSON(obj.createdAt, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.feed.FeedItemCreated();

          if (json.containerId != null) {
            result.containerId = json.containerId;
          } else {
            result.containerId = '';
          }
          if (json.entity != null) {
            result.entity = $root.wix.feed.FeedItemEntity.fromJSON(json.entity, helper);
          } else {
            delete result.entity;
          }
          if (json.applicationData != null) {
            result.applicationData = $root.wix.feed.ApplicationData.fromJSON(json.applicationData, helper);
          } else {
            delete result.applicationData;
          }
          if (json.createdAt != null) {
            result.createdAt = $root.google.protobuf.Timestamp.fromJSON(json.createdAt, helper);
          } else {
            delete result.createdAt;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.containerId != null) {
              grpc.containerId = obj.containerId;
            }
            if (obj.entity != null) {
              grpc.entity = $root.wix.feed.FeedItemEntity.toGRPC(obj.entity, helper);
            }
            if (obj.applicationData != null) {
              grpc.applicationData = $root.wix.feed.ApplicationData.toGRPC(obj.applicationData, helper);
            }
            if (obj.createdAt != null) {
              grpc.createdAt = $root.google.protobuf.Timestamp.toGRPC(obj.createdAt, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.feed.FeedItemCreated();

            if (grpc.containerId != null) {
              result.containerId = grpc.containerId;
            } else {
              result.containerId = '';
            }
            if (grpc.entity != null) {
              result.entity = $root.wix.feed.FeedItemEntity.fromGRPC(grpc.entity, helper);
            } else {
              delete result.entity;
            }
            if (grpc.applicationData != null) {
              result.applicationData = $root.wix.feed.ApplicationData.fromGRPC(grpc.applicationData, helper);
            } else {
              delete result.applicationData;
            }
            if (grpc.createdAt != null) {
              result.createdAt = $root.google.protobuf.Timestamp.fromGRPC(grpc.createdAt, helper);
            } else {
              delete result.createdAt;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'containerId': {
                'type': 'string',
                'id': 1
              },
              'entity': {
                'type': $root.wix.feed.FeedItemEntity,
                'id': 2
              },
              'applicationData': {
                'type': $root.wix.feed.ApplicationData,
                'id': 3
              },
              'createdAt': {
                'type': $root.google.protobuf.Timestamp,
                'id': 4
              }
            }
          };
        }
      }

      Object.defineProperty(FeedItemCreated.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.feed.FeedItemCreated');
        },
        enumerable: false,
        configurable: false
      });
      return FeedItemCreated;
    }());
    feed.FeedItemUpdated = (function() {

      class FeedItemUpdated {

        constructor(props) {
          this.entity = props && props.entity;
          this.applicationData = props && props.applicationData;
          this.updatedAt = props && props.updatedAt;
          this.mask = props && props.mask;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.entity != null) {
              $root.wix.feed.FeedItemEntity.verify(msg.entity, helper, errors.field('entity'));
            }
            if (msg.applicationData != null) {
              $root.wix.feed.ApplicationData.verify(msg.applicationData, helper, errors.field('applicationData'));
            }
            if (msg.updatedAt != null) {
              $root.google.protobuf.Timestamp.verify(msg.updatedAt, helper, errors.field('updatedAt'));
            }
            if (msg.mask != null) {
              $root.google.protobuf.FieldMask.verify(msg.mask, helper, errors.field('mask'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.entity != null) {
              json.entity = $root.wix.feed.FeedItemEntity.toJSON(obj.entity, helper);
            }
            if (obj.applicationData != null) {
              json.applicationData = $root.wix.feed.ApplicationData.toJSON(obj.applicationData, helper);
            }
            if (obj.updatedAt != null) {
              json.updatedAt = $root.google.protobuf.Timestamp.toJSON(obj.updatedAt, helper);
            }
            if (obj.mask != null) {
              json.mask = $root.google.protobuf.FieldMask.toJSON(obj.mask, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.feed.FeedItemUpdated();

          if (json.entity != null) {
            result.entity = $root.wix.feed.FeedItemEntity.fromJSON(json.entity, helper);
          } else {
            delete result.entity;
          }
          if (json.applicationData != null) {
            result.applicationData = $root.wix.feed.ApplicationData.fromJSON(json.applicationData, helper);
          } else {
            delete result.applicationData;
          }
          if (json.updatedAt != null) {
            result.updatedAt = $root.google.protobuf.Timestamp.fromJSON(json.updatedAt, helper);
          } else {
            delete result.updatedAt;
          }
          if (json.mask != null) {
            result.mask = $root.google.protobuf.FieldMask.fromJSON(json.mask, helper);
          } else {
            delete result.mask;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.entity != null) {
              grpc.entity = $root.wix.feed.FeedItemEntity.toGRPC(obj.entity, helper);
            }
            if (obj.applicationData != null) {
              grpc.applicationData = $root.wix.feed.ApplicationData.toGRPC(obj.applicationData, helper);
            }
            if (obj.updatedAt != null) {
              grpc.updatedAt = $root.google.protobuf.Timestamp.toGRPC(obj.updatedAt, helper);
            }
            if (obj.mask != null) {
              grpc.mask = $root.google.protobuf.FieldMask.toGRPC(obj.mask, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.feed.FeedItemUpdated();

            if (grpc.entity != null) {
              result.entity = $root.wix.feed.FeedItemEntity.fromGRPC(grpc.entity, helper);
            } else {
              delete result.entity;
            }
            if (grpc.applicationData != null) {
              result.applicationData = $root.wix.feed.ApplicationData.fromGRPC(grpc.applicationData, helper);
            } else {
              delete result.applicationData;
            }
            if (grpc.updatedAt != null) {
              result.updatedAt = $root.google.protobuf.Timestamp.fromGRPC(grpc.updatedAt, helper);
            } else {
              delete result.updatedAt;
            }
            if (grpc.mask != null) {
              result.mask = $root.google.protobuf.FieldMask.fromGRPC(grpc.mask, helper);
            } else {
              delete result.mask;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'entity': {
                'type': $root.wix.feed.FeedItemEntity,
                'id': 2
              },
              'applicationData': {
                'type': $root.wix.feed.ApplicationData,
                'id': 3
              },
              'updatedAt': {
                'type': $root.google.protobuf.Timestamp,
                'id': 4
              },
              'mask': {
                'type': $root.google.protobuf.FieldMask,
                'id': 5
              }
            }
          };
        }
      }

      Object.defineProperty(FeedItemUpdated.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.feed.FeedItemUpdated');
        },
        enumerable: false,
        configurable: false
      });
      return FeedItemUpdated;
    }());
    feed.FeedItemDeleted = (function() {

      class FeedItemDeleted {

        constructor(props) {}

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (!(typeof msg === 'object' && !Array.isArray(msg) && Object.keys(msg).length === 0)) {
              errors.error('empty object expected');
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.feed.FeedItemDeleted();

          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.feed.FeedItemDeleted();

            return result;
          }
        }

        static describe() {
          return {
            'fields': {}
          };
        }
      }

      Object.defineProperty(FeedItemDeleted.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.feed.FeedItemDeleted');
        },
        enumerable: false,
        configurable: false
      });
      return FeedItemDeleted;
    }());
    feed.FeedItemPinned = (function() {

      class FeedItemPinned {

        constructor(props) {}

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (!(typeof msg === 'object' && !Array.isArray(msg) && Object.keys(msg).length === 0)) {
              errors.error('empty object expected');
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.feed.FeedItemPinned();

          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.feed.FeedItemPinned();

            return result;
          }
        }

        static describe() {
          return {
            'fields': {}
          };
        }
      }

      Object.defineProperty(FeedItemPinned.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.feed.FeedItemPinned');
        },
        enumerable: false,
        configurable: false
      });
      return FeedItemPinned;
    }());
    feed.FeedItemUnpinned = (function() {

      class FeedItemUnpinned {

        constructor(props) {}

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (!(typeof msg === 'object' && !Array.isArray(msg) && Object.keys(msg).length === 0)) {
              errors.error('empty object expected');
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.feed.FeedItemUnpinned();

          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.feed.FeedItemUnpinned();

            return result;
          }
        }

        static describe() {
          return {
            'fields': {}
          };
        }
      }

      Object.defineProperty(FeedItemUnpinned.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.feed.FeedItemUnpinned');
        },
        enumerable: false,
        configurable: false
      });
      return FeedItemUnpinned;
    }());
    feed.callbacks = (function() {
      const callbacks = {};

      callbacks.FeedItemCreated = (function() {

        class FeedItemCreated {

          constructor(props) {
            this.feedItemId = props && props.feedItemId;
            this.feedItemCreated = props && props.feedItemCreated;
            this.createdBy = props && props.createdBy;
            this.container = props && props.container;
          }

          static verify(msg, helper, errors = helper.verification.Errors.empty()) {
            if (typeof msg !== 'object' || msg == null) {
              errors.error('object expected');
            } else {
              if (msg.feedItemId != null) {
                if (typeof msg.feedItemId !== 'string') {
                  errors.field('feedItemId').error('string expected');
                }
              }
              if (msg.feedItemCreated != null) {
                $root.wix.feed.FeedItemCreated.verify(msg.feedItemCreated, helper, errors.field('feedItemCreated'));
              }
              if (msg.createdBy != null) {
                $root.wix.social.SocialIdentity.verify(msg.createdBy, helper, errors.field('createdBy'));
              }
              if (msg.container != null) {
                $root.wix.social.SocialContainer.verify(msg.container, helper, errors.field('container'));
              }
            }
            return errors;
          }

          static toJSON(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const json = {};

              if (obj.feedItemId != null) {
                json.feedItemId = obj.feedItemId;
              }
              if (obj.feedItemCreated != null) {
                json.feedItemCreated = $root.wix.feed.FeedItemCreated.toJSON(obj.feedItemCreated, helper);
              }
              if (obj.createdBy != null) {
                json.createdBy = $root.wix.social.SocialIdentity.toJSON(obj.createdBy, helper);
              }
              if (obj.container != null) {
                json.container = $root.wix.social.SocialContainer.toJSON(obj.container, helper);
              }
              return json;
            }
          }

          static fromJSON(json, helper) {
            const result = new $root.wix.feed.callbacks.FeedItemCreated();

            if (json.feedItemId != null) {
              result.feedItemId = json.feedItemId;
            } else {
              result.feedItemId = '';
            }
            if (json.feedItemCreated != null) {
              result.feedItemCreated = $root.wix.feed.FeedItemCreated.fromJSON(json.feedItemCreated, helper);
            } else {
              delete result.feedItemCreated;
            }
            if (json.createdBy != null) {
              result.createdBy = $root.wix.social.SocialIdentity.fromJSON(json.createdBy, helper);
            } else {
              delete result.createdBy;
            }
            if (json.container != null) {
              result.container = $root.wix.social.SocialContainer.fromJSON(json.container, helper);
            } else {
              delete result.container;
            }
            return result;
          }

          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};

              if (obj.feedItemId != null) {
                grpc.feedItemId = obj.feedItemId;
              }
              if (obj.feedItemCreated != null) {
                grpc.feedItemCreated = $root.wix.feed.FeedItemCreated.toGRPC(obj.feedItemCreated, helper);
              }
              if (obj.createdBy != null) {
                grpc.createdBy = $root.wix.social.SocialIdentity.toGRPC(obj.createdBy, helper);
              }
              if (obj.container != null) {
                grpc.container = $root.wix.social.SocialContainer.toGRPC(obj.container, helper);
              }
              return grpc;
            }
          }

          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.wix.feed.callbacks.FeedItemCreated();

              if (grpc.feedItemId != null) {
                result.feedItemId = grpc.feedItemId;
              } else {
                result.feedItemId = '';
              }
              if (grpc.feedItemCreated != null) {
                result.feedItemCreated = $root.wix.feed.FeedItemCreated.fromGRPC(grpc.feedItemCreated, helper);
              } else {
                delete result.feedItemCreated;
              }
              if (grpc.createdBy != null) {
                result.createdBy = $root.wix.social.SocialIdentity.fromGRPC(grpc.createdBy, helper);
              } else {
                delete result.createdBy;
              }
              if (grpc.container != null) {
                result.container = $root.wix.social.SocialContainer.fromGRPC(grpc.container, helper);
              } else {
                delete result.container;
              }
              return result;
            }
          }

          static describe() {
            return {
              'fields': {
                'feedItemId': {
                  'type': 'string',
                  'id': 1,
                  'options': {
                    '(wix.api.format)': 'GUID'
                  }
                },
                'feedItemCreated': {
                  'type': $root.wix.feed.FeedItemCreated,
                  'id': 2
                },
                'createdBy': {
                  'type': $root.wix.social.SocialIdentity,
                  'id': 3
                },
                'container': {
                  'type': $root.wix.social.SocialContainer,
                  'id': 4
                }
              }
            };
          }
        }

        Object.defineProperty(FeedItemCreated.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('wix.feed.callbacks.FeedItemCreated');
          },
          enumerable: false,
          configurable: false
        });
        return FeedItemCreated;
      }());
      callbacks.CommentedOnFeedItem = (function() {

        class CommentedOnFeedItem {

          constructor(props) {
            this.feedItemId = props && props.feedItemId;
            this.commentId = props && props.commentId;
            this.comment = props && props.comment;
            this.createdBy = props && props.createdBy;
            this.container = props && props.container;
          }

          static verify(msg, helper, errors = helper.verification.Errors.empty()) {
            if (typeof msg !== 'object' || msg == null) {
              errors.error('object expected');
            } else {
              if (msg.feedItemId != null) {
                if (typeof msg.feedItemId !== 'string') {
                  errors.field('feedItemId').error('string expected');
                }
              }
              if (msg.commentId != null) {
                if (typeof msg.commentId !== 'string') {
                  errors.field('commentId').error('string expected');
                }
              }
              if (msg.comment != null) {
                $root.wix.comments.CommentEntity.verify(msg.comment, helper, errors.field('comment'));
              }
              if (msg.createdBy != null) {
                $root.wix.social.SocialIdentity.verify(msg.createdBy, helper, errors.field('createdBy'));
              }
              if (msg.container != null) {
                $root.wix.social.SocialContainer.verify(msg.container, helper, errors.field('container'));
              }
            }
            return errors;
          }

          static toJSON(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const json = {};

              if (obj.feedItemId != null) {
                json.feedItemId = obj.feedItemId;
              }
              if (obj.commentId != null) {
                json.commentId = obj.commentId;
              }
              if (obj.comment != null) {
                json.comment = $root.wix.comments.CommentEntity.toJSON(obj.comment, helper);
              }
              if (obj.createdBy != null) {
                json.createdBy = $root.wix.social.SocialIdentity.toJSON(obj.createdBy, helper);
              }
              if (obj.container != null) {
                json.container = $root.wix.social.SocialContainer.toJSON(obj.container, helper);
              }
              return json;
            }
          }

          static fromJSON(json, helper) {
            const result = new $root.wix.feed.callbacks.CommentedOnFeedItem();

            if (json.feedItemId != null) {
              result.feedItemId = json.feedItemId;
            } else {
              result.feedItemId = '';
            }
            if (json.commentId != null) {
              result.commentId = json.commentId;
            } else {
              result.commentId = '';
            }
            if (json.comment != null) {
              result.comment = $root.wix.comments.CommentEntity.fromJSON(json.comment, helper);
            } else {
              delete result.comment;
            }
            if (json.createdBy != null) {
              result.createdBy = $root.wix.social.SocialIdentity.fromJSON(json.createdBy, helper);
            } else {
              delete result.createdBy;
            }
            if (json.container != null) {
              result.container = $root.wix.social.SocialContainer.fromJSON(json.container, helper);
            } else {
              delete result.container;
            }
            return result;
          }

          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};

              if (obj.feedItemId != null) {
                grpc.feedItemId = obj.feedItemId;
              }
              if (obj.commentId != null) {
                grpc.commentId = obj.commentId;
              }
              if (obj.comment != null) {
                grpc.comment = $root.wix.comments.CommentEntity.toGRPC(obj.comment, helper);
              }
              if (obj.createdBy != null) {
                grpc.createdBy = $root.wix.social.SocialIdentity.toGRPC(obj.createdBy, helper);
              }
              if (obj.container != null) {
                grpc.container = $root.wix.social.SocialContainer.toGRPC(obj.container, helper);
              }
              return grpc;
            }
          }

          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.wix.feed.callbacks.CommentedOnFeedItem();

              if (grpc.feedItemId != null) {
                result.feedItemId = grpc.feedItemId;
              } else {
                result.feedItemId = '';
              }
              if (grpc.commentId != null) {
                result.commentId = grpc.commentId;
              } else {
                result.commentId = '';
              }
              if (grpc.comment != null) {
                result.comment = $root.wix.comments.CommentEntity.fromGRPC(grpc.comment, helper);
              } else {
                delete result.comment;
              }
              if (grpc.createdBy != null) {
                result.createdBy = $root.wix.social.SocialIdentity.fromGRPC(grpc.createdBy, helper);
              } else {
                delete result.createdBy;
              }
              if (grpc.container != null) {
                result.container = $root.wix.social.SocialContainer.fromGRPC(grpc.container, helper);
              } else {
                delete result.container;
              }
              return result;
            }
          }

          static describe() {
            return {
              'fields': {
                'feedItemId': {
                  'type': 'string',
                  'id': 1,
                  'options': {
                    '(wix.api.format)': 'GUID'
                  }
                },
                'commentId': {
                  'type': 'string',
                  'id': 2,
                  'options': {
                    '(wix.api.format)': 'GUID'
                  }
                },
                'comment': {
                  'type': $root.wix.comments.CommentEntity,
                  'id': 3
                },
                'createdBy': {
                  'type': $root.wix.social.SocialIdentity,
                  'id': 4
                },
                'container': {
                  'type': $root.wix.social.SocialContainer,
                  'id': 5
                }
              }
            };
          }
        }

        Object.defineProperty(CommentedOnFeedItem.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('wix.feed.callbacks.CommentedOnFeedItem');
          },
          enumerable: false,
          configurable: false
        });
        return CommentedOnFeedItem;
      }());
      callbacks.ReactedOnFeedItem = (function() {

        class ReactedOnFeedItem {

          constructor(props) {
            this.feedItemId = props && props.feedItemId;
            this.reaction = props && props.reaction;
            this.entity = props && props.entity;
            this.createdBy = props && props.createdBy;
            this.container = props && props.container;
          }

          static verify(msg, helper, errors = helper.verification.Errors.empty()) {
            if (typeof msg !== 'object' || msg == null) {
              errors.error('object expected');
            } else {
              if (msg.feedItemId != null) {
                if (typeof msg.feedItemId !== 'string') {
                  errors.field('feedItemId').error('string expected');
                }
              }
              if (msg.reaction != null) {
                $root.wix.reactions.Reaction.verify(msg.reaction, helper, errors.field('reaction'));
              }
              if (msg.entity != null) {
                $root.wix.social.SocialEntity.verify(msg.entity, helper, errors.field('entity'));
              }
              if (msg.createdBy != null) {
                $root.wix.social.SocialIdentity.verify(msg.createdBy, helper, errors.field('createdBy'));
              }
              if (msg.container != null) {
                $root.wix.social.SocialContainer.verify(msg.container, helper, errors.field('container'));
              }
            }
            return errors;
          }

          static toJSON(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const json = {};

              if (obj.feedItemId != null) {
                json.feedItemId = obj.feedItemId;
              }
              if (obj.reaction != null) {
                json.reaction = $root.wix.reactions.Reaction.toJSON(obj.reaction, helper);
              }
              if (obj.entity != null) {
                json.entity = $root.wix.social.SocialEntity.toJSON(obj.entity, helper);
              }
              if (obj.createdBy != null) {
                json.createdBy = $root.wix.social.SocialIdentity.toJSON(obj.createdBy, helper);
              }
              if (obj.container != null) {
                json.container = $root.wix.social.SocialContainer.toJSON(obj.container, helper);
              }
              return json;
            }
          }

          static fromJSON(json, helper) {
            const result = new $root.wix.feed.callbacks.ReactedOnFeedItem();

            if (json.feedItemId != null) {
              result.feedItemId = json.feedItemId;
            } else {
              result.feedItemId = '';
            }
            if (json.reaction != null) {
              result.reaction = $root.wix.reactions.Reaction.fromJSON(json.reaction, helper);
            } else {
              delete result.reaction;
            }
            if (json.entity != null) {
              result.entity = $root.wix.social.SocialEntity.fromJSON(json.entity, helper);
            } else {
              delete result.entity;
            }
            if (json.createdBy != null) {
              result.createdBy = $root.wix.social.SocialIdentity.fromJSON(json.createdBy, helper);
            } else {
              delete result.createdBy;
            }
            if (json.container != null) {
              result.container = $root.wix.social.SocialContainer.fromJSON(json.container, helper);
            } else {
              delete result.container;
            }
            return result;
          }

          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};

              if (obj.feedItemId != null) {
                grpc.feedItemId = obj.feedItemId;
              }
              if (obj.reaction != null) {
                grpc.reaction = $root.wix.reactions.Reaction.toGRPC(obj.reaction, helper);
              }
              if (obj.entity != null) {
                grpc.entity = $root.wix.social.SocialEntity.toGRPC(obj.entity, helper);
              }
              if (obj.createdBy != null) {
                grpc.createdBy = $root.wix.social.SocialIdentity.toGRPC(obj.createdBy, helper);
              }
              if (obj.container != null) {
                grpc.container = $root.wix.social.SocialContainer.toGRPC(obj.container, helper);
              }
              return grpc;
            }
          }

          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.wix.feed.callbacks.ReactedOnFeedItem();

              if (grpc.feedItemId != null) {
                result.feedItemId = grpc.feedItemId;
              } else {
                result.feedItemId = '';
              }
              if (grpc.reaction != null) {
                result.reaction = $root.wix.reactions.Reaction.fromGRPC(grpc.reaction, helper);
              } else {
                delete result.reaction;
              }
              if (grpc.entity != null) {
                result.entity = $root.wix.social.SocialEntity.fromGRPC(grpc.entity, helper);
              } else {
                delete result.entity;
              }
              if (grpc.createdBy != null) {
                result.createdBy = $root.wix.social.SocialIdentity.fromGRPC(grpc.createdBy, helper);
              } else {
                delete result.createdBy;
              }
              if (grpc.container != null) {
                result.container = $root.wix.social.SocialContainer.fromGRPC(grpc.container, helper);
              } else {
                delete result.container;
              }
              return result;
            }
          }

          static describe() {
            return {
              'fields': {
                'feedItemId': {
                  'type': 'string',
                  'id': 1,
                  'options': {
                    '(wix.api.format)': 'GUID'
                  }
                },
                'reaction': {
                  'type': $root.wix.reactions.Reaction,
                  'id': 2
                },
                'entity': {
                  'type': $root.wix.social.SocialEntity,
                  'id': 3
                },
                'createdBy': {
                  'type': $root.wix.social.SocialIdentity,
                  'id': 4
                },
                'container': {
                  'type': $root.wix.social.SocialContainer,
                  'id': 5
                }
              }
            };
          }
        }

        Object.defineProperty(ReactedOnFeedItem.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('wix.feed.callbacks.ReactedOnFeedItem');
          },
          enumerable: false,
          configurable: false
        });
        return ReactedOnFeedItem;
      }());
      callbacks.ReactedOnComment = (function() {

        class ReactedOnComment {

          constructor(props) {
            this.feedItemId = props && props.feedItemId;
            this.commentId = props && props.commentId;
            this.reaction = props && props.reaction;
            this.entity = props && props.entity;
            this.createdBy = props && props.createdBy;
            this.container = props && props.container;
          }

          static verify(msg, helper, errors = helper.verification.Errors.empty()) {
            if (typeof msg !== 'object' || msg == null) {
              errors.error('object expected');
            } else {
              if (msg.feedItemId != null) {
                if (typeof msg.feedItemId !== 'string') {
                  errors.field('feedItemId').error('string expected');
                }
              }
              if (msg.commentId != null) {
                if (typeof msg.commentId !== 'string') {
                  errors.field('commentId').error('string expected');
                }
              }
              if (msg.reaction != null) {
                $root.wix.reactions.Reaction.verify(msg.reaction, helper, errors.field('reaction'));
              }
              if (msg.entity != null) {
                $root.wix.social.SocialEntity.verify(msg.entity, helper, errors.field('entity'));
              }
              if (msg.createdBy != null) {
                $root.wix.social.SocialIdentity.verify(msg.createdBy, helper, errors.field('createdBy'));
              }
              if (msg.container != null) {
                $root.wix.social.SocialContainer.verify(msg.container, helper, errors.field('container'));
              }
            }
            return errors;
          }

          static toJSON(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const json = {};

              if (obj.feedItemId != null) {
                json.feedItemId = obj.feedItemId;
              }
              if (obj.commentId != null) {
                json.commentId = obj.commentId;
              }
              if (obj.reaction != null) {
                json.reaction = $root.wix.reactions.Reaction.toJSON(obj.reaction, helper);
              }
              if (obj.entity != null) {
                json.entity = $root.wix.social.SocialEntity.toJSON(obj.entity, helper);
              }
              if (obj.createdBy != null) {
                json.createdBy = $root.wix.social.SocialIdentity.toJSON(obj.createdBy, helper);
              }
              if (obj.container != null) {
                json.container = $root.wix.social.SocialContainer.toJSON(obj.container, helper);
              }
              return json;
            }
          }

          static fromJSON(json, helper) {
            const result = new $root.wix.feed.callbacks.ReactedOnComment();

            if (json.feedItemId != null) {
              result.feedItemId = json.feedItemId;
            } else {
              result.feedItemId = '';
            }
            if (json.commentId != null) {
              result.commentId = json.commentId;
            } else {
              result.commentId = '';
            }
            if (json.reaction != null) {
              result.reaction = $root.wix.reactions.Reaction.fromJSON(json.reaction, helper);
            } else {
              delete result.reaction;
            }
            if (json.entity != null) {
              result.entity = $root.wix.social.SocialEntity.fromJSON(json.entity, helper);
            } else {
              delete result.entity;
            }
            if (json.createdBy != null) {
              result.createdBy = $root.wix.social.SocialIdentity.fromJSON(json.createdBy, helper);
            } else {
              delete result.createdBy;
            }
            if (json.container != null) {
              result.container = $root.wix.social.SocialContainer.fromJSON(json.container, helper);
            } else {
              delete result.container;
            }
            return result;
          }

          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};

              if (obj.feedItemId != null) {
                grpc.feedItemId = obj.feedItemId;
              }
              if (obj.commentId != null) {
                grpc.commentId = obj.commentId;
              }
              if (obj.reaction != null) {
                grpc.reaction = $root.wix.reactions.Reaction.toGRPC(obj.reaction, helper);
              }
              if (obj.entity != null) {
                grpc.entity = $root.wix.social.SocialEntity.toGRPC(obj.entity, helper);
              }
              if (obj.createdBy != null) {
                grpc.createdBy = $root.wix.social.SocialIdentity.toGRPC(obj.createdBy, helper);
              }
              if (obj.container != null) {
                grpc.container = $root.wix.social.SocialContainer.toGRPC(obj.container, helper);
              }
              return grpc;
            }
          }

          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.wix.feed.callbacks.ReactedOnComment();

              if (grpc.feedItemId != null) {
                result.feedItemId = grpc.feedItemId;
              } else {
                result.feedItemId = '';
              }
              if (grpc.commentId != null) {
                result.commentId = grpc.commentId;
              } else {
                result.commentId = '';
              }
              if (grpc.reaction != null) {
                result.reaction = $root.wix.reactions.Reaction.fromGRPC(grpc.reaction, helper);
              } else {
                delete result.reaction;
              }
              if (grpc.entity != null) {
                result.entity = $root.wix.social.SocialEntity.fromGRPC(grpc.entity, helper);
              } else {
                delete result.entity;
              }
              if (grpc.createdBy != null) {
                result.createdBy = $root.wix.social.SocialIdentity.fromGRPC(grpc.createdBy, helper);
              } else {
                delete result.createdBy;
              }
              if (grpc.container != null) {
                result.container = $root.wix.social.SocialContainer.fromGRPC(grpc.container, helper);
              } else {
                delete result.container;
              }
              return result;
            }
          }

          static describe() {
            return {
              'fields': {
                'feedItemId': {
                  'type': 'string',
                  'id': 1,
                  'options': {
                    '(wix.api.format)': 'GUID'
                  }
                },
                'commentId': {
                  'type': 'string',
                  'id': 2,
                  'options': {
                    '(wix.api.format)': 'GUID'
                  }
                },
                'reaction': {
                  'type': $root.wix.reactions.Reaction,
                  'id': 3
                },
                'entity': {
                  'type': $root.wix.social.SocialEntity,
                  'id': 4
                },
                'createdBy': {
                  'type': $root.wix.social.SocialIdentity,
                  'id': 5
                },
                'container': {
                  'type': $root.wix.social.SocialContainer,
                  'id': 6
                }
              }
            };
          }
        }

        Object.defineProperty(ReactedOnComment.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('wix.feed.callbacks.ReactedOnComment');
          },
          enumerable: false,
          configurable: false
        });
        return ReactedOnComment;
      }());
      return callbacks;
    }());
    feed.component = (function() {
      const component = {};

      component.FeedComponentService = (function() {

        class FeedComponentService {

          constructor() {
            if (this.constructor.name === FeedComponentService.name) {
              throw new TypeError('class FeedComponentService is abstract');
            }
          }

          feedComponentContext(aspects, msg) {
            throw new TypeError('method feedComponentContext is abstract');
          }
        }

        FeedComponentService.prototype.feedComponentContext._messageTypes = function() {
          return [
            $root.wix.feed.component.CreateComponentContextRequests,
            $root.wix.feed.component.CreateComponentContextResponses
          ];
        };
        FeedComponentService.prototype.feedComponentContext.__proto = pbjs => {
          return $root.__lookup(pbjs)('wix.feed.component.FeedComponentService.FeedComponentContext');
        };
        Object.defineProperty(FeedComponentService.prototype, '__isRpcService__', {
          value: true,
          enumerable: false,
          configurable: false
        });
        Object.defineProperty(FeedComponentService.prototype, '__fqn__', {
          value: 'wix.feed.component.FeedComponentService',
          enumerable: false,
          configurable: false
        });
        Object.defineProperty(FeedComponentService.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('wix.feed.component.FeedComponentService');
          },
          enumerable: false,
          configurable: false
        });
        Object.defineProperty(FeedComponentService.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        return FeedComponentService;
      }());
      component.CreateComponentContextRequests = (function() {

        class CreateComponentContextRequests {

          constructor(props) {
            this.requests = props && props.requests;
          }

          static verify(msg, helper, errors = helper.verification.Errors.empty()) {
            if (typeof msg !== 'object' || msg == null) {
              errors.error('object expected');
            } else {
              if (msg.requests != null) {
                const fieldErrors = errors.field('requests');

                if (!Array.isArray(msg.requests)) {
                  fieldErrors.error('array expected');
                } else {
                  msg.requests.forEach((value, index) => {
                    $root.wix.feed.component.CreateComponentContextRequest.verify(value, helper, fieldErrors.index(index));
                  });
                }
              }
            }
            return errors;
          }

          static toJSON(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const json = {};

              if (obj.requests != null) {
                json.requests = obj.requests.map(e => {
                  return $root.wix.feed.component.CreateComponentContextRequest.toJSON(e, helper);
                });
              }
              return json;
            }
          }

          static fromJSON(json, helper) {
            const result = new $root.wix.feed.component.CreateComponentContextRequests();

            if (json.requests != null) {
              result.requests = json.requests.map(e => {
                return $root.wix.feed.component.CreateComponentContextRequest.fromJSON(e, helper);
              });
            } else {
              result.requests = [];
            }
            return result;
          }

          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};

              if (obj.requests != null) {
                grpc.requests = obj.requests.map(e => {
                  return $root.wix.feed.component.CreateComponentContextRequest.toGRPC(e, helper);
                });
              }
              return grpc;
            }
          }

          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.wix.feed.component.CreateComponentContextRequests();

              if (grpc.requests != null) {
                result.requests = grpc.requests.map(e => {
                  return $root.wix.feed.component.CreateComponentContextRequest.fromGRPC(e, helper);
                });
              } else {
                result.requests = [];
              }
              return result;
            }
          }

          static describe() {
            return {
              'fields': {
                'requests': {
                  'rule': 'repeated',
                  'type': $root.wix.feed.component.CreateComponentContextRequest,
                  'id': 1
                }
              }
            };
          }
        }

        Object.defineProperty(CreateComponentContextRequests.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('wix.feed.component.CreateComponentContextRequests');
          },
          enumerable: false,
          configurable: false
        });
        return CreateComponentContextRequests;
      }());
      component.CreateComponentContextRequest = (function() {

        class CreateComponentContextRequest {

          constructor(props) {
            this.contextSetup = props && props.contextSetup;
            this.query = props && props.query;
            this.role = props && props.role;
            this.identity = props && props.identity;
          }

          static verify(msg, helper, errors = helper.verification.Errors.empty()) {
            if (typeof msg !== 'object' || msg == null) {
              errors.error('object expected');
            } else {
              if (msg.contextSetup != null) {
                $root.wix.feed.component.PagingContextSetup.verify(msg.contextSetup, helper, errors.field('contextSetup'));
              }
              if (msg.query != null) {
                $root.wix.feed.component.FeedPropertiesQuery.verify(msg.query, helper, errors.field('query'));
              }
              if (msg.role != null) {
                $root.wix.feed.component.Role.verify(msg.role, helper, errors.field('role'));
              }
              if (msg.identity != null) {
                $root.com.wix.core.services.identification2.Identity.verify(msg.identity, helper, errors.field('identity'));
              }
            }
            return errors;
          }

          static toJSON(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const json = {};

              if (obj.contextSetup != null) {
                json.contextSetup = $root.wix.feed.component.PagingContextSetup.toJSON(obj.contextSetup, helper);
              }
              if (obj.query != null) {
                json.query = $root.wix.feed.component.FeedPropertiesQuery.toJSON(obj.query, helper);
              }
              if (obj.role != null) {
                json.role = $root.wix.feed.component.Role[obj.role];
              }
              if (obj.identity != null) {
                json.identity = $root.com.wix.core.services.identification2.Identity.toJSON(obj.identity, helper);
              }
              return json;
            }
          }

          static fromJSON(json, helper) {
            const result = new $root.wix.feed.component.CreateComponentContextRequest();

            if (json.contextSetup != null) {
              result.contextSetup = $root.wix.feed.component.PagingContextSetup.fromJSON(json.contextSetup, helper);
            } else {
              delete result.contextSetup;
            }
            if (json.query != null) {
              result.query = $root.wix.feed.component.FeedPropertiesQuery.fromJSON(json.query, helper);
            } else {
              delete result.query;
            }
            if (json.role != null) {
              result.role = $root.wix.feed.component.Role[json.role];
            } else {
              result.role = 'VIEWER';
            }
            if (json.identity != null) {
              result.identity = $root.com.wix.core.services.identification2.Identity.fromJSON(json.identity, helper);
            } else {
              delete result.identity;
            }
            return result;
          }

          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};

              if (obj.contextSetup != null) {
                grpc.contextSetup = $root.wix.feed.component.PagingContextSetup.toGRPC(obj.contextSetup, helper);
              }
              if (obj.query != null) {
                grpc.query = $root.wix.feed.component.FeedPropertiesQuery.toGRPC(obj.query, helper);
              }
              if (obj.role != null) {
                grpc.role = obj.role;
              }
              if (obj.identity != null) {
                grpc.identity = $root.com.wix.core.services.identification2.Identity.toGRPC(obj.identity, helper);
              }
              return grpc;
            }
          }

          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.wix.feed.component.CreateComponentContextRequest();

              if (grpc.contextSetup != null) {
                result.contextSetup = $root.wix.feed.component.PagingContextSetup.fromGRPC(grpc.contextSetup, helper);
              } else {
                delete result.contextSetup;
              }
              if (grpc.query != null) {
                result.query = $root.wix.feed.component.FeedPropertiesQuery.fromGRPC(grpc.query, helper);
              } else {
                delete result.query;
              }
              if (grpc.role != null) {
                result.role = grpc.role;
              } else {
                result.role = 'VIEWER';
              }
              if (grpc.identity != null) {
                result.identity = $root.com.wix.core.services.identification2.Identity.fromGRPC(grpc.identity, helper);
              } else {
                delete result.identity;
              }
              return result;
            }
          }

          static describe() {
            return {
              'fields': {
                'contextSetup': {
                  'type': $root.wix.feed.component.PagingContextSetup,
                  'id': 1
                },
                'query': {
                  'type': $root.wix.feed.component.FeedPropertiesQuery,
                  'id': 2
                },
                'role': {
                  'type': $root.wix.feed.component.Role,
                  'id': 3
                },
                'identity': {
                  'type': $root.com.wix.core.services.identification2.Identity,
                  'id': 5
                }
              }
            };
          }
        }

        Object.defineProperty(CreateComponentContextRequest.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('wix.feed.component.CreateComponentContextRequest');
          },
          enumerable: false,
          configurable: false
        });
        return CreateComponentContextRequest;
      }());
      component.FeedPropertiesQuery = (function() {

        class FeedPropertiesQuery {

          constructor(props) {
            this.commentsToLoad = props && props.commentsToLoad;
          }

          static verify(msg, helper, errors = helper.verification.Errors.empty()) {
            if (typeof msg !== 'object' || msg == null) {
              errors.error('object expected');
            } else {
              if (msg.commentsToLoad != null) {
                $root.google.protobuf.Int32Value.verify(msg.commentsToLoad, helper, errors.field('commentsToLoad'));
              }
            }
            return errors;
          }

          static toJSON(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const json = {};

              if (obj.commentsToLoad != null) {
                json.commentsToLoad = $root.google.protobuf.Int32Value.toJSON(obj.commentsToLoad, helper);
              }
              return json;
            }
          }

          static fromJSON(json, helper) {
            const result = new $root.wix.feed.component.FeedPropertiesQuery();

            if (json.commentsToLoad != null) {
              result.commentsToLoad = $root.google.protobuf.Int32Value.fromJSON(json.commentsToLoad, helper);
            } else {
              delete result.commentsToLoad;
            }
            return result;
          }

          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};

              if (obj.commentsToLoad != null) {
                grpc.commentsToLoad = $root.google.protobuf.Int32Value.toGRPC(obj.commentsToLoad, helper);
              }
              return grpc;
            }
          }

          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.wix.feed.component.FeedPropertiesQuery();

              if (grpc.commentsToLoad != null) {
                result.commentsToLoad = $root.google.protobuf.Int32Value.fromGRPC(grpc.commentsToLoad, helper);
              } else {
                delete result.commentsToLoad;
              }
              return result;
            }
          }

          static describe() {
            return {
              'fields': {
                'commentsToLoad': {
                  'type': $root.google.protobuf.Int32Value,
                  'id': 1,
                  'options': {
                    '(wix.api.min)': 0
                  }
                }
              }
            };
          }
        }

        Object.defineProperty(FeedPropertiesQuery.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('wix.feed.component.FeedPropertiesQuery');
          },
          enumerable: false,
          configurable: false
        });
        return FeedPropertiesQuery;
      }());
      component.PagingContextSetup = (function() {

        class PagingContextSetup {

          constructor(props) {
            this.containerId = props && props.containerId;
            this.containerType = props && props.containerType;
            this.limit = props && props.limit;
          }

          static verify(msg, helper, errors = helper.verification.Errors.empty()) {
            if (typeof msg !== 'object' || msg == null) {
              errors.error('object expected');
            } else {
              if (msg.containerId != null) {
                $root.google.protobuf.StringValue.verify(msg.containerId, helper, errors.field('containerId'));
              }
              if (msg.containerType != null) {
                $root.google.protobuf.StringValue.verify(msg.containerType, helper, errors.field('containerType'));
              }
              if (msg.limit != null) {
                $root.google.protobuf.Int32Value.verify(msg.limit, helper, errors.field('limit'));
              }
            }
            return errors;
          }

          static toJSON(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const json = {};

              if (obj.containerId != null) {
                json.containerId = $root.google.protobuf.StringValue.toJSON(obj.containerId, helper);
              }
              if (obj.containerType != null) {
                json.containerType = $root.google.protobuf.StringValue.toJSON(obj.containerType, helper);
              }
              if (obj.limit != null) {
                json.limit = $root.google.protobuf.Int32Value.toJSON(obj.limit, helper);
              }
              return json;
            }
          }

          static fromJSON(json, helper) {
            const result = new $root.wix.feed.component.PagingContextSetup();

            if (json.containerId != null) {
              result.containerId = $root.google.protobuf.StringValue.fromJSON(json.containerId, helper);
            } else {
              delete result.containerId;
            }
            if (json.containerType != null) {
              result.containerType = $root.google.protobuf.StringValue.fromJSON(json.containerType, helper);
            } else {
              delete result.containerType;
            }
            if (json.limit != null) {
              result.limit = $root.google.protobuf.Int32Value.fromJSON(json.limit, helper);
            } else {
              delete result.limit;
            }
            return result;
          }

          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};

              if (obj.containerId != null) {
                grpc.containerId = $root.google.protobuf.StringValue.toGRPC(obj.containerId, helper);
              }
              if (obj.containerType != null) {
                grpc.containerType = $root.google.protobuf.StringValue.toGRPC(obj.containerType, helper);
              }
              if (obj.limit != null) {
                grpc.limit = $root.google.protobuf.Int32Value.toGRPC(obj.limit, helper);
              }
              return grpc;
            }
          }

          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.wix.feed.component.PagingContextSetup();

              if (grpc.containerId != null) {
                result.containerId = $root.google.protobuf.StringValue.fromGRPC(grpc.containerId, helper);
              } else {
                delete result.containerId;
              }
              if (grpc.containerType != null) {
                result.containerType = $root.google.protobuf.StringValue.fromGRPC(grpc.containerType, helper);
              } else {
                delete result.containerType;
              }
              if (grpc.limit != null) {
                result.limit = $root.google.protobuf.Int32Value.fromGRPC(grpc.limit, helper);
              } else {
                delete result.limit;
              }
              return result;
            }
          }

          static describe() {
            return {
              'fields': {
                'containerId': {
                  'type': $root.google.protobuf.StringValue,
                  'id': 1
                },
                'containerType': {
                  'type': $root.google.protobuf.StringValue,
                  'id': 2
                },
                'limit': {
                  'type': $root.google.protobuf.Int32Value,
                  'id': 3,
                  'options': {
                    '(wix.api.min)': 0
                  }
                }
              }
            };
          }
        }

        Object.defineProperty(PagingContextSetup.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('wix.feed.component.PagingContextSetup');
          },
          enumerable: false,
          configurable: false
        });
        return PagingContextSetup;
      }());
      component.CreateComponentContextResponses = (function() {

        class CreateComponentContextResponses {

          constructor(props) {
            this.componentContexts = props && props.componentContexts;
          }

          static verify(msg, helper, errors = helper.verification.Errors.empty()) {
            if (typeof msg !== 'object' || msg == null) {
              errors.error('object expected');
            } else {
              if (msg.componentContexts != null) {
                const fieldErrors = errors.field('componentContexts');

                if (msg.componentContexts != null && (!(typeof msg.componentContexts === 'object') || Array.isArray(msg.componentContexts))) {
                  fieldErrors.error('object expected');
                } else {
                  for (let key in msg.componentContexts) {
                    const keyErrors = fieldErrors.index(key);
                    if (typeof msg.componentContexts[key] !== 'string') {
                      keyErrors.field('value').error('string expected');
                    }
                  }
                }
              }
            }
            return errors;
          }

          static toJSON(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const json = {};

              if (obj.componentContexts != null) {
                json.componentContexts = Object.entries(obj.componentContexts).reduce((acc, [k, v]) => {
                  acc[k] = v;
                  return acc;
                }, {});
              }
              return json;
            }
          }

          static fromJSON(json, helper) {
            const result = new $root.wix.feed.component.CreateComponentContextResponses();

            if (json.componentContexts != null) {
              result.componentContexts = Object.entries(json.componentContexts).reduce((acc, [k, v]) => {
                acc[k] = v;
                return acc;
              }, {});
            } else {
              delete result.componentContexts;
            }
            return result;
          }

          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};

              if (obj.componentContexts != null) {
                grpc.componentContexts = Object.entries(obj.componentContexts).reduce((acc, [k, v]) => {
                  acc[k] = v;
                  return acc;
                }, {});
              }
              return grpc;
            }
          }

          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.wix.feed.component.CreateComponentContextResponses();

              if (grpc.componentContexts != null) {
                result.componentContexts = Object.entries(grpc.componentContexts).reduce((acc, [k, v]) => {
                  acc[k] = v;
                  return acc;
                }, {});
              } else {
                delete result.componentContexts;
              }
              return result;
            }
          }

          static describe() {
            return {
              'fields': {
                'componentContexts': {
                  'keyType': 'string',
                  'type': 'string',
                  'id': 1
                }
              }
            };
          }
        }

        Object.defineProperty(CreateComponentContextResponses.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('wix.feed.component.CreateComponentContextResponses');
          },
          enumerable: false,
          configurable: false
        });
        return CreateComponentContextResponses;
      }());
      component.Role = {
        verify: (value, helper, errors = helper.verification.Errors.empty()) => {
          switch (value) {
            default: {
              errors.error('enum expected');
            }
            case 'VIEWER':
            case 'WRITER':
            case 'ADMIN':
              break;
          }
          return errors;
        },
        'VIEWER': 'VIEWER',
        'WRITER': 'WRITER',
        'ADMIN': 'ADMIN'
      };
      return component;
    }());
    feed.ContentPreviewService = (function() {

      class ContentPreviewService {

        constructor() {
          if (this.constructor.name === ContentPreviewService.name) {
            throw new TypeError('class ContentPreviewService is abstract');
          }
        }

        get(aspects, msg) {
          throw new TypeError('method get is abstract');
        }
      }

      ContentPreviewService.prototype.get._messageTypes = function() {
        return [
          $root.wix.feed.GetRequest,
          $root.wix.feed.GetResponse
        ];
      };
      ContentPreviewService.prototype.get.__proto = pbjs => {
        return $root.__lookup(pbjs)('wix.feed.ContentPreviewService.Get');
      };
      Object.defineProperty(ContentPreviewService.prototype, '__isRpcService__', {
        value: true,
        enumerable: false,
        configurable: false
      });
      Object.defineProperty(ContentPreviewService.prototype, '__fqn__', {
        value: 'wix.feed.ContentPreviewService',
        enumerable: false,
        configurable: false
      });
      Object.defineProperty(ContentPreviewService.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.feed.ContentPreviewService');
        },
        enumerable: false,
        configurable: false
      });
      Object.defineProperty(ContentPreviewService.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      return ContentPreviewService;
    }());
    feed.GetRequest = (function() {

      class GetRequest {

        constructor(props) {
          this.supportedOgTypes = props && props.supportedOgTypes;
          this.externalReferences = props && props.externalReferences;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.supportedOgTypes != null) {
              const fieldErrors = errors.field('supportedOgTypes');

              if (!Array.isArray(msg.supportedOgTypes)) {
                fieldErrors.error('array expected');
              } else {
                msg.supportedOgTypes.forEach((value, index) => {
                  if (typeof value !== 'string') {
                    fieldErrors.index(index).error('string expected');
                  }
                });
              }
            }
            if (msg.externalReferences != null) {
              const fieldErrors = errors.field('externalReferences');

              if (!Array.isArray(msg.externalReferences)) {
                fieldErrors.error('array expected');
              } else {
                msg.externalReferences.forEach((value, index) => {
                  $root.wix.social.ExternalReference.verify(value, helper, fieldErrors.index(index));
                });
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.supportedOgTypes != null) {
              json.supportedOgTypes = obj.supportedOgTypes.map(e => {
                return e;
              });
            }
            if (obj.externalReferences != null) {
              json.externalReferences = obj.externalReferences.map(e => {
                return $root.wix.social.ExternalReference.toJSON(e, helper);
              });
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.feed.GetRequest();

          if (json.supportedOgTypes != null) {
            result.supportedOgTypes = json.supportedOgTypes.map(e => {
              return e;
            });
          } else {
            result.supportedOgTypes = [];
          }
          if (json.externalReferences != null) {
            result.externalReferences = json.externalReferences.map(e => {
              return $root.wix.social.ExternalReference.fromJSON(e, helper);
            });
          } else {
            result.externalReferences = [];
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.supportedOgTypes != null) {
              grpc.supportedOgTypes = obj.supportedOgTypes.map(e => {
                return e;
              });
            }
            if (obj.externalReferences != null) {
              grpc.externalReferences = obj.externalReferences.map(e => {
                return $root.wix.social.ExternalReference.toGRPC(e, helper);
              });
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.feed.GetRequest();

            if (grpc.supportedOgTypes != null) {
              result.supportedOgTypes = grpc.supportedOgTypes.map(e => {
                return e;
              });
            } else {
              result.supportedOgTypes = [];
            }
            if (grpc.externalReferences != null) {
              result.externalReferences = grpc.externalReferences.map(e => {
                return $root.wix.social.ExternalReference.fromGRPC(e, helper);
              });
            } else {
              result.externalReferences = [];
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'supportedOgTypes': {
                'rule': 'repeated',
                'type': 'string',
                'id': 1
              },
              'externalReferences': {
                'rule': 'repeated',
                'type': $root.wix.social.ExternalReference,
                'id': 6
              }
            }
          };
        }
      }

      Object.defineProperty(GetRequest.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.feed.GetRequest');
        },
        enumerable: false,
        configurable: false
      });
      return GetRequest;
    }());
    feed.GetResponse = (function() {

      class GetResponse {

        constructor(props) {
          this.contentPreviews = props && props.contentPreviews;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.contentPreviews != null) {
              const fieldErrors = errors.field('contentPreviews');

              if (!Array.isArray(msg.contentPreviews)) {
                fieldErrors.error('array expected');
              } else {
                msg.contentPreviews.forEach((value, index) => {
                  $root.wix.social.ContentPreview.verify(value, helper, fieldErrors.index(index));
                });
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.contentPreviews != null) {
              json.contentPreviews = obj.contentPreviews.map(e => {
                return $root.wix.social.ContentPreview.toJSON(e, helper);
              });
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.feed.GetResponse();

          if (json.contentPreviews != null) {
            result.contentPreviews = json.contentPreviews.map(e => {
              return $root.wix.social.ContentPreview.fromJSON(e, helper);
            });
          } else {
            result.contentPreviews = [];
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.contentPreviews != null) {
              grpc.contentPreviews = obj.contentPreviews.map(e => {
                return $root.wix.social.ContentPreview.toGRPC(e, helper);
              });
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.feed.GetResponse();

            if (grpc.contentPreviews != null) {
              result.contentPreviews = grpc.contentPreviews.map(e => {
                return $root.wix.social.ContentPreview.fromGRPC(e, helper);
              });
            } else {
              result.contentPreviews = [];
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'contentPreviews': {
                'rule': 'repeated',
                'type': $root.wix.social.ContentPreview,
                'id': 1
              }
            }
          };
        }
      }

      Object.defineProperty(GetResponse.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.feed.GetResponse');
        },
        enumerable: false,
        configurable: false
      });
      return GetResponse;
    }());
    feed.FeedAccess = (function() {

      class FeedAccess {

        constructor(props) {}

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (!(typeof msg === 'object' && !Array.isArray(msg) && Object.keys(msg).length === 0)) {
              errors.error('empty object expected');
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.feed.FeedAccess();

          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.feed.FeedAccess();

            return result;
          }
        }

        static describe() {
          return {
            'fields': {}
          };
        }
      }

      Object.defineProperty(FeedAccess.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.feed.FeedAccess');
        },
        enumerable: false,
        configurable: false
      });
      return FeedAccess;
    }());
    feed.FeedService = (function() {

      class FeedService {

        constructor() {
          if (this.constructor.name === FeedService.name) {
            throw new TypeError('class FeedService is abstract');
          }
        }

        list(aspects, msg) {
          throw new TypeError('method list is abstract');
        }

        get(aspects, msg) {
          throw new TypeError('method get is abstract');
        }

        create(aspects, msg) {
          throw new TypeError('method create is abstract');
        }

        createComment(aspects, msg) {
          throw new TypeError('method createComment is abstract');
        }

        update(aspects, msg) {
          throw new TypeError('method update is abstract');
        }

        delete(aspects, msg) {
          throw new TypeError('method delete is abstract');
        }

        pinToContainer(aspects, msg) {
          throw new TypeError('method pinToContainer is abstract');
        }

        unpinFromContainer(aspects, msg) {
          throw new TypeError('method unpinFromContainer is abstract');
        }

        subscribeToFeedItem(aspects, msg) {
          throw new TypeError('method subscribeToFeedItem is abstract');
        }

        unsubscribeFromFeedItem(aspects, msg) {
          throw new TypeError('method unsubscribeFromFeedItem is abstract');
        }
      }

      FeedService.prototype.list._messageTypes = function() {
        return [
          $root.wix.feed.ListFeedItemsRequest,
          $root.wix.feed.ListFeedItemsResponse
        ];
      };
      FeedService.prototype.get._messageTypes = function() {
        return [
          $root.wix.feed.GetFeedItemRequest,
          $root.wix.feed.FeedItem
        ];
      };
      FeedService.prototype.create._messageTypes = function() {
        return [
          $root.wix.feed.CreateFeedItemRequest,
          $root.wix.feed.FeedItem
        ];
      };
      FeedService.prototype.createComment._messageTypes = function() {
        return [
          $root.wix.feed.CreateCommentRequest,
          $root.wix.comments.Comment
        ];
      };
      FeedService.prototype.update._messageTypes = function() {
        return [
          $root.wix.feed.UpdateFeedItemRequest,
          $root.wix.feed.FeedItem
        ];
      };
      FeedService.prototype.delete._messageTypes = function() {
        return [
          $root.wix.feed.DeleteFeedItemRequest,
          $root.wix.feed.FeedItem
        ];
      };
      FeedService.prototype.pinToContainer._messageTypes = function() {
        return [
          $root.wix.feed.PinToContainerRequest,
          $root.wix.feed.FeedItemPin
        ];
      };
      FeedService.prototype.unpinFromContainer._messageTypes = function() {
        return [
          $root.wix.feed.UnpinFromContainerRequest,
          $root.wix.feed.FeedItemPin
        ];
      };
      FeedService.prototype.subscribeToFeedItem._messageTypes = function() {
        return [
          $root.wix.feed.SubscribeToFeedItemRequest,
          $root.wix.feed.FeedItemRequester
        ];
      };
      FeedService.prototype.unsubscribeFromFeedItem._messageTypes = function() {
        return [
          $root.wix.feed.UnsubscribeFromFeedItemRequest,
          $root.wix.feed.FeedItemRequester
        ];
      };
      FeedService.prototype.list.__proto = pbjs => {
        return $root.__lookup(pbjs)('wix.feed.FeedService.List');
      };
      FeedService.prototype.get.__proto = pbjs => {
        return $root.__lookup(pbjs)('wix.feed.FeedService.Get');
      };
      FeedService.prototype.create.__proto = pbjs => {
        return $root.__lookup(pbjs)('wix.feed.FeedService.Create');
      };
      FeedService.prototype.createComment.__proto = pbjs => {
        return $root.__lookup(pbjs)('wix.feed.FeedService.CreateComment');
      };
      FeedService.prototype.update.__proto = pbjs => {
        return $root.__lookup(pbjs)('wix.feed.FeedService.Update');
      };
      FeedService.prototype.delete.__proto = pbjs => {
        return $root.__lookup(pbjs)('wix.feed.FeedService.Delete');
      };
      FeedService.prototype.pinToContainer.__proto = pbjs => {
        return $root.__lookup(pbjs)('wix.feed.FeedService.PinToContainer');
      };
      FeedService.prototype.unpinFromContainer.__proto = pbjs => {
        return $root.__lookup(pbjs)('wix.feed.FeedService.UnpinFromContainer');
      };
      FeedService.prototype.subscribeToFeedItem.__proto = pbjs => {
        return $root.__lookup(pbjs)('wix.feed.FeedService.SubscribeToFeedItem');
      };
      FeedService.prototype.unsubscribeFromFeedItem.__proto = pbjs => {
        return $root.__lookup(pbjs)('wix.feed.FeedService.UnsubscribeFromFeedItem');
      };
      Object.defineProperty(FeedService.prototype, '__isRpcService__', {
        value: true,
        enumerable: false,
        configurable: false
      });
      Object.defineProperty(FeedService.prototype, '__fqn__', {
        value: 'wix.feed.FeedService',
        enumerable: false,
        configurable: false
      });
      Object.defineProperty(FeedService.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.feed.FeedService');
        },
        enumerable: false,
        configurable: false
      });
      Object.defineProperty(FeedService.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      return FeedService;
    }());
    feed.ListFeedItemsRequest = (function() {

      class ListFeedItemsRequest {

        constructor(props) {
          this.contextToken = props && props.contextToken;
          this.cursor = props && props.cursor;
          this.query = props && props.query;
          this.fieldset = props && props.fieldset;
          this.previewQuery = props && props.previewQuery;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            const oneOfMutex = {};

            if (msg.contextToken != null) {
              $root.google.protobuf.StringValue.verify(msg.contextToken, helper, errors.field('contextToken'));
            }
            if (msg.cursor != null) {
              if (oneOfMutex['pageRequest']) {
                errors.field('cursor').up().field('pageRequest').error('multiple values');
              } else {
                oneOfMutex['pageRequest'] = true;
                $root.wix.common.CursorPaging.verify(msg.cursor, helper, errors.field('cursor'));
              }
            }
            if (msg.query != null) {
              if (oneOfMutex['pageRequest']) {
                errors.field('query').up().field('pageRequest').error('multiple values');
              } else {
                oneOfMutex['pageRequest'] = true;
                $root.wix.feed.FeedItemsQuery.verify(msg.query, helper, errors.field('query'));
              }
            }
            if (msg.fieldset != null) {
              if (typeof msg.fieldset !== 'string') {
                errors.field('fieldset').error('string expected');
              }
            }
            if (msg.previewQuery != null) {
              $root.wix.feed.ContentPreviewQuery.verify(msg.previewQuery, helper, errors.field('previewQuery'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.contextToken != null) {
              json.contextToken = $root.google.protobuf.StringValue.toJSON(obj.contextToken, helper);
            }
            if (obj.cursor != null) {
              json.cursor = $root.wix.common.CursorPaging.toJSON(obj.cursor, helper);
            }
            if (obj.query != null) {
              json.query = $root.wix.feed.FeedItemsQuery.toJSON(obj.query, helper);
            }
            if (obj.fieldset != null) {
              json.fieldset = obj.fieldset;
            }
            if (obj.previewQuery != null) {
              json.previewQuery = $root.wix.feed.ContentPreviewQuery.toJSON(obj.previewQuery, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.feed.ListFeedItemsRequest();

          if (json.contextToken != null) {
            result.contextToken = $root.google.protobuf.StringValue.fromJSON(json.contextToken, helper);
          } else {
            delete result.contextToken;
          }
          if (json.cursor != null) {
            result.cursor = $root.wix.common.CursorPaging.fromJSON(json.cursor, helper);
          } else {
            delete result.cursor;
          }
          if (json.query != null) {
            result.query = $root.wix.feed.FeedItemsQuery.fromJSON(json.query, helper);
          } else {
            delete result.query;
          }
          if (json.fieldset != null) {
            result.fieldset = json.fieldset;
          } else {
            result.fieldset = '';
          }
          if (json.previewQuery != null) {
            result.previewQuery = $root.wix.feed.ContentPreviewQuery.fromJSON(json.previewQuery, helper);
          } else {
            delete result.previewQuery;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.contextToken != null) {
              grpc.contextToken = $root.google.protobuf.StringValue.toGRPC(obj.contextToken, helper);
            }
            if (obj.cursor != null) {
              grpc.cursor = $root.wix.common.CursorPaging.toGRPC(obj.cursor, helper);
            }
            if (obj.query != null) {
              grpc.query = $root.wix.feed.FeedItemsQuery.toGRPC(obj.query, helper);
            }
            if (obj.fieldset != null) {
              grpc.fieldset = obj.fieldset;
            }
            if (obj.previewQuery != null) {
              grpc.previewQuery = $root.wix.feed.ContentPreviewQuery.toGRPC(obj.previewQuery, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.feed.ListFeedItemsRequest();

            if (grpc.contextToken != null) {
              result.contextToken = $root.google.protobuf.StringValue.fromGRPC(grpc.contextToken, helper);
            } else {
              delete result.contextToken;
            }
            if (grpc.cursor != null) {
              result.cursor = $root.wix.common.CursorPaging.fromGRPC(grpc.cursor, helper);
            } else {
              delete result.cursor;
            }
            if (grpc.query != null) {
              result.query = $root.wix.feed.FeedItemsQuery.fromGRPC(grpc.query, helper);
            } else {
              delete result.query;
            }
            if (grpc.fieldset != null) {
              result.fieldset = grpc.fieldset;
            } else {
              result.fieldset = '';
            }
            if (grpc.previewQuery != null) {
              result.previewQuery = $root.wix.feed.ContentPreviewQuery.fromGRPC(grpc.previewQuery, helper);
            } else {
              delete result.previewQuery;
            }
            return result;
          }
        }

        static describe() {
          return {
            'oneofs': {
              'pageRequest': {
                'oneof': [
                  'cursor',
                  'query'
                ]
              }
            },
            'fields': {
              'contextToken': {
                'type': $root.google.protobuf.StringValue,
                'id': 1
              },
              'cursor': {
                'type': $root.wix.common.CursorPaging,
                'id': 2
              },
              'query': {
                'type': $root.wix.feed.FeedItemsQuery,
                'id': 3
              },
              'fieldset': {
                'type': 'string',
                'id': 4
              },
              'previewQuery': {
                'type': $root.wix.feed.ContentPreviewQuery,
                'id': 5
              }
            }
          };
        }
      }

      Object.defineProperty(ListFeedItemsRequest.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.feed.ListFeedItemsRequest');
        },
        enumerable: false,
        configurable: false
      });
      return ListFeedItemsRequest;
    }());
    feed.CreateFeedItemRequest = (function() {

      class CreateFeedItemRequest {

        constructor(props) {
          this.contextToken = props && props.contextToken;
          this.entity = props && props.entity;
          this.applicationData = props && props.applicationData;
          this.applicationOverrides = props && props.applicationOverrides;
          this.fieldset = props && props.fieldset;
          this.previewQuery = props && props.previewQuery;
          this.predefinedFeedItemId = props && props.predefinedFeedItemId;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.contextToken != null) {
              $root.google.protobuf.StringValue.verify(msg.contextToken, helper, errors.field('contextToken'));
            }
            if (msg.entity != null) {
              $root.wix.feed.FeedItemEntity.verify(msg.entity, helper, errors.field('entity'));
            }
            if (msg.applicationData != null) {
              $root.wix.feed.ApplicationData.verify(msg.applicationData, helper, errors.field('applicationData'));
            }
            if (msg.applicationOverrides != null) {
              $root.wix.feed.ApplicationOverrides.verify(msg.applicationOverrides, helper, errors.field('applicationOverrides'));
            }
            if (msg.fieldset != null) {
              if (typeof msg.fieldset !== 'string') {
                errors.field('fieldset').error('string expected');
              }
            }
            if (msg.previewQuery != null) {
              $root.wix.feed.ContentPreviewQuery.verify(msg.previewQuery, helper, errors.field('previewQuery'));
            }
            if (msg.predefinedFeedItemId != null) {
              $root.google.protobuf.StringValue.verify(msg.predefinedFeedItemId, helper, errors.field('predefinedFeedItemId'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.contextToken != null) {
              json.contextToken = $root.google.protobuf.StringValue.toJSON(obj.contextToken, helper);
            }
            if (obj.entity != null) {
              json.entity = $root.wix.feed.FeedItemEntity.toJSON(obj.entity, helper);
            }
            if (obj.applicationData != null) {
              json.applicationData = $root.wix.feed.ApplicationData.toJSON(obj.applicationData, helper);
            }
            if (obj.applicationOverrides != null) {
              json.applicationOverrides = $root.wix.feed.ApplicationOverrides.toJSON(obj.applicationOverrides, helper);
            }
            if (obj.fieldset != null) {
              json.fieldset = obj.fieldset;
            }
            if (obj.previewQuery != null) {
              json.previewQuery = $root.wix.feed.ContentPreviewQuery.toJSON(obj.previewQuery, helper);
            }
            if (obj.predefinedFeedItemId != null) {
              json.predefinedFeedItemId = $root.google.protobuf.StringValue.toJSON(obj.predefinedFeedItemId, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.feed.CreateFeedItemRequest();

          if (json.contextToken != null) {
            result.contextToken = $root.google.protobuf.StringValue.fromJSON(json.contextToken, helper);
          } else {
            delete result.contextToken;
          }
          if (json.entity != null) {
            result.entity = $root.wix.feed.FeedItemEntity.fromJSON(json.entity, helper);
          } else {
            delete result.entity;
          }
          if (json.applicationData != null) {
            result.applicationData = $root.wix.feed.ApplicationData.fromJSON(json.applicationData, helper);
          } else {
            delete result.applicationData;
          }
          if (json.applicationOverrides != null) {
            result.applicationOverrides = $root.wix.feed.ApplicationOverrides.fromJSON(json.applicationOverrides, helper);
          } else {
            delete result.applicationOverrides;
          }
          if (json.fieldset != null) {
            result.fieldset = json.fieldset;
          } else {
            result.fieldset = '';
          }
          if (json.previewQuery != null) {
            result.previewQuery = $root.wix.feed.ContentPreviewQuery.fromJSON(json.previewQuery, helper);
          } else {
            delete result.previewQuery;
          }
          if (json.predefinedFeedItemId != null) {
            result.predefinedFeedItemId = $root.google.protobuf.StringValue.fromJSON(json.predefinedFeedItemId, helper);
          } else {
            delete result.predefinedFeedItemId;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.contextToken != null) {
              grpc.contextToken = $root.google.protobuf.StringValue.toGRPC(obj.contextToken, helper);
            }
            if (obj.entity != null) {
              grpc.entity = $root.wix.feed.FeedItemEntity.toGRPC(obj.entity, helper);
            }
            if (obj.applicationData != null) {
              grpc.applicationData = $root.wix.feed.ApplicationData.toGRPC(obj.applicationData, helper);
            }
            if (obj.applicationOverrides != null) {
              grpc.applicationOverrides = $root.wix.feed.ApplicationOverrides.toGRPC(obj.applicationOverrides, helper);
            }
            if (obj.fieldset != null) {
              grpc.fieldset = obj.fieldset;
            }
            if (obj.previewQuery != null) {
              grpc.previewQuery = $root.wix.feed.ContentPreviewQuery.toGRPC(obj.previewQuery, helper);
            }
            if (obj.predefinedFeedItemId != null) {
              grpc.predefinedFeedItemId = $root.google.protobuf.StringValue.toGRPC(obj.predefinedFeedItemId, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.feed.CreateFeedItemRequest();

            if (grpc.contextToken != null) {
              result.contextToken = $root.google.protobuf.StringValue.fromGRPC(grpc.contextToken, helper);
            } else {
              delete result.contextToken;
            }
            if (grpc.entity != null) {
              result.entity = $root.wix.feed.FeedItemEntity.fromGRPC(grpc.entity, helper);
            } else {
              delete result.entity;
            }
            if (grpc.applicationData != null) {
              result.applicationData = $root.wix.feed.ApplicationData.fromGRPC(grpc.applicationData, helper);
            } else {
              delete result.applicationData;
            }
            if (grpc.applicationOverrides != null) {
              result.applicationOverrides = $root.wix.feed.ApplicationOverrides.fromGRPC(grpc.applicationOverrides, helper);
            } else {
              delete result.applicationOverrides;
            }
            if (grpc.fieldset != null) {
              result.fieldset = grpc.fieldset;
            } else {
              result.fieldset = '';
            }
            if (grpc.previewQuery != null) {
              result.previewQuery = $root.wix.feed.ContentPreviewQuery.fromGRPC(grpc.previewQuery, helper);
            } else {
              delete result.previewQuery;
            }
            if (grpc.predefinedFeedItemId != null) {
              result.predefinedFeedItemId = $root.google.protobuf.StringValue.fromGRPC(grpc.predefinedFeedItemId, helper);
            } else {
              delete result.predefinedFeedItemId;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'contextToken': {
                'type': $root.google.protobuf.StringValue,
                'id': 1
              },
              'entity': {
                'type': $root.wix.feed.FeedItemEntity,
                'id': 2
              },
              'applicationData': {
                'type': $root.wix.feed.ApplicationData,
                'id': 3
              },
              'applicationOverrides': {
                'type': $root.wix.feed.ApplicationOverrides,
                'id': 4
              },
              'fieldset': {
                'type': 'string',
                'id': 5
              },
              'previewQuery': {
                'type': $root.wix.feed.ContentPreviewQuery,
                'id': 6
              },
              'predefinedFeedItemId': {
                'type': $root.google.protobuf.StringValue,
                'id': 7,
                'options': {
                  '(wix.api.format)': 'GUID'
                }
              }
            }
          };
        }
      }

      Object.defineProperty(CreateFeedItemRequest.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.feed.CreateFeedItemRequest');
        },
        enumerable: false,
        configurable: false
      });
      return CreateFeedItemRequest;
    }());
    feed.CreateCommentRequest = (function() {

      class CreateCommentRequest {

        constructor(props) {
          this.contextToken = props && props.contextToken;
          this.feedItemId = props && props.feedItemId;
          this.comment = props && props.comment;
          this.predefinedCommentId = props && props.predefinedCommentId;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.contextToken != null) {
              $root.google.protobuf.StringValue.verify(msg.contextToken, helper, errors.field('contextToken'));
            }
            if (msg.feedItemId != null) {
              if (typeof msg.feedItemId !== 'string') {
                errors.field('feedItemId').error('string expected');
              }
            }
            if (msg.comment != null) {
              $root.wix.comments.CommentEntity.verify(msg.comment, helper, errors.field('comment'));
            }
            if (msg.predefinedCommentId != null) {
              $root.google.protobuf.StringValue.verify(msg.predefinedCommentId, helper, errors.field('predefinedCommentId'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.contextToken != null) {
              json.contextToken = $root.google.protobuf.StringValue.toJSON(obj.contextToken, helper);
            }
            if (obj.feedItemId != null) {
              json.feedItemId = obj.feedItemId;
            }
            if (obj.comment != null) {
              json.comment = $root.wix.comments.CommentEntity.toJSON(obj.comment, helper);
            }
            if (obj.predefinedCommentId != null) {
              json.predefinedCommentId = $root.google.protobuf.StringValue.toJSON(obj.predefinedCommentId, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.feed.CreateCommentRequest();

          if (json.contextToken != null) {
            result.contextToken = $root.google.protobuf.StringValue.fromJSON(json.contextToken, helper);
          } else {
            delete result.contextToken;
          }
          if (json.feedItemId != null) {
            result.feedItemId = json.feedItemId;
          } else {
            result.feedItemId = '';
          }
          if (json.comment != null) {
            result.comment = $root.wix.comments.CommentEntity.fromJSON(json.comment, helper);
          } else {
            delete result.comment;
          }
          if (json.predefinedCommentId != null) {
            result.predefinedCommentId = $root.google.protobuf.StringValue.fromJSON(json.predefinedCommentId, helper);
          } else {
            delete result.predefinedCommentId;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.contextToken != null) {
              grpc.contextToken = $root.google.protobuf.StringValue.toGRPC(obj.contextToken, helper);
            }
            if (obj.feedItemId != null) {
              grpc.feedItemId = obj.feedItemId;
            }
            if (obj.comment != null) {
              grpc.comment = $root.wix.comments.CommentEntity.toGRPC(obj.comment, helper);
            }
            if (obj.predefinedCommentId != null) {
              grpc.predefinedCommentId = $root.google.protobuf.StringValue.toGRPC(obj.predefinedCommentId, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.feed.CreateCommentRequest();

            if (grpc.contextToken != null) {
              result.contextToken = $root.google.protobuf.StringValue.fromGRPC(grpc.contextToken, helper);
            } else {
              delete result.contextToken;
            }
            if (grpc.feedItemId != null) {
              result.feedItemId = grpc.feedItemId;
            } else {
              result.feedItemId = '';
            }
            if (grpc.comment != null) {
              result.comment = $root.wix.comments.CommentEntity.fromGRPC(grpc.comment, helper);
            } else {
              delete result.comment;
            }
            if (grpc.predefinedCommentId != null) {
              result.predefinedCommentId = $root.google.protobuf.StringValue.fromGRPC(grpc.predefinedCommentId, helper);
            } else {
              delete result.predefinedCommentId;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'contextToken': {
                'type': $root.google.protobuf.StringValue,
                'id': 1
              },
              'feedItemId': {
                'type': 'string',
                'id': 2,
                'options': {
                  '(wix.api.format)': 'GUID'
                }
              },
              'comment': {
                'type': $root.wix.comments.CommentEntity,
                'id': 3
              },
              'predefinedCommentId': {
                'type': $root.google.protobuf.StringValue,
                'id': 4,
                'options': {
                  '(wix.api.format)': 'GUID'
                }
              }
            }
          };
        }
      }

      Object.defineProperty(CreateCommentRequest.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.feed.CreateCommentRequest');
        },
        enumerable: false,
        configurable: false
      });
      return CreateCommentRequest;
    }());
    feed.UpdateFeedItemRequest = (function() {

      class UpdateFeedItemRequest {

        constructor(props) {
          this.contextToken = props && props.contextToken;
          this.feedItemId = props && props.feedItemId;
          this.entity = props && props.entity;
          this.applicationData = props && props.applicationData;
          this.applicationOverrides = props && props.applicationOverrides;
          this.updateMask = props && props.updateMask;
          this.fieldset = props && props.fieldset;
          this.previewQuery = props && props.previewQuery;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.contextToken != null) {
              $root.google.protobuf.StringValue.verify(msg.contextToken, helper, errors.field('contextToken'));
            }
            if (msg.feedItemId != null) {
              if (typeof msg.feedItemId !== 'string') {
                errors.field('feedItemId').error('string expected');
              }
            }
            if (msg.entity != null) {
              $root.wix.feed.FeedItemEntity.verify(msg.entity, helper, errors.field('entity'));
            }
            if (msg.applicationData != null) {
              $root.wix.feed.ApplicationData.verify(msg.applicationData, helper, errors.field('applicationData'));
            }
            if (msg.applicationOverrides != null) {
              $root.wix.feed.ApplicationOverrides.verify(msg.applicationOverrides, helper, errors.field('applicationOverrides'));
            }
            if (msg.updateMask != null) {
              $root.google.protobuf.FieldMask.verify(msg.updateMask, helper, errors.field('updateMask'));
            }
            if (msg.fieldset != null) {
              if (typeof msg.fieldset !== 'string') {
                errors.field('fieldset').error('string expected');
              }
            }
            if (msg.previewQuery != null) {
              $root.wix.feed.ContentPreviewQuery.verify(msg.previewQuery, helper, errors.field('previewQuery'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.contextToken != null) {
              json.contextToken = $root.google.protobuf.StringValue.toJSON(obj.contextToken, helper);
            }
            if (obj.feedItemId != null) {
              json.feedItemId = obj.feedItemId;
            }
            if (obj.entity != null) {
              json.entity = $root.wix.feed.FeedItemEntity.toJSON(obj.entity, helper);
            }
            if (obj.applicationData != null) {
              json.applicationData = $root.wix.feed.ApplicationData.toJSON(obj.applicationData, helper);
            }
            if (obj.applicationOverrides != null) {
              json.applicationOverrides = $root.wix.feed.ApplicationOverrides.toJSON(obj.applicationOverrides, helper);
            }
            if (obj.updateMask != null) {
              json.updateMask = $root.google.protobuf.FieldMask.toJSON(obj.updateMask, helper);
            }
            if (obj.fieldset != null) {
              json.fieldset = obj.fieldset;
            }
            if (obj.previewQuery != null) {
              json.previewQuery = $root.wix.feed.ContentPreviewQuery.toJSON(obj.previewQuery, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.feed.UpdateFeedItemRequest();

          if (json.contextToken != null) {
            result.contextToken = $root.google.protobuf.StringValue.fromJSON(json.contextToken, helper);
          } else {
            delete result.contextToken;
          }
          if (json.feedItemId != null) {
            result.feedItemId = json.feedItemId;
          } else {
            result.feedItemId = '';
          }
          if (json.entity != null) {
            result.entity = $root.wix.feed.FeedItemEntity.fromJSON(json.entity, helper);
          } else {
            delete result.entity;
          }
          if (json.applicationData != null) {
            result.applicationData = $root.wix.feed.ApplicationData.fromJSON(json.applicationData, helper);
          } else {
            delete result.applicationData;
          }
          if (json.applicationOverrides != null) {
            result.applicationOverrides = $root.wix.feed.ApplicationOverrides.fromJSON(json.applicationOverrides, helper);
          } else {
            delete result.applicationOverrides;
          }
          if (json.updateMask != null) {
            result.updateMask = $root.google.protobuf.FieldMask.fromJSON(json.updateMask, helper);
          } else {
            delete result.updateMask;
          }
          if (json.fieldset != null) {
            result.fieldset = json.fieldset;
          } else {
            result.fieldset = '';
          }
          if (json.previewQuery != null) {
            result.previewQuery = $root.wix.feed.ContentPreviewQuery.fromJSON(json.previewQuery, helper);
          } else {
            delete result.previewQuery;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.contextToken != null) {
              grpc.contextToken = $root.google.protobuf.StringValue.toGRPC(obj.contextToken, helper);
            }
            if (obj.feedItemId != null) {
              grpc.feedItemId = obj.feedItemId;
            }
            if (obj.entity != null) {
              grpc.entity = $root.wix.feed.FeedItemEntity.toGRPC(obj.entity, helper);
            }
            if (obj.applicationData != null) {
              grpc.applicationData = $root.wix.feed.ApplicationData.toGRPC(obj.applicationData, helper);
            }
            if (obj.applicationOverrides != null) {
              grpc.applicationOverrides = $root.wix.feed.ApplicationOverrides.toGRPC(obj.applicationOverrides, helper);
            }
            if (obj.updateMask != null) {
              grpc.updateMask = $root.google.protobuf.FieldMask.toGRPC(obj.updateMask, helper);
            }
            if (obj.fieldset != null) {
              grpc.fieldset = obj.fieldset;
            }
            if (obj.previewQuery != null) {
              grpc.previewQuery = $root.wix.feed.ContentPreviewQuery.toGRPC(obj.previewQuery, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.feed.UpdateFeedItemRequest();

            if (grpc.contextToken != null) {
              result.contextToken = $root.google.protobuf.StringValue.fromGRPC(grpc.contextToken, helper);
            } else {
              delete result.contextToken;
            }
            if (grpc.feedItemId != null) {
              result.feedItemId = grpc.feedItemId;
            } else {
              result.feedItemId = '';
            }
            if (grpc.entity != null) {
              result.entity = $root.wix.feed.FeedItemEntity.fromGRPC(grpc.entity, helper);
            } else {
              delete result.entity;
            }
            if (grpc.applicationData != null) {
              result.applicationData = $root.wix.feed.ApplicationData.fromGRPC(grpc.applicationData, helper);
            } else {
              delete result.applicationData;
            }
            if (grpc.applicationOverrides != null) {
              result.applicationOverrides = $root.wix.feed.ApplicationOverrides.fromGRPC(grpc.applicationOverrides, helper);
            } else {
              delete result.applicationOverrides;
            }
            if (grpc.updateMask != null) {
              result.updateMask = $root.google.protobuf.FieldMask.fromGRPC(grpc.updateMask, helper);
            } else {
              delete result.updateMask;
            }
            if (grpc.fieldset != null) {
              result.fieldset = grpc.fieldset;
            } else {
              result.fieldset = '';
            }
            if (grpc.previewQuery != null) {
              result.previewQuery = $root.wix.feed.ContentPreviewQuery.fromGRPC(grpc.previewQuery, helper);
            } else {
              delete result.previewQuery;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'contextToken': {
                'type': $root.google.protobuf.StringValue,
                'id': 1
              },
              'feedItemId': {
                'type': 'string',
                'id': 2
              },
              'entity': {
                'type': $root.wix.feed.FeedItemEntity,
                'id': 3
              },
              'applicationData': {
                'type': $root.wix.feed.ApplicationData,
                'id': 4
              },
              'applicationOverrides': {
                'type': $root.wix.feed.ApplicationOverrides,
                'id': 5
              },
              'updateMask': {
                'type': $root.google.protobuf.FieldMask,
                'id': 6
              },
              'fieldset': {
                'type': 'string',
                'id': 7
              },
              'previewQuery': {
                'type': $root.wix.feed.ContentPreviewQuery,
                'id': 8
              }
            }
          };
        }
      }

      Object.defineProperty(UpdateFeedItemRequest.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.feed.UpdateFeedItemRequest');
        },
        enumerable: false,
        configurable: false
      });
      return UpdateFeedItemRequest;
    }());
    feed.DeleteFeedItemRequest = (function() {

      class DeleteFeedItemRequest {

        constructor(props) {
          this.contextToken = props && props.contextToken;
          this.feedItemId = props && props.feedItemId;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.contextToken != null) {
              $root.google.protobuf.StringValue.verify(msg.contextToken, helper, errors.field('contextToken'));
            }
            if (msg.feedItemId != null) {
              if (typeof msg.feedItemId !== 'string') {
                errors.field('feedItemId').error('string expected');
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.contextToken != null) {
              json.contextToken = $root.google.protobuf.StringValue.toJSON(obj.contextToken, helper);
            }
            if (obj.feedItemId != null) {
              json.feedItemId = obj.feedItemId;
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.feed.DeleteFeedItemRequest();

          if (json.contextToken != null) {
            result.contextToken = $root.google.protobuf.StringValue.fromJSON(json.contextToken, helper);
          } else {
            delete result.contextToken;
          }
          if (json.feedItemId != null) {
            result.feedItemId = json.feedItemId;
          } else {
            result.feedItemId = '';
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.contextToken != null) {
              grpc.contextToken = $root.google.protobuf.StringValue.toGRPC(obj.contextToken, helper);
            }
            if (obj.feedItemId != null) {
              grpc.feedItemId = obj.feedItemId;
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.feed.DeleteFeedItemRequest();

            if (grpc.contextToken != null) {
              result.contextToken = $root.google.protobuf.StringValue.fromGRPC(grpc.contextToken, helper);
            } else {
              delete result.contextToken;
            }
            if (grpc.feedItemId != null) {
              result.feedItemId = grpc.feedItemId;
            } else {
              result.feedItemId = '';
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'contextToken': {
                'type': $root.google.protobuf.StringValue,
                'id': 1
              },
              'feedItemId': {
                'type': 'string',
                'id': 2
              }
            }
          };
        }
      }

      Object.defineProperty(DeleteFeedItemRequest.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.feed.DeleteFeedItemRequest');
        },
        enumerable: false,
        configurable: false
      });
      return DeleteFeedItemRequest;
    }());
    feed.PinToContainerRequest = (function() {

      class PinToContainerRequest {

        constructor(props) {
          this.contextToken = props && props.contextToken;
          this.feedItemId = props && props.feedItemId;
          this.pinPolicy = props && props.pinPolicy;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.contextToken != null) {
              $root.google.protobuf.StringValue.verify(msg.contextToken, helper, errors.field('contextToken'));
            }
            if (msg.feedItemId != null) {
              if (typeof msg.feedItemId !== 'string') {
                errors.field('feedItemId').error('string expected');
              }
            }
            if (msg.pinPolicy != null) {
              $root.wix.feed.PinPolicy.verify(msg.pinPolicy, helper, errors.field('pinPolicy'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.contextToken != null) {
              json.contextToken = $root.google.protobuf.StringValue.toJSON(obj.contextToken, helper);
            }
            if (obj.feedItemId != null) {
              json.feedItemId = obj.feedItemId;
            }
            if (obj.pinPolicy != null) {
              json.pinPolicy = $root.wix.feed.PinPolicy.toJSON(obj.pinPolicy, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.feed.PinToContainerRequest();

          if (json.contextToken != null) {
            result.contextToken = $root.google.protobuf.StringValue.fromJSON(json.contextToken, helper);
          } else {
            delete result.contextToken;
          }
          if (json.feedItemId != null) {
            result.feedItemId = json.feedItemId;
          } else {
            result.feedItemId = '';
          }
          if (json.pinPolicy != null) {
            result.pinPolicy = $root.wix.feed.PinPolicy.fromJSON(json.pinPolicy, helper);
          } else {
            delete result.pinPolicy;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.contextToken != null) {
              grpc.contextToken = $root.google.protobuf.StringValue.toGRPC(obj.contextToken, helper);
            }
            if (obj.feedItemId != null) {
              grpc.feedItemId = obj.feedItemId;
            }
            if (obj.pinPolicy != null) {
              grpc.pinPolicy = $root.wix.feed.PinPolicy.toGRPC(obj.pinPolicy, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.feed.PinToContainerRequest();

            if (grpc.contextToken != null) {
              result.contextToken = $root.google.protobuf.StringValue.fromGRPC(grpc.contextToken, helper);
            } else {
              delete result.contextToken;
            }
            if (grpc.feedItemId != null) {
              result.feedItemId = grpc.feedItemId;
            } else {
              result.feedItemId = '';
            }
            if (grpc.pinPolicy != null) {
              result.pinPolicy = $root.wix.feed.PinPolicy.fromGRPC(grpc.pinPolicy, helper);
            } else {
              delete result.pinPolicy;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'contextToken': {
                'type': $root.google.protobuf.StringValue,
                'id': 1
              },
              'feedItemId': {
                'type': 'string',
                'id': 2
              },
              'pinPolicy': {
                'type': $root.wix.feed.PinPolicy,
                'id': 3
              }
            }
          };
        }
      }

      Object.defineProperty(PinToContainerRequest.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.feed.PinToContainerRequest');
        },
        enumerable: false,
        configurable: false
      });
      return PinToContainerRequest;
    }());
    feed.UnpinFromContainerRequest = (function() {

      class UnpinFromContainerRequest {

        constructor(props) {
          this.contextToken = props && props.contextToken;
          this.feedItemId = props && props.feedItemId;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.contextToken != null) {
              $root.google.protobuf.StringValue.verify(msg.contextToken, helper, errors.field('contextToken'));
            }
            if (msg.feedItemId != null) {
              if (typeof msg.feedItemId !== 'string') {
                errors.field('feedItemId').error('string expected');
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.contextToken != null) {
              json.contextToken = $root.google.protobuf.StringValue.toJSON(obj.contextToken, helper);
            }
            if (obj.feedItemId != null) {
              json.feedItemId = obj.feedItemId;
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.feed.UnpinFromContainerRequest();

          if (json.contextToken != null) {
            result.contextToken = $root.google.protobuf.StringValue.fromJSON(json.contextToken, helper);
          } else {
            delete result.contextToken;
          }
          if (json.feedItemId != null) {
            result.feedItemId = json.feedItemId;
          } else {
            result.feedItemId = '';
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.contextToken != null) {
              grpc.contextToken = $root.google.protobuf.StringValue.toGRPC(obj.contextToken, helper);
            }
            if (obj.feedItemId != null) {
              grpc.feedItemId = obj.feedItemId;
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.feed.UnpinFromContainerRequest();

            if (grpc.contextToken != null) {
              result.contextToken = $root.google.protobuf.StringValue.fromGRPC(grpc.contextToken, helper);
            } else {
              delete result.contextToken;
            }
            if (grpc.feedItemId != null) {
              result.feedItemId = grpc.feedItemId;
            } else {
              result.feedItemId = '';
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'contextToken': {
                'type': $root.google.protobuf.StringValue,
                'id': 1
              },
              'feedItemId': {
                'type': 'string',
                'id': 2
              }
            }
          };
        }
      }

      Object.defineProperty(UnpinFromContainerRequest.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.feed.UnpinFromContainerRequest');
        },
        enumerable: false,
        configurable: false
      });
      return UnpinFromContainerRequest;
    }());
    feed.GetFeedItemRequest = (function() {

      class GetFeedItemRequest {

        constructor(props) {
          this.contextToken = props && props.contextToken;
          this.feedItemId = props && props.feedItemId;
          this.fieldset = props && props.fieldset;
          this.previewQuery = props && props.previewQuery;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.contextToken != null) {
              $root.google.protobuf.StringValue.verify(msg.contextToken, helper, errors.field('contextToken'));
            }
            if (msg.feedItemId != null) {
              if (typeof msg.feedItemId !== 'string') {
                errors.field('feedItemId').error('string expected');
              }
            }
            if (msg.fieldset != null) {
              if (typeof msg.fieldset !== 'string') {
                errors.field('fieldset').error('string expected');
              }
            }
            if (msg.previewQuery != null) {
              $root.wix.feed.ContentPreviewQuery.verify(msg.previewQuery, helper, errors.field('previewQuery'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.contextToken != null) {
              json.contextToken = $root.google.protobuf.StringValue.toJSON(obj.contextToken, helper);
            }
            if (obj.feedItemId != null) {
              json.feedItemId = obj.feedItemId;
            }
            if (obj.fieldset != null) {
              json.fieldset = obj.fieldset;
            }
            if (obj.previewQuery != null) {
              json.previewQuery = $root.wix.feed.ContentPreviewQuery.toJSON(obj.previewQuery, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.feed.GetFeedItemRequest();

          if (json.contextToken != null) {
            result.contextToken = $root.google.protobuf.StringValue.fromJSON(json.contextToken, helper);
          } else {
            delete result.contextToken;
          }
          if (json.feedItemId != null) {
            result.feedItemId = json.feedItemId;
          } else {
            result.feedItemId = '';
          }
          if (json.fieldset != null) {
            result.fieldset = json.fieldset;
          } else {
            result.fieldset = '';
          }
          if (json.previewQuery != null) {
            result.previewQuery = $root.wix.feed.ContentPreviewQuery.fromJSON(json.previewQuery, helper);
          } else {
            delete result.previewQuery;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.contextToken != null) {
              grpc.contextToken = $root.google.protobuf.StringValue.toGRPC(obj.contextToken, helper);
            }
            if (obj.feedItemId != null) {
              grpc.feedItemId = obj.feedItemId;
            }
            if (obj.fieldset != null) {
              grpc.fieldset = obj.fieldset;
            }
            if (obj.previewQuery != null) {
              grpc.previewQuery = $root.wix.feed.ContentPreviewQuery.toGRPC(obj.previewQuery, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.feed.GetFeedItemRequest();

            if (grpc.contextToken != null) {
              result.contextToken = $root.google.protobuf.StringValue.fromGRPC(grpc.contextToken, helper);
            } else {
              delete result.contextToken;
            }
            if (grpc.feedItemId != null) {
              result.feedItemId = grpc.feedItemId;
            } else {
              result.feedItemId = '';
            }
            if (grpc.fieldset != null) {
              result.fieldset = grpc.fieldset;
            } else {
              result.fieldset = '';
            }
            if (grpc.previewQuery != null) {
              result.previewQuery = $root.wix.feed.ContentPreviewQuery.fromGRPC(grpc.previewQuery, helper);
            } else {
              delete result.previewQuery;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'contextToken': {
                'type': $root.google.protobuf.StringValue,
                'id': 1
              },
              'feedItemId': {
                'type': 'string',
                'id': 2
              },
              'fieldset': {
                'type': 'string',
                'id': 3
              },
              'previewQuery': {
                'type': $root.wix.feed.ContentPreviewQuery,
                'id': 4
              }
            }
          };
        }
      }

      Object.defineProperty(GetFeedItemRequest.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.feed.GetFeedItemRequest');
        },
        enumerable: false,
        configurable: false
      });
      return GetFeedItemRequest;
    }());
    feed.ListFeedItemsResponse = (function() {

      class ListFeedItemsResponse {

        constructor(props) {
          this.feedItems = props && props.feedItems;
          this.nextPageCursor = props && props.nextPageCursor;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.feedItems != null) {
              const fieldErrors = errors.field('feedItems');

              if (!Array.isArray(msg.feedItems)) {
                fieldErrors.error('array expected');
              } else {
                msg.feedItems.forEach((value, index) => {
                  $root.wix.feed.FeedItem.verify(value, helper, fieldErrors.index(index));
                });
              }
            }
            if (msg.nextPageCursor != null) {
              $root.google.protobuf.StringValue.verify(msg.nextPageCursor, helper, errors.field('nextPageCursor'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.feedItems != null) {
              json.feedItems = obj.feedItems.map(e => {
                return $root.wix.feed.FeedItem.toJSON(e, helper);
              });
            }
            if (obj.nextPageCursor != null) {
              json.nextPageCursor = $root.google.protobuf.StringValue.toJSON(obj.nextPageCursor, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.feed.ListFeedItemsResponse();

          if (json.feedItems != null) {
            result.feedItems = json.feedItems.map(e => {
              return $root.wix.feed.FeedItem.fromJSON(e, helper);
            });
          } else {
            result.feedItems = [];
          }
          if (json.nextPageCursor != null) {
            result.nextPageCursor = $root.google.protobuf.StringValue.fromJSON(json.nextPageCursor, helper);
          } else {
            delete result.nextPageCursor;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.feedItems != null) {
              grpc.feedItems = obj.feedItems.map(e => {
                return $root.wix.feed.FeedItem.toGRPC(e, helper);
              });
            }
            if (obj.nextPageCursor != null) {
              grpc.nextPageCursor = $root.google.protobuf.StringValue.toGRPC(obj.nextPageCursor, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.feed.ListFeedItemsResponse();

            if (grpc.feedItems != null) {
              result.feedItems = grpc.feedItems.map(e => {
                return $root.wix.feed.FeedItem.fromGRPC(e, helper);
              });
            } else {
              result.feedItems = [];
            }
            if (grpc.nextPageCursor != null) {
              result.nextPageCursor = $root.google.protobuf.StringValue.fromGRPC(grpc.nextPageCursor, helper);
            } else {
              delete result.nextPageCursor;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'feedItems': {
                'rule': 'repeated',
                'type': $root.wix.feed.FeedItem,
                'id': 1
              },
              'nextPageCursor': {
                'type': $root.google.protobuf.StringValue,
                'id': 2
              }
            }
          };
        }
      }

      Object.defineProperty(ListFeedItemsResponse.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.feed.ListFeedItemsResponse');
        },
        enumerable: false,
        configurable: false
      });
      return ListFeedItemsResponse;
    }());
    feed.SubscribeToFeedItemRequest = (function() {

      class SubscribeToFeedItemRequest {

        constructor(props) {
          this.feedItemId = props && props.feedItemId;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.feedItemId != null) {
              if (typeof msg.feedItemId !== 'string') {
                errors.field('feedItemId').error('string expected');
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.feedItemId != null) {
              json.feedItemId = obj.feedItemId;
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.feed.SubscribeToFeedItemRequest();

          if (json.feedItemId != null) {
            result.feedItemId = json.feedItemId;
          } else {
            result.feedItemId = '';
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.feedItemId != null) {
              grpc.feedItemId = obj.feedItemId;
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.feed.SubscribeToFeedItemRequest();

            if (grpc.feedItemId != null) {
              result.feedItemId = grpc.feedItemId;
            } else {
              result.feedItemId = '';
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'feedItemId': {
                'type': 'string',
                'id': 1
              }
            }
          };
        }
      }

      Object.defineProperty(SubscribeToFeedItemRequest.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.feed.SubscribeToFeedItemRequest');
        },
        enumerable: false,
        configurable: false
      });
      return SubscribeToFeedItemRequest;
    }());
    feed.UnsubscribeFromFeedItemRequest = (function() {

      class UnsubscribeFromFeedItemRequest {

        constructor(props) {
          this.feedItemId = props && props.feedItemId;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.feedItemId != null) {
              if (typeof msg.feedItemId !== 'string') {
                errors.field('feedItemId').error('string expected');
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.feedItemId != null) {
              json.feedItemId = obj.feedItemId;
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.feed.UnsubscribeFromFeedItemRequest();

          if (json.feedItemId != null) {
            result.feedItemId = json.feedItemId;
          } else {
            result.feedItemId = '';
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.feedItemId != null) {
              grpc.feedItemId = obj.feedItemId;
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.feed.UnsubscribeFromFeedItemRequest();

            if (grpc.feedItemId != null) {
              result.feedItemId = grpc.feedItemId;
            } else {
              result.feedItemId = '';
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'feedItemId': {
                'type': 'string',
                'id': 2
              }
            }
          };
        }
      }

      Object.defineProperty(UnsubscribeFromFeedItemRequest.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.feed.UnsubscribeFromFeedItemRequest');
        },
        enumerable: false,
        configurable: false
      });
      return UnsubscribeFromFeedItemRequest;
    }());
    feed.FeedItemsQuery = (function() {

      class FeedItemsQuery {

        constructor(props) {
          this.contextToken = props && props.contextToken;
          this.containerId = props && props.containerId;
          this.identityId = props && props.identityId;
          this.excludeOwn = props && props.excludeOwn;
          this.limit = props && props.limit;
          this.filter = props && props.filter;
          this.pinningDisabled = props && props.pinningDisabled;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.contextToken != null) {
              $root.google.protobuf.StringValue.verify(msg.contextToken, helper, errors.field('contextToken'));
            }
            if (msg.containerId != null) {
              $root.google.protobuf.StringValue.verify(msg.containerId, helper, errors.field('containerId'));
            }
            if (msg.identityId != null) {
              $root.google.protobuf.StringValue.verify(msg.identityId, helper, errors.field('identityId'));
            }
            if (msg.excludeOwn != null) {
              if (typeof msg.excludeOwn !== 'boolean') {
                errors.field('excludeOwn').error('boolean expected');
              }
            }
            if (msg.limit != null) {
              $root.google.protobuf.Int32Value.verify(msg.limit, helper, errors.field('limit'));
            }
            if (msg.filter != null) {
              $root.google.protobuf.Value.verify(msg.filter, helper, errors.field('filter'));
            }
            if (msg.pinningDisabled != null) {
              if (typeof msg.pinningDisabled !== 'boolean') {
                errors.field('pinningDisabled').error('boolean expected');
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.contextToken != null) {
              json.contextToken = $root.google.protobuf.StringValue.toJSON(obj.contextToken, helper);
            }
            if (obj.containerId != null) {
              json.containerId = $root.google.protobuf.StringValue.toJSON(obj.containerId, helper);
            }
            if (obj.identityId != null) {
              json.identityId = $root.google.protobuf.StringValue.toJSON(obj.identityId, helper);
            }
            if (obj.excludeOwn != null) {
              json.excludeOwn = obj.excludeOwn;
            }
            if (obj.limit != null) {
              json.limit = $root.google.protobuf.Int32Value.toJSON(obj.limit, helper);
            }
            if (obj.filter != null) {
              json.filter = $root.google.protobuf.Value.toJSON(obj.filter, helper);
            }
            if (obj.pinningDisabled != null) {
              json.pinningDisabled = obj.pinningDisabled;
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.feed.FeedItemsQuery();

          if (json.contextToken != null) {
            result.contextToken = $root.google.protobuf.StringValue.fromJSON(json.contextToken, helper);
          } else {
            delete result.contextToken;
          }
          if (json.containerId != null) {
            result.containerId = $root.google.protobuf.StringValue.fromJSON(json.containerId, helper);
          } else {
            delete result.containerId;
          }
          if (json.identityId != null) {
            result.identityId = $root.google.protobuf.StringValue.fromJSON(json.identityId, helper);
          } else {
            delete result.identityId;
          }
          if (json.excludeOwn != null) {
            result.excludeOwn = json.excludeOwn;
          } else {
            result.excludeOwn = false;
          }
          if (json.limit != null) {
            result.limit = $root.google.protobuf.Int32Value.fromJSON(json.limit, helper);
          } else {
            delete result.limit;
          }
          if (json.filter != null) {
            result.filter = $root.google.protobuf.Value.fromJSON(json.filter, helper);
          } else {
            delete result.filter;
          }
          if (json.pinningDisabled != null) {
            result.pinningDisabled = json.pinningDisabled;
          } else {
            result.pinningDisabled = false;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.contextToken != null) {
              grpc.contextToken = $root.google.protobuf.StringValue.toGRPC(obj.contextToken, helper);
            }
            if (obj.containerId != null) {
              grpc.containerId = $root.google.protobuf.StringValue.toGRPC(obj.containerId, helper);
            }
            if (obj.identityId != null) {
              grpc.identityId = $root.google.protobuf.StringValue.toGRPC(obj.identityId, helper);
            }
            if (obj.excludeOwn != null) {
              grpc.excludeOwn = obj.excludeOwn;
            }
            if (obj.limit != null) {
              grpc.limit = $root.google.protobuf.Int32Value.toGRPC(obj.limit, helper);
            }
            grpc.filter = ($root.google.protobuf.Value.toGRPC(obj.filter, helper));
            if (obj.pinningDisabled != null) {
              grpc.pinningDisabled = obj.pinningDisabled;
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.feed.FeedItemsQuery();

            if (grpc.contextToken != null) {
              result.contextToken = $root.google.protobuf.StringValue.fromGRPC(grpc.contextToken, helper);
            } else {
              delete result.contextToken;
            }
            if (grpc.containerId != null) {
              result.containerId = $root.google.protobuf.StringValue.fromGRPC(grpc.containerId, helper);
            } else {
              delete result.containerId;
            }
            if (grpc.identityId != null) {
              result.identityId = $root.google.protobuf.StringValue.fromGRPC(grpc.identityId, helper);
            } else {
              delete result.identityId;
            }
            if (grpc.excludeOwn != null) {
              result.excludeOwn = grpc.excludeOwn;
            } else {
              result.excludeOwn = false;
            }
            if (grpc.limit != null) {
              result.limit = $root.google.protobuf.Int32Value.fromGRPC(grpc.limit, helper);
            } else {
              delete result.limit;
            }
            if (grpc.filter != null) {
              result.filter = $root.google.protobuf.Value.fromGRPC(grpc.filter, helper);
            } else {
              delete result.filter;
            }
            if (grpc.pinningDisabled != null) {
              result.pinningDisabled = grpc.pinningDisabled;
            } else {
              result.pinningDisabled = false;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'contextToken': {
                'type': $root.google.protobuf.StringValue,
                'id': 1
              },
              'containerId': {
                'type': $root.google.protobuf.StringValue,
                'id': 2
              },
              'identityId': {
                'type': $root.google.protobuf.StringValue,
                'id': 3
              },
              'excludeOwn': {
                'type': 'bool',
                'id': 4
              },
              'limit': {
                'type': $root.google.protobuf.Int32Value,
                'id': 5,
                'options': {
                  '(wix.api.min)': 0
                }
              },
              'filter': {
                'type': $root.google.protobuf.Value,
                'id': 6
              },
              'pinningDisabled': {
                'type': 'bool',
                'id': 7
              }
            }
          };
        }
      }

      Object.defineProperty(FeedItemsQuery.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.feed.FeedItemsQuery');
        },
        enumerable: false,
        configurable: false
      });
      return FeedItemsQuery;
    }());
    feed.ApplicationOverrides = (function() {

      class ApplicationOverrides {

        constructor(props) {
          this.containerId = props && props.containerId;
          this.identityId = props && props.identityId;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.containerId != null) {
              $root.google.protobuf.StringValue.verify(msg.containerId, helper, errors.field('containerId'));
            }
            if (msg.identityId != null) {
              $root.google.protobuf.StringValue.verify(msg.identityId, helper, errors.field('identityId'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.containerId != null) {
              json.containerId = $root.google.protobuf.StringValue.toJSON(obj.containerId, helper);
            }
            if (obj.identityId != null) {
              json.identityId = $root.google.protobuf.StringValue.toJSON(obj.identityId, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.feed.ApplicationOverrides();

          if (json.containerId != null) {
            result.containerId = $root.google.protobuf.StringValue.fromJSON(json.containerId, helper);
          } else {
            delete result.containerId;
          }
          if (json.identityId != null) {
            result.identityId = $root.google.protobuf.StringValue.fromJSON(json.identityId, helper);
          } else {
            delete result.identityId;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.containerId != null) {
              grpc.containerId = $root.google.protobuf.StringValue.toGRPC(obj.containerId, helper);
            }
            if (obj.identityId != null) {
              grpc.identityId = $root.google.protobuf.StringValue.toGRPC(obj.identityId, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.feed.ApplicationOverrides();

            if (grpc.containerId != null) {
              result.containerId = $root.google.protobuf.StringValue.fromGRPC(grpc.containerId, helper);
            } else {
              delete result.containerId;
            }
            if (grpc.identityId != null) {
              result.identityId = $root.google.protobuf.StringValue.fromGRPC(grpc.identityId, helper);
            } else {
              delete result.identityId;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'containerId': {
                'type': $root.google.protobuf.StringValue,
                'id': 1
              },
              'identityId': {
                'type': $root.google.protobuf.StringValue,
                'id': 2
              }
            }
          };
        }
      }

      Object.defineProperty(ApplicationOverrides.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.feed.ApplicationOverrides');
        },
        enumerable: false,
        configurable: false
      });
      return ApplicationOverrides;
    }());
    feed.ContentPreviewQuery = (function() {

      class ContentPreviewQuery {

        constructor(props) {
          this.supportedOgTypes = props && props.supportedOgTypes;
          this.limit = props && props.limit;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.supportedOgTypes != null) {
              const fieldErrors = errors.field('supportedOgTypes');

              if (!Array.isArray(msg.supportedOgTypes)) {
                fieldErrors.error('array expected');
              } else {
                msg.supportedOgTypes.forEach((value, index) => {
                  if (typeof value !== 'string') {
                    fieldErrors.index(index).error('string expected');
                  }
                });
              }
            }
            if (msg.limit != null) {
              $root.google.protobuf.Int32Value.verify(msg.limit, helper, errors.field('limit'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.supportedOgTypes != null) {
              json.supportedOgTypes = obj.supportedOgTypes.map(e => {
                return e;
              });
            }
            if (obj.limit != null) {
              json.limit = $root.google.protobuf.Int32Value.toJSON(obj.limit, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.feed.ContentPreviewQuery();

          if (json.supportedOgTypes != null) {
            result.supportedOgTypes = json.supportedOgTypes.map(e => {
              return e;
            });
          } else {
            result.supportedOgTypes = [];
          }
          if (json.limit != null) {
            result.limit = $root.google.protobuf.Int32Value.fromJSON(json.limit, helper);
          } else {
            delete result.limit;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.supportedOgTypes != null) {
              grpc.supportedOgTypes = obj.supportedOgTypes.map(e => {
                return e;
              });
            }
            if (obj.limit != null) {
              grpc.limit = $root.google.protobuf.Int32Value.toGRPC(obj.limit, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.feed.ContentPreviewQuery();

            if (grpc.supportedOgTypes != null) {
              result.supportedOgTypes = grpc.supportedOgTypes.map(e => {
                return e;
              });
            } else {
              result.supportedOgTypes = [];
            }
            if (grpc.limit != null) {
              result.limit = $root.google.protobuf.Int32Value.fromGRPC(grpc.limit, helper);
            } else {
              delete result.limit;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'supportedOgTypes': {
                'rule': 'repeated',
                'type': 'string',
                'id': 1
              },
              'limit': {
                'type': $root.google.protobuf.Int32Value,
                'id': 2
              }
            }
          };
        }
      }

      Object.defineProperty(ContentPreviewQuery.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.feed.ContentPreviewQuery');
        },
        enumerable: false,
        configurable: false
      });
      return ContentPreviewQuery;
    }());
    feed.PinPolicy = (function() {

      class PinPolicy {

        constructor(props) {
          this.pinnedFeedItemsAllowed = props && props.pinnedFeedItemsAllowed;
          this.onExceedAllowedPins = props && props.onExceedAllowedPins;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.pinnedFeedItemsAllowed != null) {
              if (!Number.isInteger(msg.pinnedFeedItemsAllowed)) {
                errors.field('pinnedFeedItemsAllowed').error('integer expected');
              }
            }
            if (msg.onExceedAllowedPins != null) {
              $root.wix.feed.PinPolicy.OnExceedAllowedPins.verify(msg.onExceedAllowedPins, helper, errors.field('onExceedAllowedPins'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.pinnedFeedItemsAllowed != null) {
              json.pinnedFeedItemsAllowed = obj.pinnedFeedItemsAllowed;
            }
            if (obj.onExceedAllowedPins != null) {
              json.onExceedAllowedPins = $root.wix.feed.PinPolicy.OnExceedAllowedPins[obj.onExceedAllowedPins];
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.feed.PinPolicy();

          if (json.pinnedFeedItemsAllowed != null) {
            result.pinnedFeedItemsAllowed = json.pinnedFeedItemsAllowed;
          } else {
            result.pinnedFeedItemsAllowed = 0;
          }
          if (json.onExceedAllowedPins != null) {
            result.onExceedAllowedPins = $root.wix.feed.PinPolicy.OnExceedAllowedPins[json.onExceedAllowedPins];
          } else {
            result.onExceedAllowedPins = 'RESPOND_WITH_ALREADY_EXISTS';
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.pinnedFeedItemsAllowed != null) {
              grpc.pinnedFeedItemsAllowed = obj.pinnedFeedItemsAllowed;
            }
            if (obj.onExceedAllowedPins != null) {
              grpc.onExceedAllowedPins = obj.onExceedAllowedPins;
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.feed.PinPolicy();

            if (grpc.pinnedFeedItemsAllowed != null) {
              result.pinnedFeedItemsAllowed = grpc.pinnedFeedItemsAllowed;
            } else {
              result.pinnedFeedItemsAllowed = 0;
            }
            if (grpc.onExceedAllowedPins != null) {
              result.onExceedAllowedPins = grpc.onExceedAllowedPins;
            } else {
              result.onExceedAllowedPins = 'RESPOND_WITH_ALREADY_EXISTS';
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'pinnedFeedItemsAllowed': {
                'type': 'int32',
                'id': 1
              },
              'onExceedAllowedPins': {
                'type': $root.wix.feed.PinPolicy.OnExceedAllowedPins,
                'id': 2
              }
            },
            'nested': {
              'OnExceedAllowedPins': {
                'values': {
                  'RESPOND_WITH_ALREADY_EXISTS': 0,
                  'REPLACE_OLDEST': 1
                }
              }
            }
          };
        }
      }

      PinPolicy.OnExceedAllowedPins = {
        verify: (value, helper, errors = helper.verification.Errors.empty()) => {
          switch (value) {
            default: {
              errors.error('enum expected');
            }
            case 'RESPOND_WITH_ALREADY_EXISTS':
            case 'REPLACE_OLDEST':
              break;
          }
          return errors;
        },
        'RESPOND_WITH_ALREADY_EXISTS': 'RESPOND_WITH_ALREADY_EXISTS',
        'REPLACE_OLDEST': 'REPLACE_OLDEST'
      };
      PinPolicy.OnExceedAllowedPins = {
        verify: (value, helper, errors = helper.verification.Errors.empty()) => {
          switch (value) {
            default: {
              errors.error('enum expected');
            }
            case 'RESPOND_WITH_ALREADY_EXISTS':
            case 'REPLACE_OLDEST':
              break;
          }
          return errors;
        },
        'RESPOND_WITH_ALREADY_EXISTS': 'RESPOND_WITH_ALREADY_EXISTS',
        'REPLACE_OLDEST': 'REPLACE_OLDEST'
      };
      Object.defineProperty(PinPolicy.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.feed.PinPolicy');
        },
        enumerable: false,
        configurable: false
      });
      return PinPolicy;
    }());
    return feed;
  }());
  wix.reactions = (function() {
    const reactions = {};

    reactions.ItemReactionsSummary = (function() {

      class ItemReactionsSummary {

        constructor(props) {
          this.itemId = props && props.itemId;
          this.total = props && props.total;
          this.usersReacted = props && props.usersReacted;
          this.usersReactions = props && props.usersReactions;
          this.reactionsSummary = props && props.reactionsSummary;
          this.requesterReactions = props && props.requesterReactions;
          this.profiles = props && props.profiles;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.itemId != null) {
              if (typeof msg.itemId !== 'string') {
                errors.field('itemId').error('string expected');
              }
            }
            if (msg.total != null) {
              if (!Number.isInteger(msg.total)) {
                errors.field('total').error('integer expected');
              }
            }
            if (msg.usersReacted != null) {
              $root.wix.reactions.Users.verify(msg.usersReacted, helper, errors.field('usersReacted'));
            }
            if (msg.usersReactions != null) {
              $root.wix.reactions.UsersReactions.verify(msg.usersReactions, helper, errors.field('usersReactions'));
            }
            if (msg.reactionsSummary != null) {
              $root.wix.reactions.ReactionsSummary.verify(msg.reactionsSummary, helper, errors.field('reactionsSummary'));
            }
            if (msg.requesterReactions != null) {
              $root.wix.reactions.UserReactions.verify(msg.requesterReactions, helper, errors.field('requesterReactions'));
            }
            if (msg.profiles != null) {
              $root.wix.social.Profiles.verify(msg.profiles, helper, errors.field('profiles'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.itemId != null) {
              json.itemId = obj.itemId;
            }
            if (obj.total != null) {
              json.total = obj.total;
            }
            if (obj.usersReacted != null) {
              json.usersReacted = $root.wix.reactions.Users.toJSON(obj.usersReacted, helper);
            }
            if (obj.usersReactions != null) {
              json.usersReactions = $root.wix.reactions.UsersReactions.toJSON(obj.usersReactions, helper);
            }
            if (obj.reactionsSummary != null) {
              json.reactionsSummary = $root.wix.reactions.ReactionsSummary.toJSON(obj.reactionsSummary, helper);
            }
            if (obj.requesterReactions != null) {
              json.requesterReactions = $root.wix.reactions.UserReactions.toJSON(obj.requesterReactions, helper);
            }
            if (obj.profiles != null) {
              json.profiles = $root.wix.social.Profiles.toJSON(obj.profiles, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.reactions.ItemReactionsSummary();

          if (json.itemId != null) {
            result.itemId = json.itemId;
          } else {
            result.itemId = '';
          }
          if (json.total != null) {
            result.total = json.total;
          } else {
            result.total = 0;
          }
          if (json.usersReacted != null) {
            result.usersReacted = $root.wix.reactions.Users.fromJSON(json.usersReacted, helper);
          } else {
            delete result.usersReacted;
          }
          if (json.usersReactions != null) {
            result.usersReactions = $root.wix.reactions.UsersReactions.fromJSON(json.usersReactions, helper);
          } else {
            delete result.usersReactions;
          }
          if (json.reactionsSummary != null) {
            result.reactionsSummary = $root.wix.reactions.ReactionsSummary.fromJSON(json.reactionsSummary, helper);
          } else {
            delete result.reactionsSummary;
          }
          if (json.requesterReactions != null) {
            result.requesterReactions = $root.wix.reactions.UserReactions.fromJSON(json.requesterReactions, helper);
          } else {
            delete result.requesterReactions;
          }
          if (json.profiles != null) {
            result.profiles = $root.wix.social.Profiles.fromJSON(json.profiles, helper);
          } else {
            delete result.profiles;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.itemId != null) {
              grpc.itemId = obj.itemId;
            }
            if (obj.total != null) {
              grpc.total = obj.total;
            }
            if (obj.usersReacted != null) {
              grpc.usersReacted = $root.wix.reactions.Users.toGRPC(obj.usersReacted, helper);
            }
            if (obj.usersReactions != null) {
              grpc.usersReactions = $root.wix.reactions.UsersReactions.toGRPC(obj.usersReactions, helper);
            }
            if (obj.reactionsSummary != null) {
              grpc.reactionsSummary = $root.wix.reactions.ReactionsSummary.toGRPC(obj.reactionsSummary, helper);
            }
            if (obj.requesterReactions != null) {
              grpc.requesterReactions = $root.wix.reactions.UserReactions.toGRPC(obj.requesterReactions, helper);
            }
            if (obj.profiles != null) {
              grpc.profiles = $root.wix.social.Profiles.toGRPC(obj.profiles, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.reactions.ItemReactionsSummary();

            if (grpc.itemId != null) {
              result.itemId = grpc.itemId;
            } else {
              result.itemId = '';
            }
            if (grpc.total != null) {
              result.total = grpc.total;
            } else {
              result.total = 0;
            }
            if (grpc.usersReacted != null) {
              result.usersReacted = $root.wix.reactions.Users.fromGRPC(grpc.usersReacted, helper);
            } else {
              delete result.usersReacted;
            }
            if (grpc.usersReactions != null) {
              result.usersReactions = $root.wix.reactions.UsersReactions.fromGRPC(grpc.usersReactions, helper);
            } else {
              delete result.usersReactions;
            }
            if (grpc.reactionsSummary != null) {
              result.reactionsSummary = $root.wix.reactions.ReactionsSummary.fromGRPC(grpc.reactionsSummary, helper);
            } else {
              delete result.reactionsSummary;
            }
            if (grpc.requesterReactions != null) {
              result.requesterReactions = $root.wix.reactions.UserReactions.fromGRPC(grpc.requesterReactions, helper);
            } else {
              delete result.requesterReactions;
            }
            if (grpc.profiles != null) {
              result.profiles = $root.wix.social.Profiles.fromGRPC(grpc.profiles, helper);
            } else {
              delete result.profiles;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'itemId': {
                'type': 'string',
                'id': 1
              },
              'total': {
                'type': 'int32',
                'id': 2
              },
              'usersReacted': {
                'type': $root.wix.reactions.Users,
                'id': 3
              },
              'usersReactions': {
                'type': $root.wix.reactions.UsersReactions,
                'id': 4
              },
              'reactionsSummary': {
                'type': $root.wix.reactions.ReactionsSummary,
                'id': 5
              },
              'requesterReactions': {
                'type': $root.wix.reactions.UserReactions,
                'id': 6
              },
              'profiles': {
                'type': $root.wix.social.Profiles,
                'id': 7
              }
            }
          };
        }
      }

      Object.defineProperty(ItemReactionsSummary.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.reactions.ItemReactionsSummary');
        },
        enumerable: false,
        configurable: false
      });
      return ItemReactionsSummary;
    }());
    reactions.Users = (function() {

      class Users {

        constructor(props) {
          this.total = props && props.total;
          this.userIds = props && props.userIds;
          this.nextCursor = props && props.nextCursor;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.total != null) {
              if (!Number.isInteger(msg.total)) {
                errors.field('total').error('integer expected');
              }
            }
            if (msg.userIds != null) {
              const fieldErrors = errors.field('userIds');

              if (!Array.isArray(msg.userIds)) {
                fieldErrors.error('array expected');
              } else {
                msg.userIds.forEach((value, index) => {
                  if (typeof value !== 'string') {
                    fieldErrors.index(index).error('string expected');
                  }
                });
              }
            }
            if (msg.nextCursor != null) {
              $root.google.protobuf.StringValue.verify(msg.nextCursor, helper, errors.field('nextCursor'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.total != null) {
              json.total = obj.total;
            }
            if (obj.userIds != null) {
              json.userIds = obj.userIds.map(e => {
                return e;
              });
            }
            if (obj.nextCursor != null) {
              json.nextCursor = $root.google.protobuf.StringValue.toJSON(obj.nextCursor, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.reactions.Users();

          if (json.total != null) {
            result.total = json.total;
          } else {
            result.total = 0;
          }
          if (json.userIds != null) {
            result.userIds = json.userIds.map(e => {
              return e;
            });
          } else {
            result.userIds = [];
          }
          if (json.nextCursor != null) {
            result.nextCursor = $root.google.protobuf.StringValue.fromJSON(json.nextCursor, helper);
          } else {
            delete result.nextCursor;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.total != null) {
              grpc.total = obj.total;
            }
            if (obj.userIds != null) {
              grpc.userIds = obj.userIds.map(e => {
                return e;
              });
            }
            if (obj.nextCursor != null) {
              grpc.nextCursor = $root.google.protobuf.StringValue.toGRPC(obj.nextCursor, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.reactions.Users();

            if (grpc.total != null) {
              result.total = grpc.total;
            } else {
              result.total = 0;
            }
            if (grpc.userIds != null) {
              result.userIds = grpc.userIds.map(e => {
                return e;
              });
            } else {
              result.userIds = [];
            }
            if (grpc.nextCursor != null) {
              result.nextCursor = $root.google.protobuf.StringValue.fromGRPC(grpc.nextCursor, helper);
            } else {
              delete result.nextCursor;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'total': {
                'type': 'int32',
                'id': 1
              },
              'userIds': {
                'rule': 'repeated',
                'type': 'string',
                'id': 2
              },
              'nextCursor': {
                'type': $root.google.protobuf.StringValue,
                'id': 4
              }
            }
          };
        }
      }

      Object.defineProperty(Users.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.reactions.Users');
        },
        enumerable: false,
        configurable: false
      });
      return Users;
    }());
    reactions.UsersReactions = (function() {

      class UsersReactions {

        constructor(props) {
          this.total = props && props.total;
          this.userReactions = props && props.userReactions;
          this.nextCursor = props && props.nextCursor;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.total != null) {
              if (!Number.isInteger(msg.total)) {
                errors.field('total').error('integer expected');
              }
            }
            if (msg.userReactions != null) {
              const fieldErrors = errors.field('userReactions');

              if (!Array.isArray(msg.userReactions)) {
                fieldErrors.error('array expected');
              } else {
                msg.userReactions.forEach((value, index) => {
                  $root.wix.reactions.UserReaction.verify(value, helper, fieldErrors.index(index));
                });
              }
            }
            if (msg.nextCursor != null) {
              $root.google.protobuf.StringValue.verify(msg.nextCursor, helper, errors.field('nextCursor'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.total != null) {
              json.total = obj.total;
            }
            if (obj.userReactions != null) {
              json.userReactions = obj.userReactions.map(e => {
                return $root.wix.reactions.UserReaction.toJSON(e, helper);
              });
            }
            if (obj.nextCursor != null) {
              json.nextCursor = $root.google.protobuf.StringValue.toJSON(obj.nextCursor, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.reactions.UsersReactions();

          if (json.total != null) {
            result.total = json.total;
          } else {
            result.total = 0;
          }
          if (json.userReactions != null) {
            result.userReactions = json.userReactions.map(e => {
              return $root.wix.reactions.UserReaction.fromJSON(e, helper);
            });
          } else {
            result.userReactions = [];
          }
          if (json.nextCursor != null) {
            result.nextCursor = $root.google.protobuf.StringValue.fromJSON(json.nextCursor, helper);
          } else {
            delete result.nextCursor;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.total != null) {
              grpc.total = obj.total;
            }
            if (obj.userReactions != null) {
              grpc.userReactions = obj.userReactions.map(e => {
                return $root.wix.reactions.UserReaction.toGRPC(e, helper);
              });
            }
            if (obj.nextCursor != null) {
              grpc.nextCursor = $root.google.protobuf.StringValue.toGRPC(obj.nextCursor, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.reactions.UsersReactions();

            if (grpc.total != null) {
              result.total = grpc.total;
            } else {
              result.total = 0;
            }
            if (grpc.userReactions != null) {
              result.userReactions = grpc.userReactions.map(e => {
                return $root.wix.reactions.UserReaction.fromGRPC(e, helper);
              });
            } else {
              result.userReactions = [];
            }
            if (grpc.nextCursor != null) {
              result.nextCursor = $root.google.protobuf.StringValue.fromGRPC(grpc.nextCursor, helper);
            } else {
              delete result.nextCursor;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'total': {
                'type': 'int32',
                'id': 1
              },
              'userReactions': {
                'rule': 'repeated',
                'type': $root.wix.reactions.UserReaction,
                'id': 3
              },
              'nextCursor': {
                'type': $root.google.protobuf.StringValue,
                'id': 4
              }
            }
          };
        }
      }

      Object.defineProperty(UsersReactions.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.reactions.UsersReactions');
        },
        enumerable: false,
        configurable: false
      });
      return UsersReactions;
    }());
    reactions.UserReactions = (function() {

      class UserReactions {

        constructor(props) {
          this.reactions = props && props.reactions;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.reactions != null) {
              const fieldErrors = errors.field('reactions');

              if (!Array.isArray(msg.reactions)) {
                fieldErrors.error('array expected');
              } else {
                msg.reactions.forEach((value, index) => {
                  $root.wix.reactions.Reaction.verify(value, helper, fieldErrors.index(index));
                });
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.reactions != null) {
              json.reactions = obj.reactions.map(e => {
                return $root.wix.reactions.Reaction.toJSON(e, helper);
              });
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.reactions.UserReactions();

          if (json.reactions != null) {
            result.reactions = json.reactions.map(e => {
              return $root.wix.reactions.Reaction.fromJSON(e, helper);
            });
          } else {
            result.reactions = [];
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.reactions != null) {
              grpc.reactions = obj.reactions.map(e => {
                return $root.wix.reactions.Reaction.toGRPC(e, helper);
              });
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.reactions.UserReactions();

            if (grpc.reactions != null) {
              result.reactions = grpc.reactions.map(e => {
                return $root.wix.reactions.Reaction.fromGRPC(e, helper);
              });
            } else {
              result.reactions = [];
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'reactions': {
                'rule': 'repeated',
                'type': $root.wix.reactions.Reaction,
                'id': 1
              }
            }
          };
        }
      }

      Object.defineProperty(UserReactions.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.reactions.UserReactions');
        },
        enumerable: false,
        configurable: false
      });
      return UserReactions;
    }());
    reactions.UserReaction = (function() {

      class UserReaction {

        constructor(props) {
          this.reaction = props && props.reaction;
          this.userId = props && props.userId;
          this.reactionTime = props && props.reactionTime;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.reaction != null) {
              $root.wix.reactions.Reaction.verify(msg.reaction, helper, errors.field('reaction'));
            }
            if (msg.userId != null) {
              if (typeof msg.userId !== 'string') {
                errors.field('userId').error('string expected');
              }
            }
            if (msg.reactionTime != null) {
              $root.google.protobuf.Timestamp.verify(msg.reactionTime, helper, errors.field('reactionTime'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.reaction != null) {
              json.reaction = $root.wix.reactions.Reaction.toJSON(obj.reaction, helper);
            }
            if (obj.userId != null) {
              json.userId = obj.userId;
            }
            if (obj.reactionTime != null) {
              json.reactionTime = $root.google.protobuf.Timestamp.toJSON(obj.reactionTime, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.reactions.UserReaction();

          if (json.reaction != null) {
            result.reaction = $root.wix.reactions.Reaction.fromJSON(json.reaction, helper);
          } else {
            delete result.reaction;
          }
          if (json.userId != null) {
            result.userId = json.userId;
          } else {
            result.userId = '';
          }
          if (json.reactionTime != null) {
            result.reactionTime = $root.google.protobuf.Timestamp.fromJSON(json.reactionTime, helper);
          } else {
            delete result.reactionTime;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.reaction != null) {
              grpc.reaction = $root.wix.reactions.Reaction.toGRPC(obj.reaction, helper);
            }
            if (obj.userId != null) {
              grpc.userId = obj.userId;
            }
            if (obj.reactionTime != null) {
              grpc.reactionTime = $root.google.protobuf.Timestamp.toGRPC(obj.reactionTime, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.reactions.UserReaction();

            if (grpc.reaction != null) {
              result.reaction = $root.wix.reactions.Reaction.fromGRPC(grpc.reaction, helper);
            } else {
              delete result.reaction;
            }
            if (grpc.userId != null) {
              result.userId = grpc.userId;
            } else {
              result.userId = '';
            }
            if (grpc.reactionTime != null) {
              result.reactionTime = $root.google.protobuf.Timestamp.fromGRPC(grpc.reactionTime, helper);
            } else {
              delete result.reactionTime;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'reaction': {
                'type': $root.wix.reactions.Reaction,
                'id': 1
              },
              'userId': {
                'type': 'string',
                'id': 2,
                'options': {
                  '(wix.api.format)': 'GUID'
                }
              },
              'reactionTime': {
                'type': $root.google.protobuf.Timestamp,
                'id': 3
              }
            }
          };
        }
      }

      Object.defineProperty(UserReaction.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.reactions.UserReaction');
        },
        enumerable: false,
        configurable: false
      });
      return UserReaction;
    }());
    reactions.ReactionsSummary = (function() {

      class ReactionsSummary {

        constructor(props) {
          this.latestReactions = props && props.latestReactions;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.latestReactions != null) {
              const fieldErrors = errors.field('latestReactions');

              if (!Array.isArray(msg.latestReactions)) {
                fieldErrors.error('array expected');
              } else {
                msg.latestReactions.forEach((value, index) => {
                  $root.wix.reactions.ReactionSummary.verify(value, helper, fieldErrors.index(index));
                });
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.latestReactions != null) {
              json.latestReactions = obj.latestReactions.map(e => {
                return $root.wix.reactions.ReactionSummary.toJSON(e, helper);
              });
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.reactions.ReactionsSummary();

          if (json.latestReactions != null) {
            result.latestReactions = json.latestReactions.map(e => {
              return $root.wix.reactions.ReactionSummary.fromJSON(e, helper);
            });
          } else {
            result.latestReactions = [];
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.latestReactions != null) {
              grpc.latestReactions = obj.latestReactions.map(e => {
                return $root.wix.reactions.ReactionSummary.toGRPC(e, helper);
              });
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.reactions.ReactionsSummary();

            if (grpc.latestReactions != null) {
              result.latestReactions = grpc.latestReactions.map(e => {
                return $root.wix.reactions.ReactionSummary.fromGRPC(e, helper);
              });
            } else {
              result.latestReactions = [];
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'latestReactions': {
                'rule': 'repeated',
                'type': $root.wix.reactions.ReactionSummary,
                'id': 1
              }
            }
          };
        }
      }

      Object.defineProperty(ReactionsSummary.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.reactions.ReactionsSummary');
        },
        enumerable: false,
        configurable: false
      });
      return ReactionsSummary;
    }());
    reactions.ReactionSummary = (function() {

      class ReactionSummary {

        constructor(props) {
          this.reaction = props && props.reaction;
          this.usersReacted = props && props.usersReacted;
          this.reactionTime = props && props.reactionTime;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.reaction != null) {
              $root.wix.reactions.Reaction.verify(msg.reaction, helper, errors.field('reaction'));
            }
            if (msg.usersReacted != null) {
              $root.wix.reactions.Users.verify(msg.usersReacted, helper, errors.field('usersReacted'));
            }
            if (msg.reactionTime != null) {
              $root.google.protobuf.Timestamp.verify(msg.reactionTime, helper, errors.field('reactionTime'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.reaction != null) {
              json.reaction = $root.wix.reactions.Reaction.toJSON(obj.reaction, helper);
            }
            if (obj.usersReacted != null) {
              json.usersReacted = $root.wix.reactions.Users.toJSON(obj.usersReacted, helper);
            }
            if (obj.reactionTime != null) {
              json.reactionTime = $root.google.protobuf.Timestamp.toJSON(obj.reactionTime, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.reactions.ReactionSummary();

          if (json.reaction != null) {
            result.reaction = $root.wix.reactions.Reaction.fromJSON(json.reaction, helper);
          } else {
            delete result.reaction;
          }
          if (json.usersReacted != null) {
            result.usersReacted = $root.wix.reactions.Users.fromJSON(json.usersReacted, helper);
          } else {
            delete result.usersReacted;
          }
          if (json.reactionTime != null) {
            result.reactionTime = $root.google.protobuf.Timestamp.fromJSON(json.reactionTime, helper);
          } else {
            delete result.reactionTime;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.reaction != null) {
              grpc.reaction = $root.wix.reactions.Reaction.toGRPC(obj.reaction, helper);
            }
            if (obj.usersReacted != null) {
              grpc.usersReacted = $root.wix.reactions.Users.toGRPC(obj.usersReacted, helper);
            }
            if (obj.reactionTime != null) {
              grpc.reactionTime = $root.google.protobuf.Timestamp.toGRPC(obj.reactionTime, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.reactions.ReactionSummary();

            if (grpc.reaction != null) {
              result.reaction = $root.wix.reactions.Reaction.fromGRPC(grpc.reaction, helper);
            } else {
              delete result.reaction;
            }
            if (grpc.usersReacted != null) {
              result.usersReacted = $root.wix.reactions.Users.fromGRPC(grpc.usersReacted, helper);
            } else {
              delete result.usersReacted;
            }
            if (grpc.reactionTime != null) {
              result.reactionTime = $root.google.protobuf.Timestamp.fromGRPC(grpc.reactionTime, helper);
            } else {
              delete result.reactionTime;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'reaction': {
                'type': $root.wix.reactions.Reaction,
                'id': 1
              },
              'usersReacted': {
                'type': $root.wix.reactions.Users,
                'id': 2
              },
              'reactionTime': {
                'type': $root.google.protobuf.Timestamp,
                'id': 3
              }
            }
          };
        }
      }

      Object.defineProperty(ReactionSummary.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.reactions.ReactionSummary');
        },
        enumerable: false,
        configurable: false
      });
      return ReactionSummary;
    }());
    reactions.Reaction = (function() {

      class Reaction {

        constructor(props) {
          this.reactionCode = props && props.reactionCode;
          this.reactionParams = props && props.reactionParams;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.reactionCode != null) {
              if (typeof msg.reactionCode !== 'string') {
                errors.field('reactionCode').error('string expected');
              }
            }
            if (msg.reactionParams != null) {
              const fieldErrors = errors.field('reactionParams');

              if (msg.reactionParams != null && (!(typeof msg.reactionParams === 'object') || Array.isArray(msg.reactionParams))) {
                fieldErrors.error('object expected');
              } else {
                for (let key in msg.reactionParams) {
                  const keyErrors = fieldErrors.index(key);
                  if (typeof msg.reactionParams[key] !== 'string') {
                    keyErrors.field('value').error('string expected');
                  }
                }
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.reactionCode != null) {
              json.reactionCode = obj.reactionCode;
            }
            if (obj.reactionParams != null) {
              json.reactionParams = Object.entries(obj.reactionParams).reduce((acc, [k, v]) => {
                acc[k] = v;
                return acc;
              }, {});
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.reactions.Reaction();

          if (json.reactionCode != null) {
            result.reactionCode = json.reactionCode;
          } else {
            result.reactionCode = '';
          }
          if (json.reactionParams != null) {
            result.reactionParams = Object.entries(json.reactionParams).reduce((acc, [k, v]) => {
              acc[k] = v;
              return acc;
            }, {});
          } else {
            delete result.reactionParams;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.reactionCode != null) {
              grpc.reactionCode = obj.reactionCode;
            }
            if (obj.reactionParams != null) {
              grpc.reactionParams = Object.entries(obj.reactionParams).reduce((acc, [k, v]) => {
                acc[k] = v;
                return acc;
              }, {});
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.reactions.Reaction();

            if (grpc.reactionCode != null) {
              result.reactionCode = grpc.reactionCode;
            } else {
              result.reactionCode = '';
            }
            if (grpc.reactionParams != null) {
              result.reactionParams = Object.entries(grpc.reactionParams).reduce((acc, [k, v]) => {
                acc[k] = v;
                return acc;
              }, {});
            } else {
              delete result.reactionParams;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'reactionCode': {
                'type': 'string',
                'id': 1
              },
              'reactionParams': {
                'keyType': 'string',
                'type': 'string',
                'id': 2
              }
            }
          };
        }
      }

      Object.defineProperty(Reaction.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.reactions.Reaction');
        },
        enumerable: false,
        configurable: false
      });
      return Reaction;
    }());
    reactions.ItemsReacted = (function() {

      class ItemsReacted {

        constructor(props) {
          this.total = props && props.total;
          this.itemReactions = props && props.itemReactions;
          this.nextCursor = props && props.nextCursor;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.total != null) {
              if (!Number.isInteger(msg.total)) {
                errors.field('total').error('integer expected');
              }
            }
            if (msg.itemReactions != null) {
              const fieldErrors = errors.field('itemReactions');

              if (!Array.isArray(msg.itemReactions)) {
                fieldErrors.error('array expected');
              } else {
                msg.itemReactions.forEach((value, index) => {
                  $root.wix.reactions.ItemReactions.verify(value, helper, fieldErrors.index(index));
                });
              }
            }
            if (msg.nextCursor != null) {
              $root.google.protobuf.StringValue.verify(msg.nextCursor, helper, errors.field('nextCursor'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.total != null) {
              json.total = obj.total;
            }
            if (obj.itemReactions != null) {
              json.itemReactions = obj.itemReactions.map(e => {
                return $root.wix.reactions.ItemReactions.toJSON(e, helper);
              });
            }
            if (obj.nextCursor != null) {
              json.nextCursor = $root.google.protobuf.StringValue.toJSON(obj.nextCursor, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.reactions.ItemsReacted();

          if (json.total != null) {
            result.total = json.total;
          } else {
            result.total = 0;
          }
          if (json.itemReactions != null) {
            result.itemReactions = json.itemReactions.map(e => {
              return $root.wix.reactions.ItemReactions.fromJSON(e, helper);
            });
          } else {
            result.itemReactions = [];
          }
          if (json.nextCursor != null) {
            result.nextCursor = $root.google.protobuf.StringValue.fromJSON(json.nextCursor, helper);
          } else {
            delete result.nextCursor;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.total != null) {
              grpc.total = obj.total;
            }
            if (obj.itemReactions != null) {
              grpc.itemReactions = obj.itemReactions.map(e => {
                return $root.wix.reactions.ItemReactions.toGRPC(e, helper);
              });
            }
            if (obj.nextCursor != null) {
              grpc.nextCursor = $root.google.protobuf.StringValue.toGRPC(obj.nextCursor, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.reactions.ItemsReacted();

            if (grpc.total != null) {
              result.total = grpc.total;
            } else {
              result.total = 0;
            }
            if (grpc.itemReactions != null) {
              result.itemReactions = grpc.itemReactions.map(e => {
                return $root.wix.reactions.ItemReactions.fromGRPC(e, helper);
              });
            } else {
              result.itemReactions = [];
            }
            if (grpc.nextCursor != null) {
              result.nextCursor = $root.google.protobuf.StringValue.fromGRPC(grpc.nextCursor, helper);
            } else {
              delete result.nextCursor;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'total': {
                'type': 'int32',
                'id': 1
              },
              'itemReactions': {
                'rule': 'repeated',
                'type': $root.wix.reactions.ItemReactions,
                'id': 2
              },
              'nextCursor': {
                'type': $root.google.protobuf.StringValue,
                'id': 3
              }
            }
          };
        }
      }

      Object.defineProperty(ItemsReacted.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.reactions.ItemsReacted');
        },
        enumerable: false,
        configurable: false
      });
      return ItemsReacted;
    }());
    reactions.ItemReactions = (function() {

      class ItemReactions {

        constructor(props) {
          this.itemId = props && props.itemId;
          this.reactionsCount = props && props.reactionsCount;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.itemId != null) {
              if (typeof msg.itemId !== 'string') {
                errors.field('itemId').error('string expected');
              }
            }
            if (msg.reactionsCount != null) {
              if (!Number.isInteger(msg.reactionsCount)) {
                errors.field('reactionsCount').error('integer expected');
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.itemId != null) {
              json.itemId = obj.itemId;
            }
            if (obj.reactionsCount != null) {
              json.reactionsCount = obj.reactionsCount;
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.reactions.ItemReactions();

          if (json.itemId != null) {
            result.itemId = json.itemId;
          } else {
            result.itemId = '';
          }
          if (json.reactionsCount != null) {
            result.reactionsCount = json.reactionsCount;
          } else {
            result.reactionsCount = 0;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.itemId != null) {
              grpc.itemId = obj.itemId;
            }
            if (obj.reactionsCount != null) {
              grpc.reactionsCount = obj.reactionsCount;
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.reactions.ItemReactions();

            if (grpc.itemId != null) {
              result.itemId = grpc.itemId;
            } else {
              result.itemId = '';
            }
            if (grpc.reactionsCount != null) {
              result.reactionsCount = grpc.reactionsCount;
            } else {
              result.reactionsCount = 0;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'itemId': {
                'type': 'string',
                'id': 1,
                'options': {
                  '(wix.api.format)': 'GUID'
                }
              },
              'reactionsCount': {
                'type': 'int32',
                'id': 2
              }
            }
          };
        }
      }

      Object.defineProperty(ItemReactions.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.reactions.ItemReactions');
        },
        enumerable: false,
        configurable: false
      });
      return ItemReactions;
    }());
    reactions.UsersReacted = (function() {

      class UsersReacted {

        constructor(props) {
          this.total = props && props.total;
          this.userReactions = props && props.userReactions;
          this.nextCursor = props && props.nextCursor;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.total != null) {
              if (!Number.isInteger(msg.total)) {
                errors.field('total').error('integer expected');
              }
            }
            if (msg.userReactions != null) {
              const fieldErrors = errors.field('userReactions');

              if (!Array.isArray(msg.userReactions)) {
                fieldErrors.error('array expected');
              } else {
                msg.userReactions.forEach((value, index) => {
                  $root.wix.reactions.UserReactionsCount.verify(value, helper, fieldErrors.index(index));
                });
              }
            }
            if (msg.nextCursor != null) {
              $root.google.protobuf.StringValue.verify(msg.nextCursor, helper, errors.field('nextCursor'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.total != null) {
              json.total = obj.total;
            }
            if (obj.userReactions != null) {
              json.userReactions = obj.userReactions.map(e => {
                return $root.wix.reactions.UserReactionsCount.toJSON(e, helper);
              });
            }
            if (obj.nextCursor != null) {
              json.nextCursor = $root.google.protobuf.StringValue.toJSON(obj.nextCursor, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.reactions.UsersReacted();

          if (json.total != null) {
            result.total = json.total;
          } else {
            result.total = 0;
          }
          if (json.userReactions != null) {
            result.userReactions = json.userReactions.map(e => {
              return $root.wix.reactions.UserReactionsCount.fromJSON(e, helper);
            });
          } else {
            result.userReactions = [];
          }
          if (json.nextCursor != null) {
            result.nextCursor = $root.google.protobuf.StringValue.fromJSON(json.nextCursor, helper);
          } else {
            delete result.nextCursor;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.total != null) {
              grpc.total = obj.total;
            }
            if (obj.userReactions != null) {
              grpc.userReactions = obj.userReactions.map(e => {
                return $root.wix.reactions.UserReactionsCount.toGRPC(e, helper);
              });
            }
            if (obj.nextCursor != null) {
              grpc.nextCursor = $root.google.protobuf.StringValue.toGRPC(obj.nextCursor, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.reactions.UsersReacted();

            if (grpc.total != null) {
              result.total = grpc.total;
            } else {
              result.total = 0;
            }
            if (grpc.userReactions != null) {
              result.userReactions = grpc.userReactions.map(e => {
                return $root.wix.reactions.UserReactionsCount.fromGRPC(e, helper);
              });
            } else {
              result.userReactions = [];
            }
            if (grpc.nextCursor != null) {
              result.nextCursor = $root.google.protobuf.StringValue.fromGRPC(grpc.nextCursor, helper);
            } else {
              delete result.nextCursor;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'total': {
                'type': 'int32',
                'id': 1
              },
              'userReactions': {
                'rule': 'repeated',
                'type': $root.wix.reactions.UserReactionsCount,
                'id': 2
              },
              'nextCursor': {
                'type': $root.google.protobuf.StringValue,
                'id': 3
              }
            }
          };
        }
      }

      Object.defineProperty(UsersReacted.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.reactions.UsersReacted');
        },
        enumerable: false,
        configurable: false
      });
      return UsersReacted;
    }());
    reactions.UserReactionsCount = (function() {

      class UserReactionsCount {

        constructor(props) {
          this.userId = props && props.userId;
          this.count = props && props.count;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.userId != null) {
              if (typeof msg.userId !== 'string') {
                errors.field('userId').error('string expected');
              }
            }
            if (msg.count != null) {
              if (!Number.isInteger(msg.count)) {
                errors.field('count').error('integer expected');
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.userId != null) {
              json.userId = obj.userId;
            }
            if (obj.count != null) {
              json.count = obj.count;
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.reactions.UserReactionsCount();

          if (json.userId != null) {
            result.userId = json.userId;
          } else {
            result.userId = '';
          }
          if (json.count != null) {
            result.count = json.count;
          } else {
            result.count = 0;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.userId != null) {
              grpc.userId = obj.userId;
            }
            if (obj.count != null) {
              grpc.count = obj.count;
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.reactions.UserReactionsCount();

            if (grpc.userId != null) {
              result.userId = grpc.userId;
            } else {
              result.userId = '';
            }
            if (grpc.count != null) {
              result.count = grpc.count;
            } else {
              result.count = 0;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'userId': {
                'type': 'string',
                'id': 1,
                'options': {
                  '(wix.api.format)': 'GUID'
                }
              },
              'count': {
                'type': 'int32',
                'id': 2
              }
            }
          };
        }
      }

      Object.defineProperty(UserReactionsCount.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.reactions.UserReactionsCount');
        },
        enumerable: false,
        configurable: false
      });
      return UserReactionsCount;
    }());
    reactions.UserReacted = (function() {

      class UserReacted {

        constructor(props) {
          this.reaction = props && props.reaction;
          this.args = props && props.args;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.reaction != null) {
              $root.google.protobuf.StringValue.verify(msg.reaction, helper, errors.field('reaction'));
            }
            if (msg.args != null) {
              const fieldErrors = errors.field('args');

              if (msg.args != null && (!(typeof msg.args === 'object') || Array.isArray(msg.args))) {
                fieldErrors.error('object expected');
              } else {
                for (let key in msg.args) {
                  const keyErrors = fieldErrors.index(key);
                  if (typeof msg.args[key] !== 'string') {
                    keyErrors.field('value').error('string expected');
                  }
                }
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.reaction != null) {
              json.reaction = $root.google.protobuf.StringValue.toJSON(obj.reaction, helper);
            }
            if (obj.args != null) {
              json.args = Object.entries(obj.args).reduce((acc, [k, v]) => {
                acc[k] = v;
                return acc;
              }, {});
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.reactions.UserReacted();

          if (json.reaction != null) {
            result.reaction = $root.google.protobuf.StringValue.fromJSON(json.reaction, helper);
          } else {
            delete result.reaction;
          }
          if (json.args != null) {
            result.args = Object.entries(json.args).reduce((acc, [k, v]) => {
              acc[k] = v;
              return acc;
            }, {});
          } else {
            delete result.args;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.reaction != null) {
              grpc.reaction = $root.google.protobuf.StringValue.toGRPC(obj.reaction, helper);
            }
            if (obj.args != null) {
              grpc.args = Object.entries(obj.args).reduce((acc, [k, v]) => {
                acc[k] = v;
                return acc;
              }, {});
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.reactions.UserReacted();

            if (grpc.reaction != null) {
              result.reaction = $root.google.protobuf.StringValue.fromGRPC(grpc.reaction, helper);
            } else {
              delete result.reaction;
            }
            if (grpc.args != null) {
              result.args = Object.entries(grpc.args).reduce((acc, [k, v]) => {
                acc[k] = v;
                return acc;
              }, {});
            } else {
              delete result.args;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'reaction': {
                'type': $root.google.protobuf.StringValue,
                'id': 1
              },
              'args': {
                'keyType': 'string',
                'type': 'string',
                'id': 2
              }
            }
          };
        }
      }

      Object.defineProperty(UserReacted.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.reactions.UserReacted');
        },
        enumerable: false,
        configurable: false
      });
      return UserReacted;
    }());
    reactions.UserUnreacted = (function() {

      class UserUnreacted {

        constructor(props) {
          this.reaction = props && props.reaction;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.reaction != null) {
              $root.google.protobuf.StringValue.verify(msg.reaction, helper, errors.field('reaction'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.reaction != null) {
              json.reaction = $root.google.protobuf.StringValue.toJSON(obj.reaction, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.reactions.UserUnreacted();

          if (json.reaction != null) {
            result.reaction = $root.google.protobuf.StringValue.fromJSON(json.reaction, helper);
          } else {
            delete result.reaction;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.reaction != null) {
              grpc.reaction = $root.google.protobuf.StringValue.toGRPC(obj.reaction, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.reactions.UserUnreacted();

            if (grpc.reaction != null) {
              result.reaction = $root.google.protobuf.StringValue.fromGRPC(grpc.reaction, helper);
            } else {
              delete result.reaction;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'reaction': {
                'type': $root.google.protobuf.StringValue,
                'id': 1
              }
            }
          };
        }
      }

      Object.defineProperty(UserUnreacted.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.reactions.UserUnreacted');
        },
        enumerable: false,
        configurable: false
      });
      return UserUnreacted;
    }());
    reactions.ReactionsService = (function() {

      class ReactionsService {

        constructor() {
          if (this.constructor.name === ReactionsService.name) {
            throw new TypeError('class ReactionsService is abstract');
          }
        }

        react(aspects, msg) {
          throw new TypeError('method react is abstract');
        }

        unreact(aspects, msg) {
          throw new TypeError('method unreact is abstract');
        }

        get(aspects, msg) {
          throw new TypeError('method get is abstract');
        }

        removeAll(aspects, msg) {
          throw new TypeError('method removeAll is abstract');
        }

        getReactions(aspects, msg) {
          throw new TypeError('method getReactions is abstract');
        }

        getReactionsSummary(aspects, msg) {
          throw new TypeError('method getReactionsSummary is abstract');
        }
      }

      ReactionsService.prototype.react._messageTypes = function() {
        return [
          $root.wix.reactions.ReactRequest,
          $root.wix.reactions.ItemReactionsSummary
        ];
      };
      ReactionsService.prototype.unreact._messageTypes = function() {
        return [
          $root.wix.reactions.UnreactRequest,
          $root.wix.reactions.ItemReactionsSummary
        ];
      };
      ReactionsService.prototype.get._messageTypes = function() {
        return [
          $root.wix.reactions.GetRequest,
          $root.wix.reactions.ItemReactionsSummary
        ];
      };
      ReactionsService.prototype.removeAll._messageTypes = function() {
        return [
          $root.wix.reactions.RemoveAllRequest,
          $root.google.protobuf.Empty
        ];
      };
      ReactionsService.prototype.getReactions._messageTypes = function() {
        return [
          $root.wix.reactions.GetReactionsRequest,
          $root.wix.reactions.GetReactionsResponse
        ];
      };
      ReactionsService.prototype.getReactionsSummary._messageTypes = function() {
        return [
          $root.wix.reactions.GetReactionsSummaryRequest,
          $root.wix.reactions.GetReactionsSummaryResponse
        ];
      };
      ReactionsService.prototype.react.__proto = pbjs => {
        return $root.__lookup(pbjs)('wix.reactions.ReactionsService.React');
      };
      ReactionsService.prototype.unreact.__proto = pbjs => {
        return $root.__lookup(pbjs)('wix.reactions.ReactionsService.Unreact');
      };
      ReactionsService.prototype.get.__proto = pbjs => {
        return $root.__lookup(pbjs)('wix.reactions.ReactionsService.Get');
      };
      ReactionsService.prototype.removeAll.__proto = pbjs => {
        return $root.__lookup(pbjs)('wix.reactions.ReactionsService.RemoveAll');
      };
      ReactionsService.prototype.getReactions.__proto = pbjs => {
        return $root.__lookup(pbjs)('wix.reactions.ReactionsService.GetReactions');
      };
      ReactionsService.prototype.getReactionsSummary.__proto = pbjs => {
        return $root.__lookup(pbjs)('wix.reactions.ReactionsService.GetReactionsSummary');
      };
      Object.defineProperty(ReactionsService.prototype, '__isRpcService__', {
        value: true,
        enumerable: false,
        configurable: false
      });
      Object.defineProperty(ReactionsService.prototype, '__fqn__', {
        value: 'wix.reactions.ReactionsService',
        enumerable: false,
        configurable: false
      });
      Object.defineProperty(ReactionsService.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.reactions.ReactionsService');
        },
        enumerable: false,
        configurable: false
      });
      Object.defineProperty(ReactionsService.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      return ReactionsService;
    }());
    reactions.ReactRequest = (function() {

      class ReactRequest {

        constructor(props) {
          this.itemId = props && props.itemId;
          this.reaction = props && props.reaction;
          this.scopeId = props && props.scopeId;
          this.contextToken = props && props.contextToken;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.itemId != null) {
              if (typeof msg.itemId !== 'string') {
                errors.field('itemId').error('string expected');
              }
            }
            if (msg.reaction != null) {
              $root.wix.reactions.Reaction.verify(msg.reaction, helper, errors.field('reaction'));
            }
            if (msg.scopeId != null) {
              $root.google.protobuf.StringValue.verify(msg.scopeId, helper, errors.field('scopeId'));
            }
            if (msg.contextToken != null) {
              $root.google.protobuf.StringValue.verify(msg.contextToken, helper, errors.field('contextToken'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.itemId != null) {
              json.itemId = obj.itemId;
            }
            if (obj.reaction != null) {
              json.reaction = $root.wix.reactions.Reaction.toJSON(obj.reaction, helper);
            }
            if (obj.scopeId != null) {
              json.scopeId = $root.google.protobuf.StringValue.toJSON(obj.scopeId, helper);
            }
            if (obj.contextToken != null) {
              json.contextToken = $root.google.protobuf.StringValue.toJSON(obj.contextToken, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.reactions.ReactRequest();

          if (json.itemId != null) {
            result.itemId = json.itemId;
          } else {
            result.itemId = '';
          }
          if (json.reaction != null) {
            result.reaction = $root.wix.reactions.Reaction.fromJSON(json.reaction, helper);
          } else {
            delete result.reaction;
          }
          if (json.scopeId != null) {
            result.scopeId = $root.google.protobuf.StringValue.fromJSON(json.scopeId, helper);
          } else {
            delete result.scopeId;
          }
          if (json.contextToken != null) {
            result.contextToken = $root.google.protobuf.StringValue.fromJSON(json.contextToken, helper);
          } else {
            delete result.contextToken;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.itemId != null) {
              grpc.itemId = obj.itemId;
            }
            if (obj.reaction != null) {
              grpc.reaction = $root.wix.reactions.Reaction.toGRPC(obj.reaction, helper);
            }
            if (obj.scopeId != null) {
              grpc.scopeId = $root.google.protobuf.StringValue.toGRPC(obj.scopeId, helper);
            }
            if (obj.contextToken != null) {
              grpc.contextToken = $root.google.protobuf.StringValue.toGRPC(obj.contextToken, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.reactions.ReactRequest();

            if (grpc.itemId != null) {
              result.itemId = grpc.itemId;
            } else {
              result.itemId = '';
            }
            if (grpc.reaction != null) {
              result.reaction = $root.wix.reactions.Reaction.fromGRPC(grpc.reaction, helper);
            } else {
              delete result.reaction;
            }
            if (grpc.scopeId != null) {
              result.scopeId = $root.google.protobuf.StringValue.fromGRPC(grpc.scopeId, helper);
            } else {
              delete result.scopeId;
            }
            if (grpc.contextToken != null) {
              result.contextToken = $root.google.protobuf.StringValue.fromGRPC(grpc.contextToken, helper);
            } else {
              delete result.contextToken;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'itemId': {
                'type': 'string',
                'id': 1,
                'options': {
                  '(wix.api.format)': 'GUID'
                }
              },
              'reaction': {
                'type': $root.wix.reactions.Reaction,
                'id': 2
              },
              'scopeId': {
                'type': $root.google.protobuf.StringValue,
                'id': 3
              },
              'contextToken': {
                'type': $root.google.protobuf.StringValue,
                'id': 4
              }
            }
          };
        }
      }

      Object.defineProperty(ReactRequest.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.reactions.ReactRequest');
        },
        enumerable: false,
        configurable: false
      });
      return ReactRequest;
    }());
    reactions.UnreactRequest = (function() {

      class UnreactRequest {

        constructor(props) {
          this.itemId = props && props.itemId;
          this.reactionCode = props && props.reactionCode;
          this.contextToken = props && props.contextToken;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.itemId != null) {
              if (typeof msg.itemId !== 'string') {
                errors.field('itemId').error('string expected');
              }
            }
            if (msg.reactionCode != null) {
              if (typeof msg.reactionCode !== 'string') {
                errors.field('reactionCode').error('string expected');
              }
            }
            if (msg.contextToken != null) {
              $root.google.protobuf.StringValue.verify(msg.contextToken, helper, errors.field('contextToken'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.itemId != null) {
              json.itemId = obj.itemId;
            }
            if (obj.reactionCode != null) {
              json.reactionCode = obj.reactionCode;
            }
            if (obj.contextToken != null) {
              json.contextToken = $root.google.protobuf.StringValue.toJSON(obj.contextToken, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.reactions.UnreactRequest();

          if (json.itemId != null) {
            result.itemId = json.itemId;
          } else {
            result.itemId = '';
          }
          if (json.reactionCode != null) {
            result.reactionCode = json.reactionCode;
          } else {
            result.reactionCode = '';
          }
          if (json.contextToken != null) {
            result.contextToken = $root.google.protobuf.StringValue.fromJSON(json.contextToken, helper);
          } else {
            delete result.contextToken;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.itemId != null) {
              grpc.itemId = obj.itemId;
            }
            if (obj.reactionCode != null) {
              grpc.reactionCode = obj.reactionCode;
            }
            if (obj.contextToken != null) {
              grpc.contextToken = $root.google.protobuf.StringValue.toGRPC(obj.contextToken, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.reactions.UnreactRequest();

            if (grpc.itemId != null) {
              result.itemId = grpc.itemId;
            } else {
              result.itemId = '';
            }
            if (grpc.reactionCode != null) {
              result.reactionCode = grpc.reactionCode;
            } else {
              result.reactionCode = '';
            }
            if (grpc.contextToken != null) {
              result.contextToken = $root.google.protobuf.StringValue.fromGRPC(grpc.contextToken, helper);
            } else {
              delete result.contextToken;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'itemId': {
                'type': 'string',
                'id': 1,
                'options': {
                  '(wix.api.format)': 'GUID'
                }
              },
              'reactionCode': {
                'type': 'string',
                'id': 2
              },
              'contextToken': {
                'type': $root.google.protobuf.StringValue,
                'id': 4
              }
            }
          };
        }
      }

      Object.defineProperty(UnreactRequest.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.reactions.UnreactRequest');
        },
        enumerable: false,
        configurable: false
      });
      return UnreactRequest;
    }());
    reactions.GetRequest = (function() {

      class GetRequest {

        constructor(props) {
          this.itemId = props && props.itemId;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.itemId != null) {
              if (typeof msg.itemId !== 'string') {
                errors.field('itemId').error('string expected');
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.itemId != null) {
              json.itemId = obj.itemId;
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.reactions.GetRequest();

          if (json.itemId != null) {
            result.itemId = json.itemId;
          } else {
            result.itemId = '';
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.itemId != null) {
              grpc.itemId = obj.itemId;
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.reactions.GetRequest();

            if (grpc.itemId != null) {
              result.itemId = grpc.itemId;
            } else {
              result.itemId = '';
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'itemId': {
                'type': 'string',
                'id': 1,
                'options': {
                  '(wix.api.format)': 'GUID'
                }
              }
            }
          };
        }
      }

      Object.defineProperty(GetRequest.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.reactions.GetRequest');
        },
        enumerable: false,
        configurable: false
      });
      return GetRequest;
    }());
    reactions.RemoveAllRequest = (function() {

      class RemoveAllRequest {

        constructor(props) {
          this.itemId = props && props.itemId;
          this.scopeId = props && props.scopeId;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.itemId != null) {
              const fieldErrors = errors.field('itemId');

              if (!Array.isArray(msg.itemId)) {
                fieldErrors.error('array expected');
              } else {
                msg.itemId.forEach((value, index) => {
                  if (typeof value !== 'string') {
                    fieldErrors.index(index).error('string expected');
                  }
                });
              }
            }
            if (msg.scopeId != null) {
              $root.google.protobuf.StringValue.verify(msg.scopeId, helper, errors.field('scopeId'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.itemId != null) {
              json.itemId = obj.itemId.map(e => {
                return e;
              });
            }
            if (obj.scopeId != null) {
              json.scopeId = $root.google.protobuf.StringValue.toJSON(obj.scopeId, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.reactions.RemoveAllRequest();

          if (json.itemId != null) {
            result.itemId = json.itemId.map(e => {
              return e;
            });
          } else {
            result.itemId = [];
          }
          if (json.scopeId != null) {
            result.scopeId = $root.google.protobuf.StringValue.fromJSON(json.scopeId, helper);
          } else {
            delete result.scopeId;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.itemId != null) {
              grpc.itemId = obj.itemId.map(e => {
                return e;
              });
            }
            if (obj.scopeId != null) {
              grpc.scopeId = $root.google.protobuf.StringValue.toGRPC(obj.scopeId, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.reactions.RemoveAllRequest();

            if (grpc.itemId != null) {
              result.itemId = grpc.itemId.map(e => {
                return e;
              });
            } else {
              result.itemId = [];
            }
            if (grpc.scopeId != null) {
              result.scopeId = $root.google.protobuf.StringValue.fromGRPC(grpc.scopeId, helper);
            } else {
              delete result.scopeId;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'itemId': {
                'rule': 'repeated',
                'type': 'string',
                'id': 1,
                'options': {
                  '(wix.api.format)': 'GUID'
                }
              },
              'scopeId': {
                'type': $root.google.protobuf.StringValue,
                'id': 2,
                'options': {
                  '(wix.api.format)': 'GUID'
                }
              }
            }
          };
        }
      }

      Object.defineProperty(RemoveAllRequest.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.reactions.RemoveAllRequest');
        },
        enumerable: false,
        configurable: false
      });
      return RemoveAllRequest;
    }());
    reactions.GetReactionsSummaryRequest = (function() {

      class GetReactionsSummaryRequest {

        constructor(props) {
          this.itemId = props && props.itemId;
          this.scopeId = props && props.scopeId;
          this.limit = props && props.limit;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.itemId != null) {
              const fieldErrors = errors.field('itemId');

              if (!Array.isArray(msg.itemId)) {
                fieldErrors.error('array expected');
              } else {
                msg.itemId.forEach((value, index) => {
                  if (typeof value !== 'string') {
                    fieldErrors.index(index).error('string expected');
                  }
                });
              }
            }
            if (msg.scopeId != null) {
              $root.google.protobuf.StringValue.verify(msg.scopeId, helper, errors.field('scopeId'));
            }
            if (msg.limit != null) {
              $root.google.protobuf.Int32Value.verify(msg.limit, helper, errors.field('limit'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.itemId != null) {
              json.itemId = obj.itemId.map(e => {
                return e;
              });
            }
            if (obj.scopeId != null) {
              json.scopeId = $root.google.protobuf.StringValue.toJSON(obj.scopeId, helper);
            }
            if (obj.limit != null) {
              json.limit = $root.google.protobuf.Int32Value.toJSON(obj.limit, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.reactions.GetReactionsSummaryRequest();

          if (json.itemId != null) {
            result.itemId = json.itemId.map(e => {
              return e;
            });
          } else {
            result.itemId = [];
          }
          if (json.scopeId != null) {
            result.scopeId = $root.google.protobuf.StringValue.fromJSON(json.scopeId, helper);
          } else {
            delete result.scopeId;
          }
          if (json.limit != null) {
            result.limit = $root.google.protobuf.Int32Value.fromJSON(json.limit, helper);
          } else {
            delete result.limit;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.itemId != null) {
              grpc.itemId = obj.itemId.map(e => {
                return e;
              });
            }
            if (obj.scopeId != null) {
              grpc.scopeId = $root.google.protobuf.StringValue.toGRPC(obj.scopeId, helper);
            }
            if (obj.limit != null) {
              grpc.limit = $root.google.protobuf.Int32Value.toGRPC(obj.limit, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.reactions.GetReactionsSummaryRequest();

            if (grpc.itemId != null) {
              result.itemId = grpc.itemId.map(e => {
                return e;
              });
            } else {
              result.itemId = [];
            }
            if (grpc.scopeId != null) {
              result.scopeId = $root.google.protobuf.StringValue.fromGRPC(grpc.scopeId, helper);
            } else {
              delete result.scopeId;
            }
            if (grpc.limit != null) {
              result.limit = $root.google.protobuf.Int32Value.fromGRPC(grpc.limit, helper);
            } else {
              delete result.limit;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'itemId': {
                'rule': 'repeated',
                'type': 'string',
                'id': 1
              },
              'scopeId': {
                'type': $root.google.protobuf.StringValue,
                'id': 2,
                'options': {
                  '(wix.api.format)': 'GUID'
                }
              },
              'limit': {
                'type': $root.google.protobuf.Int32Value,
                'id': 3
              }
            }
          };
        }
      }

      Object.defineProperty(GetReactionsSummaryRequest.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.reactions.GetReactionsSummaryRequest');
        },
        enumerable: false,
        configurable: false
      });
      return GetReactionsSummaryRequest;
    }());
    reactions.GetReactionsRequest = (function() {

      class GetReactionsRequest {

        constructor(props) {
          this.itemId = props && props.itemId;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.itemId != null) {
              const fieldErrors = errors.field('itemId');

              if (!Array.isArray(msg.itemId)) {
                fieldErrors.error('array expected');
              } else {
                msg.itemId.forEach((value, index) => {
                  if (typeof value !== 'string') {
                    fieldErrors.index(index).error('string expected');
                  }
                });
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.itemId != null) {
              json.itemId = obj.itemId.map(e => {
                return e;
              });
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.reactions.GetReactionsRequest();

          if (json.itemId != null) {
            result.itemId = json.itemId.map(e => {
              return e;
            });
          } else {
            result.itemId = [];
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.itemId != null) {
              grpc.itemId = obj.itemId.map(e => {
                return e;
              });
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.reactions.GetReactionsRequest();

            if (grpc.itemId != null) {
              result.itemId = grpc.itemId.map(e => {
                return e;
              });
            } else {
              result.itemId = [];
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'itemId': {
                'rule': 'repeated',
                'type': 'string',
                'id': 1
              }
            }
          };
        }
      }

      Object.defineProperty(GetReactionsRequest.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.reactions.GetReactionsRequest');
        },
        enumerable: false,
        configurable: false
      });
      return GetReactionsRequest;
    }());
    reactions.GetReactionsResponse = (function() {

      class GetReactionsResponse {

        constructor(props) {
          this.total = props && props.total;
          this.itemReactions = props && props.itemReactions;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.total != null) {
              if (!Number.isInteger(msg.total)) {
                errors.field('total').error('integer expected');
              }
            }
            if (msg.itemReactions != null) {
              const fieldErrors = errors.field('itemReactions');

              if (!Array.isArray(msg.itemReactions)) {
                fieldErrors.error('array expected');
              } else {
                msg.itemReactions.forEach((value, index) => {
                  $root.wix.reactions.ItemReactionsSummary.verify(value, helper, fieldErrors.index(index));
                });
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.total != null) {
              json.total = obj.total;
            }
            if (obj.itemReactions != null) {
              json.itemReactions = obj.itemReactions.map(e => {
                return $root.wix.reactions.ItemReactionsSummary.toJSON(e, helper);
              });
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.reactions.GetReactionsResponse();

          if (json.total != null) {
            result.total = json.total;
          } else {
            result.total = 0;
          }
          if (json.itemReactions != null) {
            result.itemReactions = json.itemReactions.map(e => {
              return $root.wix.reactions.ItemReactionsSummary.fromJSON(e, helper);
            });
          } else {
            result.itemReactions = [];
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.total != null) {
              grpc.total = obj.total;
            }
            if (obj.itemReactions != null) {
              grpc.itemReactions = obj.itemReactions.map(e => {
                return $root.wix.reactions.ItemReactionsSummary.toGRPC(e, helper);
              });
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.reactions.GetReactionsResponse();

            if (grpc.total != null) {
              result.total = grpc.total;
            } else {
              result.total = 0;
            }
            if (grpc.itemReactions != null) {
              result.itemReactions = grpc.itemReactions.map(e => {
                return $root.wix.reactions.ItemReactionsSummary.fromGRPC(e, helper);
              });
            } else {
              result.itemReactions = [];
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'total': {
                'type': 'int32',
                'id': 1
              },
              'itemReactions': {
                'rule': 'repeated',
                'type': $root.wix.reactions.ItemReactionsSummary,
                'id': 2
              }
            }
          };
        }
      }

      Object.defineProperty(GetReactionsResponse.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.reactions.GetReactionsResponse');
        },
        enumerable: false,
        configurable: false
      });
      return GetReactionsResponse;
    }());
    reactions.GetReactionsSummaryResponse = (function() {

      class GetReactionsSummaryResponse {

        constructor(props) {
          this.reactionsSummary = props && props.reactionsSummary;
          this.usersReacted = props && props.usersReacted;
          this.itemsReacted = props && props.itemsReacted;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.reactionsSummary != null) {
              $root.wix.reactions.ReactionsSummary.verify(msg.reactionsSummary, helper, errors.field('reactionsSummary'));
            }
            if (msg.usersReacted != null) {
              $root.wix.reactions.UsersReacted.verify(msg.usersReacted, helper, errors.field('usersReacted'));
            }
            if (msg.itemsReacted != null) {
              $root.wix.reactions.ItemsReacted.verify(msg.itemsReacted, helper, errors.field('itemsReacted'));
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.reactionsSummary != null) {
              json.reactionsSummary = $root.wix.reactions.ReactionsSummary.toJSON(obj.reactionsSummary, helper);
            }
            if (obj.usersReacted != null) {
              json.usersReacted = $root.wix.reactions.UsersReacted.toJSON(obj.usersReacted, helper);
            }
            if (obj.itemsReacted != null) {
              json.itemsReacted = $root.wix.reactions.ItemsReacted.toJSON(obj.itemsReacted, helper);
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.wix.reactions.GetReactionsSummaryResponse();

          if (json.reactionsSummary != null) {
            result.reactionsSummary = $root.wix.reactions.ReactionsSummary.fromJSON(json.reactionsSummary, helper);
          } else {
            delete result.reactionsSummary;
          }
          if (json.usersReacted != null) {
            result.usersReacted = $root.wix.reactions.UsersReacted.fromJSON(json.usersReacted, helper);
          } else {
            delete result.usersReacted;
          }
          if (json.itemsReacted != null) {
            result.itemsReacted = $root.wix.reactions.ItemsReacted.fromJSON(json.itemsReacted, helper);
          } else {
            delete result.itemsReacted;
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.reactionsSummary != null) {
              grpc.reactionsSummary = $root.wix.reactions.ReactionsSummary.toGRPC(obj.reactionsSummary, helper);
            }
            if (obj.usersReacted != null) {
              grpc.usersReacted = $root.wix.reactions.UsersReacted.toGRPC(obj.usersReacted, helper);
            }
            if (obj.itemsReacted != null) {
              grpc.itemsReacted = $root.wix.reactions.ItemsReacted.toGRPC(obj.itemsReacted, helper);
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.reactions.GetReactionsSummaryResponse();

            if (grpc.reactionsSummary != null) {
              result.reactionsSummary = $root.wix.reactions.ReactionsSummary.fromGRPC(grpc.reactionsSummary, helper);
            } else {
              delete result.reactionsSummary;
            }
            if (grpc.usersReacted != null) {
              result.usersReacted = $root.wix.reactions.UsersReacted.fromGRPC(grpc.usersReacted, helper);
            } else {
              delete result.usersReacted;
            }
            if (grpc.itemsReacted != null) {
              result.itemsReacted = $root.wix.reactions.ItemsReacted.fromGRPC(grpc.itemsReacted, helper);
            } else {
              delete result.itemsReacted;
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'reactionsSummary': {
                'type': $root.wix.reactions.ReactionsSummary,
                'id': 1
              },
              'usersReacted': {
                'type': $root.wix.reactions.UsersReacted,
                'id': 2
              },
              'itemsReacted': {
                'type': $root.wix.reactions.ItemsReacted,
                'id': 3
              }
            }
          };
        }
      }

      Object.defineProperty(GetReactionsSummaryResponse.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.reactions.GetReactionsSummaryResponse');
        },
        enumerable: false,
        configurable: false
      });
      return GetReactionsSummaryResponse;
    }());
    return reactions;
  }());
  return wix;
}());
$root.google = (function() {
  const google = {};

  google.protobuf = (function() {
    const protobuf = {};

    protobuf.DoubleValue = (function() {

      class DoubleValue {

        constructor(props) {
          this.value = props && props.value;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'number') {
            errors.error('number expected');
          }
          return errors;
        }

        static toJSON(obj, helper) {
          return obj == null ? obj : isNaN(obj) ? 'NaN' : isFinite(obj) ? obj : obj.toString();
        }

        static fromJSON(json, helper) {
          return json === 'NaN' ? NaN : json === 'Infinity' ? Infinity : json === '-Infinity' ? -Infinity : json;
        }

        static toGRPC(obj, helper) {
          return obj == null ? obj : {
            'value': obj
          };
        }

        static fromGRPC(grpc, helper) {
          return grpc && grpc.value;
        }
      }

      Object.defineProperty(DoubleValue.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.protobuf.DoubleValue');
        },
        enumerable: false,
        configurable: false
      });
      return DoubleValue;
    }());
    protobuf.FloatValue = (function() {

      class FloatValue {

        constructor(props) {
          this.value = props && props.value;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'number') {
            errors.error('number expected');
          }
          return errors;
        }

        static toJSON(obj, helper) {
          return obj == null ? obj : isNaN(obj) ? 'NaN' : isFinite(obj) ? obj : obj.toString();
        }

        static fromJSON(json, helper) {
          return json === 'NaN' ? NaN : json === 'Infinity' ? Infinity : json === '-Infinity' ? -Infinity : json;
        }

        static toGRPC(obj, helper) {
          return obj == null ? obj : {
            'value': obj
          };
        }

        static fromGRPC(grpc, helper) {
          return grpc && grpc.value;
        }
      }

      Object.defineProperty(FloatValue.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.protobuf.FloatValue');
        },
        enumerable: false,
        configurable: false
      });
      return FloatValue;
    }());
    protobuf.Int64Value = (function() {

      class Int64Value {

        constructor(props) {
          this.value = props && props.value;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (!Number.isInteger(msg) && !Long.isLong(msg)) {
            errors.error('long or integer expected');
          }
          return errors;
        }

        static toJSON(obj, helper) {
          return obj == null ? obj : obj.toString();
        }

        static fromJSON(json, helper) {
          return json == null ? json : Long.fromValue(json);
        }

        static toGRPC(obj, helper) {
          return obj == null ? obj : {
            'value': obj.toString()
          };
        }

        static fromGRPC(grpc, helper) {
          return grpc && Long.fromValue(grpc.value);
        }
      }

      Object.defineProperty(Int64Value.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.protobuf.Int64Value');
        },
        enumerable: false,
        configurable: false
      });
      return Int64Value;
    }());
    protobuf.UInt64Value = (function() {

      class UInt64Value {

        constructor(props) {
          this.value = props && props.value;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (!((Number.isInteger(msg) || Long.isLong(msg)) && Long.fromValue(msg).greaterThanOrEqual(0))) {
            errors.error('non-negative long or integer expected');
          }
          return errors;
        }

        static toJSON(obj, helper) {
          return obj == null ? obj : obj.toString();
        }

        static fromJSON(json, helper) {
          return json == null ? json : Long.fromValue(json);
        }

        static toGRPC(obj, helper) {
          return obj == null ? obj : {
            'value': obj.toString()
          };
        }

        static fromGRPC(grpc, helper) {
          return grpc && Long.fromValue(grpc.value);
        }
      }

      Object.defineProperty(UInt64Value.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.protobuf.UInt64Value');
        },
        enumerable: false,
        configurable: false
      });
      return UInt64Value;
    }());
    protobuf.Int32Value = (function() {

      class Int32Value {

        constructor(props) {
          this.value = props && props.value;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (!Number.isInteger(msg)) {
            errors.error('integer expected');
          }
          return errors;
        }

        static toJSON(obj, helper) {
          return obj;
        }

        static fromJSON(json, helper) {
          return json;
        }

        static toGRPC(obj, helper) {
          return obj == null ? obj : {
            'value': obj
          };
        }

        static fromGRPC(grpc, helper) {
          return grpc && grpc.value;
        }
      }

      Object.defineProperty(Int32Value.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.protobuf.Int32Value');
        },
        enumerable: false,
        configurable: false
      });
      return Int32Value;
    }());
    protobuf.UInt32Value = (function() {

      class UInt32Value {

        constructor(props) {
          this.value = props && props.value;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (!Number.isInteger(msg) || msg < 0) {
            errors.error('non-negative integer expected');
          }
          return errors;
        }

        static toJSON(obj, helper) {
          return obj;
        }

        static fromJSON(json, helper) {
          return json;
        }

        static toGRPC(obj, helper) {
          return obj == null ? obj : {
            'value': obj
          };
        }

        static fromGRPC(grpc, helper) {
          return grpc && grpc.value;
        }
      }

      Object.defineProperty(UInt32Value.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.protobuf.UInt32Value');
        },
        enumerable: false,
        configurable: false
      });
      return UInt32Value;
    }());
    protobuf.BoolValue = (function() {

      class BoolValue {

        constructor(props) {
          this.value = props && props.value;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'boolean') {
            errors.error('boolean expected');
          }
          return errors;
        }

        static toJSON(obj, helper) {
          return obj;
        }

        static fromJSON(json, helper) {
          return json;
        }

        static toGRPC(obj, helper) {
          return obj == null ? obj : {
            'value': obj
          };
        }

        static fromGRPC(grpc, helper) {
          return grpc && grpc.value;
        }
      }

      Object.defineProperty(BoolValue.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.protobuf.BoolValue');
        },
        enumerable: false,
        configurable: false
      });
      return BoolValue;
    }());
    protobuf.StringValue = (function() {

      class StringValue {

        constructor(props) {
          this.value = props && props.value;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'string') {
            errors.error('string expected');
          }
          return errors;
        }

        static toJSON(obj, helper) {
          return obj;
        }

        static fromJSON(json, helper) {
          return json;
        }

        static toGRPC(obj, helper) {
          return obj == null ? obj : {
            'value': obj
          };
        }

        static fromGRPC(grpc, helper) {
          return grpc && grpc.value;
        }
      }

      Object.defineProperty(StringValue.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.protobuf.StringValue');
        },
        enumerable: false,
        configurable: false
      });
      return StringValue;
    }());
    protobuf.BytesValue = (function() {

      class BytesValue {

        constructor(props) {
          this.value = props && props.value;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (!Buffer.isBuffer(msg)) {
            errors.error('buffer expected');
          }
          return errors;
        }

        static toJSON(obj, helper) {
          return obj && obj.toString('base64');
        }

        static fromJSON(json, helper) {
          return json && function tryParseBytes(val) {
              try {
                return Buffer.from(val, 'base64');
              } catch (e) {
                return val;
              } finally {}
            }(json);
        }

        static toGRPC(obj, helper) {
          return obj == null ? obj : {
            'value': obj
          };
        }

        static fromGRPC(grpc, helper) {
          return grpc && grpc.value;
        }
      }

      Object.defineProperty(BytesValue.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.protobuf.BytesValue');
        },
        enumerable: false,
        configurable: false
      });
      return BytesValue;
    }());
    protobuf.Timestamp = (function() {

      class Timestamp {

        constructor(props) {
          this.seconds = props && props.seconds;
          this.nanos = props && props.nanos;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (msg != null && !(msg instanceof Date)) {
            errors.error('Date expected');
          }
          return errors;
        }

        static toJSON(obj, helper) {
          return obj && obj.toISOString();
        }

        static fromJSON(json, helper) {
          return json && new Date(json);
        }

        static toGRPC(obj, helper) {
          return helper.grpc.timestampToGRPC(obj);
        }

        static fromGRPC(grpc, helper) {
          return helper.grpc.timestampFromGRPC(grpc);
        }

        static describe() {
          return {
            'fields': {
              'seconds': {
                'type': 'int64',
                'id': 1
              },
              'nanos': {
                'type': 'int32',
                'id': 2
              }
            }
          };
        }
      }

      Object.defineProperty(Timestamp.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.protobuf.Timestamp');
        },
        enumerable: false,
        configurable: false
      });
      return Timestamp;
    }());
    protobuf.Empty = (function() {

      class Empty {

        constructor(props) {}

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (!(typeof msg === 'object' && !Array.isArray(msg) && Object.keys(msg).length === 0)) {
              errors.error('empty object expected');
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.google.protobuf.Empty();

          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.google.protobuf.Empty();

            return result;
          }
        }

        static describe() {
          return {
            'fields': {}
          };
        }
      }

      Object.defineProperty(Empty.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.protobuf.Empty');
        },
        enumerable: false,
        configurable: false
      });
      return Empty;
    }());
    protobuf.FieldMask = (function() {

      class FieldMask {

        constructor(props) {
          this.paths = props && props.paths;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (msg != null && !Array.isArray(msg)) {
            errors.error('array expected');
          } else {
            msg.forEach((value, index) => {
              if (typeof value !== 'string') {
                errors.index(index).error('string expected');
              }
            });
          }
        }

        static toJSON(obj, helper) {
          return obj && obj.join();
        }

        static fromJSON(json, helper) {
          return json && json.split(',');
        }

        static toGRPC(obj, helper) {
          return helper.grpc.fieldmaskToGRPC(obj);
        }

        static fromGRPC(grpc, helper) {
          return helper.grpc.fieldmaskFromGRPC(grpc);
        }

        static describe() {
          return {
            'fields': {
              'paths': {
                'rule': 'repeated',
                'type': 'string',
                'id': 1
              }
            }
          };
        }
      }

      Object.defineProperty(FieldMask.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.protobuf.FieldMask');
        },
        enumerable: false,
        configurable: false
      });
      return FieldMask;
    }());
    protobuf.Struct = (function() {

      class Struct {

        constructor(props) {
          this.fields = props && props.fields;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (msg != null && (!(typeof msg === 'object') || Array.isArray(msg))) {
            errors.error('object expected');
          }
          return errors;
        }

        static toJSON(obj, helper) {
          return obj;
        }

        static fromJSON(json, helper) {
          return json;
        }

        static toGRPC(obj, helper) {
          return helper.grpc.structToGRPC(obj);
        }

        static fromGRPC(grpc, helper) {
          return helper.grpc.structFromGRPC(grpc);
        }

        static describe() {
          return {
            'fields': {
              'fields': {
                'keyType': 'string',
                'type': $root.google.protobuf.Value,
                'id': 1
              }
            }
          };
        }
      }

      Object.defineProperty(Struct.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.protobuf.Struct');
        },
        enumerable: false,
        configurable: false
      });
      return Struct;
    }());
    protobuf.Value = (function() {

      class Value {

        constructor(props) {
          this.nullValue = props && props.nullValue;
          this.numberValue = props && props.numberValue;
          this.stringValue = props && props.stringValue;
          this.boolValue = props && props.boolValue;
          this.structValue = props && props.structValue;
          this.listValue = props && props.listValue;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          return errors;
        }

        static toJSON(obj, helper) {
          return obj;
        }

        static fromJSON(json, helper) {
          return json;
        }

        static toGRPC(obj, helper) {
          return helper.grpc.valueToGRPC(obj);
        }

        static fromGRPC(grpc, helper) {
          return helper.grpc.valueFromGRPC(grpc);
        }

        static describe() {
          return {
            'oneofs': {
              'kind': {
                'oneof': [
                  'nullValue',
                  'numberValue',
                  'stringValue',
                  'boolValue',
                  'structValue',
                  'listValue'
                ]
              }
            },
            'fields': {
              'nullValue': {
                'type': $root.google.protobuf.NullValue,
                'id': 1
              },
              'numberValue': {
                'type': 'double',
                'id': 2
              },
              'stringValue': {
                'type': 'string',
                'id': 3
              },
              'boolValue': {
                'type': 'bool',
                'id': 4
              },
              'structValue': {
                'type': $root.google.protobuf.Struct,
                'id': 5
              },
              'listValue': {
                'type': $root.google.protobuf.ListValue,
                'id': 6
              }
            }
          };
        }
      }

      Object.defineProperty(Value.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.protobuf.Value');
        },
        enumerable: false,
        configurable: false
      });
      return Value;
    }());
    return protobuf;
  }());
  google.api = (function() {
    const api = {};

    api.Http = (function() {

      class Http {

        constructor(props) {
          this.rules = props && props.rules;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.rules != null) {
              const fieldErrors = errors.field('rules');

              if (!Array.isArray(msg.rules)) {
                fieldErrors.error('array expected');
              } else {
                msg.rules.forEach((value, index) => {
                  $root.google.api.HttpRule.verify(value, helper, fieldErrors.index(index));
                });
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.rules != null) {
              json.rules = obj.rules.map(e => {
                return $root.google.api.HttpRule.toJSON(e, helper);
              });
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.google.api.Http();

          if (json.rules != null) {
            result.rules = json.rules.map(e => {
              return $root.google.api.HttpRule.fromJSON(e, helper);
            });
          } else {
            result.rules = [];
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.rules != null) {
              grpc.rules = obj.rules.map(e => {
                return $root.google.api.HttpRule.toGRPC(e, helper);
              });
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.google.api.Http();

            if (grpc.rules != null) {
              result.rules = grpc.rules.map(e => {
                return $root.google.api.HttpRule.fromGRPC(e, helper);
              });
            } else {
              result.rules = [];
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'rules': {
                'rule': 'repeated',
                'type': $root.google.api.HttpRule,
                'id': 1
              }
            }
          };
        }
      }

      Object.defineProperty(Http.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.api.Http');
        },
        enumerable: false,
        configurable: false
      });
      return Http;
    }());
    api.HttpRule = (function() {

      class HttpRule {

        constructor(props) {
          this.selector = props && props.selector;
          this.get = props && props.get;
          this.put = props && props.put;
          this.post = props && props.post;
          this.delete = props && props.delete;
          this.patch = props && props.patch;
          this.custom = props && props.custom;
          this.body = props && props.body;
          this.additionalBindings = props && props.additionalBindings;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            const oneOfMutex = {};

            if (msg.selector != null) {
              if (typeof msg.selector !== 'string') {
                errors.field('selector').error('string expected');
              }
            }
            if (msg.get != null) {
              if (oneOfMutex['pattern']) {
                errors.field('get').up().field('pattern').error('multiple values');
              } else {
                oneOfMutex['pattern'] = true;
                if (typeof msg.get !== 'string') {
                  errors.field('get').error('string expected');
                }
              }
            }
            if (msg.put != null) {
              if (oneOfMutex['pattern']) {
                errors.field('put').up().field('pattern').error('multiple values');
              } else {
                oneOfMutex['pattern'] = true;
                if (typeof msg.put !== 'string') {
                  errors.field('put').error('string expected');
                }
              }
            }
            if (msg.post != null) {
              if (oneOfMutex['pattern']) {
                errors.field('post').up().field('pattern').error('multiple values');
              } else {
                oneOfMutex['pattern'] = true;
                if (typeof msg.post !== 'string') {
                  errors.field('post').error('string expected');
                }
              }
            }
            if (msg.delete != null) {
              if (oneOfMutex['pattern']) {
                errors.field('delete').up().field('pattern').error('multiple values');
              } else {
                oneOfMutex['pattern'] = true;
                if (typeof msg.delete !== 'string') {
                  errors.field('delete').error('string expected');
                }
              }
            }
            if (msg.patch != null) {
              if (oneOfMutex['pattern']) {
                errors.field('patch').up().field('pattern').error('multiple values');
              } else {
                oneOfMutex['pattern'] = true;
                if (typeof msg.patch !== 'string') {
                  errors.field('patch').error('string expected');
                }
              }
            }
            if (msg.custom != null) {
              if (oneOfMutex['pattern']) {
                errors.field('custom').up().field('pattern').error('multiple values');
              } else {
                oneOfMutex['pattern'] = true;
                $root.google.api.CustomHttpPattern.verify(msg.custom, helper, errors.field('custom'));
              }
            }
            if (msg.body != null) {
              if (typeof msg.body !== 'string') {
                errors.field('body').error('string expected');
              }
            }
            if (msg.additionalBindings != null) {
              const fieldErrors = errors.field('additionalBindings');

              if (!Array.isArray(msg.additionalBindings)) {
                fieldErrors.error('array expected');
              } else {
                msg.additionalBindings.forEach((value, index) => {
                  $root.google.api.HttpRule.verify(value, helper, fieldErrors.index(index));
                });
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.selector != null) {
              json.selector = obj.selector;
            }
            if (obj.get != null) {
              json.get = obj.get;
            }
            if (obj.put != null) {
              json.put = obj.put;
            }
            if (obj.post != null) {
              json.post = obj.post;
            }
            if (obj.delete != null) {
              json.delete = obj.delete;
            }
            if (obj.patch != null) {
              json.patch = obj.patch;
            }
            if (obj.custom != null) {
              json.custom = $root.google.api.CustomHttpPattern.toJSON(obj.custom, helper);
            }
            if (obj.body != null) {
              json.body = obj.body;
            }
            if (obj.additionalBindings != null) {
              json.additionalBindings = obj.additionalBindings.map(e => {
                return $root.google.api.HttpRule.toJSON(e, helper);
              });
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.google.api.HttpRule();

          if (json.selector != null) {
            result.selector = json.selector;
          } else {
            result.selector = '';
          }
          if (json.get != null) {
            result.get = json.get;
          } else {
            delete result.get;
          }
          if (json.put != null) {
            result.put = json.put;
          } else {
            delete result.put;
          }
          if (json.post != null) {
            result.post = json.post;
          } else {
            delete result.post;
          }
          if (json.delete != null) {
            result.delete = json.delete;
          } else {
            delete result.delete;
          }
          if (json.patch != null) {
            result.patch = json.patch;
          } else {
            delete result.patch;
          }
          if (json.custom != null) {
            result.custom = $root.google.api.CustomHttpPattern.fromJSON(json.custom, helper);
          } else {
            delete result.custom;
          }
          if (json.body != null) {
            result.body = json.body;
          } else {
            result.body = '';
          }
          if (json.additionalBindings != null) {
            result.additionalBindings = json.additionalBindings.map(e => {
              return $root.google.api.HttpRule.fromJSON(e, helper);
            });
          } else {
            result.additionalBindings = [];
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.selector != null) {
              grpc.selector = obj.selector;
            }
            if (obj.get != null) {
              grpc.get = obj.get;
            }
            if (obj.put != null) {
              grpc.put = obj.put;
            }
            if (obj.post != null) {
              grpc.post = obj.post;
            }
            if (obj.delete != null) {
              grpc.delete = obj.delete;
            }
            if (obj.patch != null) {
              grpc.patch = obj.patch;
            }
            if (obj.custom != null) {
              grpc.custom = $root.google.api.CustomHttpPattern.toGRPC(obj.custom, helper);
            }
            if (obj.body != null) {
              grpc.body = obj.body;
            }
            if (obj.additionalBindings != null) {
              grpc.additionalBindings = obj.additionalBindings.map(e => {
                return $root.google.api.HttpRule.toGRPC(e, helper);
              });
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.google.api.HttpRule();

            if (grpc.selector != null) {
              result.selector = grpc.selector;
            } else {
              result.selector = '';
            }
            if (grpc.get != null) {
              result.get = grpc.get;
            } else {
              delete result.get;
            }
            if (grpc.put != null) {
              result.put = grpc.put;
            } else {
              delete result.put;
            }
            if (grpc.post != null) {
              result.post = grpc.post;
            } else {
              delete result.post;
            }
            if (grpc.delete != null) {
              result.delete = grpc.delete;
            } else {
              delete result.delete;
            }
            if (grpc.patch != null) {
              result.patch = grpc.patch;
            } else {
              delete result.patch;
            }
            if (grpc.custom != null) {
              result.custom = $root.google.api.CustomHttpPattern.fromGRPC(grpc.custom, helper);
            } else {
              delete result.custom;
            }
            if (grpc.body != null) {
              result.body = grpc.body;
            } else {
              result.body = '';
            }
            if (grpc.additionalBindings != null) {
              result.additionalBindings = grpc.additionalBindings.map(e => {
                return $root.google.api.HttpRule.fromGRPC(e, helper);
              });
            } else {
              result.additionalBindings = [];
            }
            return result;
          }
        }

        static describe() {
          return {
            'oneofs': {
              'pattern': {
                'oneof': [
                  'get',
                  'put',
                  'post',
                  'delete',
                  'patch',
                  'custom'
                ]
              }
            },
            'fields': {
              'selector': {
                'type': 'string',
                'id': 1
              },
              'get': {
                'type': 'string',
                'id': 2
              },
              'put': {
                'type': 'string',
                'id': 3
              },
              'post': {
                'type': 'string',
                'id': 4
              },
              'delete': {
                'type': 'string',
                'id': 5
              },
              'patch': {
                'type': 'string',
                'id': 6
              },
              'custom': {
                'type': $root.google.api.CustomHttpPattern,
                'id': 8
              },
              'body': {
                'type': 'string',
                'id': 7
              },
              'additionalBindings': {
                'rule': 'repeated',
                'type': $root.google.api.HttpRule,
                'id': 11
              }
            }
          };
        }
      }

      Object.defineProperty(HttpRule.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.api.HttpRule');
        },
        enumerable: false,
        configurable: false
      });
      return HttpRule;
    }());
    api.CustomHttpPattern = (function() {

      class CustomHttpPattern {

        constructor(props) {
          this.kind = props && props.kind;
          this.path = props && props.path;
        }

        static verify(msg, helper, errors = helper.verification.Errors.empty()) {
          if (typeof msg !== 'object' || msg == null) {
            errors.error('object expected');
          } else {
            if (msg.kind != null) {
              if (typeof msg.kind !== 'string') {
                errors.field('kind').error('string expected');
              }
            }
            if (msg.path != null) {
              if (typeof msg.path !== 'string') {
                errors.field('path').error('string expected');
              }
            }
          }
          return errors;
        }

        static toJSON(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const json = {};

            if (obj.kind != null) {
              json.kind = obj.kind;
            }
            if (obj.path != null) {
              json.path = obj.path;
            }
            return json;
          }
        }

        static fromJSON(json, helper) {
          const result = new $root.google.api.CustomHttpPattern();

          if (json.kind != null) {
            result.kind = json.kind;
          } else {
            result.kind = '';
          }
          if (json.path != null) {
            result.path = json.path;
          } else {
            result.path = '';
          }
          return result;
        }

        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};

            if (obj.kind != null) {
              grpc.kind = obj.kind;
            }
            if (obj.path != null) {
              grpc.path = obj.path;
            }
            return grpc;
          }
        }

        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.google.api.CustomHttpPattern();

            if (grpc.kind != null) {
              result.kind = grpc.kind;
            } else {
              result.kind = '';
            }
            if (grpc.path != null) {
              result.path = grpc.path;
            } else {
              result.path = '';
            }
            return result;
          }
        }

        static describe() {
          return {
            'fields': {
              'kind': {
                'type': 'string',
                'id': 1
              },
              'path': {
                'type': 'string',
                'id': 2
              }
            }
          };
        }
      }

      Object.defineProperty(CustomHttpPattern.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.api.CustomHttpPattern');
        },
        enumerable: false,
        configurable: false
      });
      return CustomHttpPattern;
    }());
    return api;
  }());
  return google;
}());
$root.com = (function() {
  const com = {};

  com.wix = (function() {
    const wix = {};

    wix.core = (function() {
      const core = {};

      core.services = (function() {
        const services = {};

        services.identification2 = (function() {
          const identification2 = {};

          identification2.PersonType = {
            verify: (value, helper, errors = helper.verification.Errors.empty()) => {
              switch (value) {
                default: {
                  errors.error('enum expected');
                }
                case 'USER':
                case 'SITEMEMBER':
                case 'VISITOR':
                  break;
              }
              return errors;
            },
            'USER': 'USER',
            'SITEMEMBER': 'SITEMEMBER',
            'VISITOR': 'VISITOR'
          };
          identification2.Service = (function() {

            class Service {

              constructor(props) {
                this.appDefId = props && props.appDefId;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.appDefId != null) {
                    if (typeof msg.appDefId !== 'string') {
                      errors.field('appDefId').error('string expected');
                    }
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.appDefId != null) {
                    json.appDefId = obj.appDefId;
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.com.wix.core.services.identification2.Service();

                if (json.appDefId != null) {
                  result.appDefId = json.appDefId;
                } else {
                  result.appDefId = '';
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.appDefId != null) {
                    grpc.appDefId = obj.appDefId;
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.com.wix.core.services.identification2.Service();

                  if (grpc.appDefId != null) {
                    result.appDefId = grpc.appDefId;
                  } else {
                    result.appDefId = '';
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'appDefId': {
                      'type': 'string',
                      'id': 1
                    }
                  }
                };
              }
            }

            Object.defineProperty(Service.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('com.wix.core.services.identification2.Service');
              },
              enumerable: false,
              configurable: false
            });
            return Service;
          }());
          identification2.Person = (function() {

            class Person {

              constructor(props) {
                this.type = props && props.type;
                this.id = props && props.id;
                this.hasUserRole = props && props.hasUserRole;
                this.isWixStaff = props && props.isWixStaff;
                this.userAccountInfo = props && props.userAccountInfo;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.type != null) {
                    $root.com.wix.core.services.identification2.PersonType.verify(msg.type, helper, errors.field('type'));
                  }
                  if (msg.id != null) {
                    if (typeof msg.id !== 'string') {
                      errors.field('id').error('string expected');
                    }
                  }
                  if (msg.hasUserRole != null) {
                    if (typeof msg.hasUserRole !== 'boolean') {
                      errors.field('hasUserRole').error('boolean expected');
                    }
                  }
                  if (msg.isWixStaff != null) {
                    if (typeof msg.isWixStaff !== 'boolean') {
                      errors.field('isWixStaff').error('boolean expected');
                    }
                  }
                  if (msg.userAccountInfo != null) {
                    $root.com.wix.core.services.identification2.UserAccountInfo.verify(msg.userAccountInfo, helper, errors.field('userAccountInfo'));
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.type != null) {
                    json.type = $root.com.wix.core.services.identification2.PersonType[obj.type];
                  }
                  if (obj.id != null) {
                    json.id = obj.id;
                  }
                  if (obj.hasUserRole != null) {
                    json.hasUserRole = obj.hasUserRole;
                  }
                  if (obj.isWixStaff != null) {
                    json.isWixStaff = obj.isWixStaff;
                  }
                  if (obj.userAccountInfo != null) {
                    json.userAccountInfo = $root.com.wix.core.services.identification2.UserAccountInfo.toJSON(obj.userAccountInfo, helper);
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.com.wix.core.services.identification2.Person();

                if (json.type != null) {
                  result.type = $root.com.wix.core.services.identification2.PersonType[json.type];
                } else {
                  result.type = 'USER';
                }
                if (json.id != null) {
                  result.id = json.id;
                } else {
                  result.id = '';
                }
                if (json.hasUserRole != null) {
                  result.hasUserRole = json.hasUserRole;
                } else {
                  result.hasUserRole = false;
                }
                if (json.isWixStaff != null) {
                  result.isWixStaff = json.isWixStaff;
                } else {
                  result.isWixStaff = false;
                }
                if (json.userAccountInfo != null) {
                  result.userAccountInfo = $root.com.wix.core.services.identification2.UserAccountInfo.fromJSON(json.userAccountInfo, helper);
                } else {
                  delete result.userAccountInfo;
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.type != null) {
                    grpc.type = obj.type;
                  }
                  if (obj.id != null) {
                    grpc.id = obj.id;
                  }
                  if (obj.hasUserRole != null) {
                    grpc.hasUserRole = obj.hasUserRole;
                  }
                  if (obj.isWixStaff != null) {
                    grpc.isWixStaff = obj.isWixStaff;
                  }
                  if (obj.userAccountInfo != null) {
                    grpc.userAccountInfo = $root.com.wix.core.services.identification2.UserAccountInfo.toGRPC(obj.userAccountInfo, helper);
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.com.wix.core.services.identification2.Person();

                  if (grpc.type != null) {
                    result.type = grpc.type;
                  } else {
                    result.type = 'USER';
                  }
                  if (grpc.id != null) {
                    result.id = grpc.id;
                  } else {
                    result.id = '';
                  }
                  if (grpc.hasUserRole != null) {
                    result.hasUserRole = grpc.hasUserRole;
                  } else {
                    result.hasUserRole = false;
                  }
                  if (grpc.isWixStaff != null) {
                    result.isWixStaff = grpc.isWixStaff;
                  } else {
                    result.isWixStaff = false;
                  }
                  if (grpc.userAccountInfo != null) {
                    result.userAccountInfo = $root.com.wix.core.services.identification2.UserAccountInfo.fromGRPC(grpc.userAccountInfo, helper);
                  } else {
                    delete result.userAccountInfo;
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'type': {
                      'type': $root.com.wix.core.services.identification2.PersonType,
                      'id': 1
                    },
                    'id': {
                      'type': 'string',
                      'id': 2
                    },
                    'hasUserRole': {
                      'type': 'bool',
                      'id': 3
                    },
                    'isWixStaff': {
                      'type': 'bool',
                      'id': 4
                    },
                    'userAccountInfo': {
                      'type': $root.com.wix.core.services.identification2.UserAccountInfo,
                      'id': 5
                    }
                  }
                };
              }
            }

            Object.defineProperty(Person.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('com.wix.core.services.identification2.Person');
              },
              enumerable: false,
              configurable: false
            });
            return Person;
          }());
          identification2.UserAccountInfo = (function() {

            class UserAccountInfo {

              constructor(props) {
                this.loggedInAccountId = props && props.loggedInAccountId;
                this.isAccountOwner = props && props.isAccountOwner;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.loggedInAccountId != null) {
                    if (typeof msg.loggedInAccountId !== 'string') {
                      errors.field('loggedInAccountId').error('string expected');
                    }
                  }
                  if (msg.isAccountOwner != null) {
                    if (typeof msg.isAccountOwner !== 'boolean') {
                      errors.field('isAccountOwner').error('boolean expected');
                    }
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.loggedInAccountId != null) {
                    json.loggedInAccountId = obj.loggedInAccountId;
                  }
                  if (obj.isAccountOwner != null) {
                    json.isAccountOwner = obj.isAccountOwner;
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.com.wix.core.services.identification2.UserAccountInfo();

                if (json.loggedInAccountId != null) {
                  result.loggedInAccountId = json.loggedInAccountId;
                } else {
                  result.loggedInAccountId = '';
                }
                if (json.isAccountOwner != null) {
                  result.isAccountOwner = json.isAccountOwner;
                } else {
                  result.isAccountOwner = false;
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.loggedInAccountId != null) {
                    grpc.loggedInAccountId = obj.loggedInAccountId;
                  }
                  if (obj.isAccountOwner != null) {
                    grpc.isAccountOwner = obj.isAccountOwner;
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.com.wix.core.services.identification2.UserAccountInfo();

                  if (grpc.loggedInAccountId != null) {
                    result.loggedInAccountId = grpc.loggedInAccountId;
                  } else {
                    result.loggedInAccountId = '';
                  }
                  if (grpc.isAccountOwner != null) {
                    result.isAccountOwner = grpc.isAccountOwner;
                  } else {
                    result.isAccountOwner = false;
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'loggedInAccountId': {
                      'type': 'string',
                      'id': 1
                    },
                    'isAccountOwner': {
                      'type': 'bool',
                      'id': 2
                    }
                  }
                };
              }
            }

            Object.defineProperty(UserAccountInfo.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('com.wix.core.services.identification2.UserAccountInfo');
              },
              enumerable: false,
              configurable: false
            });
            return UserAccountInfo;
          }());
          identification2.UserData = (function() {

            class UserData {

              constructor(props) {
                this.userId = props && props.userId;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.userId != null) {
                    if (typeof msg.userId !== 'string') {
                      errors.field('userId').error('string expected');
                    }
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.userId != null) {
                    json.userId = obj.userId;
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.com.wix.core.services.identification2.UserData();

                if (json.userId != null) {
                  result.userId = json.userId;
                } else {
                  result.userId = '';
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.userId != null) {
                    grpc.userId = obj.userId;
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.com.wix.core.services.identification2.UserData();

                  if (grpc.userId != null) {
                    result.userId = grpc.userId;
                  } else {
                    result.userId = '';
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'userId': {
                      'type': 'string',
                      'id': 1
                    }
                  }
                };
              }
            }

            Object.defineProperty(UserData.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('com.wix.core.services.identification2.UserData');
              },
              enumerable: false,
              configurable: false
            });
            return UserData;
          }());
          identification2.SiteData = (function() {

            class SiteData {

              constructor(props) {
                this.instanceId = props && props.instanceId;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.instanceId != null) {
                    if (typeof msg.instanceId !== 'string') {
                      errors.field('instanceId').error('string expected');
                    }
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.instanceId != null) {
                    json.instanceId = obj.instanceId;
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.com.wix.core.services.identification2.SiteData();

                if (json.instanceId != null) {
                  result.instanceId = json.instanceId;
                } else {
                  result.instanceId = '';
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.instanceId != null) {
                    grpc.instanceId = obj.instanceId;
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.com.wix.core.services.identification2.SiteData();

                  if (grpc.instanceId != null) {
                    result.instanceId = grpc.instanceId;
                  } else {
                    result.instanceId = '';
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'instanceId': {
                      'type': 'string',
                      'id': 1
                    }
                  }
                };
              }
            }

            Object.defineProperty(SiteData.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('com.wix.core.services.identification2.SiteData');
              },
              enumerable: false,
              configurable: false
            });
            return SiteData;
          }());
          identification2.WixGlobalData = (function() {

            class WixGlobalData {

              constructor(props) {}

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (!(typeof msg === 'object' && !Array.isArray(msg) && Object.keys(msg).length === 0)) {
                    errors.error('empty object expected');
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.com.wix.core.services.identification2.WixGlobalData();

                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.com.wix.core.services.identification2.WixGlobalData();

                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {}
                };
              }
            }

            Object.defineProperty(WixGlobalData.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('com.wix.core.services.identification2.WixGlobalData');
              },
              enumerable: false,
              configurable: false
            });
            return WixGlobalData;
          }());
          identification2.ExternalApp = (function() {

            class ExternalApp {

              constructor(props) {
                this.appDefId = props && props.appDefId;
                this.permissions = props && props.permissions;
                this.userData = props && props.userData;
                this.siteData = props && props.siteData;
                this.wixGlobalData = props && props.wixGlobalData;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  const oneOfMutex = {};

                  if (msg.appDefId != null) {
                    if (typeof msg.appDefId !== 'string') {
                      errors.field('appDefId').error('string expected');
                    }
                  }
                  if (msg.permissions != null) {
                    const fieldErrors = errors.field('permissions');

                    if (!Array.isArray(msg.permissions)) {
                      fieldErrors.error('array expected');
                    } else {
                      msg.permissions.forEach((value, index) => {
                        if (typeof value !== 'string') {
                          fieldErrors.index(index).error('string expected');
                        }
                      });
                    }
                  }
                  if (msg.userData != null) {
                    if (oneOfMutex['DataSelector']) {
                      errors.field('userData').up().field('DataSelector').error('multiple values');
                    } else {
                      oneOfMutex['DataSelector'] = true;
                      $root.com.wix.core.services.identification2.UserData.verify(msg.userData, helper, errors.field('userData'));
                    }
                  }
                  if (msg.siteData != null) {
                    if (oneOfMutex['DataSelector']) {
                      errors.field('siteData').up().field('DataSelector').error('multiple values');
                    } else {
                      oneOfMutex['DataSelector'] = true;
                      $root.com.wix.core.services.identification2.SiteData.verify(msg.siteData, helper, errors.field('siteData'));
                    }
                  }
                  if (msg.wixGlobalData != null) {
                    if (oneOfMutex['DataSelector']) {
                      errors.field('wixGlobalData').up().field('DataSelector').error('multiple values');
                    } else {
                      oneOfMutex['DataSelector'] = true;
                      $root.com.wix.core.services.identification2.WixGlobalData.verify(msg.wixGlobalData, helper, errors.field('wixGlobalData'));
                    }
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.appDefId != null) {
                    json.appDefId = obj.appDefId;
                  }
                  if (obj.permissions != null) {
                    json.permissions = obj.permissions.map(e => {
                      return e;
                    });
                  }
                  if (obj.userData != null) {
                    json.userData = $root.com.wix.core.services.identification2.UserData.toJSON(obj.userData, helper);
                  }
                  if (obj.siteData != null) {
                    json.siteData = $root.com.wix.core.services.identification2.SiteData.toJSON(obj.siteData, helper);
                  }
                  if (obj.wixGlobalData != null) {
                    json.wixGlobalData = $root.com.wix.core.services.identification2.WixGlobalData.toJSON(obj.wixGlobalData, helper);
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.com.wix.core.services.identification2.ExternalApp();

                if (json.appDefId != null) {
                  result.appDefId = json.appDefId;
                } else {
                  result.appDefId = '';
                }
                if (json.permissions != null) {
                  result.permissions = json.permissions.map(e => {
                    return e;
                  });
                } else {
                  result.permissions = [];
                }
                if (json.userData != null) {
                  result.userData = $root.com.wix.core.services.identification2.UserData.fromJSON(json.userData, helper);
                } else {
                  delete result.userData;
                }
                if (json.siteData != null) {
                  result.siteData = $root.com.wix.core.services.identification2.SiteData.fromJSON(json.siteData, helper);
                } else {
                  delete result.siteData;
                }
                if (json.wixGlobalData != null) {
                  result.wixGlobalData = $root.com.wix.core.services.identification2.WixGlobalData.fromJSON(json.wixGlobalData, helper);
                } else {
                  delete result.wixGlobalData;
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.appDefId != null) {
                    grpc.appDefId = obj.appDefId;
                  }
                  if (obj.permissions != null) {
                    grpc.permissions = obj.permissions.map(e => {
                      return e;
                    });
                  }
                  if (obj.userData != null) {
                    grpc.userData = $root.com.wix.core.services.identification2.UserData.toGRPC(obj.userData, helper);
                  }
                  if (obj.siteData != null) {
                    grpc.siteData = $root.com.wix.core.services.identification2.SiteData.toGRPC(obj.siteData, helper);
                  }
                  if (obj.wixGlobalData != null) {
                    grpc.wixGlobalData = $root.com.wix.core.services.identification2.WixGlobalData.toGRPC(obj.wixGlobalData, helper);
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.com.wix.core.services.identification2.ExternalApp();

                  if (grpc.appDefId != null) {
                    result.appDefId = grpc.appDefId;
                  } else {
                    result.appDefId = '';
                  }
                  if (grpc.permissions != null) {
                    result.permissions = grpc.permissions.map(e => {
                      return e;
                    });
                  } else {
                    result.permissions = [];
                  }
                  if (grpc.userData != null) {
                    result.userData = $root.com.wix.core.services.identification2.UserData.fromGRPC(grpc.userData, helper);
                  } else {
                    delete result.userData;
                  }
                  if (grpc.siteData != null) {
                    result.siteData = $root.com.wix.core.services.identification2.SiteData.fromGRPC(grpc.siteData, helper);
                  } else {
                    delete result.siteData;
                  }
                  if (grpc.wixGlobalData != null) {
                    result.wixGlobalData = $root.com.wix.core.services.identification2.WixGlobalData.fromGRPC(grpc.wixGlobalData, helper);
                  } else {
                    delete result.wixGlobalData;
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'oneofs': {
                    'DataSelector': {
                      'oneof': [
                        'userData',
                        'siteData',
                        'wixGlobalData'
                      ]
                    }
                  },
                  'fields': {
                    'appDefId': {
                      'type': 'string',
                      'id': 1
                    },
                    'permissions': {
                      'rule': 'repeated',
                      'type': 'string',
                      'id': 2
                    },
                    'userData': {
                      'type': $root.com.wix.core.services.identification2.UserData,
                      'id': 3
                    },
                    'siteData': {
                      'type': $root.com.wix.core.services.identification2.SiteData,
                      'id': 4
                    },
                    'wixGlobalData': {
                      'type': $root.com.wix.core.services.identification2.WixGlobalData,
                      'id': 5
                    }
                  }
                };
              }
            }

            Object.defineProperty(ExternalApp.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('com.wix.core.services.identification2.ExternalApp');
              },
              enumerable: false,
              configurable: false
            });
            return ExternalApp;
          }());
          identification2.Cache = (function() {

            class Cache {

              constructor(props) {}

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (!(typeof msg === 'object' && !Array.isArray(msg) && Object.keys(msg).length === 0)) {
                    errors.error('empty object expected');
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.com.wix.core.services.identification2.Cache();

                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.com.wix.core.services.identification2.Cache();

                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {}
                };
              }
            }

            Object.defineProperty(Cache.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('com.wix.core.services.identification2.Cache');
              },
              enumerable: false,
              configurable: false
            });
            return Cache;
          }());
          identification2.Identity = (function() {

            class Identity {

              constructor(props) {
                this.person = props && props.person;
                this.service = props && props.service;
                this.externalApp = props && props.externalApp;
                this.cache = props && props.cache;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  const oneOfMutex = {};

                  if (msg.person != null) {
                    if (oneOfMutex['IdentitySelector']) {
                      errors.field('person').up().field('IdentitySelector').error('multiple values');
                    } else {
                      oneOfMutex['IdentitySelector'] = true;
                      $root.com.wix.core.services.identification2.Person.verify(msg.person, helper, errors.field('person'));
                    }
                  }
                  if (msg.service != null) {
                    if (oneOfMutex['IdentitySelector']) {
                      errors.field('service').up().field('IdentitySelector').error('multiple values');
                    } else {
                      oneOfMutex['IdentitySelector'] = true;
                      $root.com.wix.core.services.identification2.Service.verify(msg.service, helper, errors.field('service'));
                    }
                  }
                  if (msg.externalApp != null) {
                    if (oneOfMutex['IdentitySelector']) {
                      errors.field('externalApp').up().field('IdentitySelector').error('multiple values');
                    } else {
                      oneOfMutex['IdentitySelector'] = true;
                      $root.com.wix.core.services.identification2.ExternalApp.verify(msg.externalApp, helper, errors.field('externalApp'));
                    }
                  }
                  if (msg.cache != null) {
                    if (oneOfMutex['IdentitySelector']) {
                      errors.field('cache').up().field('IdentitySelector').error('multiple values');
                    } else {
                      oneOfMutex['IdentitySelector'] = true;
                      $root.com.wix.core.services.identification2.Cache.verify(msg.cache, helper, errors.field('cache'));
                    }
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.person != null) {
                    json.person = $root.com.wix.core.services.identification2.Person.toJSON(obj.person, helper);
                  }
                  if (obj.service != null) {
                    json.service = $root.com.wix.core.services.identification2.Service.toJSON(obj.service, helper);
                  }
                  if (obj.externalApp != null) {
                    json.externalApp = $root.com.wix.core.services.identification2.ExternalApp.toJSON(obj.externalApp, helper);
                  }
                  if (obj.cache != null) {
                    json.cache = $root.com.wix.core.services.identification2.Cache.toJSON(obj.cache, helper);
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.com.wix.core.services.identification2.Identity();

                if (json.person != null) {
                  result.person = $root.com.wix.core.services.identification2.Person.fromJSON(json.person, helper);
                } else {
                  delete result.person;
                }
                if (json.service != null) {
                  result.service = $root.com.wix.core.services.identification2.Service.fromJSON(json.service, helper);
                } else {
                  delete result.service;
                }
                if (json.externalApp != null) {
                  result.externalApp = $root.com.wix.core.services.identification2.ExternalApp.fromJSON(json.externalApp, helper);
                } else {
                  delete result.externalApp;
                }
                if (json.cache != null) {
                  result.cache = $root.com.wix.core.services.identification2.Cache.fromJSON(json.cache, helper);
                } else {
                  delete result.cache;
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.person != null) {
                    grpc.person = $root.com.wix.core.services.identification2.Person.toGRPC(obj.person, helper);
                  }
                  if (obj.service != null) {
                    grpc.service = $root.com.wix.core.services.identification2.Service.toGRPC(obj.service, helper);
                  }
                  if (obj.externalApp != null) {
                    grpc.externalApp = $root.com.wix.core.services.identification2.ExternalApp.toGRPC(obj.externalApp, helper);
                  }
                  if (obj.cache != null) {
                    grpc.cache = $root.com.wix.core.services.identification2.Cache.toGRPC(obj.cache, helper);
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.com.wix.core.services.identification2.Identity();

                  if (grpc.person != null) {
                    result.person = $root.com.wix.core.services.identification2.Person.fromGRPC(grpc.person, helper);
                  } else {
                    delete result.person;
                  }
                  if (grpc.service != null) {
                    result.service = $root.com.wix.core.services.identification2.Service.fromGRPC(grpc.service, helper);
                  } else {
                    delete result.service;
                  }
                  if (grpc.externalApp != null) {
                    result.externalApp = $root.com.wix.core.services.identification2.ExternalApp.fromGRPC(grpc.externalApp, helper);
                  } else {
                    delete result.externalApp;
                  }
                  if (grpc.cache != null) {
                    result.cache = $root.com.wix.core.services.identification2.Cache.fromGRPC(grpc.cache, helper);
                  } else {
                    delete result.cache;
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'oneofs': {
                    'IdentitySelector': {
                      'oneof': [
                        'person',
                        'service',
                        'externalApp',
                        'cache'
                      ]
                    }
                  },
                  'fields': {
                    'person': {
                      'type': $root.com.wix.core.services.identification2.Person,
                      'id': 1
                    },
                    'service': {
                      'type': $root.com.wix.core.services.identification2.Service,
                      'id': 2
                    },
                    'externalApp': {
                      'type': $root.com.wix.core.services.identification2.ExternalApp,
                      'id': 3
                    },
                    'cache': {
                      'type': $root.com.wix.core.services.identification2.Cache,
                      'id': 4
                    }
                  }
                };
              }
            }

            Object.defineProperty(Identity.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('com.wix.core.services.identification2.Identity');
              },
              enumerable: false,
              configurable: false
            });
            return Identity;
          }());
          identification2.Context = (function() {

            class Context {

              constructor(props) {
                this.appDefId = props && props.appDefId;
                this.instanceId = props && props.instanceId;
                this.metasiteId = props && props.metasiteId;
                this.siteMemberId = props && props.siteMemberId;
                this.targetAccountId = props && props.targetAccountId;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.appDefId != null) {
                    $root.google.protobuf.StringValue.verify(msg.appDefId, helper, errors.field('appDefId'));
                  }
                  if (msg.instanceId != null) {
                    $root.google.protobuf.StringValue.verify(msg.instanceId, helper, errors.field('instanceId'));
                  }
                  if (msg.metasiteId != null) {
                    $root.google.protobuf.StringValue.verify(msg.metasiteId, helper, errors.field('metasiteId'));
                  }
                  if (msg.siteMemberId != null) {
                    $root.google.protobuf.StringValue.verify(msg.siteMemberId, helper, errors.field('siteMemberId'));
                  }
                  if (msg.targetAccountId != null) {
                    $root.google.protobuf.StringValue.verify(msg.targetAccountId, helper, errors.field('targetAccountId'));
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.appDefId != null) {
                    json.appDefId = $root.google.protobuf.StringValue.toJSON(obj.appDefId, helper);
                  }
                  if (obj.instanceId != null) {
                    json.instanceId = $root.google.protobuf.StringValue.toJSON(obj.instanceId, helper);
                  }
                  if (obj.metasiteId != null) {
                    json.metasiteId = $root.google.protobuf.StringValue.toJSON(obj.metasiteId, helper);
                  }
                  if (obj.siteMemberId != null) {
                    json.siteMemberId = $root.google.protobuf.StringValue.toJSON(obj.siteMemberId, helper);
                  }
                  if (obj.targetAccountId != null) {
                    json.targetAccountId = $root.google.protobuf.StringValue.toJSON(obj.targetAccountId, helper);
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.com.wix.core.services.identification2.Context();

                if (json.appDefId != null) {
                  result.appDefId = $root.google.protobuf.StringValue.fromJSON(json.appDefId, helper);
                } else {
                  delete result.appDefId;
                }
                if (json.instanceId != null) {
                  result.instanceId = $root.google.protobuf.StringValue.fromJSON(json.instanceId, helper);
                } else {
                  delete result.instanceId;
                }
                if (json.metasiteId != null) {
                  result.metasiteId = $root.google.protobuf.StringValue.fromJSON(json.metasiteId, helper);
                } else {
                  delete result.metasiteId;
                }
                if (json.siteMemberId != null) {
                  result.siteMemberId = $root.google.protobuf.StringValue.fromJSON(json.siteMemberId, helper);
                } else {
                  delete result.siteMemberId;
                }
                if (json.targetAccountId != null) {
                  result.targetAccountId = $root.google.protobuf.StringValue.fromJSON(json.targetAccountId, helper);
                } else {
                  delete result.targetAccountId;
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.appDefId != null) {
                    grpc.appDefId = $root.google.protobuf.StringValue.toGRPC(obj.appDefId, helper);
                  }
                  if (obj.instanceId != null) {
                    grpc.instanceId = $root.google.protobuf.StringValue.toGRPC(obj.instanceId, helper);
                  }
                  if (obj.metasiteId != null) {
                    grpc.metasiteId = $root.google.protobuf.StringValue.toGRPC(obj.metasiteId, helper);
                  }
                  if (obj.siteMemberId != null) {
                    grpc.siteMemberId = $root.google.protobuf.StringValue.toGRPC(obj.siteMemberId, helper);
                  }
                  if (obj.targetAccountId != null) {
                    grpc.targetAccountId = $root.google.protobuf.StringValue.toGRPC(obj.targetAccountId, helper);
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.com.wix.core.services.identification2.Context();

                  if (grpc.appDefId != null) {
                    result.appDefId = $root.google.protobuf.StringValue.fromGRPC(grpc.appDefId, helper);
                  } else {
                    delete result.appDefId;
                  }
                  if (grpc.instanceId != null) {
                    result.instanceId = $root.google.protobuf.StringValue.fromGRPC(grpc.instanceId, helper);
                  } else {
                    delete result.instanceId;
                  }
                  if (grpc.metasiteId != null) {
                    result.metasiteId = $root.google.protobuf.StringValue.fromGRPC(grpc.metasiteId, helper);
                  } else {
                    delete result.metasiteId;
                  }
                  if (grpc.siteMemberId != null) {
                    result.siteMemberId = $root.google.protobuf.StringValue.fromGRPC(grpc.siteMemberId, helper);
                  } else {
                    delete result.siteMemberId;
                  }
                  if (grpc.targetAccountId != null) {
                    result.targetAccountId = $root.google.protobuf.StringValue.fromGRPC(grpc.targetAccountId, helper);
                  } else {
                    delete result.targetAccountId;
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'appDefId': {
                      'type': $root.google.protobuf.StringValue,
                      'id': 1
                    },
                    'instanceId': {
                      'type': $root.google.protobuf.StringValue,
                      'id': 2
                    },
                    'metasiteId': {
                      'type': $root.google.protobuf.StringValue,
                      'id': 3
                    },
                    'siteMemberId': {
                      'type': $root.google.protobuf.StringValue,
                      'id': 4
                    },
                    'targetAccountId': {
                      'type': $root.google.protobuf.StringValue,
                      'id': 5
                    }
                  }
                };
              }
            }

            Object.defineProperty(Context.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('com.wix.core.services.identification2.Context');
              },
              enumerable: false,
              configurable: false
            });
            return Context;
          }());
          identification2.IdentificationData = (function() {

            class IdentificationData {

              constructor(props) {
                this.context = props && props.context;
                this.identities = props && props.identities;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.context != null) {
                    $root.com.wix.core.services.identification2.Context.verify(msg.context, helper, errors.field('context'));
                  }
                  if (msg.identities != null) {
                    const fieldErrors = errors.field('identities');

                    if (!Array.isArray(msg.identities)) {
                      fieldErrors.error('array expected');
                    } else {
                      msg.identities.forEach((value, index) => {
                        $root.com.wix.core.services.identification2.Identity.verify(value, helper, fieldErrors.index(index));
                      });
                    }
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.context != null) {
                    json.context = $root.com.wix.core.services.identification2.Context.toJSON(obj.context, helper);
                  }
                  if (obj.identities != null) {
                    json.identities = obj.identities.map(e => {
                      return $root.com.wix.core.services.identification2.Identity.toJSON(e, helper);
                    });
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.com.wix.core.services.identification2.IdentificationData();

                if (json.context != null) {
                  result.context = $root.com.wix.core.services.identification2.Context.fromJSON(json.context, helper);
                } else {
                  delete result.context;
                }
                if (json.identities != null) {
                  result.identities = json.identities.map(e => {
                    return $root.com.wix.core.services.identification2.Identity.fromJSON(e, helper);
                  });
                } else {
                  result.identities = [];
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.context != null) {
                    grpc.context = $root.com.wix.core.services.identification2.Context.toGRPC(obj.context, helper);
                  }
                  if (obj.identities != null) {
                    grpc.identities = obj.identities.map(e => {
                      return $root.com.wix.core.services.identification2.Identity.toGRPC(e, helper);
                    });
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.com.wix.core.services.identification2.IdentificationData();

                  if (grpc.context != null) {
                    result.context = $root.com.wix.core.services.identification2.Context.fromGRPC(grpc.context, helper);
                  } else {
                    delete result.context;
                  }
                  if (grpc.identities != null) {
                    result.identities = grpc.identities.map(e => {
                      return $root.com.wix.core.services.identification2.Identity.fromGRPC(e, helper);
                    });
                  } else {
                    result.identities = [];
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'context': {
                      'type': $root.com.wix.core.services.identification2.Context,
                      'id': 1
                    },
                    'identities': {
                      'rule': 'repeated',
                      'type': $root.com.wix.core.services.identification2.Identity,
                      'id': 2
                    }
                  }
                };
              }
            }

            Object.defineProperty(IdentificationData.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('com.wix.core.services.identification2.IdentificationData');
              },
              enumerable: false,
              configurable: false
            });
            return IdentificationData;
          }());
          identification2.IdentityRequest = (function() {

            class IdentityRequest {

              constructor(props) {
                this.sessions = props && props.sessions;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.sessions != null) {
                    const fieldErrors = errors.field('sessions');

                    if (msg.sessions != null && (!(typeof msg.sessions === 'object') || Array.isArray(msg.sessions))) {
                      fieldErrors.error('object expected');
                    } else {
                      for (let key in msg.sessions) {
                        const keyErrors = fieldErrors.index(key);
                        if (typeof msg.sessions[key] !== 'string') {
                          keyErrors.field('value').error('string expected');
                        }
                      }
                    }
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.sessions != null) {
                    json.sessions = Object.entries(obj.sessions).reduce((acc, [k, v]) => {
                      acc[k] = v;
                      return acc;
                    }, {});
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.com.wix.core.services.identification2.IdentityRequest();

                if (json.sessions != null) {
                  result.sessions = Object.entries(json.sessions).reduce((acc, [k, v]) => {
                    acc[k] = v;
                    return acc;
                  }, {});
                } else {
                  delete result.sessions;
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.sessions != null) {
                    grpc.sessions = Object.entries(obj.sessions).reduce((acc, [k, v]) => {
                      acc[k] = v;
                      return acc;
                    }, {});
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.com.wix.core.services.identification2.IdentityRequest();

                  if (grpc.sessions != null) {
                    result.sessions = Object.entries(grpc.sessions).reduce((acc, [k, v]) => {
                      acc[k] = v;
                      return acc;
                    }, {});
                  } else {
                    delete result.sessions;
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'sessions': {
                      'keyType': 'string',
                      'type': 'string',
                      'id': 1
                    }
                  }
                };
              }
            }

            Object.defineProperty(IdentityRequest.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('com.wix.core.services.identification2.IdentityRequest');
              },
              enumerable: false,
              configurable: false
            });
            return IdentityRequest;
          }());
          identification2.IdentityResponse = (function() {

            class IdentityResponse {

              constructor(props) {
                this.identificationData = props && props.identificationData;
                this.signedToken = props && props.signedToken;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.identificationData != null) {
                    $root.com.wix.core.services.identification2.IdentificationData.verify(msg.identificationData, helper, errors.field('identificationData'));
                  }
                  if (msg.signedToken != null) {
                    if (typeof msg.signedToken !== 'string') {
                      errors.field('signedToken').error('string expected');
                    }
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.identificationData != null) {
                    json.identificationData = $root.com.wix.core.services.identification2.IdentificationData.toJSON(obj.identificationData, helper);
                  }
                  if (obj.signedToken != null) {
                    json.signedToken = obj.signedToken;
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.com.wix.core.services.identification2.IdentityResponse();

                if (json.identificationData != null) {
                  result.identificationData = $root.com.wix.core.services.identification2.IdentificationData.fromJSON(json.identificationData, helper);
                } else {
                  delete result.identificationData;
                }
                if (json.signedToken != null) {
                  result.signedToken = json.signedToken;
                } else {
                  result.signedToken = '';
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.identificationData != null) {
                    grpc.identificationData = $root.com.wix.core.services.identification2.IdentificationData.toGRPC(obj.identificationData, helper);
                  }
                  if (obj.signedToken != null) {
                    grpc.signedToken = obj.signedToken;
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.com.wix.core.services.identification2.IdentityResponse();

                  if (grpc.identificationData != null) {
                    result.identificationData = $root.com.wix.core.services.identification2.IdentificationData.fromGRPC(grpc.identificationData, helper);
                  } else {
                    delete result.identificationData;
                  }
                  if (grpc.signedToken != null) {
                    result.signedToken = grpc.signedToken;
                  } else {
                    result.signedToken = '';
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'identificationData': {
                      'type': $root.com.wix.core.services.identification2.IdentificationData,
                      'id': 1
                    },
                    'signedToken': {
                      'type': 'string',
                      'id': 2
                    }
                  }
                };
              }
            }

            Object.defineProperty(IdentityResponse.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('com.wix.core.services.identification2.IdentityResponse');
              },
              enumerable: false,
              configurable: false
            });
            return IdentityResponse;
          }());
          identification2.IdentificationServiceV2 = (function() {

            class IdentificationServiceV2 {

              constructor() {
                if (this.constructor.name === IdentificationServiceV2.name) {
                  throw new TypeError('class IdentificationServiceV2 is abstract');
                }
              }

              extractIdentity(aspects, msg) {
                throw new TypeError('method extractIdentity is abstract');
              }
            }

            IdentificationServiceV2.prototype.extractIdentity._messageTypes = function() {
              return [
                $root.com.wix.core.services.identification2.IdentityRequest,
                $root.com.wix.core.services.identification2.IdentityResponse
              ];
            };
            IdentificationServiceV2.prototype.extractIdentity.__proto = pbjs => {
              return $root.__lookup(pbjs)('com.wix.core.services.identification2.IdentificationServiceV2.extractIdentity');
            };
            Object.defineProperty(IdentificationServiceV2.prototype, '__isRpcService__', {
              value: true,
              enumerable: false,
              configurable: false
            });
            Object.defineProperty(IdentificationServiceV2.prototype, '__fqn__', {
              value: 'com.wix.core.services.identification2.IdentificationServiceV2',
              enumerable: false,
              configurable: false
            });
            Object.defineProperty(IdentificationServiceV2.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('com.wix.core.services.identification2.IdentificationServiceV2');
              },
              enumerable: false,
              configurable: false
            });
            Object.defineProperty(IdentificationServiceV2.prototype, '__options__', {
              value: $root.__options,
              enumerable: false,
              configurable: false
            });
            return IdentificationServiceV2;
          }());
          return identification2;
        }());
        return services;
      }());
      return core;
    }());
    return wix;
  }());
  com.wixpress = (function() {
    const wixpress = {};

    wixpress.metasite = (function() {
      const metasite = {};

      metasite.reloose = (function() {
        const reloose = {};

        reloose.api = (function() {
          const api = {};

          api.MetaSiteContext = (function() {

            class MetaSiteContext {

              constructor(props) {
                this.metaSiteId = props && props.metaSiteId;
                this.published = props && props.published;
                this.apps = props && props.apps;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.metaSiteId != null) {
                    if (typeof msg.metaSiteId !== 'string') {
                      errors.field('metaSiteId').error('string expected');
                    }
                  }
                  if (msg.published != null) {
                    if (typeof msg.published !== 'boolean') {
                      errors.field('published').error('boolean expected');
                    }
                  }
                  if (msg.apps != null) {
                    const fieldErrors = errors.field('apps');

                    if (!Array.isArray(msg.apps)) {
                      fieldErrors.error('array expected');
                    } else {
                      msg.apps.forEach((value, index) => {
                        $root.com.wixpress.metasite.reloose.api.App.verify(value, helper, fieldErrors.index(index));
                      });
                    }
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.metaSiteId != null) {
                    json.metaSiteId = obj.metaSiteId;
                  }
                  if (obj.published != null) {
                    json.published = obj.published;
                  }
                  if (obj.apps != null) {
                    json.apps = obj.apps.map(e => {
                      return $root.com.wixpress.metasite.reloose.api.App.toJSON(e, helper);
                    });
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.com.wixpress.metasite.reloose.api.MetaSiteContext();

                if (json.metaSiteId != null) {
                  result.metaSiteId = json.metaSiteId;
                } else {
                  result.metaSiteId = '';
                }
                if (json.published != null) {
                  result.published = json.published;
                } else {
                  result.published = false;
                }
                if (json.apps != null) {
                  result.apps = json.apps.map(e => {
                    return $root.com.wixpress.metasite.reloose.api.App.fromJSON(e, helper);
                  });
                } else {
                  result.apps = [];
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.metaSiteId != null) {
                    grpc.metaSiteId = obj.metaSiteId;
                  }
                  if (obj.published != null) {
                    grpc.published = obj.published;
                  }
                  if (obj.apps != null) {
                    grpc.apps = obj.apps.map(e => {
                      return $root.com.wixpress.metasite.reloose.api.App.toGRPC(e, helper);
                    });
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.com.wixpress.metasite.reloose.api.MetaSiteContext();

                  if (grpc.metaSiteId != null) {
                    result.metaSiteId = grpc.metaSiteId;
                  } else {
                    result.metaSiteId = '';
                  }
                  if (grpc.published != null) {
                    result.published = grpc.published;
                  } else {
                    result.published = false;
                  }
                  if (grpc.apps != null) {
                    result.apps = grpc.apps.map(e => {
                      return $root.com.wixpress.metasite.reloose.api.App.fromGRPC(e, helper);
                    });
                  } else {
                    result.apps = [];
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'metaSiteId': {
                      'type': 'string',
                      'id': 1,
                      'options': {
                        '(wix.api.format)': 'GUID'
                      }
                    },
                    'published': {
                      'type': 'bool',
                      'id': 2
                    },
                    'apps': {
                      'rule': 'repeated',
                      'type': $root.com.wixpress.metasite.reloose.api.App,
                      'id': 3
                    }
                  }
                };
              }
            }

            Object.defineProperty(MetaSiteContext.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('com.wixpress.metasite.reloose.api.MetaSiteContext');
              },
              enumerable: false,
              configurable: false
            });
            return MetaSiteContext;
          }());
          api.App = (function() {

            class App {

              constructor(props) {
                this.appDefId = props && props.appDefId;
                this.instanceId = props && props.instanceId;
                this.state = props && props.state;
                this.version = props && props.version;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.appDefId != null) {
                    if (typeof msg.appDefId !== 'string') {
                      errors.field('appDefId').error('string expected');
                    }
                  }
                  if (msg.instanceId != null) {
                    if (typeof msg.instanceId !== 'string') {
                      errors.field('instanceId').error('string expected');
                    }
                  }
                  if (msg.state != null) {
                    $root.com.wixpress.metasite.reloose.api.App.State.verify(msg.state, helper, errors.field('state'));
                  }
                  if (msg.version != null) {
                    $root.google.protobuf.StringValue.verify(msg.version, helper, errors.field('version'));
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.appDefId != null) {
                    json.appDefId = obj.appDefId;
                  }
                  if (obj.instanceId != null) {
                    json.instanceId = obj.instanceId;
                  }
                  if (obj.state != null) {
                    json.state = $root.com.wixpress.metasite.reloose.api.App.State[obj.state];
                  }
                  if (obj.version != null) {
                    json.version = $root.google.protobuf.StringValue.toJSON(obj.version, helper);
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.com.wixpress.metasite.reloose.api.App();

                if (json.appDefId != null) {
                  result.appDefId = json.appDefId;
                } else {
                  result.appDefId = '';
                }
                if (json.instanceId != null) {
                  result.instanceId = json.instanceId;
                } else {
                  result.instanceId = '';
                }
                if (json.state != null) {
                  result.state = $root.com.wixpress.metasite.reloose.api.App.State[json.state];
                } else {
                  result.state = 'UNKNOWN';
                }
                if (json.version != null) {
                  result.version = $root.google.protobuf.StringValue.fromJSON(json.version, helper);
                } else {
                  delete result.version;
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.appDefId != null) {
                    grpc.appDefId = obj.appDefId;
                  }
                  if (obj.instanceId != null) {
                    grpc.instanceId = obj.instanceId;
                  }
                  if (obj.state != null) {
                    grpc.state = obj.state;
                  }
                  if (obj.version != null) {
                    grpc.version = $root.google.protobuf.StringValue.toGRPC(obj.version, helper);
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.com.wixpress.metasite.reloose.api.App();

                  if (grpc.appDefId != null) {
                    result.appDefId = grpc.appDefId;
                  } else {
                    result.appDefId = '';
                  }
                  if (grpc.instanceId != null) {
                    result.instanceId = grpc.instanceId;
                  } else {
                    result.instanceId = '';
                  }
                  if (grpc.state != null) {
                    result.state = grpc.state;
                  } else {
                    result.state = 'UNKNOWN';
                  }
                  if (grpc.version != null) {
                    result.version = $root.google.protobuf.StringValue.fromGRPC(grpc.version, helper);
                  } else {
                    delete result.version;
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'appDefId': {
                      'type': 'string',
                      'id': 1,
                      'options': {
                        '(wix.api.maxLength)': 36
                      }
                    },
                    'instanceId': {
                      'type': 'string',
                      'id': 2,
                      'options': {
                        '(wix.api.maxLength)': 36
                      }
                    },
                    'state': {
                      'type': $root.com.wixpress.metasite.reloose.api.App.State,
                      'id': 3,
                      'options': {
                        '(wix.api.readOnly)': true
                      }
                    },
                    'version': {
                      'type': $root.google.protobuf.StringValue,
                      'id': 4
                    }
                  },
                  'nested': {
                    'State': {
                      'values': {
                        'UNKNOWN': 0,
                        'ENABLED': 1,
                        'DISABLED': 2,
                        'TEMPLATE': 3,
                        'PENDING': 4
                      }
                    }
                  }
                };
              }
            }

            App.State = {
              verify: (value, helper, errors = helper.verification.Errors.empty()) => {
                switch (value) {
                  default: {
                    errors.error('enum expected');
                  }
                  case 'UNKNOWN':
                  case 'ENABLED':
                  case 'DISABLED':
                  case 'TEMPLATE':
                  case 'PENDING':
                    break;
                }
                return errors;
              },
              'UNKNOWN': 'UNKNOWN',
              'ENABLED': 'ENABLED',
              'DISABLED': 'DISABLED',
              'TEMPLATE': 'TEMPLATE',
              'PENDING': 'PENDING'
            };
            App.State = {
              verify: (value, helper, errors = helper.verification.Errors.empty()) => {
                switch (value) {
                  default: {
                    errors.error('enum expected');
                  }
                  case 'UNKNOWN':
                  case 'ENABLED':
                  case 'DISABLED':
                  case 'TEMPLATE':
                  case 'PENDING':
                    break;
                }
                return errors;
              },
              'UNKNOWN': 'UNKNOWN',
              'ENABLED': 'ENABLED',
              'DISABLED': 'DISABLED',
              'TEMPLATE': 'TEMPLATE',
              'PENDING': 'PENDING'
            };
            Object.defineProperty(App.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('com.wixpress.metasite.reloose.api.App');
              },
              enumerable: false,
              configurable: false
            });
            return App;
          }());
          api.GetRequest = (function() {

            class GetRequest {

              constructor(props) {
                this.metaSiteId = props && props.metaSiteId;
                this.app = props && props.app;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  const oneOfMutex = {};

                  if (msg.metaSiteId != null) {
                    if (oneOfMutex['getBy']) {
                      errors.field('metaSiteId').up().field('getBy').error('multiple values');
                    } else {
                      oneOfMutex['getBy'] = true;
                      if (typeof msg.metaSiteId !== 'string') {
                        errors.field('metaSiteId').error('string expected');
                      }
                    }
                  }
                  if (msg.app != null) {
                    if (oneOfMutex['getBy']) {
                      errors.field('app').up().field('getBy').error('multiple values');
                    } else {
                      oneOfMutex['getBy'] = true;
                      $root.com.wixpress.metasite.reloose.api.App.verify(msg.app, helper, errors.field('app'));
                    }
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.metaSiteId != null) {
                    json.metaSiteId = obj.metaSiteId;
                  }
                  if (obj.app != null) {
                    json.app = $root.com.wixpress.metasite.reloose.api.App.toJSON(obj.app, helper);
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.com.wixpress.metasite.reloose.api.GetRequest();

                if (json.metaSiteId != null) {
                  result.metaSiteId = json.metaSiteId;
                } else {
                  delete result.metaSiteId;
                }
                if (json.app != null) {
                  result.app = $root.com.wixpress.metasite.reloose.api.App.fromJSON(json.app, helper);
                } else {
                  delete result.app;
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.metaSiteId != null) {
                    grpc.metaSiteId = obj.metaSiteId;
                  }
                  if (obj.app != null) {
                    grpc.app = $root.com.wixpress.metasite.reloose.api.App.toGRPC(obj.app, helper);
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.com.wixpress.metasite.reloose.api.GetRequest();

                  if (grpc.metaSiteId != null) {
                    result.metaSiteId = grpc.metaSiteId;
                  } else {
                    delete result.metaSiteId;
                  }
                  if (grpc.app != null) {
                    result.app = $root.com.wixpress.metasite.reloose.api.App.fromGRPC(grpc.app, helper);
                  } else {
                    delete result.app;
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'oneofs': {
                    'getBy': {
                      'oneof': [
                        'metaSiteId',
                        'app'
                      ]
                    }
                  },
                  'fields': {
                    'metaSiteId': {
                      'type': 'string',
                      'id': 1,
                      'options': {
                        '(wix.api.format)': 'GUID'
                      }
                    },
                    'app': {
                      'type': $root.com.wixpress.metasite.reloose.api.App,
                      'id': 2
                    }
                  }
                };
              }
            }

            Object.defineProperty(GetRequest.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('com.wixpress.metasite.reloose.api.GetRequest');
              },
              enumerable: false,
              configurable: false
            });
            return GetRequest;
          }());
          api.GetResponse = (function() {

            class GetResponse {

              constructor(props) {
                this.context = props && props.context;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.context != null) {
                    $root.com.wixpress.metasite.reloose.api.MetaSiteContext.verify(msg.context, helper, errors.field('context'));
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.context != null) {
                    json.context = $root.com.wixpress.metasite.reloose.api.MetaSiteContext.toJSON(obj.context, helper);
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.com.wixpress.metasite.reloose.api.GetResponse();

                if (json.context != null) {
                  result.context = $root.com.wixpress.metasite.reloose.api.MetaSiteContext.fromJSON(json.context, helper);
                } else {
                  delete result.context;
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.context != null) {
                    grpc.context = $root.com.wixpress.metasite.reloose.api.MetaSiteContext.toGRPC(obj.context, helper);
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.com.wixpress.metasite.reloose.api.GetResponse();

                  if (grpc.context != null) {
                    result.context = $root.com.wixpress.metasite.reloose.api.MetaSiteContext.fromGRPC(grpc.context, helper);
                  } else {
                    delete result.context;
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'context': {
                      'type': $root.com.wixpress.metasite.reloose.api.MetaSiteContext,
                      'id': 1
                    }
                  }
                };
              }
            }

            Object.defineProperty(GetResponse.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('com.wixpress.metasite.reloose.api.GetResponse');
              },
              enumerable: false,
              configurable: false
            });
            return GetResponse;
          }());
          api.GetByMetaSiteIdBulkRequest = (function() {

            class GetByMetaSiteIdBulkRequest {

              constructor(props) {
                this.metaSiteIds = props && props.metaSiteIds;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.metaSiteIds != null) {
                    const fieldErrors = errors.field('metaSiteIds');

                    if (!Array.isArray(msg.metaSiteIds)) {
                      fieldErrors.error('array expected');
                    } else {
                      msg.metaSiteIds.forEach((value, index) => {
                        if (typeof value !== 'string') {
                          fieldErrors.index(index).error('string expected');
                        }
                      });
                    }
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.metaSiteIds != null) {
                    json.metaSiteIds = obj.metaSiteIds.map(e => {
                      return e;
                    });
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.com.wixpress.metasite.reloose.api.GetByMetaSiteIdBulkRequest();

                if (json.metaSiteIds != null) {
                  result.metaSiteIds = json.metaSiteIds.map(e => {
                    return e;
                  });
                } else {
                  result.metaSiteIds = [];
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.metaSiteIds != null) {
                    grpc.metaSiteIds = obj.metaSiteIds.map(e => {
                      return e;
                    });
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.com.wixpress.metasite.reloose.api.GetByMetaSiteIdBulkRequest();

                  if (grpc.metaSiteIds != null) {
                    result.metaSiteIds = grpc.metaSiteIds.map(e => {
                      return e;
                    });
                  } else {
                    result.metaSiteIds = [];
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'metaSiteIds': {
                      'rule': 'repeated',
                      'type': 'string',
                      'id': 1,
                      'options': {
                        '(wix.api.format)': 'GUID',
                        '(wix.api.minSize)': 1,
                        '(wix.api.maxSize)': 200
                      }
                    }
                  }
                };
              }
            }

            Object.defineProperty(GetByMetaSiteIdBulkRequest.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('com.wixpress.metasite.reloose.api.GetByMetaSiteIdBulkRequest');
              },
              enumerable: false,
              configurable: false
            });
            return GetByMetaSiteIdBulkRequest;
          }());
          api.GetByMetaSiteIdBulkResponse = (function() {

            class GetByMetaSiteIdBulkResponse {

              constructor(props) {
                this.contexts = props && props.contexts;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.contexts != null) {
                    const fieldErrors = errors.field('contexts');

                    if (!Array.isArray(msg.contexts)) {
                      fieldErrors.error('array expected');
                    } else {
                      msg.contexts.forEach((value, index) => {
                        $root.com.wixpress.metasite.reloose.api.MetaSiteContext.verify(value, helper, fieldErrors.index(index));
                      });
                    }
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.contexts != null) {
                    json.contexts = obj.contexts.map(e => {
                      return $root.com.wixpress.metasite.reloose.api.MetaSiteContext.toJSON(e, helper);
                    });
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.com.wixpress.metasite.reloose.api.GetByMetaSiteIdBulkResponse();

                if (json.contexts != null) {
                  result.contexts = json.contexts.map(e => {
                    return $root.com.wixpress.metasite.reloose.api.MetaSiteContext.fromJSON(e, helper);
                  });
                } else {
                  result.contexts = [];
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.contexts != null) {
                    grpc.contexts = obj.contexts.map(e => {
                      return $root.com.wixpress.metasite.reloose.api.MetaSiteContext.toGRPC(e, helper);
                    });
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.com.wixpress.metasite.reloose.api.GetByMetaSiteIdBulkResponse();

                  if (grpc.contexts != null) {
                    result.contexts = grpc.contexts.map(e => {
                      return $root.com.wixpress.metasite.reloose.api.MetaSiteContext.fromGRPC(e, helper);
                    });
                  } else {
                    result.contexts = [];
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'contexts': {
                      'rule': 'repeated',
                      'type': $root.com.wixpress.metasite.reloose.api.MetaSiteContext,
                      'id': 1
                    }
                  }
                };
              }
            }

            Object.defineProperty(GetByMetaSiteIdBulkResponse.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('com.wixpress.metasite.reloose.api.GetByMetaSiteIdBulkResponse');
              },
              enumerable: false,
              configurable: false
            });
            return GetByMetaSiteIdBulkResponse;
          }());
          api.GetByAppBulkRequest = (function() {

            class GetByAppBulkRequest {

              constructor(props) {
                this.appDefId = props && props.appDefId;
                this.instanceIds = props && props.instanceIds;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.appDefId != null) {
                    if (typeof msg.appDefId !== 'string') {
                      errors.field('appDefId').error('string expected');
                    }
                  }
                  if (msg.instanceIds != null) {
                    const fieldErrors = errors.field('instanceIds');

                    if (!Array.isArray(msg.instanceIds)) {
                      fieldErrors.error('array expected');
                    } else {
                      msg.instanceIds.forEach((value, index) => {
                        if (typeof value !== 'string') {
                          fieldErrors.index(index).error('string expected');
                        }
                      });
                    }
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.appDefId != null) {
                    json.appDefId = obj.appDefId;
                  }
                  if (obj.instanceIds != null) {
                    json.instanceIds = obj.instanceIds.map(e => {
                      return e;
                    });
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.com.wixpress.metasite.reloose.api.GetByAppBulkRequest();

                if (json.appDefId != null) {
                  result.appDefId = json.appDefId;
                } else {
                  result.appDefId = '';
                }
                if (json.instanceIds != null) {
                  result.instanceIds = json.instanceIds.map(e => {
                    return e;
                  });
                } else {
                  result.instanceIds = [];
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.appDefId != null) {
                    grpc.appDefId = obj.appDefId;
                  }
                  if (obj.instanceIds != null) {
                    grpc.instanceIds = obj.instanceIds.map(e => {
                      return e;
                    });
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.com.wixpress.metasite.reloose.api.GetByAppBulkRequest();

                  if (grpc.appDefId != null) {
                    result.appDefId = grpc.appDefId;
                  } else {
                    result.appDefId = '';
                  }
                  if (grpc.instanceIds != null) {
                    result.instanceIds = grpc.instanceIds.map(e => {
                      return e;
                    });
                  } else {
                    result.instanceIds = [];
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'appDefId': {
                      'type': 'string',
                      'id': 1,
                      'options': {
                        '(wix.api.maxLength)': 36
                      }
                    },
                    'instanceIds': {
                      'rule': 'repeated',
                      'type': 'string',
                      'id': 2,
                      'options': {
                        '(wix.api.minSize)': 1,
                        '(wix.api.maxSize)': 200
                      }
                    }
                  }
                };
              }
            }

            Object.defineProperty(GetByAppBulkRequest.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('com.wixpress.metasite.reloose.api.GetByAppBulkRequest');
              },
              enumerable: false,
              configurable: false
            });
            return GetByAppBulkRequest;
          }());
          api.GetByAppBulkResponse = (function() {

            class GetByAppBulkResponse {

              constructor(props) {
                this.contexts = props && props.contexts;
              }

              static verify(msg, helper, errors = helper.verification.Errors.empty()) {
                if (typeof msg !== 'object' || msg == null) {
                  errors.error('object expected');
                } else {
                  if (msg.contexts != null) {
                    const fieldErrors = errors.field('contexts');

                    if (!Array.isArray(msg.contexts)) {
                      fieldErrors.error('array expected');
                    } else {
                      msg.contexts.forEach((value, index) => {
                        $root.com.wixpress.metasite.reloose.api.MetaSiteContext.verify(value, helper, fieldErrors.index(index));
                      });
                    }
                  }
                }
                return errors;
              }

              static toJSON(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};

                  if (obj.contexts != null) {
                    json.contexts = obj.contexts.map(e => {
                      return $root.com.wixpress.metasite.reloose.api.MetaSiteContext.toJSON(e, helper);
                    });
                  }
                  return json;
                }
              }

              static fromJSON(json, helper) {
                const result = new $root.com.wixpress.metasite.reloose.api.GetByAppBulkResponse();

                if (json.contexts != null) {
                  result.contexts = json.contexts.map(e => {
                    return $root.com.wixpress.metasite.reloose.api.MetaSiteContext.fromJSON(e, helper);
                  });
                } else {
                  result.contexts = [];
                }
                return result;
              }

              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};

                  if (obj.contexts != null) {
                    grpc.contexts = obj.contexts.map(e => {
                      return $root.com.wixpress.metasite.reloose.api.MetaSiteContext.toGRPC(e, helper);
                    });
                  }
                  return grpc;
                }
              }

              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.com.wixpress.metasite.reloose.api.GetByAppBulkResponse();

                  if (grpc.contexts != null) {
                    result.contexts = grpc.contexts.map(e => {
                      return $root.com.wixpress.metasite.reloose.api.MetaSiteContext.fromGRPC(e, helper);
                    });
                  } else {
                    result.contexts = [];
                  }
                  return result;
                }
              }

              static describe() {
                return {
                  'fields': {
                    'contexts': {
                      'rule': 'repeated',
                      'type': $root.com.wixpress.metasite.reloose.api.MetaSiteContext,
                      'id': 1
                    }
                  }
                };
              }
            }

            Object.defineProperty(GetByAppBulkResponse.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('com.wixpress.metasite.reloose.api.GetByAppBulkResponse');
              },
              enumerable: false,
              configurable: false
            });
            return GetByAppBulkResponse;
          }());
          api.RelooseApi = (function() {

            class RelooseApi {

              constructor() {
                if (this.constructor.name === RelooseApi.name) {
                  throw new TypeError('class RelooseApi is abstract');
                }
              }

              get(aspects, msg) {
                throw new TypeError('method get is abstract');
              }

              getByMetaSiteIdBulk(aspects, msg) {
                throw new TypeError('method getByMetaSiteIdBulk is abstract');
              }

              getByAppBulk(aspects, msg) {
                throw new TypeError('method getByAppBulk is abstract');
              }
            }

            RelooseApi.prototype.get._messageTypes = function() {
              return [
                $root.com.wixpress.metasite.reloose.api.GetRequest,
                $root.com.wixpress.metasite.reloose.api.GetResponse
              ];
            };
            RelooseApi.prototype.getByMetaSiteIdBulk._messageTypes = function() {
              return [
                $root.com.wixpress.metasite.reloose.api.GetByMetaSiteIdBulkRequest,
                $root.com.wixpress.metasite.reloose.api.GetByMetaSiteIdBulkResponse
              ];
            };
            RelooseApi.prototype.getByAppBulk._messageTypes = function() {
              return [
                $root.com.wixpress.metasite.reloose.api.GetByAppBulkRequest,
                $root.com.wixpress.metasite.reloose.api.GetByAppBulkResponse
              ];
            };
            RelooseApi.prototype.get.__proto = pbjs => {
              return $root.__lookup(pbjs)('com.wixpress.metasite.reloose.api.RelooseApi.Get');
            };
            RelooseApi.prototype.getByMetaSiteIdBulk.__proto = pbjs => {
              return $root.__lookup(pbjs)('com.wixpress.metasite.reloose.api.RelooseApi.GetByMetaSiteIdBulk');
            };
            RelooseApi.prototype.getByAppBulk.__proto = pbjs => {
              return $root.__lookup(pbjs)('com.wixpress.metasite.reloose.api.RelooseApi.GetByAppBulk');
            };
            Object.defineProperty(RelooseApi.prototype, '__isRpcService__', {
              value: true,
              enumerable: false,
              configurable: false
            });
            Object.defineProperty(RelooseApi.prototype, '__fqn__', {
              value: 'com.wixpress.metasite.reloose.api.RelooseApi',
              enumerable: false,
              configurable: false
            });
            Object.defineProperty(RelooseApi.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('com.wixpress.metasite.reloose.api.RelooseApi');
              },
              enumerable: false,
              configurable: false
            });
            Object.defineProperty(RelooseApi.prototype, '__options__', {
              value: $root.__options,
              enumerable: false,
              configurable: false
            });
            return RelooseApi;
          }());
          return api;
        }());
        return reloose;
      }());
      return metasite;
    }());
    return wixpress;
  }());
  return com;
}());
module.exports = $root;